// CORE =====================
import {
  mFile,
  createCookie,
  getCookie,
  PREP,
  insertDiv,
  id,
  loader,
  valE,
  toggleSelectsection,
  parseIntObj,
  getRecipe,
  cObj,
  sanatizeNum,
  buildDropDownMain,
  buildDList,
  hide,
  unhide,
  uuidvMain,
  toggleSliderYN,
  note,
  eListen,
  errBox,
  infoBox,
  warningBox,
  custardBox,
  eCustardBox,
  countryCode,
  ccRegex,
  ccRegexMulti,
  dragDrop,
  btnModalOn,
  btnModalOff,
  createToggle,
  inpFeedbackBanner,
  validatePage,
  validateDiv,
  rejectElem,
  divAtt,
  addAtt,
  changeTabN,
  changeSubTab,
  getLocalTimeUCT,
  formatDateTime,
  dateFromDateTime,
  dateShortFromDateTime,
  offsetTime,
  createSelectOptions2,
  uuidv4,
  formatDate,
  formatDateforInput,
  rawTable,
  buildInpText,
  buildInpEmail,
  buildInpMobNum,
  buildSelectInp,
  buildTextarea,
  buildDateInp,
  buildBtn,
  buildBtnFormCenter,
  buildFeedbackBanner,
  buildRadio,
  paginate,
  paginateA,
  buildTgl,
  buildTickBox,
  lineBreaks,
  sF,
  svgStringParse,
} from './core';

import { isLive, apiURLDF, imgPlaceholderURL } from './config';

import { MAt_consent } from './candi';

// import Chart from "./chart.min";
import Chart from 'chart.js/auto';
import { getRelativePosition } from 'chart.js/helpers';
// ICONS ====================
import { dustbinSVG, keyEncrypt, passwordEye, duplicateSVG, dSVG, mfSVG, cfSVG, cdrSVG, mcgfSVG, tickCircleSVG, crossCircleSVG, linkOpenTabSVG, additionalServicesIcon, supervisionIcon, timerIcon, scientistIcon, dragDotsSVG, crossSVG, additionalAssRedSVG, additionalAssGreenSVG } from './svgIcons';

// IMAGES ====================
import greyCross from '../assets/img/icons/crossGrey.svg';
import minusIcon from '../assets/img/icons/minus_icon.svg';
import plusIcon from '../assets/img/icons/plus_icon.svg';
import smartRecruiterIcon from '../assets/img/icons/smartRecruiter.png';
import lockedOutIcon from '../assets/img/icons/lockedOut.svg';
import trashCanIcon from '../assets/img/icons/trashCan.svg';
import tickIcon from '../assets/img/icons/tick.svg';

// DOWNLOADS ====================
import AngloAppDevUpload_Eng from '../assets/downloads/1/AngloApplicantsUpload_development.xlsx';
import AngloAppRecUpload_Eng from '../assets/downloads/1/AngloApplicantsUpload_recruitment.xlsx';
import AngloAppDevUpload_Por from '../assets/downloads/10/AngloCandidatosUpload_desenvolvimento.xlsx';
import AngloAppRecUpload_Por from '../assets/downloads/10/AngloCandidatosUpload_recrutamento.xlsx';
import AngloAppDevUpload_Span from '../assets/downloads/11/CargarPostulantesdeAnglo_desarrollo.xlsx';
import AngloAppRecUpload_Span from '../assets/downloads/11/CargarPostulantesdeAnglo_reclutamiento.xlsx';

// FUNTIONS ====================
export const pagination = (pagination, callback, direction) => {
  const pagDiv = id('pagDiv');
  pagDiv.innerHTML = '';
  const varble = direction ? direction : '';
  if (pagination.totalPages == 1) {
    hide('pagDiv');
  } else if (pagination.totalPages <= 10) {
    for (let i = 1; i <= pagination.totalPages; i++) {
      const button = divAtt('button', 'class', 'pagNum');
      button.innerHTML = i;
      if (i == pagination.currentPage) {
        button.classList.add('pagNumActive');
      }
      pagDiv.appendChild(button);
      //button.setAttribute("onclick", `${callback}(${i}, '${varble}')`);
      eListen(
        button,
        () => {
          callback(i, varble);
        },
        // () => {
        //   eval(`${callback}(${i}, '${varble}')`);
        // },
        'click'
      );
    }
    unhide('pagDiv');
  } else if (pagination.totalPages > 10) {
    paginationA(pagination, callback, varble);
  }
};

export const paginationA = (pagination, callback, direction) => {
  const pagDiv = id('pagDiv');
  const currPage = parseInt(pagination.currentPage);
  const first = ('' + currPage).slice(0, -1);
  const lastDigit = parseInt(('' + currPage).slice(-1));
  const firstDigit = lastDigit == 0 ? first - 1 : first;

  const currBlockStart = currPage > 10 ? parseInt(`${firstDigit}1`) : 1;
  const currBlockEnd = currBlockStart + 9 > pagination.totalPages ? pagination.totalPages : currBlockStart + 9;

  const firstPage = divAtt('button', 'class', 'pagArrow');
  firstPage.innerHTML = '&#171;';
  pagDiv.appendChild(firstPage);
  //firstPage.setAttribute("onclick", `${callback}(1, '${direction}')`);
  eListen(
    firstPage,
    () => {
      callback('1', direction);
    },
    // () => {
    //   eval(`${callback}(1, '${direction}')`);
    // },
    'click'
  );

  const minusOne = currPage - 10 > 1 ? currPage - 10 : 1;
  const oneDown = divAtt('button', 'class', 'pagArrow');
  oneDown.innerHTML = '&#8249;';
  pagDiv.appendChild(oneDown);
  //oneDown.setAttribute("onclick", `${callback}(${minusOne}, '${direction}')`);

  eListen(
    oneDown,
    () => {
      callback(minusOne, direction);
    },
    // () => {
    //   eval(`${callback}(${minusOne}, '${direction}')`);
    // },
    'click'
  );

  for (let i = currBlockStart; i <= currBlockEnd; i++) {
    const button = divAtt('button', 'class', 'pagNum');

    button.innerHTML = i;
    if (i == currPage) {
      button.classList.add('pagNumActive');
    }
    pagDiv.appendChild(button); //()=>{report.remove(`${reportRegisterID}`)
    //button.setAttribute("onclick", `${callback}(${i}, '${direction}')`);//@mike
    //`${callback}(${i}, '${direction}')`;
    eListen(
      button,
      () => {
        callback(i, direction);
      }, //`${callback}(${i}, '${direction}')`//mikey
      'click'
    );
  }

  const plusOne = currPage + 10 < pagination.totalPages ? currPage + 10 : pagination.totalPages;

  const oneUp = divAtt('button', 'class', 'pagArrow');

  oneUp.innerHTML = '&#8250;';
  pagDiv.appendChild(oneUp);
  //oneUp.setAttribute("onclick", `${callback}(${plusOne}, '${direction}')`);
  eListen(
    oneUp,
    () => {
      callback(plusOne, direction);
    },
    // () => {
    //   eval(`${callback}(${plusOne}, '${direction}')`);
    // },
    'click'
  );

  const lastPage = divAtt('button', 'class', 'pagArrow');
  lastPage.innerHTML = '&#187;';
  pagDiv.appendChild(lastPage);
  //lastPage.setAttribute("onclick",`${callback}(${pagination.totalPages}, '${direction}')`);
  eListen(
    lastPage,
    () => {
      callback(pagination.totalPages, direction);
    },
    // () => {
    //   eval(`${callback}(${pagination.totalPages}, '${direction}')`);
    // },
    'click'
  );

  unhide('pagDiv');
};

// ========================== ADMIN APPLICATIONS ==================
export class AdminApplications {
  constructor() {
    this.name = 'Admin Applications';
    this.pageTier = 10;
    this.reference = 'adminApplications';
    this.pageID = null;
    this.data = null;
    this.HclientID = null;
    this.applicationState = id('applicationState').value;
  }

  initPage() {
    // Set page pecific variables
    this.loadPage();
  }

  loadPage() {
    this.adminAppsPage();
  }

  async adminAppsPage() {
    id('listApplicationsTable').innerHTML = '';

    const table = id('listApplicationsTable');
    const thead = await this.buildAdminHead();
    table.appendChild(thead);
    const searchRow = await this.buildAdminSearchRow();
    table.appendChild(searchRow);
    //dynamic El's
    eListen(
      'ts10searchDate',
      () => {
        AdminApplications.searchDate();
      },
      'change'
    );
    eListen(
      'exp',
      () => {
        applications.searchFiltersExpress();
      },
      'click'
    );
    eListen(
      'addSer',
      () => {
        applications.searchFiltersAddSer();
      },
      'click'
    );
    eListen(
      'addSuper',
      () => {
        applications.searchFiltersSuper();
      },
      'click'
    );
    eListen(
      'addScience',
      () => {
        applications.searchFiltersScience();
      },
      'click'
    );
    eListen(
      'pub',
      () => {
        applications.searchFiltersPublished();
      },
      'click'
    );
    eListen(
      'smartR',
      () => {
        applications.searchFiltersSmartR();
      },
      'click'
    );
    eListen(
      'success',
      () => {
        applications.searchFiltersSuccess();
      },
      'click'
    );
    eListen(
      'unsuccessful',
      () => {
        applications.searchFiltersUnsuccess();
      },
      'click'
    );
    eListen(
      'dupStatus',
      () => {
        applications.searchFiltersDupStatus();
      },
      'click'
    );
    eListen(
      'MFE',
      () => {
        applications.searchFilterOnOff('MFE');
      },
      'click'
    );
    eListen(
      'CFE',
      () => {
        applications.searchFilterOnOff('CFE');
      },
      'click'
    );
    eListen(
      'CDR',
      () => {
        applications.searchFilterOnOff('CDR');
      },
      'click'
    );
    eListen(
      'MCG',
      () => {
        applications.searchFilterOnOff('MCG');
      },
      'click'
    );
    eListen(
      'clearFiltersBtn',
      () => {
        applications.clearSearch();
      },
      'click'
    );
    await AdminApplications.getApplicants();
    AdminApplications.searchTable();
  }

  async buildAdminHead() {
    const thead = divAtt('thead', 'id', 'appHead');

    const th0 = document.createElement('th');
    const th5 = divAtt('th');
    const th01 = document.createElement('th');
    const th1 = document.createElement('th');
    const th2 = document.createElement('th');
    const th3 = document.createElement('th');
    const th4 = document.createElement('th');

    const th6 = document.createElement('th');
    const th8 = document.createElement('th');
    const th10 = document.createElement('th');
    const th7 = document.createElement('th');
    const th9 = document.createElement('th');

    th01.innerHTML = 'Client';
    th1.innerHTML = 'Job Number';
    th2.innerHTML = 'Candidate';
    th3.innerHTML = 'Job Title';
    th4.innerHTML = 'Position';
    th6.innerHTML = 'Line Manager';
    th8.innerHTML = 'Status';
    th10.innerHTML = 'Last Updated';
    th7.innerHTML = 'Pending Activity';
    th9.innerHTML = '';

    thead.appendChild(th0);
    thead.appendChild(th5);
    thead.appendChild(th01);
    thead.appendChild(th1);
    thead.appendChild(th2);
    thead.appendChild(th3);
    thead.appendChild(th4);
    thead.appendChild(th6);
    thead.appendChild(th8);
    thead.appendChild(th10);
    thead.appendChild(th7);
    thead.appendChild(th9);

    return thead;
  }

  async buildAdminSearchRow() {
    const searchRow = divAtt('tr', 'id', 'trSearch');
    searchRow.setAttribute('class', 'hide');

    const ts0 = document.createElement('td');
    ts0.innerHTML = `<div class="iconGrid">
    <svg  id="exp" class="iconOff" width="24px" height="26" viewBox="0 0 14.84 14.84" style="cursor: pointer;" ><rect x="1.24" y="5.56" width="4.95" height="1.24" rx="0.56"/><rect y="8.04" width="4.95" height="1.24" rx="0.59"/><path d="M7.93,1.69a6.67,6.67,0,0,1,1.61,0A.39.39,0,0,0,10,1.29V.47A.39.39,0,0,0,9.58.08H7.89A.39.39,0,0,0,7.5.47V1.3A.39.39,0,0,0,7.93,1.69Z" transform="translate(-0.08 -0.08)"/><path d="M11.27,5.59,9,7.5a1.27,1.27,0,0,0-1.18.39,1.24,1.24,0,1,0,2.1.44l1.63-2.49Z" transform="translate(-0.08 -0.08)"/><rect x="1.85" y="10.51" width="4.33" height="1.24" rx="0.56"/><path d="M8.74,2.55a6.15,6.15,0,0,0-4.4,1.86h2a4.87,4.87,0,0,1,2.37-.62,4.95,4.95,0,0,1,0,9.89,4.87,4.87,0,0,1-2.37-.62h-2A6.18,6.18,0,1,0,8.74,2.55Z" transform="translate(-0.08 -0.08)"/></svg>

    <svg  id="addSer" class="iconOff" width="25px" height="26px" viewBox="0 0 14.96 14.97" style="cursor: pointer; margin-top: 2px;" ><path d="M5.7,12.16H1.83a.79.79,0,0,1-.89-.89V1.83A.79.79,0,0,1,1.82.94h7a.8.8,0,0,1,.89.89V5.47a.47.47,0,1,0,.93,0c0-1.26,0-2.52,0-3.77A1.7,1.7,0,0,0,8.9,0H1.69A1.69,1.69,0,0,0,.35.68,2,2,0,0,0,0,1.49V11.6l0,.07a1.67,1.67,0,0,0,1.45,1.4,6.58,6.58,0,0,0,.89,0H5.68a.47.47,0,0,0,.48-.3A.46.46,0,0,0,5.7,12.16Z" transform="translate(0 0)"/><path d="M14.91,10.25A4.05,4.05,0,1,0,9.77,14.8c.27.07.54.11.81.17h.67l.42-.08A4,4,0,0,0,14.91,10.25ZM10.9,14A3.12,3.12,0,1,1,14,10.92,3.11,3.11,0,0,1,10.9,14Z" transform="translate(0 0)"/><path d="M2.05,5.81a.73.73,0,0,0,.38.11H8.17a.83.83,0,0,0,.22,0,.42.42,0,0,0,.32-.32A.46.46,0,0,0,8.23,5H2.3a.45.45,0,0,0-.41.32A.42.42,0,0,0,2.05,5.81Z" transform="translate(0 0)"/><path d="M5.71,7.48H2.38A.47.47,0,0,0,1.87,8a.48.48,0,0,0,.52.47H5.72a.47.47,0,1,0,0-.94Z" transform="translate(0 0)"/><path d="M2.39,3.43H5.11A.47.47,0,0,0,5.61,3a.48.48,0,0,0-.51-.47H2.38a.47.47,0,1,0,0,.94Z" transform="translate(0 0)"/><path d="M12.85,10.51a.62.62,0,0,0-.3-.06H11.38V9.23a.47.47,0,0,0-.47-.5.47.47,0,0,0-.47.49v1.22H9.22a.47.47,0,1,0,0,.94h1.22V12.6a.48.48,0,0,0,.48.5.48.48,0,0,0,.46-.5V11.38h1.27a.45.45,0,0,0,.44-.36A.46.46,0,0,0,12.85,10.51Z" transform="translate(0 0)"/></svg>

    <svg  id="addSuper" class="iconOff" width="28px" height="25px" viewBox="0 0 14.93 7.73" style="cursor: pointer;" ><path d="M0,7.38c.31-.34.59-.7.92-1A10.53,10.53,0,0,1,5.38,3.92a8.09,8.09,0,0,1,4.7.14,10.43,10.43,0,0,1,4.71,3.08.46.46,0,0,1,0,.72,10.34,10.34,0,0,1-6,3.39,8.27,8.27,0,0,1-4.53-.54A10.52,10.52,0,0,1,.21,7.86,1.6,1.6,0,0,1,0,7.61Zm10.45.12a3,3,0,1,0-3,3A3,3,0,0,0,10.48,7.5Zm3.44,0a9.84,9.84,0,0,0-3.29-2.28,3.92,3.92,0,0,1,0,4.6A10.46,10.46,0,0,0,13.92,7.5ZM4.37,5.21A10,10,0,0,0,1.09,7.5,9.86,9.86,0,0,0,4.37,9.79,3.92,3.92,0,0,1,4.37,5.21Z" transform="translate(-0.03 -3.64)"/><path d="M7.5,6A1.49,1.49,0,1,1,6,7.49,1.49,1.49,0,0,1,7.5,6ZM8.11,7.5a.62.62,0,0,0-1.23,0,.62.62,0,1,0,1.23,0Z" transform="translate(-0.03 -3.64)"/></svg>

    <svg  id="addScience" class="iconOff" width="25px" height="26px" viewBox="0 0 13.77 14.84" style="cursor: pointer;" ><path d="M14.37,10.12a3.86,3.86,0,0,0-.67-1.69c-.15-.23-.32-.45-.49-.67L13,7.49l.11-.13a6.39,6.39,0,0,0,1-1.54,2.64,2.64,0,0,0,.26-1.34A1.72,1.72,0,0,0,13.05,3a4.89,4.89,0,0,0-2-.11l-.5.07-.15,0,0-.1c-.05-.13-.09-.25-.14-.37a.12.12,0,0,1,0-.17,1.05,1.05,0,0,0,.07-1.2A1,1,0,0,0,9.17.62.25.25,0,0,1,8.92.55,1.73,1.73,0,0,0,7.37.12a2.09,2.09,0,0,0-1.1.7,5.85,5.85,0,0,0-1.11,2l0,.14H5.05l-.2,0a5.77,5.77,0,0,0-2.2,0,2,2,0,0,0-1.31.86,2,2,0,0,0-.15,1.58A4.93,4.93,0,0,0,2,6.86c.12.16.24.32.37.47l.13.17-.07.1-.28.33-.18.26-.17.24H1.71A1.05,1.05,0,0,0,1,10.33a.2.2,0,0,1,.06.11A1.7,1.7,0,0,0,2.27,12a4.56,4.56,0,0,0,2.19.17l.48-.07.15,0c0,.1.09.21.13.31.11.25.22.52.35.77a3.67,3.67,0,0,0,1.14,1.43,1.8,1.8,0,0,0,1,.35,1.72,1.72,0,0,0,1-.35,3.66,3.66,0,0,0,.55-.5,5.7,5.7,0,0,0,1-1.94c0-.07,0-.08.13-.06a6.39,6.39,0,0,0,1.83.12.16.16,0,0,1,.14.05,1,1,0,0,0,1.27.2,1.06,1.06,0,0,0,.51-1.2.32.32,0,0,1,0-.14A1.84,1.84,0,0,0,14.37,10.12ZM2.74,11.3A1.92,1.92,0,0,1,2.17,11a.64.64,0,0,1-.25-.46,1.07,1.07,0,0,0,.57-1.72L3,8.12l0,0,.21.18c.21.19.41.37.62.54s.23.19.35.28l.26.2a.36.36,0,0,1,.07.09c.08.53.17,1,.26,1.59l0,.3A4.7,4.7,0,0,1,2.74,11.3Zm.83-3.79.87-.78V8.27ZM4.81,4c0,.28-.11.55-.16.82l-.06.43c0,.11,0,.22,0,.33s0,.09,0,.1l-1.18,1L3,6.92a4.45,4.45,0,0,1-1.12-2,.92.92,0,0,1,.58-1.1,3.16,3.16,0,0,1,.86-.18,2.17,2.17,0,0,1,.36,0,6.15,6.15,0,0,1,1.16.13Zm5-.09L10.05,5,8.73,4.27h0l.32-.12L9.61,4ZM7,1.27A1.17,1.17,0,0,1,7.56.91a1,1,0,0,1,.87.28,1,1,0,0,0,.92,1.52c.06,0,.07,0,.09.07s.07.19.11.29l0,.07h0l-.22.07-1.52.55a.24.24,0,0,1-.11,0L6.29,3.25l-.38-.14A4.85,4.85,0,0,1,7,1.27ZM5.66,3.9l1.09.36L5.43,5ZM5.42,10l1.33.77-1.1.37Zm3.19,3.68a1.37,1.37,0,0,1-.69.44,1,1,0,0,1-1-.34A4.2,4.2,0,0,1,6,12.25c0-.1-.08-.2-.11-.3l0-.08.25-.08.72-.24.47-.19.34-.13a.15.15,0,0,1,.11,0l1.54.55.27.1A5.12,5.12,0,0,1,8.61,13.65ZM9.83,11.1l-1.11-.36L10.05,10Zm.4-3.24c0,.32,0,.63-.05,1A.18.18,0,0,1,10.1,9a14.36,14.36,0,0,1-2.29,1.32.2.2,0,0,1-.15,0A15.91,15.91,0,0,1,5.36,9a.15.15,0,0,1-.06-.11,15.22,15.22,0,0,1,0-2.7.18.18,0,0,1,0-.08A14.63,14.63,0,0,1,7.68,4.72H7.8A16.71,16.71,0,0,1,10.11,6a.21.21,0,0,1,.08.16c0,.34,0,.67,0,1v.66Zm2.5-4.16.16,0a1,1,0,0,1,.67,1.19,3.83,3.83,0,0,1-.67,1.42l-.32.42-.12.13-.18-.16-.55-.49-.42-.33L11,5.7a.36.36,0,0,1-.07-.09c-.09-.52-.17-1.05-.26-1.58l0-.32A5,5,0,0,1,12.73,3.7ZM11.9,7.51,11,8.28V6.73Zm.74,3.1a1,1,0,0,0-.5.78,5.53,5.53,0,0,1-1.53-.11l.08-.41c.06-.34.13-.67.19-1v0a.78.78,0,0,0,0-.22c0-.17.07-.27.24-.4s.61-.51.91-.77l.34-.29,0,0,.07.09a3.68,3.68,0,0,1,1.06,2.35A1,1,0,0,0,12.64,10.61Z" transform="translate(-0.62 -0.08)"/><path d="M7.75,6.1a1.4,1.4,0,1,0,0,2.8,1.4,1.4,0,0,0,0-2.8Z" transform="translate(-0.62 -0.08)"/></svg>

    <svg id="pub" class="iconOff"  width="4.64" height="17.15" viewBox="0 0 4.64 17.15" style="cursor: pointer;" ><path d="M306.24,398.45a1.83,1.83,0,0,0,1.86-1.8l.46-6.74a2.32,2.32,0,0,0-4.64,0l.46,6.74A1.83,1.83,0,0,0,306.24,398.45Z" transform="translate(-303.92 -387.66)"/><path d="M306.24,400.32a2.25,2.25,0,1,0,2.32,2.25A2.29,2.29,0,0,0,306.24,400.32Z" transform="translate(-303.92 -387.66)"/></svg>


    <svg id="smartR" class="iconOff"  width="23"  viewBox="0 0 18.85 23.43" ><path d="M16.89,3.55C15.32,1.6,13.26,.47,10.77,.1,6.92-.47,3.04,1.4,1.13,4.77-.78,8.15-.24,12.44,2.5,15.2c1.63,1.65,2.67,3.56,3,5.86,.09,.61,.37,1.1,.82,1.43,.71,.57,1.83,.94,3.1,.94,2,0,3.65-.92,3.85-2.1,.06-.19,.11-.4,.14-.62,.34-2.14,1.36-3.94,2.88-5.47,1.45-1.46,2.31-3.24,2.51-5.28,.24-2.38-.41-4.55-1.92-6.42h0Zm-3.39,9.22c-.09,.97-.66,1.6-1.52,1.99-.82,.38-1.7,.49-2.6,.47-.84,.02-1.66-.08-2.45-.41-1.18-.48-1.73-1.35-1.67-2.6,.02-.45,.11-.54,.55-.54h.96c.29,0,.43,.12,.45,.4,0,.11,.01,.22,.01,.33,0,.59,.18,.91,.76,1.03,.58,.13,1.19,.17,1.78,.18,.37,0,.76-.1,1.12-.22,.43-.14,.64-.45,.64-.93,0-1-.11-1.17-1.06-1.51-1.05-.37-2.11-.73-3.17-1.1-1.17-.4-1.8-1.27-1.79-2.51,0-.39,0-.8,.1-1.17,.23-.9,.88-1.42,1.73-1.7,1.41-.46,2.83-.46,4.23,.01,1.26,.43,1.9,1.44,1.8,2.77-.03,.39-.12,.48-.51,.48h-.99c-.25,0-.4-.11-.42-.36-.02-.19-.03-.37-.02-.56,.02-.44-.2-.73-.57-.87-.93-.35-1.86-.32-2.8-.03-.8,.25-.81,1.65-.21,1.97,.34,.18,.69,.33,1.05,.46,.85,.3,1.71,.55,2.54,.89,.52,.21,1.02,.5,1.47,.83,.43,.32,.59,.83,.59,1.37,0,.43,.03,.86-.01,1.29v.04Z"/></svg>

  <svg id="success" class="iconOff"  width="22" height="22" viewBox="0 0 15 15" ><defs><style>.cls-1{stroke-width:0px;}</style></defs><path class="cls-1" d="m7.5,0C3.36,0,0,3.36,0,7.5s3.36,7.5,7.5,7.5,7.5-3.36,7.5-7.5S11.64,0,7.5,0Zm-1.27,11.01l-3.49-3.35.88-.91,2.59,2.47,5.14-5.24.9.89-6.02,6.13Z"/></svg>
   
  <svg id="unsuccessful" class="iconOff" width="22" height="22" viewBox="0 0 15 15" ><defs><style>.cls-1{stroke-width:0px;}</style></defs><path class="cls-1" d="m7.5,0C3.36,0,0,3.36,0,7.5s3.36,7.5,7.5,7.5,7.5-3.36,7.5-7.5S11.64,0,7.5,0Zm3.02,11.41l-3.01-2.99-2.99,3.02-.92-.92,2.98-3.01-3.01-2.99.92-.92,3.01,2.98,2.98-3.01.93.92-2.98,3.01,3.01,2.98-.92.93Z"/></svg>

  <svg version="1.1" id="dupStatus" class="iconOff"  viewBox="0 0 15 15" style="max-height: 21px"><path d="M13.6,4.6c-0.4-0.9-0.9-1.7-1.6-2.3c-0.7-0.7-1.5-1.2-2.5-1.5c-1-0.4-2-0.6-3.2-0.6H0.8v14.7h5.5c1.1,0,2.2-0.2,3.2-0.6
	c1-0.4,1.8-0.9,2.5-1.6c0.7-0.7,1.2-1.4,1.6-2.3c0.4-0.9,0.6-1.9,0.6-2.9C14.2,6.4,14,5.5,13.6,4.6z M11.1,9.5
	c-0.2,0.6-0.6,1.1-1,1.6c-0.4,0.4-1,0.8-1.6,1c-0.6,0.2-1.3,0.4-2.1,0.4H3.4v-10h2.9c0.8,0,1.5,0.1,2.1,0.4C9.1,3.1,9.6,3.5,10,3.9
	c0.4,0.5,0.8,1,1,1.6c0.2,0.6,0.4,1.3,0.4,2C11.4,8.3,11.3,8.9,11.1,9.5z"/></svg>

  </div>`;

    const ts5 = document.createElement('td');
    const ts01 = document.createElement('td');
    const ts1 = document.createElement('td');
    const ts1Input = divAtt('input', 'type', 'text');
    ts1Input.setAttribute('class', 'searchInputTable searchInp');
    ts1Input.setAttribute('placeholder', 'Search by job Number');
    ts1Input.setAttribute('id', 'rfcSearch');
    const ts2 = document.createElement('td');
    const ts2Input = divAtt('input', 'type', 'text');
    ts2Input.setAttribute('placeholder', 'Search by candidate');
    ts2Input.setAttribute('class', 'searchInputTable searchInp');
    ts2Input.setAttribute('id', 'canSearch');
    const ts3 = document.createElement('td');
    const ts3Input = divAtt('input', 'type', 'text');
    ts3Input.setAttribute('class', 'searchInputTable  searchInp');
    ts3Input.setAttribute('placeholder', 'Search by job title');
    ts3Input.setAttribute('id', 'jobTitleSearch');
    const ts4 = document.createElement('td');
    const ts4Input = divAtt('input', 'type', 'text');
    ts4Input.setAttribute('class', 'searchInputTable  searchInp');
    ts4Input.setAttribute('placeholder', 'Search by position');
    ts4Input.setAttribute('id', 'posSearch');
    const ts6 = document.createElement('td');
    const ts6Input = divAtt('input', 'type', 'text');
    ts6Input.setAttribute('class', 'searchInputTable  searchInp');
    ts6Input.setAttribute('placeholder', 'Search by line manager');
    ts6Input.setAttribute('id', 'lineManSearch');

    const ts8 = document.createElement('td');
    const ts8Input = divAtt('input', 'type', 'text');
    ts8Input.setAttribute('class', 'searchInputTable  searchInp');
    ts8Input.setAttribute('placeholder', 'Search by status');
    ts8Input.setAttribute('id', 'statusSearch');

    const ts10 = document.createElement('td');
    const ts10Input = divAtt('input', 'type', 'date');
    ts10Input.setAttribute('class', 'searchInputTable ');
    ts10Input.setAttribute('placeholder', 'Search by status');
    ts10Input.setAttribute('id', 'dateSearch');
    ts10Input.style = 'width: 125px;';
    //ts10.setAttribute("onchange", "AdminApplications.searchDate()");
    ts10.setAttribute('id', 'ts10searchDate');
    // ==========Add pending activity search here
    const ts7 = document.createElement('td');
    ts7.innerHTML = `<div class="iconGrid">

    <svg id="MFE" class="iconOff addSerIcons" style="cursor: pointer;"  width="15.02" height="7.95" viewBox="0 0 15.02 7.95"><polygon points="4.01 4.52 1.66 0 0 0 0 7.95 1.54 7.95 1.54 2.69 3.59 6.6 4.43 6.6 6.48 2.69 6.48 7.95 8.02 7.95 8.02 0 6.38 0 4.01 4.52"/><polygon points="15.02 1.35 15.02 0 9.68 0 9.68 7.95 11.22 7.95 11.22 4.66 14.38 4.66 14.38 3.4 11.22 3.4 11.22 1.35 15.02 1.35"/></svg>


     <svg id="CFE" class="iconOff addSerIcons" style="cursor: pointer;"  width="15.05" height="8.98" viewBox="0 0 15.05 8.98"><path d="m6.13,6.73c-.17.17-.35.31-.54.42-.2.11-.4.19-.62.24s-.42.07-.62.07c-.38,0-.73-.08-1.05-.25s-.59-.39-.82-.66-.41-.59-.53-.95c-.12-.36-.19-.74-.19-1.13,0-.35.05-.7.16-1.05.11-.35.27-.67.48-.95s.48-.51.8-.68c.32-.17.7-.26,1.13-.26.2,0,.4.02.61.07s.41.12.6.22c.19.1.37.23.54.41s.31.38.42.63l1.32-.91c-.29-.57-.73-1.04-1.33-1.4-.59-.36-1.3-.54-2.12-.54-.69,0-1.31.13-1.85.39s-1,.59-1.37,1.01c-.37.42-.66.89-.85,1.42-.2.53-.29,1.06-.29,1.6s.11,1.12.32,1.67.51,1.03.89,1.46.83.78,1.35,1.04c.52.27,1.1.4,1.73.4.36,0,.72-.05,1.1-.14.37-.09.73-.23,1.05-.4s.62-.39.89-.64c.26-.25.46-.55.61-.88l-1.41-.81c-.1.24-.23.45-.4.62Z"/><polygon points="15.05 1.56 15.05 .05 9.1 .05 9.1 8.91 10.82 8.91 10.82 5.24 14.34 5.24 14.34 3.84 10.82 3.84 10.82 1.56 15.05 1.56"/></svg>



        <svg id="CDR" class="iconOff addSerIcons" style="cursor: pointer;"  width="23.46" height="8.37" viewBox="0 0 23.46 8.37"><path d="m5.7,6.27c-.15.16-.32.29-.51.39-.18.1-.37.17-.57.22s-.4.07-.58.07c-.36,0-.68-.08-.98-.23s-.55-.36-.77-.62-.38-.55-.49-.89c-.12-.34-.17-.69-.17-1.05,0-.33.05-.65.15-.98.1-.33.25-.62.45-.88s.44-.47.74-.63c.3-.16.65-.24,1.05-.24.19,0,.38.02.57.06s.38.11.56.2c.18.09.34.22.5.38s.29.35.4.59l1.23-.85c-.27-.53-.68-.97-1.24-1.3-.55-.33-1.21-.5-1.97-.5-.64,0-1.22.12-1.72.36-.5.24-.93.55-1.28.94-.35.39-.61.83-.8,1.32-.18.49-.27.99-.27,1.49s.1,1.04.3,1.55c.2.51.47.96.82,1.36s.77.72,1.26.97c.49.25,1.03.37,1.62.37.33,0,.67-.04,1.02-.13.35-.09.68-.21.98-.37.31-.16.58-.36.82-.6s.43-.51.56-.82l-1.31-.76c-.09.22-.22.42-.37.57Z"/><path d="m14.51,1.26c-.34-.37-.77-.67-1.27-.88-.51-.22-1.1-.33-1.77-.33h-3v8.25h3c.62,0,1.18-.1,1.68-.3s.93-.48,1.28-.84.63-.79.82-1.3.28-1.07.28-1.7c0-.57-.09-1.1-.26-1.6-.17-.5-.43-.94-.77-1.31Zm-.76,3.99c-.11.33-.27.62-.47.87-.21.24-.46.44-.77.57-.31.14-.66.21-1.05.21h-1.39V1.45h1.39c.39,0,.73.07,1.04.2.31.13.56.32.77.56.21.24.37.53.48.86.11.33.16.7.16,1.09s-.05.75-.16,1.08Z"/><path d="m21.58,5.19c.46-.19.82-.51,1.09-.95.27-.44.4-.92.4-1.46,0-.33-.07-.66-.2-.99-.13-.33-.31-.62-.55-.88-.23-.26-.51-.47-.83-.63s-.67-.24-1.05-.24h-3.65v8.25h1.6v-2.77h1.58l1.69,2.77h1.8l-1.88-3.1Zm-.21-1.88c-.05.16-.13.3-.22.42-.09.12-.2.22-.33.28s-.27.1-.41.1h-2.01V1.45h1.94c.14,0,.28.03.41.1.14.07.26.16.36.28s.19.26.25.42c.06.16.09.34.09.53s-.03.36-.08.52Z"/></svg>

        <svg id="MCG" class="iconOff addSerIcons" style="cursor: pointer;" width="29.41" height="9.86" viewBox="0 0 29.41 9.86"><defs><style>.cls-1{stroke-width:0px;}</style></defs><polygon class="cls-1" points="4.89 5.59 2.02 .07 0 .07 0 9.78 1.89 9.78 1.89 3.35 4.39 8.14 5.41 8.14 7.92 3.35 7.92 9.78 9.8 9.78 9.8 .07 7.79 .07 4.89 5.59"/><path class="cls-1" d="m17.95,7.39c-.18.19-.38.34-.59.46-.21.12-.44.2-.68.26s-.47.08-.68.08c-.42,0-.8-.09-1.16-.27s-.65-.42-.9-.72-.44-.65-.58-1.05c-.14-.4-.2-.81-.2-1.24,0-.38.06-.77.18-1.16.12-.39.29-.73.53-1.04s.52-.55.87-.74c.35-.19.76-.29,1.24-.29.22,0,.44.02.67.08s.45.13.66.24c.21.11.41.26.59.44s.34.42.47.69l1.45-1c-.32-.63-.8-1.14-1.46-1.53C17.69.21,16.92.01,16.02.01c-.76,0-1.43.14-2.02.42-.59.28-1.09.65-1.5,1.11-.41.46-.72.97-.94,1.55-.21.58-.32,1.16-.32,1.76s.12,1.23.35,1.82c.23.6.56,1.13.97,1.6s.91.85,1.48,1.14c.57.29,1.21.44,1.9.44.39,0,.79-.05,1.2-.15.41-.1.8-.25,1.16-.44.36-.19.68-.43.97-.7s.51-.6.66-.96l-1.55-.89c-.11.26-.26.49-.44.68Z"/><path class="cls-1" d="m25.9,4.79v1.38h1.95v.68c-.76.88-1.6,1.33-2.54,1.33-.41,0-.79-.08-1.14-.25s-.65-.4-.91-.69c-.26-.29-.46-.64-.6-1.03-.15-.4-.22-.82-.22-1.28s.07-.85.2-1.24c.13-.39.32-.74.56-1.04s.53-.54.87-.71c.34-.17.72-.26,1.13-.26.52,0,1,.13,1.44.38.44.26.79.62,1.03,1.11l1.41-1.04c-.33-.65-.82-1.16-1.47-1.55-.65-.38-1.43-.57-2.34-.57-.67,0-1.3.13-1.87.39-.57.26-1.07.61-1.5,1.05s-.76.96-1,1.55c-.24.59-.36,1.21-.36,1.88,0,.7.12,1.36.36,1.96s.57,1.13.98,1.58c.41.45.9.8,1.46,1.05.56.26,1.16.38,1.8.38,1.03,0,1.93-.39,2.71-1.16v1.09h1.56v-4.99h-3.51Z"/></svg>
       
       <div>`;

    const ts9 = document.createElement('td');
    const clearBtn = divAtt('button', '', '');
    clearBtn.setAttribute('class', 'clearBtn');
    clearBtn.setAttribute('id', 'clearFiltersBtn');
    clearBtn.innerHTML = '<svg  width="13.58" height="13.58" viewBox="0 0 13.58 13.58"><defs><style>.a{fill:#231f20;}</style></defs><polygon class="a" points="12.53 13.53 13.58 12.47 7.84 6.78 13.53 1.05 12.47 0 6.79 5.74 1.05 0.06 0 1.1 5.74 6.79 0.05 12.53 1.1 13.58 6.8 7.84 12.53 13.53"/></svg> Clear Search';

    ts1.appendChild(ts1Input);
    ts2.appendChild(ts2Input);
    ts3.appendChild(ts3Input);
    ts4.appendChild(ts4Input);
    ts6.appendChild(ts6Input);
    // ts7.appendChild(ts7Input);
    ts8.appendChild(ts8Input);
    ts10.appendChild(ts10Input);
    ts9.appendChild(clearBtn);
    searchRow.appendChild(ts0);
    searchRow.appendChild(ts5);
    searchRow.appendChild(ts01);
    searchRow.appendChild(ts1);
    searchRow.appendChild(ts2);
    searchRow.appendChild(ts3);
    searchRow.appendChild(ts4);
    searchRow.appendChild(ts6);
    searchRow.appendChild(ts8);
    searchRow.appendChild(ts10);
    searchRow.appendChild(ts7);
    searchRow.appendChild(ts9);

    return searchRow;
  }

  static async getApplicants(displaypage, displayListCount) {
    const obj = {};
    obj.rfcSearch = id('rfcSearch').value || '';
    obj.canSearch = id('canSearch').value;
    obj.jobTitleSearch = id('jobTitleSearch').value;
    obj.posSearch = id('posSearch').value;
    obj.posLevelSearch = ''; //id('posLevelSearch').value;
    obj.lineManSearch = id('lineManSearch').value;
    obj.HclientID = id('clientDD').value;
    obj.statusSearch = id('statusSearch').value;
    obj.genSearch = id('genSearch').value;
    obj.expSearch = id('exp').classList.contains('iconOn') ? true : false;
    obj.addSearch = id('addSer').classList.contains('iconOn') ? true : false;
    obj.supervisionSearch = id('addSuper').classList.contains('iconOn') ? true : false;
    obj.scientistSearch = id('addScience').classList.contains('iconOn') ? true : false;
    obj.publishedSearch = id('pub').classList.contains('iconOn') ? true : false;
    obj.HclientID = id('clientDD').value;
    obj.SRsearch = id('smartR').classList.contains('iconOn') ? true : false;

    let success = '';
    if (id('unsuccessful').classList.contains('iconOn')) {
      success = 'Unsuccessful';
    } else if (id('success').classList.contains('iconOn')) {
      success = 'Successful';
    }
    obj.successfulAppYN = success;

    obj.containedDuplicateAssessment = id('dupStatus').classList.contains('iconOn') ? true : false;
    obj.lastUpdateSearch = id('dateSearch').value;

    // obj.pendingActSearch = id('penAct').classList.contains('iconOn') ? true : false;
    obj.pendingActSearch = false;
    obj.MFEsearch = id('MFE').classList.contains('iconOn') ? true : false;
    obj.CFEsearch = id('CFE').classList.contains('iconOn') ? true : false;
    obj.CDRsearch = id('CDR').classList.contains('iconOn') ? true : false;
    obj.MCGsearch = id('MCG').classList.contains('iconOn') ? true : false;
    // const addSerArr = [];
    // const addSerList = document.querySelectorAll('.addSerIcons');
    // addSerList.forEach(item => {
    //     if (item.classList.contains('iconOn')) {
    //         addSerArr.push(`${item.id}`)
    //     }
    // });
    // obj.addSerKEYS = addSerArr.toString();

    const vars = {};
    vars.applicationState = id('applicationState').value ? id('applicationState').value : 'o';
    vars.displaypage = displaypage ? displaypage : 1;
    vars.displayListCount = displayListCount ? displayListCount : 50;
    vars.searchObj = JSON.stringify(obj) || JSON.stringify({});

    hide('pagDiv');

    // const recipe = await getRecipe();
    // recipe.endPoint = devAPI;
    // recipe.methods = ['getGenericApplications']
    let returnData;
    await PREP(['getGenericApplications'], vars, 'Searching... Please wait')
      .then((res) => {
        returnData = res.data.getGenericApplications[0].ReturnList;
        //console.log('HERERERE', res.data.getGenericApplications[0].pagination[0]);//@mike
        let callback = (p1, p2) => {
          AdminApplications.getApplicants(p1, p2);
        };
        pagination(
          res.data.getGenericApplications[0].pagination[0],
          callback
          // AdminApplications.getApplicants //mikey
        );
        AdminApplications.populateAppTable(returnData);
        loader(0);
      })
      .catch(console.error());
  }

  static async populateAppTable(data) {
    if (data.length) {
      await AdminApplications.buildAppBody(data);
      hide('noApps');
      id('listApplicationsTable').style = 'visibility: visible;';
    } else {
      id('appListBody').innerHTML = '';
      // id('listApplicationsTable').style = 'visibility: hidden;'
      unhide('noApps');
      // hide('searchSpace')
      hide('pagDiv');
    }
  }

  static searchTable() {
    const searchInp = document.querySelectorAll('.searchInp');
    searchInp.forEach((sInp) => {
      let timeout;
      sInp.addEventListener('keyup', () => {
        clearTimeout(timeout);
        timeout = setTimeout(async () => {
          await AdminApplications.getApplicants(1, 50);
        }, 1500);
      });
    });
  }

  static searchDate() {
    let timeout;
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      await AdminApplications.getApplicants(1, 50);
    }, 250);
  }

  static async buildAppBody(data) {
    const tbody = id('appListBody') ? id('appListBody') : divAtt('tbody', 'id', 'appListBody');
    tbody.innerHTML = '';

    if (data.length) {
      for (let row of data) {
        const tr = divAtt('tr', 'class', '');

        const td0 = divAtt('td', 'class', '');
        const iconDiv = divAtt('div', 'style', 'display: flex;');
        const expressImg = divAtt('span', 'class', 'tableIcon');
        //expressImg.innerHTML = timerIcon;
        const addSerImg = divAtt('span', 'class', 'tableIcon');
        addSerImg.innerHTML = additionalServicesIcon;
        const superImg = divAtt('img', 'class', 'tableIcon');
        superImg.innerHTML = supervisionIcon;
        const scientistImg = divAtt('span', 'class', 'tableIcon');
        scientistImg.innerHTML = scientistIcon;
        const smartRecImg = divAtt('img', 'style', 'margin-left: 12px;');
        smartRecImg.src = smartRecruiterIcon;
        const dupStatusImg = divAtt('div', 'style', 'margin-left: 12px;');
        dupStatusImg.innerHTML = dSVG;
        const successImg = divAtt('div', 'style', 'margin-left: 12px;');
        successImg.innerHTML = tickCircleSVG;
        const unsuccessImg = divAtt('div', 'style', 'margin-left: 12px;');
        unsuccessImg.innerHTML = crossCircleSVG;

        if (row.expressServiceYN) {
          iconDiv.appendChild(expressImg);
        }
        if (row.additionalServicesYN) {
          iconDiv.appendChild(addSerImg);
        }
        if (row.containsSupervisedAssessmentYN) {
          iconDiv.appendChild(superImg);
        }
        if (row.acanscCombo) {
          iconDiv.appendChild(scientistImg);
        }
        if (row.smartRecruitersYN) {
          iconDiv.appendChild(smartRecImg);
        }

        if (row.successfulAppYN === 'Unsuccessful') {
          iconDiv.appendChild(unsuccessImg);
        }
        if (row.successfulAppYN === 'Successful') {
          iconDiv.appendChild(successImg);
        }

        if (row.containedDuplicateAssessment) {
          iconDiv.appendChild(dupStatusImg);

          if (row.duplicateassessmentStatus.toLowerCase() === 'red') {
            dupStatusImg.style.fill = 'var(--errorHoverColor)';
          } else if (row.duplicateassessmentStatus.toLowerCase() === 'green') {
            dupStatusImg.style.fill = '#09ba15';
          } else if (row.duplicateassessmentStatus.toLowerCase() === 'orange') {
            dupStatusImg.style.fill = '#f58b19';
          }
        }
        td0.appendChild(iconDiv);

        const td5 = divAtt('td', 'class', '');
        td5.innerHTML = !row.publishedYN
          ? `<svg id="Layer_1" data-name="Layer 1"  width="4.64" height="17.15" viewBox="0 0 4.64 17.15"><defs><style>.cls-45{fill:#e7242e;}</style></defs><path class="cls-45" d="M306.24,398.45a1.83,1.83,0,0,0,1.86-1.8l.46-6.74a2.32,2.32,0,0,0-4.64,0l.46,6.74A1.83,1.83,0,0,0,306.24,398.45Z" transform="translate(-303.92 -387.66)"/><path class="cls-45" d="M306.24,400.32a2.25,2.25,0,1,0,2.32,2.25A2.29,2.29,0,0,0,306.24,400.32Z" transform="translate(-303.92 -387.66)"/></svg>`
          : '';

        const td01 = divAtt('td', 'class', 'clientLogoTable');
        // td01.innerHTML = row.clientLogo;
        const logoImg = divAtt('img', 'src', `${row.HclientLogo}`);
        td01.appendChild(logoImg);
        const td1 = divAtt('td', 'class', '');
        td1.innerHTML = row.RFCNumber;
        const td2 = divAtt('td', 'class', '');
        td2.innerHTML = row.candidateFname + ' ' + row.candidatesname;
        const td3 = divAtt('td', 'class', '');
        td3.innerHTML = row.clientjobTitle;
        const td4 = divAtt('td', 'class', '');
        td4.innerHTML = row.positionLevel;

        const td6 = divAtt('td', 'class', '');
        td6.innerHTML = row.lineManagerfname + ' ' + row.linemanagerSname;
        const td8 = divAtt('td', 'class', '');
        td8.innerHTML = row.status;
        const td10 = divAtt('td', 'class', '');
        td10.innerHTML = row.lastUpdated;
        const td7 = divAtt('td', 'class', '');

        const activityDiv = divAtt('div', 'class', 'iconGrid');
        activityDiv.style.fill = 'var(--primaryColor)';
        if (row.activityInProgressYN) {
          if (row.additionalServiceKEYList.length) {
            let cfImg = row.additionalServiceKEYList.includes('CFE') ? 1 : 0;
            let mfImg = row.additionalServiceKEYList.includes('MFE') ? 1 : 0;
            let cdrImg = row.additionalServiceKEYList.includes('CDR') ? 1 : 0;
            let mcgfImg = row.additionalServiceKEYList.includes('MCG') ? 1 : 0;

            activityDiv.innerHTML = `${cfImg ? cfSVG : ''} ${mfImg ? mfSVG : ''} ${cdrImg ? cdrSVG : ''} ${mcgfImg ? mcgfSVG : ''}`;
            td7.appendChild(activityDiv);
          } else {
            const pendActivity = divAtt('img', 'src', `${greyCross}`);
            td7.appendChild(pendActivity);
          }
        } else {
          const pendActivity = divAtt('img', 'src', `${greyCross}`);
          td7.appendChild(pendActivity);
        }
        // const pendActivity = row.activityInProgressYN ? divAtt('img', 'src', `${tickIcon}`) : divAtt('img', 'src', `${greyCross}`);

        const td9 = divAtt('td', 'class', '');
        const params = row.HapplicationID;
        const btn = divAtt('button', 'onclick', `PREP('sanitizeApplications', 'HAPPLICATIONID=${params}')`);
        btn.classList.add('btn');
        btn.innerHTML = 'update';
        td9.appendChild(btn);

        tr.appendChild(td0);
        tr.appendChild(td5);
        tr.appendChild(td01);
        tr.appendChild(td1);
        tr.appendChild(td2);
        tr.appendChild(td3);
        tr.appendChild(td4);
        tr.appendChild(td6);
        tr.appendChild(td8);
        tr.appendChild(td10);
        tr.appendChild(td7);
        tr.appendChild(td9);
        tbody.appendChild(tr);
      }
      unhide('searchSpace');
    }
    id('listApplicationsTable').appendChild(tbody);
    // return tbody
  }
}

export class SanitizeApplication {
  constructor(vars) {
    this.name = 'Edit Application';
    this.pageTier = 15;
    this.reference = 'editApplication';
    this.pageID = null;
    this.data = null;
    this.HclientID = null;
    this.HapplicationID = vars.HapplicationID;
  }

  initPage(data) {
    // Set page pecific variables
    this.HclientID = data.getApplicationDetail[0].HclientID;
    this.candidateID = data.getApplicationDetail[0].candidateID;
    this.loadPage();
  }

  loadPage() {}
}

export class SanitizeAppDiscHeaders {
  constructor(vars) {
    this.name = 'Edit Application - Discovery Headers';
    this.pageTier = 20;
    this.reference = 'SAs_headersDISC';
    this.pageID = null;
    this.data = null;
    this.HclientID = vars.HclientID;
    this.HapplicationID = vars.HapplicationID;
    this.grouping = vars.grouping;
  }

  initPage(data) {
    // Set page pecific variables
    this.getApplicationDetail = data.getApplicationDetail[0];
    this.HclientID = data.getApplicationDetail[0].HclientID;
    this.getDDCountry = cObj(data.getDDCountry);
    this.getDDPositionLevel = cObj(data.getDDPositionLevel);
    this.getDiscoveryLineManagers = cObj(data.getDiscoveryLineManagers);
    this.getDDCostCenters = cObj(data.getDDCostCenters);
    this.getDDdivisions = cObj(data.getDDdivisions);
    this.getDDjobfamily = cObj(data.getDDjobfamily);
    this.getDiscoveryRecruiters = cObj(data.getDiscoveryRecruiters);
    this.loadPage();
  }

  loadPage() {
    this.headersPageDisc();
  }

  headersPageDisc() {
    const getDDCountry = this.getDDCountry;
    const getDDPositionLevel = this.getDDPositionLevel;
    const getDiscoveryLineManagers = this.getDiscoveryLineManagers;
    const getDDCostCenters = this.getDDCostCenters;
    const getDDdivisions = this.getDDdivisions;
    const getDDjobfamily = this.getDDjobfamily;
    const getDiscoveryRecruiters = this.getDiscoveryRecruiters;

    //Country
    buildDropDownMain(getDDCountry, 'preferredLocation', 'DDCOUNTRYID', 'DESCRIPTION');

    //position Level
    createSelectOptions2(getDDPositionLevel, 'DDPOSITIONLEVELID', ['SHORTDESCRIPTION'], 'DDpositionLevelID');

    id('DDpositionLevelID').addEventListener('click', () => {
      const select = id('DDpositionLevelID');
      id('c_f_positionlevel').value = select.options[select.selectedIndex].text;
    });

    //getDiscoveryLineManagers
    createSelectOptions2(getDiscoveryLineManagers, 'HUSERID', ['COMBONAME'], 'hiringManagerID');

    id('hiringManagerID').addEventListener('click', () => {
      const select = id('hiringManagerID');
      id('c_f_hiringManager').value = select.options[select.selectedIndex].text;
    });

    //getDDCostCenters
    createSelectOptions2(getDDCostCenters, 'DDCOSTCENTERID', ['SHORTDESCRIPTION'], 'DDcostCenterID');

    id('DDcostCenterID').addEventListener('click', () => {
      const select = id('DDcostCenterID');
      id('newCostCenterName').value = select.options[select.selectedIndex].text;
    });

    //getDDdivisions
    createSelectOptions2(getDDdivisions, 'DDDIVISIONID', ['SHORTDESCRIPTION'], 'DDdivisionID');

    id('DDdivisionID').addEventListener('click', () => {
      const select = id('DDdivisionID');
      id('newDivisionName').value = select.options[select.selectedIndex].text;
    });

    //getDDjobfamily
    createSelectOptions2(getDDjobfamily, 'DDJOBFAMILYID', ['FULLDECSRIPTION'], 'DDjobFamilyID');

    id('DDjobFamilyID').addEventListener('click', () => {
      const select = id('DDjobFamilyID');
      id('newjobFamilyName').value = select.options[select.selectedIndex].text;
    });

    //getDiscoveryRecruiters
    createSelectOptions2(getDiscoveryRecruiters, 'HUSERID', ['COMBONAME'], 'recruiterID');

    id('recruiterID').addEventListener('click', () => {
      const select = id('recruiterID');
      id('c_f_recruiter').value = select.options[select.selectedIndex].text;
    });

    this.headersDetailDisc();
  }

  headersDetailDisc() {
    const data = this.getApplicationDetail;

    const date = new Date(data.clientrequiredAssessmentDate).toISOString().substring(0, 10);
    id('editUserID').value = data.candidateID;
    id('candidatefname').value = data.candidateFname;
    id('candidatesname').value = data.candidatesname;
    id('jobTitle').value = data.clientjobTitle;
    id('DDpositionLevelID').value = data.clientpositionID;
    id('preferredLocation').value = data.DDcountryID ? data.DDcountryID : '-';
    id('preferredDate').value = date;
    id('rfcNr').value = data.RFCNumber;
    id('purpose').value = data.purpose;
    id('DDcostCenterID').value = data.DDcostCenterID;
    id('DDdivisionID').value = data.DDdivisionID;
    id('DDpositionLevelID').value = data.DDpositionLevelID;
    id('hiringManagerID').value = data.lineManagerID;
    id('recruiterID').value = data.RecruiterID;
    id('clientcomments').value = data.clientcomments;
    id('positionNumber').value = data.clientpositionID;
    id('addedBy').innerHTML = data.addedbyfname + ' ' + data.addedbysname;
    id('candidateemailAddress').value = data.candidateEmail;

    countryCode(data.candidateMobilenumber, this.HclientID);
    // id('candidatemobileNo').value = data.candidateMobilenumber;

    if (data.candidateIDnumber && data.candidateIDnumber !== 'N/A') {
      id('candidateIDnr').value = data.candidateIDnumber;
    } else {
      id('candidatePassportnr').value = data.candidatePassportNumber;
      hide('candidateIDnrInput');
      unhide('candidatePassportnrInput');
    }

    id('DDjobFamilyID').value = data.DDjobFamilyID;
    if (id('DDjobFamilyID').value === '6') {
      id('Q1YN').src = data.question1 === 1 ? `${tickIcon}` : `${greyCross}`;
      id('Q2YN').src = data.question2 === 1 ? `${tickIcon}` : `${greyCross}`;
      id('QcomboYN').src = data.questionCombo === 1 ? `${tickIcon}` : `${greyCross}`;
      unhide('scientistDiv');
    }

    id('applicationStatus').innerHTML = data.status;
    if (data.activityInProgressYN) {
      id('actStatus').innerHTML = data.latestActivity;
      unhide('actStatusDiv');
    }

    if (data.expressServiceYN) {
      id('expressService').checked = true;
      id('expressService').setAttribute('disabled', '');
      id('checkBoxColour').style.backgroundColor = '#C0C0C0';
    }
    const otherProfiles = data.alternateProfiles;
    const altProfiles = id('otherProfiles');

    const newProfArr = otherProfiles.split(',');

    for (let i = 0; i < newProfArr.length; i++) {
      if (newProfArr[i] === 'Other roles for this email address:') {
        const newProfile = divAtt('span', 'class', 'otherRoles');
        newProfile.innerHTML = `${newProfArr[i]}`;
        altProfiles.appendChild(newProfile);
      } else if (newProfArr[i] === 'No other roles') {
        const newProfile = divAtt('span', 'class', 'noOtherRoles');
        newProfile.innerHTML = `${newProfArr[i]}`;
        altProfiles.appendChild(newProfile);
      } else if (i === 1) {
        const newProfile = divAtt('span', 'class', 'idkWhatThisIs');
        newProfile.innerHTML = ` ${newProfArr[i]}`;
        altProfiles.appendChild(newProfile);
      } else {
        const newProfile = divAtt('span', 'class', 'idkWhatThisIs');
        newProfile.innerHTML = `, ${newProfArr[i]}`;
        altProfiles.appendChild(newProfile);
      }
    }

    // Cater for client pacific fields
    applications.hideClientPacificFields(this.HclientID);

    // if app has been cancelled
    if (data.status === 'Cancelled' || data.status === 'cancelled') {
      // id('cancelBtn').setAttribute('onclick', `applications.reactivateApp('${this.HapplicationID}')`);

      eListen(
        'cancelBtn',
        () => {
          applications.reactivateApp(this.HapplicationID);
        },
        'click'
      );
      id('cancelBtn').innerHTML = 'Reactivate Application';
    }
  }

  static async updateApplication() {
    const ths = pgstr.SAs_headersDISC;

    if (!validatePage()) {
      return;
    }

    const obj = {};
    obj.expressService = toggleSliderYN(id('expressService').checked);
    obj.candidatefname = id('candidatefname').value.trim();
    obj.candidatesname = id('candidatesname').value.trim();
    obj.candidateIDnr = id('candidateIDnr').value.trim();
    obj.candidateemailAddress = id('candidateemailAddress').value.trim();
    const phoneNumber = await sanatizeNum(id('f_cellNr').value, id('countryCodes').value);
    obj.candidatemobileNo = phoneNumber;
    obj.positionNumber = id('positionNumber').value.trim();
    obj.rfcNr = id('rfcNr').value.trim();
    obj.clientcomments = obj.clientcomments === '' ? 0 : id('clientcomments').value.trim();
    obj.jobTitle = id('jobTitle').value.trim();
    obj.preferredDate = id('preferredDate').value.trim();
    obj.DDCountryID = id('preferredLocation').value;
    obj.purpose = id('purpose').value.trim();
    obj.DDpositionLevelID = id('DDpositionLevelID').value;
    obj.DDjobFamilyID = id('DDjobFamilyID').value.trim();
    obj.DDcostCenterID = id('DDcostCenterID').value.trim();
    obj.DDdivisionID = id('DDdivisionID').value.trim();
    obj.hiringManagerID = id('hiringManagerID').value.trim();
    obj.recruiterID = id('recruiterID').value.trim();
    obj.HapplicationID = ths.HapplicationID;

    const vars = {};

    vars.entityUUID = uuidv4();
    vars.entityType = 'updateDiscoveryApplication';
    vars.payload = JSON.stringify(obj);
    PREP(['uploadNewRecords'], vars)
      .then((res) => {
        note(res.data.uploadNewRecords);
        changeTabN('SAt_headers');
      })
      .catch(console.error());
  }

  static cancelReason() {
    const div = divAtt('div', 'class', 'grid-1col');
    div.setAttribute('id', 'cancelDiv');
    const btn = buildBtnFormCenter('confirmCancel', `SanitizeAppGAPHeaders.cancelApplication('${pgstr.SAs_headersDISC.HapplicationID}')`, 'Confirm Cancel');

    PREP(['getApplicationCancellOptions'], {
      HapplicationID: pgstr.SAs_headersDISC.HapplicationID,
    })
      .then(async (res) => {
        const select = await buildSelectInp('cancelReason', 1, 'Reason');
        select.setAttribute('style', 'margin-top: 3rem;');
        const comments = await buildTextarea('cancellComments', 1, 'Comments');
        div.appendChild(select);
        div.appendChild(comments);
        div.appendChild(btn);
        eCustardBox(div, `Reason for Cancelling Application`, [
          'confirmCancel',
          () => {
            SanitizeAppGAPHeaders.cancelApplication(pgstr.SAs_headersDISC.HapplicationID);
          },
          'click',
        ]);
        // await custardBox(
        //   div,
        //   `Reason
        //         for Cancelling Application`
        // )
        buildDropDownMain(res.data.getApplicationCancellOptions[0].cancellReasons, 'cancelReason', 'cancellReasonID', 'reasonDisplay');
      })
      .catch(console.error());
  }
}

export class SanitizeAppGAPHeaders {
  constructor(vars) {
    this.name = 'Edit Application - GAP Headers';
    this.pageTier = 20;
    this.reference = 'SAs_headersGAP';
    this.pageID = null;
    this.data = null;
    this.HclientID = vars.HclientID;
    this.HapplicationID = vars.HapplicationID;
    this.grouping = vars.grouping;
  }

  initPage(data) {
    // Set page pecific variables
    this.getApplicationDetail = data.getApplicationDetail[0];
    this.HclientID = data.getApplicationDetail[0].HclientID;
    this.loadPage();
  }

  loadPage() {
    this.headersPageGAP();
  }

  headersPageGAP() {
    const gap = this.getApplicationDetail;
    id('addedBy').innerHTML = gap.addedbyfname + ' ' + gap.addedbysname;
    id('applicationStatus').innerHTML = gap.status;
    id('applicationStatus').innerHTML = gap.status;
    if (gap.activityInProgressYN) {
      id('actStatus').innerHTML = gap.latestActivity;
      unhide('actStatusDiv');
    }
    id('candidatefname').value = gap.candidateFname;
    id('candidatesname').value = gap.candidatesname;
    id('candidateemailAddress').value = gap.candidateEmail;
    countryCode(gap.candidateMobilenumber, gap.HclientID);
    if (gap.internalExternal) {
      const intExName = gap.internalExternal.trim().toLowerCase();
      id(`${intExName}`).checked = true;
    }

    // if (!gap.candidatePassportNumber) {
    //     id('candidateIDnr').value = gap.candidateIDnumber;
    //     id('candidatePassportnr').value = '';
    //     hide('candidatePassportnrInput');
    // } else {
    //     id('candidatePassportnr').value = gap.candidatePassportNumber;
    //     id('candidateIDnr').value = '';
    //     id('candidatePassportnr').classList.add('notEmpty');
    //     id('candidateIDnr').classList.remove('notEmpty');
    //     id('IDtoggle').checked = false;
    //     unhide('candidateIDnrInput');
    //     hide('candidateIDdiv');
    // }
    id('candidateDOB').value = formatDateforInput(gap.candidateDOB);

    id('positionNumber').innerHTML = gap.clientpositionID;
    id('jobTitle').innerHTML = gap.clientjobTitle;
    id('jobLevel').innerHTML = gap.positionLevel;
    id('jobGrade').innerHTML = gap.GAPjobgrade;
    id('jobFamily').innerHTML = gap.jobFamilyName;
    id('jobDepart').innerHTML = gap.division;
    if (gap.agency === 'internalDev') {
      id('agency').innerHTML = 'Internal Development';
    } else {
      id('agency').innerHTML = gap.agency;
    }
    if (gap.hireResource === 'internalDev') {
      id('hireResource').innerHTML = 'Internal Development';
    } else {
      id('hireResource').innerHTML = gap.hireResource;
    }

    // id('jobObjective').innerHTML = gap.jobobjectives;
    const objectivesDiv = id('jobObjective');
    objectivesDiv.innerHTML = '';
    if (!gap.objectives.length) {
      objectivesDiv.innerHTML = '';
    } else if (gap.objectives.length > 1) {
      for (let objctv of gap.objectives) {
        const li = divAtt('li', 'class', '');
        li.innerHTML = objctv.shortName;
        objectivesDiv.appendChild(li);
      }
    } else {
      objectivesDiv.innerHTML = gap.objectives.shortName;
    }

    id('costCenter').innerHTML = gap.costCenter;
    id('jobPurpose').innerHTML = gap.GAPJobpurpose;
    id('lineMan').innerHTML = `${gap.lineManagerfname} ${gap.linemanagerSname}`;
    // id('numReports').innerHTML = gap.directreportcnt;
    if (!gap.supervisionRequiredYN) {
      id('supervision').innerHTML = `No`;
    } else {
      id('supervision').innerHTML = `Yes`;
    }
    id('jobFuncArea').innerHTML = `${gap.GAPJobfunctionarea}`;
    // if (gap.expressServiceYN) {
    //   id('expressService').checked = true;
    //   id('expressService').setAttribute('disabled', '');
    //   id('checkBoxColour').style.backgroundColor = '#C0C0C0';
    // }

    // ====List Docs====
    if (gap.documents.length) {
      const data = gap.documents;

      console.log('gap data', data);
      const docBody = id('docBody');
      docBody.innerHTML = '';

      for (let el of data) {
        const profRow = divAtt('tr', 'class', 'doc');
        profRow.setAttribute('id', `docID_${el.HjobDocumentsID}`);
        const dateAdded = divAtt('td', 'class', '');
        dateAdded.innerHTML = `${el.dateAdded}`;
        const addedBy = divAtt('td', 'class', '');
        addedBy.innerHTML = `${el.addedbyFname} ${el.addedbySname}`;
        const fileName = divAtt('td', 'class', '');
        fileName.innerHTML = `${el.originalFileName}`;

        const download = divAtt('td', 'class', '');
        const downloadImg = divAtt('a', 'class', 'flex');
        downloadImg.innerHTML = `<svg  width="13.8" height="13.8" viewBox="0 0 13.8 13.8">
            <path
                d="M7,11.34a.72.72,0,0,0,1,0l2.7-2.69a.74.74,0,0,0,0-1,.72.72,0,0,0-1,0L8.21,9.11V1.31a.71.71,0,0,0-1.42,0v7.8L5.31,7.64a.72.72,0,0,0-1,0,.74.74,0,0,0,0,1Z"
                transform="translate(-0.6 -0.6)" />
            <path
                d="M13.69,6.79A.72.72,0,0,0,13,7.5V13H2V7.5a.71.71,0,0,0-.71-.71h0A.71.71,0,0,0,.6,7.5v5.71A1.19,1.19,0,0,0,1.79,14.4H13.21a1.19,1.19,0,0,0,1.19-1.19V7.5A.71.71,0,0,0,13.69,6.79Z"
                transform="translate(-0.6 -0.6)" /></svg>`;
        // downloadImg.setAttribute(
        //   "onclick",
        //   `report.download(${el.HjobDocumentsID})`
        // );
        // downloadImg.setAttribute('target', `blank`);
        download.appendChild(downloadImg);

        profRow.appendChild(dateAdded);
        profRow.appendChild(addedBy);
        profRow.appendChild(fileName);
        profRow.appendChild(download);
        docBody.appendChild(profRow);
        eListen(
          downloadImg,
          () => {
            report.download(el.HjobDocumentsID);
          },
          'click'
        );
      }
      unhide('docTable');
    } else {
      hide('docTable');
    }

    // Cater for client pacific fields
    applications.hideClientPacificFields(this.HclientID);

    // if app has been cancelled
    if (gap.status === 'Cancelled' || gap.status === 'cancelled') {
      // id('cancelBtn').setAttribute('onclick', `applications.reactivateApp('${this.HapplicationID}')`);
      eListen(
        'cancelBtn',
        () => {
          applications.reactivateApp(this.HapplicationID);
        },
        'click'
      );
      id('cancelBtn').innerHTML = 'Reactivate Application';
    }
  }

  static async updateApplicationGAP() {
    if (!validatePage()) {
      return;
    }
    const obj = {};
    obj.candidatefname = id('candidatefname').value.trim();
    obj.candidatesname = id('candidatesname').value.trim();
    obj.candidateemailAddress = id('candidateemailAddress').value.trim();
    obj.candidatemobileNo = await sanatizeNum(id('f_cellNr').value, id('countryCodes').value);

    var radios = document.getElementsByName('internExternal');
    for (var i = 0, length = radios.length; i < length; i++) {
      if (radios[i].checked) {
        obj.internalExternal = radios[i].value;
        break;
      }
    }
    // if (id('IDtoggle').checked) {
    //     obj.candidateIDnumber = (id('candidateIDnr').value).trim();
    //     obj.candidatePassportNumber = '';
    // } else {
    //     obj.candidateIDnumber = '';
    //     obj.candidatePassportNumber = (id('candidatePassportnr').value).trim();
    // }

    obj.candidateIDnumber = '';
    obj.candidatePassportNumber = '';
    obj.candidateDOB = id('candidateDOB').value.trim();
    obj.HapplicationID = pgstr.SAs_headersGAP.HapplicationID;

    const vars = {};
    vars.entityUUID = uuidv4();
    vars.entityType = 'updateGAPApplication';
    vars.payload = JSON.stringify(obj);

    PREP(['uploadNewRecords'], vars)
      .then((res) => {
        note(res.data.uploadNewRecords);
        changeTabN('SAs_headersGAP');
      })
      .catch(console.error());
  }

  static cancelReason() {
    const div = divAtt('div', 'class', 'grid-1col');
    div.setAttribute('id', 'cancelDiv');
    const btn = buildBtnFormCenter('confirmCancel', `SanitizeAppGAPHeaders.cancelApplication('${pgstr.SAs_headersGAP.HapplicationID}')`, 'Confirm Cancel');

    PREP(['getApplicationCancellOptions'], {
      HapplicationID: pgstr.SAs_headersGAP.HapplicationID,
    })
      .then(async (res) => {
        const select = await buildSelectInp('cancelReason', 1, 'Reason');
        select.setAttribute('style', 'margin-top: 3rem;');
        const comments = await buildTextarea('cancellComments', 1, 'Comments');
        div.appendChild(select);
        div.appendChild(comments);
        div.appendChild(btn);
        eCustardBox(div, `Reason for Cancelling Application`, [
          'confirmCancel',
          () => {
            SanitizeAppGAPHeaders.cancelApplication(pgstr.SAs_headersGAP.HapplicationID);
          },
          'click',
        ]);
        // await custardBox(
        //   div,
        //   `Reason
        //         for Cancelling Application`
        // )

        console.log('cancelreason', res.data.getApplicationCancellOptions[0].cancellReasons);

        buildDropDownMain(res.data.getApplicationCancellOptions[0].cancellReasons, 'cancelReason', 'cancellReasonID', 'reasonDisplay');
      })
      .catch(console.error());
  }

  static cancelApplication(HapplicationID) {
    if (!validateDiv('cancelDiv')) {
      return;
    }

    const vars = {};
    vars.HapplicationId = HapplicationID;
    vars.cancellReasonID = id('cancelReason').value;
    vars.cancellComments = id('cancellComments').value;
    PREP(['cancellApplication'], vars)
      .then((res) => {
        note(res.data.cancellApplication);
        hide('custardBox');
        PREP('adminApplications');
      })
      .catch(console.error());
  }
}

export class SanitizeAppAAHeaders {
  constructor(vars) {
    this.name = 'Edit Application - Anglo Headers';
    this.pageTier = 20;
    this.reference = 'SAs_headersAA';
    this.pageID = null;
    this.data = null;
    this.HclientID = vars.HclientID;
    this.HapplicationID = vars.HapplicationID;
    this.grouping = vars.grouping;
  }

  initPage(data) {
    // Set page pecific variables
    this.appDetail = data.getApplicationDetail[0];
    this.HclientID = data.getApplicationDetail[0].HclientID;
    // this.appAss = data.listAllocatedAssessmentOne;
    // this.appAss = data.listAllocatedAssessmentOne.length ? data.listAllocatedAssessmentOne[0].assListArray : data.listAllocatedAssessmentOne;
    if (data.listAllocatedAssessmentOne.length) {
      if (data.listAllocatedAssessmentOne[0].assListArray) {
        this.appAss = data.listAllocatedAssessmentOne[0].assListArray;
      } else {
        this.appAss = data.listAllocatedAssessmentOne;
      }
    } else {
      this.appAss = data.listAllocatedAssessmentOne;
    }
    this.feedbackRequestor = data.getAAFeedbackRequestor;
    this.reportAllocToApp = cObj(data.getReportsAllocatedToApplication);
    this.getAAReportViewer = data.getAAReportViewer;
    this.getLinkedReportViewers = data.getLinkedReportViewers;
    this.getLinkedHRBP = data.getLinkedHRBP;
    this.getAAHRContact = data.getAAHRContact;

    this.getDDlegalEntity = null; // cObj(data.getDDlegalEntity);
    this.getLocations = data.getLocations; //cObj(data.getLocations);
    // this.getSuccessprofile = cObj(data.getSuccessprofile);
    this.getBusinessEntities = cObj(data.getBusinessEntities);
    this.costCenter = data.GAPCostCenter;
    this.roleTitle = data.GAPJobTitle;
    this.workLevel = data.GAPPositionLevel;
    this.busUnit = data.GAPJobDivision;
    this.requestors = data.getAARequestors;
    this.HRContact = data.getAAHRContact;
    this.hiringManager = data.getAAHiringmanager;
    this.reportViewer = data.getAAReportViewer;
    this.timeZones = cObj(data.getTimezones);
    this.feedbackRequestor = data.getAAFeedbackRequestor;
    this.HapplicationID = data.getApplicationDetail[0].HapplicationID;

    this.loadPage();
  }

  loadPage() {
    this.headersPageAA();
  }

  async headersPageAA() {
    buildDropDownMain(this.getBusinessEntities, 'busEntity', 'DDBUSINESSENTITYID', 'DESCRIPTION');

    buildDropDownMain(this.workLevel, 'workLevel', 'DDpositionLevelID', 'shortname');

    buildDropDownMain(this.costCenter, 'costCentre', 'DDcostCenterID', 'shortdescription');

    buildDropDownMain(this.requestors, 'recruiter', 'HuserID', 'comboname');

    buildDropDownMain(this.HRContact, 'HRContact', 'HuserID', 'shortname');
    ViewAngloApplication.buildHRBP(this.getLinkedHRBP);

    buildDropDownMain(this.hiringManager, 'hiringManager', 'HuserID', 'shortname');

    buildDropDownMain(this.roleTitle, 'roleTitle', 'DDjobtitleID', 'shortname');

    buildDropDownMain(this.busUnit, 'busUnit', 'DDDivisionID', 'shortname');

    buildDropDownMain(this.timeZones, 'timeZone', 'DDTIMEZONEID', 'DESCRIPTION');

    buildDropDownMain(this.getLocations, 'location', 'DDlocationsID', 'description');

    buildDropDownMain(this.reportViewer, 'reportViewer', 'HuserID', 'shortname');
    ViewAngloApplication.buildReportViewers(this.getLinkedReportViewers, this.HclientID);
    RecordAngloApp.newEntries();

    const data = this.appDetail;

    id('applicationStatus').innerHTML = data.status;
    id('addedBy').innerHTML = data.addedbyfname + ' ' + data.addedbysname;
    if (data.activityInProgressYN) {
      id('actStatus').innerHTML = data.latestActivity;
      unhide('actStatusDiv');
    }

    // SECTION Commercial Details
    id('busEntity').value = data.DDbusinessentityID;
    SanitizeAppAAHeaders.populatelegalEnt(data.DDbusinessentityID, data.DDLegalentityID);
    id('workLevel').value = data.DDpositionLevelID;
    if (data.purpose === 'Recruitment' || data.purpose === 'recruitment') {
      id('assPurpose').value = 'recruitment';
    } else {
      id('assPurpose').value = 'development';
    }

    id('purchaseOrderNum').value = data.PONumber;
    id('costCentre').value = data.DDcostCenterID;
    await SanitizeAppAAHeaders.populateAssPackage(data.DDpositionLevelID, data.DDLegalentityID, data.purpose, data.DDassPackageID);
    RecordAngloApp.assPurposeOpt();
    RecordAngloApp.includeMPA();

    // SECTION Candidate Details
    id('roleTitle').value = data.applicationJobtitleID;
    id('busUnit').value = data.DDdivisionID;
    if (data.leadershipScope.includes('Integrated')) {
      id('leadershipScope').value = 'integrated';
    } else {
      id('leadershipScope').value = data.leadershipScope;
    }

    id('location').value = data.DDlocationsID;
    id('timeZone').value = data.DDtimezoneID;
    id('jobID').value = data.clientjobID;

    // SECTION Business Contact details
    id('recruiter').value = data.RecruiterID;
    id('hiringManager').value = data.lineManagerID;

    // SECTION Candidate Details
    id('canName').value = data.candidateFname;
    id('canSName').value = data.candidatesname;
    id('canEmail').value = data.candidateEmail;
    ccRegexMulti(0, data.HclientID);
    countryCode(data.candidateMobilenumber, data.HclientID, 'canCountryCodes', 'canPhoneNum');
    id('comments').value = data.clientcomments;
    id('appEmployeeID').value = data.candidateID;

    if (data.internalExternal === 'internal') {
      id('internal').checked = true;
    } else {
      id('external').checked = true;
    }

    // MPA
    RecordAngloApp.includeMPA();
    if (data.MPAIncluded == 1) {
      id('Include').checked = true;
      id('Exclude').disabled = true;
      unhide('MPAreadonly');
    } else {
      id('Exclude').checked = true;
      hide('MPAreadonly');
    }

    // Cater for client pacific fields
    applications.hideClientPacificFields(this.HclientID);

    // if app has been cancelled
    if ([7, 8, 9, 14].includes(data.DDapplicationStatusID)) {
      // id('cancelBtn').setAttribute('onclick', `applications.reactivateApp('${this.HapplicationID}')`);
      eListen(
        'cancelBtn',
        () => {
          applications.reactivateApp(this.HapplicationID);
        },
        'click'
      );
      id('cancelBtn').innerHTML = 'Reactivate Application';
    }
  }

  static populatelegalEnt(val, legVal) {
    const busEnt = val;

    if (busEnt === '-') {
      unhide('legalMsg');
      hide('legalEntity');
      hide('legalEntity_FB');
      return;
    }

    const vars = {};
    vars.DDbusinessentityID = busEnt;
    vars.HclientID = 42;
    PREP(['getDDlegalEntity'], vars)
      .then((res) => {
        const legal = cObj(res.data.getDDlegalEntity);
        buildDropDownMain(legal, 'legalEntity', 'DDLEGALENTITYID', 'DESCRIPTION');

        hide('legalMsg');
        unhide('legalEntity');

        id('legalEntity').value = legVal;

        const langList = {};
        for (const lang of legal) {
          langList[`${lang.DDLEGALENTITYID}`] = lang.LANGUAGE;
        }
        pgstr.SAs_headersAA.language = langList;
        SanitizeAppAAHeaders.changeRegLang();
      })
      .catch(console.error());
  }

  static populateAssPackage(workLev, legEnt, assPur, asspackID) {
    // const workLevel = id('workLevel').value;
    // const legalEntity = id('legalEntity').value;
    // const assPurpose = id('assPurpose').value;

    const workLevel = workLev;
    const legalEntity = legEnt;
    const assPurpose = assPur;

    const vars = {};
    vars.DDpositionlevelID = workLevel;
    vars.DDlegalEntityID = legalEntity;
    vars.assPurpose = assPurpose;
    PREP(['getassPackages'], vars)
      .then((res) => {
        const assPack = res.data.getassPackages;
        buildDropDownMain(assPack, 'assPackage', 'HasspackageID', 'shortname');

        hide('assPackMsg');
        unhide('assPackage');

        id('assPackage').value = asspackID;
      })
      .catch(console.error());
  }

  static changeRegLang() {
    const langList = pgstr.SAs_headersAA.language;

    if (langList) {
      Object.entries(langList).forEach(([key, value]) => {
        if (key === id('legalEntity').value) {
          id('regLang').innerHTML = value;
        }
      });
    } else {
      id('regLang').innerHTML = 'Language will update based on Legal Entity selection';
    }
  }

  static cancelReason() {
    const div = divAtt('div', 'class', 'grid-1col');
    div.setAttribute('id', 'cancelDiv');
    const btn = buildBtnFormCenter('confirmCancel', `SanitizeAppAAHeaders.cancelApplication('${pgstr.SAs_headersAA.HapplicationID}')`, 'Confirm Cancel');

    PREP(['getApplicationCancellOptions'], {
      HapplicationID: pgstr.SAs_headersAA.HapplicationID,
    })
      .then(async (res) => {
        const select = await buildSelectInp('cancelReason', 1, 'Reason');
        select.setAttribute('style', 'margin-top: 3rem;');
        const comments = await buildTextarea('cancellComments', 1, 'Comments');
        div.appendChild(select);
        div.appendChild(comments);
        div.appendChild(btn); //fuck
        eCustardBox(div, `Reason for Cancelling Application`, [
          'confirmCancel',
          () => {
            SanitizeAppAAHeaders.cancelApplication(pgstr.SAs_headersAA.HapplicationID);
          },
          'click',
        ]);
        // await custardBox(
        //   div,
        //   `Reason for Cancelling Application`
        // )

        buildDropDownMain(res.data.getApplicationCancellOptions[0].cancellReasons, 'cancelReason', 'cancellReasonID', 'reasonDisplay');
      })
      .catch(console.error());
  }

  static cancelApplication(HapplicationID) {
    if (!validateDiv('cancelDiv')) {
      return;
    }

    const vars = {};
    vars.HapplicationId = HapplicationID;
    vars.cancellReasonID = id('cancelReason').value;
    vars.cancellComments = id('cancellComments').value;
    PREP(['cancellApplication'], vars)
      .then((res) => {
        note(res.data.cancellApplication);
        hide('custardBox');
        PREP('adminApplications');
      })
      .catch(console.error());
  }

  static async updateApplicationAA() {
    if (!validatePage()) {
      return;
    }

    if (id('internal').checked === false && id('external').checked === false) {
      return inpFeedbackBanner('Please select an option for Inter/External under Candidate Details');
    }

    if (id('MPAdiv').classList.contains('extraVal')) {
      if (id('Include').checked === false && id('Exclude').checked === false) {
        return inpFeedbackBanner('Please select an option for MPA assessment battery.');
      }
    }

    if (!id('HRBPList').innerHTML.trim()) {
      id('HRContact').classList.add('incorrect');
      return inpFeedbackBanner(`Please add an HR Business Partner by selecting an option and clicking the '+' button`);
    }

    // ==================================

    const obj = {};
    const vars = {};

    const idArr = ['busEntity', 'legalEntity', 'workLevel', 'assPurpose', 'assPackage', 'purchaseOrderNum', 'costCentre', 'roleTitle', 'busUnit', 'leadershipScope', 'location', 'timeZone', 'recruiter', 'hiringManager', 'comments']; //successProfile regionalLanguage addServices

    for (let item of idArr) {
      if (id(`${item}`).value == 'NEW' && item == 'hiringManager') {
        const RphoneNumber = await sanatizeNum(id('cellHM').value, id('HMcountryCodes').value);
        obj[item] = {
          value: id(`${item}`).value,
          fName: id('fNameHM').value,
          sName: id('sNameHM').value,
          email: id('emailHM').value,
          mobNum: RphoneNumber,
        };
      } else if (id(`${item}`).value == 'NEW' && item == 'recruiter') {
        const RphoneNumber = await sanatizeNum(id('cellR').value, id('RcountryCodes').value);
        obj[item] = {
          value: id(`${item}`).value,
          fName: id('fNameR').value,
          sName: id('sNameR').value,
          email: id('emailR').value,
          mobNum: RphoneNumber,
        };
      } else if (id(`${item}`).value == 'NEW') {
        obj[item] = {
          value: id(`${item}`).value,
          newEntry: id(`new${item}`).value,
        };
      } else {
        obj[item] = {
          value: id(`${item}`).value,
        };
      }
    }

    // ================================

    const canPhoneNumber = await sanatizeNum(id('canPhoneNum').value, id('canCountryCodes').value);
    obj['candidateDetails'] = {
      fName: id('canName').value,
      sName: id('canSName').value,
      appEmployeeID: id('appEmployeeID').value,
      jobID: id('jobID').value,
      mobNum: canPhoneNumber,
      email: id('canEmail').value,
    };

    var radios = document.getElementsByName('internExternal');
    for (var i = 0, length = radios.length; i < length; i++) {
      if (radios[i].checked) {
        obj.internalExternal = {
          value: radios[i].value,
        };
        break;
      }
    }

    var radiosMPA = document.getElementsByName('mpa');
    for (var i = 0, length = radiosMPA.length; i < length; i++) {
      if (radiosMPA[i].checked) {
        if (id('MPAdiv').classList.contains('extraVal')) {
          obj.MPA = {
            value: radiosMPA[i].value,
          };
        } else {
          obj.MPA = {
            value: '',
          };
        }
        break;
      }
    }

    // ==================

    const HRBPobj = {};
    const HRlis = document.querySelectorAll('.HRli');
    let cntr = 1;
    HRlis.forEach((HRli) => {
      if (HRli.classList.contains('new')) {
        HRBPobj[`HRBR${cntr}`] = {
          value: 'NEW',
          fName: id(`${HRli.id}_name`).innerHTML,
          sName: id(`${HRli.id}_surname`).innerHTML,
          email: id(`${HRli.id}_email`).innerHTML,
          mobNum: id(`${HRli.id}_num`).innerHTML,
        };
      } else {
        HRBPobj[`HRBR${cntr}`] = {
          value: HRli.id,
        };
      }
      cntr++;
    });
    obj.HRbusinessPartner = JSON.stringify(HRBPobj);
    obj.HapplicationID = pgstr.SAs_headersAA.HapplicationID;

    const ReportViewerObj = {};
    const RVlis = document.querySelectorAll('.RVli');
    let cnt = 1;
    RVlis.forEach((RVli) => {
      if (RVli.classList.contains('new')) {
        ReportViewerObj[`RV${cnt}`] = {
          value: 'NEW',
          fName: id(`${RVli.id}_name`).innerHTML,
          sName: id(`${RVli.id}_surname`).innerHTML,
          email: id(`${RVli.id}_email`).innerHTML,
          mobNum: id(`${RVli.id}_num`).innerHTML,
        };
      } else {
        ReportViewerObj[`RV${cnt}`] = {
          value: RVli.id,
        };
      }
      cnt++;
    });
    obj.reportViewer = JSON.stringify(ReportViewerObj);

    // ==================

    vars.payload = JSON.stringify(obj);
    vars.entityType = 'updateAngloApplication';
    vars.entityUUID = uuidvMain();
    console.log('vars', vars.payload);

    PREP(['uploadnewrecords'], vars)
      .then((res) => {
        note(res.data.uploadnewrecords);
        PREP('sanitizeApplications', `HAPPLICATIONID=${pgstr.SAs_headersAA.HapplicationID}`);
      })
      .catch(console.error());
  }
}

export class SAt_contactForm {
  constructor(vars) {
    this.name = 'Edit Application - Contact Form';
    this.pageTier = 20;
    this.reference = 'SAt_contactForm';
    this.pageID = null;
    this.data = null;
    this.HclientID = vars.HclientID;
    this.HapplicationID = vars.HapplicationID;
    this.grouping = vars.grouping;
  }
  initPage(data) {
    // Set page pecific variables
    this.getApplicationDetail = data.getApplicationDetail[0];
    this.getOtherApplications = data.getOtherApplications[0];

    if (data.listAllocatedAssessmentOne[0].assListArray) {
      this.assListArray = data.listAllocatedAssessmentOne[0].assListArray;
    } else {
      this.assListArray = [];
    }

    if (data.listAllocatedAssessmentOne[0].battDetsArray) {
      this.battDetails = data.listAllocatedAssessmentOne[0].battDetsArray[0];
    }

    if (data.listAllocatedAssessmentOne[0].prevAssListArray) {
      this.prevAssListArray = data.listAllocatedAssessmentOne[0].prevAssListArray;
    }

    // this.listAllocatedAssessmentOne = data.listAllocatedAssessmentOne;

    this.loadPage();
  }
  loadPage() {
    this.contactPage();
  }
  async contactPage() {
    const getApplicationDetail = this.getApplicationDetail;

    if (this.battDetails) {
      const battDets = this.battDetails;
      id('battName').innerHTML = battDets.batteryname;
      id('legalEnt').innerHTML = battDets.location;
      id('origin').innerHTML = battDets.ApplicationOrigin;
      id('synch').innerHTML = battDets.synchronicity;

      const commentsArr = battDets.bookingComments.split(',');
      const commentsObj = {};
      commentsArr.forEach((comm) => {
        const comment = comm.split(':');
        const comment0 = comment[0].trim().toLowerCase();
        commentsObj[`${comment0}`] = comment[1];
      });
      id('gBand').innerHTML = commentsObj['global band'] ? commentsObj['global band'] : '';
      id('workLevel').innerHTML = commentsObj['level of work'] ? commentsObj['level of work'] : '';
      unhide('assDets');
    }
    if (getApplicationDetail.publishYN == 0) {
      hide('bookingDiv');
      unhide('notPublished');
      hide('assignedAssesments');
    } else {
      hide('notPublished');

      const body = id('assignedAssBody');
      body.innerHTML = '';
      let dynamicElems = [];

      for (let el of this.assListArray) {
        const tr = divAtt('tr');
        const batName = divAtt('td');
        batName.id = el.HassessmentId;
        batName.classList.add('assessments');
        const prevApp = el.prevApp ? `(${el.prevApp})` : '';
        batName.innerHTML = `${el.shortname} ${prevApp}`;
        tr.appendChild(batName);

        const assBookingDate = divAtt('td');
        assBookingDate.innerHTML = el.bookingdate ? dateFromDateTime(el.bookingdate) : el.bookingdate;
        tr.appendChild(assBookingDate);

        const assHist = divAtt('td');
        assHist.innerHTML = el.assStatus;
        tr.appendChild(assHist);

        const uptDate = divAtt('td');
        uptDate.innerHTML = el.lastUpdated ? el.lastUpdated : 'N/A';
        tr.appendChild(uptDate);

        const assOrigin = divAtt('td');
        assOrigin.innerHTML = el.assResultOrigin ? el.assResultOrigin : 'N/A';
        tr.appendChild(assOrigin);

        const assResultDate = divAtt('td', 'id', `valPeriod_${el.HassessmentId}`);
        const val = el.valPeriod ? `<br>(${el.valPeriod})` : '';
        assResultDate.innerHTML = el.lastResultDate ? `${dateFromDateTime(el.lastResultDate)}${val}` : `N/A`;
        tr.appendChild(assResultDate);

        // ==============
        const noSupp = divAtt('td');
        let suppCheck;
        if (el.reuseYN) {
          suppCheck = divAtt('img', 'src', `${greyCross}`);
          suppCheck.classList.add('cross');
          suppCheck.id = `supp_${el.HassessmentId}`;
        } else {
          if (el.provisionYN) {
            suppCheck = divAtt('img', 'src', `${tickIcon}`);
          } else {
            suppCheck = await buildTickBox(`supp_${el.HassessmentId}`, 0);
            let suppid = `supp_${el.HassessmentId}`;
            dynamicElems.push([
              suppid,
              () => {
                SAt_contactForm.enableDisableRecordBtn(suppid);
              },
            ]);
          }
          // suppCheck = el.provisionYN
          //   ? divAtt("img", "src", `${tickIcon}`)
          //   : await buildTickBox(
          //       `supp_${el.HassessmentId}`,
          //       0);
          // `SAt_contactForm.checkProvReuse('supp_${el.HassessmentId}')`
        }
        noSupp.appendChild(suppCheck);
        tr.appendChild(noSupp);

        const regen = divAtt('td');
        let regenCheck;
        if (el.regenYN) {
          regenCheck = divAtt('img', 'src', `${tickIcon}`);
        } else {
          regenCheck = await buildTickBox(`regen_${el.HassessmentId}`, 0);
          let regid = `regen_${el.HassessmentId}`;
          dynamicElems.push([
            regid,
            () => {
              SAt_contactForm.enableDisableRecordBtn(regid);
            },
          ]);
        }
        regen.appendChild(regenCheck);
        tr.appendChild(regen);

        const conver = divAtt('td');
        let converCheck;
        if (el.conversionYN) {
          converCheck = divAtt('img', 'src', `${tickIcon}`);
        } else {
          converCheck = await buildTickBox(`conver_${el.HassessmentId}`, 0);
          let conid = `conver_${el.HassessmentId}`;
          dynamicElems.push([
            conid,
            () => {
              SAt_contactForm.enableDisableRecordBtn(conid);
            },
          ]);
        }
        conver.appendChild(converCheck);
        tr.appendChild(conver);

        const reuse = divAtt('td');
        let reuseCheck;
        if (el.provisionYN) {
          reuseCheck = divAtt('img', 'src', `${greyCross}`);
          reuseCheck.classList.add('cross');
          reuseCheck.id = `reuse_${el.HassessmentId}`;
        } else {
          if (el.reuseYN) {
            reuseCheck = divAtt('img', 'src', `${tickIcon}`);
          } else {
            reuseCheck = await buildTickBox(`reuse_${el.HassessmentId}`, 0);
            let reuseid = `reuse_${el.HassessmentId}`;
            dynamicElems.push([
              reuseid,
              () => {
                SAt_contactForm.enableDisableRecordBtn(reuseid);
              },
            ]);
          }
          // reuseCheck = el.reuseYN
          //   ? divAtt("img", "src", `${tickIcon}`)
          //   : await buildTickBox(
          //       `reuse_${el.HassessmentId}`,
          //       0);
          // `SAt_contactForm.checkProvReuse('reuse_${el.HassessmentId}')`
        }
        reuse.appendChild(reuseCheck);
        tr.appendChild(reuse);

        body.appendChild(tr);
        // el.provisionYN && (id(`supp_${el.HassessmentId}`).checked = true);
        // el.regenYN && (id(`regen_${el.HassessmentId}`).checked = true);
        // el.conversionYN && (id(`conver_${el.HassessmentId}`).checked = true);
      }

      for (let i = 0; i < dynamicElems.length; i++) {
        eListen(dynamicElems[i][0], dynamicElems[i][1], 'change'); //test mikeee
      }

      unhide('assignedAssesments');
    }

    if (this.getOtherApplications) {
      id('jobTitle').innerHTML = this.getOtherApplications.jobTitle;
      id('batteryName').innerHTML = this.getOtherApplications.batteryName;
      id('busEntity').innerHTML = this.getOtherApplications.businessEntityName;
      id('legalEntity').innerHTML = this.getOtherApplications.legalEntityName;
      id('dateCreated').innerHTML = this.getOtherApplications.dateCreated;
      unhide('otherAppDiv');
    }

    changeSubTab('CFs_email');

    if (getApplicationDetail.duplicateCandidateArray.length) {
      const tableBody = id('dupBody');
      tableBody.innerHTML = '';
      const data = getApplicationDetail.duplicateCandidateArray;
      for (const el of data) {
        const dupRow = divAtt('tr', 'class', 'dup');
        const dupName = divAtt('td', 'class', '');
        dupName.innerHTML = `${el.fname} ${el.sname}`;
        const dupEmail = divAtt('td', 'class', '');
        dupEmail.innerHTML = el.emailaddress;
        const dupNum = divAtt('td', 'class', '');
        dupNum.innerHTML = el.mobileNumber;

        dupRow.appendChild(dupName);
        dupRow.appendChild(dupEmail);
        dupRow.appendChild(dupNum);
        tableBody.appendChild(dupRow);
      }

      unhide('dupTable');
      unhide('dupHR');
    }

    this.populateOtherAss();
  }
  populateOtherAss() {
    if (this.prevAssListArray && this.prevAssListArray.length) {
      const body = id('otherAssBody');
      body.innerHTML = '';

      for (let row of this.prevAssListArray) {
        const tr = divAtt('tr');

        const assName = divAtt('td');
        assName.innerHTML = row.shortName;
        tr.appendChild(assName);

        const assStatus = divAtt('td');
        assStatus.innerHTML = row.assStatus;
        tr.appendChild(assStatus);

        const uptDate = divAtt('td');
        uptDate.innerHTML = row.lastUpdated ? row.lastUpdated : 'N/A';
        tr.appendChild(uptDate);

        const assOrigin = divAtt('td');
        assOrigin.innerHTML = row.assResultOrigin ? row.assResultOrigin : 'N/A';
        tr.appendChild(assOrigin);

        const assResultDate = divAtt('td');
        const val = row.valPeriod ? `<br>(${row.valPeriod})` : '';
        assResultDate.innerHTML = row.lastResultDate ? `${dateFromDateTime(row.lastResultDate)}${val}` : `N/A`;
        tr.appendChild(assResultDate);

        body.appendChild(tr);
      }

      unhide('otherAss');
      hide('noOtherAss');
    } else {
      hide('otherAss');
      unhide('noOtherAss');
    }
  }
  static recordApplicationComments() {
    const vars = {};
    vars.HapplicationID = pgstr.SAt_contactForm.HapplicationID;
    vars.comments = id('contactComments').value;
    PREP(['recordApplicationComments'], vars)
      .then((res) => {
        note(res.data.recordApplicationComments);
        id('contactComments').value = '';
      })
      .catch(console.error());
  }
  static viewApplicationComments() {
    const vars = {};
    vars.HapplicationID = pgstr.SAt_contactForm.HapplicationID;
    vars.HclientID = pgstr.SAt_contactForm.HclientID;

    PREP(['getApplicationComments'], vars)
      .then((res) => {
        const commentsList = res.data.getApplicationComments;
        const div = divAtt('div', 'class', '');
        const table = divAtt('table');
        table.style.margin = '2rem 0';

        const closeBtn = divAtt('button', 'class', 'btn');
        closeBtn.innerHTML = 'Close';
        closeBtn.setAttribute('onclick', `hide('custardBox')`);

        const thead = divAtt('thead');
        const th0 = divAtt('th');
        const th1 = divAtt('th');
        const th2 = divAtt('th');
        th0.innerHTML = 'Date';
        th1.innerHTML = 'Comment by';
        th2.innerHTML = 'Comments';
        thead.appendChild(th0);
        thead.appendChild(th1);
        thead.appendChild(th2);

        const tBody = divAtt('tBody');
        for (let row of commentsList) {
          const tr = divAtt('tr', 'class', '');

          const date = divAtt('td');
          date.innerHTML = dateFromDateTime(row.dateon);

          const user = divAtt('td');
          user.innerHTML = row.comoName;

          const comment = divAtt('td');
          comment.innerHTML = row.comments;

          tr.appendChild(date);
          tr.appendChild(user);
          tr.appendChild(comment);
          tBody.appendChild(tr);
        }
        table.appendChild(thead);
        table.appendChild(tBody);
        if (commentsList.length) {
          div.appendChild(table);
        } else {
          const p = divAtt('p');
          p.innerHTML = 'No comments to show.';
          p.style = 'margin-bottom: 1rem;';
          div.appendChild(p);
        }

        div.appendChild(closeBtn);
        let RFCNumber = pgstr.SAt_contactForm.getApplicationDetail.RFCNumber ? pgstr.SAt_contactForm.getApplicationDetail.RFCNumber : '';
        let canName = pgstr.SAt_contactForm.getApplicationDetail.candidatename ? pgstr.SAt_contactForm.getApplicationDetail.candidatename : '';
        custardBox(div, `Application Comment History: ${RFCNumber} - ${canName}`);
      })
      .catch((error) => console.error('Error:', error)); //.catch(console.error());
  }
  static recordBookingDate() {
    const assessments = document.querySelectorAll('.assessments');
    const date = id('bookingDate').value;
    const list = [];

    assessments.forEach((assess) => {
      assess.checked && list.push(assess.value);
    });

    if (!list.length) {
      infoBox('Please select an assessment');
      return;
    }
    if (date === '') {
      infoBox('Please select a booking date.');
      return;
    }
    const vars = {};
    vars.HapplicationID = pgstr.SAt_contactForm.HapplicationID;
    vars.HassessmentIDList = list.toString();
    vars.bookingDate = new Date(date);

    PREP(['recordAssessmentBookingeOne'], vars)
      .then((res) => {
        note(res.data.recordAssessmentBookingeOne);
        changeTabN('SAt_contactForm');
      })
      .catch(console.error());
  }
  static async checkProvReuse(checkID) {
    const checkIDsplit = checkID.split('_');
    const assId = checkIDsplit[1];

    const OGcheck = id(checkID).checked ? true : false;
    if (id(`supp_${assId}`) && id(`reuse_${assId}`)) {
      id(`reuse_${assId}`).checked = false;
      id(`supp_${assId}`).checked = false;
    }

    id(checkID).checked = OGcheck;
  }
  static enableDisableRecordBtn(elID) {
    if (elID.includes('supp') || elID.includes('reuse')) {
      this.checkProvReuse(elID);
    }

    const checkboxes = document.querySelectorAll('#assignedAssBody input[type="checkbox"]');
    const checkboxGroups = {};
    let allGroupsChecked = true;

    // -------------
    checkboxes.forEach(function (checkbox) {
      const id = checkbox.id;
      const idEnding = id.substring(id.lastIndexOf('_') + 1); // Extract ID ending
      if (!checkboxGroups[idEnding]) {
        checkboxGroups[idEnding] = [];
      }
      checkboxGroups[idEnding].push(checkbox);
    });

    // -------------
    Object.values(checkboxGroups).forEach(function (group) {
      let groupChecked = false;
      group.forEach(function (checkbox) {
        if (checkbox.checked) {
          groupChecked = true;
          return;
        }
      });
      if (!groupChecked) {
        allGroupsChecked = false;
        return;
      }
    });

    //Enable record button
    id('CFs_bookingDate').disabled = allGroupsChecked ? false : true;
  }

  static checkExistsValid() {
    const date = id('bookingDate').value;
    if (date === '') {
      infoBox('Please select a booking date.');
      return;
    }

    let existing = false;
    let valid = false;
    let provNew = false;

    const assessments = document.querySelectorAll('.assessments');
    assessments.forEach((assess) => {
      // 1. existing result on record

      // 2.
      if (id(`valPeriod_${assess.id}`) && id(`valPeriod_${assess.id}`).innerHTML.includes('Within Validity')) {
        valid = true;
      }

      // 3.
      if (id(`supp_${assess.id}`) && id(`supp_${assess.id}`).checked === true) {
        provNew = true;
      } else if (!id(`supp_${assess.id}`)) {
        provNew = true;
      }
    });

    if (valid && provNew) {
      this.warningPopUp();
    } else {
      this.recordBookingDateNew();
    }
  }
  static recordBookingDateNew() {
    const date = id('bookingDate').value;
    if (date === '') {
      infoBox('Please select a booking date.');
      return;
    }

    const assessments = document.querySelectorAll('.assessments');
    const list = [];
    const payLoaod = {};

    assessments.forEach((assess) => {
      let provYN = 0;
      if (!id(`supp_${assess.id}`)) {
        provYN = 'tick';
      } else if (!id(`supp_${assess.id}`).classList.contains('cross')) {
        if (id(`supp_${assess.id}`).checked) {
          provYN = 1;
        }
      }

      let regenYN = 0;
      if (!id(`regen_${assess.id}`)) {
        regenYN = 'tick';
      } else if (id(`regen_${assess.id}`).checked) {
        regenYN = 1;
      }

      let conYN = 0;
      if (!id(`conver_${assess.id}`)) {
        conYN = 'tick';
      } else if (id(`conver_${assess.id}`).checked) {
        conYN = 1;
      }

      let reuseYN = 0;
      if (!id(`reuse_${assess.id}`)) {
        reuseYN = 1;
      } else if (!id(`reuse_${assess.id}`).classList.contains('cross')) {
        if (id(`reuse_${assess.id}`).checked) {
          reuseYN = 1;
        }
      }

      list.push(assess.id);
      payLoaod[assess.id] = {
        // HassessmentID: assess.id,
        provisionYN: provYN,
        regenYN: regenYN,
        conversionYN: conYN,
        reuseYN: reuseYN,
      };
    });

    const vars = {};
    vars.HapplicationID = pgstr.SAt_contactForm.HapplicationID;
    // vars.HassessmentIDList = list.toString();
    vars.assPayload = JSON.stringify(payLoaod);
    vars.bookingDate = new Date(date);

    PREP(['recordAssessmentBookingeOne'], vars)
      .then((res) => {
        note(res.data.recordAssessmentBookingeOne);
        changeTabN('SAt_contactForm');
      })
      .catch(console.error());
  }

  static warningPopUp() {
    const msg = 'You are about to provision a new assessment for an existing and valid result. Click "Proceed" to contine with the provisioning.';

    warningBox(msg, 'SAt_contactForm.recordBookingDateNew()', 1);
    eListen(
      'infoBoxBtn',
      () => {
        this.recordBookingDateNew();
      },
      'click'
    );

    eListen(
      'warningCancelBtn',
      () => {
        this.cancelRecordBooking();
      },
      'click'
    );
  }
  static cancelRecordBooking() {
    const assessments = document.querySelectorAll('.assessments');
    assessments.forEach((assess) => {
      if (id(`supp_${assess.id}`) && id(`supp_${assess.id}`).matches('input[type="checkbox"]')) {
        id(`supp_${assess.id}`).checked = false;
      }
    });

    // this.recordBookingDateNew();
  }
}

export class CFs_email {
  constructor() {
    this.name = 'Edit Application - Contact Form - Email';
    this.pageTier = 25;
    this.reference = 'CFs_email';
    this.pageID = null;
    this.data = null;
    this.HclientID = pgstr.SAt_contactForm.HclientID;
    this.HapplicationID = pgstr.SAt_contactForm.HapplicationID;
    this.grouping = pgstr.SAt_contactForm.grouping;
  }

  initPage() {
    // Set page pecific variables
    this.getApplicationDetail = pgstr.SAt_contactForm.getApplicationDetail;
    this.loadPage();
  }

  loadPage() {
    this.emailPage();
  }

  emailPage() {
    const getApplicationDetail = this.getApplicationDetail;

    id('emailRecipient').innerHTML = `${getApplicationDetail.candidateFname}${getApplicationDetail.candidatesname} (${getApplicationDetail.candidateEmail})`;
  }

  static sendEmail() {
    const vars = {};
    vars.HapplicationID = pgstr.SAt_contactForm.HapplicationID;
    vars.emailSubject = id('emailSubject').value;
    vars.messageBody = lineBreaks(id('emailBody').value);
    vars.messageType = 'email';

    PREP(['messageApplicant'], vars)
      .then((res) => {
        note(res.data.messageApplicant);
        changeTabN('SAt_contactForm');
      })
      .catch(console.error());
  }
}

export class CFs_SMS {
  constructor() {
    this.name = 'Edit Application - Contact Form - SMS';
    this.pageTier = 25;
    this.reference = 'CFs_SMS';
    this.pageID = null;
    this.data = null;
    this.HclientID = pgstr.SAt_contactForm.HclientID;
    this.HapplicationID = pgstr.SAt_contactForm.HapplicationID;
    this.grouping = pgstr.SAt_contactForm.grouping;
  }

  initPage() {
    // Set page pecific variables
    this.getApplicationDetail = pgstr.SAt_contactForm.getApplicationDetail;
    this.loadPage();
  }

  loadPage() {
    this.SMSPage();
  }

  SMSPage() {
    const getApplicationDetail = this.getApplicationDetail;

    id('smsRecipient').innerHTML = getApplicationDetail.candidateFname + ' ' + getApplicationDetail.candidatesname + ' ( ' + getApplicationDetail.candidateMobilenumber + ' )';
  }

  static sendSMS() {
    const vars = {};
    vars.HapplicationID = pgstr.SAt_contactForm.HapplicationID;
    vars.messageBody = id('smsBody').value;
    vars.messageType = 'sms';
    PREP(['messageApplicant'], vars)
      .then((res) => {
        changeTabN('SAt_contactForm');
        note(res.data.messageApplicant);
      })
      .catch(console.error());
  }
}

export class SAt_addAssessments {
  constructor(vars) {
    this.name = 'Edit Application - Contact Form';
    this.pageTier = 20;
    this.reference = 'SAt_addAssessments';
    this.pageID = null;
    this.data = null;
    this.HclientID = null;
    this.candidateID = vars.candidateID;
  }

  initPage(data) {
    // Set page pecific variables
    this.getAllocatedExternalAssessmentsToUser = data.getAllocatedExternalAssessmentsToUser;
    this.getAllocatedProjectsToUser = data.getAllocatedProjectsToUser;
    this.getExternalAssessmentsForAlloc = data.getExternalAssessmentsForAlloc;
    this.getJVROProjectsForAlloc = data.getJVROProjectsForAlloc;
    this.getExternalAssessmentsForAlloc = data.getExternalAssessmentsForAlloc;
    this.loadPage();
  }

  loadPage() {
    this.addAssessmentsPage();
  }

  addAssessmentsPage() {
    editAplication.listProjects(this.getAllocatedProjectsToUser);
    editAplication.listAssessments(this.getAllocatedExternalAssessmentsToUser);
    buildDropDownMain(this.getJVROProjectsForAlloc, 'jvroProject', 'JVROprojectID', 'projectName');
    buildDropDownMain(this.getExternalAssessmentsForAlloc, 'exAssessment', 'HassessmentID', 'assessmentName');
  }
}

export class SAt_history {
  constructor(vars) {
    this.name = 'Edit Application - History';
    this.pageTier = 20;
    this.reference = 'SAt_history';
    this.pageID = null;
    this.data = null;
    this.HclientID = null;
    this.HapplicationID = vars.HapplicationID;
  }

  initPage(data) {
    // Set page pecific variables
    this.getApplicationHistory = data.getApplicationHistory;
    this.getApplicationHistory2 = data.getApplicationHistory2;
    this.loadPage();
  }

  loadPage() {
    this.historyPageEA2();
  }

  async historyPageEA() {
    const data = this.getApplicationHistory;
    const history = id('hidtoryList');
    history.innerHTML = '';

    if (data.length) {
      hide('noHistory');
      const thead = await viewApplication.buildHistoryHead();
      history.appendChild(thead);
      let cntr = 1;

      for (const el of data) {
        const tr = divAtt('tr');
        const td1 = divAtt('td', 'class', 'historydate');
        td1.innerHTML = dateFromDateTime(el.changeDateTime);
        const td2 = divAtt('td', 'class', 'reportUpdater');
        td2.innerHTML = el.updater;
        const td3 = divAtt('td', 'class', 'reporttype');
        td3.innerHTML = el.changeType;
        const td4 = divAtt('td', 'class', 'reporttype');
        const btn = divAtt('button', 'class', 'btn');
        btn.innerHTML = 'Show more';
        // btn.setAttribute("onclick", `viewApplication.toggleHistory('${cntr}')`);
        btn.setAttribute('id', `historyView_${cntr}`);
        td4.appendChild(btn);
        tr.appendChild(td1);
        tr.appendChild(td2);
        tr.appendChild(td3);
        tr.appendChild(td4);

        const tr2 = divAtt('tr', 'id', `historyShow1_${cntr}`);
        tr2.setAttribute('class', 'hide');
        tr2.style = 'background-color: var(--lightGrey);';
        const tr3 = divAtt('tr', 'id', `historyShow2_${cntr}`);
        tr3.setAttribute('class', 'hide');
        tr3.style = 'background-color: var(--lightGrey);';

        for (let el2 of el.detailArray) {
          const td01 = divAtt('td', 'class', 'description');
          td01.innerHTML = el2.detailLineDescription;
          td01.setAttribute('colspan', '4');
          const td02 = divAtt('td', 'class', 'value');
          td02.innerHTML = el2.detailLineValue;
          td02.setAttribute('colspan', '4');
          tr2.appendChild(td01);
          tr3.appendChild(td02);
        }

        history.appendChild(tr);
        history.appendChild(tr2);
        history.appendChild(tr3);
        eListen(
          btn,
          () => {
            viewApplication.toggleHistory(cntr);
          },
          'click'
        );
        cntr++;
      }
    } else {
      unhide('noHistory');
    }
  }

  async historyPageEA2() {
    const data = this.getApplicationHistory2;
    const history = id('hidtoryList');
    history.innerHTML = '';

    if (data.length) {
      hide('noHistory');
      viewApplication.buildHistoryTable(data);
    } else {
      unhide('noHistory');
    }
  }
}

export class SAt_addServices {
  constructor(vars) {
    this.name = 'Edit Application - Additional Services';
    this.pageTier = 20;
    this.reference = 'SAt_addServices';
    this.pageID = null;
    this.data = null;
    this.HclientID = pgstr.editApplication.HclientID;
    this.HapplicationID = vars.happlicationID;
    this.applicationID = vars.applicationID;
  }

  initPage(data) {
    // console.log("HERE QWERTY",data);
    // Set page pecific variables
    this.getAdditionalServices = data.getAdditionalServices;
    this.getAdditionalServicesAllocated = cObj(data.getAdditionalServicesAllocated);
    this.getFeedbackRequestor = data.getFeedbackRequestor;

    this.loadPage();
  }

  loadPage() {
    this.addServicesPage();
  }

  addServicesPage() {
    additionalService.buildAssSerCheckboxes1(this.getAdditionalServices, this.getFeedbackRequestor, this.HclientID);
    if (this.getAdditionalServicesAllocated.length) {
      additionalService.allocatedServices(this.getAdditionalServicesAllocated, 1, 1);
    } else {
      additionalService.allocatedServices(this.getAdditionalServicesAllocated, '', 1);
    }
  }
  //old own call requestAdditionalServices
  // Steph 09/04/24
  // static requestAdditionalServices() {
  //   const checkboxes = document.querySelectorAll('.addSerInp');
  //   const checkArr = [];

  //   checkboxes.forEach((box) => {
  //     if (box.checked) {
  //       checkArr.push(box.id);
  //     }
  //   });
  //   if (!checkArr.length) {
  //     infoBox('Please select a service.');
  //     return;
  //   }

  //   const vars = {};
  //   vars.applicationID = pgstr.SAt_addServices.HapplicationID;
  //   vars.additionalservices = checkArr;

  //   const canFBbox = document.getElementsByName('Candidate feedback');
  //   const canBox = canFBbox[0];

  //   const manFBbox = document.getElementsByName('Management feedback');
  //   const manbox = manFBbox[0];

  //   if (manbox) {
  //     // Managememt || candidate Feedback Ticked
  //     if (manbox.checked === true) {
  //       if (id('requester').value === '-' || !id('requester').value) {
  //         return infoBox('Please select a Requester.');
  //       }
  //       vars.requestor = id('requester').value;
  //       if (id('requester').value === 'New') {
  //         if (!id('fName').value || !id('sName').value || !id('email').value) {
  //           return infoBox('Please fill in new requester details.');
  //         }
  //         if (!valE(id('email').value)) {
  //           return infoBox('Please fill in a valid email address.');
  //         }
  //         const obj = {};

  //         (obj.fName = id('fName').value), (obj.sName = id('sName').value), (obj.email = id('email').value), (vars.payload = JSON.stringify(obj));
  //       }

  //       if (id('fbDuration').value === '-') {
  //         return infoBox('Please select a duration of feedback.');
  //       }
  //       vars.feedbackDuration = id('fbDuration').value;
  //     }
  //   } else if (canBox) {
  //     if (canBox.checked === true) {
  //       if (id('fbDuration').value === '-') {
  //         return infoBox('Please select a duration of feedback.');
  //       }
  //       vars.feedbackDuration = id('fbDuration').value;
  //       vars.requestor = '';
  //     }
  //   } else {
  //     vars.feedbackDuration = '';
  //     vars.requestor = '';
  //   }

  //   PREP(['requestAdditionalServices'], vars)
  //     .then((res) => {
  //       note(res.data.requestAdditionalServices);
  //       PREP('SAt_addServices');
  //     })
  //     .catch(console.error());
  // }

  //new uploadnewrecord
  static async requestAddServices2() {
    const vars = await SAt_addServices.addSerVars(pgstr.SAt_addServices.HapplicationID);

    if (vars) {
      PREP(['uploadnewrecords'], vars)
        .then((res) => {
          note(res.data.uploadnewrecords);
          changeTabN('SAt_addServices');
        })
        .catch(console.error());
    }
  }

  static async addSerVars(HapplicationID) {
    const vars = {};
    const obj = {};
    obj.applicationID = HapplicationID;

    const checkboxes = document.querySelectorAll('.addSerInp');

    const checkArr = [];
    checkboxes.forEach((box) => {
      if (box.checked) {
        checkArr.push(box.id);
      }
    });

    if (checkArr.length) {
      const addSerArr = [];

      const canFBbox = document.getElementsByName('Candidate feedback');
      const canBox = canFBbox[0];

      const manFBbox = document.getElementsByName('Management feedback');
      const manbox = manFBbox[0];

      const cdFBbox = document.getElementsByName('Candidate Development Report');
      const cdbox = cdFBbox[0];

      const mancompFBbox = document.getElementsByName('Manager Comparative Group feedback');
      const mancompbox = mancompFBbox[0];

      let pass = true;
      const canObj = {};
      if (canBox) {
        if (canBox.checked === true) {
          canObj.addSerID = canBox.id;

          // Duration
          if (id('canduration').value === '-') {
            pass = false;
            id('canduration').value === '-' && id('canduration').classList.add('incorrect');
          } else {
            canObj.duration = id('canduration').value;
          }

          // TimeZone
          if (id('canTimeZone')) {
            if (id('canTimeZone').value === '-' || !id('canTimeZone').value) {
              pass = false;
              id('canTimeZone').value === '-' && id(`canTimeZone`).classList.add('incorrect');
            } else {
              canObj.timeZone = id('canTimeZone').value;
            }
          }

          // Language
          if (id('canLang')) {
            if (id('canLang').value === '-' || !id('canLang').value) {
              pass = false;
              id('canLang').value === '-' && id(`canLang`).classList.add('incorrect');
            } else {
              canObj.lang = id('canLang').value;
            }
          }

          addSerArr.push(canObj);
        }
      }

      const manObj = {};
      if (manbox) {
        if (manbox.checked === true) {
          manObj.addSerID = manbox.id;

          // Duration
          if (id('manduration').value === '-') {
            pass = false;
            id('manduration').value === '-' && id(`manduration`).classList.add('incorrect');
          } else {
            manObj.duration = id('manduration').value;
          }

          // Reqestor
          if (!id('manrequester').value) {
            pass = false;
            !id('manrequester').value && id('manrequester').classList.add('incorrect');
          } else if (id('manrequester').value === 'New') {
            if (!id(`manfName`).value || !id(`mansName`).value || !valE(id(`manemail`).value)) {
              pass = false;
              !id(`manfName`).value && id(`manfName`).classList.add('incorrect');
              !id(`mansName`).value && id(`mansName`).classList.add('incorrect');
              !valE(id(`manemail`).value) && id(`manemail`).classList.add('incorrect');
            } else {
              manObj[`requestor`] = {
                value: 'NEW',
                fName: id(`manfName`).value,
                sName: id(`mansName`).value,
                email: id(`manemail`).value,
              };
            }
          } else {
            if (id('manrequester').value) {
              manObj.requestor = id('manrequester').value;
            }
          }

          // TimeZone
          if (id('manTimeZone')) {
            if (id('manTimeZone').value === '-' || !id('manTimeZone').value) {
              pass = false;
              id('manTimeZone').value === '-' && id(`manTimeZone`).classList.add('incorrect');
            } else {
              manObj.timeZone = id('manTimeZone').value;
            }
          }

          // Language
          if (id('manLang')) {
            if (id('manLang').value === '-' || !id('manLang').value) {
              pass = false;
              id('manLang').value === '-' && id(`manLang`).classList.add('incorrect');
            } else {
              manObj.lang = id('manLang').value;
            }
          }

          addSerArr.push(manObj);
        }
      }

      const cdObj = {};
      if (cdbox) {
        if (cdbox.checked === true) {
          cdObj.addSerID = cdbox.id;
          addSerArr.push(cdObj);
        }
      }

      //
      const mancompObj = {};
      if (mancompbox) {
        if (mancompbox.checked === true) {
          mancompObj.addSerID = mancompbox.id;

          // Duration
          if (id('mancompduration').innerHTML === '') {
            pass = false;
          } else {
            const timeNum = id('mancompduration').innerHTML.split(' ');
            mancompObj.duration = timeNum[0];
          }

          // Reqestor
          if (!id('mancomprequester').value) {
            pass = false;
            !id('mancomprequester').value && id('mancomprequester').classList.add('incorrect');
          } else if (id('mancomprequester').value === 'New') {
            if (!id(`mancompfName`).value || !id(`mancompsName`).value || !valE(id(`manemail`).value)) {
              pass = false;
              !id(`mancompfName`).value && id(`mancompfName`).classList.add('incorrect');
              !id(`mancompsName`).value && id(`mancompsName`).classList.add('incorrect');
              !valE(id(`mancompemail`).value) && id(`manemail`).classList.add('incorrect');
            } else {
              mancompObj[`requestor`] = {
                value: 'NEW',
                fName: id(`mancompfName`).value,
                sName: id(`mancompsName`).value,
                email: id(`mancompemail`).value,
              };
            }
          } else {
            if (id('mancomprequester').value) {
              mancompObj.requestor = id('mancomprequester').value;
            }
          }

          // TimeZone
          if (id('mancompTimeZone')) {
            if (id('mancompTimeZone').value === '-') {
              pass = false;
              id(`mancompTimeZone`).classList.add('incorrect');
            } else {
              mancompObj.timeZone = id('mancompTimeZone').value;
            }
          }

          // Language
          if (id('mancompLang')) {
            if (id('mancompLang').value === '-') {
              pass = false;
              id(`mancompLang`).classList.add('incorrect');
            } else {
              mancompObj.lang = id('mancompLang').value;
            }
          }

          //Candidate collection here
          const table = id('canTableBody');
          if (table.children.length < 2 || table.children.length > 4) {
            pass = false;
            return infoBox('Between 2 and 4 Candidates need to be added.');
          } else {
            mancompObj.applicationIDs = Array.from(table.children)
              .map((child) => child.id)
              .join(',');
          }
          addSerArr.push(mancompObj);
        }
      }

      if (!pass) {
        infoBox('Please fill in all required information for Additional Services');
        return;
      }

      obj.additionalservices = JSON.stringify(addSerArr); //checkArr;
    } else {
      return infoBox('No Additional Services Selected');
      obj.additionalservices = checkArr;
    }

    vars.payload = JSON.stringify(obj);
    vars.entityType = 'requestAdditionalServices';
    vars.entityUUID = uuidvMain();

    // return console.log('these are the addSer Vars', vars);
    return vars;
  }
}

export class SAt_manStatus {
  constructor(vars) {
    this.name = 'Edit Application - Status';
    this.pageTier = 20;
    this.reference = 'SAt_manStatus';
    this.pageID = null;
    this.data = null;
    this.HclientID = null;
    this.HapplicationID = vars.HapplicationID;
  }

  initPage(data) {
    // Set page pecific variables
    this.getApplicatonStatusForAdminUpdate = cObj(data.getApplicatonStatusForAdminUpdate);
    this.appDetail = data.getApplicationDetail[0];
    this.loadPage();
  }

  loadPage() {
    this.manStatusPage();
  }

  manStatusPage() {
    buildDropDownMain(this.getApplicatonStatusForAdminUpdate, 'f_changeStatus', 'DDAPPLICATIONSTATUSID', 'SHORTDESCRIPTION');

    SAt_manStatus.appResult();
  }

  static changeApplicationStatus() {
    if (!validatePage()) {
      return;
    }

    const vars = {};
    vars.newStatus = parseInt(id('f_changeStatus').value);
    vars.updateComments = id('changeComments').value;
    vars.HapplicationID = pgstr.SAt_manStatus.HapplicationID;

    PREP(['updateApplicationStatusAdmin'], vars)
      .then((res) => {
        note(res.data.updateApplicationStatusAdmin);
        changeTabN('SAt_manStatus');
      })
      .catch(console.error());
  }

  static appResult() {
    const data = pgstr.SAt_manStatus.appDetail;

    if (data.ApplicationResultRequiredYN == 0 || '') {
      hide('appResultsSection');
    } else {
      unhide('appResultsSection');

      if (data.applicationResultDate) {
        const tr = id('appResultTable');
        const date = divAtt('td');
        date.innerHTML = data.applicationResultDate;
        const by = divAtt('td');
        by.innerHTML = data.applicationresultBy;
        const result = divAtt('td');
        result.innerHTML = data.applicationresult;

        tr.appendChild(date);
        tr.appendChild(by);
        tr.appendChild(result);

        hide('appResultTggl');
        unhide('appResultView');
      } else {
        unhide('appResultTggl');
        hide('appResultView');
      }
    }
  }

  static recordAppResult() {
    const vars = {};
    var radios = document.getElementsByName('appResult');
    for (var i = 0, length = radios.length; i < length; i++) {
      if (radios[i].checked) {
        vars.applicationresult = radios[i].value;
        break;
      }
    }

    // vars.applicationresult = 'Successful';
    vars.HapplicationID = pgstr.SAt_manStatus.HapplicationID;
    PREP(['recordApplicationResult'], vars)
      .then((res) => {
        note(res.data.recordApplicationResult);

        PREP(['getApplicationDetail'], vars).then((res) => {
          pgstr.SAt_manStatus.appDetail = res.data.getApplicationDetail[0];
          SAt_manStatus.appResult();
        });
      })
      .catch(console.error());
  }
}

// ========================== MANAGE USERS ==================

export class ManageUsers {
  static addToUserGroup() {
    const allUsers = document.querySelectorAll('.userList');

    const usersSelected = [];
    allUsers.forEach((user) => {
      if (user.checked) {
        const inpID = user.id.split('_');
        usersSelected.push(parseInt(inpID[1]));
      }
    });

    if (!usersSelected.length) {
      infoBox('Please select Users to add to Group.');
    } else if (id('groupDD').value == '-') {
      infoBox('Please select a User Group.');
    } else if (id('NewGroupName').value == '' && id('groupDD').value == 'new') {
      infoBox('Please fill in the Group Name for the new Group.');
    } else {
      const vars = {};
      vars.HclientID = id('clientDD').value;
      let usl = JSON.stringify(usersSelected);
      usl = usl.replace('[', '');
      usl = usl.replace(']', '');
      vars.usersToAdd = usl;
      vars.HuserGroupID = id('groupDD').value;
      vars.newHuserGroupName = id('NewGroupName').value;
      vars.newHuserGroupDescription = id('NewGroupdescription').value;
      vars.newHuserGroupPrivateYN = id('NewGroupPrivate').checked;

      PREP(['addToUserGroup'], vars)
        .then((res) => {
          const data = res.data.addToUserGroup;
          infoBox(data[0].addResults);

          // Turn on ManageGroups tab added
          // switchBox('manageGroups', 'groupID=' + data[0].HuserGroupID + '&groupName=' + data[0].HuserGroupName);
        })
        .catch(console.error());
    }
  }
}

export class MUtUsers {
  constructor() {
    this.name = 'Manage Users';
    this.pageTier = 20;
    this.reference = 'MUt_users';
    this.pageID = null;
    this.data = null;
    this.HclientID = null;
  }

  initPage() {
    // Set page pecific variables
    this.loadPage();
  }

  loadPage() {
    this.buildUserHead();
  }

  buildUserHead() {
    const page = id('userListTable');
    page.innerHTML = '';
    const table = divAtt('table', 'id', 'UserListTable_t');
    table.classList.add('width100');
    table.style = 'margin: unset;';
    const tBody = divAtt('tBody', 'id', 'userListBody');
    const inp = divAtt('input', 'type', 'checkbox');
    inp.setAttribute('class', 'selectAllUsers');
    inp.setAttribute('id', 'all_userList');
    const searchRow = divAtt('tr', 'id', 'trSearch');
    searchRow.setAttribute('class', 'hide');
    const ts0 = divAtt('td');
    const ts1 = divAtt('td');
    const ts1Input = divAtt('div', 'class', '');
    ts1Input.innerHTML =
      '<svg  id="locked" class="iconOff" width="24px" height="26" viewBox="0 0 11.88 14.91" style="cursor: pointer;" ><path d="M12.7,5.85a1.71,1.71,0,0,0-1-.33h-1V5.35c0-.71,0-1.42,0-2.14a3.42,3.42,0,0,0-.07-.71,3.15,3.15,0,0,0-6.22.73c0,.71,0,1.42,0,2.13v.17c-.39,0-.75,0-1.12,0a1.69,1.69,0,0,0-1.41.82,1.71,1.71,0,0,0-.27.93v5.91a1.73,1.73,0,0,0,.76,1.45,2,2,0,0,0,.79.31h8.78l.1,0a1.74,1.74,0,0,0,1.42-1.45,1.84,1.84,0,0,0,0-.33V7.33A1.74,1.74,0,0,0,12.7,5.85ZM5.52,5.38V3.17A2,2,0,0,1,7.31,1.22a2,2,0,0,1,2.12,1.5,1.74,1.74,0,0,1,.05.39V5.44a.28.28,0,0,1,0,.08h-4Zm6.75,7.72a.6.6,0,0,1-.68.69H3.41a.6.6,0,0,1-.68-.69V7.37a.59.59,0,0,1,.67-.68h8.18a.6.6,0,0,1,.69.69Z" transform="translate(-1.56 -0.05)"/><path d="M6.8,8.64a1,1,0,0,0-.11,1.5.77.77,0,0,1,.23.65,2.25,2.25,0,0,0,0,.26h0c0,.2,0,.4,0,.6a.59.59,0,0,0,.4.54.58.58,0,0,0,.76-.56c0-.38,0-.77,0-1.15a.22.22,0,0,1,.09-.19A1.07,1.07,0,1,0,6.8,8.64Z" transform="translate(-1.56 -0.05)"/></svg>';
    const ts2 = divAtt('td');
    const ts2Input = divAtt('input', 'type', 'text');
    ts2Input.setAttribute('class', 'searchInputTable');
    ts2Input.setAttribute('placeholder', 'Search by name');
    ts2Input.setAttribute('id', 'nameSearch');
    const ts3 = divAtt('td');
    const ts3Input = divAtt('input', 'type', 'text');
    ts3Input.setAttribute('placeholder', 'Search by email');
    ts3Input.setAttribute('class', 'searchInputTable');
    ts3Input.setAttribute('id', 'emailSearch');
    const ts4 = divAtt('td');
    const ts4Input = divAtt('input', 'type', 'text');
    ts4Input.setAttribute('class', 'searchInputTable');
    ts4Input.setAttribute('placeholder', 'Search by number');
    ts4Input.setAttribute('id', 'numSearch');
    const ts5 = divAtt('td');
    const ts5Input = divAtt('input', 'type', 'text');
    ts5Input.setAttribute('class', 'searchInputTable');
    ts5Input.setAttribute('placeholder', 'Search by role');
    ts5Input.setAttribute('id', 'roleSearch');
    const ts6 = divAtt('td');
    ts6.innerHTML = `<button  class="clearBtn" id="clearSearchBtn"><svg  width="13.58"
      height="13.58" viewBox="0 0 13.58 13.58">
      <defs>
        <style>
          .clearA {
            fill: #231f20;
          }
        </style>
      </defs>
      <polygon class="clearA"
        points="12.53 13.53 13.58 12.47 7.84 6.78 13.53 1.05 12.47 0 6.79 5.74 1.05 0.06 0 1.1 5.74 6.79 0.05 12.53 1.1 13.58 6.8 7.84 12.53 13.53">
      </polygon>
    </svg> Clear Search</button>`;

    const thead = divAtt('thead');
    const th0 = divAtt('th');
    const th1 = divAtt('th');
    const th2 = divAtt('th');
    const th3 = divAtt('th');
    const th4 = divAtt('th');
    const th5 = divAtt('th');
    const th6 = divAtt('th');
    th2.innerHTML = 'Name';
    th3.innerHTML = 'Email Address';
    th4.innerHTML = 'Mobile Number';
    th5.innerHTML = 'Role';
    th6.innerHTML = 'Action';
    // th0.appendChild(inp)
    thead.appendChild(th0);
    thead.appendChild(th1);
    thead.appendChild(th2);
    thead.appendChild(th3);
    thead.appendChild(th4);
    thead.appendChild(th5);
    thead.appendChild(th6);
    searchRow.appendChild(ts0);
    searchRow.appendChild(ts1);
    searchRow.appendChild(ts2);
    searchRow.appendChild(ts3);
    searchRow.appendChild(ts4);
    searchRow.appendChild(ts5);
    searchRow.appendChild(ts6);
    ts1.appendChild(ts1Input);
    ts2.appendChild(ts2Input);
    ts3.appendChild(ts3Input);
    ts4.appendChild(ts4Input);
    ts5.appendChild(ts5Input);
    table.appendChild(thead);
    table.appendChild(searchRow);
    table.appendChild(tBody);
    page.appendChild(table);
    eListen(
      'locked',
      () => {
        MUtUsers.searchFiltersLocked();
      },
      'click'
    );
    eListen(
      'clearSearchBtn',
      () => {
        MUtUsers.clearSearch();
      },
      'click'
    );
    id('clientDD').value && MUtUsers.getUsers();

    //@steph -> not in use?
    // inp.addEventListener("change", () => {
    //   const checked = id("all_userList").checked;
    //   const rows = table.getElementsByTagName("tr");
    //   for (let tablerow of rows) {
    //     const SelectBox = tablerow.getElementsByClassName("userList");
    //     if (tablerow.style.display !== "none") {
    //       id(SelectBox[0].id).checked = checked;
    //     }
    //   }
    // });

    const genSearch = id('genSearch');
    const searchInp = [genSearch, ts1Input, ts2Input, ts3Input, ts4Input, ts5Input];
    searchInp.forEach((sInp) => {
      let timeout;
      sInp.addEventListener('keyup', () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          MUtUsers.getUsers(1, 50);
        }, 250);
      });
    });
  }

  static async clearSearch() {
    const searchInps = document.querySelectorAll('.searchInputTable');
    searchInps.forEach((inp) => {
      inp.value = '';
    });

    if (id('locked')) {
      id('locked').classList.remove('iconOn');
    }

    MUtUsers.getUsers(1, 50);
  }

  static searchFilters() {
    const searchFilters = id('searchFilters');
    const trSearch = id('trSearch');

    if (trSearch.classList.contains('hide')) {
      searchFilters.classList.add('searchFiltersActive');
      hide('searchBar');
      id('genSearch').value = '';
      unhide('trSearch');
    } else {
      searchFilters.classList.remove('searchFiltersActive');
      hide('trSearch');
      unhide('searchBar');
      id('nameSearch').value = '';
      id('emailSearch').value = '';
      id('numSearch').value = '';
      id('roleSearch').value = '';
      id('genSearch').value = '';
    }
    MUtUsers.getUsers(1, 50);
  }

  static searchFiltersLocked() {
    const locked = id('locked');

    if (locked.classList.contains('iconOn')) {
      locked.classList.remove('iconOn');
    } else {
      locked.classList.add('iconOn');
    }
    MUtUsers.getUsers(1, 50);
  }

  static getUsers(displaypage, displayListCount) {
    const obj = {};
    obj.lockedOutYN = id('locked').classList.contains('iconOn') ? true : false;
    obj.nameSearch = id('nameSearch').value;
    obj.emailSearch = id('emailSearch').value;
    obj.numSearch = id('numSearch').value;
    obj.roleSearch = id('roleSearch').value;
    obj.genSearch = id('genSearch').value;
    const vars = {};
    vars.HclientID = id('clientDD').value;
    vars.displaypage = displaypage || 1;
    vars.displayListCount = displayListCount || 50;
    vars.searchObj = JSON.stringify(obj) || JSON.stringify({});
    hide('pagDiv');
    if (id('clientDD').value) {
      PREP(['getUsers'], vars)
        .then((res) => {
          // toggleSelectsection(['clientSelect', 'selectGroup']);
          // if (id('groupDD').value !== '-' && id('groupDD').value !== '') {
          //     unhide('addToUserGroup');
          // }
          console.log('yessyes');
          MUtUsers.buildUsersList(res.data.getUsers[0].ReturnList);
          let callback = (p1, p2) => {
            MUtUsers.getUsers(p1, p2);
          };
          pagination(res.data.getUsers[0].pagination[0], callback);
        })
        .catch(console.error());
    } else {
      hide('userListTable');
      infoBox('Please select a client.');
    }
  }

  static async buildUsersList(data) {
    id('userListBody').innerHTML = '';
    for (let row of data) {
      const show = !id('activeNo').checked;
      if (toggleSliderYN(row.activeYN) === show) {
        const tr = divAtt('tr', 'class', '');

        const tdSelect = divAtt('td', 'class', 'Name');
        const label = await buildTickBox(`userList_${row.HuserID}`, 0);
        tdSelect.appendChild(label);
        tr.appendChild(tdSelect);

        const tdIcon = divAtt('td', 'class', '');
        if (row.lockedOutYN) {
          tdIcon.innerHTML = `<img src="${lockedOutIcon}"><span hidden>locked out</span>`;
        } else {
          tdIcon.innerHTML = '';
        }
        tr.appendChild(tdIcon);

        const tdName = divAtt('td', 'class', 'Name');
        tdName.innerHTML = row['First name'] + ' ' + row.Surname;
        tr.appendChild(tdName);

        const tdEmail = divAtt('td', 'class', 'emailAddress');
        tdEmail.innerHTML = row['Email address'];
        tr.appendChild(tdEmail);

        const tdMobile = divAtt('td', 'class', 'mobileNr');
        tdMobile.innerHTML = row['Mobile number'];
        tr.appendChild(tdMobile);

        const tdrole = divAtt('td', 'class', 'role');
        tdrole.innerHTML = row.Role;
        tr.appendChild(tdrole);

        const tdlink = divAtt('td', 'class', '');
        const btn = divAtt('a', 'href', '#');
        const btn2 = divAtt('a', 'href', '#');
        const clientID = id('clientDD').value;
        const params = 'HclientID=' + clientID + '&editUserID=' + row.HuserID;
        btn.setAttribute('onclick', 'PREP("assignAssessment", "' + params + '")');
        btn.setAttribute('class', 'btn');
        btn.style = 'margin-right: 0.5rem;';
        btn.innerHTML = 'Link';
        btn2.setAttribute('onclick', 'PREP("editUser", "' + params + '")');
        btn2.classList.add('class', 'btn');
        btn2.innerHTML = 'Edit';
        tdlink.appendChild(btn);
        tdlink.appendChild(btn2);
        tr.appendChild(tdlink);
        id('userListBody').appendChild(tr);
        id(`userList_${row.HuserID}`).classList.add('userList');
        unhide('userListTable');
      }
    }
    unhide('searchSpace');
    unhide('compareDiv');
  }

  static compareUsers() {
    const slctdUsers = document.querySelectorAll('.userList');
    const selected = [];
    slctdUsers.forEach((users) => {
      users.checked && selected.push(parseInt(users.id.split('_')[1]));
    });
    if (selected.length < 4 && selected.length > 1) {
      const csv = selected.join(',');
      const vars = {};
      vars.compareList = JSON.stringify(csv).slice(1, -1);
      changeTabN('MUt_compareUsers', vars);
    } else {
      infoBox('Please select only 2 or 3 users to compare.');
    }
  }
}

export class MUt_AdvSearch {
  constructor(vars) {
    this.name = 'Manage Users - Advanced Search';
    this.pageTier = 20;
    this.reference = 'MUt_advSearch';
    this.pageID = null;
    this.data = null;
    this.HclientID = null;
  }

  initPage() {
    // Set page pecific variables
    this.loadPage();
  }

  loadPage() {
    this.advSearchPage();
  }

  advSearchPage() {
    if (id('clientDD').value) {
      const vars = {};
      vars.HclientID = id('clientDD').value;
      PREP(['getAssessmentsPerClient'], vars)
        .then((res) => {
          toggleSelectsection(['clientSelect', 'selectGroup']);
          buildDropDownMain(cObj(res.data.getAssessmentsPerClient), 'assessmentsDD', 'HASSESSMENTID', 'SHORTNAME');
          hide('status');
          hide('userListTable');
          hide('raterRatee');
          unhide('advanceSearchContent');
          if (id('groupDD').value !== '-' && id('groupDD').value !== '') {
            unhide('addToUserGroup');
          }
          eListen('assessmentsDD', () => {
            if (id('assessmentsDD').value !== '-') {
              vars.HassessmentList = id('assessmentsDD').value;
              hide('status');
              hide('userListTable');
              MUt_AdvSearch.getRaterRatee(vars);
            } else {
              hide('status');
              hide('userListTable');
              hide('raterRatee');
            }
          });
        })
        .catch(console.error());
    } else {
      toggleSelectsection(['clientSelect']);
      hide('advanceSearchContent');
      hide('status');
      hide('userListTable');
      hide('raterRatee');
      infoBox('Please select a client.');
    }
  }

  static getRaterRatee(vars) {
    unhide('raterRatee');
    eListen('raterRateeDD', () => {
      if (id('raterRateeDD').value !== '-') {
        hide('userListTable');
        MUt_AdvSearch.getAssessmentstatus(vars);
      } else {
        hide('status');
        hide('userListTable');
      }
    });
  }

  static getAssessmentstatus(vars) {
    PREP(['getStatsuLIstPerAssessmentList'], vars)
      .then((res) => {
        buildDropDownMain(cObj(res.data.getStatsuLIstPerAssessmentList), 'statusDD', 'STATUSID', 'DESCRIPTION');
        unhide('status');
        eListen('statusDD', () => {
          if (id('statusDD').value !== '-') {
            vars.assessmentStatusList = id('statusDD').value;
            vars.raterRatee = id('raterRateeDD').value;
            MUt_AdvSearch.getUsersByAssessmentStatus(vars);
          } else {
            hide('userListTable');
          }
        });
      })
      .catch(console.error());
  }

  static getUsersByAssessmentStatus(vars) {
    PREP(['getUsersByAssessmentStatus'], vars)
      .then((res) => {
        MUt_AdvSearch.buildSearchList(cObj(res.data.getUsersByAssessmentStatus));
      })
      .catch(console.error());
  }

  static buildSearchList(data) {
    id('userListTable').innerHTML = '';
    if (data.length) {
      const page = id('userListTable');
      const table = divAtt('table', 'id', 'UserListTable_t');
      table.classList.add('width100');
      table.style = 'margin: unset;';
      const inp = divAtt('input', 'type', 'checkbox');
      inp.setAttribute('class', 'selectAllUsers');
      inp.setAttribute('id', 'all_userList');
      const icon = divAtt('div');
      const thead = divAtt('thead');
      const th0 = divAtt('th');
      const th1 = divAtt('th');
      const th2 = divAtt('th');
      const th3 = divAtt('th');
      const th4 = divAtt('th');
      const th5 = divAtt('th');
      const th6 = divAtt('th');
      th2.innerHTML = 'Name';
      th3.innerHTML = 'Email Address';
      th4.innerHTML = 'Mobile Number';
      th5.innerHTML = 'Allocation Status';
      th6.innerHTML = 'Action';
      th0.appendChild(inp);
      th1.appendChild(icon);
      // thead.appendChild(th0);
      thead.appendChild(th1);
      thead.appendChild(th2);
      thead.appendChild(th3);
      thead.appendChild(th4);
      thead.appendChild(th5);
      thead.appendChild(th6);
      table.appendChild(thead);
      page.appendChild(table);

      //@steph -> below not used?
      // inp.addEventListener("change", () => {
      //   const checked = id("all_userList").checked;
      //   const rows = table.getElementsByTagName("tr");
      //   for (let tablerow of rows) {
      //     const SelectBox = tablerow.getElementsByClassName("userList");
      //     if (tablerow.style.display !== "none") {
      //       id(SelectBox[0].id).checked = checked;
      //     }
      //   }
      // });

      for (let row of data) {
        const show = !id('activeNo').checked;
        if (row.USERACTIVEYN === show) {
          const tr = divAtt('tr', 'class', '');
          const tdSelect = divAtt('td', 'class', 'Name');
          const label = divAtt('label', 'class', 'container');
          const select = divAtt('input', 'type', 'checkbox');
          select.setAttribute('class', 'userList');
          select.setAttribute('id', `userList_${row.HUSERID}`);
          const span = divAtt('span', 'class', 'checkmark');
          label.appendChild(select);
          label.appendChild(span);
          tdSelect.appendChild(label);
          tr.appendChild(tdSelect);

          const tdName = divAtt('td', 'class', 'Name');
          tdName.innerHTML = row.FNAME + '' + row.SNAME;
          tr.appendChild(tdName);

          const tdEmail = divAtt('td', 'class', 'emailAddress');
          tdEmail.innerHTML = row.EMAILADDRESS;
          tr.appendChild(tdEmail);

          const tdMobile = divAtt('td', 'class', 'mobileNr');
          tdMobile.innerHTML = row.MOBILENUMBER;
          tr.appendChild(tdMobile);

          const tdAllocAss = divAtt('td', 'class', 'tdAllocAss');
          tdAllocAss.innerHTML = row.ALLOCATIONSTATUS;
          tr.appendChild(tdAllocAss);

          const tdlink = divAtt('td', 'class', '');
          const btn = divAtt('a', 'href', '#');
          const btn2 = divAtt('a', 'href', '#');
          const clientID = id('clientDD').value;
          const params = 'HclientID=' + clientID + '&editUserID=' + row.HUSERID;
          btn.setAttribute('onclick', 'PREP("assignAssessment", "' + params + '")');
          btn.classList.add('btn');
          btn.innerHTML = 'Link';
          btn.style = 'margin-right: 0.5rem;';
          btn2.setAttribute('onclick', 'PREP("editUser", "' + params + '")');
          btn2.classList.add('class', 'btn');
          btn2.innerHTML = 'Edit';
          tdlink.appendChild(btn);
          tdlink.appendChild(btn2);
          tr.appendChild(tdlink);
          id('UserListTable_t').appendChild(tr);
        }
      }
      unhide('userListTable');
    }
  }
}

export class MUt_CompareUsers {
  constructor(vars) {
    this.name = 'Manage Users - Compare Users';
    this.pageTier = 20;
    this.reference = 'MUt_compareUsers';
    this.pageID = null;
    this.HclientID = vars.hclientID;
    this.compareList = vars.compareList;
  }

  initPage(data) {
    // Set page pecific variables
    this.getUserMergeDets = data.getUserMergeDets;
    this.loadPage();
  }

  loadPage() {
    this.comparePage();
  }

  comparePage() {
    const data = this.getUserMergeDets;

    for (let i = 0; i < data.length; i++) {
      const user = data[i].userDets[0];
      const apps = data[i].applicationDets;
      const asses = data[i].assessmentDets;
      id(`target_${i}`).value = user.HuserID;
      id(`dateCreated_${i}`).innerHTML = formatDate(user.dateFirstOnSystem);
      id(`lastlogin_${i}`).innerHTML = user.lastLogin != '' ? formatDate(user.lastLogin) : '-';
      id(`numLogins_${i}`).innerHTML = user.totalLogins || 0;

      id(`lastUpdtd_${i}`).innerHTML = user.lastUpdated != '' ? formatDate(user.lastUpdated) : '-';
      id(`lastUpdtrText_${i}`).innerHTML = user.LastupdaterText || '-';

      id(`ppic_${i}`).src = user.profileImage || imgPlaceholderURL;
      id(`ppic_${i}_box`).value = user.HuserID;
      id(`fname_${i}`).innerHTML = user.fname || '-';
      id(`fname_${i}_box`).value = user.HuserID;
      id(`sname_${i}`).innerHTML = user.sname || '-';
      id(`sname_${i}_box`).value = user.HuserID;
      id(`mobile_${i}`).innerHTML = user.mobileNumber || '-';
      id(`mobile_${i}_box`).value = user.HuserID;
      id(`email_${i}`).innerHTML = user.emailAddress || '-';
      id(`email_${i}_box`).value = user.HuserID;
      id(`IDNum_${i}`).innerHTML = user.IDnumber || '-';
      id(`IDNum_${i}_box`).value = user.HuserID;
      id(`gender_${i}`).innerHTML = user.GenderDisplay || '-';
      id(`gender_${i}_box`).value = user.HuserID;
      id(`eth_${i}`).innerHTML = user.ethnicityDisplay || '-';
      id(`eth_${i}_box`).value = user.HuserID;
      id(`nat_${i}`).innerHTML = user.residentCountry || '-';
      id(`nat_${i}_box`).value = user.HuserID;
      id(`role_${i}`).innerHTML = user.role || '-';
      id(`role_${i}_box`).value = user.HuserID;
      //-----------------------------------------------------
      id(`job_${i}`).innerHTML = user.jobTitle || '-';
      id(`job_${i}_box`).value = user.HuserID;
      id(`foreignNat_${i}`).innerHTML = user.foreignNational === 1 ? 'Yes' : user.foreignNational === 0 ? 'No' : '-';
      id(`foreignNat_${i}_box`).value = user.HuserID;
      id(`passportNum_${i}`).innerHTML = user.Passportnumber || '-';
      id(`passportNum_${i}_box`).value = user.HuserID;
      id(`workPermRSA_${i}`).innerHTML = user.RSAWorkPermit == 1 ? 'Yes' : 'No';
      id(`workPermRSA_${i}_box`).value = user.HuserID;
      id(`dob_${i}`).innerHTML = user.DOB || '-';
      id(`dob_${i}_box`).value = user.HuserID;
      id(`empID_${i}`).innerHTML = user.employeeID || '-';
      id(`empID_${i}_box`).value = user.HuserID;
      id(`linkedInURL_${i}`).innerHTML = user.linkedInURL ? 'Yes' : '-';
      id(`linkedInURL_${i}_box`).value = user.HuserID;
      id(`cntryofO_${i}`).innerHTML = user.countryoforigin || '-';
      id(`cntryofO_${i}_box`).value = user.HuserID;
      if (asses.length) {
        for (let ass of asses) {
          const list = document.createElement('li');
          list.innerHTML = ass.assessmentName;
          const uList = divAtt('ul', 'class', 'compareSubli');
          const rList = document.createElement('li');
          rList.innerHTML = 'Relationship: ';
          const rSpan = document.createElement('span');
          rSpan.innerHTML = ass.relationship;

          const aList = document.createElement('li');
          aList.innerHTML = 'Active: ';
          const aSpan = document.createElement('span');
          aSpan.innerHTML = ass.activeYN ? 'Yes' : 'No';

          rList.appendChild(rSpan);
          uList.appendChild(rList);
          aList.appendChild(aSpan);
          uList.appendChild(aList);
          list.appendChild(uList);
          id(`ass_${i}`).appendChild(list);
        }
      }
      if (apps.length) {
        for (let app of apps) {
          const list = document.createElement('li');
          list.innerHTML = app.Reference;
          const uList = divAtt('ul', 'class', 'compareSubli');
          const rList = document.createElement('li');
          rList.innerHTML = 'Role: ';
          const rSpan = document.createElement('span');
          rSpan.innerHTML = app.Role;

          const sList = document.createElement('li');
          sList.innerHTML = 'Status: ';
          const sSpan = document.createElement('span');
          sSpan.innerHTML = app.status;

          rList.appendChild(rSpan);
          uList.appendChild(rList);
          sList.appendChild(sSpan);
          uList.appendChild(sList);
          list.appendChild(uList);
          id(`app_${i}`).appendChild(list);
        }
      }

      unhide(`profile_${i}`);
    }
  }

  static selectuserItem(elID) {
    const elArr = elID.split('_');
    for (let i = 0; i < 3; i++) {
      if (i == elArr[1]) {
        id(`${elArr[0]}_${i}_box`).checked = true;
        !id(`${elArr[0]}_${i}`).classList.contains('selectedCU') && id(`${elArr[0]}_${i}`).classList.add('selectedCU');
      } else {
        id(`${elArr[0]}_${i}_box`).checked = false;
        id(`${elArr[0]}_${i}`).classList.contains('selectedCU') && id(`${elArr[0]}_${i}`).classList.remove('selectedCU');
      }
    }
  }

  static selectuserProfile(elID) {
    const elArr = elID.split('_');
    for (let i = 0; i < 3; i++) {
      if (i != elArr[1]) {
        id(`compareProfile_${i}`).classList.remove('compareProfileActive');
        id(`profileDets_${i}`).classList.remove('profileDetsActive');
      } else {
        id(`compareProfile_${i}`).classList.add('compareProfileActive');
        id(`profileDets_${i}`).classList.add('profileDetsActive');
      }
    }
  }

  static selectuserProfileImage(elID) {
    const elArr = elID.split('_');
    for (let i = 0; i < 3; i++) {
      if (i != elArr[1]) {
        hide(`tick_${i}`);
        id(`ppContainer_${i}`).classList.remove('ppActive');
      } else {
        unhide(`tick_${i}`);
        id(`ppContainer_${i}`).classList.add('ppActive');
      }
    }
  }

  static mergeUsers() {
    const obj = {};
    const userArr = [];
    const fieldArr = ['ppic', 'fname', 'sname', 'mobile', 'email', 'IDNum', 'gender', 'eth', 'nat', 'role', 'job', 'foreignNat', 'passportNum', 'workPermRSA', 'dob', 'empID', 'linkedInURL', 'cntryofO'];
    for (let field of fieldArr) {
      for (let i = 0; i < 3; i++) {
        if (id(`compareProfile_${i}`).classList.contains('compareProfileActive')) {
          obj.targetProfile = id(`target_${i}`).value;
        } else {
          const user = id(`target_${i}`).value;
          !userArr.includes(user) && userArr.push(user);
        }
        if (id(`${field}_${i}_box`).checked) {
          obj[`${field}`] = id(`${field}_${i}_box`).value;
        }
      }
    }
    obj.otherUsers = userArr.join(',');
    const vars = {};
    vars.HclientID = id('clientDD').value;
    vars.mergedUsers = JSON.stringify(obj);
    vars.editUserID = obj.targetProfile;

    PREP(['mergeProfiles'], vars)
      .then((res) => {
        note(res.data.mergeProfiles);
        PREP('editUser', vars);
      })
      .catch(console.error());
  }
}

export class assAssessment {
  constructor(vars) {
    this.name = 'Manage Users - Assign Assessment';
    this.pageTier = 20;
    this.reference = 'assignAssessment';
    this.pageID = null;
    this.HclientID = vars.HclientID;
    this.groupName = vars.groupName;
    this.groupID = vars.groupID;
  }

  initPage(data) {
    // Set page pecific variables
    console.log('assData', data);
    this.getAssPerClient = cObj(data.getAssessmentsPerClient);
    this.getRaterRel = cObj(data.getDDraterRelationship);
    this.getUserDets = data.getUserDets;
    this.getUsers = data.getUsers[0].ReturnList;
    this.loadPage();
  }

  loadPage() {
    this.page();
  }

  page() {
    const getRaterRel = this.getRaterRel;
    const getUserDets = this.getUserDets ? this.getUserDets[0] : undefined;

    //-------------------------------
    //getUserDetails
    const profImg = divAtt('img', 'class', 'user_Headers_profilePic');
    profImg.src = getUserDets ? getUserDets.profileImage : '';
    getUserDets && id('userDetails').appendChild(profImg);

    id('assessmentHeader').innerHTML = getUserDets ? `${getUserDets.fname} ${getUserDets.sname}` : this.groupName;
    id('HclientID').value = getUserDets ? getUserDets.HclientID : this.HclientID;
    id('HuserID').value = getUserDets ? getUserDets.HuserID : '';
    id('HuserGroupID').value = getUserDets ? '' : this.groupID;

    //-------------------------------
    //getAssessmentsPerClient
    buildDropDownMain(this.getAssPerClient, 'AssesmentDD', 'HASSESSMENTID', 'SHORTNAME');

    //-------------------------------
    //getDDraterRelationship
    this.createRelationship(getRaterRel, 'AddRatersRelationshipsMinMax', 'Add');
    this.createRelationship(getRaterRel, 'selfSelectRelationshipsMinMax', 'Choose');

    //-------------------------------
    //getUsers
    buildDropDownMain(this.getUsers, 'approverDD', 'HuserID', 'First name+Surname');
  }
  createRelationship(data, locID, type) {
    var div = document.getElementById(locID);
    data.forEach((value) => {
      var row = divAtt('div', 'class', 'grid-3col-aapage');
      var label = divAtt('p', 'class', 'marginRight');
      label.innerHTML = value.DESCRIPTION;
      var inputMin = divAtt('input', 'type', 'text');
      inputMin = addAtt(inputMin, 'placeholder', 'Min');
      inputMin = addAtt(inputMin, 'name', `${value.DDRATERRELATIONSHIPID}_qtyMin`);
      inputMin.setAttribute('class', 'inputMinMax');
      inputMin = addAtt(inputMin, 'style', 'min-width:60px; width:60px;');
      inputMin = addAtt(inputMin, 'id', type + '_presMin_' + value.DDRATERRELATIONSHIPID);
      inputMin.classList.add('marginRight');
      var inputMax = divAtt('input', 'type', 'text');
      inputMax = addAtt(inputMax, 'placeholder', 'Max');
      inputMax = addAtt(inputMax, 'style', 'min-width:60px; width:60px;');
      inputMax = addAtt(inputMax, 'name', `${value.DDRATERRELATIONSHIPID}_qtyMax`);
      inputMax.setAttribute('class', 'inputMinMax');
      inputMax = addAtt(inputMax, 'id', type + '_presMax_' + value.DDRATERRELATIONSHIPID);
      row.appendChild(label);
      row.appendChild(inputMin);
      row.appendChild(inputMax);
      div.appendChild(row);
    });
  }
  static termDate(elID) {
    const dateInp = id(elID);
    const dateInpF = new Date(dateInp.value);
    const FullYear = dateInpF.getFullYear();
    const today = new Date();
    if (dateInp !== '' && dateInpF > today && FullYear < 2100) {
      dateInp.classList.remove('invld');
      if (elID == 'assDate') {
        unhide('hdrContent2');
      }
    } else {
      dateInp.classList.add('invld');
      if (elID == 'assDate') {
        hide('hdrContent2');
        id('addRatersValue').checked = false;
        id('selfSelectRateeValue').checked = false;
        hide('selfSelectSection');
        hide('nominateCand');
        unhide('linkSimpleBtn');
      }
    }
  }

  static linkAssesment() {
    const assesmentDD = id('AssesmentDD');
    if (assesmentDD.value == '-') {
      id('addRatersValue').checked = false;
      id('selfSelectRateeValue').checked = false;
      hide('hdrContent');
      hide('selfSelectSection');
      hide('nominateCand');
      unhide('linkSimpleBtn');
    } else {
      PREP(['getUserGroups'], `HassessmentID=${assesmentDD.value}`).then((res) => {
        const userGroups = cObj(res.data.getUserGroups);
        buildDropDownMain(userGroups, 'targetUserGroupDDChoose', 'HUSERGROUPID', 'SHORTNAME');
        buildDropDownMain(userGroups, 'targetUserGroupDDNominate', 'HUSERGROUPID', 'SHORTNAME');
        unhide('hdrContent');
      });
    }
  }
  static newOption(element) {
    const div = element.id == 'targetUserGroupDDNominate' ? 'addNewRaters' : 'selfSelectNewRatee';
    if (element.value != '-') {
      unhide(div);
    } else {
      id(`${div}Value`).checked = false;
      hide(div);
    }
  }
  static selfSelectNewOption(element) {
    if (element.value != '-') {
      unhide('selfSelectNewRatee');
    } else {
      id('selfSelectNewRateeValue').checked = false;
      hide('selfSelectNewRatee');
    }
  }
  static addRater() {
    if (id('addRatersValue').checked) {
      unhide('nominateCand');
      unhide('addRatersRelationships');
      id('selfSelectRateeValue').checked = false;
      assAssessment.selfSelect();
      hide('linkSimpleBtn');
    } else {
      hide('nominateCand');
      hide('addRatersRelationships');
      hide('AddRatersRelationshipsMinMax');
      hide('addRatersOpenRelationships');
      hide('approvers');
      hide('approversList');
      hide('linkNominationsBtn');
      unhide('linkSimpleBtn');
      id('addRatersPrescribed').checked = false;
      id('addRatersOpen').checked = false;
    }
  }
  static selfSelect() {
    if (id('selfSelectRateeValue').checked) {
      unhide('selfSelectSection');
      unhide('chooseRateeRelationships');
      id('addRatersValue').checked = false;
      assAssessment.addRater();
      hide('linkSimpleBtn');
    } else {
      id('cRateePrescribed').checked = false;
      id('cRateeOpen').checked = false;
      hide('selfSelectSection');
      hide('linkChoicesBtn');
      hide('selDateShow');
      hide('chooseRateeRelationships');
      hide('selfSelectOpenRelationships');
      hide('selfSelectRelationshipsMinMax');
      id('selfSelectMin').value = '';
      id('selfSelectMax').value = '';
      unhide('linkSimpleBtn');
    }
  }
  static relationships() {
    unhide('approvers');
    unhide('linkNominationsBtn');
    if (id('addRatersPrescribed').checked) {
      unhide('AddRatersRelationshipsMinMax');
      hide('addRatersOpenRelationships');
    }
    if (id('addRatersOpen').checked) {
      hide('AddRatersRelationshipsMinMax');
      unhide('addRatersOpenRelationships');
    }
    const approvers = document.querySelectorAll('.approver');
    approvers.length && unhide('approversList');
  }
  static cRateeRelationships() {
    unhide('linkChoicesBtn');
    unhide('selDateShow');
    if (id('cRateePrescribed').checked) {
      unhide('selfSelectRelationshipsMinMax');
      hide('selfSelectOpenRelationships');
    }
    if (id('cRateeOpen').checked) {
      hide('selfSelectRelationshipsMinMax');
      unhide('selfSelectOpenRelationships');
    }
  }
  static addApprover() {
    const approverList = id('approverDD');
    const approversList = id('approversList');
    const approverArr = document.querySelectorAll('.approver');
    const curArr = [];
    approverArr.forEach((app) => {
      const appId = app.id.split('_');
      curArr.push(appId[1]);
    });
    if (approverList.value == '-') {
      showError('Please choose an option from the list of approvers!', 'Error!');
    } else if (curArr.includes(approverList.value)) {
      showError('This approver has already been selected.', 'Error!');
      return;
    } else {
      let div1 = divAtt('div', 'class', 'row');
      div1.classList.add('approver');
      div1.setAttribute('id', `approver_${approverList.value}`);
      const div2 = divAtt('div', 'class', '');
      const div3 = divAtt('div', 'style', 'padding-left:5px;');
      div2.innerHTML = approverList.options[approverList.selectedIndex].text;
      let remove = divAtt('img', 'class', 'iconSize');
      remove.src = trashCanIcon;
      div3.appendChild(remove);
      div1.appendChild(div2);
      div1.appendChild(div3);
      approversList.appendChild(div1);
      eListen(
        remove,
        () => {
          assAssessment.removeApprover(approverList.value);
        },
        'click'
      );
      unhide('approversList');
    }
  }
  static removeApprover(appID) {
    const approver = id(`approver_${appID}`);
    approver.parentNode.removeChild(approver);
    const approvers = document.querySelectorAll('.approver');
    approvers.length == 0 && hide('approversList');
  }
  static presVal(presArr) {
    let response = true;
    for (let el of presArr) {
      if (el.qtyMax == '' || el.qtyMin == '') {
        response = false;
      }
    }
    return response;
  }
  static openVal(openArr) {
    let response = true;
    if (openArr.qtyMax == '' || openArr.qtyMin == '') {
      response = false;
    }
    return response;
  }
  static linkNominations() {
    const minimumReachedRuleValue = id('MinimumReachedRuleValue');
    const inputMinMax = document.querySelectorAll('.inputMinMax');
    const approverArr = document.querySelectorAll('.approver');
    const addRatersValue = id('addRatersValue');
    const selfRateValue = id('selfRateValue');
    const addRatersOpen = id('addRatersOpen');
    const huserGroupID = id('HuserGroupID');
    const assesmentDD = id('AssesmentDD');
    const clientID = id('HclientID');
    const assDate = id('assDate');
    const nomDate = id('nomDate');
    const openMin = id('openMin');
    const openMax = id('openMax');
    const userID = id('HuserID');

    const targetUserGroupDDNominate = id('targetUserGroupDDNominate');
    const addNewRatersValue = id('addNewRatersValue');

    const ChooseTargetGroup = '-';
    const addUserToChoose = 0;

    const approverHuserID = [];
    const minMaxArr = [];
    const dataObj = {};
    const vars = {};
    let cntr = 0;
    //-----------------------------------
    //Prescribed relationship quantities
    approverArr.forEach((approver) => {
      const id = approver.id.split('_');
      approverHuserID.push(id[1]);
    });
    //-----------------------------------
    //Prescribed relationship quantities
    inputMinMax.forEach((input) => {
      const id = input.id.split('_');
      const name = input.name;
      const inSplit = name.split('_');
      if (cntr == inSplit[0]) {
        for (let qty of minMaxArr) {
          if (qty.DDRATERRELATIONSHIPID == inSplit[0] && id[0] == 'Add') {
            qty[inSplit[1]] = input.value;
          }
        }
      } else {
        if (id[0] == 'Add') {
          const qtyObj = {};
          qtyObj.DDRATERRELATIONSHIPID = inSplit[0];
          qtyObj[inSplit[1]] = input.value;
          minMaxArr.push(qtyObj);
          cntr = inSplit[0];
        }
      }
    });
    //----------------------------------------------------
    //Prepare Object
    dataObj.relaxMinRule = toggleSliderYN(minimumReachedRuleValue.checked);
    dataObj.addRaterRelationshipType = addRatersOpen.checked ? 'open' : 'prescribed';
    dataObj.selfRate = toggleSliderYN(selfRateValue.checked);
    dataObj.addRaters = toggleSliderYN(addRatersValue.checked);
    dataObj.approverHuserID = approverHuserID;
    dataObj.AddRaterRelationships = minMaxArr;
    dataObj.HuserGroupID = huserGroupID.value;
    dataObj.AssessmentID = assesmentDD.value;
    dataObj.detailsUserID = userID.value;
    dataObj.allocHUserID = userID.value;
    dataObj.hClientID = clientID.value;
    dataObj.assDate = assDate.value;
    dataObj.nomDate = nomDate.value;
    dataObj.openAddRater = {
      qtyMax: openMax.value,
      qtyMin: openMin.value,
    };

    dataObj.NominateTargetGroup = targetUserGroupDDNominate.value;
    dataObj.addUserToNominate = toggleSliderYN(addNewRatersValue.checked);

    dataObj.ChooseTargetGroup = ChooseTargetGroup;
    dataObj.addUserToChoose = addUserToChoose;

    //----------------------------------------------------
    //Validate and Update
    if (dataObj.addRaterRelationshipType == 'prescribed' && !assAssessment.presVal(dataObj.AddRaterRelationships)) {
      showError('Please declare the minimum and maximum for each relationship.', 'Required Field');
    } else if (dataObj.addRaterRelationshipType == 'open' && !assAssessment.openVal(dataObj.openAddRater)) {
      showError('Please declare the minimum and maximum for each relationship.', 'Required Field');
    } else if (dataObj.nomDate == '' || nomDate.classList.contains('invld')) {
      showError('Please choose a valid date of completion ', 'Required Field');
    } else {
      vars.entityType = 'allocateUserAssessment';
      vars.entityUUID = uuidvMain();
      vars.detailsUserID = dataObj.detailsUserID;
      vars.HuserGroupID = dataObj.HuserGroupID;
      vars.payload = JSON.stringify(dataObj);
      PREP(['uploadNewRecords'], vars)
        .then((res) => {
          note(res.data.uploadNewRecords);
        })
        .catch(console.error());
    }
  }
  static linkChoices() {
    const minimumReachedRuleValue = id('MinimumReachedRuleValue');
    const inputMinMax = document.querySelectorAll('.inputMinMax');
    const approverArr = document.querySelectorAll('.approver');
    const addRatersValue = id('addRatersValue');
    const selfRateValue = id('selfRateValue');
    const cRateeOpen = id('cRateeOpen');
    const assesmentDD = id('AssesmentDD');
    const clientID = id('HclientID');
    const assDate = id('assDate');
    const selDate = id('selDate');
    const selfSelectMin = id('selfSelectMin');
    const selfSelectMax = id('selfSelectMax');
    const huserGroupID = id('HuserGroupID');
    const userID = id('HuserID');

    const chooseTargetGroup = id('targetUserGroupDDChoose');
    const addUserToChoose = id('selfSelectRateeValue');

    const targetUserGroupDDNominate = '-';
    const addNewRatersValue = 0;

    const approverHuserID = [];
    const minMaxArr = [];
    const dataObj = {};
    const vars = {};
    let cntr = 0;
    //-----------------------------------
    //Prescribed relationship quantities
    approverArr.forEach((approver) => {
      const id = approver.id.split('_');
      approverHuserID.push(id[1]);
    });
    //-----------------------------------
    //Prescribed relationship quantities
    inputMinMax.forEach((input) => {
      const id = input.id.split('_');
      const name = input.name;
      const inSplit = name.split('_');
      if (cntr == inSplit[0]) {
        for (let qty of minMaxArr) {
          if (qty.DDRATERRELATIONSHIPID == inSplit[0] && id[0] == 'Choose') {
            qty[inSplit[1]] = input.value;
          }
        }
      } else {
        if (id[0] == 'Choose') {
          const qtyObj = {};
          qtyObj.DDRATERRELATIONSHIPID = inSplit[0];
          qtyObj[inSplit[1]] = input.value;
          minMaxArr.push(qtyObj);
          cntr = inSplit[0];
        }
      }
    });
    //----------------------------------------------------
    //Validation
    dataObj.relaxMinRule = toggleSliderYN(minimumReachedRuleValue.checked);
    dataObj.chooseRateeRelationshipType = cRateeOpen.checked ? 'open' : 'prescribed';
    dataObj.selfRate = toggleSliderYN(selfRateValue.checked);
    dataObj.addRaters = toggleSliderYN(addRatersValue.checked);
    dataObj.NominateTargetGroup = targetUserGroupDDNominate.value;
    dataObj.approverHuserID = approverHuserID;
    dataObj.AddRaterRelationships = minMaxArr;
    dataObj.HuserGroupID = huserGroupID.value;
    dataObj.AssessmentID = assesmentDD.value;
    dataObj.detailsUserID = userID.value;
    dataObj.allocHUserID = userID.value;
    dataObj.hClientID = clientID.value;
    dataObj.assDate = assDate.value;
    dataObj.selDate = selDate.value;
    dataObj.openChooseRatee = {
      qtyMax: selfSelectMax.value,
      qtyMin: selfSelectMin.value,
    };

    dataObj.ChooseTargetGroup = chooseTargetGroup.value;
    dataObj.addUserToChoose = toggleSliderYN(addUserToChoose.checked);

    dataObj.NominateTargetGroup = targetUserGroupDDNominate;
    dataObj.addUserToNominate = addNewRatersValue;

    //----------------------------------------------------
    //Validate and Update
    if (dataObj.chooseRateeRelationshipType == 'prescribed' && !assAssessment.presVal(dataObj.AddRaterRelationships)) {
      showError('Please declare the minimum and maximum for each relationship.', 'Required Field');
    } else if (dataObj.chooseRateeRelationshipType == 'open' && !assAssessment.openVal(dataObj.openChooseRatee)) {
      showError('Please declare the minimum and maximum for each relationship.', 'Required Field');
    } else if (dataObj.selDate == '' || selDate.classList.contains('invld')) {
      showError('Please choose a valid date of completion ', 'Required Field');
    } else {
      vars.entityType = 'allocateUserAssessment';
      vars.entityUUID = uuidvMain();
      vars.detailsUserID = dataObj.detailsUserID;
      vars.HuserGroupID = dataObj.HuserGroupID;
      vars.payload = JSON.stringify(dataObj);
      PREP(['uploadNewRecords'], vars)
        .then((res) => {
          note(res.data.uploadNewRecords);
        })
        .catch(console.error());
    }
  }
  static linkSimple() {
    const selfRateValue = id('selfRateValue');
    const huserGroupID = id('HuserGroupID');
    const assesmentDD = id('AssesmentDD');
    const clientID = id('HclientID');
    const assDate = id('assDate');
    const userID = id('HuserID');

    const dataObj = {};
    const vars = {};

    //----------------------------------------------------
    //Validation
    dataObj.relaxMinRule = 0;
    dataObj.addRaterRelationshipType = 'simple';
    dataObj.selfRate = toggleSliderYN(selfRateValue.checked); //This One
    dataObj.addRaters = 0;
    dataObj.NominateTargetGroup = '';
    dataObj.approverHuserID = [];
    dataObj.AddRaterRelationships = '';
    dataObj.HuserGroupID = huserGroupID.value; //This One
    dataObj.AssessmentID = assesmentDD.value; //This One
    dataObj.detailsUserID = userID.value; //This One
    dataObj.allocHUserID = userID.value; //This One
    dataObj.hClientID = clientID.value; //This One
    dataObj.assDate = assDate.value; //This One
    dataObj.selDate = '';
    dataObj.openAddRater = {};

    dataObj.ChooseTargetGroup = '-';
    dataObj.addUserToChoose = 0;

    dataObj.NominateTargetGroup = '-';
    dataObj.addUserToNominate = 0;

    //----------------------------------------------------
    //Update
    vars.entityType = 'allocateUserAssessment';
    vars.entityUUID = uuidvMain();
    vars.detailsUserID = dataObj.detailsUserID;
    vars.HuserGroupID = huserGroupID.value;
    vars.payload = JSON.stringify(dataObj);
    PREP(['uploadNewRecords'], vars)
      .then((res) => {
        note(res.data.uploadNewRecords);
      })
      .catch(console.error());
  }
}

// ========================= ADD USER ===================

export class addUser {
  constructor() {
    this.name = 'Add Users';
    this.pageTier = 20;
    this.reference = 'addUser';
    this.pageID = null;
    this.HclientID = null;
  }

  initPage() {
    // Set page pecific variables
    this.loadPage();
  }

  loadPage() {
    this.addUserPage();
  }

  addUserPage() {
    id('selectC').addEventListener('change', addUserLoad);

    function addUserLoad() {
      if (id('AUt_addUser')) {
        if (id('clientDD').value == '') {
          unhide('selectClientMessage');
          hide('contentContainer');
        } else {
          if (id('AUt_addUser').classList.contains('active')) {
            ccRegex(0, id('clientDD').value);
          }

          hide('selectClientMessage');
          unhide('contentContainer');
        }
      } else {
        id('clientDD').removeEventListener('change', addUserLoad);
      }
    }
  }
}

export class AUt_addUser {
  constructor() {
    this.name = 'Add Users';
    this.pageTier = 30;
    this.reference = 'AUt_addUser';
    this.pageID = null;
    this.HclientID = null;
  }

  initPage(data) {
    // Set page pecific variables
    this.loadPage();
  }

  loadPage() {
    this.addUserPage();
  }

  addUserPage() {
    if (id('clientDD').value) {
      ccRegex(0, id('clientDD').value);
      hide('selectClientMessage');
      unhide('contentContainer');
    }
  }

  static async addSingleUser() {
    if (id('clientDD').value === '') {
      infoBox('Please select a client.');
    } else if (!validatePage) {
      return;
    }

    const phoneNumber = await sanatizeNum(id('f_cellNr').value, id('countryCodes').value);
    const vars = {};
    const obj = {};
    obj.fname = id('fname').value;
    obj.sname = id('sname').value;
    obj.mobileNo = phoneNumber;
    obj.emailAddress = id('emailAddress').value;
    obj.employeeNo = id('employeeNo').value;
    obj.employeeRole = id('roleDD').value;
    obj.uuid = uuidvMain();
    obj.HclientID = id('clientDD').value;
    vars.entityType = 'submitNewUser';
    vars.entityUUID = uuidvMain();
    vars.payload = JSON.stringify(obj);
    vars.HclientID = id('clientDD').value;
    PREP(['uploadNewRecords'], vars)
      .then((res) => {
        note(res.data.uploadNewRecords);
        changeTabN('AUt_addUser');
      })
      .catch(console.error());
  }
}

export class AUt_bulkUser {
  constructor() {
    this.name = 'Add Bulk Users';
    this.pageTier = 30;
    this.reference = 'AUt_bulkUser';
    this.pageID = null;
    this.HclientID = null;
  }

  initPage() {
    // Set page pecific variables
    this.loadPage();
  }

  loadPage() {
    this.bulkUsersPage();
  }

  bulkUsersPage() {
    if (id('clientDD').value) {
      // if (id('bulkRoleDD').value === '-' || id('bulkRoleDD').value === '') {
      //     hide('bulkUploadBtn')
      // } else {
      //     unhide('bulkUploadBtn')
      // }
      //         PREP(['getUserGroups'], {
      //                 hclientID: id('clientDD').value
      //             })
      //             .then(res => {
      //                 const groups = cObj(res.data.getUserGroups)
      //                 const obj = {};
      //                 obj.HUSERGROUPID = 'new';
      //                 obj.SHORTNAME = 'Create new';
      //                 groups.push(obj);
      //                 buildDropDownMain(groups, 'groupDD', 'HUSERGROUPID', 'SHORTNAME');
      //                 unhide('selectGroup');
      //             }).catch(console.error());
      //     }
      //     eListen('groupDD', () => {
      //         if (id('groupDD').value !== '-') {
      //             // unhide('addToUserGroup');
      //             if (id('groupDD').value == 'new') {
      //                 unhide('privateGroup');
      //                 unhide('newGroupNameDiv');
      //                 unhide('newGroupDescription');
      //             } else {
      //                 hide('privateGroup');
      //                 hide('newGroupNameDiv');
      //                 hide('newGroupDescription');
      //             }
      //         } else {
      //             hide('addToUserGroup');
      //         }
      //     })
      //     eListen('bulkRoleDD', () => {
      //         if (id('bulkRoleDD').value !== '-') {
      //             unhide('bulkUploadBtn')
      //         } else {
      //             hide('bulkUploadBtn')
      //         }
      //     })
      // }
    }
  }

  static excelUpload() {
    const selectedFile = id('excelUpload').files[0];
    let rowObject;
    if (selectedFile) {
      var fileReader = new FileReader();
      fileReader.onload = function (event) {
        var data = event.target.result;

        var workbook = XLSX.read(data, {
          type: 'binary',
        });
        workbook.SheetNames.forEach((sheet) => {
          rowObject = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet]);
          AUt_bulkUser.buildUserTable(rowObject);
        });
      };
      fileReader.readAsBinaryString(selectedFile);
    }
    id('batchID').value = uuidv4();
  }

  static buildUserTable(data) {
    const table = id('editUserTable');
    table.innerHTML = '';

    const thead = document.createElement('thead');
    const th1 = document.createElement('th');
    const th2 = document.createElement('th');
    const th3 = document.createElement('th');
    const th4 = document.createElement('th');
    const th5 = document.createElement('th');
    const th6 = document.createElement('th');
    const th7 = document.createElement('th');
    th1.innerHTML = 'Name';
    th2.innerHTML = 'Surname';
    th3.innerHTML = 'Email';
    // th4.innerHTML = 'Mobile Number';
    // th5.innerHTML = 'Employee/Application Number';
    // th6.innerHTML = 'Job Title';
    th7.innerHTML = '';
    thead.appendChild(th1);
    thead.appendChild(th2);
    thead.appendChild(th3);
    // thead.appendChild(th4);
    // thead.appendChild(th5);
    // thead.appendChild(th6);
    thead.appendChild(th7);
    table.appendChild(thead);

    console.log('excelData', data);
    for (const row of data) {
      const uuid = uuidv4();
      const tr = divAtt('tr', 'id', `${uuid}`);
      tr.setAttribute('class', `userRow`);
      const td1 = divAtt('td', 'id', `name_${uuid}`);
      td1.innerHTML = row.firstName;
      const td2 = divAtt('td', 'id', `surname_${uuid}`);
      td2.innerHTML = row.surname;
      const td3 = divAtt('td', 'id', `email_${uuid}`);
      td3.innerHTML = row.email;
      // const td4 = divAtt('td', 'id', `mobNum_${uuid}`);
      // td4.innerHTML = row['mobileNumber include prefix (eg. 27831234567)'];
      // const td5 = divAtt('td', 'id', `employeeApp_${uuid}`);
      // td5.innerHTML = row['employee/applicationNumber'];
      // const td6 = divAtt('td', 'id', `jobTitle_${uuid}`);
      // td6.innerHTML = row.jobTitle;
      const td7 = divAtt('td');
      const btn = divAtt('button', '', '');
      btn.classList.add('btn');
      btn.innerHTML = 'edit';
      td7.appendChild(btn);

      tr.appendChild(td1);
      tr.appendChild(td2);
      tr.appendChild(td3);
      // tr.appendChild(td4);
      // tr.appendChild(td5);
      // tr.appendChild(td6);
      tr.appendChild(td7);
      table.appendChild(tr);
      eListen(
        btn,
        () => {
          AUt_bulkUser.editRow(uuid);
        },
        'click'
      );
    }

    unhide('uploadUserBtnDiv');
  }

  static editRow(rowID) {
    const div = divAtt('div', 'class', '');
    const newRVDiv = divAtt('div', 'class', 'grid-2col-input-custard marginBottom');
    newRVDiv.setAttribute('id', 'newHR');
    // Name
    const nameDiv = buildInpText('editFname', 1, 'Name');
    // Surname
    const surnameDiv = buildInpText('editSname', 1, 'Surname');
    // Email
    const emailDiv = buildInpEmail('editEmail', 1, 'Email');
    // Number
    // const numDiv = buildInpMobNum('f_cellNr', 1, 'Mobile Number');
    // // EmployeeAppNum
    // const emAppDiv = buildInpText('editEmployeeAppNum', 1, 'Employee/Application Number');
    // const jobTitleDiv = buildInpText('editJobTitle', 1, 'Job Title');
    // Feedback Banner
    const FBbanner = buildFeedbackBanner();

    const btnDiv = divAtt('div', 'class', 'gridSpan btnCenterGrid');
    const btn = divAtt('button', 'class', 'btn');
    btn.innerHTML = 'Save';
    //btn.setAttribute("onclick", `AUt_bulkUser.saveEditUser('${rowID}')`);
    const btn2 = divAtt('button', 'class', 'btnCancel');
    btn2.innerHTML = 'Cancel';
    //btn2.setAttribute("onclick", `hide('custardBox')`);
    btnDiv.appendChild(btn2);
    btnDiv.appendChild(btn);

    newRVDiv.appendChild(nameDiv);
    newRVDiv.appendChild(surnameDiv);
    newRVDiv.appendChild(emailDiv);
    // newRVDiv.appendChild(numDiv);
    // newRVDiv.appendChild(emAppDiv);
    // newRVDiv.appendChild(jobTitleDiv);
    newRVDiv.appendChild(FBbanner);
    newRVDiv.appendChild(btnDiv);
    div.appendChild(newRVDiv);
    //custardBox(div, "Edit User");
    eCustardBox(div, `Edit User`, [
      [
        btn,
        () => {
          AUt_bulkUser.saveEditUser(`${rowID}`);
        },
        'click',
      ],
      [
        btn2,
        () => {
          hide('custardBox');
        },
        'click',
      ],
    ]);
    //@mike
    id('editFname').classList.add('notEmptyPopUp');
    id('editSname').classList.add('notEmptyPopUp');
    id('editEmail').classList.add('notEmptyPopUp');
    // id('f_cellNr').classList.add('notEmptyPopUp');
    // id('editEmployeeAppNum').classList.add('notEmptyPopUp');

    // ccRegex(0, 0)
    id('editFname').value = id(`name_${rowID}`).innerHTML;
    id('editSname').value = id(`surname_${rowID}`).innerHTML;
    id('editEmail').value = id(`email_${rowID}`).innerHTML;

    // countryCode(id(`mobNum_${rowID}`).innerHTML, id('clientDD').value);
    // id('editEmployeeAppNum').value = id(`employeeApp_${rowID}`).innerHTML;
    // id('editJobTitle').value = id(`jobTitle_${rowID}`).innerHTML;
  }

  static async saveEditUser(rowID) {
    id(`name_${rowID}`).innerHTML = id('editFname').value;
    id(`surname_${rowID}`).innerHTML = id('editSname').value;
    id(`email_${rowID}`).innerHTML = id('editEmail').value;
    // const canPhoneNumber = await sanatizeNum(id('f_cellNr').value, id('countryCodes').value);
    // console.log('canPhoneNumber', canPhoneNumber);
    // id(`mobNum_${rowID}`).innerHTML = canPhoneNumber;
    // id(`employeeApp_${rowID}`).innerHTML = id('editEmployeeAppNum').value;
    hide('custardBox');
  }

  static uploadUsers() {
    loader(1);

    const newUsers = {};
    newUsers.batchUUID = id('batchID').value;

    const approverArr = document.querySelectorAll('.userRow');
    const curArr = [];
    approverArr.forEach((user) => {
      const userObj = {};
      const userId = user.id;
      userObj.uuid = userId;
      userObj.fname = id(`name_${userId}`).innerHTML;
      userObj.sname = id(`surname_${userId}`).innerHTML;
      userObj.emailAddress = id(`email_${userId}`).innerHTML;
      // userObj.mobileNumber = id(`mobNum_${userId}`).innerHTML;
      // userObj.employeeNo = id(`employeeApp_${userId}`).innerHTML;
      // userObj.jobTitle = id(`jobTitle_${userId}`).innerHTML;
      userObj.mobileNumber = '';
      userObj.employeeNo = '';
      userObj.jobTitle = '';
      userObj.additional = '';
      curArr.push(userObj);
    });
    newUsers.list = curArr;

    if (id('groupDD').value == '-') {
      infoBox('Please select a user group.');
      loader(0);
      return;
    } else if (id('bulkRoleDD').value === '-') {
      infoBox('Please select a role.');
      loader(0);
      return;
    } else if (id('groupDD').value !== 'new') {
      newUsers.HuserGroupID = id('groupDD').value;
      newUsers.HclientID = parseInt(id('clientDD').value);
      newUsers.DDroleID = id('bulkRoleDD').value;
    } else if (id('NewGroupName').value == '' && id('groupDD').value == 'new') {
      infoBox('Please fill in the Group Name for the new Group.');
      loader(0);
      return;
    } else {
      newUsers.HuserGroupID = id('groupDD').value;
      newUsers.newHuserGroupName = id('NewGroupName').value;
      newUsers.newHuserGroupDescription = id('NewGroupdescription').value;
      newUsers.newHuserGroupPrivateYN = id('NewGroupPrivate').checked;
      newUsers.HclientID = parseInt(id('clientDD').value);
      newUsers.DDroleID = id('bulkRoleDD').value;
    }

    const vars = {};
    vars.entityType = 'submitNewUsers';
    vars.entityUUID = uuidvMain();
    vars.payload = JSON.stringify(newUsers);

    PREP(['uploadNewRecords'], vars)
      .then(() => {
        loader(0);
        clearAllDataS('uploadedUsers');
        infoBox(`New Users have been submitted for upload. Once New Users have been successfuly uploaded they will be available under Manage Users. If you do not see these users under manage users, <strong>do not </strong> upload them again. Please contact your administrator. Entity UUID: ${newUsers.batchUUID}`);
        changeTabN('AUt_bulkUser');
      })
      .catch((err) => {
        loader(0);
        infoBox(`Please contact your Administarator for Support.  Error : Entity UUID ${newUsers.batchUUID}, ${err}`);
      });
  }
}

// ========================== EDIT USER ==================

export class EUt_profile {
  constructor(vars) {
    this.name = 'Edit User - Profile';
    this.pageTier = 20;
    this.reference = 'EUt_profile';
    this.pageID = null;
    this.data = null;
    this.HclientID = vars.HclientID;
    this.editUserID = vars.editUserID;
    this.detailsUserID = vars.detailsUserID;
  }

  initPage(data) {
    // Set page pecific variables
    this.getUserDets = data.getUserDets[0];
    this.getDDroles = cObj(data.getDDroles);
    this.getLoggedInhomePageOptions = data.getLoggedInhomePageOptions;
    this.loadPage();
  }

  loadPage() {
    this.profilePage();
  }

  profilePage() {
    buildDropDownMain(this.getDDroles, 'userRoleDD', 'DDROLEID', 'DESCRIPTION');
    buildDropDownMain(this.getLoggedInhomePageOptions, 'userLihpDD', 'HloggedInHomePageID', 'pageName');

    const data = this.getUserDets;

    const f_firstName = id('f_firstName');
    const f_surname = id('f_surname');
    const f_email = id('f_email');
    const userRoleDD = id('userRoleDD');
    const bulkUploadValue = id('bulkUploadValue');
    const profilePic = id('dp');
    const imageMotivation = id('imageMotivation');
    const hclientID = id('hclientID');
    const userLihpDD = id('userLihpDD');
    const lockedProfile = id('locked');

    let imageSrc = '';

    f_firstName.value = data.fname;
    f_surname.value = data.sname;
    f_email.value = data.emailAddress;
    countryCode(data.mobileNumber, data.HclientID);
    bulkUploadValue.checked = data.activeYN;
    lockedProfile.checked = data.lockedOutYN;
    hclientID.value = data.HclientID;

    if (data.LIHPID !== '-' && data.LIHPID !== '') {
      userLihpDD.value = data.LIHPID;
    }

    if (data.roleID !== '-' && data.roleID !== '') {
      userRoleDD.value = data.roleID;
    }
    if (data.profileImage === '') {
      imageSrc = imgPlaceholderURL;
    } else {
      imageSrc = data.profileImage;
    }

    profilePic.setAttribute('name', data.profileImage);
    profilePic.src = imageSrc;
    profilePic.setAttribute('onload', 'OnImageLoad(event, 150)');
  }

  static changePassBox() {
    const vars = {};
    vars.HTMLPageName = 'UPt_profile';
    vars.languageID = getCookie('mbohvbhfje');

    PREP(['getHTMLLexicon'], vars)
      .then((res) => {
        const langObj = {};
        const data = res.data.getHTMLLexicon;
        for (let row of data) {
          langObj[row.marker] = row.display;
        }

        const div = divAtt('div', 'class', '');
        const p = divAtt('p', 'class', 'sectionGap');
        p.innerHTML = langObj.upp_Mkr18;

        const inputDiv = divAtt('div', 'class', 'grid-2col-input-custard marginBottom upp_Mkr18');
        inputDiv.innerHTML = `<div>
        <div class="group">
            <input id="f_password" type="password" autocomplete="new-password" onblur="hidePassBox()"
                oninput="inpPass(this.id)">
            <span class="highlight"></span>
            <span class="bar"></span>
            <label for="">${langObj.upp_Mkr6}</label>

            <svg id="eye1" class="viewPass"   width="25.7" height="15.32" viewBox="0 0 25.7 15.32"><path d="M25.5,7.06C22.22,2.69,17.77,0,12.86,0S3.49,2.69.2,7.05a1.05,1.05,0,0,0,0,1.22c3.29,4.37,7.74,7.05,12.66,7.05s9.36-2.68,12.64-7A1,1,0,0,0,25.5,7.06ZM18.25,8a5.4,5.4,0,1,1,0-.7A4.09,4.09,0,0,1,18.25,8Z" transform="translate(0 0)"/><path d="M12.67,4.76A2.91,2.91,0,1,0,13,10.57h0a2.92,2.92,0,0,0,2.72-2.72,2.28,2.28,0,0,0,0-.37A2.9,2.9,0,0,0,12.67,4.76Z" transform="translate(0 0)"/></svg>
        </div>

        <!-- Password validation -->
        <div id="passValBox" class="hide">
            <h5 class="upp_Mkr19">${langObj.upp_Mkr19}</h5>
            <ul>
                <li id="minChar" class="upp_Mkr20">${langObj.upp_Mkr20}</li>
                <li id="upCase" class="upp_Mkr21">${langObj.upp_Mkr21}</li>
                <li id="lowCase" class="upp_Mkr22">${langObj.upp_Mkr22}</li>
                <li id="num" class="upp_Mkr23">${langObj.upp_Mkr24}</li>
                <li id="special" class="upp_Mkr24">${langObj.upp_Mkr24}</li>
            </ul>
        </div>
    </div>

    <div>

        <div class="group">
            <input id="f_confirm_password" type="password" onblur="hidePassBox()"
                oninput="matchPass('f_password',this.id)" autocomplete="new-password">
            <span class="highlight"></span>
            <span class="bar"></span>
            <label for="">${langObj.upp_Mkr7}</label>

            <svg id="eye2" class="viewPass"   width="25.7" height="15.32" viewBox="0 0 25.7 15.32"><path d="M25.5,7.06C22.22,2.69,17.77,0,12.86,0S3.49,2.69.2,7.05a1.05,1.05,0,0,0,0,1.22c3.29,4.37,7.74,7.05,12.66,7.05s9.36-2.68,12.64-7A1,1,0,0,0,25.5,7.06ZM18.25,8a5.4,5.4,0,1,1,0-.7A4.09,4.09,0,0,1,18.25,8Z" transform="translate(0 0)"/><path d="M12.67,4.76A2.91,2.91,0,1,0,13,10.57h0a2.92,2.92,0,0,0,2.72-2.72,2.28,2.28,0,0,0,0-.37A2.9,2.9,0,0,0,12.67,4.76Z" transform="translate(0 0)"/></svg>

        </div>
        <!-- match password validation -->
        <div id="passMatchBox" class="hide">
            <h5 class="upp_Mkr25">${langObj.upp_Mkr25}</h5>
        </div>
    </div>`;
        const btn = divAtt('btn', 'class', 'btn upp_Mkr17');
        //btn.setAttribute("onclick", `EUt_profile.changePassword()`);
        btn.innerHTML = langObj.upp_Mkr17;
        div.append(p);
        div.append(inputDiv);
        div.append(btn);

        // custardBox(div, `${langObj.upp_Mkr17}`);
        eCustardBox(div, `Edit User`, [
          [
            btn,
            () => {
              EUt_profile.changePassword();
            },
            'click',
          ],
          [
            'eye1',
            () => {
              viewPass('f_password', 'eye1');
            },
            'click',
          ],
          [
            'eye2',
            () => {
              viewPass('f_confirm_password', 'eye2');
            },
            'click',
          ],
        ]);
      })
      .catch(console.error());
  }

  static changePassword() {
    if (id('f_password').value === id('f_confirm_password').value) {
      const vars = {};
      vars.currentPassword = id('f_password').value;
      vars.editUserID = id('editUserID').value;

      PREP(['updCandiPassword'], vars)
        .then((res) => {
          note(res.data.updCandiPassword);
          hide('custardBox');
        })
        .catch(console.error());
    } else {
      const vars = {};
      vars.HTMLPageName = 'UPt_profile';
      vars.languageID = getCookie('mbohvbhfje');

      PREP(['getHTMLLexicon'], vars).then((res) => {
        const langObj = {};

        const data = res.data.getHTMLLexicon;
        for (let row of data) {
          langObj[row.marker] = row.display;
        }

        errBox(langObj.upp_Mkr25);
        hide('custardBox');
        EUt_profile.changePassBox();
      });
    }
  }

  static async updateUserProfile() {
    const editUserID = id('editUserID');

    if (!validatePage()) {
      return;
    }

    //OLD FOX HERE with Lawrie new -->updUserProfile

    const vars = {};
    vars.updateUserID = editUserID.value;
    vars.fname = id('f_firstName').value;
    vars.sname = id('f_surname').value;
    vars.emailAddress = id('f_email').value;
    vars.userName = id('f_email').value;
    vars.currentPassword = ''; //id('f_password').value;
    vars.cellNumber = await sanatizeNum(id('f_cellNr').value, id('countryCodes').value);
    vars.roleId = id('userRoleDD').value;
    vars.lihpID = id('userLihpDD').value;
    vars.activeYN = id('bulkUploadValue').checked;
    vars.lockedOutYN = id('locked').checked;
    if (id('image_file').files[0]) {
      vars.imageFileName = id('image_file').files[0].name;
      vars.imageFile = id('image_file').files[0];
    }
    PREP(['updUserProfile'], vars)
      .then((res) => {
        note(res.data.updUserProfile);
        changeTabN('EUt_profile');
      })
      .catch(console.error());
  }

  static viewLIHP(selID) {
    const sel = id(selID);
    const htmlPre = sel.options[sel.selectedIndex].text;

    if (sel.value == '-') {
      infoBox('Please select a Logged In Homepage to view.');
    } else {
      insertDiv(htmlPre, 'viewLIHP').then(() => {
        unhide('viewLIHP_popupdiv');
      });
    }
  }
}

export class EUt_messageBox {
  constructor(vars) {
    this.name = 'Edit User - Meassages';
    this.pageTier = 20;
    this.reference = 'EUt_messageBox';
    this.pageID = null;
    this.data = null;
    this.editUserID = vars.editUserID;
  }

  initPage() {
    // Set page pecific variables
    this.loadPage();
  }

  loadPage() {
    this.messagePage();
  }

  messagePage() {
    EUt_messageBox.emailPage();
  }

  static async changeSubTab(block) {
    // block active
    const blocks = document.querySelectorAll('.mainBlockItem');
    blocks.forEach((block) => {
      block.classList.remove('blockActive');
    });

    id(block).classList.add('blockActive');

    if (block === 'smsBlock') {
      EUt_messageBox.smsPage();
    } else {
      EUt_messageBox.emailPage();
    }
  }

  static emailPage() {
    const vars = {};
    // const target = direction == 'in' ? 'emailIn' : 'emailOut';
    vars.messageUserID = id('editUserID').value;
    vars.displaypage = 1;
    vars.displayListCount = 25;
    vars.messageType = 'email';
    // vars.direction = direction;
    PREP(['getCommsForUser'], vars)
      .then((res) => {
        console.log('Email getCommsForUser', res.data.getCommsForUser);
        EUt_messageBox.buildMsgPage(res.data.getCommsForUser);
      })
      .catch(console.error());
  }

  static smsPage() {
    const vars = {};
    // const target = direction == 'in' ? 'smsIn' : 'smsOut';
    vars.messageUserID = id('editUserID').value;
    vars.displaypage = 1;
    vars.displayListCount = 25;
    vars.messageType = 'sms';
    // vars.direction = direction;
    PREP(['getCommsForUser'], vars)
      .then((res) => {
        console.log('Email getCommsForUser', res.data.getCommsForUser);
        EUt_messageBox.buildMsgPage(res.data.getCommsForUser);
      })
      .catch(console.error());
  }

  static async buildMsgPage(data) {
    const messages = data[0].ReturnList;
    const msgList = id('listMsgs');
    msgList.innerHTML = '';

    const inboxDiv = divAtt('div', 'id', 'inboxDiv');
    const sentDiv = divAtt('div', 'class', 'hide');
    sentDiv.setAttribute('id', 'sentDiv');
    let ids = [];
    for (let row of messages) {
      const msg = divAtt('div', 'class', 'msg');
      ids.push(row.commslogID);
      msg.setAttribute('id', `${row.commslogID}`);
      //msg.setAttribute("onclick", "EUt_messageBox.viewMsg(this.id)");
      const date = divAtt('p', 'class', 'msgDate');
      date.innerHTML = dateShortFromDateTime(`${row.Spooled}`);
      const subject = divAtt('p', 'class', 'msgSubject');
      if (row.emailSubject) {
        subject.innerHTML = row.emailSubject;
      } else {
        subject.innerHTML = 'SMS';
      }

      const msgPreview = divAtt('p', 'class', 'msgPreview');
      msgPreview.innerHTML = row.shortDescription;
      msg.appendChild(date);
      msg.appendChild(subject);
      msg.appendChild(msgPreview);

      if (row.receiverName === 'This user') {
        inboxDiv.appendChild(msg);
      } else {
        sentDiv.appendChild(msg);
      }
    }

    if (inboxDiv.innerHTML === '') {
      inboxDiv.innerHTML = 'No Messages';
      inboxDiv.style = `margin-top: 2rem;
      color: var(--primaryColor);`;
    }

    if (sentDiv.innerHTML === '') {
      sentDiv.innerHTML = 'No Messages';
      sentDiv.style = `margin-top: 2rem;
      color: var(--primaryColor);`;
    }

    msgList.appendChild(inboxDiv);
    msgList.appendChild(sentDiv);
    for (let i = 0; i < ids.length; i++) {
      eListen(
        `${ids[i]}`,
        () => {
          EUt_messageBox.viewMsg(ids[i]);
        },
        'click'
      );
    }
    EUt_messageBox.inboxSent('inbox');
  }

  static inboxSent(block) {
    // block active
    const blocks = document.querySelectorAll('.subBlockItem');
    blocks.forEach((block) => {
      block.classList.remove('blockActive');
    });
    id(block).classList.add('blockActive');

    if (block === 'inbox') {
      unhide('inboxDiv');
      hide('sentDiv');
    } else {
      hide('inboxDiv');
      unhide('sentDiv');
    }
  }
  static viewMsg(msgId) {
    // msg active
    const msgs = document.querySelectorAll('.msg');
    msgs.forEach((block) => {
      block.classList.remove('msgActive');
    });
    id(msgId).classList.add('msgActive');

    const vars = {};
    vars.commslogID = msgId;
    vars.HTMLPageName = 'EUt_messageBox';
    vars.languageID = getCookie('mbohvbhfje');
    PREP(['getMessageDetail', 'getHTMLLexicon'], vars)
      .then((res) => {
        const langObj = {};
        const data = res.data.getHTMLLexicon;
        for (let row of data) {
          langObj[row.marker] = row.display;
        }

        const detail = res.data.getMessageDetail[0];
        const msgDetail = id('msgDetail');
        msgDetail.innerHTML = '';

        const backDiv = divAtt('div', 'id', 'msgBack');
        //backDiv.setAttribute("onclick", "EUt_messageBox.back()");
        backDiv.innerHTML = `<svg class="backChev"  width="22.79" height="14.4" viewBox="0 0 22.79 14.4">
       <path d="M11.39,14.4,0,3.3,3.39,0l8,7.79,8-7.79,3.4,3.3Z"></path>
       </svg> Back`;

        const date = divAtt('p', 'id', 'msgDDate');
        date.innerHTML = dateFromDateTime(`${detail.spooled}`);
        const subject = divAtt('h3', 'id', 'msgDSubject');
        subject.innerHTML = detail.emailSubject;
        const sender = divAtt('p', 'id', 'msgDWho');
        if (detail.direction) {
          sender.innerHTML = `From: <span>${detail.senderName}</span>`;
        } else {
          sender.innerHTML = `To: <span>${detail.senderName}</span>`;
        }

        const hr = divAtt('hr', 'style', 'margin-top: 30px;');
        const msg = divAtt('p', 'id', 'text');
        msg.innerHTML = detail.emailBody;

        msgDetail.appendChild(backDiv);
        msgDetail.appendChild(date);
        msgDetail.appendChild(subject);
        msgDetail.appendChild(sender);

        // if (detail.messageType === "Email") {
        const resendBtn = divAtt('button', 'class', 'btn');
        resendBtn.style = `margin-top: 1rem;`;
        // resendBtn.setAttribute(
        //   "onclick",
        //   `EUt_messageBox.resend(${detail.commslogID}, '${detail.recipientEmailAddress}')`
        // );
        resendBtn.innerHTML = langObj.upm_Mkr9 ? langObj.upm_Mkr9 : 'Resend';
        msgDetail.appendChild(resendBtn);
        // }

        msgDetail.appendChild(hr);
        msgDetail.appendChild(msg);

        // media size
        const mediaSize = window.matchMedia('(max-width: 900px)');

        eListen(
          backDiv,
          () => {
            EUt_messageBox.back();
          },
          'click'
        );
        eListen(
          resendBtn,
          () => {
            EUt_messageBox.resend(detail.commslogID, detail.recipientEmailAddress);
          },
          'click'
        );
        if (mediaSize.matches) {
          console.log('true');
          id('msgs').style = 'display:none ;';
          id('msgDetail').style = 'display: block ;';
        } else {
          id('msgs').style = 'display: block ;';
          id('msgDetail').style = 'display: block;';
        }
      })
      .catch(console.error());
  }
  static resend(commsLogID, email) {
    const vars = {};
    vars.commsLogID = commsLogID;
    if (email) {
      vars.targetEmailAddress = email;
    }
    PREP(['resendEmail'], vars)
      .then((res) => {
        note(res.data.resendEmail);
      })
      .catch(console.error());
  }
  static back() {
    const mediaSize = window.matchMedia('(max-width: 900px)');
    // console.log("mediaSize", mediaSize);

    if (mediaSize.matches) {
      id('msgs').style = 'display: block !important;';
      id('msgDetail').style = 'display: none !important;';

      const msgs = document.querySelectorAll('.msg');
      msgs.forEach((block) => {
        block.classList.remove('msgActive');
      });
    } else {
      id('msgs').style = 'display: block ;';
      id('msgDetail').style = 'display: block;';
    }
  }
}

export class EUt_navigation {
  constructor(vars) {
    this.name = 'Edit User - Navigation';
    this.pageTier = 20;
    this.reference = 'EUt_navigation';
    this.pageID = null;
    this.data = null;
    this.HclientID = vars.HclientID;
    this.editUserID = vars.editUserID;
    this.detailsUserID = vars.detailsUserID;
  }

  initPage(data) {
    // Set page pecific variables
    this.getUserMenuOptions = data.getUserMenuOptions;
    this.loadPage();
  }

  loadPage() {
    this.navPage();
  }

  navPage() {
    const menu = this.getUserMenuOptions;
    const navtab = id('navtab');
    navtab.innerHTML = '';
    const table = document.createElement('table');
    const thead = document.createElement('thead');
    const short = document.createElement('th');
    short.innerHTML = 'Short Description';
    const long = document.createElement('th');
    long.innerHTML = 'Long Description';
    const entity = document.createElement('th');
    entity.innerHTML = 'Entity Name';
    const defaultYN = document.createElement('th');
    defaultYN.innerHTML = 'Default';
    const tabs = document.createElement('th');
    tabs.innerHTML = 'Tabs';
    const alloc = document.createElement('th');
    alloc.innerHTML = 'Allocated';
    thead.appendChild(short);
    thead.appendChild(long);
    thead.appendChild(entity);
    thead.appendChild(defaultYN);
    thead.appendChild(tabs);
    thead.appendChild(alloc);
    table.appendChild(thead);
    for (let el of menu) {
      if (id(`${el.entityName}_main`)) {
        console.log('Duplicate row: ', el.entityName);
      } else {
        const tr = document.createElement('tr');
        tr.setAttribute('id', `${el.entityName}_main`);
        const trTab = document.createElement('tr');
        trTab.setAttribute('id', `${el.entityName}_tab`);
        trTab.classList.add('hide');
        const tds = document.createElement('td');
        tds.innerHTML = el.shortdescription;
        const tdl = document.createElement('td');
        tdl.innerHTML = el.longdescription;
        const tde = document.createElement('td');
        tde.innerHTML = el.entityName;
        const tdd = document.createElement('td');
        if (el.defaultYN) {
          tdd.innerHTML = 'Yes';
        } else {
          tdd.innerHTML = 'No';
        }
        const tdt = document.createElement('td');
        const frac = divAtt('div', 'id', `${el.entityName}_frac`);
        const tda = document.createElement('td');
        const label = divAtt('label', 'class', 'checkContainer');
        let selectedMenu = divAtt('input', 'type', 'checkbox');
        selectedMenu = addAtt(selectedMenu, 'id', `id_${el.entityName}`);
        selectedMenu.setAttribute('value', `${el.navigationentityID}`);
        selectedMenu.setAttribute('class', 'menuNavOpt');
        const span = divAtt('span', 'class', 'tick');
        if (el.allocatedYN == 1) {
          selectedMenu = addAtt(selectedMenu, 'checked', 'true');
        }
        label.appendChild(selectedMenu);
        label.appendChild(span);
        tdt.appendChild(frac);
        tda.appendChild(label);
        tr.appendChild(tds);
        tr.appendChild(tdl);
        tr.appendChild(tde);
        tr.appendChild(tdd);
        tr.appendChild(tdt);
        tr.appendChild(tda);
        table.appendChild(tr);
        table.appendChild(trTab);
        navtab.appendChild(table);
        if (!el.tabArray.length) {
          frac.innerHTML = 'N/A';
        } else {
          this.buildTabList(el.tabArray, el.entityName);
        }
      }
    }
    const btndiv = divAtt('div', 'class', 'btnEndGrid inlineTableHeading sectionGap');
    btndiv.style = 'padding: unset; width: unset;';
    let btn = divAtt('button', 'class', 'btn');
    btn = addAtt(btn, 'type', 'button');
    btn = addAtt(btn, 'id', 'f_navigationOptions');
    //btn = addAtt(btn, "onclick", "EUt_navigation.updateNavigationOptions()");
    btn.innerHTML = 'Update Navigation';
    btndiv.appendChild(btn);
    navtab.appendChild(btndiv);
    eListen(
      btn,
      () => {
        EUt_navigation.updateNavigationOptions();
      },
      'click'
    );
  }

  async buildTabList(tabArr, parentEntyName) {
    const tabRow = id(`${parentEntyName}_tab`);
    const tdMain = divAtt('td', 'colspan', '6');
    const tabTable = divAtt('table', 'id', `${parentEntyName}_tabList`);
    const fracBtn = divAtt('input', 'class', 'btn');
    fracBtn.setAttribute('type', 'button');
    //fracBtn.setAttribute("onclick", `toggleHide('${parentEntyName}_tab')`);
    fracBtn.setAttribute('id', `${parentEntyName}_btn`);
    const cntr = {
      tabs: 0,
    };
    let elems = [];
    for (let row of tabArr) {
      const tr = divAtt('tr', 'class', '');
      const tabName = divAtt('td', 'class', '');
      tabName.innerHTML = row.shortdescription;
      const tabCheck = divAtt('td', 'class', '');
      const label = divAtt('label', 'class', 'checkContainer');
      let selectedMenu = divAtt('input', 'type', 'checkbox');
      selectedMenu.setAttribute('value', `${row.navigationentityID}`);
      selectedMenu.setAttribute('class', 'menuNavOpt');
      // selectedMenu.setAttribute(
      //   "onclick",
      //   `EUt_navigation.tabMenu('${parentEntyName}')`
      // );
      elems.push(selectedMenu);
      selectedMenu.classList.add(`${parentEntyName}TabOpt`);

      const span = divAtt('span', 'class', 'tick');
      if (row.allocatedYN == 1) {
        selectedMenu.setAttribute('checked', 'true');
        cntr.tabs++;
      }
      label.appendChild(selectedMenu);
      label.appendChild(span);
      tabCheck.appendChild(label);
      tr.appendChild(tabName);
      tr.appendChild(tabCheck);
      tabTable.appendChild(tr);
    }
    fracBtn.setAttribute('value', `(${cntr.tabs}/${tabArr.length})`);
    id(`${parentEntyName}_frac`).appendChild(fracBtn);
    tdMain.appendChild(tabTable);
    tabRow.appendChild(tdMain);
    eListen(
      fracBtn,
      () => {
        toggleHide(parentEntyName + '_tab');
      },
      'click'
    );
    for (let i = 0; i < elems.length; i++) {
      eListen(
        elems[i],
        () => {
          EUt_navigation.tabMenu(parentEntyName);
        },
        'click'
      );
    }
  }

  static tabMenu(parentName) {
    const parentfrac = id(`${parentName}_btn`);
    const totalRows = id(`${parentName}_tabList`);
    const ckd = [];
    const totalopt = document.querySelectorAll(`.${parentName}TabOpt`);
    totalopt.forEach((opt) => {
      if (opt.checked) {
        ckd.push(opt.value);
      }
    });
    parentfrac.value = `(${ckd.length}/${totalRows.rows.length})`;
  }

  static updateNavigationOptions() {
    const editUserIDUN = id('editUserID');
    const menuOptions = document.querySelectorAll('.menuNavOpt');
    const navOption = [];
    menuOptions.forEach((option) => {
      if (option.checked) {
        navOption.push(parseInt(option.value));
      }
    });

    let vars = new Object();
    vars.menuOptions = navOption.join(',');
    vars.updateUserID = editUserIDUN.value;
    PREP(['updUserMenu'], vars)
      .then((res) => {
        changeTabN('EUt_navigation');
        note(res.data.updUserMenu);
      })
      .catch(console.error());
  }
}

export class EUt_allocateClient {
  constructor(vars) {
    this.name = 'Edit User - Navigation';
    this.pageTier = 20;
    this.reference = 'EUt_navigation';
    this.pageID = null;
    this.data = null;
    this.HclientID = vars.HclientID;
    this.editUserID = vars.editUserID;
    this.detailsUserID = vars.detailsUserID;
  }

  initPage(data) {
    // Set page pecific variables
    this.getAllocatedClients = data.getAllocatedClients;
    this.loadPage();
  }

  loadPage() {
    this.allocClientPage();
  }

  allocClientPage() {
    const data = this.getAllocatedClients;
    const table = document.getElementById('allocClientsTable');
    const thead = document.createElement('thead');
    const thname = document.createElement('th');
    thname.innerHTML = 'Client Name';
    const thdesc = document.createElement('th');
    thdesc.innerHTML = 'Client Description';
    const thalloc = document.createElement('th');
    thalloc.innerHTML = 'Allocated';
    thead.appendChild(thname);
    thead.appendChild(thdesc);
    thead.appendChild(thalloc);
    table.appendChild(thead);
    for (let client of data) {
      const tr = document.createElement('tr');
      const tdName = document.createElement('td');
      tdName.innerHTML = client.clientShortName;
      const tdDesc = document.createElement('td');
      tdDesc.innerHTML = client.clientDescription;
      const tdAlloc = document.createElement('td');
      const check = divAtt('input', 'value', client.HclientID);
      const label = divAtt('label', 'class', 'checkContainer');
      check.setAttribute('type', 'checkbox');
      check.setAttribute('class', 'allocYN');
      const span = divAtt('span', 'class', 'tick');
      check.checked = client.allocatedYN == 1 ? true : false;

      label.appendChild(check);
      label.appendChild(span);
      tdAlloc.appendChild(label);
      tr.appendChild(tdName);
      tr.appendChild(tdDesc);
      tr.appendChild(tdAlloc);
      table.appendChild(tr);
    }
  }

  static updateAllocatedClients() {
    const list = document.querySelectorAll('.allocYN');
    let vars = {};
    let alloc = [];

    list.forEach((ck) => {
      ck.checked && alloc.push(parseInt(ck.value));
    });
    vars.allocatedClients = alloc;
    vars.allocatedUser = id('editUserID').value;

    PREP(['allocateHuserHclient'], vars)
      .then((res) => {
        changeTabN('EUt_allocateClient');
        note(res.data.allocateHuserHclient);
      })
      .catch(console.error());
  }
}

export class EUt_userGroups {
  constructor(vars) {
    this.name = 'Edit User - Navigation';
    this.pageTier = 20;
    this.reference = 'EUt_navigation';
    this.pageID = null;
    this.data = null;
    this.HclientID = vars.HclientID;
    this.editUserID = vars.editUserID;
    this.detailsUserID = vars.detailsUserID;
  }

  initPage(data) {
    // Set page pecific variables
    this.getGroupsPerHuser = cObj(data.getGroupsPerHuser);
    this.getUserGroups = cObj(data.getUserGroups);
    this.getTeams = data.getTeams;
    this.getTeamsPerUser = data.getTeamsPerUser;
    this.loadPage();
  }

  loadPage() {
    this.userGroupsPage();
  }

  userGroupsPage() {
    // GROUPS
    //  editUser.buildGroupsTab(cObj(res.data.getGroupsPerHuser), cObj(res.data.getUserGroups));
    buildDropDownMain(this.getUserGroups, 'groupDD2', 'HUSERGROUPID', 'SHORTNAME');

    const data = this.getGroupsPerHuser;
    const newOpt = divAtt('option', 'value', 'new');
    newOpt.appendChild(document.createTextNode('CREATE NEW ----'));
    id('groupDD2').appendChild(newOpt);
    var list = new Array();
    for (let group of data) {
      var tData = new Object();
      //@steph what switchbox is this? isnt it meant to be `SWITCHBOX`
      var link = divAtt('div', 'onclick', 'switchBox("manageGroups", "HclientID=6&groupID=' + group.HUSERGROUPID + '&groupName=' + group.SHORTNAME + '")');
      link.innerHTML = group.SHORTNAME;
      tData['Group Name'] = link;
      tData['Description'] = group.DESCRIPTION;
      if (group.ACTIVEYN) {
        tData['Group Status'] = 'Active';
      } else {
        tData['Group Status'] = 'Inactive';
      }

      tData['Name'] = group.FNAME + ' ' + group.SNAME;
      tData['HUSERGROUPID'] = group.HUSERGROUPID;
      tData['Group Type'] = group.USERGROUPTYPE;
      tData['Client'] = group.CLIENTNAME;
      list.push(tData);
    }

    if (list.length) {
      rawTable(list, 'groupsPerUser');
      hide('noGroups');
    } else {
      unhide('noGroups');
    }

    // =====================================================================
    //TEAMS
    //  editUser.buildTeamsTab(res.data.getTeamsPerUser, res.data.getTeams)

    buildDropDownMain(this.getTeams, 'teamDD2', 'HteamID', 'teamName');
    const table = id('teamsPerUser');
    const tableData = this.getTeamsPerUser;

    if (tableData.length) {
      const thead = divAtt('thead', 'class', '');
      const th1 = divAtt('th', 'class', '');
      th1.innerHTML = 'ID';
      const th2 = divAtt('th', 'class', '');
      th2.innerHTML = 'Team Name';
      const th3 = divAtt('th', 'class', '');
      th3.innerHTML = 'Allocated By';
      const th4 = divAtt('th', 'class', '');
      th4.innerHTML = 'Allocation Date';
      const th5 = divAtt('th', 'class', '');
      th5.innerHTML = 'Active';
      thead.appendChild(th1);
      thead.appendChild(th2);
      thead.appendChild(th3);
      thead.appendChild(th4);
      thead.appendChild(th5);
      table.appendChild(thead);
      for (let row of tableData) {
        const tr = divAtt('tr', 'class', '');
        const td1 = divAtt('td', 'class', '');
        td1.innerHTML = row.HteamID;
        const td2 = divAtt('td', 'class', '');
        td2.innerHTML = row.teamName;
        const td3 = divAtt('td', 'class', '');
        td3.innerHTML = `${row.allocatedByFname} ${row.allocatedBySname}`;
        const td4 = divAtt('td', 'class', '');
        td4.innerHTML = row.allocatedDate;
        const td5 = divAtt('td', 'class', '');
        const tglDiv = divAtt('div');
        const tglLabel = divAtt('label', 'class', 'switch');
        const tglInp = divAtt('input', 'type', 'checkbox');
        tglInp.setAttribute('id', `HuserHteamID_${row.allocHuserHteamID}`);
        tglInp.checked = row.activeYn ? true : false;
        // tglInp.setAttribute(
        //   'onchange',
        //   `EUt_userGroups.userActiveYN(${row.allocHuserHteamID})`
        // )
        const tglSpan = divAtt('span', 'class', 'toggle round');
        tglLabel.appendChild(tglInp);
        tglLabel.appendChild(tglSpan);
        tglDiv.appendChild(tglLabel);
        td5.appendChild(tglDiv);
        tr.appendChild(td1);
        tr.appendChild(td2);
        tr.appendChild(td3);
        tr.appendChild(td4);
        tr.appendChild(td5);
        table.appendChild(tr);
        eListen(
          `HuserHteamID_${row.allocHuserHteamID}`,
          () => {
            EUt_userGroups.userActiveYN(row.allocHuserHteamID);
          },
          'change'
        );
      }
      hide('noTeams');
    } else {
      unhide('noTeams');
    }
  }

  static async changeSubTab(block) {
    // block active
    const blocks = document.querySelectorAll('.blockItem');
    blocks.forEach((block) => {
      block.classList.remove('blockActive');
      const name = block.id;
      id(`${name}_content`).classList.add('hide');
    });

    id(block).classList.add('blockActive');
    unhide(`${block}_content`);
  }

  static newGroup() {
    if (id('groupDD2').value == 'new') {
      id('addNewGroupForm2').style.display = 'block';
    } else {
      id('addNewGroupForm2').style.display = 'none';
    }
  }

  static addToUserGroup() {
    const vars = {};
    vars.huserGroupID = id('groupDD2').value;
    vars.newHuserGroupName = id('NewGroupName2').value;
    vars.newHuserGroupDescription = id('NewGroupdescription2').value;
    vars.newHuserGroupPrivateYN = id('NewGroupPrivate2').checked;
    vars.usersToAdd = id('editUserID').value;
    vars.HclientID = id('hclientID').value;
    if (vars.huserGroupID == '' || vars.huserGroupID == '-') {
      infoBox('Please select a valid group or create a new group.');
    } else if (vars.huserGroupID == 'new' && vars.newHuserGroupName.trim() == '') {
      infoBox('Please enter a Name for the New User Group');
    } else {
      PREP(['addToUserGroup'], vars)
        .then((res) => {
          note(res.data.addToUserGroup[0].addResults);
          changeTabN('EUt_userGroups');
        })
        .catch(console.error());
    }
  }
  static addTeamMembers() {
    if (id('teamDD2').value == '-') {
      errBox('Please select a team member.');
    } else {
      const vars = {};
      vars.HteamID = id('teamDD2').value;
      vars.targetUserID = id('editUserID').value;
      PREP(['allocateUserToTeam'], vars)
        .then(async (res) => {
          await changeTabN('EUt_userGroups');
          note(res.data.allocateUserToTeam);

          setTimeout(() => {
            EUt_userGroups.changeSubTab('teamsBlock');
          }, 1000);
        })
        .catch(console.error());
    }
  }
  static userActiveYN(allocHuserHteamID) {
    const userHteamID = document.getElementById(`HuserHteamID_${allocHuserHteamID}`);

    const vars = {};
    vars.allocHuserHteamID = allocHuserHteamID;
    vars.activeYN = toggleSliderYN(userHteamID.checked);

    PREP(['toggleTeamMember'], vars)
      .then((res) => {
        note(res.data.toggleTeamMember);
      })
      .catch(console.error());
  }
}

export class EUt_userAssessments {
  constructor(vars) {
    this.name = 'Edit User -User Assessments';
    this.pageTier = 20;
    this.reference = 'EUt_userAssessments';
    this.pageID = null;
    this.data = null;
    this.HclientID = vars.HclientID;
    this.editUserID = vars.participantID;
    this.participantID = vars.participantID;
  }

  initPage(data) {
    // Set page pecific variables
    this.getParticipantReview = data.getParticipantReview[0];
    this.loadPage();
  }

  loadPage() {
    this.assessmentPage();
  }

  async assessmentPage() {
    this.rateeProfile();

    const asRatee = this.getParticipantReview.asrateeArray;
    const asRater = this.getParticipantReview.asraterArray;

    id('asrateeArray').innerHTML = '';
    let cntr = 1;
    for (let row of asRatee) {
      const listBoxRatee = await this.listBoxRatee(row, cntr);
      id('asrateeArray').appendChild(listBoxRatee);
      eListen(
        `${row.allocHuserHassessmentID}`,
        () => {
          EUt_userAssessments.toggleActive(`${row.allocHuserHassessmentID}`);
        },
        'change'
      );
      let arrowid = 'arrowDD_' + cntr; //`arrowDD_${cntr}`
      let formid = 'form_' + cntr; //`form_${cntr}`
      let borderid = 'border_' + cntr; //`border_${cntr}`
      // row.allocationActiveYN ? id(`${row.allocHuserHassessmentID}`).checked = true : id(`${row.allocHuserHassessmentID}`).checked = false;
      eListen(
        `border_${cntr}`,
        () => {
          MAt_consent.expandForm(arrowid, formid, borderid);
        },
        'click'
      );
      eListen(
        `raterBtn_${row.allocHuserHassessmentID}`,
        () => {
          EUt_userAssessments.getratees(row.allocHuserHassessmentID);
        },
        'click'
      );
      cntr++;
    }
    id('asRaterArray').innerHTML = '';

    for (let row of asRater) {
      var listBoxRater = await this.listBoxRater(row, cntr);
      id('asRaterArray').appendChild(listBoxRater);
      eListen(
        `${row.allocHuserHassessmentID}`,
        () => {
          EUt_userAssessments.toggleActive(`${row.allocHuserHassessmentID}`);
        },
        'change'
      );
      let arrowid = 'arrowDD_' + cntr; //`arrowDD_${cntr}`
      let formid = 'form_' + cntr; //`form_${cntr}`
      let borderid = 'border_' + cntr; //`border_${cntr}`
      eListen(
        `border_${cntr}`,
        () => {
          MAt_consent.expandForm(arrowid, formid, borderid);
        },
        'click'
      );
      cntr++;
    }
  }

  rateeProfile() {
    const profile = this.getParticipantReview.profileArray[0];
    // id('rateeImage').src = '';
    id('c_name').innerHTML = `${profile.fname} ${profile.sname}`;
    id('addedDate').innerHTML = dateFromDateTime(profile.addedDate);
    id('addedBy').innerHTML = `${profile.addedByFname} ${profile.addedBySname}`;
    id('clientName').innerHTML = profile.clientName;
    id('employeeID').innerHTML = profile.employeeID;
    id('jobtitle').innerHTML = profile.jobtitle;
    id('username').innerHTML = profile.username;
    id('emailaddress').innerHTML = profile.emailaddress;
    id('mobilenumber').innerHTML = profile.mobilenumber;
    id('roleDesc').innerHTML = profile.roleDesc;
    id('rateeActiveYN').innerHTML = profile.activeYN ? 'Yes' : 'No';
    id('loginCount').innerHTML = profile.loginCount;
    id('changeHsitoryCount').innerHTML = profile.changeHsitoryCount;

    id('loginDate').innerHTML = profile.getLastLoginDate ? dateFromDateTime(profile.getLastLoginDate) : '';
    id('profileDate').innerHTML = profile.getLastProfileUpdateDate ? dateFromDateTime(profile.getLastProfileUpdateDate) : '';
    id('lockoutDate').innerHTML = profile.getLastLockedOutDate ? dateFromDateTime(profile.getLastLockedOutDate) : '';
  }

  listBoxRatee(row, cntr) {
    const formContainer = divAtt('div', 'class', 'formContainer');

    const consentName = divAtt('div', 'class', 'consentName');
    consentName.setAttribute('id', `border_${cntr}`);
    consentName.innerHTML = `<svg id="arrowDD_${cntr}" class="arrowDD"  width="9.05" height="14.62"
            viewBox="0 0 9.05 14.62">
            <path
                d="M11.58,6.49,6,.8a1.62,1.62,0,0,0-.8-.57l-.06,0a1,1,0,0,0-.59,0,2.56,2.56,0,0,0-1.25,1A1.29,1.29,0,0,0,3.42,3c.93.94,1.86,1.86,2.79,2.78L8,7.47,3.42,12l-.14.15a1.34,1.34,0,0,0,0,1.67,3.59,3.59,0,0,0,.47.48l.11.11a1.31,1.31,0,0,0,.89.34,1.26,1.26,0,0,0,1-.42l5.9-5.9A1.41,1.41,0,0,0,12,7.9,1.33,1.33,0,0,0,11.58,6.49Z"
                transform="translate(-2.98 -0.17)" /></svg>`;
    // consentName.setAttribute(
    //   "onclick",
    //   `MAt_consent.expandForm('arrowDD_${cntr}', 'form_${cntr}', 'border_${cntr}')`
    // );
    const h5 = divAtt('h5');
    h5.innerHTML = `${row.Assessment} - ${dateFromDateTime(row.allocatedDate)} - ${row.assessmentStatus}`;
    consentName.appendChild(h5);

    const textContainer = divAtt('div', 'class', 'textContainer hide');
    textContainer.setAttribute('id', `form_${cntr}`);

    // Build info here ==
    const info = divAtt('div', 'class', 'detailInfo');

    const activeLabel = divAtt('p');
    activeLabel.innerHTML = 'Active:';
    //@mike
    const active = createToggle(row.allocHuserHassessmentID, row.allocHuserHassessmentID, row.allocationActiveYN, `EUt_userAssessments.toggleActive(${row.allocHuserHassessmentID})`);
    info.appendChild(activeLabel);
    info.appendChild(active);
    //============
    const statusLabel = divAtt('p');
    statusLabel.innerHTML = 'Status:';
    const status = divAtt('p', 'style', 'font-weight: bold;');
    status.innerHTML = row.assessmentStatus;
    info.appendChild(statusLabel);
    info.appendChild(status);
    //============
    const relLabel = divAtt('p');
    relLabel.innerHTML = 'Relationship:';
    const rel = divAtt('p', 'style', 'font-weight: bold;');
    rel.innerHTML = row.Relationship;
    info.appendChild(relLabel);
    info.appendChild(rel);
    //============
    const startLabel = divAtt('p');
    startLabel.innerHTML = 'Can start assessment:';
    const start = divAtt('p', 'style', 'font-weight: bold;');
    start.innerHTML = row.canStartAssessment ? 'Yes' : 'No';
    info.appendChild(startLabel);
    info.appendChild(start);
    //============
    const allocLabel = divAtt('p');
    allocLabel.innerHTML = 'Allocation active:';
    const alloc = divAtt('p', 'style', 'font-weight: bold;');
    alloc.innerHTML = row.allocationActiveYN ? 'Active' : 'Not active';
    info.appendChild(allocLabel);
    info.appendChild(alloc);
    //============
    const thisIsSelfLabel = divAtt('p');
    thisIsSelfLabel.innerHTML = 'This Is Self:';
    const thisIsSelf = divAtt('p', 'style', 'font-weight: bold;');
    thisIsSelf.innerHTML = row.thisIsSelf ? 'Yes' : 'No';
    info.appendChild(thisIsSelfLabel);
    info.appendChild(thisIsSelf);
    //============
    const selfRateLabel = divAtt('p');
    selfRateLabel.innerHTML = 'Self rate:';
    const selfRate = divAtt('p', 'style', 'font-weight: bold;');
    selfRate.innerHTML = row.selfRateYN ? 'Yes' : 'No';
    info.appendChild(selfRateLabel);
    info.appendChild(selfRate);
    //============
    const raterCntLabel = divAtt('p');
    raterCntLabel.innerHTML = 'Rater Count:';
    const raterCnt = divAtt('p', 'style', 'font-weight: bold;');
    raterCnt.innerHTML = row.raterCnt;
    info.appendChild(raterCntLabel);
    info.appendChild(raterCnt);
    //============
    const addRatersLabel = divAtt('p');
    addRatersLabel.innerHTML = 'Can add Raters:';
    const addRaters = divAtt('p', 'style', 'font-weight: bold;');
    addRaters.innerHTML = row.addRatersYN ? 'Yes' : 'No';
    info.appendChild(addRatersLabel);
    info.appendChild(addRaters);
    //============
    const nomsApprLabel = divAtt('p');
    nomsApprLabel.innerHTML = 'Nominations Approved:';
    const nomsAppr = divAtt('p', 'style', 'font-weight: bold;');
    nomsAppr.innerHTML = row.nominationsApproved ? 'Yes' : 'No';
    info.appendChild(nomsApprLabel);
    info.appendChild(nomsAppr);
    //============
    const archivedLabel = divAtt('p');
    archivedLabel.innerHTML = 'Archived:';
    const archived = divAtt('p', 'style', 'font-weight: bold;');
    archived.innerHTML = row.archivedYN ? 'Yes' : 'No';
    info.appendChild(archivedLabel);
    info.appendChild(archived);
    //============
    const minRatersLabel = divAtt('p');
    minRatersLabel.innerHTML = 'Minimum raters:';
    const minRaters = divAtt('p', 'style', 'font-weight: bold;');
    minRaters.innerHTML = row.minimumRaters;
    info.appendChild(minRatersLabel);
    info.appendChild(minRaters);
    //============
    const approversLabel = divAtt('p');
    approversLabel.innerHTML = 'Minimum raters:';
    const approvers = divAtt('div', 'style', 'font-weight: bold;');
    if (row.approversArray.length) {
      const list = divAtt('ul');
      for (let element of row.approversArray) {
        const item = divAtt('li');
        item.innerHTML = element.approverComboName;
        list.appendChild(item);
      }
      approvers.appendChild(list);
    } else {
      approvers.innerHTML = 'None';
    }
    info.appendChild(approversLabel);
    info.appendChild(approvers);
    //============
    if (row.relrulesArray) {
      for (const type of row.relrulesArray) {
        const raterDesLabel = divAtt('p');
        raterDesLabel.innerHTML = 'Minimum raters:';
        const minMaxRaters = divAtt('p', 'style', 'font-weight: bold;');
        minMaxRaters.innerHTML = `Min: ${type.qtyMin} <br> Max: ${type.qtyMax}`;
        info.appendChild(raterDesLabel);
        info.appendChild(minMaxRaters);
      }
    }
    //============
    const btnDiv = divAtt('div', 'class', 'btnEndGrid marginRight');
    const btnR = divAtt('button', 'class', 'btn');
    btnR.setAttribute('id', `raterBtn_${row.allocHuserHassessmentID}`);
    btnR.innerHTML = 'View Raters';
    // btnR.setAttribute(
    //   "onclick",
    //   `EUt_userAssessments.getratees('${row.allocHuserHassessmentID}')`
    // );
    btnDiv.appendChild(btnR);
    info.appendChild(btnDiv);

    //@mike
    const raterListDiv = divAtt('div', 'id', `listBox_${row.allocHuserHassessmentID}`);
    raterListDiv.setAttribute('class', 'gridSpan');
    info.appendChild(raterListDiv);
    //============

    textContainer.appendChild(info);
    formContainer.appendChild(consentName);
    formContainer.appendChild(textContainer);

    //============

    return formContainer;
  }

  listBoxRater(row, cntr) {
    const formContainer = divAtt('div', 'class', 'formContainer');

    const consentName = divAtt('div', 'class', 'consentName');
    consentName.setAttribute('id', `border_${cntr}`);
    consentName.innerHTML = `<svg id="arrowDD_${cntr}" class="arrowDD"  width="9.05" height="14.62"
            viewBox="0 0 9.05 14.62">
            <path
                d="M11.58,6.49,6,.8a1.62,1.62,0,0,0-.8-.57l-.06,0a1,1,0,0,0-.59,0,2.56,2.56,0,0,0-1.25,1A1.29,1.29,0,0,0,3.42,3c.93.94,1.86,1.86,2.79,2.78L8,7.47,3.42,12l-.14.15a1.34,1.34,0,0,0,0,1.67,3.59,3.59,0,0,0,.47.48l.11.11a1.31,1.31,0,0,0,.89.34,1.26,1.26,0,0,0,1-.42l5.9-5.9A1.41,1.41,0,0,0,12,7.9,1.33,1.33,0,0,0,11.58,6.49Z"
                transform="translate(-2.98 -0.17)" /></svg>`;
    // consentName.setAttribute(
    //   "onclick",
    //   `MAt_consent.expandForm('arrowDD_${cntr}', 'form_${cntr}', 'border_${cntr}')`
    // );
    const h5 = divAtt('h5');
    h5.innerHTML = `${row.Assessment} - ${dateFromDateTime(row.nominatedDate)} - ${row.assessmentStatus}`;
    consentName.appendChild(h5);

    const textContainer = divAtt('div', 'class', 'textContainer hide');
    textContainer.setAttribute('id', `form_${cntr}`);

    // Build info here ==
    const info = divAtt('div', 'class', 'detailInfo');

    const activeLabel = divAtt('p');
    activeLabel.innerHTML = 'Active:';
    //@mike
    const active = createToggle(`${row.allocHuserHassessmentID}`, row.allocHuserHassessmentID, row.allocationActiveYN, `EUt_userAssessments.toggleActive(this.id)`);
    info.appendChild(activeLabel);
    info.appendChild(active);
    //============ \\
    const statusLabel = divAtt('p');
    statusLabel.innerHTML = 'Status:';
    const status = divAtt('p', 'style', 'font-weight: bold;');
    status.innerHTML = row.assessmentStatus;
    info.appendChild(statusLabel);
    info.appendChild(status);
    //============
    const rateeLabel = divAtt('p');
    rateeLabel.innerHTML = 'Ratee:';
    const ratee = divAtt('p', 'style', 'font-weight: bold;');
    ratee.innerHTML = row.rateeComboName;
    info.appendChild(rateeLabel);
    info.appendChild(ratee);
    //============
    const relLabel = divAtt('p');
    relLabel.innerHTML = 'Relationship:';
    const rel = divAtt('p', 'style', 'font-weight: bold;');
    rel.innerHTML = row.Relationship;
    info.appendChild(relLabel);
    info.appendChild(rel);
    //============
    const allocLabel = divAtt('p');
    allocLabel.innerHTML = 'Allocation active:';
    const alloc = divAtt('p', 'style', 'font-weight: bold;');
    alloc.innerHTML = row.allocationActiveYN ? 'Active' : 'Not active';
    info.appendChild(allocLabel);
    info.appendChild(alloc);
    //============
    const nomsApprLabel = divAtt('p');
    nomsApprLabel.innerHTML = 'Nominations Approved:';
    const nomsAppr = divAtt('p', 'style', 'font-weight: bold;');
    nomsAppr.innerHTML = row.nominationsApproved ? 'Yes' : 'No';
    info.appendChild(nomsApprLabel);
    info.appendChild(nomsAppr);
    //============
    const startLabel = divAtt('p');
    startLabel.innerHTML = 'Can start assessment:';
    const start = divAtt('p', 'style', 'font-weight: bold;');
    start.innerHTML = row.canStartAssessment ? 'Yes' : 'No';
    info.appendChild(startLabel);
    info.appendChild(start);
    //============

    textContainer.appendChild(info);
    formContainer.appendChild(consentName);
    formContainer.appendChild(textContainer);
    return formContainer;
  }

  static expandForm(arrowID, formID, border) {
    id(formID).classList.toggle('hide');
    id(arrowID).classList.toggle('arrowDown');
    id(border).classList.toggle('borderR');
  }

  static toggleActive(element) {
    const vars = {};
    vars.allocHuserHassessmentID = element;
    console.log({
      'id(element)': id(element),
      'id(element).checked': id(element).checked,
    });
    vars.activeYN = id(element).checked ? 1 : 0;

    PREP(['toggleAssessmentActiveToUser'], vars)
      .then((res) => {
        note(res.data.toggleAssessmentActiveToUser);
      })
      .catch(console.error());
  }

  static getratees(elID) {
    PREP(['getRaters'], {
      allocHuserHassessmentID: elID,
    })
      .then((res) => {
        const raters = cObj(res.data.getRaters);
        const list = [];
        for (let row of raters) {
          const obj = {};
          obj.Date = dateFromDateTime(row.DATEON);
          obj['Profile Image'] = EUt_userAssessments.createImageNode(row.PROFILEIMAGE);
          obj.Name = row.COMBONAME;
          obj['Email Address'] = row.EMAILADDRESS;
          obj.Relationship = row.RELATIONSHIP;
          obj.Status = row.ASSESSMENTSTATUS;
          list.push(obj);
        }
        const table = EUt_userAssessments.createRatersTable(list, elID);
        if (id('raters_' + elID)) {
          const remove = id('raters_' + elID);
          remove.parentNode.removeChild(remove);
        }
        id(`listBox_${elID}`).appendChild(table);

        id(`raterBtn_${elID}`).setAttribute('onclick', `EUt_userAssessments.tgglHideRatersList(${elID})`);
      })
      .catch(console.error());
  }

  static tgglHideRatersList(elID) {
    id(`listBox_${elID}`).classList.toggle('hide');
  }

  static createImageNode(imageURL) {
    const div = divAtt('div', 'class', 'imageContainer');

    const url = imageURL ? imageURL : imgPlaceholderURL; //@steph
    let img = divAtt('img', 'src', url);
    img = addAtt(img, 'class', 'tableImage');
    img = addAtt(img, 'onload', ''); //OnImageLoad(event, 50)
    img = addAtt(img, 'width', '50');
    img = addAtt(img, 'height', '50');
    img = addAtt(img, 'style', 'left: 0px; top: -5px;');
    div.appendChild(img);
    return div;
  }

  static createRatersTable(raters, elID) {
    var table = divAtt('table', 'id', 'raters_' + elID);
    var thead = document.createElement('thead');
    //create Headers
    for (const key in raters[0]) {
      var th = document.createElement('th');
      th.innerHTML = key;
      thead.appendChild(th);
    }
    table.appendChild(thead);
    //create rows
    for (let row of raters) {
      var tr = document.createElement('tr');
      for (let key in row) {
        var td = document.createElement('td');
        if (typeof row[key] === 'string') {
          td.innerHTML = row[key];
        } else {
          td.appendChild(row[key]);
        }

        tr.appendChild(td);
      }
      table.appendChild(tr);
    }
    return table;
  }
}

export class EUt_reports {
  constructor(vars) {
    this.name = 'Edit Application - Reports';
    this.pageTier = 20;
    this.reference = 'EUt_reports';
    this.pageID = null;
    this.data = null;
    this.HclientID = null;
    this.TargetUser = vars.TargetUser;
  }

  initPage(data) {
    // Set page pecific variables
    this.getReportTypesForUserUpload = data.getReportTypesForUserUpload;
    this.getReportsAllocatedToUser = cObj(data.getReportsAllocatedToUser);
    this.loadPage();
  }

  loadPage() {
    this.reportsPage();
    this.dynamicEvents();
  }

  dynamicEvents() {
    const reports = this.getReportsAllocatedToUser;
    if (reports.length) {
      for (let el of reports) {
        const btns = id(`docID_${el.REPORTREGISTERID}`).getElementsByClassName('btn');
        const viewBtn = btns[0];
        const remBtn = btns[1];
        const histBtn = btns[2];

        if (el.ENCRYPTYN) {
          eListen(
            viewBtn,
            () => {
              report.encryptedReport(`${el.REPORTREGISTERID}`, `${el.ORIGINALFILE}`);
            },
            'click'
          );
        } else {
          eListen(
            viewBtn,
            () => {
              report.download(`${el.REPORTREGISTERID}`);
            },
            'click'
          );
        }
        eListen(
          remBtn,
          () => {
            report.removeReason(`${el.REPORTREGISTERID}`);
          },
          'click'
        );
        eListen(
          histBtn,
          () => {
            report.reportHistory(`${el.REPORTREGISTERID}`, `${el.ORIGINALFILE}`);
          },
          'click'
        );
      }
    }
  }

  reportsPage() {
    buildDropDownMain(this.getReportTypesForUserUpload, 'reportType', 'HreportTypeID', 'shortname', 'captureHTML');
    const ulpoadResultsCheck = id('ulpoadResultsCheck');
    const uploadReportCheck = id('uploadReportCheck');
    uploadReportCheck.checked = true;

    eListen(
      'reportType',
      () => {
        const selValue = id('reportType').value;
        for (let report of this.getReportTypesForUserUpload) {
          if (report.HreportTypeID == selValue) {
            if (report.captureHTML) {
              insertDiv(report.captureHTML, 'uploadResultsDiv');
              unhide('uploadResultsDiv');
              unhide('assResultDateDiv');
              unhide('resultsCheck');
              ulpoadResultsCheck.checked = true;
              hide('uploadReportBtn');

              ulpoadResultsCheck.addEventListener('change', () => {
                if (!ulpoadResultsCheck.checked) {
                  hide('uploadResultsDiv');
                  unhide('uploadReportBtn');
                } else {
                  ulpoadResultsCheck.checked = true;
                  unhide('uploadResultsDiv');
                  hide('uploadReportBtn');
                }
              });
            } else {
              id('uploadResultsDiv').innerHTML = '';
              hide('uploadResultsDiv');
              hide('assResultDateDiv');
              hide('resultsCheck');
              unhide('uploadReportBtn');
            }
          }
        }
      },
      'change'
    );

    // ===========

    const getReportsAllocatedToUser = this.getReportsAllocatedToUser;

    // ====List Docs====
    if (getReportsAllocatedToUser.length) {
      const docBody = id('docBody');
      docBody.innerHTML = '';

      for (let el of getReportsAllocatedToUser) {
        const profRow = divAtt('tr', 'class', 'doc');
        profRow.setAttribute('id', `docID_${el.REPORTREGISTERID}`);
        const dateAdded = divAtt('td', 'class', '');
        dateAdded.innerHTML = `${el.DATEON}`;
        const addedBy = divAtt('td', 'class', '');
        addedBy.innerHTML = `${el.FNAME} ${el.SNAME}`;
        const reportType = divAtt('td', 'class', '');
        reportType.innerHTML = `${el.REPORTTYPE}`;
        const fileName = divAtt('td', 'class', '');
        fileName.innerHTML = `${el.ORIGINALFILE}`;

        const encryptInd = divAtt('td', 'class', '');
        if (el.ENCRYPTYN) {
          const encryptIcon = divAtt('div', 'class', 'iconTable');
          encryptIcon.innerHTML = keyEncrypt;
          encryptInd.appendChild(encryptIcon);
        }

        const history = divAtt('td');
        const histBtn = divAtt('div', 'class', 'btn');
        histBtn.innerHTML = 'History';
        // histBtn.setAttribute(
        //   "onclick",
        //   `report.reportHistory('${el.REPORTREGISTERID}', '${el.ORIGINALFILE}')`
        // );
        history.appendChild(histBtn);

        const download = divAtt('td', 'class', 'row');
        download.style = 'max-width: unset; justify-content: center;';

        // button 1
        const spanbutton = divAtt('span', 'class', 'reporturl');
        const btn = divAtt('div', 'class', 'btn');
        btn.innerHTML = 'View';
        // if (el.ENCRYPTYN) {
        //   btn.setAttribute(
        //     "onclick",
        //     `report.encryptedReport('${el.REPORTREGISTERID}', '${el.ORIGINALFILE}')`
        //   );
        // } else {
        //   // btn.setAttribute('onclick', `report.encryptedReport('${el.REPORTREGISTERID}', '${el.ORIGINALFILE}')`);
        //   btn.setAttribute(
        //     "onclick",
        //     "report.download(" + el.REPORTREGISTERID + ")"
        //   );
        // }
        spanbutton.appendChild(btn);

        //button 2
        const spanbutton2 = divAtt('span', 'class', 'reporturl');
        spanbutton2.style = 'margin-left: 1rem;';
        const btn2 = divAtt('div', 'class', 'btn');
        btn2.innerHTML = 'Remove';
        //@mike
        // btn2.setAttribute(
        //   "onclick",
        //   "report.removeReason(" + el.REPORTREGISTERID + ")"
        // );
        spanbutton2.appendChild(btn2);
        !el.REMOVEYN && spanbutton2.classList.add('hide');
        download.appendChild(spanbutton);
        download.appendChild(spanbutton2);

        profRow.appendChild(dateAdded);
        profRow.appendChild(addedBy);
        profRow.appendChild(reportType);
        profRow.appendChild(fileName);
        profRow.appendChild(encryptInd);
        profRow.appendChild(download);
        profRow.appendChild(history);
        docBody.appendChild(profRow);
      }
      unhide('docTable');
      unhide('docHR');
    } else {
      hide('docTable');
      hide('docHR');
    }
  }

  static fileSelected() {
    const iMaxFilesize = 250000; // 1MB
    const oFile = id('reportFile').files[0];

    if (oFile.type !== 'application/pdf') {
      id('reportFile').value = '';
      infoBox('Invalid: Please select a *.pdf file format.');
      hide('fileDisplay');
      hide('uploadBtnContainer');
    } else {
      id('fileNameDisplay').innerHTML = oFile.name;
      unhide('fileDisplay');
      hide('uploadBtnContainer');

      if (oFile.size <= iMaxFilesize) {
        const oReader = new FileReader();
        oReader.readAsDataURL(oFile);
      }
    }
  }

  static rmvFile() {
    id('reportFile').value = '';
    unhide('uploadBtnContainer');
    hide('fileDisplay');
  }

  static uploadReport() {
    if (id('reportFile').files[0] === undefined) {
      infoBox('Please select a File to Upload');
    } else if (id('reportType').value === '-') {
      infoBox('Please select a report type from the dropdown.');
    } else {
      const vars = {};
      vars.participantID = id('editUserID').value;
      vars.comments = id('reportComments').value;
      vars.reportFile = id('reportFile').files[0];
      vars.reportTypeID = id('reportType').value;
      vars.HapplicationID = id('HapplicationID') ? id('HapplicationID').value : 0;
      vars.attachmentToParticipantYN = toggleSliderYN(id('attachFile').checked);

      PREP(['uploadReport'], vars)
        .then((res) => {
          note(res.data.uploadReport);
          changeTabN('EUt_reports');
        })
        .catch(console.error());
    }
  }
}
//here
export class EUt_results {
  constructor(vars) {
    this.name = 'Edit Application - Reports';
    this.pageTier = 20;
    this.reference = 'EUt_results';
    this.pageID = null;
    this.data = null;
    this.HclientID = vars.HclientID;
    this.editUserID = vars.editUserID;
    this.TargetUser = vars.TargetUser;
  }

  initPage(data) {
    // Set page pecific variables
    this.getAllocAssForCompletionEvents = cObj(data.getAllocatedAssessmentsForCompletionEvents);
    this.loadPage();
  }

  loadPage() {
    this.resultsPage();
  }

  resultsPage() {
    buildDropDownMain(this.getAllocAssForCompletionEvents, 'assessmentSelect', 'ALLOCHUSERHASSESSMENTID', 'ASSESSMENT');
  }

  static assDD(elId) {
    const assDD = id(elId).value;

    if (assDD === '-' || !assDD) {
      hide('uploadResults');
      hide('uploadReportIDP');
      hide('autoCreateCheckBox');
    } else {
      unhide('uploadResults');
    }
  }

  static fileSelected(inputID) {
    const oFile = id(inputID).files[0];
    hide(`${inputID}_BtnContainer`);
    id(`${inputID}_Name`).innerHTML = oFile.name;
    unhide(`${inputID}_Display`);
    unhide(`${inputID}_BtnDiv`);
  }

  static rmvFile(inputID) {
    id(inputID).value = '';
    unhide(`${inputID}_BtnContainer`);
    hide(`${inputID}_Display`);
    hide(`${inputID}_BtnDiv`);
  }

  static uploadResults() {
    const resultsFile = id('scoresFile').files[0];
    const participantID = id('editUserID').value;
    const allocHuserhassessmentID = id('assessmentSelect');

    if (allocHuserhassessmentID.value == '-') {
      infoBox('Please choose an asssessment');
    } else if (resultsFile == undefined) {
      infoBox('Please choose a file to upload');
    } else {
      const vars = {};
      vars.allocHuserhassessmentID = allocHuserhassessmentID.value;
      vars.resultsFile = resultsFile;
      vars.participantID = participantID;
      PREP(['uploadAssessmentResults'], vars)
        .then(() => {
          allocHuserhassessmentID.setAttribute('disabled', '');
          unhide('uploadReportIDP');
          hide('scoresFile_BtnDiv');
          hide('scoresFile_X');
        })
        .catch(console.error());
    }
  }

  static uploadReportIDP() {
    const scoresFile = id('reportFile').files[0];
    const participantID = id('editUserID').value;
    const comments = id('reportCommentsIDP');
    const allocHuserhassessmentID = id('assessmentSelect');

    const aHIDPTemplateID = id('HIDPTemplateID');
    const aHassessmentID = id('HassessmentID');

    const HapplicationID = 0;
    const reportTypeID = 15;
    const vars = {};
    vars.scoresFile = scoresFile;
    vars.participantID = participantID;
    vars.comments = comments.value;
    vars.HapplicationID = HapplicationID;
    vars.reportTypeID = reportTypeID;
    vars.allocHuserhassessmentID = allocHuserhassessmentID.value;
    PREP(['uploadReport'], vars)
      .then((res) => {
        note(res.data.uploadReport);
        comments.setAttribute('disabled', '');
        hide('reportFile_BtnDiv');
        PREP(['checkForAssessmentCompleteEvents'], vars).then((res1) => {
          const data1 = res1.data.checkForAssessmentCompleteEvents[0];
          aHIDPTemplateID.value = data1.HIDPTemplateID;
          aHassessmentID.value = data1.HassessmentID;

          if (data1.linkEfeedbackYN == 1 && data1.generateIDPYN == 1) {
            unhide('autoCreateCheckBox');
            unhide('autoIDP');
            unhide('autoEFeedback');
          } else if (data1.generateIDPYN == 1) {
            unhide('autoCreateCheckBox');
            unhide('autoIDP');
          } else if (data1.linkEfeedbackYN == 1) {
            unhide('autoCreateCheckBox');
            unhide('autoEFeedback');
          } else {
            changeTabN('EUt_results');
          }
        });
      })
      .catch(console.error());
  }

  static autoCreate() {
    const autoIDP = id('autoIDPCheck');
    const autoEFeedback = id('autoEFeedbackCheck');
    const targetUserID = id('editUserID');
    const aHIDPTemplateID = id('HIDPTemplateID');
    const aHassessmentID = id('HassessmentID');
    const vars = {};
    vars.targetUserID = targetUserID.value;
    vars.HIDPTemplateID = aHIDPTemplateID.value;
    vars.HassessmentID = aHassessmentID.value;
    vars.allocateUser = targetUserID.value;
    vars.allocateAction = 'uponCompleteAssessment';
    if (autoEFeedback.checked && autoIDP.checked) {
      PREP(['generateIDPFromTemplate', 'allocateCourseByAssessmentAction'], vars).then((res) => {
        note(`${res.data.generateIDPFromTemplate} ${res.data.allocateCourseByAssessmentAction}`);
        changeTabN('EUt_results');
      });
    } else if (autoEFeedback.checked) {
      PREP(['allocateCourseByAssessmentAction'], vars).then((res) => {
        note(res.data.allocateCourseByAssessmentAction);
        changeTabN('EUt_results');
      });
    } else if (autoIDP.checked) {
      PREP(['generateIDPFromTemplate'], vars).then((res) => {
        note(res.data.generateIDPFromTemplate);
        changeTabN('EUt_results');
      });
    } else {
      note('Results successfully loaded');
      changeTabN('EUt_results');
    }
  }
}

export class EUt_developmentPlan {
  constructor(vars) {
    this.name = 'Edit Application - Development Plan';
    this.pageTier = 20;
    this.reference = 'EUt_developmentPlan';
    this.pageID = null;
    this.data = null;
    this.editUserID = vars.candidateID;
  }

  initPage(data) {
    console.log('data', data);
    //Edit Tab
    this.getDDassessmentType = cObj(data.getDDassessmentType);

    this.loadPage();
  }

  loadPage() {
    this.devPage();
  }

  devPage() {
    buildDropDownMain(this.getDDassessmentType, 'getDDAssessmentType', 'DDASSESSMENTTYPEID', 'SHORTNAME');
  }

  static listIDPTab() {
    const vars = {};
    vars.candidateID = pgstr.EUt_developmentPlan.editUserID;
    PREP(['listAllocHuserIDPAssets'], vars)
      .then((res) => {
        const data = res.data.listAllocHuserIDPAssets;

        const devPlanCurr = id('devPlanCurr');
        devPlanCurr.innerHTML = '';
        for (let arr of data) {
          if (arr.assetArray.length) {
            const groupDiv = divAtt('div', 'class', 'groupDiv');
            groupDiv.style = 'margin-bottom: 2rem;';
            const assetLabel = divAtt('h6');
            assetLabel.innerHTML = arr.shortname;
            groupDiv.appendChild(assetLabel);
            let dataSet = arr.assetArray;
            let elems = [];
            for (let item of dataSet) {
              const assetDiv = divAtt('div', 'id', `asset_${item.allocHuserIDPAssetID}`);
              assetDiv.classList.add('row');
              assetDiv.classList.add('assetDiv');
              assetDiv.style = 'margin-bottom: 0.5rem;';
              let delImg = divAtt('img', 'class', 'iconSize');
              delImg.src = trashCanIcon;
              delImg.style = `margin-right: 10px; cursor: pointer;`;
              elems.push([delImg, item.allocHuserIDPAssetID]);
              // delImg.setAttribute(
              //   "onclick",
              //   `EUt_developmentPlan.removeIDP(${item.allocHuserIDPAssetID})`
              // );
              delImg.classList.add('removeBtnIDP');
              const assets = divAtt('p', 'class', 'assetIDP');
              assets.innerHTML = item.shortName;
              assetDiv.appendChild(delImg);
              assetDiv.appendChild(assets);
              groupDiv.appendChild(assetDiv);
            }
            devPlanCurr.appendChild(groupDiv);
            for (let i = 0; i < elems.length; i++) {
              eListen(
                elems[i][0],
                () => {
                  EUt_developmentPlan.removeIDP(elems[i][1]);
                },
                'click'
              );
            }
          }
        }
      })
      .catch(console.error());
  }

  static async changeSubTab(block) {
    // block active
    const blocks = document.querySelectorAll('.blockItem');
    blocks.forEach((block) => {
      block.classList.remove('blockActive');
      const name = block.id;
      id(`${name}_content`).classList.add('hide');
    });

    id(block).classList.add('blockActive');
    unhide(`${block}_content`);

    if (block === 'editUserIDPView') {
      EUt_developmentPlan.listIDPTab();
    }
  }

  static assFrameworkDD() {
    const assTypeDD = id('getDDAssessmentType').value;
    if (!assTypeDD || assTypeDD === '-') {
      hide('getDDAssessmentFrameworkForm');
      hide('getDDCategoryForm');
      hide('searchSpace');
      hide('allocationTableAdd');
    } else {
      const vars = {};
      vars.DDassessmentTypeID = assTypeDD;

      PREP(['getDDAssessmentFramework'], vars)
        .then((res) => {
          buildDropDownMain(cObj(res.data.getDDAssessmentFramework), 'getDDAssessmentFramework', 'CATEGORYGROUP', 'CATEGORYGROUP');
          unhide('getDDAssessmentFrameworkForm');
        })
        .catch(console.error());
    }
  }

  static catFormDD() {
    const frameworkDD = id('getDDAssessmentFramework').value;
    if (!frameworkDD || frameworkDD === '-') {
      hide('getDDCategoryForm');
      hide('searchSpace');
      hide('allocationTableAdd');
    } else {
      const vars = {};
      vars.categoryGroup = frameworkDD;

      PREP(['getDDCategory'], vars)
        .then((res) => {
          buildDropDownMain(cObj(res.data.getDDCategory), 'getDDCategory', 'DDCATEGORYID', 'DISPLAYNAME');
          unhide('getDDCategoryForm');
        })
        .catch(console.error());
    }
  }

  static libAssetMeasure() {
    const measureDD = id('getDDCategory').value;
    if (!measureDD || measureDD === '-') {
      hide('searchSpace');
      hide('allocationTableAdd');
    } else {
      const vars = {};
      vars.DDcategoryID = measureDD;

      PREP(['getLibAssetsPerMeasure'], vars)
        .then((res) => {
          EUt_developmentPlan.buildallocationTable(res.data.getLibAssetsPerMeasure);
        })
        .catch(console.error());
    }
  }

  static async buildallocationTable(data) {
    var table = id('allocationTableAdd');
    table.innerHTML = '';

    if (!data[0].assetsArray.length) {
      hide('searchSpace');
      infoBox('There are no development plans under this selection.');
      table.innerHTML = '';
      return;
    }

    // HEAD ===
    var thead = document.createElement('thead');
    if ('assetType' in data[0].assetsArray[0]) {
      var th = document.createElement('th');
      th.innerHTML = 'Content Type';
      thead.appendChild(th);
    }

    const th1 = document.createElement('th');
    th1.innerHTML = 'Display Name';
    thead.appendChild(th1);

    // create header per range given
    for (let i = 0; i < data[0].rangeArray.length; i++) {
      const element = data[0].rangeArray[i];
      let th2 = document.createElement('th');
      for (const key in element) {
        if (key !== 'measureRangeID') {
          th2.innerHTML = element[key];
          thead.appendChild(th2);
        }
      }
    }

    const th3 = document.createElement('th');
    th3.innerHTML = 'Select for Development Plan';
    thead.appendChild(th3);
    table.appendChild(thead);

    // BODY ===
    for (let i = 0; i < data[0].assetsArray.length; i++) {
      const asset = data[0].assetsArray[i];
      var tr = document.createElement('tr');
      if ('assetType' in asset) {
        var td = divAtt('td', 'class', 'contentType');
        td.innerHTML = asset.assetType;
        tr.appendChild(td);
      }
      var td1 = divAtt('td', 'class', 'displayName');
      td.style = 'max-width: 250px;';
      td1.innerHTML = asset.assetName;
      tr.appendChild(td1);
      let dynamicElems = [];
      for (let i = 0; i < data[0].rangeArray.length; i++) {
        const element = data[0].rangeArray[i];
        var td2 = document.createElement('td');
        for (const key in element) {
          if (key !== 'measureRangeID') {
            if ('assetType' in asset) {
              const icon = asset[key] !== 0 ? divAtt('img', 'src', `${tickIcon}`) : divAtt('img', 'src', `${greyCross}`);
              td2.appendChild(icon);
            } else {
              var input = divAtt('input', 'class', 'checkbox__input');
              input = addAtt(input, 'type', 'checkbox');
              input = addAtt(input, 'value', key);
              input = addAtt(input, 'id', asset.libraryAssetID + '_' + key);

              let myMethod = () => {
                classifyAssets.toggleRange('libraryAssetID=' + asset.libraryAssetID + '&measureRangeID=' + element.measureRangeID + ', event');
              };
              dynamicElems.push([input, myMethod]);
              // input = addAtt(
              //   input,
              //   "onclick",
              //   'classifyAssets.toggleRange("libraryAssetID=' +asset.libraryAssetID +
              //     "&measureRangeID=" +
              //     element.measureRangeID +
              //     '", event)'
              // );
              if (asset[key] !== 0) {
                input = addAtt(input, 'checked', 'true');
              }
              var label = divAtt('label', 'class', 'checkbox__label');
              label = addAtt(label, 'for', asset.libraryAssetID + '_' + key);
              var span = divAtt('span', 'class', 'checkbox__custom');
              label.appendChild(span);
              td2.appendChild(input);
              td2.appendChild(label);
            }
            tr.appendChild(td2);
          }
        }
      }

      var td3 = divAtt('td');
      td3.style = 'display: flex; justify-content: center; max-width: unset;';
      const tggl = await buildTickBox(
        `${asset.libraryAssetID}`,
        0
        //`EUt_developmentPlan.addIDPToDevPlan(this.id)` //test
      );
      td3.appendChild(tggl);
      tr.appendChild(td3);

      table.appendChild(tr);
      for (let i = 0; i < dynamicElems.length; i++) {
        eListen(dynamicElems[i][0], dynamicElems[i][1], 'click'); //test
      }
      eListen(
        asset.libraryAssetID,
        () => {
          EUt_developmentPlan.addIDPToDevPlan(asset.libraryAssetID);
        },
        'change'
      );
    }
    unhide('searchSpace');
    unhide('allocationTableAdd');
  }

  static addIDPToDevPlan(value) {
    const vars = {};
    vars.candidateID = pgstr.EUt_developmentPlan.editUserID; //id('editUserID').value;
    vars.libraryassetID = value; //el.target.value;
    vars.DDcategoryID = id('getDDCategory').value;
    PREP(['allocateIDPtouser'], vars)
      .then((res) => {
        note(res.data.allocateIDPtouser);
      })
      .catch(() => {
        el.target.checked = false;
        console.error();
      });
  }

  static filter() {
    const input = id('genSearch');
    const filterByClass = id('filterDD').value; //Dropdown
    let filter = input.value.toUpperCase();
    let tr = document.getElementsByTagName('tr');
    let txtValue;

    for (let r = 0; r < tr.length; r++) {
      const row = tr[r];
      let td = row.getElementsByClassName(filterByClass);
      for (let d = 0; d < td.length; d++) {
        txtValue = td[d].textContent || td[d].innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          row.style.display = '';
        } else {
          row.style.display = 'none';
        }
      }
    }
  }

  static removeIDP(elid) {
    PREP(['removeIDPassetFromUser'], {
      allocHuserIDPAssetID: elid,
    })
      .then((res) => {
        note(res.data.removeIDPassetFromUser);
        hide(`asset_${elid}`);
      })
      .catch(console.error());
  }
}

export class EUt_projects {
  constructor(vars) {
    this.name = 'Edit Application - Development Plan';
    this.pageTier = 20;
    this.reference = 'EUt_developmentPlan';
    this.pageID = null;
    this.data = null;
    this.HclientID = vars.HclientID;
    this.editUserID = vars.editUserID;
    this.TargetUser = vars.TargetUser;
  }

  initPage(data) {
    // Set page pecific variables
    this.getJVROProjectsForAlloc = data.getJVROProjectsForAlloc;
    this.getExternalAssessmentsForAlloc = data.getExternalAssessmentsForAlloc;
    this.getAllocatedProjectsToUser = data.getAllocatedProjectsToUser;
    this.getAllocatedExternalAssessmentsToUser = data.getAllocatedExternalAssessmentsToUser;
    this.loadPage();
  }

  loadPage() {
    this.projectsPage();
  }

  projectsPage() {
    buildDropDownMain(this.getJVROProjectsForAlloc, 'jvroProject', 'JVROprojectID', 'projectName');
    buildDropDownMain(this.getExternalAssessmentsForAlloc, 'exAssessment', 'HassessmentID', 'assessmentName');

    //Table 1 JVRO Project
    const list = this.getAllocatedProjectsToUser;
    const table1 = id('listProjects');
    if (!list.length) {
      table1.innerHTML = '';
    } else {
      table1.innerHTML = `<thead>
        <th>Status</th>
        <th>Date Allocated</th>
        <th>Portal Name</th>
        <th>Project Name</th>
        <th>Assessment List</th>
      </thead>`;
      for (let el of list) {
        const row = divAtt('tr', 'class', '');
        const status = divAtt('td', 'class', '');
        status.innerHTML = el.Status;
        const date = divAtt('td', 'class', '');
        date.innerHTML = offsetTime(el.allocatedDate, 8);
        const portalName = divAtt('td', 'class', '');
        portalName.innerHTML = el.portalName;
        const projectName = divAtt('td', 'class', '');
        projectName.innerHTML = el.projectName;
        const assessmentList = divAtt('td', 'class', 'listProjects');
        assessmentList.innerHTML = el.AssessmentList;
        row.appendChild(status);
        row.appendChild(date);
        row.appendChild(portalName);
        row.appendChild(projectName);
        row.appendChild(assessmentList);
        table1.appendChild(row);
      }
    }

    // Table 2 External Ass
    const table2 = id('listExAssessment');
    const list2 = this.getAllocatedExternalAssessmentsToUser;

    if (!list2.length) {
      table2.innerHTML = '';
    } else {
      table2.innerHTML = `<thead>
        <th>Status</th>
        <th>Date Allocated</th>
        <th>Supplier</th>
        <th>Assessment List</th>
      </thead>`;
      for (let el of list2) {
        const row = divAtt('tr', 'class', '');
        const status = divAtt('td', 'class', '');
        status.innerHTML = el.Status;
        const date = divAtt('td', 'class', '');
        date.innerHTML = offsetTime(el.allocatedDate, 8);
        const supplier = divAtt('td', 'class', '');
        supplier.innerHTML = el.supplier;
        const assessmentName = divAtt('td', 'class', 'listProjects');
        assessmentName.innerHTML = el.assessmentName;
        row.appendChild(status);
        row.appendChild(date);
        row.appendChild(supplier);
        row.appendChild(assessmentName);
        table2.appendChild(row);
      }
    }
  }

  static allocateProject(choice) {
    const candidateID = id('editUserID');
    const project = id('jvroProject');
    const assessment = id('exAssessment');

    if ((project.value == '-' && choice === 'project') || (project.value == '' && choice === 'project')) {
      infoBox('Please choose a project to allocate');
    } else if ((assessment.value == '-' && choice === 'assessment') || (assessment.value == '' && choice === 'assessment')) {
      infoBox('Please choose an assessment to allocate');
    } else {
      const vars = {};
      vars.JVROprojectID = project.value;
      vars.candidateID = candidateID.value;
      vars.HassessmentID = assessment.value;
      if (choice === 'project') {
        PREP(['allocateUserToJVRProject'], vars)
          .then((res) => {
            note(res.data.allocateUserToJVRProject);
            changeTabN('EUt_projects');
          })
          .catch(console.error());
      } else if (choice === 'assessment') {
        PREP(['allocateUserToExternalAssessment'], vars)
          .then((res) => {
            note(res.data.allocateUserToExternalAssessment);
            changeTabN('EUt_projects');
          })
          .catch(console.error());
      }
    }
  }
}

export class EUt_LMS {
  constructor(vars) {
    this.name = 'Edit Application - LMS';
    this.pageTier = 20;
    this.reference = 'EUt_LMS';
    this.pageID = null;
    this.data = null;
    this.editUserID = vars.candidateID;
  }

  initPage(data) {
    //Edit Tab
    this.getAllocatedHuserHcourse = cObj(data.getAllocatedHuserHcourse);
    this.loadPage();
  }

  loadPage() {
    this.LMSPage();
  }

  async LMSPage() {
    const data = this.getAllocatedHuserHcourse;
    data.length && this.LMSTable(data);

    const rec = await getRecipe();
    rec.endPoint = apiURLDF;
    rec.methods = ['getDDCourseType'];

    PREP(rec, {})
      .then((res) => {
        // if (res.data.getDDCourseType) {
        buildDropDownMain(cObj(res.data.getDDCourseType), 'courseTypeDD', 'DDCOURSETYPEID', 'DESCRIPTION+TPNAME');
        // }
      })
      .catch(console.error());

    id('courseTypeDD').addEventListener('change', (e) => {
      hide('addEFeedbackDiv');
      const vars = {};
      if (e.target.value !== '-') {
        vars.courseTypeID = e.target.value;
        rec.methods = ['getCourses'];
        PREP(rec, vars).then((res) => {
          buildDropDownMain(cObj(res.data.getCourses), 'eFeedbackDD', 'HCOURSEID', 'SHORTNAME');
          unhide('efeedbackDiv');
        });
      } else {
        hide('efeedbackDiv');
      }
    });
    id('eFeedbackDD').addEventListener('change', (e) => {
      if (e.target.value == '-') {
        hide('addEFeedbackDiv');
      } else {
        unhide('addEFeedbackDiv');
      }
    });
  }

  LMSTable() {
    const data = this.getAllocatedHuserHcourse;
    const table = id('getAllocateHassessmentHcourse');
    table.innerHTML = '';
    const thead = document.createElement('thead');
    const th1 = document.createElement('th');
    th1.innerHTML = 'Name';
    const th2 = document.createElement('th');
    th2.innerHTML = 'Description';
    const th3 = document.createElement('th');
    th3.innerHTML = 'Date';
    const th4 = document.createElement('th');
    th4.innerHTML = 'Active';
    thead.appendChild(th1);
    thead.appendChild(th2);
    thead.appendChild(th3);
    thead.appendChild(th4);
    table.appendChild(thead);
    for (let row of data) {
      const tr = document.createElement('tr');
      const td1 = document.createElement('td');
      td1.innerHTML = row.COURSENAME;
      const td2 = document.createElement('td');
      td2.innerHTML = row.COURSEDESCRIPTION;
      const td3 = document.createElement('td');
      td3.innerHTML = formatDate(row.DATEON);
      const td4 = document.createElement('td');
      td4.appendChild(createToggle(row.ALLOCHUSERHCOURSEID, row.ALLOCHUSERHCOURSEID, row.ACTIVEYN, `EUt_LMS.toggleCourseToUser(this.id)`));
      tr.appendChild(td1);
      tr.appendChild(td2);
      tr.appendChild(td3);
      tr.appendChild(td4);
      table.appendChild(tr);
      eListen(
        `${row.ALLOCHUSERHCOURSEID}`,
        () => {
          EUt_LMS.toggleCourseToUser(`${row.ALLOCHUSERHCOURSEID}`);
        },
        'change'
      );
    }
  }

  static addLMSFeedback() {
    const sel = id('eFeedbackDD');
    const vars = {};
    vars.allocateUserID = id('editUserID').value;
    vars.HcourseID = sel.value;
    vars.coursename = sel.options[sel.selectedIndex].text;

    if (vars.HcourseID == '-' || vars.HcourseID == '') {
      return infoBox('Please choose a course to add.');
    }

    PREP(['allocateCourseToUser'], vars)
      .then((res) => {
        note(res.data.allocateCourseToUser);
        changeTabN('EUt_LMS');
      })
      .catch(console.error());
  }

  static courseTypeDD() {
    const courseTypeDD = id('courseTypeDD').value;
    if (!courseTypeDD || courseTypeDD === '-') {
      const vars = {};
      vars.courseTypeID = courseTypeDD;

      PREP(['getCourses'], vars)
        .then((res) => {
          note(res.data.getCourses);

          buildDropDownMain(cObj(res.data.getCourses), 'eFeedbackDD', 'HCOURSEID', 'SHORTNAME');
          unhide('efeedbackDiv');
        })
        .catch(console.error());
    } else {
      hide('efeedbackDiv');
    }
  }

  static toggleCourseToUser(courseID) {
    const vars = {};
    vars.allocHuserHcourseID = courseID;
    vars.toggleYN = id(courseID).checked === true ? 1 : 0;

    PREP(['toggleCourseToUser'], vars)
      .then((res) => {
        note(res.data.toggleCourseToUser);
      })
      .catch(console.error());
  }
}

export class EUt_busEntAlloc {
  constructor(vars) {
    this.name = 'Edit Application - Business Entity Allocation';
    this.pageTier = 20;
    this.reference = 'EUt_busEntAlloc';
    this.HclientID = vars.HclientID;
    this.editUserID = vars.editUserID;
  }

  initPage(data) {
    this.getBusinessEntities = cObj(data.getBusinessEntities);
    this.getUserBusinesEntities = data.getUserBusinesEntities;
    // console.log(data); //qwerty
    this.getReportType = cObj(data.getReportType);
    // console.log(this.getReportType);
    this.loadPage();
  }

  loadPage() {
    this.busEntAllocPage();
  }

  async busEntAllocPage() {
    buildDropDownMain(this.getBusinessEntities, 'busEntity', 'DDBUSINESSENTITYID', 'DESCRIPTION');
    buildDropDownMain(this.getReportType, 'reportViewing', 'HREPORTTYPEID', 'SHORTNAME');

    EUt_busEntAlloc.buildAllocTable();
    EUt_busEntAlloc.buildRepTypeTable();
  }

  static async buildAllocTable() {
    const vars = {};
    vars.TargetHuserID = pgstr.EUt_busEntAlloc.editUserID;

    PREP(['getUserBusinesEntities'], vars).then(async (res) => {
      pgstr.EUt_busEntAlloc.getUserBusinesEntities = res.data.getUserBusinesEntities;

      const data = pgstr.EUt_busEntAlloc.getUserBusinesEntities;
      if (data.length) {
        const body = id('busEntAllocBody');
        body.innerHTML = '';

        for (let row of data) {
          const tr = document.createElement('tr');
          const td1 = document.createElement('td');
          td1.innerHTML = row.busEntdescription;
          const td2 = document.createElement('td');
          td2.innerHTML = row.legEntdescription;
          const td3 = document.createElement('td');
          const tggl = await createToggle(row.allocHuserBusinessEntityID, row.allocHuserBusinessEntityID, row.reportviewYN, `EUt_busEntAlloc.tgglReportView('${row.allocHuserBusinessEntityID}')`);
          td3.appendChild(tggl);
          const td4 = document.createElement('td');
          const remove = divAtt('span', 'class', 'trash');
          remove.innerHTML = dustbinSVG;
          // remove.setAttribute(
          //   "onclick",
          //   `EUt_busEntAlloc.removeBusEntAlloc('${row.allocHuserBusinessEntityID}')`
          // );
          td4.appendChild(remove);

          tr.appendChild(td1);
          tr.appendChild(td2);
          tr.appendChild(td3);
          tr.appendChild(td4);
          body.appendChild(tr);
          eListen(
            `${row.allocHuserBusinessEntityID}`,
            () => {
              EUt_busEntAlloc.tgglReportView(`${row.allocHuserBusinessEntityID}`);
            },
            'change'
          );
          eListen(
            remove,
            () => {
              EUt_busEntAlloc.removeBusEntAlloc(row.allocHuserBusinessEntityID);
            },
            'click'
          );
        }
        unhide('busEntAllocTable');
        hide('noAlloc');
      } else {
        hide('busEntAllocTable');
        unhide('noAlloc');
      }
    });
  }

  static async buildRepTypeTable() {
    const vars = {};
    vars.ReportViewerID = pgstr.EUt_busEntAlloc.editUserID;
    console.log('pgstr', pgstr);
    PREP(['listReportsAlllocatedToUser'], vars).then(async (res) => {
      console.log(res);
      //listReportsAlllocatedToUser
      pgstr.EUt_busEntAlloc.listReportsAlllocatedToUser = res.data.listReportsAlllocatedToUser;

      const data = pgstr.EUt_busEntAlloc.listReportsAlllocatedToUser;
      if (data.length) {
        const body = id('allocRepTypesBody');
        body.innerHTML = '';
        //{allocHreportTypeHuserID: 4,
        // reportType: 'Candidate Development Report'}
        for (let row of data) {
          const tr = document.createElement('tr');
          const td1 = document.createElement('td');
          td1.innerHTML = row.reportType;
          const td2 = document.createElement('td');
          const remove = divAtt('span', 'class', 'trash');
          remove.innerHTML = dustbinSVG;
          // remove.setAttribute(
          //   "onclick",
          //   `EUt_busEntAlloc.removeRepViewAlloc('${row.allocHreportTypeHuserID}')`
          // );
          td2.appendChild(remove);

          tr.appendChild(td1);
          tr.appendChild(td2);
          body.appendChild(tr);
          eListen(
            remove,
            () => {
              EUt_busEntAlloc.removeRepViewAlloc(row.allocHreportTypeHuserID);
            },
            'click'
          );
        }
        unhide('allocRepTypesTable');
        // hide("noAlloc");
      } else {
        hide('allocRepTypesTable');
        // unhide("noAlloc");
      }
    });
  }

  static addBusEntAlloc() {
    const vars = {};
    vars.DDbusinessEntityID = id('busEntity').value;
    vars.DDLegalEntityID = id('legalEntity').value;
    vars.TargetHuserID = pgstr.EUt_busEntAlloc.editUserID;

    if (!vars.DDLegalEntityID || vars.DDLegalEntityID === '-') {
      infoBox('Please select a Legal Entity.');
      return;
    }

    PREP(['allocateUserToBusinessEntity'], vars)
      .then((res) => {
        note(res.data.allocateUserToBusinessEntity);
        EUt_busEntAlloc.buildAllocTable();
        id('busEntity').value = '-';
        hide('legalEntityDiv');
        hide('addBusEntAlloc');
      })
      .catch(console.error());
  }

  static addReportViewingAlloc() {
    const vars = {};
    vars.HreportTypeID = id('reportViewing').value;
    vars.ReportViewerID = pgstr.EUt_busEntAlloc.editUserID;

    if (!vars.HreportTypeID || vars.ReportViewerID === '-') {
      infoBox('Please select Report Type');
      return;
    }

    PREP(['allocReportToUser'], vars)
      .then((res) => {
        //note(res.data.allocateUserToBusinessEntity);
        EUt_busEntAlloc.buildRepTypeTable();
        id('reportViewing').value = '-';
        hide('addReportViewingAlloc');
      })
      .catch(console.error());
  }

  static populatelegalEnt() {
    const busEnt = id('busEntity').value;

    if (busEnt === '-') {
      hide('legalEntityDiv');
      hide('addBusEntAlloc');
      return;
    }

    const vars = {};
    vars.DDbusinessentityID = busEnt;
    vars.HclientID = pgstr.EUt_busEntAlloc.HclientID;
    PREP(['getDDlegalEntity'], vars)
      .then(async (res) => {
        const legal = await cObj(res.data.getDDlegalEntity);
        buildDropDownMain(legal, 'legalEntity', 'DDLEGALENTITYID', 'DESCRIPTION');

        unhide('legalEntityDiv');
        unhide('addBusEntAlloc');
      })
      .catch(console.error());
  }

  static reportViewingChange() {
    const repEnt = id('reportViewing').value;
    if (repEnt === '-') {
      hide('addReportViewingAlloc');
      return;
    }
    unhide('addReportViewingAlloc');
  }

  static tgglReportView(entID) {
    const vars = {};
    vars.allocHuserBusinessEntityID = entID;
    vars.toggle = id(`${entID}`).checked ? 1 : 0;

    PREP(['toggleHuserBEReportview'], vars)
      .then((res) => {
        note(res.data.toggleHuserBEReportview);
      })
      .catch(console.error());
  }

  static removeBusEntAlloc(entID) {
    const vars = {};
    vars.allocHuserBusinessEntityID = entID;

    PREP(['DEallocateUserToBusinessEntity'], vars)
      .then((res) => {
        note(res.data.DEallocateUserToBusinessEntity);
        EUt_busEntAlloc.buildAllocTable();
      })
      .catch(console.error());
  }

  static removeRepViewAlloc(entID) {
    const vars = {};
    vars.allocHreportTypeHuserID = entID;

    PREP(['removeReportFromUser'], vars)
      .then((res) => {
        note(res.data.DEallocateUserToBusinessEntity);
        EUt_busEntAlloc.buildRepTypeTable();
      })
      .catch(console.error());
  }
}

// ==== Functions for all "EUt_"assessment result pages eg. EIP, CPP...

export const uploadResults = {
  uploadEIP: () => {
    if (id('reportFile').files[0] === undefined) {
      infoBox('Please select a File to Upload');
    } else if (!id('assResultStartDate').value) {
      infoBox('Please select an assessment result start date.');
    } else {
      const vars = {};
      vars.participantID = id('editUserID').value;
      vars.comments = id('reportComments').value;
      vars.reportFile = id('reportFile').files[0];
      vars.reportTypeID = id('reportType').value;
      vars.HapplicationID = 0;
      vars.attachmentToParticipantYN = toggleSliderYN(id('attachFile').checked);

      PREP(['uploadReport'], vars)
        .then((res) => {
          note(res.data.uploadReport);
          changeTabN('EUt_reports');
        })
        .catch(console.error());

      const results = {};
      results.candidateID = id('editUserID').value;
      results.integrationID = id('canID_2').value;
      results.assResultStartDate = id('assResultStartDate').value;
      results.total = id('total_2').value + '%';
      results.mathReasoning = id('mathRes_2').value + '%';
      results.mathReasoningAttempted = id('mathResAttempted_2').value + '%';
      results.mathReasoningCorrect = id('mathResCorrect_2').value + '%';
      results.mathReasoningIncorrect = id('mathResIncorrect_2').value + '%';
      results.mathSkillLevel = {
        attempted: id('mathSkillAttemptedA_2').value + '/' + id('mathSkillAttemptedB_2').value,
        correct: id('mathSkillCorrectA_2').value + '/' + id('mathSkillCorrectB_2').value,
        incorrect: id('mathSkillIncorrectA_2').value + '/' + id('mathSkillIncorrectB_2').value,
        correctTotalPossible: id('mathSkillCorrectTotalA_2').value + '/' + id('mathSkillCorrectTotalB_2').value,
      };
      results.verbalReasoning = id('verbalRes_2').value + '%';
      results.verbalReasoningAttempted = id('verbalResAttempted_2').value + '%';
      results.verbalReasoningCorrect = id('verbalResCorrect_2').value + '%';
      results.verbalReasoningIncorrect = id('verbalResIncorrect_2').value + '%';
      results.verbalSkillLevel = {
        attempted: id('verbalResAttemptedFractA_2').value + '/' + id('verbalResAttemptedFractB_2').value,
        correct: id('verbalResCorrectFractA_2').value + '/' + id('verbalResCorrectFractB_2').value,
        incorrect: id('verbalResIncorrectFractA_2').value + '/' + id('verbalResIncorrectFractB_2').value,
        correctTotalPossible: id('verbalResCorrectTotalFractA_2').value + '/' + id('verbalResCorrectTotalFractB_2').value,
      };

      const vars2 = {};
      vars2.entityType = 'uploadEIPResults';
      vars2.entityUUID = uuidvMain();
      vars2.payload = JSON.stringify(results);
      PREP(['uploadNewRecords'], vars2)
        .then((res) => {
          note(res.data.uploadNewRecords);
        })
        .catch(console.error());
    }
  },
  uploadMCPA: () => {
    if (id('currentCap').value == '-' || id('futureDev').value == '-') {
      infoBox('Please select an option for both dropdowns.');
    } else if (id('reportFile').files[0] === undefined) {
      infoBox('Please select a File to Upload');
    } else if (!id('assResultStartDate').value) {
      infoBox('Please select an assessment result start date.');
    } else {
      const vars = {};
      vars.participantID = id('editUserID').value;
      vars.comments = id('reportComments').value;
      vars.reportFile = id('reportFile').files[0];
      vars.reportTypeID = id('reportType').value;
      vars.HapplicationID = 0;
      vars.attachmentToParticipantYN = toggleSliderYN(id('attachFile').checked);

      const results = {};
      results.currentCap = id('currentCap2').value;
      results.futureDev = id('futureDev2').value;
      results.candidateID = id('editUserID').value;
      results.reportTypeID = id('reportType').value;
      results.assResultStartDate = id('assResultStartDate').value;

      vars.entityType = 'recordMCPAResults';
      vars.entityUUID = uuidvMain();
      vars.payload = JSON.stringify(results);

      PREP(['uploadReport', 'uploadNewRecords'], vars)
        .then((res) => {
          note(res.data.uploadReport);
          note(res.data.uploadNewRecords);
          changeTabN('EUt_reports');
        })
        .catch(console.error());
    }
  },
  uploadMCPAScan: () => {
    if (id('currentCapScan2').value == '-' || id('futureDevScan2').value == '-') {
      infoBox('Please select an option for both dropdowns.');
    } else if (id('reportFile').files[0] === undefined) {
      infoBox('Please select a File to Upload');
    } else if (!id('assResultStartDate').value) {
      infoBox('Please select an assessment result start date.');
    } else {
      const vars = {};
      vars.participantID = id('editUserID').value;
      vars.comments = id('reportComments').value;
      vars.reportFile = id('reportFile').files[0];
      vars.reportTypeID = id('reportType').value;
      vars.HapplicationID = 0;
      vars.attachmentToParticipantYN = toggleSliderYN(id('attachFile').checked);

      const results = {};
      results.currentCap = id('currentCapScan2').value;
      results.futureDev = id('futureDevScan2').value;
      results.candidateID = id('editUserID').value;
      results.reportTypeID = id('reportType').value;
      results.assResultStartDate = id('assResultStartDate').value;

      vars.entityType = 'recordMCPAScanResults';
      vars.entityUUID = uuidvMain();
      vars.payload = JSON.stringify(results);

      PREP(['uploadReport', 'uploadNewRecords'], vars)
        .then((res) => {
          note(res.data.uploadReport);
          note(res.data.uploadNewRecords);
          changeTabN('EUt_reports');
        })
        .catch(console.error());
    }
  },
  nextResults: () => {
    let pass = true;
    const results = document.querySelectorAll('.rInput0');
    results.forEach((result) => {
      if (result.value == '') {
        pass = false;
        result.classList.add('incorrect');
      } else {
        result.classList.remove('incorrect');
      }
    });

    if (pass) {
      hide('next');
      hide('step1Content');
      id('step2').classList.add('bgActive');
      id('stepLine1').classList.add('hrActive');
      unhide('step2Content');
    } else {
      infoBox('Please fill in all results fields.');
    }
  },
  compareResult: (elid) => {
    const element = elid.split('_');
    if (id(`${element[0]}_1`).value == id(`${element[0]}_2`).value) {
      id(`${element[0]}_2`).classList.add('correct');
      id(`${element[0]}_2`).classList.remove('incorrect');
    } else {
      id(`${element[0]}_2`).classList.add('incorrect');
      id(`${element[0]}_2`).classList.remove('correct');
      unhide('resultsNote');
    }

    let fill = true;
    let pass = true;
    const results = document.querySelectorAll('.rInput1');
    results.forEach((result) => {
      if (result.classList.contains('incorrect')) {
        unhide('resultsNote');
        pass = false;
      }
      if (result.value == '') {
        fill = false;
      }
    });

    if (fill && pass) {
      hide('resultsNote');
      unhide('uploadResultsBtn');
    } else if (fill && !pass) {
      unhide('resultsNote');
      hide('uploadResultsBtn');
    } else if (!fill && pass) {
      unhide('resultsNote');
      hide('uploadResultsBtn');
    } else {
      hide('resultsNote');
      hide('uploadResultsBtn');
    }
  },
  valCanID: (elID) => {
    if (id(elID).value.length !== 6) {
      id(elID).classList.add('incorrect');
      id(elID).classList.remove('correct');
    } else {
      id(elID).classList.add('correct');
      id(elID).classList.remove('incorrect');
    }
    uploadResults.firstRunVal();
  },
  valPerc: (elID) => {
    if (id(elID).value) {
      if (isNaN(id(elID).value) || id(elID).value > 100 || id(elID).value < 0) {
        id(elID).classList.add('incorrect');
        id(elID).classList.remove('correct');
      } else if (id(elID).value < 100 || id(elID).value > 0) {
        id(elID).classList.add('correct');
        id(elID).classList.remove('incorrect');
      }
    }
    uploadResults.firstRunVal();
  },
  valFracB: (elID) => {
    const split = elID.split('_')[0].slice(0, -1);
    const valA = parseInt(id(`${split}A_1`).value);
    const valB = parseInt(id(`${split}B_1`).value);

    if (id(`${split}A_1`).value.length == 0 || id(`${split}B_1`).value.length == 0 || valA > valB || valB > 20) {
      id(`${split}A_1`).classList.add('incorrect');
      id(`${split}B_1`).classList.add('incorrect');
      id(`${split}A_1`).classList.remove('correct');
      id(`${split}B_1`).classList.remove('correct');
    } else {
      id(`${split}A_1`).classList.remove('incorrect');
      id(`${split}B_1`).classList.remove('incorrect');
      id(`${split}A_1`).classList.add('correct');
      id(`${split}B_1`).classList.add('correct');
    }
    uploadResults.firstRunVal();
  },
  valFracA: (elID) => {
    const split = elID.split('_')[0].slice(0, -1);
    if (id(`${split}B_1`).value.length !== 0) {
      uploadResults.valFracB(elID);
    }
  },
  firstRunVal: () => {
    let fill = true;
    let pass = true;
    const results = document.querySelectorAll('.rInput0');
    results.forEach((result) => {
      if (result.classList.contains('incorrect')) {
        pass = false;
      }
      if (result.value.length == 0) {
        fill = false;
      }
    });
    if (fill && pass) {
      unhide('next');
    } else {
      hide('next');
    }
  },
  CPPpage: async (data) => {
    buildDropDownMain(data, 'currLevel', 'DDLevelCPPID', 'shortDescription');
    buildDropDownMain(data, 'currLevel2', 'DDLevelCPPID', 'shortDescription');
    // buildDropDownMain(data, 'potencialLevel', 'DDLevelCPPID', 'shortDescription')
    const barLefts = document.querySelectorAll('.barLeft');
    const svgElement = await svgStringParse(dragDotsSVG);
    barLefts.forEach((bar) => {
      bar.prepend(svgElement.cloneNode(true));
    });
    dragDrop();
  },
  potenLevDD: (elID, potencialLevel) => {
    const currLevelDD = id(elID);

    if (!currLevelDD.value || currLevelDD.value === '-') {
      hide(`${potencialLevel}Div`);
    } else {
      let newDDList = [];

      PREP(['getDDLevelsCPP'])
        .then(async (res) => {
          const list = res.data.getDDLevelsCPP;
          let valCheck = await list.find((item) => item.DDLevelCPPID == currLevelDD.value);

          await list.forEach((item) => {
            if (item.displayorder >= valCheck.displayorder) {
              newDDList.push(item);
            }
          });

          buildDropDownMain(newDDList, `${potencialLevel}`, 'DDLevelCPPID', 'shortDescription');
          unhide(`${potencialLevel}Div`);
        })
        .catch(console.error());
    }
  },
  val100: (elID) => {
    if (id(elID).value) {
      if (isNaN(id(elID).value) || id(elID).value > 100 || id(elID).value < 0) {
        id(elID).classList.add('incorrect');
        id(elID).classList.remove('correct');
      } else if (id(elID).value < 100 || id(elID).value > 0) {
        id(elID).classList.add('correct');
        id(elID).classList.remove('incorrect');
      }
    }
  },
  val200: (elID) => {
    if (id(elID).value) {
      if (isNaN(id(elID).value) || id(elID).value > 200 || id(elID).value < 0) {
        id(elID).classList.add('incorrect');
        id(elID).classList.remove('correct');
      } else if (id(elID).value < 200 || id(elID).value > 0) {
        id(elID).classList.add('correct');
        id(elID).classList.remove('incorrect');
      }
    }
  },
  step1Next: () => {
    let pass = true;
    const results = document.querySelectorAll('.inputStep1');
    results.forEach((result) => {
      if (result.value.length == 0 || result.value === '-') {
        result.classList.add('incorrect');
        infoBox('Please fill in all inputs.');
        pass = false;
      }
    });

    if (pass) {
      id('step2').classList.add('bgActive');
      id('stepLine1').classList.add('hrActive');
      hide('step1Content');
      unhide('step2Content');
    }
  },
  step2Next: () => {
    let pass = true;
    const results = document.querySelectorAll('.inputStep2');
    results.forEach((result) => {
      if (result.value.length == 0 || result.value > 100) {
        result.classList.add('incorrect');
        infoBox('Please fill in all values but not exceeding 100.');
        pass = false;
      }
    });

    if (pass) {
      id('step3').classList.add('bgActive');
      id('stepLine2').classList.add('hrActive');
      hide('step2Content');
      unhide('step3Content');
    }
  },
  step3NextCompare: (elid) => {
    // COMPARE

    const element = elid.split('_');
    if (id(`${element[0]}_0`).value == id(`${element[0]}_1`).value) {
      id(`${element[0]}_1`).classList.add('correct');
      id(`${element[0]}_1`).classList.remove('incorrect');
    } else {
      id(`${element[0]}_1`).classList.add('incorrect');
      id(`${element[0]}_1`).classList.remove('correct');
      unhide('resultsNote1');
    }

    let fill = true;
    let pass = true;
    const results = document.querySelectorAll('.inputStep3');
    results.forEach((result) => {
      if (result.classList.contains('incorrect')) {
        unhide('resultsNote1');
        pass = false;
      }
      if (result.value == '') {
        fill = false;
      }
    });

    if (fill && pass) {
      hide('resultsNote1');
      unhide('step3NextBtn');
    } else if (fill && !pass) {
      unhide('resultsNote1');
      hide('step3NextBtn');
    } else {
      hide('resultsNote1');
      hide('step3NextBtn');
    }
  },
  step3Next: () => {
    id('step4').classList.add('bgActive');
    id('stepLine3').classList.add('hrActive');
    hide('step3Content');
    unhide('step4Content');
  },
  step4Next: () => {
    id('step5').classList.add('bgActive');
    id('stepLine4').classList.add('hrActive');
    hide('step4Content');
    unhide('step5Content');
  },
  step5Next: () => {
    let pass = true;
    const results = document.querySelectorAll('.inputStep5');
    results.forEach((result) => {
      if (result.value.length == 0 || result.value > 100) {
        result.classList.add('incorrect');
        infoBox('Please fill in all values but not exceeding 100.');
        pass = false;
      }
    });

    if (pass) {
      id('step6').classList.add('bgActive');
      id('stepLine5').classList.add('hrActive');
      hide('step5Content');
      unhide('step6Content');
    }
  },
  step6NextCompare: (elid) => {
    // COMPARE

    const element = elid.split('_');
    if (id(`${element[0]}_0`).value == id(`${element[0]}_1`).value) {
      id(`${element[0]}_1`).classList.add('correct');
      id(`${element[0]}_1`).classList.remove('incorrect');
    } else {
      id(`${element[0]}_1`).classList.add('incorrect');
      id(`${element[0]}_1`).classList.remove('correct');
      unhide('resultsNote1');
    }

    let fill = true;
    let pass = true;
    const results = document.querySelectorAll('.inputStep6');
    results.forEach((result) => {
      if (result.classList.contains('incorrect')) {
        unhide('resultsNote1');
        pass = false;
      }
      if (result.value == '') {
        fill = false;
      }
    });

    if (fill && pass) {
      hide('resultsNote');
      unhide('uploadResultsBtn');
    } else if (fill && !pass) {
      unhide('resultsNote');
      hide('uploadResultsBtn');
    } else {
      hide('resultsNote');
      hide('uploadResultsBtn');
    }
  },
  uploadCPPresults: () => {
    if (id('reportFile').files[0] === undefined) {
      infoBox('Please select a File to Upload', 'Error');
      return;
    } else if (!id('assResultStartDate').value) {
      infoBox('Please select an assessment result start date.');
      return;
    } else {
      const vars1 = {};
      vars1.participantID = id('editUserID').value;
      vars1.comments = id('reportComments').value;
      vars1.reportFile = id('reportFile').files[0];
      vars1.reportTypeID = id('reportType').value;
      vars1.HapplicationID = 0;
      vars1.attachmentToParticipantYN = toggleSliderYN(id('attachFile').checked);

      PREP(['uploadReport'], vars1)
        .then((res) => {
          note(res.data.uploadReport);
        })
        .catch(console.error());

      const vars = {};
      vars.targetUserID = id('editUserID').value;
      vars.assResultStartDate = id('assResultStartDate').value;
      // vars.candidateName = id('cName').value;
      vars.CPPNumber = id('cppNum').value;
      vars.assessmentDate = id('assDate').value;
      vars.currentLevel = id('currLevel2').value;
      vars.potentialLevel = id('potencialLevel2').value;
      vars.detailComplexity = id('detail_1').value;
      vars.dynamicComplexity = id('dynamic_1').value;
      vars.tangibleInfo = id('tangInfo_1').value;
      vars.intagibleInfo = id('intangInfo_1').value;
      vars.shortTermFocus = id('shortTerm_1').value;
      vars.longTermFocus = id('longTerm_1').value;
      vars.structuredContexts = id('structured_1').value;
      vars.unstructuredContexts = id('unstructured_1').value;
      vars.speedOfWork = id('speed_1').value;
      vars.quickSight = id('quickInsight_1').value;
      vars.paceControl = id('paceControl_1').value;
      vars.quickClosure = id('quickClosure_1').value;
      vars.MUseOfMemory = id('memoryUse_1').value;
      vars.MMemoryStrategies = id('memoryStrat_1').value;
      vars.EPragmatic = id('pragmatic_1').value;
      vars.EExploration = id('exploration_1').value;
      vars.AAnalysis = id('analysis_1').value;
      vars.ARules = id('rules_1').value;
      vars.SICategorisation = id('cat_1').value;
      vars.SIIntegration = id('integration_1').value;
      vars.SIGradualImprovementlearning = id('complex_1').value;
      vars.TLogicalReasoning = id('logicalReson_1').value;
      vars.TVerbalConseptualisation = id('verbalConon_1').value;
      vars.MJudgement = id('judgement_1').value;
      vars.MQuickInsightLearning = id('qInsightLearn_1').value;
      vars.MGradualImprovementLearning = id('improvementLearn_1').value;

      let cntr = 1;
      const cogList = document.querySelectorAll('.cogStyles');
      cogList.forEach((cog) => {
        vars[`order${cntr}`] = cog.value;
        cntr++;
      });

      const vars2 = {};
      vars2.entityType = 'addAssessmentScoreCPP';
      vars2.entityUUID = uuidvMain();
      vars2.payload = JSON.stringify(parseIntObj(vars));

      PREP(['uploadNewRecords'], vars2)
        .then((res) => {
          note(res.data.uploadNewRecords);
          changeTabN('EUt_reports');
        })
        .catch(console.error());
    }
  },
  val10: (elID) => {
    if (id(elID).value) {
      if (isNaN(id(elID).value) || id(elID).value > 10 || id(elID).value < 0) {
        id(elID).classList.add('incorrect');
        id(elID).classList.remove('correct');
      } else if (id(elID).value < 10 || id(elID).value > 0) {
        id(elID).classList.add('correct');
        id(elID).classList.remove('incorrect');
      }
    }
  },
  val4: (elID) => {
    if (id(elID).value) {
      if (isNaN(id(elID).value) || id(elID).value > 4 || id(elID).value < 0) {
        id(elID).classList.add('incorrect');
        id(elID).classList.remove('correct');
      } else if (id(elID).value < 4 || id(elID).value > 0) {
        id(elID).classList.add('correct');
        id(elID).classList.remove('incorrect');
      }
    }
  },
  nextStepSten: (inpsClass, stepNum) => {
    let pass = true;
    const results = document.querySelectorAll(`.${inpsClass}`);
    results.forEach((result) => {
      if (result.value.length == 0 || result.value > 10) {
        result.classList.add('incorrect');
        infoBox('Please fill in all values but not exceeding 10.');
        pass = false;
      }
    });

    const followingStep = parseInt(stepNum) + 1;
    if (pass) {
      id(`step${followingStep}`).classList.add('bgActive');
      if (id(`stepLine${stepNum}`)) {
        id(`stepLine${stepNum}`).classList.add('hrActive');
      }
      hide(`step${stepNum}Content`);
      unhide(`step${followingStep}Content`);
    }
  },
  nextStep200: (inpsClass, stepNum, anom) => {
    let pass = true;
    const results = document.querySelectorAll(`.${inpsClass}`);
    results.forEach((result) => {
      if (result.value.length == 0 || result.value > 200) {
        result.classList.add('incorrect');
        infoBox('Please fill in all values but not exceeding 200.');
        pass = false;
      }
    });

    if (id(anom)) {
      if (isNaN(id(anom).value) || id(anom).value > 10 || id(anom).value < 0) {
        infoBox('Please fill in a value for  Consistency Index not exceeding 10.');
        pass = false;
      }
    }

    const followingStep = parseInt(stepNum) + 1;
    if (pass) {
      id(`step${followingStep}`).classList.add('bgActive');
      if (id(`stepLine${stepNum}`)) {
        id(`stepLine${stepNum}`).classList.add('hrActive');
      }
      hide(`step${stepNum}Content`);
      unhide(`step${followingStep}Content`);
    }
  },
  nextStepHDS: (inpsClass, stepNum) => {
    let pass = true;
    const results = document.querySelectorAll(`.${inpsClass}`);
    results.forEach((result) => {
      if (result.classList.contains('4')) {
        if (result.value.length == 0 || result.value > 4) {
          result.classList.add('incorrect');
          infoBox('Please fill in all values, scales not exceeding 100 and subsales not exceeding 4.');
          pass = false;
        }
      }

      if (result.classList.contains('100')) {
        if (result.value.length == 0 || result.value > 100) {
          result.classList.add('incorrect');
          infoBox('Please fill in all values, scales not exceeding 100 and subsales not exceeding 4.');
          pass = false;
        }
      }
    });

    const followingStep = parseInt(stepNum) + 1;
    if (pass) {
      id(`step${followingStep}`).classList.add('bgActive');
      if (id(`stepLine${stepNum}`)) {
        id(`stepLine${stepNum}`).classList.add('hrActive');
      }
      hide(`step${stepNum}Content`);
      unhide(`step${followingStep}Content`);
    }
  },
  compareAnswer: (elid, inpsClass, stepNum) => {
    // COMPARE
    const element = elid.split('_');
    if (id(`${element[0]}_0`).value == id(`${element[0]}_1`).value) {
      id(`${element[0]}_1`).classList.add('correct');
      id(`${element[0]}_1`).classList.remove('incorrect');
    } else {
      id(`${element[0]}_1`).classList.add('incorrect');
      id(`${element[0]}_1`).classList.remove('correct');
      unhide(`resultsNote${stepNum}`);
    }

    let fill = true;
    let pass = true;
    const results = document.querySelectorAll(`.${inpsClass}`);
    results.forEach((result) => {
      if (result.classList.contains('incorrect')) {
        unhide(`resultsNote${stepNum}`);
        pass = false;
      }
      if (result.value == '') {
        fill = false;
      }
    });

    if (fill && pass) {
      hide(`resultsNote${stepNum}`);
      unhide(`step${stepNum}NextBtn`);
    } else if (fill && !pass) {
      unhide(`resultsNote${stepNum}`);
      hide(`step${stepNum}NextBtn`);
    } else {
      hide(`resultsNote${stepNum}`);
      hide(`step${stepNum}NextBtn`);
    }
  },
  valNotEmpty: (elID) => {
    if (id(elID).value) {
      if (isNaN(id(elID).value) || id(elID).value < 0 || id(elID).value === '') {
        id(elID).classList.add('incorrect');
        id(elID).classList.remove('correct');
      } else if (id(elID).value > 0) {
        id(elID).classList.add('correct');
        id(elID).classList.remove('incorrect');
      }
    }
  },
  nextStepNotEmpty: (inpsClass, stepNum) => {
    let pass = true;
    const results = document.querySelectorAll(`.${inpsClass}`);
    results.forEach((result) => {
      if (result.value.length == 0) {
        result.classList.add('incorrect');
        infoBox('Please fill in all values.');
        pass = false;
      }
    });

    const followingStep = parseInt(stepNum) + 1;
    if (pass) {
      id(`step${followingStep}`).classList.add('bgActive');
      if (id(`stepLine${stepNum}`)) {
        id(`stepLine${stepNum}`).classList.add('hrActive');
      }
      hide(`step${stepNum}Content`);
      unhide(`step${followingStep}Content`);
    }
  },
  uploadOPQresults: () => {
    if (id('reportFile').files[0] === undefined) {
      infoBox('Please select a File to Upload', 'Error');
      return;
    } else if (!id('assResultStartDate').value) {
      infoBox('Please select an assessment result start date.');
      return;
    } else {
      const vars1 = {};
      vars1.participantID = id('editUserID').value;
      vars1.comments = id('reportComments').value;
      vars1.reportFile = id('reportFile').files[0];
      vars1.reportTypeID = id('reportType').value;
      vars1.HapplicationID = 0;
      vars1.attachmentToParticipantYN = toggleSliderYN(id('attachFile').checked);

      PREP(['uploadReport'], vars1)
        .then((res) => {
          note(res.data.uploadReport);
        })
        .catch(console.error());
    }

    const obj = {};
    obj.candidateID = id('editUserID').value;
    obj.reportTypeID = id('reportType').value;
    obj.assResultStartDate = id('assResultStartDate').value;
    //Page 1
    obj.influencePersuasive = id('persuasive_1').value;
    obj.influenceControlling = id('controlling_1').value;
    obj.influenceOutspoken = id('outspoken_1').value;
    obj.influenceIndependentMind = id('independentMind_1').value;
    obj.sociabilityOutgoing = id('outgoing_1').value;
    obj.sociabilityAffiliative = id('affiliative_1').value;
    obj.sociabilityConfident = id('confident_1').value;
    obj.empathyModest = id('modest_1').value;
    obj.empathyDemocratic = id('democratic_1').value;
    obj.empathyCaring = id('caring_1').value;

    // page 2
    obj.analysisDataRational = id('dataRational_1').value;
    obj.analysisEvaluative = id('evaluative_1').value;
    obj.analysisBehavioural = id('behavioural_1').value;
    obj.creativeChangeConventional = id('conventional_1').value;
    obj.creativeChangeConceptual = id('conceptual_1').value;
    obj.creativeChangeInnovative = id('innovative_1').value;
    obj.creativeChangeVarietySeeking = id('vSeeking_1').value;
    obj.creativeChangeAdaptable = id('adaptable_1').value;
    obj.structureForwardThinking = id('forwardThinking_1').value;
    obj.structureDetailConscious = id('detailConscious_1').value;
    obj.structureConscientious = id('conscientious_1').value;
    obj.structureRuleFollowing = id('ruleFollowing_1').value;

    // page 3
    obj.emotionsRelaxed = id('relaxed_1').value;
    obj.emotionsWorrying = id('worrying_1').value;
    obj.emotionsToughMinded = id('toughMinded_1').value;
    obj.emotionsOptimistic = id('conventional_1').value;
    obj.emotionsTrusting = id('conceptual_1').value;
    obj.emotionsEmotionallyControlled = id('innovative_1').value;
    obj.dynamismVigorous = id('vigorous_1').value;
    obj.dynamismCompetitive = id('competitive_1').value;
    obj.dynamismAchieving = id('achieving_1').value;
    obj.dynamismDecisive = id('decisive_1').value;
    obj.consistency = id('consistency_1').value;

    const vars = {};
    vars.entityType = 'addAssessmentScoreOPQ';
    vars.entityUUID = uuidvMain();
    vars.payload = JSON.stringify(parseIntObj(obj));

    PREP(['uploadNewRecords'], vars)
      .then((res) => {
        note(res.data.uploadNewRecords);
        changeTabN('EUt_reports');
      })
      .catch(console.error());
  },
  uploadEQiResults: () => {
    if (id('reportFile').files[0] === undefined) {
      infoBox('Please select a File to Upload', 'Error');
      return;
    } else if (!id('assResultStartDate').value) {
      infoBox('Please select an assessment result start date.');
      return;
    } else {
      const vars1 = {};
      vars1.participantID = id('editUserID').value;
      vars1.comments = id('reportComments').value;
      vars1.reportFile = id('reportFile').files[0];
      vars1.reportTypeID = id('reportType').value;
      vars1.HapplicationID = 0;
      vars1.attachmentToParticipantYN = toggleSliderYN(id('attachFile').checked);

      PREP(['uploadReport'], vars1)
        .then((res) => {
          note(res.data.uploadReport);
        })
        .catch(console.error());
    }

    const obj = {};
    obj.candidateID = id('editUserID').value;
    obj.reportTypeID = id('reportType').value;
    obj.assResultStartDate = id('assResultStartDate').value;
    //Page 1
    obj.positiveImpression = id('positiveImpression_1').value;
    obj.negativeImpression = id('negativeImpression_1').value;
    obj.totalEI = id('totalEI_1').value;
    obj.selfPerception = id('selfPerception_1').value;
    obj.selfRegard = id('selfRegard_1').value;
    obj.selfAculization = id('selfAculization_1').value;
    obj.emotionalSelfAwareness = id('emotionalSelfAwareness_1').value;
    obj.selfExpressionComposite = id('selfExpressionComposite_1').value;
    obj.emotionalExpression = id('emotionalExpression_1').value;
    obj.assertiveness = id('assertiveness_1').value;
    obj.independence = id('independence_1').value;
    obj.interpersonalComposite = id('interpersonalComposite_1').value;
    obj.interpersonalRelationships = id('interpersonalRelationships_1').value;
    obj.empathy = id('empathy_1').value;
    obj.socialResponsibility = id('socialResponsibility_1').value;

    // page 2
    obj.decisionMakingComposite = id('decisionMakingComposite_1').value;
    obj.problemSolving = id('problemSolving_1').value;
    obj.realityTesting = id('realityTesting_1').value;
    obj.impulseControl = id('impulseControl_1').value;
    obj.stressManagementComposite = id('stressManagementComposite_1').value;
    obj.flexibility = id('flexibility_1').value;
    obj.stressTolerance = id('stressTolerance_1').value;
    obj.optimism = id('optimism_1').value;
    obj.wellBeingIndicator = id('wellBeingIndicator_1').value;
    obj.happiness = id('happiness_1').value;
    obj.consistencyIndex = id('consistencyIndex_1').value;

    const vars = {};
    vars.entityType = 'addAssessmentScoreEQi';
    vars.entityUUID = uuidvMain();
    vars.payload = JSON.stringify(parseIntObj(obj));

    console.log(vars);

    PREP(['uploadNewRecords'], vars)
      .then((res) => {
        note(res.data.uploadNewRecords);
        changeTabN('EUt_reports');
      })
      .catch(console.error());
  },
  uploadHDSResults: (inpsClass) => {
    let pass = true;
    const results = document.querySelectorAll(`.${inpsClass}`);
    results.forEach((result) => {
      if (result.classList.contains('4')) {
        if (result.value.length == 0 || result.value > 4) {
          result.classList.add('incorrect');
          pass = false;
        }
      }

      if (result.classList.contains('100')) {
        if (result.value.length == 0 || result.value > 100) {
          result.classList.add('incorrect');
          pass = false;
        }
      }
    });

    if (!pass) {
      return infoBox('Please fill in all values, scales not exceeding 100 and subsales not exceeding 4.');
    }

    if (id('reportFile').files[0] === undefined) {
      infoBox('Please select a File to Upload', 'Error');
      return;
    } else if (!id('assResultStartDate').value) {
      infoBox('Please select an assessment result start date.');
      return;
    } else {
      const vars1 = {};
      vars1.participantID = id('editUserID').value;
      vars1.comments = id('reportComments').value;
      vars1.reportFile = id('reportFile').files[0];
      vars1.reportTypeID = id('reportType').value;
      vars1.HapplicationID = 0;
      vars1.attachmentToParticipantYN = toggleSliderYN(id('attachFile').checked);

      PREP(['uploadReport'], vars1)
        .then((res) => {
          note(res.data.uploadReport);
        })
        .catch(console.error());
    }

    const obj = {};
    obj.candidateID = id('editUserID').value;
    obj.reportTypeID = id('reportType').value;
    obj.assResultStartDate = id('assResultStartDate').value;
    //Page 1
    obj.scaleExcitable = id('excitable_1').value;
    obj.subscaleVolatile = id('volatile_1').value;
    obj.subscaleEasilyDisappointed = id('easilyDisappointed_1').value;
    obj.subscaleNoDirection = id('noDirection_1').value;
    obj.scaleSkeptical = id('skeptical_1').value;
    obj.subscaleCynical = id('cynical_1').value;
    obj.subscaleMistrusting = id('mistrusting_1').value;
    obj.subscaleGrudges = id('grudges_1').value;
    obj.scaleCautious = id('cautious_1').value;
    obj.subscaleAvoidant = id('avoidant_1').value;
    obj.subscaleFearful = id('fearful_1').value;
    obj.subscaleUnassertive = id('unassertive_1').value;
    obj.scaleReserved = id('reserved_1').value;
    obj.subscaleIntroverted = id('introverted_1').value;
    obj.subscaleUnsocial = id('unsocial_1').value;
    obj.subscaleTough = id('tough_1').value;
    obj.scaleLeisurely = id('leisurely_1').value;
    obj.subscalePassiveAgressive = id('passiveAgressive_1').value;
    obj.subscaleUnappreciated = id('unappreciated_1').value;
    obj.subscaleIrritated = id('irritated_1').value;
    obj.scaleBold = id('bold_1').value;
    obj.subscaleEntitled = id('entitled_1').value;
    obj.subscaleOverconfidence = id('overconfidence_1').value;
    obj.subscaleFantasizedTalent = id('fantasizedTalent_1').value;

    // page 2
    obj.scaleMischievous = id('mischievous_1').value;
    obj.subscaleRisky = id('risky_1').value;
    obj.subscaleImpulsive = id('impulsive_1').value;
    obj.subscaleManipulative = id('manipulative_1').value;
    obj.scaleColourful = id('colourful_1').value;
    obj.subscalePublicConfidence = id('publicConfidence_1').value;
    obj.subscaleDistractible = id('distractible_1').value;
    obj.subscaleSelfDisplay = id('selfDisplay_1').value;
    obj.scaleImaginative = id('imaginative_1').value;
    obj.subscaleEccentric = id('eccentric_1').value;
    obj.subscaleSpecialSensitivity = id('specialSensitivity_1').value;
    obj.subscaleCreativeThinking = id('creativeThinking_1').value;
    obj.scaleDiligent = id('diligent_1').value;
    obj.subscaleStandards = id('standards_1').value;
    obj.subscalePerfectionistic = id('perfectionistic_1').value;
    obj.subscaleOrganized = id('organized_1').value;
    obj.scaleDutiful = id('dutiful_1').value;
    obj.subscaleIndecisive = id('indecisive_1').value;
    obj.subscaleIntegrating = id('integrating_1').value;
    obj.subscaleConforming = id('conforming_1').value;

    const vars = {};
    vars.entityType = 'addAssessmentScoreHDS';
    vars.entityUUID = uuidvMain();
    vars.payload = JSON.stringify(parseIntObj(obj));

    PREP(['uploadNewRecords'], vars)
      .then((res) => {
        note(res.data.uploadNewRecords);
        changeTabN('EUt_reports');
      })
      .catch(console.error());
  },
  // Verify: Toggle + % + sten Results
  resultTggl: (elID) => {
    if (id(`${elID}`).checked === false) {
      //hide inputs
      id(`${elID}Percent_0`).parentElement.style = 'opacity: 0;  cursor: none;';
      id(`${elID}Sten_0`).parentElement.style = 'opacity: 0;  cursor: none;';

      //hide step 2 inputs
      id(`${elID}Percent_1`).parentElement.style = 'opacity: 0;  cursor: unset;';
      id(`${elID}Sten_1`).parentElement.style = 'opacity: 0;  cursor: unset;';
      id(`${elID}Heading`).style = 'color: var(--mediumGrey);';

      //set de-active inputs
      id(`${elID}Percent_0`).classList.remove('inputStep1');
      id(`${elID}Sten_0`).classList.remove('inputStep1');
      id(`${elID}Percent_1`).classList.remove('inputStep2');
      id(`${elID}Sten_1`).classList.remove('inputStep2');
      id(`${elID}Percent_1`).classList.remove('percent');
      id(`${elID}Sten_1`).classList.remove('sten');
    } else {
      //show inputs
      id(`${elID}Percent_0`).parentElement.style = 'opacity: 100;  cursor: unset;';
      id(`${elID}Sten_0`).parentElement.style = 'opacity: 100;  cursor: unset;';

      //show step 2 inputs
      id(`${elID}Percent_1`).parentElement.style = 'display: inline-flex !important;';
      id(`${elID}Sten_1`).parentElement.style = 'display: inline-flex !important;';
      id(`${elID}Heading`).style = 'color: unset;';

      //set active inputs
      id(`${elID}Percent_0`).classList.add('inputStep1');
      id(`${elID}Sten_0`).classList.add('inputStep1');
      id(`${elID}Percent_1`).classList.add('inputStep2');
      id(`${elID}Sten_1`).classList.add('inputStep2');
      id(`${elID}Percent_1`).classList.add('percent');
      id(`${elID}Sten_1`).classList.add('sten');
    }
  },
  nextStepStenPercent: (inpsClass, stepNum) => {
    // Val
    let pass = true;
    const results = document.querySelectorAll(`.${inpsClass}`);

    if (!results.length) {
      return infoBox('<b>No Test Selected.</b></br>Please toggle on a test to fill in results.');
    }

    results.forEach((result) => {
      //sten
      if (result.classList.contains('sten')) {
        if (result.value.length == 0 || result.value > 10) {
          result.classList.add('incorrect');
          infoBox('Please fill in all values either a percentile or sten.');
          pass = false;
        }
      }

      //percent
      if (result.classList.contains('percent')) {
        if (result.value.length == 0 || result.value > 100) {
          result.classList.add('incorrect');
          infoBox('Please fill in all values either a percentile or sten.');
          pass = false;
        }
      }
    });

    // Colour Steps
    const followingStep = parseInt(stepNum) + 1;
    if (pass) {
      id(`step${followingStep}`).classList.add('bgActive');
      if (id(`stepLine${stepNum}`)) {
        id(`stepLine${stepNum}`).classList.add('hrActive');
      }
      hide(`step${stepNum}Content`);
      unhide(`step${followingStep}Content`);
    }
  },
  uploadSHLVerifyResults: (inpsClass) => {
    // Val
    let pass = true;
    const results = document.querySelectorAll(`.${inpsClass}`);

    if (!results.length) {
      return infoBox('<b>No Test Selected.</b></br>Please toggle on a test to fill in results.');
    }

    results.forEach((result) => {
      //sten
      if (result.classList.contains('sten')) {
        if (result.value.length == 0 || result.value > 10) {
          result.classList.add('incorrect');
          pass = false;
        }
      }

      //percent
      if (result.classList.contains('percent')) {
        if (result.value.length == 0 || result.value > 100) {
          result.classList.add('incorrect');
          pass = false;
        }
      }
    });

    if (!pass) {
      return infoBox('Please fill in all values either a percentile or sten.');
    }
    if (id('reportFile').files[0] === undefined) {
      infoBox('Please select a File to Upload', 'Error');
      return;
    } else if (!id('assResultStartDate').value) {
      infoBox('Please select an assessment result start date.');
      return;
    } else {
      const vars1 = {};
      vars1.participantID = id('editUserID').value;
      vars1.comments = id('reportComments').value;
      vars1.reportFile = id('reportFile').files[0];
      vars1.reportTypeID = id('reportType').value;
      vars1.HapplicationID = 0;
      vars1.attachmentToParticipantYN = toggleSliderYN(id('attachFile').checked);

      PREP(['uploadReport'], vars1)
        .then((res) => {
          note(res.data.uploadReport);
        })
        .catch(console.error());
    }

    const obj = {};
    obj.candidateID = id('editUserID').value;
    obj.reportTypeID = id('reportType').value;
    obj.assResultStartDate = id('assResultStartDate').value;

    //Percent
    obj.inductiveReasoningPercent = id('inductiveReasoningPercent_1').value;
    obj.numericalAbilityPercent = id('numericalAbilityPercent_1').value;
    obj.deductiveReasoningPercent = id('deductiveReasoningPercent_1').value;
    obj.verbalReasoningPercent = id('verbalReasoningPercent_1').value;
    obj.mechanicalTestPercent = id('mechanicalTestPercent_1').value;
    obj.spatialReasoningPercent = id('spatialReasoningPercent_1').value;
    obj.faultDiagnosisPercent = id('faultDiagnosisPercent_1').value;

    //Sten
    obj.inductiveReasoningSten = id('inductiveReasoningSten_1').value;
    obj.numericalAbilitySten = id('numericalAbilitySten_1').value;
    obj.deductiveReasoningSten = id('deductiveReasoningSten_1').value;
    obj.verbalReasoningSten = id('verbalReasoningSten_1').value;
    obj.mechanicalTestSten = id('mechanicalTestSten_1').value;
    obj.spatialReasoningSten = id('spatialReasoningSten_1').value;
    obj.faultDiagnosisSten = id('faultDiagnosisSten_1').value;

    const vars = {};
    vars.entityType = 'addAssessmentScoreSHLVerify';
    vars.entityUUID = uuidvMain();
    vars.payload = JSON.stringify(parseIntObj(obj));

    PREP(['uploadNewRecords'], vars)
      .then((res) => {
        note(res.data.uploadNewRecords);
        changeTabN('EUt_reports');
      })
      .catch(console.error());
  },
  futureDevDD: (currentCapScan, futureDevScan) => {
    const currCapDD = id(currentCapScan);

    if (!currCapDD.value || currCapDD.value === '-') {
      hide(`${futureDevScan}Div`);
    } else {
      let newDDList = [];

      PREP(['getMCPAScanMeasures'])
        .then(async (res) => {
          const list = res.data.getMCPAScanMeasures;
          let valCheck = await list.find((item) => item.DDMCPAScanID == currCapDD.value);

          await list.forEach((item) => {
            if (item.displayorder >= valCheck.displayorder) {
              newDDList.push(item);
            }
          });

          await buildDropDownMain(newDDList, `${futureDevScan}`, 'DDMCPAScanID', 'shortDesc');
          unhide(`${futureDevScan}Div`);
        })
        .catch(console.error());
    }
  },
  dd1Next: () => {
    let pass = true;
    const results = document.querySelectorAll('.inputStep0');
    results.forEach((result) => {
      if (result.value.length == 0 || result.value === '-') {
        result.classList.add('incorrect');
        infoBox('Please fill in all inputs.');
        pass = false;
      }
    });

    if (pass) {
      hide('ddDiv1');
      unhide('ddDiv2');
    }
  },
  ddCompare: (elid) => {
    // COMPARE

    const element = elid.split('_');
    if (id(elid).value == id(`${elid}2`).value) {
      id(`${elid}2`).classList.add('correct');
      id(`${elid}2`).classList.remove('incorrect');
    } else {
      id(`${elid}2`).classList.add('incorrect');
      id(`${elid}2`).classList.remove('correct');
      unhide('resultsNote0');
    }

    let fill = true;
    let pass = true;
    const results = document.querySelectorAll('.inputStep00');
    results.forEach((result) => {
      if (result.classList.contains('incorrect')) {
        unhide('resultsNote0');
        pass = false;
      }
      if (result.value == '') {
        fill = false;
      }
    });

    if (fill && pass) {
      hide('resultsNote0');
      unhide('nextStep1Btn');
    } else if (fill && !pass) {
      unhide('resultsNote0');
      hide('nextStep1Btn');
    } else {
      hide('resultsNote0');
      hide('nextStep1Btn');
    }
  },
  goBack: (currStep) => {
    const backStep = currStep - 1;

    id(`step${currStep}`).classList.remove('bgActive');
    if (id(`stepLine${backStep}`)) {
      id(`stepLine${backStep}`).classList.remove('hrActive');
    }
    hide(`step${currStep}Content`);
    unhide(`step${backStep}Content`);
  },
  reVal: (classInput) => {
    const results = document.querySelectorAll(`.${classInput}`);
    results.forEach((result) => {
      //   if (result.classList.contains("incorrect")) {
      result.focus();
      const event = new KeyboardEvent('keyup');
      result.dispatchEvent(event);
      result.blur();
      //   }
    });
  },
};
window.uploadResults = uploadResults;

// ========================== MANGAGE APPLICATIONS ==================

export class ManageApplications {
  constructor() {
    this.name = 'Manage Applications';
    this.pageTier = 10;
    this.reference = 'manageApplications';
    this.pageID = null;
    this.data = null;
    this.HclientID = null;
  }

  initPage() {
    // Set page pecific variables
    this.loadPage();
  }

  loadPage() {
    this.gapAppsPage();
  }

  async gapAppsPage() {
    id('listApplicationsTable').innerHTML = '';

    const table = id('listApplicationsTable');
    const thead = await this.buildGapHead();
    table.appendChild(thead);
    const searchRow = await this.buildGapSearchRow();
    table.appendChild(searchRow);
    eListen(
      'exp',
      () => {
        applications.searchFiltersExpress();
      },
      'click'
    );
    eListen(
      'addSer',
      () => {
        applications.searchFiltersAddSer();
      },
      'click'
    );
    eListen(
      'addSuper',
      () => {
        applications.searchFiltersSuper();
      },
      'click'
    );
    eListen(
      'addScience',
      () => {
        applications.searchFiltersScience();
      },
      'click'
    );
    eListen(
      'pub',
      () => {
        applications.searchFiltersPublished();
      },
      'click'
    );
    eListen(
      'success',
      () => {
        applications.searchFiltersSuccess();
      },
      'click'
    );
    eListen(
      'unsuccessful',
      () => {
        applications.searchFiltersUnsuccess();
      },
      'click'
    );
    eListen(
      'MFE',
      () => {
        applications.searchFilterOnOff('MFE');
      },
      'click'
    );
    eListen(
      'CFE',
      () => {
        applications.searchFilterOnOff('CFE');
      },
      'click'
    );
    eListen(
      'CDR',
      () => {
        applications.searchFilterOnOff('CDR');
      },
      'click'
    );
    eListen(
      'MCG',
      () => {
        applications.searchFilterOnOff('MCG');
      },
      'click'
    );
    eListen(
      'clearSearchBtn',
      () => {
        applications.clearSearch();
      },
      'click'
    );
    ManageApplications.getGAPApplicants();
  }

  async buildGapHead() {
    const thead = document.createElement('thead');

    const th0 = document.createElement('th');
    const th5 = divAtt('th');
    const th1 = document.createElement('th');
    const th2 = document.createElement('th');
    const th3 = document.createElement('th');
    const th4 = document.createElement('th');
    const th6 = document.createElement('th');
    const th8 = document.createElement('th');
    const th7 = document.createElement('th');
    const th9 = document.createElement('th');
    const th10 = document.createElement('th');
    th10.innerHTML = 'Date Created';
    th1.innerHTML = 'Job Number';
    th2.innerHTML = 'Candidate';
    th3.innerHTML = 'Job Title';
    th4.innerHTML = 'Position';
    th6.innerHTML = 'Line Manager';
    th7.innerHTML = 'Pending Activity';
    th8.innerHTML = 'Status';
    th9.innerHTML = '';

    thead.appendChild(th10);
    thead.appendChild(th0);
    thead.appendChild(th5);
    thead.appendChild(th1);
    thead.appendChild(th2);
    thead.appendChild(th3);
    thead.appendChild(th4);
    thead.appendChild(th6);
    thead.appendChild(th8);
    thead.appendChild(th7);
    thead.appendChild(th9);

    return thead;
  }

  async buildGapSearchRow() {
    const searchRow = divAtt('tr', 'id', 'trSearch');
    searchRow.setAttribute('class', 'hide');

    const ts0 = document.createElement('td');
    ts0.innerHTML = `<div class="iconGrid">
    <svg  id="exp" class="iconOff" width="24px" height="26" viewBox="0 0 14.84 14.84" style="cursor: pointer;" ><rect x="1.24" y="5.56" width="4.95" height="1.24" rx="0.56"/><rect y="8.04" width="4.95" height="1.24" rx="0.59"/><path d="M7.93,1.69a6.67,6.67,0,0,1,1.61,0A.39.39,0,0,0,10,1.29V.47A.39.39,0,0,0,9.58.08H7.89A.39.39,0,0,0,7.5.47V1.3A.39.39,0,0,0,7.93,1.69Z" transform="translate(-0.08 -0.08)"/><path d="M11.27,5.59,9,7.5a1.27,1.27,0,0,0-1.18.39,1.24,1.24,0,1,0,2.1.44l1.63-2.49Z" transform="translate(-0.08 -0.08)"/><rect x="1.85" y="10.51" width="4.33" height="1.24" rx="0.56"/><path d="M8.74,2.55a6.15,6.15,0,0,0-4.4,1.86h2a4.87,4.87,0,0,1,2.37-.62,4.95,4.95,0,0,1,0,9.89,4.87,4.87,0,0,1-2.37-.62h-2A6.18,6.18,0,1,0,8.74,2.55Z" transform="translate(-0.08 -0.08)"/></svg>

    <svg  id="addSer" class="iconOff" width="25px" height="26px" viewBox="0 0 14.96 14.97" style="cursor: pointer; margin-top: 2px;"><path d="M5.7,12.16H1.83a.79.79,0,0,1-.89-.89V1.83A.79.79,0,0,1,1.82.94h7a.8.8,0,0,1,.89.89V5.47a.47.47,0,1,0,.93,0c0-1.26,0-2.52,0-3.77A1.7,1.7,0,0,0,8.9,0H1.69A1.69,1.69,0,0,0,.35.68,2,2,0,0,0,0,1.49V11.6l0,.07a1.67,1.67,0,0,0,1.45,1.4,6.58,6.58,0,0,0,.89,0H5.68a.47.47,0,0,0,.48-.3A.46.46,0,0,0,5.7,12.16Z" transform="translate(0 0)"/><path d="M14.91,10.25A4.05,4.05,0,1,0,9.77,14.8c.27.07.54.11.81.17h.67l.42-.08A4,4,0,0,0,14.91,10.25ZM10.9,14A3.12,3.12,0,1,1,14,10.92,3.11,3.11,0,0,1,10.9,14Z" transform="translate(0 0)"/><path d="M2.05,5.81a.73.73,0,0,0,.38.11H8.17a.83.83,0,0,0,.22,0,.42.42,0,0,0,.32-.32A.46.46,0,0,0,8.23,5H2.3a.45.45,0,0,0-.41.32A.42.42,0,0,0,2.05,5.81Z" transform="translate(0 0)"/><path d="M5.71,7.48H2.38A.47.47,0,0,0,1.87,8a.48.48,0,0,0,.52.47H5.72a.47.47,0,1,0,0-.94Z" transform="translate(0 0)"/><path d="M2.39,3.43H5.11A.47.47,0,0,0,5.61,3a.48.48,0,0,0-.51-.47H2.38a.47.47,0,1,0,0,.94Z" transform="translate(0 0)"/><path d="M12.85,10.51a.62.62,0,0,0-.3-.06H11.38V9.23a.47.47,0,0,0-.47-.5.47.47,0,0,0-.47.49v1.22H9.22a.47.47,0,1,0,0,.94h1.22V12.6a.48.48,0,0,0,.48.5.48.48,0,0,0,.46-.5V11.38h1.27a.45.45,0,0,0,.44-.36A.46.46,0,0,0,12.85,10.51Z" transform="translate(0 0)"/></svg>

    <svg  id="addSuper" class="iconOff" width="28px" height="25px" viewBox="0 0 14.93 7.73" style="cursor: pointer;" ><path d="M0,7.38c.31-.34.59-.7.92-1A10.53,10.53,0,0,1,5.38,3.92a8.09,8.09,0,0,1,4.7.14,10.43,10.43,0,0,1,4.71,3.08.46.46,0,0,1,0,.72,10.34,10.34,0,0,1-6,3.39,8.27,8.27,0,0,1-4.53-.54A10.52,10.52,0,0,1,.21,7.86,1.6,1.6,0,0,1,0,7.61Zm10.45.12a3,3,0,1,0-3,3A3,3,0,0,0,10.48,7.5Zm3.44,0a9.84,9.84,0,0,0-3.29-2.28,3.92,3.92,0,0,1,0,4.6A10.46,10.46,0,0,0,13.92,7.5ZM4.37,5.21A10,10,0,0,0,1.09,7.5,9.86,9.86,0,0,0,4.37,9.79,3.92,3.92,0,0,1,4.37,5.21Z" transform="translate(-0.03 -3.64)"/><path d="M7.5,6A1.49,1.49,0,1,1,6,7.49,1.49,1.49,0,0,1,7.5,6ZM8.11,7.5a.62.62,0,0,0-1.23,0,.62.62,0,1,0,1.23,0Z" transform="translate(-0.03 -3.64)"/></svg>

        <svg  id="addScience" class="iconOff" width="25px" height="26px" viewBox="0 0 13.77 14.84" style="cursor: pointer;" ><path d="M14.37,10.12a3.86,3.86,0,0,0-.67-1.69c-.15-.23-.32-.45-.49-.67L13,7.49l.11-.13a6.39,6.39,0,0,0,1-1.54,2.64,2.64,0,0,0,.26-1.34A1.72,1.72,0,0,0,13.05,3a4.89,4.89,0,0,0-2-.11l-.5.07-.15,0,0-.1c-.05-.13-.09-.25-.14-.37a.12.12,0,0,1,0-.17,1.05,1.05,0,0,0,.07-1.2A1,1,0,0,0,9.17.62.25.25,0,0,1,8.92.55,1.73,1.73,0,0,0,7.37.12a2.09,2.09,0,0,0-1.1.7,5.85,5.85,0,0,0-1.11,2l0,.14H5.05l-.2,0a5.77,5.77,0,0,0-2.2,0,2,2,0,0,0-1.31.86,2,2,0,0,0-.15,1.58A4.93,4.93,0,0,0,2,6.86c.12.16.24.32.37.47l.13.17-.07.1-.28.33-.18.26-.17.24H1.71A1.05,1.05,0,0,0,1,10.33a.2.2,0,0,1,.06.11A1.7,1.7,0,0,0,2.27,12a4.56,4.56,0,0,0,2.19.17l.48-.07.15,0c0,.1.09.21.13.31.11.25.22.52.35.77a3.67,3.67,0,0,0,1.14,1.43,1.8,1.8,0,0,0,1,.35,1.72,1.72,0,0,0,1-.35,3.66,3.66,0,0,0,.55-.5,5.7,5.7,0,0,0,1-1.94c0-.07,0-.08.13-.06a6.39,6.39,0,0,0,1.83.12.16.16,0,0,1,.14.05,1,1,0,0,0,1.27.2,1.06,1.06,0,0,0,.51-1.2.32.32,0,0,1,0-.14A1.84,1.84,0,0,0,14.37,10.12ZM2.74,11.3A1.92,1.92,0,0,1,2.17,11a.64.64,0,0,1-.25-.46,1.07,1.07,0,0,0,.57-1.72L3,8.12l0,0,.21.18c.21.19.41.37.62.54s.23.19.35.28l.26.2a.36.36,0,0,1,.07.09c.08.53.17,1,.26,1.59l0,.3A4.7,4.7,0,0,1,2.74,11.3Zm.83-3.79.87-.78V8.27ZM4.81,4c0,.28-.11.55-.16.82l-.06.43c0,.11,0,.22,0,.33s0,.09,0,.1l-1.18,1L3,6.92a4.45,4.45,0,0,1-1.12-2,.92.92,0,0,1,.58-1.1,3.16,3.16,0,0,1,.86-.18,2.17,2.17,0,0,1,.36,0,6.15,6.15,0,0,1,1.16.13Zm5-.09L10.05,5,8.73,4.27h0l.32-.12L9.61,4ZM7,1.27A1.17,1.17,0,0,1,7.56.91a1,1,0,0,1,.87.28,1,1,0,0,0,.92,1.52c.06,0,.07,0,.09.07s.07.19.11.29l0,.07h0l-.22.07-1.52.55a.24.24,0,0,1-.11,0L6.29,3.25l-.38-.14A4.85,4.85,0,0,1,7,1.27ZM5.66,3.9l1.09.36L5.43,5ZM5.42,10l1.33.77-1.1.37Zm3.19,3.68a1.37,1.37,0,0,1-.69.44,1,1,0,0,1-1-.34A4.2,4.2,0,0,1,6,12.25c0-.1-.08-.2-.11-.3l0-.08.25-.08.72-.24.47-.19.34-.13a.15.15,0,0,1,.11,0l1.54.55.27.1A5.12,5.12,0,0,1,8.61,13.65ZM9.83,11.1l-1.11-.36L10.05,10Zm.4-3.24c0,.32,0,.63-.05,1A.18.18,0,0,1,10.1,9a14.36,14.36,0,0,1-2.29,1.32.2.2,0,0,1-.15,0A15.91,15.91,0,0,1,5.36,9a.15.15,0,0,1-.06-.11,15.22,15.22,0,0,1,0-2.7.18.18,0,0,1,0-.08A14.63,14.63,0,0,1,7.68,4.72H7.8A16.71,16.71,0,0,1,10.11,6a.21.21,0,0,1,.08.16c0,.34,0,.67,0,1v.66Zm2.5-4.16.16,0a1,1,0,0,1,.67,1.19,3.83,3.83,0,0,1-.67,1.42l-.32.42-.12.13-.18-.16-.55-.49-.42-.33L11,5.7a.36.36,0,0,1-.07-.09c-.09-.52-.17-1.05-.26-1.58l0-.32A5,5,0,0,1,12.73,3.7ZM11.9,7.51,11,8.28V6.73Zm.74,3.1a1,1,0,0,0-.5.78,5.53,5.53,0,0,1-1.53-.11l.08-.41c.06-.34.13-.67.19-1v0a.78.78,0,0,0,0-.22c0-.17.07-.27.24-.4s.61-.51.91-.77l.34-.29,0,0,.07.09a3.68,3.68,0,0,1,1.06,2.35A1,1,0,0,0,12.64,10.61Z" transform="translate(-0.62 -0.08)"/><path d="M7.75,6.1a1.4,1.4,0,1,0,0,2.8,1.4,1.4,0,0,0,0-2.8Z" transform="translate(-0.62 -0.08)"/></svg>

        <svg id="pub" class="iconOff"  width="4.64" height="17.15" viewBox="0 0 4.64 17.15" style="cursor: pointer;" ><path d="M306.24,398.45a1.83,1.83,0,0,0,1.86-1.8l.46-6.74a2.32,2.32,0,0,0-4.64,0l.46,6.74A1.83,1.83,0,0,0,306.24,398.45Z" transform="translate(-303.92 -387.66)"/><path d="M306.24,400.32a2.25,2.25,0,1,0,2.32,2.25A2.29,2.29,0,0,0,306.24,400.32Z" transform="translate(-303.92 -387.66)"/></svg>


          <svg id="success" class="iconOff"  width="22" height="22" viewBox="0 0 15 15" ><defs><style>.cls-1{stroke-width:0px;}</style></defs><path class="cls-1" d="m7.5,0C3.36,0,0,3.36,0,7.5s3.36,7.5,7.5,7.5,7.5-3.36,7.5-7.5S11.64,0,7.5,0Zm-1.27,11.01l-3.49-3.35.88-.91,2.59,2.47,5.14-5.24.9.89-6.02,6.13Z"/></svg>
   
  <svg id="unsuccessful" class="iconOff" width="22" height="22" viewBox="0 0 15 15" ><defs><style>.cls-1{stroke-width:0px;}</style></defs><path class="cls-1" d="m7.5,0C3.36,0,0,3.36,0,7.5s3.36,7.5,7.5,7.5,7.5-3.36,7.5-7.5S11.64,0,7.5,0Zm3.02,11.41l-3.01-2.99-2.99,3.02-.92-.92,2.98-3.01-3.01-2.99.92-.92,3.01,2.98,2.98-3.01.93.92-2.98,3.01,3.01,2.98-.92.93Z"/></svg>
        </div>
    </div>`;
    const ts5 = document.createElement('td');
    const ts1 = document.createElement('td');
    const ts1Input = divAtt('input', 'type', 'text');
    ts1Input.setAttribute('class', 'searchInputTable searchInp');
    ts1Input.setAttribute('placeholder', 'Search by job Number');
    ts1Input.setAttribute('id', 'rfcSearch');
    const ts2 = document.createElement('td');
    const ts2Input = divAtt('input', 'type', 'text');
    ts2Input.setAttribute('placeholder', 'Search by candidate');
    ts2Input.setAttribute('class', 'searchInputTable searchInp');
    ts2Input.setAttribute('id', 'canSearch');
    const ts3 = document.createElement('td');
    const ts3Input = divAtt('input', 'type', 'text');
    ts3Input.setAttribute('class', 'searchInputTable searchInp');
    ts3Input.setAttribute('placeholder', 'Search by job title');
    ts3Input.setAttribute('id', 'jobTitleSearch');
    const ts4 = document.createElement('td');
    const ts4Input = divAtt('input', 'type', 'text');
    ts4Input.setAttribute('class', 'searchInputTable searchInp');
    ts4Input.setAttribute('placeholder', 'Search by position');
    ts4Input.setAttribute('id', 'posSearch');
    const ts6 = document.createElement('td');
    const ts6Input = divAtt('input', 'type', 'text');
    ts6Input.setAttribute('class', 'searchInputTable searchInp');
    ts6Input.setAttribute('placeholder', 'Search by line manager');
    ts6Input.setAttribute('id', 'lineManSearch');
    const ts8 = document.createElement('td');
    const ts8Input = divAtt('input', 'type', 'text');
    ts8Input.setAttribute('class', 'searchInputTable searchInp');
    ts8Input.setAttribute('placeholder', 'Search by status');
    ts8Input.setAttribute('id', 'statusSearch');

    // ==========Add pending activity search here
    const ts7 = document.createElement('td');
    ts7.innerHTML = `<div class="iconGrid">

        <svg id="MFE" class="iconOff addSerIcons" style="cursor: pointer;"  width="15.02" height="7.95" viewBox="0 0 15.02 7.95"><polygon points="4.01 4.52 1.66 0 0 0 0 7.95 1.54 7.95 1.54 2.69 3.59 6.6 4.43 6.6 6.48 2.69 6.48 7.95 8.02 7.95 8.02 0 6.38 0 4.01 4.52"/><polygon points="15.02 1.35 15.02 0 9.68 0 9.68 7.95 11.22 7.95 11.22 4.66 14.38 4.66 14.38 3.4 11.22 3.4 11.22 1.35 15.02 1.35"/></svg>


     <svg id="CFE" class="iconOff addSerIcons" style="cursor: pointer;"  width="15.05" height="8.98" viewBox="0 0 15.05 8.98"><path d="m6.13,6.73c-.17.17-.35.31-.54.42-.2.11-.4.19-.62.24s-.42.07-.62.07c-.38,0-.73-.08-1.05-.25s-.59-.39-.82-.66-.41-.59-.53-.95c-.12-.36-.19-.74-.19-1.13,0-.35.05-.7.16-1.05.11-.35.27-.67.48-.95s.48-.51.8-.68c.32-.17.7-.26,1.13-.26.2,0,.4.02.61.07s.41.12.6.22c.19.1.37.23.54.41s.31.38.42.63l1.32-.91c-.29-.57-.73-1.04-1.33-1.4-.59-.36-1.3-.54-2.12-.54-.69,0-1.31.13-1.85.39s-1,.59-1.37,1.01c-.37.42-.66.89-.85,1.42-.2.53-.29,1.06-.29,1.6s.11,1.12.32,1.67.51,1.03.89,1.46.83.78,1.35,1.04c.52.27,1.1.4,1.73.4.36,0,.72-.05,1.1-.14.37-.09.73-.23,1.05-.4s.62-.39.89-.64c.26-.25.46-.55.61-.88l-1.41-.81c-.1.24-.23.45-.4.62Z"/><polygon points="15.05 1.56 15.05 .05 9.1 .05 9.1 8.91 10.82 8.91 10.82 5.24 14.34 5.24 14.34 3.84 10.82 3.84 10.82 1.56 15.05 1.56"/></svg>



        <svg id="CDR" class="iconOff addSerIcons" style="cursor: pointer;" width="23.46" height="8.37" viewBox="0 0 23.46 8.37"><path d="m5.7,6.27c-.15.16-.32.29-.51.39-.18.1-.37.17-.57.22s-.4.07-.58.07c-.36,0-.68-.08-.98-.23s-.55-.36-.77-.62-.38-.55-.49-.89c-.12-.34-.17-.69-.17-1.05,0-.33.05-.65.15-.98.1-.33.25-.62.45-.88s.44-.47.74-.63c.3-.16.65-.24,1.05-.24.19,0,.38.02.57.06s.38.11.56.2c.18.09.34.22.5.38s.29.35.4.59l1.23-.85c-.27-.53-.68-.97-1.24-1.3-.55-.33-1.21-.5-1.97-.5-.64,0-1.22.12-1.72.36-.5.24-.93.55-1.28.94-.35.39-.61.83-.8,1.32-.18.49-.27.99-.27,1.49s.1,1.04.3,1.55c.2.51.47.96.82,1.36s.77.72,1.26.97c.49.25,1.03.37,1.62.37.33,0,.67-.04,1.02-.13.35-.09.68-.21.98-.37.31-.16.58-.36.82-.6s.43-.51.56-.82l-1.31-.76c-.09.22-.22.42-.37.57Z"/><path d="m14.51,1.26c-.34-.37-.77-.67-1.27-.88-.51-.22-1.1-.33-1.77-.33h-3v8.25h3c.62,0,1.18-.1,1.68-.3s.93-.48,1.28-.84.63-.79.82-1.3.28-1.07.28-1.7c0-.57-.09-1.1-.26-1.6-.17-.5-.43-.94-.77-1.31Zm-.76,3.99c-.11.33-.27.62-.47.87-.21.24-.46.44-.77.57-.31.14-.66.21-1.05.21h-1.39V1.45h1.39c.39,0,.73.07,1.04.2.31.13.56.32.77.56.21.24.37.53.48.86.11.33.16.7.16,1.09s-.05.75-.16,1.08Z"/><path d="m21.58,5.19c.46-.19.82-.51,1.09-.95.27-.44.4-.92.4-1.46,0-.33-.07-.66-.2-.99-.13-.33-.31-.62-.55-.88-.23-.26-.51-.47-.83-.63s-.67-.24-1.05-.24h-3.65v8.25h1.6v-2.77h1.58l1.69,2.77h1.8l-1.88-3.1Zm-.21-1.88c-.05.16-.13.3-.22.42-.09.12-.2.22-.33.28s-.27.1-.41.1h-2.01V1.45h1.94c.14,0,.28.03.41.1.14.07.26.16.36.28s.19.26.25.42c.06.16.09.34.09.53s-.03.36-.08.52Z"/></svg>


            <svg id="MCG" class="iconOff addSerIcons" style="cursor: pointer;" width="29.41" height="9.86" viewBox="0 0 29.41 9.86"><defs><style>.cls-1{stroke-width:0px;}</style></defs><polygon class="cls-1" points="4.89 5.59 2.02 .07 0 .07 0 9.78 1.89 9.78 1.89 3.35 4.39 8.14 5.41 8.14 7.92 3.35 7.92 9.78 9.8 9.78 9.8 .07 7.79 .07 4.89 5.59"/><path class="cls-1" d="m17.95,7.39c-.18.19-.38.34-.59.46-.21.12-.44.2-.68.26s-.47.08-.68.08c-.42,0-.8-.09-1.16-.27s-.65-.42-.9-.72-.44-.65-.58-1.05c-.14-.4-.2-.81-.2-1.24,0-.38.06-.77.18-1.16.12-.39.29-.73.53-1.04s.52-.55.87-.74c.35-.19.76-.29,1.24-.29.22,0,.44.02.67.08s.45.13.66.24c.21.11.41.26.59.44s.34.42.47.69l1.45-1c-.32-.63-.8-1.14-1.46-1.53C17.69.21,16.92.01,16.02.01c-.76,0-1.43.14-2.02.42-.59.28-1.09.65-1.5,1.11-.41.46-.72.97-.94,1.55-.21.58-.32,1.16-.32,1.76s.12,1.23.35,1.82c.23.6.56,1.13.97,1.6s.91.85,1.48,1.14c.57.29,1.21.44,1.9.44.39,0,.79-.05,1.2-.15.41-.1.8-.25,1.16-.44.36-.19.68-.43.97-.7s.51-.6.66-.96l-1.55-.89c-.11.26-.26.49-.44.68Z"/><path class="cls-1" d="m25.9,4.79v1.38h1.95v.68c-.76.88-1.6,1.33-2.54,1.33-.41,0-.79-.08-1.14-.25s-.65-.4-.91-.69c-.26-.29-.46-.64-.6-1.03-.15-.4-.22-.82-.22-1.28s.07-.85.2-1.24c.13-.39.32-.74.56-1.04s.53-.54.87-.71c.34-.17.72-.26,1.13-.26.52,0,1,.13,1.44.38.44.26.79.62,1.03,1.11l1.41-1.04c-.33-.65-.82-1.16-1.47-1.55-.65-.38-1.43-.57-2.34-.57-.67,0-1.3.13-1.87.39-.57.26-1.07.61-1.5,1.05s-.76.96-1,1.55c-.24.59-.36,1.21-.36,1.88,0,.7.12,1.36.36,1.96s.57,1.13.98,1.58c.41.45.9.8,1.46,1.05.56.26,1.16.38,1.8.38,1.03,0,1.93-.39,2.71-1.16v1.09h1.56v-4.99h-3.51Z"/></svg>
       
       <div>`;

    //         ts7.innerHTML = `
    //     <svg id="penAct" class="iconOff" onclick="applications.searchFiltersPenAct()" style="cursor: pointer;"  width="20.34" height="15" viewBox="0 0 20.34 15"><polygon class="cls-1" points="18.42 0 7.43 11.19 1.89 5.91 0 7.84 7.46 15 20.34 1.9 18.42 0"/></svg>
    //    `;

    const ts9 = document.createElement('td');
    const clearBtn = divAtt('button', 'id', 'clearSearchBtn');
    clearBtn.setAttribute('class', 'clearBtn');
    clearBtn.innerHTML = '<svg  width="13.58" height="13.58" viewBox="0 0 13.58 13.58"><defs><style>.a{fill:#231f20;}</style></defs><polygon class="a" points="12.53 13.53 13.58 12.47 7.84 6.78 13.53 1.05 12.47 0 6.79 5.74 1.05 0.06 0 1.1 5.74 6.79 0.05 12.53 1.1 13.58 6.8 7.84 12.53 13.53"/></svg> Clear Search';

    const ts10 = document.createElement('td');

    ts1.appendChild(ts1Input);
    ts2.appendChild(ts2Input);
    ts3.appendChild(ts3Input);
    ts4.appendChild(ts4Input);
    ts6.appendChild(ts6Input);
    ts8.appendChild(ts8Input);
    ts9.appendChild(clearBtn);
    searchRow.appendChild(ts10);
    searchRow.appendChild(ts0);
    searchRow.appendChild(ts5);
    searchRow.appendChild(ts1);
    searchRow.appendChild(ts2);
    searchRow.appendChild(ts3);
    searchRow.appendChild(ts4);
    searchRow.appendChild(ts6);
    searchRow.appendChild(ts8);
    searchRow.appendChild(ts7);
    searchRow.appendChild(ts9);

    return searchRow;
  }

  static async getGAPApplicants(displaypage, displayListCount) {
    const obj = {};
    obj.rfcSearch = id('rfcSearch').value;
    obj.canSearch = id('canSearch').value;
    obj.jobTitleSearch = id('jobTitleSearch').value;
    obj.posSearch = id('posSearch').value;
    obj.posLevelSearch = ''; //id('posLevelSearch').value;
    obj.lineManSearch = id('lineManSearch').value;
    obj.HclientID = id('clientDD').value;
    obj.statusSearch = id('statusSearch').value;
    obj.genSearch = id('genSearch').value;
    obj.expSearch = id('exp').classList.contains('iconOn') ? true : false;
    obj.addSearch = id('addSer').classList.contains('iconOn') ? true : false;
    obj.supervisionSearch = id('addSuper').classList.contains('iconOn') ? true : false;
    obj.scientistSearch = id('addScience').classList.contains('iconOn') ? true : false;
    obj.publishedSearch = id('pub').classList.contains('iconOn') ? true : false;
    obj.HclientID = id('clientDD').value;
    obj.SRsearch = false;
    obj.lastUpdateSearch = ''; // id('dateSearch').value;

    let success = '';
    if (id('unsuccessful').classList.contains('iconOn')) {
      success = 'Unsuccessful';
    } else if (id('success').classList.contains('iconOn')) {
      success = 'Successful';
    }
    obj.successfulAppYN = success;

    //  obj.pendingActSearch = id('penAct').classList.contains('iconOn') ? true : false;
    obj.pendingActSearch = false;
    obj.MFEsearch = id('MFE').classList.contains('iconOn') ? true : false;
    obj.CFEsearch = id('CFE').classList.contains('iconOn') ? true : false;
    obj.CDRsearch = id('CDR').classList.contains('iconOn') ? true : false;
    obj.MCGsearch = id('MCG').classList.contains('iconOn') ? true : false;

    const vars = {};
    vars.applicationState = id('applicationState').value ? id('applicationState').value : 'o';
    vars.displaypage = displaypage || 1;
    vars.displayListCount = displayListCount || 50;
    vars.searchObj = JSON.stringify(obj) || JSON.stringify({});
    hide('pagDiv');

    let returnData;
    await PREP(['getGenericApplications'], vars, 'Searching... Please wait')
      .then((res) => {
        returnData = res.data.getGenericApplications[0].ReturnList;
        let callback = (p1, p2) => {
          ManageApplications.getGAPApplicants(p1, p2);
        };
        pagination(res.data.getGenericApplications[0].pagination[0], callback);
        ManageApplications.populateGAPAppTable(returnData);
      })
      .catch(console.error());
  }

  static async populateGAPAppTable(data) {
    if (data.length) {
      await ManageApplications.buildGapAppBody(data);
      ManageApplications.searchGapTable();
      hide('noApps');
      id('listApplicationsTable').style = 'visibility: visible;';
    } else {
      unhide('noApps');
      id('listApplicationsTable').style = 'visibility: hidden;';
      hide('pagDiv');
    }
  }

  static async buildGapAppBody(data) {
    const tbody = id('appListBody') ? id('appListBody') : divAtt('tbody', 'id', 'appListBody');
    tbody.innerHTML = '';

    if (data.length) {
      for (let row of data) {
        const tr = divAtt('tr', 'class', '');

        const td10 = divAtt('td', 'class', '');
        td10.innerHTML = dateShortFromDateTime(row.applicationCreatedDate);

        const td0 = divAtt('td', 'class', '');
        const iconDiv = divAtt('div', 'style', 'display: flex;');
        const expressImg = divAtt('span', 'class', 'tableIcon');
        expressImg.innerHTML = timerIcon;
        const addSerImg = divAtt('span', 'class', 'tableIcon');
        addSerImg.innerHTML = additionalServicesIcon;
        const superImg = divAtt('span', 'class', 'tableIcon');
        superImg.innerHTML = supervisionIcon;
        const scientistImg = divAtt('span', 'class', 'tableIcon');
        scientistImg.innerHTML = scientistIcon;
        const successImg = divAtt('div', 'style', 'margin-left: 12px;');
        successImg.innerHTML = tickCircleSVG;
        const unsuccessImg = divAtt('div', 'style', 'margin-left: 12px;');
        unsuccessImg.innerHTML = crossCircleSVG;
        const addAssGreenImg = divAtt('div', 'style', 'margin-left: 12px;');
        addAssGreenImg.innerHTML = additionalAssGreenSVG;
        const addAssRedImg = divAtt('div', 'style', 'margin-left: 12px;');
        addAssRedImg.innerHTML = additionalAssRedSVG;

        if (row.expressServiceYN) {
          iconDiv.appendChild(expressImg);
        }
        if (row.additionalServicesYN) {
          iconDiv.appendChild(addSerImg);
        }
        if (row.containsSupervisedAssessmentYN) {
          iconDiv.appendChild(superImg);
        }
        if (row.acanscCombo) {
          iconDiv.appendChild(scientistImg);
        }

        if (row.successfulAppYN === 'Unsuccessful') {
          iconDiv.appendChild(unsuccessImg);
        }
        if (row.successfulAppYN === 'Successful') {
          iconDiv.appendChild(successImg);
        }

        if (row.assAllocYN === 1) {
          iconDiv.appendChild(addAssRedImg);
        } else if (row.assAllocYN === 2) {
          iconDiv.appendChild(addAssGreenImg);
        }

        td0.appendChild(iconDiv);

        const td5 = divAtt('td', 'class', '');
        td5.innerHTML = !row.publishedYN
          ? `<svg id="Layer_1" data-name="Layer 1"  width="4.64" height="17.15" viewBox="0 0 4.64 17.15"><defs><style>.cls-45{fill:#e7242e;}</style></defs><path class="cls-45" d="M306.24,398.45a1.83,1.83,0,0,0,1.86-1.8l.46-6.74a2.32,2.32,0,0,0-4.64,0l.46,6.74A1.83,1.83,0,0,0,306.24,398.45Z" transform="translate(-303.92 -387.66)"/><path class="cls-45" d="M306.24,400.32a2.25,2.25,0,1,0,2.32,2.25A2.29,2.29,0,0,0,306.24,400.32Z" transform="translate(-303.92 -387.66)"/></svg>`
          : '';

        const td1 = divAtt('td', 'class', '');
        td1.innerHTML = row.RFCNumber;
        const td2 = divAtt('td', 'class', '');
        td2.innerHTML = row.candidateFname + ' ' + row.candidatesname;
        const td3 = divAtt('td', 'class', '');
        td3.innerHTML = row.clientjobTitle;
        const td4 = divAtt('td', 'class', '');
        td4.innerHTML = row.clientpositionID;
        const td6 = divAtt('td', 'class', '');
        td6.innerHTML = row.lineManagerfname + ' ' + row.linemanagerSname;
        const td8 = divAtt('td', 'class', '');
        td8.innerHTML = row.status;
        const td7 = divAtt('td', 'class', '');

        const activityDiv = divAtt('div', 'class', 'iconGrid');
        activityDiv.style.fill = 'var(--primaryColor)';
        if (row.additionalServiceKEYList.length) {
          let cfImg = row.additionalServiceKEYList.includes('CFE') ? 1 : 0;
          let mfImg = row.additionalServiceKEYList.includes('MFE') ? 1 : 0;
          let cdrImg = row.additionalServiceKEYList.includes('CDR') ? 1 : 0;
          let mcgImg = row.additionalServiceKEYList.includes('MCG') ? 1 : 0;

          activityDiv.innerHTML = `${cfImg ? cfSVG : ''} ${mfImg ? mfSVG : ''} ${cdrImg ? cdrSVG : ''} ${mcgImg ? mcgfSVG : ''}`;
          td7.appendChild(activityDiv);
        } else {
          const pendActivity = divAtt('img', 'src', `${greyCross}`);
          td7.appendChild(pendActivity);
        }
        // const pendActivity = row.activityInProgressYN ? divAtt('img', 'src', `${tickIcon}`) : divAtt('img', 'src', `${greyCross}`);

        const td9 = divAtt('td', 'class', '');
        const params = row.HapplicationID;
        const btn = divAtt('button', 'onclick', 'PREP("viewAppDetails", "HAPPLICATIONID=' + params + '")');
        ('HclientID=${row}');
        btn.classList.add('btn');
        btn.innerHTML = 'view';
        td9.appendChild(btn);

        tr.appendChild(td10);
        tr.appendChild(td0);
        tr.appendChild(td5);
        tr.appendChild(td1);
        tr.appendChild(td2);
        tr.appendChild(td3);
        tr.appendChild(td4);
        tr.appendChild(td6);
        tr.appendChild(td8);
        tr.appendChild(td7);
        tr.appendChild(td9);
        tbody.appendChild(tr);
      }
      unhide('searchSpace');
    }
    id('listApplicationsTable').appendChild(tbody);
  }

  static searchGapTable() {
    const searchInp = document.querySelectorAll('.searchInp');
    searchInp.forEach((sInp) => {
      let timeout;
      sInp.addEventListener('keyup', () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          ManageApplications.getGAPApplicants(1, 50);
        }, 1500);
      });
    });
  }
}

export class ViewAppDetails {
  constructor(vars) {
    this.name = 'View Application Detail';
    this.pageTier = 15;
    this.reference = 'viewAppDetails';
    this.pageID = null;
    this.data = null;
    this.applicationID = vars.HAPPLICATIONID;
  }

  initPage(data) {
    // Set page pecific variables
    this.appDetail = data.getApplicationDetail;
    this.HclientID = data.getApplicationDetail[0].HclientID;
    // this.appHistory = data.getApplicationHistory;
    this.appHistory2 = data.getApplicationHistory2;
    this.addServices = data.getAdditionalServices;
    this.feedbackRequestor = data.getFeedbackRequestor;
    this.reportAllocToApp = cObj(data.getReportsAllocatedToApplication);
    this.addServicesAlloc = cObj(data.getAdditionalServicesAllocated);
    this.getAdditionalAssOpts = data.getAdditionalAssOpts;
    // this.getClientDetails = data.getClientDetails[0];
    if (data.listAllocatedAssessmentOne.length) {
      if (data.listAllocatedAssessmentOne[0].assListArray) {
        this.appAss = data.listAllocatedAssessmentOne[0].assListArray;
      } else {
        this.appAss = data.listAllocatedAssessmentOne;
      }
    } else {
      this.appAss = data.listAllocatedAssessmentOne;
    }

    this.loadPage();
  }

  async loadPage() {
    this.viewDetailPage();
  }

  viewDetailPage() {
    this.viewDetail();
    this.listAssessments();
    this.buildReportList(this.reportAllocToApp);
    this.listHistory();
    ViewAppDetails.appResult();

    const addAssList = this.getAdditionalAssOpts;
    console.log('addAssList', addAssList);
    buildDropDownMain(addAssList, 'addAssDD', 'HassessmentID', 'shortName');
    // this.listAdditionalAss() if they want to list on page -future thangs @steph

    //Additional Services ===
    if (this.appDetail[0].HclientID == 40) {
      unhide('appDetailsAdditionalServicesBox');
      additionalService.buildAssSerCheckboxes1(this.addServices, this.feedbackRequestor, this.HclientID);
      if (this.addServicesAlloc.length) {
        additionalService.allocatedServices(this.addServicesAlloc, 1);
      } else {
        additionalService.allocatedServices(this.addServicesAlloc);
      }
    } else {
      hide('appDetailsAdditionalServicesBox');
    }
  }

  viewDetail() {
    const data = this.appDetail[0];

    //General Info ================
    id('status1').innerHTML = data.status;
    id('lastUpdatedBy').innerHTML = !data.lastUpdaterText ? `N/A` : data.lastUpdaterText;
    id('lastUpdatedDate').innerHTML = !data.lastupdated ? '' : ` on ${dateFromDateTime(data.lastupdated)}`;
    id('status').innerHTML = data.status; //(History)
    id('actStatus').innerHTML = data.latestActivity;

    //Candidate Details ===========
    id('c_name').innerHTML = `${data.candidateFname} ${data.candidatesname}`;
    id('c_mobile').innerHTML = data.candidateMobilenumber;
    id('c_eMail').innerHTML = data.candidateEmail;
    id('c_comments').innerHTML = data.clientcomments;
    id('c_dob').innerHTML = formatDate(data.candidateDOB);

    //Position Details ============
    const profs = id('professional');
    profs.innerHTML = '';
    if (!data.Profs) {
      profs.innerHTML = '';
    } else if (data.Profs.length > 1) {
      for (let prof of data.Profs) {
        const li = divAtt('li', 'class', '');
        li.innerHTML = `${prof.fname} ${prof.sname}`;
        profs.appendChild(li);
      }
    } else {
      profs.innerHTML = `${data.Profs[0].fname} ${data.Profs[0].sname}`;
    }
    if (this.HclientID == 42) {
      id('EmployeeID').innerHTML = 'Employee/Application ID:';

      if (data.jobID) {
        unhide('jobIDLabel');
        id('jobID').innerHTML = data.clientjobID;
        unhide('jobID');
      }
    }
    id('RFCnumber').innerHTML = data.RFCNumber;
    id('jobTitle').innerHTML = data.clientjobTitle;
    id('positionLevel').innerHTML = data.positionLevel;
    id('jobGrade').innerHTML = data.GAPjobgrade;
    id('jobfamily').innerHTML = data.jobFamilyName;
    id('funcArea').innerHTML = data.GAPJobfunctionarea;
    id('businessDivision').innerHTML = data.division;
    if (data.agency === 'internalDev') {
      id('agency').innerHTML = 'Internal Development';
    } else {
      id('agency').innerHTML = data.agency;
    }
    if (data.hireResource === 'internalDev') {
      id('hireResource').innerHTML = 'Internal Development';
    } else {
      id('hireResource').innerHTML = data.hireResource;
    }
    id('internalExternal').innerHTML = data.internalExternal;

    // id('jobObjectives').innerHTML = data.jobobjectives;
    const objectivesDiv = id('jobObjectives');
    objectivesDiv.innerHTML = '';
    if (!data.objectives) {
      objectivesDiv.innerHTML = '';
    } else if (data.objectives.length > 1) {
      for (let objctv of data.objectives) {
        const li = divAtt('li', 'class', '');
        li.innerHTML = objctv.shortName;
        objectivesDiv.appendChild(li);
      }
    } else {
      objectivesDiv.innerHTML = data.objectives.shortName;
    }

    id('purpose').innerHTML = data.purpose;
    id('costCentre').innerHTML = data.costCenter;
    id('lineManager').innerHTML = `${data.lineManagerfname} ${data.linemanagerSname}`;
    id('lineManagerEmail').innerHTML = data.lineManagerEmail;
    const fname = data.recruiterfname !== null ? data.recruiterfname : '';
    const sname = data.recruitersname !== null ? data.recruitersname : '';
    id('recruiter').innerHTML = fname + ' ' + sname;
    id('recruiterEmail').innerHTML = data.recruiterEmail;

    if (this.HclientID !== 4) {
      id('GAPDisplayRecruiter').innerHTML = 'HRBP:';
      id('recruiterEmailDisplay').innerHTML = 'HRBP Email:';
    }

    // Assessment Info ==========
    // id("preferedLoc").innerHTML = data.countryname;
    // id("preferedDate").innerHTML = !data.clientrequiredAssessmentDate
    //   ? ""
    //   : dateFromDateTime(data.clientrequiredAssessmentDate);
    // if (data.requiresMPA == 1) {
    //   if (data.MPAIncluded == 1) {
    //     id("MPA").innerHTML = "Included";
    //   } else {
    //     id("MPA").innerHTML = "Not included";
    //   }
    //   unhide("MPAheading");
    //   unhide("MPA");
    // } else {
    //   hide("MPAheading");
    //   hide("MPA");
    // }

    // Cater for client pacific fields
    applications.hideClientPacificFields(this.HclientID);
  }

  // listAssessments() {
  //   const data = this.appAss;
  //   // let data;
  //   // if (this.allocAss) {
  //   //     data = this.allocAss;
  //   // } else {
  //   //     data = this.appAss;
  //   // }

  //   id("assessmentList").innerHTML = "";
  //   for (let el of data) {
  //     const li = divAtt("li", "class", "");
  //     li.innerHTML = !el.bookingdate
  //       ? el.shortname
  //       : el.shortname + " - " + dateFromDateTime(el.bookingdate);
  //     id("assessmentList").appendChild(li);
  //   }
  // }

  async listAssessments() {
    const langObj = {};
    const vars = {};
    vars.HTMLPageName = 'reportHistList';
    vars.languageID = getCookie('mbohvbhfje');

    await PREP(['getHTMLLexicon'], vars).then(async (res) => {
      const lang = res.data.getHTMLLexicon;
      for (let row of lang) {
        langObj[row.marker] = row.display;
      }
    });

    const data = this.appAss;
    const ass = id('assTable');
    ass.innerHTML = '';

    if (data.length) {
      hide('noass');

      const thead = await viewApplication.buildAssHead();
      ass.appendChild(thead);

      for (const el of data) {
        const tr = divAtt('tr');
        const td1 = divAtt('td');
        td1.innerHTML = el.shortname;
        const td2 = divAtt('td');
        td2.innerHTML = el.assStatus;
        const td3 = divAtt('td');
        const bookingDate = el.bookingdate ? dateFromDateTime(el.bookingdate) : el.bookingdate;
        td3.innerHTML = el.lastUpdated ? dateFromDateTime(el.lastUpdated) : bookingDate;
        tr.appendChild(td1);
        tr.appendChild(td2);
        tr.appendChild(td3);
        ass.appendChild(tr);
      }
    } else {
      unhide('noass');
    }
  }

  async listHistory() {
    const data = this.appHistory2;
    const history = id('hidtoryList');
    history.innerHTML = '';

    if (data.length) {
      hide('noHistory');
      viewApplication.buildHistoryTable(data);
    } else {
      unhide('noHistory');
    }
  }

  async buildReportList(reports) {
    const table = id('applicationReports') ? id('applicationReports') : id('userReports');
    table.innerHTML = '';

    if (reports.length) {
      hide('noReports');
      const thead = await viewApplication.listReportHead();
      table.appendChild(thead);

      reports.forEach((rprt) => {
        PREP(['downloadReport'], {
          reportRegisterID: rprt.REPORTREGISTERID,
        })
          .then(async (res) => {
            rprt.url = res.data.downloadReport;
            const tr = await this.listReports(rprt);
            table.appendChild(tr);
            //dynamic events
            rprt.ENCRYPTYN
              ? eListen(
                  'viewRBtn',
                  () => {
                    report.encryptedReport(`${rprt.REPORTREGISTERID}`, `${rprt.ORIGINALFILE}`);
                  },
                  'click'
                )
              : eListen(
                  'viewRBtn',
                  () => {
                    report.download(`${rprt.REPORTREGISTERID}`);
                  },
                  'click'
                );
            eListen(
              'dlHist',
              () => {
                report.reportHistory(`${rprt.REPORTREGISTERID}`, `${rprt.ORIGINALFILE}`); //michael
              },
              'click'
            );
          })
          .catch(console.error());
      });
    } else {
      unhide('noReports');
    }
  }

  async listReports(data) {
    const tr = divAtt('tr', 'class', '');
    const td1 = divAtt('td', 'class', 'reportdate');
    td1.innerHTML = dateFromDateTime(new Date(data.DATEON));
    const td2 = divAtt('td', 'class', 'reportUpdater');
    td2.innerHTML = `${data.FNAME} ${data.SNAME}`;
    const td3 = divAtt('td', 'class', 'reporttype');
    td3.innerHTML = data.REPORTTYPE;
    const td7 = divAtt('td', 'class', 'reporttype');
    td7.innerHTML = data.ORIGINALFILE;

    const td4 = divAtt('td', 'class', 'center');
    if (data.ENCRYPTYN) {
      const encryptIcon = divAtt('div', 'class', 'iconTable');
      encryptIcon.innerHTML = keyEncrypt;
      td4.appendChild(encryptIcon);
    }

    const td5 = divAtt('td', 'class', 'reporreporturlttype');
    const btn = divAtt('button', 'class', 'btn');
    addAtt(btn, 'id', 'viewRBtn');
    btn.innerHTML = 'View';
    // if (data.ENCRYPTYN) {
    //   btn.setAttribute(
    //     "onclick",
    //     `report.encryptedReport('${data.REPORTREGISTERID}', '${data.ORIGINALFILE}')`
    //   );
    // } else {
    //   btn.setAttribute(
    //     "onclick",
    //     `report.download('${data.REPORTREGISTERID}')`
    //   );
    // }
    td5.appendChild(btn);

    const td6 = divAtt('td', 'class', 'downloadHistory');
    const histBtn = divAtt('button', 'class', 'btn');
    addAtt(histBtn, 'id', 'dlHist'); //michael
    histBtn.innerHTML = 'Download History';
    // const histBtn = buildBtn(
    //   "dlHist",//id
    //   `report.reportHistory('${data.REPORTREGISTERID}', '${data.ORIGINALFILE}')`,
    //   "Download History"//text
    // );

    td6.appendChild(histBtn);

    tr.appendChild(td1);
    tr.appendChild(td2);
    tr.appendChild(td3);
    tr.appendChild(td7);
    tr.appendChild(td4);
    tr.appendChild(td5);
    tr.appendChild(td6);

    return tr;
  }

  static appResult() {
    const data = pgstr.viewAppDetails.appDetail[0];

    if (data.ApplicationResultRequiredYN == 0 || '') {
      hide('appResultsSection');
    } else {
      unhide('appResultsSection');

      if (data.applicationResultDate) {
        const tr = id('appResultTable');
        const date = divAtt('td');
        date.innerHTML = data.applicationResultDate;
        const by = divAtt('td');
        by.innerHTML = data.applicationresultBy;
        const result = divAtt('td');
        const intEx = data.internalExternal ? data.internalExternal : data.hireResource;
        result.innerHTML = `${data.applicationresult} - ${intEx}`;

        tr.appendChild(date);
        tr.appendChild(by);
        tr.appendChild(result);

        hide('appResultTggl');
        unhide('appResultView');
      } else {
        unhide('appResultTggl');
        hide('appResultView');
      }
    }
  }

  static recordAppResult() {
    const vars = {};
    var radios = document.getElementsByName('appResult');
    for (var i = 0, length = radios.length; i < length; i++) {
      if (radios[i].checked) {
        vars.applicationresult = radios[i].value;
        break;
      }
    }

    // vars.applicationresult = 'Successful';
    vars.HapplicationID = pgstr.viewAppDetails.applicationID;
    // vars.HclientID = pgstr.viewAppDetails.HclientID;
    PREP(['recordApplicationResult'], vars)
      .then((res) => {
        note(res.data.recordApplicationResult);

        PREP(['getApplicationDetail'], vars).then((res) => {
          pgstr.viewAppDetails.appDetail = res.data.getApplicationDetail;
          ViewAppDetails.appResult();
        });
      })
      .catch(console.error());
  }

  static async additionalServicesWarningPopup() {
    console.log('JDBJKDB');
    const msg = 'Please note an additional cost will be incurred by selecting these services';
    warningBox(msg, 'ViewAppDetails.requestAddServicesVR()');
    eListen(
      'infoBoxBtn',
      () => {
        this.requestAddServicesVR();
      },
      'click'
    );
    //btn.setAttribute("onclick", `${onclickFun}`);
  }

  static async requestAddServicesVR() {
    if (id('popupBox')) {
      hide('popupBox');
    }

    const vars = await SAt_addServices.addSerVars(pgstr.viewAppDetails.applicationID);
    if (vars) {
      PREP(['uploadnewrecords'], vars)
        .then((res) => {
          note(res.data.uploadnewrecords);
          vars.HAPPLICATIONID = pgstr.viewAppDetails.applicationID;
          vars.HclientID = 40;
          PREP('viewAppDetails', vars);
        })
        .catch(console.error());
    }
  }

  // Not needed right now @steph
  async listAdditionalAss() {
    const assList = this.addAssList;
    buildDropDownMain(assList, 'userRoleDD', 'DDROLEID', 'DESCRIPTION');

    const listData = this.getRoleAllocReport;
    console.log('getRoleAllocReport', listData);
    // id('reportName').innerHTML = data.SHORTNAME;

    // Build Listy list
    const list = id('msgListy');
    list.innerHTML = '';

    if (listData.length) {
      for (const row of listData) {
        const tr = divAtt('tr');
        const td1 = divAtt('td');
        td1.innerHTML = row.roleName;
        const td3 = divAtt('td');
        const remove = divAtt('span', 'class', 'trash');
        remove.innerHTML = dustbinSVG;
        td3.appendChild(remove);
        tr.appendChild(td1);

        tr.appendChild(td3);
        list.appendChild(tr);
        eListen(
          remove,
          () => {
            ViewAppDetails.removeAdditionalAss(row.allocDDroleHreportTypeID);
          },
          'click'
        );
      }
      unhide('listyTable');
    } else {
      hide('listyTable');
    }
  }

  //Additional Assessment Section
  static async addAdditionalAss() {
    const vars = {};
    vars.HassessmentID = id('addAssDD').value;
    vars.candidateID = pgstr.viewAppDetails.appDetail[0].candidateID;
    vars.HapplicationID = pgstr.viewAppDetails.applicationID;

    if (vars.HassessmentID === '-') {
      return infoBox('Please select an assessment.');
    }

    PREP(['allocateUserToExternalAssessment'], vars)
      .then((res) => {
        note(res.data.allocateUserToExternalAssessment);
      })
      .catch(console.error());
  }
}

// ================== ANGLO APPLICATIONS =============================

export class AngloApplications {
  constructor() {
    this.name = 'Anglo Applications';
    this.pageTier = 10;
    this.reference = 'angloApplications';
    this.pageID = null;
    this.data = null;
  }

  initPage(data) {
    // Set page pecific variables
    this.data = data;
    this.getHTMLLexicon = data.getHTMLLexicon;

    this.loadPage();
  }

  loadPage() {
    this.angloAppsPage();
  }

  async angloAppsPage() {
    id('listApplicationsTable').innerHTML = '';

    const table = id('listApplicationsTable');
    const thead = await this.buildAngloHead();
    table.appendChild(thead);
    const searchRow = await this.buildAngloSearchRow();
    table.appendChild(searchRow);
    eListen(
      'exp',
      () => {
        applications.searchFiltersExpress();
      },
      'click'
    );
    eListen(
      'addSer',
      () => {
        applications.searchFiltersAddSer();
      },
      'click'
    );
    eListen(
      'addSuper',
      () => {
        applications.searchFiltersSuper();
      },
      'click'
    );
    eListen(
      'penAct',
      () => {
        applications.searchFiltersPenAct();
      },
      'click'
    );
    eListen(
      'clearSearchBtn',
      () => {
        applications.clearSearch();
      },
      'click'
    );
    AngloApplications.getAngloApplicants();

    // Set lang stuff
    const langObj = {};
    for (let row of this.getHTMLLexicon) {
      langObj[row.marker] = row.display;
    }
    id('genSearch').setAttribute('placeholder', `${langObj.aal_Mkr5}`);
  }

  async buildAngloHead() {
    const langObj = {};
    const data = this.getHTMLLexicon;
    for (let row of data) {
      langObj[row.marker] = row.display;
    }

    const thead = document.createElement('thead');

    const th0 = document.createElement('th');
    const th5 = document.createElement('th');
    const th1 = document.createElement('th');
    const th2 = document.createElement('th');
    const th3 = document.createElement('th');
    const th4 = document.createElement('th');
    const th6 = document.createElement('th');
    const th7 = document.createElement('th');
    const th8 = document.createElement('th');
    const th9 = document.createElement('th');
    th1.innerHTML = langObj.aal_Mkr7 ? langObj.aal_Mkr7 : 'RFC Number';
    th5.innerHTML = langObj.aal_Mkr31 ? langObj.aal_Mkr31 : 'Job ID';
    th2.innerHTML = langObj.aal_Mkr8 ? langObj.aal_Mkr8 : 'Candidate';
    th3.innerHTML = langObj.aal_Mkr9 ? langObj.aal_Mkr9 : 'Job Title';
    th4.innerHTML = langObj.aal_Mkr10 ? langObj.aal_Mkr10 : 'Position';
    th6.innerHTML = langObj.aal_Mkr11 ? langObj.aal_Mkr11 : 'Line Manager';
    th8.innerHTML = langObj.aal_Mkr12 ? langObj.aal_Mkr12 : 'Status';
    th7.innerHTML = langObj.aal_Mkr13 ? langObj.aal_Mkr13 : 'Pending Activity';
    th9.innerHTML = langObj.aal_Mkr14 ? langObj.aal_Mkr14 : 'Action';

    thead.appendChild(th0);
    thead.appendChild(th1);
    thead.appendChild(th5);
    thead.appendChild(th2);
    thead.appendChild(th3);
    thead.appendChild(th4);
    thead.appendChild(th6);
    thead.appendChild(th8);
    thead.appendChild(th7);
    thead.appendChild(th9);

    return thead;
  }

  async buildAngloSearchRow() {
    // Set lang stuff
    const langObj = {};
    for (let row of this.getHTMLLexicon) {
      langObj[row.marker] = row.display;
    }

    const searchRow = divAtt('tr', 'id', 'trSearch');

    searchRow.setAttribute('class', 'hide');
    const ts0 = document.createElement('td');
    ts0.innerHTML = `<div class="iconGrid">
    <svg  id="exp" class="iconOff" width="24px" height="26" viewBox="0 0 14.84 14.84" style="cursor: pointer;" ><rect x="1.24" y="5.56" width="4.95" height="1.24" rx="0.56"/><rect y="8.04" width="4.95" height="1.24" rx="0.59"/><path d="M7.93,1.69a6.67,6.67,0,0,1,1.61,0A.39.39,0,0,0,10,1.29V.47A.39.39,0,0,0,9.58.08H7.89A.39.39,0,0,0,7.5.47V1.3A.39.39,0,0,0,7.93,1.69Z" transform="translate(-0.08 -0.08)"/><path d="M11.27,5.59,9,7.5a1.27,1.27,0,0,0-1.18.39,1.24,1.24,0,1,0,2.1.44l1.63-2.49Z" transform="translate(-0.08 -0.08)"/><rect x="1.85" y="10.51" width="4.33" height="1.24" rx="0.56"/><path d="M8.74,2.55a6.15,6.15,0,0,0-4.4,1.86h2a4.87,4.87,0,0,1,2.37-.62,4.95,4.95,0,0,1,0,9.89,4.87,4.87,0,0,1-2.37-.62h-2A6.18,6.18,0,1,0,8.74,2.55Z" transform="translate(-0.08 -0.08)"/></svg>

    <svg  id="addSer" class="iconOff" width="25px" height="26px" viewBox="0 0 14.96 14.97" style="cursor: pointer; margin-top: 2px;" ><path d="M5.7,12.16H1.83a.79.79,0,0,1-.89-.89V1.83A.79.79,0,0,1,1.82.94h7a.8.8,0,0,1,.89.89V5.47a.47.47,0,1,0,.93,0c0-1.26,0-2.52,0-3.77A1.7,1.7,0,0,0,8.9,0H1.69A1.69,1.69,0,0,0,.35.68,2,2,0,0,0,0,1.49V11.6l0,.07a1.67,1.67,0,0,0,1.45,1.4,6.58,6.58,0,0,0,.89,0H5.68a.47.47,0,0,0,.48-.3A.46.46,0,0,0,5.7,12.16Z" transform="translate(0 0)"/><path d="M14.91,10.25A4.05,4.05,0,1,0,9.77,14.8c.27.07.54.11.81.17h.67l.42-.08A4,4,0,0,0,14.91,10.25ZM10.9,14A3.12,3.12,0,1,1,14,10.92,3.11,3.11,0,0,1,10.9,14Z" transform="translate(0 0)"/><path d="M2.05,5.81a.73.73,0,0,0,.38.11H8.17a.83.83,0,0,0,.22,0,.42.42,0,0,0,.32-.32A.46.46,0,0,0,8.23,5H2.3a.45.45,0,0,0-.41.32A.42.42,0,0,0,2.05,5.81Z" transform="translate(0 0)"/><path d="M5.71,7.48H2.38A.47.47,0,0,0,1.87,8a.48.48,0,0,0,.52.47H5.72a.47.47,0,1,0,0-.94Z" transform="translate(0 0)"/><path d="M2.39,3.43H5.11A.47.47,0,0,0,5.61,3a.48.48,0,0,0-.51-.47H2.38a.47.47,0,1,0,0,.94Z" transform="translate(0 0)"/><path d="M12.85,10.51a.62.62,0,0,0-.3-.06H11.38V9.23a.47.47,0,0,0-.47-.5.47.47,0,0,0-.47.49v1.22H9.22a.47.47,0,1,0,0,.94h1.22V12.6a.48.48,0,0,0,.48.5.48.48,0,0,0,.46-.5V11.38h1.27a.45.45,0,0,0,.44-.36A.46.46,0,0,0,12.85,10.51Z" transform="translate(0 0)"/></svg>

    <svg  id="addSuper" class="iconOff" width="28px" height="25px" viewBox="0 0 14.93 7.73" style="cursor: pointer;" ><path d="M0,7.38c.31-.34.59-.7.92-1A10.53,10.53,0,0,1,5.38,3.92a8.09,8.09,0,0,1,4.7.14,10.43,10.43,0,0,1,4.71,3.08.46.46,0,0,1,0,.72,10.34,10.34,0,0,1-6,3.39,8.27,8.27,0,0,1-4.53-.54A10.52,10.52,0,0,1,.21,7.86,1.6,1.6,0,0,1,0,7.61Zm10.45.12a3,3,0,1,0-3,3A3,3,0,0,0,10.48,7.5Zm3.44,0a9.84,9.84,0,0,0-3.29-2.28,3.92,3.92,0,0,1,0,4.6A10.46,10.46,0,0,0,13.92,7.5ZM4.37,5.21A10,10,0,0,0,1.09,7.5,9.86,9.86,0,0,0,4.37,9.79,3.92,3.92,0,0,1,4.37,5.21Z" transform="translate(-0.03 -3.64)"/><path d="M7.5,6A1.49,1.49,0,1,1,6,7.49,1.49,1.49,0,0,1,7.5,6ZM8.11,7.5a.62.62,0,0,0-1.23,0,.62.62,0,1,0,1.23,0Z" transform="translate(-0.03 -3.64)"/></svg>

    </div>`;
    const ts1 = document.createElement('td');
    const ts1Input = divAtt('input', 'type', 'text');
    ts1Input.setAttribute('class', 'searchInputTable searchInp');
    ts1Input.setAttribute('placeholder', `${langObj.aal_Mkr16}`); // Search by job number
    ts1Input.setAttribute('id', 'rfcSearch');
    const ts5 = divAtt('td');
    const ts5Input = divAtt('input', 'type', 'text');
    ts5Input.setAttribute('class', 'searchInputTable searchInp');
    ts5Input.setAttribute('placeholder', `${langObj.aal_Mkr32}`); //Search by JobID
    ts5Input.setAttribute('id', 'jobIDSearch');
    const ts2 = document.createElement('td');
    const ts2Input = divAtt('input', 'type', 'text');
    ts2Input.setAttribute('placeholder', `${langObj.aal_Mkr17}`); //Search by candidate
    ts2Input.setAttribute('class', 'searchInputTable searchInp');
    ts2Input.setAttribute('id', 'canSearch');
    const ts3 = document.createElement('td');
    const ts3Input = divAtt('input', 'type', 'text');
    ts3Input.setAttribute('class', 'searchInputTable searchInp');
    ts3Input.setAttribute('placeholder', `${langObj.aal_Mkr18}`); //'Search by job title');
    ts3Input.setAttribute('id', 'jobTitleSearch');
    const ts4 = document.createElement('td');
    const ts4Input = divAtt('input', 'type', 'text');
    ts4Input.setAttribute('class', 'searchInputTable searchInp');
    ts4Input.setAttribute('placeholder', `${langObj.aal_Mkr19}`); // 'Search by position');
    ts4Input.setAttribute('id', 'posSearch');

    const ts6 = document.createElement('td');
    const ts6Input = divAtt('input', 'type', 'text');
    ts6Input.setAttribute('class', 'searchInputTable searchInp');
    ts6Input.setAttribute('placeholder', `${langObj.aal_Mkr20}`); //'Search by line manager');
    ts6Input.setAttribute('id', 'lineManSearch');

    const ts8 = document.createElement('td');
    const ts8Input = divAtt('input', 'type', 'text');
    ts8Input.setAttribute('class', 'searchInputTable searchInp');
    ts8Input.setAttribute('placeholder', `${langObj.aal_Mkr21}`); //'Search by status');
    ts8Input.setAttribute('id', 'statusSearch');

    const ts7 = document.createElement('td');
    ts7.innerHTML = `
    <svg id="penAct" class="iconOff"  style="cursor: pointer;"  width="20.34" height="15" viewBox="0 0 20.34 15"><polygon class="cls-1" points="18.42 0 7.43 11.19 1.89 5.91 0 7.84 7.46 15 20.34 1.9 18.42 0"/></svg>
   `;
    // <div class="iconGrid"> </div>

    const ts9 = document.createElement('td');
    const clearBtn = divAtt('button', 'id', 'clearSearchBtn');
    clearBtn.setAttribute('class', 'clearBtn');
    clearBtn.innerHTML = `<svg  width="13.58" height="13.58" viewBox="0 0 13.58 13.58"><defs><style>.a{fill:#231f20;}</style></defs><polygon class="a" points="12.53 13.53 13.58 12.47 7.84 6.78 13.53 1.05 12.47 0 6.79 5.74 1.05 0.06 0 1.1 5.74 6.79 0.05 12.53 1.1 13.58 6.8 7.84 12.53 13.53"/></svg> ${langObj.aal_Mkr22}`;
    //clear search

    ts1.appendChild(ts1Input);
    ts5.appendChild(ts5Input);
    ts2.appendChild(ts2Input);
    ts3.appendChild(ts3Input);
    ts4.appendChild(ts4Input);

    ts6.appendChild(ts6Input);
    ts8.appendChild(ts8Input);
    ts9.appendChild(clearBtn);
    searchRow.appendChild(ts0);
    searchRow.appendChild(ts1);
    searchRow.appendChild(ts5);
    searchRow.appendChild(ts2);
    searchRow.appendChild(ts3);
    searchRow.appendChild(ts4);
    searchRow.appendChild(ts6);
    searchRow.appendChild(ts8);
    searchRow.appendChild(ts7);
    searchRow.appendChild(ts9);

    return searchRow;
  }

  static async getAngloApplicants(displaypage, displayListCount) {
    const obj = {};
    obj.rfcSearch = id('rfcSearch').value;
    obj.canSearch = id('canSearch').value;
    obj.jobTitleSearch = id('jobTitleSearch').value;
    obj.posSearch = id('posSearch').value;
    obj.posLevelSearch = ''; //id('posLevelSearch').value;
    obj.lineManSearch = id('lineManSearch').value;
    obj.HclientID = id('clientDD').value;
    obj.statusSearch = id('statusSearch').value;
    obj.genSearch = id('genSearch').value;
    obj.expSearch = id('exp').classList.contains('iconOn') ? true : false;
    obj.addSearch = id('addSer').classList.contains('iconOn') ? true : false;
    obj.supervisionSearch = id('addSuper').classList.contains('iconOn') ? true : false;
    obj.scientistSearch = false;
    obj.pendingActSearch = id('penAct').classList.contains('iconOn') ? true : false;
    obj.clientjobID = id('jobIDSearch').value;
    // obj.publishedSearch = id('pub').classList.contains('iconOn') ? false : true;

    const vars = {};
    vars.applicationState = id('applicationState').value ? id('applicationState').value : 'o'; //id('applicationState').value ? id('applicationState').value :
    vars.displaypage = displaypage || 1;
    vars.displayListCount = displayListCount || 50;
    vars.searchObj = JSON.stringify(obj) || JSON.stringify({});
    hide('pagDiv');

    let returnData;
    await PREP(['getAAApplications'], vars, 'Searching... Please wait')
      .then((res) => {
        returnData = res.data.getAAApplications[0].ReturnList;
        let callback = (p1, p2) => {
          AngloApplications.getAngloApplicants(p1, p2);
        };
        pagination(res.data.getAAApplications[0].pagination[0], callback);
        AngloApplications.populateAngloAppTable(returnData);
      })
      .catch(console.error());
  }

  static async populateAngloAppTable(data) {
    if (data.length) {
      await AngloApplications.buildAngloAppBody(data);
      AngloApplications.searchAngloTable();
      hide('noApps');
      id('listApplicationsTable').style = 'visibility: visible;';
    } else {
      if (id('trSearch').classList.contains('hide')) {
        id('appListBody').innerHTML = '';
        unhide('noApps');
        id('listApplicationsTable').style = 'visibility: hidden;';
      } else {
        id('appListBody').innerHTML = '';
      }
    }
  }

  static async buildAngloAppBody(data) {
    const tbody = id('appListBody') ? id('appListBody') : divAtt('tbody', 'id', 'appListBody');
    tbody.innerHTML = '';

    if (data.length) {
      for (let row of data) {
        const tr = divAtt('tr', 'class', '');
        const td0 = divAtt('td', 'class', '');
        const iconDiv = divAtt('div', 'style', 'display: flex;');
        const expressImg = divAtt('span', 'class', 'tableIcon');
        expressImg.innerHTML = timerIcon;
        const addSerImg = divAtt('span', 'class', 'tableIcon');
        addSerImg.innerHTML = additionalServicesIcon;
        const superImg = divAtt('span', 'class', 'tableIcon');
        superImg.innerHTML = supervisionIcon;
        const scientistImg = divAtt('span', 'class', 'tableIcon');
        scientistImg.innerHTML = scientistIcon;

        if (row.expressServiceYN) {
          iconDiv.appendChild(expressImg);
        }
        if (row.additionalServicesYN) {
          iconDiv.appendChild(addSerImg);
        }
        if (row.containsSupervisedAssessmentYN) {
          iconDiv.appendChild(superImg);
        }
        td0.appendChild(iconDiv);

        const td1 = divAtt('td', 'class', '');
        td1.innerHTML = row.RFCNumber;
        const td5 = divAtt('td', 'class', '');
        td5.innerHTML = row.clientjobID;
        const td2 = divAtt('td', 'class', '');
        td2.innerHTML = row.candidateFname + ' ' + row.candidatesname;
        const td3 = divAtt('td', 'class', '');
        td3.innerHTML = row.clientjobTitle;
        const td4 = divAtt('td', 'class', '');
        td4.innerHTML = row.clientpositionID;
        const td6 = divAtt('td', 'class', '');
        td6.innerHTML = row.lineManagerfname + ' ' + row.linemanagerSname;
        const td8 = divAtt('td', 'class', '');
        td8.innerHTML = row.status;
        const td7 = divAtt('td', 'class', '');
        const pendActivity = row.activityInProgressYN ? divAtt('img', 'src', `${tickIcon}`) : divAtt('img', 'src', `${greyCross}`);
        td7.appendChild(pendActivity);
        const td9 = divAtt('td', 'class', '');
        const btn = divAtt('button', 'onclick', `PREP('viewAngloApp', 'HAPPLICATIONID=${row.HapplicationID}')`);
        btn.classList.add('btn');

        const langObj = {};
        const data = pgstr.angloApplications.getHTMLLexicon;
        for (let row of data) {
          langObj[row.marker] = row.display;
        }
        btn.innerHTML = langObj.aal_Mkr15 ? langObj.aal_Mkr15 : 'view';
        td9.appendChild(btn);

        tr.appendChild(td0);
        tr.appendChild(td1);
        tr.appendChild(td5);
        tr.appendChild(td2);
        tr.appendChild(td3);
        tr.appendChild(td4);
        tr.appendChild(td6);
        tr.appendChild(td8);
        tr.appendChild(td7);
        tr.appendChild(td9);
        tbody.appendChild(tr);
      }
      unhide('searchSpace');
    }
    id('listApplicationsTable').appendChild(tbody);
    // return tbody
  }

  static searchAngloTable() {
    const searchInp = document.querySelectorAll('.searchInp');
    searchInp.forEach((sInp) => {
      let timeout;
      sInp.addEventListener('keyup', () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          AngloApplications.getAngloApplicants(1, 50);
        }, 1500);
      });
    });
  }
}

export class RecordAngloApp {
  constructor(vars) {
    this.name = 'Record Anglo Appplication';
    this.pageTier = 10;
    this.reference = 'recordAngloApp';
    this.pageID = null;
    this.data = null;
    this.HclientID = vars.HclientID;
    this.HapplicationID = vars.HapplicationID;
    this.getDDlegalEntity = null;
    this.getLocations = null;
    // this.getSuccessprofile = null;
    this.getBusinessEntities = null;
    this.costCenter = null;
    this.roleTitle = null;
    this.workLevel = null;
    this.busUnit = null;
    // this.assPackages = data.getassPackages
    this.additionalServices = null;
    this.requestors = null;
    this.HRContact = null;
    this.hiringManager = null;
    this.reportViewer = null;
    this.timeZones = null;
    this.language = null;
  }

  initPage(data) {
    // Set page pecific variables
    this.data = data;
    this.getHTMLLexicon = data.getHTMLLexicon;
    this.getDDlegalEntity = null; // cObj(data.getDDlegalEntity);
    this.getLocations = data.getLocations; //cObj(data.getLocations);
    // this.getSuccessprofile = cObj(data.getSuccessprofile);
    this.getBusinessEntities = cObj(data.getBusinessEntities);
    this.costCenter = data.GAPCostCenter;
    this.roleTitle = data.GAPJobTitle;
    this.workLevel = data.GAPPositionLevel;
    this.busUnit = data.GAPJobDivision;
    // this.assPackages = data.getassPackages
    this.additionalServices = data.getAdditionalServicesByClient;
    this.requestors = data.getAARequestors;
    this.HRContact = data.getAAHRContact;
    this.hiringManager = data.getAAHiringmanager;
    this.reportViewer = data.getAAReportViewer;
    this.timeZones = cObj(data.getTimezones);
    this.feedbackRequestor = data.getAAFeedbackRequestor;
    this.bulkAppsObj = '';
    this.loadPage();
  }

  loadPage() {
    this.populateAARecordPage();
  }

  populateAARecordPage() {
    ccRegexMulti(0, this.HclientID);

    // ADD SERVICES
    additionalService.buildAssSerCheckboxes2(this.additionalServices, this.feedbackRequestor, this.HclientID);
    // buildDropDownMain(this.additionalServices, 'addServices', 'serviceID', 'serviceName');

    // SECTION Commercial Details

    buildDropDownMain(this.getBusinessEntities, 'busEntity', 'DDBUSINESSENTITYID', 'DESCRIPTION');

    // buildDropDownMain(this.getDDlegalEntity, 'legalEntity', 'DDLEGALENTITYID', 'DESCRIPTION');

    buildDropDownMain(this.workLevel, 'workLevel', 'DDpositionLevelID', 'shortname');

    // buildDropDownMain(this.language, 'regionalLanguage', 'HlanguageID', 'shortname');

    buildDropDownMain(this.costCenter, 'costCentre', 'DDcostCenterID', 'shortdescription');

    // SECTION Requestor Details

    buildDropDownMain(this.requestors, 'recruiter', 'HuserID', 'comboname');

    buildDropDownMain(this.HRContact, 'HRContact', 'HuserID', 'shortname');

    buildDropDownMain(this.hiringManager, 'hiringManager', 'HuserID', 'shortname');

    // SECTION Role Details

    buildDropDownMain(this.roleTitle, 'roleTitle', 'DDjobtitleID', 'shortname');

    buildDropDownMain(this.busUnit, 'busUnit', 'DDDivisionID', 'shortname');

    buildDropDownMain(this.timeZones, 'timeZone', 'DDTIMEZONEID', 'DESCRIPTION');

    // buildDropDownMain(this.assPackage, 'assPackage', 'DDpositionLevelID', 'shortname');

    // buildDropDownMain(this.getSuccessprofile, 'successProfile', 'DDSUCCESSPROFILEID', 'DESCRIPTION');

    // SECTION Candidate Details
    buildDropDownMain(this.getLocations, 'location', 'DDlocationsID', 'description');

    // buildDropDownMain(this.reportViewer, 'reportViewer', 'HuserID', 'shortname');

    RecordAngloApp.newEntries();
    RecordAngloApp.assPurposeOpt();
    RecordAngloApp.changeExcel();

    // Set Lang Elements
    const infoText = window.infoText;
    id('selectOpt').innerHTML = infoText.inf_Mkr10 ? infoText.inf_Mkr10 : 'Please choose an option---';
    id('selectOpt2').innerHTML = infoText.inf_Mkr10 ? infoText.inf_Mkr10 : 'Please choose an option---';
  }

  static newEntries() {
    // EVENT LISTENERS ===

    const newEntries = document.querySelectorAll('.newEnrty');

    for (let newEntry of newEntries) {
      newEntry.addEventListener('change', () => {
        let firstChild = id(`new${newEntry.id}Div`).children;

        if (newEntry.value === 'NEW') {
          unhide(`new${newEntry.id}Div`);

          // ADD VAL CLASS HERE
          for (let child of firstChild) {
            for (let childchild of child.children) {
              if (childchild.type == 'text') {
                childchild.classList.add('notEmpty');
              } else if (childchild.type == 'email') {
                childchild.classList.add('eAddress');
                childchild.classList.add('notEmpty');
              } else if (childchild.classList.contains('CCdigits')) {
                childchild.classList.add('notEmpty');
              }
            }
          }
        } else {
          hide(`new${newEntry.id}Div`);

          // ADD VAL CLASS HERE
          for (let child of firstChild) {
            for (let childchild of child.children) {
              if (childchild.type == 'text') {
                childchild.classList.remove('notEmpty');
              } else if (childchild.type == 'email') {
                childchild.classList.remove('eAddress');
                childchild.classList.remove('notEmpty');
              } else if (childchild.classList.contains('CCdigits')) {
                childchild.classList.remove('notEmpty');
              }
            }
          }
        }
      });
    }
  }

  static populateAssPackage() {
    const workLevel = id('workLevel').value;
    const legalEntity = id('legalEntity').value;
    const assPurpose = id('assPurpose').value;

    if (workLevel === '-' || legalEntity === '-' || assPurpose === '-') {
      unhide('assPackMsg');
      hide('assPackage');
      hide('assPackage_FB');
      return;
    }

    const vars = {};
    vars.DDpositionlevelID = workLevel;
    vars.DDlegalEntityID = legalEntity;
    vars.assPurpose = assPurpose;
    PREP(['getassPackages'], vars)
      .then((res) => {
        const assPack = res.data.getassPackages;
        buildDropDownMain(assPack, 'assPackage', 'HasspackageID', 'shortname');

        hide('assPackMsg');
        unhide('assPackage');
      })
      .catch(console.error());
  }

  static includeMPA() {
    // Cater for live and QA dropdown values
    // const busEntValue = isLive ? 90 : 34; // OLD
    const busEntValue = isLive ? 95 : 109; // De Beers ((BU006))
    const workLevelValue = isLive ? 46 : 46; // Band 7

    if (id('busEntity').value == busEntValue && id('workLevel').value == workLevelValue && id('assPurpose').value === 'recruitment') {
      unhide('MPAdiv');
      id('MPAdiv').classList.add('extraVal');
    } else {
      hide('MPAdiv');
      id('MPAdiv').classList.remove('extraVal');
    }
  }

  static changeExcel() {
    const langID = getCookie('mbohvbhfje');
    let hrefRecPath;
    let hrefDevPath;
    let hrefRecName;
    let hrefDevName;

    if (langID == 10) {
      //pork and cheese
      hrefRecPath = AngloAppRecUpload_Por;
      hrefDevPath = AngloAppDevUpload_Por;
      hrefRecName = 'AngloCandidatosUpload_recrutamento.xlsx';
      hrefDevName = 'AngloCandidatosUpload_desenvolvimento.xlsx';
    } else if (langID == 11) {
      //spanish
      hrefRecPath = AngloAppRecUpload_Span;
      hrefDevPath = AngloAppDevUpload_Span;
      hrefRecName = 'CargarPostulantesdeAnglo_reclutamiento.xlsx';
      hrefDevName = 'CargarPostulantesdeAnglo_desarrollo.xlsx';
    } else {
      //eng
      hrefRecPath = AngloAppRecUpload_Eng;
      hrefDevPath = AngloAppDevUpload_Eng;
      hrefRecName = 'AngloApplicantsUpload_recruitment.xlsx';
      hrefDevName = 'AngloApplicantsUpload_development.xlsx';
    }

    if (id('assPurpose').value === 'recruitment') {
      id('excelDownload').setAttribute('href', `${hrefRecPath}`);
      id('excelDownload').setAttribute('download', `${hrefRecName}`);
    } else {
      id('excelDownload').setAttribute('href', `${hrefDevPath}`);
      id('excelDownload').setAttribute('download', `${hrefDevName}`);
    }
  }

  static populatelegalEnt() {
    const busEnt = id('busEntity').value;

    if (busEnt === '-') {
      unhide('legalMsg');
      hide('legalEntity');
      hide('legalEntity_FB');
      return;
    }

    const vars = {};
    vars.DDbusinessentityID = busEnt;
    vars.HclientID = 42;
    PREP(['getDDlegalEntity'], vars)
      .then((res) => {
        const legal = cObj(res.data.getDDlegalEntity);
        buildDropDownMain(legal, 'legalEntity', 'DDLEGALENTITYID', 'DESCRIPTION');

        hide('legalMsg');
        unhide('legalEntity');

        const langList = {};
        for (const lang of legal) {
          langList[`${lang.DDLEGALENTITYID}`] = lang.LANGUAGE;
        }
        pgstr.recordAngloApp.language = langList;
      })
      .catch(console.error());
  }

  static changeRegLang() {
    const langList = pgstr.recordAngloApp.language;

    if (id('legalEntity').value !== '-' || id('legalEntity').value !== '') {
    }

    if (langList) {
      Object.entries(langList).forEach(([key, value]) => {
        if (key === id('legalEntity').value) {
          id('regLang').innerHTML = value;
        }
      });
    } else {
      id('regLang').innerHTML = 'Language will update based on Legal Entity selection';
    }
  }

  static timeZoneDescroption() {
    if (id('timeZone').value === '-' || !id('timeZone').value) {
      // id('timeZoneDesc'). innerHTML = '';
      hide('timeZoneDesc');
    } else {
      id('timeZoneDesc').innerHTML = '';
      const data = pgstr.recordAngloApp.timeZones;

      console.log(data);

      for (let row of data) {
        if (id('timeZone').value == row.DDTIMEZONEID) {
          id('timeZoneDesc').innerHTML = `<b>${row.DESCRIPTION}:</b> ${row.LONGDESCRIPTION}`;
        }
      }
      unhide('timeZoneDesc');
    }
  }

  static addReportViewer() {
    const infoText = window.infoText;
    const langObj = {};
    const data = pgstr.recordAngloApp.getHTMLLexicon;
    for (let row of data) {
      langObj[row.marker] = row.display;
    }

    id('newReportViewerDiv').classList.toggle('hide');
    id('fNameRV').classList.toggle('notEmpty');
    id('sNameRV').classList.toggle('notEmpty');
    id('f_cellNr').classList.toggle('notEmpty');
    id('f_cellNr').classList.toggle('mobNum');
    id('eAddressRV').classList.toggle('eAddress');
    id('eAddressRV').classList.toggle('notEmpty');

    if (id('btnName').innerHTML === langObj.raa_Mkr82) {
      id('btnName').innerHTML = infoText.inf_Mkr23 ? infoText.inf_Mkr23 : 'Cancel';
      id('plus').innerHTML = '-';

      id('fNameRV').value = '';
      id('sNameRV').value = '';
      id('f_cellNr').value = '';
      id('eAddressRV').value = '';
    } else {
      id('btnName').innerHTML = langObj.raa_Mkr82 ? langObj.raa_Mkr82 : 'Add Report Viewer';
      id('plus').innerHTML = '+';
    }
  }

  static removeLi(liID) {
    const li = id(liID);
    li.remove();
  }

  static buildHRPopup() {
    const infoText = window.infoText;
    const langObj = {};
    const data = pgstr.recordAngloApp.getHTMLLexicon;
    for (let row of data) {
      langObj[row.marker] = row.display;
    }

    const div = divAtt('div', 'class', '');
    const newRVDiv = divAtt('div', 'class', 'grid-2col-input-custard marginBottom');
    newRVDiv.setAttribute('id', 'newHR');
    // Name
    const nameDiv = buildInpText('HRfname', 1, langObj.raa_Mkr73);
    // Surname
    const surnameDiv = buildInpText('HRsname', 1, langObj.raa_Mkr80);
    // Email
    const emailDiv = buildInpEmail('HRemail', 1, langObj.raa_Mkr74);
    // Number
    const numDiv = buildInpMobNum('HRcellNum', 1, langObj.raa_Mkr81);
    // Feedback Banner
    const FBbanner = buildFeedbackBanner();

    const btnDiv = divAtt('div', 'class', 'gridSpan btnCenterGrid');
    const btn = divAtt('button', 'class', 'btn');
    btn.innerHTML = langObj.raa_Mkr87 ? langObj.raa_Mkr87 : 'Add HRBP';
    // btn.setAttribute("onclick", "RecordAngloApp.addHRpopup()");
    const btn2 = divAtt('button', 'class', 'btnCancel');
    btn2.innerHTML = infoText.inf_Mkr23 ? infoText.inf_Mkr23 : 'Cancel';
    // btn2.setAttribute(
    //   "onclick",
    //   `hide('custardBox'), document.getElementById('HRContact').value = '-'`
    // );

    btnDiv.appendChild(btn2);
    btnDiv.appendChild(btn);

    newRVDiv.appendChild(nameDiv);
    newRVDiv.appendChild(surnameDiv);
    newRVDiv.appendChild(emailDiv);
    newRVDiv.appendChild(numDiv);
    newRVDiv.appendChild(FBbanner);
    newRVDiv.appendChild(btnDiv);
    div.appendChild(newRVDiv);
    //custardBox(div, `${langObj.raa_Mkr88}`); // HR Business Partner Details
    eCustardBox(div, `${langObj.raa_Mkr88}`, [
      [
        btn,
        () => {
          RecordAngloApp.addHRpopup();
        },
        'click',
      ],
      [
        btn2,
        () => {
          hide('custardBox');
          document.getElementById('HRContact').value = '-';
        },
        'click',
      ],
    ]);
    id('HRfname').classList.add('notEmptyPopUp');
    id('HRsname').classList.add('notEmptyPopUp');
    id('HRemail').classList.add('notEmptyPopUp');
    id('HRcellNum').classList.add('notEmptyPopUp');

    ccRegexMulti(0, pgstr.recordAngloApp.HclientID);
  }

  static isNewHR() {
    if (id('HRContact').value === 'NEW') {
      RecordAngloApp.buildHRPopup();
    }
  }

  static addHR() {
    const langObj = {};
    const data = pgstr.recordAngloApp.getHTMLLexicon;
    for (let row of data) {
      langObj[row.marker] = row.display;
    }

    if (id('HRContact').value === 'NEW') {
      RecordAngloApp.buildHRPopup();
    } else if (id('HRContact').value === '-') {
      return infoBox(`${langObj.raa_Mkr85}`); //Please first select an HR Business Partner from the dropdown.
    } else {
      const optionValue = id('HRContact').value;
      const HRBPList = id('HRBPList');
      let areadyAdded = false;

      const HRs = document.querySelectorAll('.HRli');
      HRs.forEach((HR) => {
        if (HR.id === optionValue) {
          infoBox(`${langObj.raa_Mkr86}`); //HR Business Partner already added.
          areadyAdded = true;
        }
      });

      if (areadyAdded) {
        return;
      }

      const li = divAtt('li', 'class', 'HRli');
      li.setAttribute('id', `${optionValue}`); // value
      const name = divAtt('span');
      name.innerHTML = `${id('HRContact').options[id('HRContact').selectedIndex].text}`;
      const remove = divAtt('span', 'class', 'trash');
      remove.innerHTML = dustbinSVG;
      // remove.setAttribute(
      //   "onclick",
      //   `RecordAngloApp.removeLi('${optionValue}')`
      // );

      li.appendChild(name);
      li.appendChild(remove);
      HRBPList.appendChild(li);
      id('HRContact').value = '-';
      //@steph how do i navigate here through website
      eListen(
        remove,
        () => {
          RecordAngloApp.removeLi(optionValue);
        },
        'click'
      );
    }
  }

  static async addHRpopup() {
    // VAL inputs here
    const inpts = document.querySelectorAll('.notEmptyPopUp');
    let passValue = true;
    const returnMessage = [];

    inpts.forEach((inpt) => {
      if (!inpt.value.trim()) {
        rejectElem(inpt);
        passValue = false;
        returnMessage.push('Please completed all required fields.');
      }
      if (inpt.classList.contains('incorrect')) {
        passValue = false;
      }
    });

    if (returnMessage.length) {
      inpFeedbackBanner(returnMessage[0]);
    } else {
      id('feedbackBanner') && hide('feedbackBanner');
    }

    if (passValue === false) {
      return;
    }

    const randomId = uuidvMain();
    const viewlist = id('HRBPList');

    const li = divAtt('li', 'class', 'HRli new');
    li.setAttribute('id', `${randomId}`); // random num
    const name = divAtt('span');
    name.setAttribute('id', `${randomId}_name`);
    name.innerHTML = `${id('HRfname').value}`;
    name.style = `margin-right: 0.3rem`;
    const surname = divAtt('span');
    surname.setAttribute('id', `${randomId}_surname`);
    surname.innerHTML = id('HRsname').value;
    const email = divAtt('span', 'class', 'hide');
    email.setAttribute('id', `${randomId}_email`);
    email.innerHTML = id('HRemail').value;
    const number = divAtt('span', 'class', 'hide');
    number.setAttribute('id', `${randomId}_num`);
    number.innerHTML = await sanatizeNum(id('HRcellNum').value, id('countryCodes').value);

    const remove = divAtt('span', 'class', 'trash');
    remove.innerHTML = dustbinSVG;
    //remove.setAttribute("onclick", `RecordAngloApp.removeLi('${randomId}')`);

    li.appendChild(name);
    li.appendChild(surname);
    li.appendChild(email);
    li.appendChild(number);
    li.appendChild(remove);

    viewlist.appendChild(li);
    hide('custardBox');
    id('HRContact').value = '-';
    eListen(
      remove,
      () => {
        RecordAngloApp.removeLi(randomId);
      },
      'click'
    );
    // const lis = document.querySelectorAll('.VRli')
    // if (lis.length >= 5) {
    //     hide('addRVbtn')
    // }
  }

  static async assPurposeOpt() {
    const langObj = {};
    let data;
    if (pgstr.recordAngloApp) {
      data = pgstr.recordAngloApp.getHTMLLexicon;
    } else {
      const vars = {};
      vars.HTMLPageName = 'recordAngloApp';
      vars.languageID = getCookie('mbohvbhfje');

      await PREP(['getHTMLLexicon'], vars).then(async (res) => {
        data = res.data.getHTMLLexicon;
      });
    }

    for (let row of data) {
      langObj[row.marker] = row.display;
    }

    if (id('assPurpose').value === 'recruitment') {
      unhide('GAPDisplayRecruiter');
      id('recruiter').classList.add('notDash');
      id('recruiter').classList.add('newEnrty');

      id('hiringLineManager').innerHTML = langObj.raa_Mkr96 ? langObj.raa_Mkr96 : 'Hiring manager*';
      id('fNameHMlabel').innerHTML = langObj.raa_Mkr98 ? langObj.raa_Mkr98 : 'Hiring manager first name';
      id('sNameHMlabel').innerHTML = langObj.raa_Mkr99 ? langObj.raa_Mkr99 : 'Hiring manager surname';
      id('emailHMlabel').innerHTML = langObj.raa_Mkr100 ? langObj.raa_Mkr100 : 'Hiring manager email address';
      id('cellHMlabel').innerHTML = langObj.raa_Mkr101 ? langObj.raa_Mkr101 : 'Hiring manager cell number';

      id('employeeAppID').innerHTML = langObj.raa_Mkr40 ? langObj.raa_Mkr40 : 'Application ID*';
      id('appEmployeeID').classList.remove('notEmpty');
      id('appEmployeeID').innerHTML = '';
      hide('appEmployeeIDDiv');

      id('jobID').classList.add('notEmpty');
      unhide('jobIDDiv');
    } else {
      hide('GAPDisplayRecruiter');
      id('recruiter').classList.remove('notDash');
      id('recruiter').classList.remove('newEnrty');

      if (!id('newrecruiterDiv').classList.contains('hide')) {
        id('fNameR').classList.remove('notEmpty');
        id('sNameR').classList.remove('notEmpty');
        id('emailR').classList.remove('eAddress');
        id('cellR').classList.remove('notEmpty');
      }

      id('employeeAppID').innerHTML = langObj.raa_Mkr97 ? langObj.raa_Mkr97 : 'Employee ID*';
      id('appEmployeeID').classList.add('notEmpty');
      unhide('appEmployeeIDDiv');

      id('jobID').classList.remove('notEmpty');
      id('jobID').innerHTML = '';
      hide('jobIDDiv');
    }

    if (id('assPurpose').value === 'development') {
      id('hiringLineManager').innerHTML = langObj.raa_Mkr23 ? langObj.raa_Mkr23 : 'Line manager*';
      id('fNameHMlabel').innerHTML = langObj.raa_Mkr24 ? langObj.raa_Mkr24 : 'Line manager first name';
      id('sNameHMlabel').innerHTML = langObj.raa_Mkr25 ? langObj.raa_Mkr25 : 'Line manager surname';
      id('emailHMlabel').innerHTML = langObj.raa_Mkr26 ? langObj.raa_Mkr26 : 'Line manager email address';
      id('cellHMlabel').innerHTML = langObj.raa_Mkr27 ? langObj.raa_Mkr27 : 'Line manager cell number';
    }

    RecordAngloApp.newEntries();
    if (!pgstr.SAs_headersAA) {
      id('recruiter').value = '-';
    }
    id('fNameR').value = '';
    id('sNameR').value = '';
    id('emailR').value = '';
    id('cellR').value = '';
  }

  static bulkToggle() {
    if (id('bulkUploadToggle').checked) {
      unhide('bulkUpload');
      hide('singleUpload');
    } else {
      hide('bulkUpload');
      unhide('singleUpload');
    }
  }

  static displayFile(file) {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    if (file) {
      if (file.type == fileType) {
        id('displayFileName').innerHTML = file.name;
        unhide('displayFile');
        unhide('importBtn');
        hide('valFail');
        hide('appReview');
      } else {
        infoBox("Invalid file: Please choose a file ending in '.xls'. ");
        id('upload').files[0] = null;
        hide('displayFile');
        hide('importBtn');
      }
    } else {
      infoBox('Please choose a file to upload.');
      id('upload').files[0] = null;
      hide('displayFile');
      hide('importBtn');
    }
  }

  static uploadApps() {
    const file = id('upload').files[0];
    if (file) {
      const vars = {};
      vars.uploadfile = file;

      PREP(['validateBulkApplicants'], vars)
        .then((res) => {
          RecordAngloApp.buildAppReviewTable(res.data.validateBulkApplicants);

          id('displayFileName').innerHTML = '';
          hide('displayFile');
          hide('importBtn');
        })
        .catch(console.error());
    } else {
      infoBox('Please choose a file to upload.');
      id('upload').files[0] = null;
      hide('displayFile');
    }
  }

  static buildAppReviewTable(data) {
    let pass = true;

    const table = id('appReviewTable');
    table.innerHTML = '';

    for (let row of data) {
      const tr = divAtt('tr');
      const name = divAtt('td');
      name.innerHTML = `${row.fname} ${row.sname}`;
      const jobAppID = divAtt('td');
      jobAppID.innerHTML = row.appJobID;
      const email = divAtt('td');
      email.innerHTML = row.email;
      const mobNum = divAtt('td');
      mobNum.innerHTML = row.mobNum;
      const intExt = divAtt('td');
      intExt.innerHTML = row.intExt;
      const failReason = divAtt('td');
      failReason.style = 'color: var(--errorColor);';
      failReason.innerHTML = row.faIlreason;
      tr.appendChild(name);
      tr.appendChild(jobAppID);
      tr.appendChild(email);
      tr.appendChild(mobNum);
      tr.appendChild(intExt);
      tr.appendChild(failReason);
      table.appendChild(tr);

      if (row.faIlreason) {
        pass = false;
      }
    }
    unhide('appReview');

    if (pass) {
      pgstr.recordAngloApp.bulkAppsObj = data;
      hide('valFail');
    } else {
      unhide('valFail');
    }
  }

  static async addApplicant() {
    if (!validatePage()) {
      return;
    }

    const phoneNumber = await sanatizeNum(id('f_cellNr').value, id('countryCodes').value);

    const vars = {};
    vars.HjobID = pgstr.MJt_applications.HjobID;
    vars.fname = id('fName').value;
    vars.sname = id('sName').value;
    vars.email = id('email').value;
    vars.mobile = phoneNumber;
    vars.dob = ''; //id('DOB').value;
    vars.idNum = ''; //id('IDnum').value;
    vars.passNum = ''; // id('passNum').value;

    PREP(['addGAPApplication'], vars).then((res) => {
      note(res.data.addGAPApplication);
      changeTabN('MJt_applications');
    });
  }

  static async recordApplication() {
    const langObj = {};
    const data = pgstr.recordAngloApp.getHTMLLexicon;
    for (let row of data) {
      langObj[row.marker] = row.display;
    }

    if (!validatePage()) {
      console.log('validate');
      return;
    }

    if (id('bulkUploadToggle').checked === false) {
      if (id('internal').checked === false && id('external').checked === false) {
        console.log('internal/external');
        const inExMsg = langObj.raa_Mkr103 ? langObj.raa_Mkr103 : 'Please select an option for Inter/External under Candidate Details';
        return inpFeedbackBanner(`${inExMsg}`);
      }
    }

    const bulk = pgstr.recordAngloApp.bulkAppsObj;
    if (id('bulkUploadToggle').checked === true) {
      if (!bulk) {
        const excelMsg = langObj.raa_Mkr104 ? langObj.raa_Mkr104 : `Please import the applicant's excel spreadsheet before recording the application.`;
        return inpFeedbackBanner(`${excelMsg}`);
      }
    }

    if (id('MPAdiv').classList.contains('extraVal')) {
      if (id('Include').checked === false && id('Exclude').checked === false) {
        const mpaMsg = langObj.raa_Mkr105 ? langObj.raa_Mkr105 : `Please select an option for MPA assessment battery.`;
        return inpFeedbackBanner(`${mpaMsg}`);
      }
    }

    if (!id('HRBPList').innerHTML.trim()) {
      id('HRContact').classList.add('incorrect');

      const hrbpMsg = langObj.raa_Mkr106 ? langObj.raa_Mkr106 : `Please add an HR Business Partner by selecting an option and clicking the '+' button`;
      return inpFeedbackBanner(`${mphrbpMsgaMsg}`);
    }

    // ============================
    // obj.assRequestNum = uuidvMain();

    const obj = {};
    const vars = {};

    // ============================

    const checkboxes = document.querySelectorAll('.addSerInp');

    const checkArr = [];
    checkboxes.forEach((box) => {
      if (box.checked) {
        checkArr.push(box.id);
      }
    });

    if (checkArr.length) {
      const addSerArr = [];

      const canFBbox = document.getElementsByName('Candidate feedback');
      const canBox = canFBbox[0];

      const manFBbox = document.getElementsByName('Management feedback');
      const manbox = manFBbox[0];

      const cdFBbox = document.getElementsByName('Candidate Development Report');
      const cdbox = cdFBbox[0];

      let pass = true;
      const canObj = {};

      if (canBox) {
        if (canBox.checked === true) {
          canObj.addSerID = canBox.id;

          // Duration
          if (id('canduration').value === '-') {
            pass = false;
            id('canduration').value === '-' && id('canduration').classList.add('incorrect');
          } else {
            canObj.duration = id('canduration').value;
          }

          addSerArr.push(canObj);
        }
      }

      const manObj = {};
      if (manbox) {
        if (manbox.checked === true) {
          manObj.addSerID = manbox.id;

          // Duration
          if (id('manduration').value === '-') {
            pass = false;
            id('manduration').value === '-' && id(`manduration`).classList.add('incorrect');
          } else {
            manObj.duration = id('manduration').value;
          }

          // Reqestor
          if (!id('manrequester').value) {
            pass = false;
            !id('manrequester').value && id('manrequester').classList.add('incorrect');
          } else if (id('manrequester').value === 'New') {
            if (!id(`manfName`).value || !id(`mansName`).value || !valE(id(`manemail`).value)) {
              pass = false;
              !id(`manfName`).value && id(`manfName`).classList.add('incorrect');
              !id(`mansName`).value && id(`mansName`).classList.add('incorrect');
              !valE(id(`manemail`).value) && id(`manemail`).classList.add('incorrect');
            } else {
              manObj[`requestor`] = {
                value: 'NEW',
                fName: id(`manfName`).value,
                sName: id(`mansName`).value,
                email: id(`manemail`).value,
              };
            }
          } else {
            if (id('manrequester').value) {
              manObj.requestor = id('manrequester').value;
            }
          }

          addSerArr.push(manObj);
        }
      }

      const cdObj = {};
      if (cdbox) {
        if (cdbox.checked === true) {
          cdObj.addSerID = cdbox.id;
          addSerArr.push(cdObj);
        }
      }

      if (!pass) {
        const addMsg = langObj.raa_Mkr107 ? langObj.raa_Mkr107 : 'Please fill in all required information for Additional Services';

        infoBox(`${addMsg}`);
        id('ADscroll').scrollIntoView();
        return;
      }

      obj.additionalservices = addSerArr; //checkArr;
    } else {
      obj.additionalservices = checkArr;
    }

    // ============================

    const idArr = ['busEntity', 'legalEntity', 'workLevel', 'assPurpose', 'assPackage', 'purchaseOrderNum', 'costCentre', 'roleTitle', 'busUnit', 'leadershipScope', 'location', 'timeZone', 'recruiter', 'hiringManager']; // comments successProfile regionalLanguage addServices

    for (let item of idArr) {
      if (id(`${item}`).value == 'NEW' && item == 'hiringManager') {
        const RphoneNumber = await sanatizeNum(id('cellHM').value, id('HMcountryCodes').value);
        obj[item] = {
          value: id(`${item}`).value,
          fName: id('fNameHM').value,
          sName: id('sNameHM').value,
          email: id('emailHM').value,
          mobNum: RphoneNumber,
        };
      } else if (id(`${item}`).value == 'NEW' && item == 'recruiter') {
        const RphoneNumber = await sanatizeNum(id('cellR').value, id('RcountryCodes').value);
        obj[item] = {
          value: id(`${item}`).value,
          fName: id('fNameR').value,
          sName: id('sNameR').value,
          email: id('emailR').value,
          mobNum: RphoneNumber,
        };
      } else if (id(`${item}`).value == 'NEW') {
        obj[item] = {
          value: id(`${item}`).value,
          newEntry: id(`new${item}`).value,
        };
      } else {
        obj[item] = {
          value: id(`${item}`).value,
        };
      }
    }

    // Added by TF
    obj['comments'] = {
      value: '',
    };
    // To be removed by SC

    // ================================

    if (id('bulkUploadToggle').checked === false) {
      obj['multipleCandidates'] = '';
      const canPhoneNumber = await sanatizeNum(id('canPhoneNum').value, id('canCountryCodes').value);
      obj['candidateDetails'] = {
        value: 'NEW',
        fName: id('canName').value,
        sName: id('canSName').value,
        appEmployeeID: id('appEmployeeID').value,
        jobID: id('jobID').value,
        mobNum: canPhoneNumber,
        email: id('canEmail').value,
      };
    } else {
      obj['multipleCandidates'] = pgstr.recordAngloApp.bulkAppsObj;
      obj['candidateDetails'] = '';
    }

    var radios = document.getElementsByName('internExternal');
    for (var i = 0, length = radios.length; i < length; i++) {
      if (radios[i].checked) {
        // alert(radios[i].value);
        obj.internalExternal = {
          value: radios[i].value,
        };
        break;
      }
    }

    var radiosMPA = document.getElementsByName('mpa');
    for (var i = 0, length = radiosMPA.length; i < length; i++) {
      if (id('MPAdiv').classList.contains('extraVal')) {
        if (radiosMPA[i].checked) {
          obj.MPA = {
            value: radiosMPA[i].value,
          };
        }
      } else {
        obj.MPA = {
          value: '',
        };
        break;
      }
    }

    // ==================

    const HRBPobj = {};
    const HRlis = document.querySelectorAll('.HRli');
    let cntr = 1;
    HRlis.forEach((HRli) => {
      if (HRli.classList.contains('new')) {
        HRBPobj[`HRBR${cntr}`] = {
          value: 'NEW',
          fName: id(`${HRli.id}_name`).innerHTML,
          sName: id(`${HRli.id}_surname`).innerHTML,
          email: id(`${HRli.id}_email`).innerHTML,
          mobNum: id(`${HRli.id}_num`).innerHTML,
        };
      } else {
        HRBPobj[`HRBR${cntr}`] = {
          value: HRli.id,
        };
      }
      cntr++;
    });
    obj.HRbusinessPartner = JSON.stringify(HRBPobj);

    // ==================

    const repVPhoneNumber = await sanatizeNum(id('f_cellNr').value, id('countryCodes').value);
    obj['reportViewerDetails'] = {
      fName: id('fNameRV').value,
      sName: id('sNameRV').value,
      mobNum: repVPhoneNumber,
      email: id('eAddressRV').value,
    };

    // ==================

    vars.payload = JSON.stringify(obj);
    vars.entityType = 'recordAngloApplication';
    vars.entityUUID = uuidvMain();
    // console.log('vars', vars.payload);

    PREP(['uploadnewrecords'], vars)
      .then((res) => {
        note(res.data.uploadnewrecords);
        window.scrollTo(0, 0);
        PREP('recordAngloApp');
      })
      .catch(console.error());
  }
}

export class ViewAngloApplication {
  constructor(vars) {
    this.name = 'View Application Detail';
    this.pageTier = 15;
    this.reference = 'viewAngloApp';
    this.pageID = null;
    this.data = null;
    this.applicationID = vars.HAPPLICATIONID;
    this.HclientID = vars.HclientID;
  }

  initPage(data) {
    // Set page pecific variables
    this.appDetail = data.getApplicationDetail;
    this.HclientID = data.getApplicationDetail[0].HclientID;
    //this.appAss = data.listAllocatedAssessmentOne;
    // this.appHistory = data.getApplicationHistory;
    this.appHistory2 = data.getApplicationHistory2;
    this.addServices = data.getAdditionalServices;
    this.feedbackRequestor = data.getAAFeedbackRequestor;
    this.reportAllocToApp = cObj(data.getReportsAllocatedToApplication);
    this.addServicesAlloc = cObj(data.getAdditionalServicesAllocated);
    this.getAAReportViewer = data.getAAReportViewer;
    this.getLinkedReportViewers = data.getLinkedReportViewers;
    this.getLinkedHRBP = data.getLinkedHRBP;
    this.getAAHRContact = data.getAAHRContact;
    this.getHTMLLexicon = data.getHTMLLexicon;

    if (data.listAllocatedAssessmentOne.length) {
      if (data.listAllocatedAssessmentOne[0].assListArray) {
        this.appAss = data.listAllocatedAssessmentOne[0].assListArray;
      } else {
        this.appAss = data.listAllocatedAssessmentOne;
      }
    } else {
      this.appAss = data.listAllocatedAssessmentOne;
    }

    this.loadPage();
  }

  async loadPage() {
    this.viewAngloDetailPage();
  }

  viewAngloDetailPage() {
    const langObj = {};
    for (let row of pgstr.viewAngloApp.getHTMLLexicon) {
      langObj[row.marker] = row.display;
    }

    // Page details ===
    this.viewDetail();
    this.listAssessments();
    ViewAngloApplication.appResult();
    id('duplicateBtn').innerHTML = `${duplicateSVG} ${langObj.vaa_Mkr66}`;

    // MPA ===
    ViewAngloApplication.MPAlogic();

    //Additional Services ===
    additionalService.buildAssSerCheckboxes1(this.addServices, this.feedbackRequestor, this.HclientID);
    if (this.addServicesAlloc.length) {
      additionalService.allocatedServices(this.addServicesAlloc);
    }

    // Reports ===
    this.buildReportList(this.reportAllocToApp);

    //History  ===
    this.listHistory();

    // report viewers ===
    // buildDropDownMain(this.getAAReportViewer, 'reportViewer', 'HuserID', 'shortname');
    ccRegex(0, 0);
    ViewAngloApplication.buildReportViewers(this.getLinkedReportViewers, this.HclientID);

    // HRContact
    buildDropDownMain(this.getAAHRContact, 'HRContact', 'HuserID', 'shortname');
    ViewAngloApplication.buildHRBP(this.getLinkedHRBP);
  }

  viewDetail() {
    const data = this.appDetail[0];

    id('lastUpdatedBy').innerHTML = !data.lastUpdaterText ? `N/A` : data.lastUpdaterText;
    id('lastUpdatedDate').innerHTML = !data.lastupdated ? '' : ` on ${dateFromDateTime(data.lastupdated)}`;
    id('status1').innerHTML = data.status;
    id('c_name').innerHTML = `${data.candidateFname} ${data.candidatesname}`;
    id('c_eMail').innerHTML = data.candidateEmail;
    id('c_mobile').innerHTML = data.candidateMobilenumber;
    id('c_intEx').innerHTML = data.internalExternal;
    id('c_comments').innerHTML = data.clientcomments;

    id('RFCnumber').innerHTML = data.RFCNumber;
    id('jobID').innerHTML = data.clientjobID;
    id('PONumber').innerHTML = data.PONumber;
    id('jobTitle').innerHTML = data.applicationJobtitleName;
    id('businessDivision').innerHTML = data.division;
    id('location').innerHTML = data.location;
    id('timeZone').innerHTML = data.timezone;
    id('busEnt').innerHTML = data.businessEntity;
    id('legalEnt').innerHTML = data.legalEntity;
    id('positionLevel').innerHTML = data.positionLevel;
    id('purpose').innerHTML = data.purpose;
    id('assPackage').innerHTML = data.assPackage;
    id('costCentre').innerHTML = data.costCenter;
    id('capturer').innerHTML = `${data.addedbyfname} ${data.addedbysname}`;
    id('status2').innerHTML = data.status;
    id('actStatus').innerHTML = data.latestActivity;

    id('lineManager').innerHTML = `${data.lineManagerfname} ${data.linemanagerSname}`;
    id('lineManagerEmail').innerHTML = data.lineManagerEmail;

    const langObj = {};
    for (let row of pgstr.viewAngloApp.getHTMLLexicon) {
      langObj[row.marker] = row.display;
    }

    if (data.purpose === 'Recruitment' || data.purpose === 'recruitment') {
      id('recruiter').innerHTML = `${data.recruiterfname} ${data.recruitersname}`;
      id('recruierEmail').innerHTML = data.recruiterEmail;
      unhide('GAPDisplayRecruiter');
      unhide('recruiter');
      unhide('recruiterEmailDisplay');
      unhide('recruierEmail');
      id('GAPDisplayLineManager').innerHTML = langObj.vaa_Mkr81 ? langObj.vaa_Mkr81 : 'Hiring Manager:';
      id('lineEmailDisplay').innerHTML = langObj.vaa_Mkr85 ? langObj.vaa_Mkr85 : 'Hiring Manager Email:';
    }

    // Cater for client pacific fields
    applications.hideClientPacificFields(this.HclientID);
  }

  async listAssessments() {
    const langObj = {};
    const vars = {};
    vars.HTMLPageName = 'reportHistList';
    vars.languageID = getCookie('mbohvbhfje');

    await PREP(['getHTMLLexicon'], vars).then(async (res) => {
      const lang = res.data.getHTMLLexicon;
      for (let row of lang) {
        langObj[row.marker] = row.display;
      }
    });

    const data = this.appAss;
    const ass = id('assTable');
    ass.innerHTML = '';

    if (data.length) {
      hide('noass');

      const thead = await viewApplication.buildAssHead();
      ass.appendChild(thead);

      for (const el of data) {
        const tr = divAtt('tr');
        const td1 = divAtt('td');
        td1.innerHTML = el.shortname;
        const td2 = divAtt('td');
        td2.innerHTML = el.assStatus;
        const td3 = divAtt('td');
        const bookingDate = el.bookingdate ? dateFromDateTime(el.bookingdate) : el.bookingdate;
        td3.innerHTML = el.lastUpdated ? dateFromDateTime(el.lastUpdated) : bookingDate;
        tr.appendChild(td1);
        tr.appendChild(td2);
        tr.appendChild(td3);
        ass.appendChild(tr);
      }
    } else {
      unhide('noass');
    }
  }

  static appResult() {
    const data = pgstr.viewAngloApp.appDetail[0];

    if (data.ApplicationResultRequiredYN == 0 || '') {
      hide('appResultsSection');
    } else {
      unhide('appResultsSection');

      if (data.applicationResultDate) {
        const tr = id('appResultTable');
        const date = divAtt('td');
        date.innerHTML = data.applicationResultDate;
        const by = divAtt('td');
        by.innerHTML = data.applicationresultBy;
        const result = divAtt('td');
        result.innerHTML = data.applicationresult;

        tr.appendChild(date);
        tr.appendChild(by);
        tr.appendChild(result);

        hide('appResultTggl');
        unhide('appResultView');
      } else {
        unhide('appResultTggl');
        hide('appResultView');
      }
    }
  }

  async listHistory() {
    const langObj = {};
    const vars = {};
    vars.HTMLPageName = 'reportHistList';
    vars.languageID = getCookie('mbohvbhfje');

    await PREP(['getHTMLLexicon'], vars).then(async (res) => {
      const lang = res.data.getHTMLLexicon;
      for (let row of lang) {
        langObj[row.marker] = row.display;
      }
    });

    const data = this.appHistory2;
    const history = id('hidtoryList');
    history.innerHTML = '';

    if (data.length) {
      hide('noHistory');
      viewApplication.buildHistoryTable(data);
    } else {
      unhide('noHistory');
    }
  }

  async buildReportList(reports) {
    const table = id('applicationReports') ? id('applicationReports') : id('userReports');
    table.innerHTML = '';
    if (reports.length) {
      hide('noReports');
      const thead = await this.listReportHead();
      table.appendChild(thead);

      reports.forEach((rprt) => {
        PREP(['downloadReport'], {
          reportRegisterID: rprt.REPORTREGISTERID,
        })
          .then(async (res) => {
            rprt.url = res.data.downloadReport;
            await this.listReports(rprt, table);
            //table.appendChild(tr);
          })
          .catch(console.error());
      });
    } else {
      unhide('noReports');
    }
  }

  async listReportHead() {
    const langObj = {};
    for (let row of pgstr.viewAngloApp.getHTMLLexicon) {
      langObj[row.marker] = row.display;
    }

    const thead = document.createElement('thead');
    const th1 = document.createElement('th');
    const th2 = document.createElement('th');
    const th3 = document.createElement('th');
    const th7 = document.createElement('th');
    const th4 = document.createElement('th');
    const th5 = document.createElement('th');
    const th6 = document.createElement('th');
    th1.innerHTML = langObj.vaa_Mkr30 ? langObj.vaa_Mkr30 : 'Date';
    th2.innerHTML = langObj.vaa_Mkr31 ? langObj.vaa_Mkr31 : 'Report updater';
    th3.innerHTML = langObj.vaa_Mkr33 ? langObj.vaa_Mkr32 : 'Report Type';
    th7.innerHTML = langObj.vaa_Mkr100 ? langObj.vaa_Mkr100 : 'File Name';
    th4.innerHTML = ''; //Encrypted
    th5.innerHTML = '';
    th6.innerHTML = '';
    thead.appendChild(th1);
    thead.appendChild(th2);
    thead.appendChild(th3);
    thead.appendChild(th7);
    thead.appendChild(th4);
    thead.appendChild(th5);
    thead.appendChild(th6);

    return thead;
  }

  async listReports(data, table) {
    const langObj = {};
    for (let row of pgstr.viewAngloApp.getHTMLLexicon) {
      langObj[row.marker] = row.display;
    }
    const tr = divAtt('tr', 'class', '');
    const td1 = divAtt('td', 'class', 'reportdate');
    td1.innerHTML = dateFromDateTime(new Date(data.DATEON));
    const td2 = divAtt('td', 'class', 'reportUpdater');
    td2.innerHTML = `${data.FNAME} ${data.SNAME}`;
    const td3 = divAtt('td', 'class', 'reporttype');
    td3.innerHTML = data.REPORTTYPE;
    const td7 = divAtt('td', 'class', 'reporttype');
    td7.innerHTML = data.ORIGINALFILE;
    const td4 = divAtt('td', 'class', 'center');
    if (data.ENCRYPTYN) {
      const encryptIcon = divAtt('div', 'class', 'iconTable');
      encryptIcon.innerHTML = keyEncrypt;
      td4.appendChild(encryptIcon);
    }

    const td5 = divAtt('td', 'class', 'reporreporturlttype');
    const btn = divAtt('button', 'class', 'btn');
    btn.innerHTML = langObj.vaa_Mkr36 ? langObj.vaa_Mkr36 : 'View';

    td5.appendChild(btn);

    const td6 = divAtt('td', 'class', 'downloadHistory');
    const histBtn = divAtt('button', 'class', 'btn');
    addAtt(histBtn, 'id', 'dlHist');
    histBtn.innerHTML = langObj.vaa_Mkr37;
    // const histBtn = buildBtn(
    //   "dlHist",
    //   `report.reportHistory('${data.REPORTREGISTERID}', '${data.ORIGINALFILE}')`,
    //   `${langObj.vaa_Mkr37}`
    // ); //Download History

    td6.appendChild(histBtn);

    tr.appendChild(td1);
    tr.appendChild(td2);
    tr.appendChild(td3);
    tr.appendChild(td7);
    tr.appendChild(td4);
    tr.appendChild(td5);
    tr.appendChild(td6);

    table.appendChild(tr);
    if (data.ENCRYPTYN && !data.PROCEEDDISCLAIMER) {
      eListen(
        btn,
        () => {
          report.encryptedReport(data.REPORTREGISTERID, data.ORIGINALFILE);
        },
        'click'
      );
      // btn.setAttribute(
      //   "onclick",
      //   `report.encryptedReport(${data.REPORTREGISTERID}, '${data.ORIGINALFILE}')`
      // );
    } else if (data.ENCRYPTYN) {
      eListen(
        btn,
        () => {
          ViewAngloApplication.buildAngloPopup(data.PROCEEDBUTTONTEXT, data.PROCEEDHEADER, data.PROCEEDDISCLAIMER, 'encrypted', data.REPORTREGISTERID, data.ORIGINALFILE);
        },
        'click'
      );
      // btn.setAttribute(
      //   "onclick",
      //   `ViewAngloApplication.buildAngloPopup(
      //     '${data.PROCEEDBUTTONTEXT}',
      //     '${data.PROCEEDHEADER}',
      //     '${data.PROCEEDDISCLAIMER}',
      //     'encrypted',
      //     ${data.REPORTREGISTERID},
      //     '${data.ORIGINALFILE}')`
      // );
    } else if (!data.PROCEEDDISCLAIMER) {
      eListen(
        btn,
        () => {
          report.download(data.REPORTREGISTERID);
        },
        'click'
      );
      // btn.setAttribute("onclick", `report.download(${data.REPORTREGISTERID})`);
    } else {
      eListen(
        btn,
        () => {
          ViewAngloApplication.buildAngloPopup(data.PROCEEDBUTTONTEXT, data.PROCEEDHEADER, data.PROCEEDDISCLAIMER, data.REPORTREGISTERID);
        },
        'click'
      );
      // btn.setAttribute(
      //   "onclick",
      //   ``
      // );
    }
    eListen(
      histBtn,
      () => {
        report.reportHistory(data.REPORTREGISTERID, data.ORIGINALFILE);
      },
      'click'
    );
  }

  static buildReportViewers(data, HclientID) {
    let clientID = HclientID ? HclientID : pgstr.viewAngloApp.HclientID;

    ccRegexMulti(0, clientID);

    if (!data.length) {
      unhide('noReportViewers');
      hide('RVListDiv');
    } else {
      const RVList = id('RVList');
      RVList.innerHTML = '';

      for (const viewer of data) {
        const li = divAtt('li', 'class', 'RVli');
        li.setAttribute('id', `${viewer.HuserID}`);
        const name = divAtt('span');
        name.innerHTML = viewer.comboName;

        const remove = divAtt('span', 'class', 'trash');
        remove.innerHTML = dustbinSVG;
        // remove.setAttribute(
        //   "onclick",
        //   `ViewAngloApplication.removeLi('${viewer.allocateID}')`
        // );
        li.appendChild(name);
        li.appendChild(remove);
        RVList.appendChild(li);
        eListen(
          remove,
          () => {
            ViewAngloApplication.removeLi(viewer.allocateID);
          },
          'click'
        );
      }

      hide('noReportViewers');
      unhide('RVListDiv');
    }

    // id('reportViewer').value = '-';
  }

  static buildAngloPopup(btnName, heading, msg, onclick, reportID, reportName) {
    const div = divAtt('div', 'class', '');
    const p = divAtt('p', 'class', 'marginTop marginBottom');
    p.innerHTML = msg;
    const cancelBtn = divAtt('button', 'class', 'btnCancel');
    cancelBtn.innerHTML = 'Cancel';
    const btn = divAtt('button', 'class', 'btn');
    btn.innerHTML = btnName;
    let myMethod;
    if (onclick === 'encrypted') {
      myMethod = () => {
        report.encryptedReport(reportID, reportName);
        hide('custardBox');
      };
    } else {
      myMethod = () => {
        report.download(onclick);
      };
    }

    div.appendChild(p);
    div.appendChild(cancelBtn);
    div.appendChild(btn);

    eCustardBox(div, heading, [
      [
        cancelBtn,
        () => {
          hide('custardBox');
        },
        'click',
      ],
      [btn, myMethod, 'click'],
    ]);
  }
  // static addReportViewer() {

  //     if (id('reportViewer').value === 'NEW') {
  //         ViewAngloApplication.buildReportViewerPopup();

  //     } else if (id('reportViewer').value === '-') {

  //         return infoBox('Please first select a Report Viewer from the dropdown.');

  //     } else {

  //         // Val
  //         let areadyAdded = false
  //         const RVs = document.querySelectorAll('.RVli')
  //         RVs.forEach(RV => {

  //             if (RV.id === id('reportViewer').value) {
  //                 infoBox('Report Viewer already added.');
  //                 areadyAdded = true;
  //             }
  //         });

  //         if (areadyAdded) {
  //             return
  //         }

  //         // Add
  //         const vars = {};
  //         vars.HapplicationID = pgstr.viewAngloApp.applicationID;
  //         vars.reportViewerID = id('reportViewer').value;
  //         PREP(['addreportViewerToApplication'], vars)
  //             .then(res => {

  //                 note(res.data.addreportViewerToApplication);

  //                 const vars1 = {}
  //                 vars1.HapplicationID = pgstr.viewAngloApp.applicationID;
  //                 PREP(['getLinkedReportViewers'], vars1)
  //                     .then(async res => {

  //                         ViewAngloApplication.buildReportViewers(res.data.getLinkedReportViewers)
  //                     })
  //             });

  //     }

  // }

  static async addReportViewerNew() {
    const infoText = window.infoText;
    if (!validateDiv('newRVUser')) {
      return infoBox(`${infoText.inf_Mkr8}`);
    }

    const phoneNumber = await sanatizeNum(id('f_cellNr').value, id('countryCodes').value);
    // Add
    const vars = {};
    vars.HapplicationID = pgstr.viewAngloApp.applicationID;
    vars.RVFname = id('fNameRV').value;
    vars.RVSname = id('sNameRV').value;
    vars.RVEmailaddress = id('eAddressRV').value;
    vars.RVmobnum = phoneNumber;

    PREP(['addreportViewerToApplication'], vars).then((res) => {
      id('f_cellNr').value = '';
      id('fNameRV').value = '';
      id('sNameRV').value = '';
      id('eAddressRV').value = '';

      note(res.data.addreportViewerToApplication);

      const vars1 = {};
      vars1.HapplicationID = pgstr.viewAngloApp.applicationID;
      PREP(['getLinkedReportViewers'], vars1).then(async (res) => {
        ViewAngloApplication.buildReportViewers(res.data.getLinkedReportViewers);
      });
    });
  }

  static buildReportViewerPopup() {
    const div = divAtt('div', 'class', '');
    const newRVDiv = divAtt('div', 'class', 'grid-2col-input-custard marginBottom');
    newRVDiv.setAttribute('id', 'newRV');
    // Name
    const nameDiv = buildInpText('RVfname', 1, 'Name');
    // Surname
    const surnameDiv = buildInpText('RVsname', 1, 'Surname');
    // Email
    const emailDiv = buildInpEmail('RVemail', 1);
    // Number
    const numDiv = buildInpMobNum('RVcellNum', 1);
    const FBbanner = buildFeedbackBanner();

    const btnDiv = divAtt('div', 'class', 'gridSpan');
    const btn = divAtt('button', 'class', 'btn');
    btn.innerHTML = 'Add Report Viewer';
    //btn.setAttribute("onclick", "RecordAngloApp.addRVpopup()");
    btnDiv.appendChild(btn);

    newRVDiv.appendChild(nameDiv);
    newRVDiv.appendChild(surnameDiv);
    newRVDiv.appendChild(emailDiv);
    newRVDiv.appendChild(numDiv);
    newRVDiv.appendChild(FBbanner);
    newRVDiv.appendChild(btnDiv);
    div.appendChild(newRVDiv);
    //custardBox(div, "Report Viewers Details");
    eCustardBox(div, 'Report Viewers Details', [
      btn,
      () => {
        RecordAngloApp.addRVpopup();
      },
      'click',
    ]);
    id('RVfname').classList.add('notEmptyPopUp');
    id('RVsname').classList.add('notEmptyPopUp');
    id('RVemail').classList.add('notEmptyPopUp');
    id('RVcellNum').classList.add('notEmptyPopUp');

    ccRegexMulti(0, pgstr.viewAngloApp.HclientID);
  }

  static async addRVpopup() {
    // VAL inputs here
    const inpts = document.querySelectorAll('.notEmptyPopUp');
    let passValue = true;
    const returnMessage = [];

    inpts.forEach((inpt) => {
      if (!inpt.value.trim()) {
        rejectElem(inpt);
        passValue = false;
        returnMessage.push('Please completed all required fields.');
      }
      if (inpt.classList.contains('incorrect')) {
        passValue = false;
      }
    });

    if (returnMessage.length) {
      inpFeedbackBanner(returnMessage[0]);
    } else {
      id('feedbackBanner') && hide('feedbackBanner');
    }

    if (passValue === false) {
      return;
    }

    // Add
    const phoneNumber = await sanatizeNum(id('RVcellNum').value, id('countryCodes').value);
    const obj = {};
    obj.fName = id('RVfname');
    obj.sName = id('RVsname');
    obj.email = id('RVemail');
    obj.mobNum = phoneNumber;

    const vars = {};
    vars.HapplicationID = pgstr.viewAngloApp.applicationID;
    vars.reportViewerID = id('reportViewer').value;
    vars.payload = JSON.stringify(obj);

    PREP(['addreportViewerToApplication'], vars).then((res) => {
      note(res.data.addreportViewerToApplication);

      const vars1 = {};
      vars1.HapplicationID = pgstr.viewAngloApp.applicationID;
      PREP(['getLinkedReportViewers'], vars1).then(async (res) => {
        ViewAngloApplication.buildReportViewers(res.data.getLinkedReportViewers);
      });
    });
    hide('custardBox');
    id('HRContact').value = '-';
  }

  static async removeLi(liID) {
    const vars = {};
    vars.allocateID = liID;

    PREP(['removereportViewerToApplication'], vars)
      .then(async (res) => {
        console.log('removereportViewerToApplication', res.data.removereportViewerToApplication);
        note(res.data.removereportViewerToApplication);

        const vars1 = {};
        vars1.HapplicationID = pgstr.viewAngloApp.applicationID;
        PREP(['getLinkedReportViewers'], vars1).then(async (res) => {
          ViewAngloApplication.buildReportViewers(res.data.getLinkedReportViewers);
        });
      })
      .catch(console.error());
  }

  static buildHRBP(data) {
    if (!data.length) {
      unhide('noHRBP');
      hide('HRBPListDiv');
    } else {
      const HRBPList = id('HRBPList');
      HRBPList.innerHTML = '';

      for (const viewer of data) {
        const li = divAtt('li', 'class', 'HRli');
        li.setAttribute('id', `${viewer.HuserID}`);
        const name = divAtt('span');
        name.innerHTML = viewer.comboName;

        const remove = divAtt('span', 'class', 'trash');
        remove.innerHTML = dustbinSVG;
        // remove.setAttribute(
        //   "onclick",
        //   `ViewAngloApplication.removeHRBPLi('${viewer.allocateID}')`
        // );
        li.appendChild(name);
        li.appendChild(remove);
        HRBPList.appendChild(li);
        eListen(
          remove,
          () => {
            ViewAngloApplication.removeHRBPLi(viewer.allocateID);
          },
          'click'
        );
      }

      hide('noHRBP');
      unhide('HRBPListDiv');
    }

    id('HRContact') && (id('HRContact').value = '-');
  }

  static addHRBP() {
    const langObj = {};
    for (let row of pgstr.viewAngloApp.getHTMLLexicon) {
      langObj[row.marker] = row.display;
    }

    if (id('HRContact').value === 'NEW') {
      ViewAngloApplication.buildHRBPPopup();
    } else if (id('HRContact').value === '-') {
      return infoBox(`${langObj.vaa_Mkr91}`); //Please first select an HR Business Partner from the dropdown.
    } else {
      // Val
      let areadyAdded = false;
      const RVs = document.querySelectorAll('.HRli');
      RVs.forEach((RV) => {
        if (RV.id === id('HRContact').value) {
          infoBox(`${langObj.vaa_Mkr92}`); //('HR Business Partner is already added.');
          areadyAdded = true;
        }
      });

      if (areadyAdded) {
        return;
      }

      // Add
      const vars = {};
      vars.HapplicationID = pgstr.viewAngloApp.applicationID;
      vars.HRBPID = id('HRContact').value;
      PREP(['addHRBPToApplication'], vars).then((res) => {
        note(res.data.addHRBPToApplication);

        const vars1 = {};
        vars1.HapplicationID = pgstr.viewAngloApp.applicationID;
        PREP(['getLinkedHRBP'], vars1).then(async (res) => {
          ViewAngloApplication.buildHRBP(res.data.getLinkedHRBP);
        });
      });
    }
  }

  static buildHRBPPopup() {
    const langObj = {};
    for (let row of pgstr.viewAngloApp.getHTMLLexicon) {
      langObj[row.marker] = row.display;
    }

    const div = divAtt('div', 'class', '');
    const newHRDiv = divAtt('div', 'class', 'grid-2col-input-custard marginBottom');
    newHRDiv.setAttribute('id', 'newHR');
    // Name
    const nameDiv = buildInpText('HRfname', 1, `${langObj.vaa_Mkr95}`);
    // Surname
    const surnameDiv = buildInpText('HRsname', 1, langObj.vaa_Mkr75);
    // Email
    const emailDiv = buildInpEmail('HRemail', 1, langObj.vaa_Mkr7);
    // Number
    const numDiv = buildInpMobNum('HRcellNum', 1, langObj.vaa_Mkr76);
    const FBbanner = buildFeedbackBanner();

    const btnDiv = divAtt('div', 'class', 'gridSpan');
    const btn = divAtt('button', 'class', 'btn');
    btn.innerHTML = langObj.vaa_Mkr93 ? langObj.vaa_Mkr93 : 'Add HRBP';
    // btn.setAttribute("onclick", "ViewAngloApplication.addHRBPpopup()");
    btnDiv.appendChild(btn);

    newHRDiv.appendChild(nameDiv);
    newHRDiv.appendChild(surnameDiv);
    newHRDiv.appendChild(emailDiv);
    newHRDiv.appendChild(numDiv);
    newHRDiv.appendChild(FBbanner);
    newHRDiv.appendChild(btnDiv);
    div.appendChild(newHRDiv);
    //custardBox(div, langObj.vaa_Mkr94); //'Report Viewers Details')
    eCustardBox(div, langObj.vaa_Mkr94, [
      btn,
      () => {
        ViewAngloApplication.addHRBPpopup();
      },
      'click',
    ]);
    id('HRfname').classList.add('notEmptyPopUp');
    id('HRsname').classList.add('notEmptyPopUp');
    id('HRemail').classList.add('notEmptyPopUp');
    id('HRcellNum').classList.add('notEmptyPopUp');

    ccRegexMulti(0, pgstr.viewAngloApp.HclientID);
  }

  static async addHRBPpopup() {
    // VAL inputs here
    const inpts = document.querySelectorAll('.notEmptyPopUp');
    let passValue = true;
    const returnMessage = [];

    inpts.forEach((inpt) => {
      if (!inpt.value.trim()) {
        rejectElem(inpt);
        passValue = false;
        returnMessage.push('Please completed all required fields.');
      }
      if (inpt.classList.contains('incorrect')) {
        passValue = false;
      }
    });

    if (returnMessage.length) {
      inpFeedbackBanner(returnMessage[0]);
    } else {
      id('feedbackBanner') && hide('feedbackBanner');
    }

    if (passValue === false) {
      return;
    }

    // Add
    const phoneNumber = await sanatizeNum(id('HRcellNum').value, id('countryCodes').value);
    const obj = {};
    obj.fName = id('HRfname').value;
    obj.sName = id('HRsname').value;
    obj.email = id('HRemail').value;
    obj.mobNum = phoneNumber;

    const vars = {};
    vars.HapplicationID = pgstr.viewAngloApp.applicationID;
    vars.HRBPID = id('HRContact').value;
    vars.payload = JSON.stringify(obj);

    PREP(['addHRBPToApplication'], vars).then((res) => {
      note(res.data.addHRBPToApplication);

      const vars1 = {};
      vars1.HapplicationID = pgstr.viewAngloApp.applicationID;
      PREP(['getLinkedHRBP'], vars1).then(async (res) => {
        ViewAngloApplication.buildHRBP(res.data.getLinkedHRBP);
      });
    });
    hide('custardBox');
    id('HRContact').value = '-';
  }

  static async removeHRBPLi(liID) {
    const vars = {};
    vars.allocateID = liID;

    PREP(['removeHRBPToApplication'], vars)
      .then(async (res) => {
        note(res.data.removeHRBPToApplication);

        const vars1 = {};
        vars1.HapplicationID = pgstr.viewAngloApp.applicationID;
        PREP(['getLinkedHRBP'], vars1).then(async (res) => {
          ViewAngloApplication.buildHRBP(res.data.getLinkedHRBP);
        });
      })
      .catch(console.error());
  }

  static recordAppResult() {
    const vars = {};
    var radios = document.getElementsByName('appResult');
    for (var i = 0, length = radios.length; i < length; i++) {
      if (radios[i].checked) {
        vars.applicationresult = radios[i].value;
        break;
      }
    }

    // vars.applicationresult = 'Successful';
    vars.HapplicationID = pgstr.viewAngloApp.applicationID;
    PREP(['recordApplicationResult'], vars)
      .then((res) => {
        note(res.data.recordApplicationResult);

        PREP(['getApplicationDetail'], vars).then((res) => {
          pgstr.appDetail = res.data.getApplicationDetail;
          ViewAngloApplication.appResult();
        });
      })
      .catch(console.error());
  }

  static duplicateApp() {
    const vars = {};
    vars.HTMLPageName = 'duplicateApp';
    vars.languageID = getCookie('mbohvbhfje') || createCookie('mbohvbhfje', 1);

    PREP(['getHTMLLexicon'], vars).then((res) => {
      const langObj = {};

      const data = res.data.getHTMLLexicon;
      for (let row of data) {
        langObj[row.marker] = row.display;
      }

      const div = divAtt('div');
      const instructions = divAtt('p');
      instructions.innerHTML = `<b>${langObj.dap_Mkr2}</b>`; //Please specify Candidate Details:
      const duplicateAppDiv = divAtt('div', 'class', 'grid-2col-input-custard marginBottom');
      duplicateAppDiv.setAttribute('id', `${pgstr.viewAngloApp.applicationID}`);
      // Name
      const nameDiv = buildInpText('canFname', 1, `${langObj.dap_Mkr3}`);
      // Surname
      const surnameDiv = buildInpText('canSname', 1, `${langObj.dap_Mkr4}`);
      // Email
      const emailDiv = buildInpEmail('canEmail', 1, `${langObj.dap_Mkr5}`);
      // Number
      const numDiv = buildInpMobNum('canCellNum', 1, `${langObj.dap_Mkr6}`);
      // AppID
      let label = langObj.dap_Mkr8; //'Application ID';
      if (pgstr.viewAngloApp.appDetail[0].purpose === 'recruitment') {
        label = langObj.dap_Mkr7; //'Job ID';
      }
      const appIDDiv = buildInpText('canAppID', 1, `${label}`);

      //Internal/External Radio
      const radio = buildRadio(`${langObj.dap_Mkr9}`, 'internal', `${langObj.dap_Mkr10}`, 'external', 'internExternal', `${langObj.dap_Mkr9}/${langObj.dap_Mkr10}`);
      //const radio = buildRadio('Internal', 'internal', 'External', 'external', 'internExternal', 'Internal/External');
      radio.classList.add('flex');

      const FBbanner = buildFeedbackBanner();

      const btnDiv = divAtt('div', 'class', 'gridSpan');
      const btn = divAtt('button', 'class', 'btn');
      btn.innerHTML = langObj.dap_Mkr13; //'Duplicate';
      // btn.setAttribute("onclick", "ViewAngloApplication.recordDuplicateApp()");
      btnDiv.appendChild(btn);

      duplicateAppDiv.appendChild(nameDiv);
      duplicateAppDiv.appendChild(surnameDiv);
      duplicateAppDiv.appendChild(emailDiv);
      duplicateAppDiv.appendChild(numDiv);
      duplicateAppDiv.appendChild(appIDDiv);
      duplicateAppDiv.appendChild(radio);
      duplicateAppDiv.appendChild(FBbanner);
      duplicateAppDiv.appendChild(btnDiv);
      div.appendChild(instructions);
      div.appendChild(duplicateAppDiv);
      // custardBox(div, `${langObj.dap_Mkr1}`); //Duplicate Application
      eCustardBox(div, langObj.dap_Mkr1, [
        btn,
        () => {
          ViewAngloApplication.recordDuplicateApp();
        },
        'click',
      ]);
      id('canFname').classList.add('notEmptyPopUp');
      id('canSname').classList.add('notEmptyPopUp');
      id('canEmail').classList.add('notEmptyPopUp');
      id('canCellNum').classList.add('notEmptyPopUp');
      id('canAppID').classList.add('notEmptyPopUp');

      ccRegexMulti(0, pgstr.viewAngloApp.HclientID);
    });
  }

  static async recordDuplicateApp() {
    // VAL inputs here
    const inpts = document.querySelectorAll('.notEmptyPopUp');
    let passValue = true;
    const returnMessage = [];

    inpts.forEach((inpt) => {
      if (!inpt.value.trim()) {
        rejectElem(inpt);
        passValue = false;
        returnMessage.push('Please completed all required fields.');
      }
      if (inpt.classList.contains('incorrect')) {
        passValue = false;
      }
    });

    if (returnMessage.length) {
      inpFeedbackBanner(returnMessage[0]);
    } else {
      id('feedbackBanner') && hide('feedbackBanner');
    }

    if (passValue === false) {
      return;
    }

    if (id('internal').checked === false && id('external').checked === false) {
      return inpFeedbackBanner('Please select an option for Inter/External under Candidate Details');
    }

    // Add
    const phoneNumber = await sanatizeNum(id('canCellNum').value, id('countryCodes').value);
    const obj = {};
    obj.fName = id('canFname').value;
    obj.sName = id('canSname').value;
    obj.email = id('canEmail').value;
    obj.mobNum = phoneNumber;

    if (pgstr.viewAngloApp.appDetail[0].purpose === 'recruitment') {
      obj.appEmployeeID = '';
      obj.jobID = id('canAppID').value;
    } else {
      obj.appEmployeeID = id('canAppID').value;
      obj.jobID = '';
    }

    var radios = document.getElementsByName('internExternal');
    for (var i = 0, length = radios.length; i < length; i++) {
      if (radios[i].checked) {
        obj.internalExternal = {
          value: radios[i].value,
        };
        break;
      }
    }

    const vars = {};
    vars.HapplicationID = pgstr.viewAngloApp.applicationID;
    vars.payload = JSON.stringify(obj);

    PREP(['recordDuplicateAngloApplication'], vars)
      .then((res) => {
        const newApp = res.data.recordDuplicateAngloApplication[0].newHapplicationID;
        note('Application Duplicated.');
        PREP('viewAngloApp', `HAPPLICATIONID=${newApp}`);
      })
      .catch(console.error());
    hide('custardBox');
  }

  static async additionalServicesWarningPopup() {
    const langObj = {};
    for (let row of pgstr.viewAngloApp.getHTMLLexicon) {
      langObj[row.marker] = row.display;
    }

    const msg = langObj.vaa_Mkr104 ? langObj.vaa_Mkr104 : 'Please note an additional cost will be incurred by selecting these services';
    warningBox(msg, 'ViewAngloApplication.requestAddServicesAA()');
    eListen(
      'infoBoxBtn',
      () => {
        this.requestAddServicesAA();
      },
      'click'
    );
  }

  static async requestAddServicesAA() {
    if (id('popupBox')) {
      hide('popupBox');
    }

    const vars = await SAt_addServices.addSerVars(pgstr.viewAngloApp.applicationID);
    if (vars) {
      PREP(['uploadnewrecords'], vars)
        .then((res) => {
          note(res.data.uploadnewrecords);
          vars.HAPPLICATIONID = pgstr.viewAngloApp.applicationID;
          vars.HclientID = 42;
          PREP('viewAngloApp', vars);
        })
        .catch(console.error());
    }
  }

  static MPAlogic() {
    // Set Lang
    const langObj = {};
    for (let row of pgstr.viewAngloApp.getHTMLLexicon) {
      langObj[row.marker] = row.display;
    }

    const data = pgstr.viewAngloApp.appDetail[0];
    if (data.requiresMPA == 1) {
      if (data.MPAIncluded == 1) {
        id('Include').checked = true;
        id('Exclude').disabled = true;
        // id('updateMPAbtn').disabled = true;
        hide('updateMPAbtn');

        const readOnly = divAtt('p', 'class', 'instructionP');
        readOnly.innerHTML = langObj.vaa_Mkr68; //`Readonly - This option cannot be changed`;
        id('MPAheading').appendChild(readOnly);
      } else {
        id('Exclude').checked = true;
        id('updateMPAbtn').disabled = true;
      }
      unhide('MPAsection');
    }
  }

  static disableBtnMPA() {
    if (id('Exclude').checked == true) {
      id('updateMPAbtn').disabled = true;
    } else {
      id('updateMPAbtn').disabled = false;
    }
  }

  static updateMPA() {
    const vars = {};
    vars.HapplicationID = pgstr.viewAngloApp.applicationID;

    PREP(['updateMPA'], vars)
      .then((res) => {
        note(res.data.updateMPA);
        pgstr.viewAngloApp.appDetail[0].MPAIncluded = 1;
        ViewAngloApplication.MPAlogic().MPAlogic();
      })
      .catch(console.error());
  }
}

// ===================== DISCOVERY APPLICATIONS ===============

export class DiscoveryApplications {
  constructor() {
    this.name = 'Discovery Applications';
    this.pageTier = 10;
    this.reference = 'applications';
    this.pageID = null;
    this.data = null;
    this.HclientID = null;
  }

  initPage() {
    // Set page pecific variables
    this.loadPage();
  }

  loadPage() {
    this.discAppsPage();
  }

  async discAppsPage() {
    id('listApplicationsTable').innerHTML = '';

    const table = id('listApplicationsTable');
    const thead = await this.buildDiscHead();
    table.appendChild(thead);
    const searchRow = await this.buildDiscSearchRow();
    table.appendChild(searchRow);
    eListen(
      'exp',
      () => {
        applications.searchFiltersExpress();
      },
      'click'
    );
    eListen(
      'addSer',
      () => {
        applications.searchFiltersAddSer();
      },
      'click'
    );
    eListen(
      'addSuper',
      () => {
        applications.searchFiltersSuper();
      },
      'click'
    );
    eListen(
      'addScience',
      () => {
        applications.searchFiltersScience();
      },
      'click'
    );
    eListen(
      'penAct',
      () => {
        applications.searchFiltersPenAct();
      },
      'click'
    );
    eListen(
      'clearButton',
      () => {
        applications.clearSearch();
      },
      'click'
    );
    DiscoveryApplications.getDiscApplicants();
  }

  async buildDiscHead() {
    const thead = document.createElement('thead');

    const th0 = document.createElement('th');
    const th1 = document.createElement('th');
    const th2 = document.createElement('th');
    const th3 = document.createElement('th');
    const th4 = document.createElement('th');
    // const th5 = document.createElement('th');
    const th6 = document.createElement('th');
    const th7 = document.createElement('th');
    const th8 = document.createElement('th');
    const th9 = document.createElement('th');
    th1.innerHTML = 'RFC Number';
    th2.innerHTML = 'Candidate';
    th3.innerHTML = 'Job Title';
    th4.innerHTML = 'Position';
    // th5.innerHTML = 'Position Level';
    th6.innerHTML = 'Line Manager';
    th8.innerHTML = 'Status';
    th7.innerHTML = 'Pending Activity';
    th9.innerHTML = 'Action';

    thead.appendChild(th0);
    thead.appendChild(th1);
    thead.appendChild(th2);
    thead.appendChild(th3);
    thead.appendChild(th4);
    // thead.appendChild(th5);
    thead.appendChild(th6);
    thead.appendChild(th8);
    thead.appendChild(th7);
    thead.appendChild(th9);

    return thead;
  }

  async buildDiscSearchRow() {
    const searchRow = divAtt('tr', 'id', 'trSearch');

    searchRow.setAttribute('class', 'hide');
    const ts0 = document.createElement('td');
    ts0.innerHTML = `<div class="iconGrid">
    <svg  id="exp" class="iconOff" width="24px" height="26" viewBox="0 0 14.84 14.84" style="cursor: pointer;" ><rect x="1.24" y="5.56" width="4.95" height="1.24" rx="0.56"/><rect y="8.04" width="4.95" height="1.24" rx="0.59"/><path d="M7.93,1.69a6.67,6.67,0,0,1,1.61,0A.39.39,0,0,0,10,1.29V.47A.39.39,0,0,0,9.58.08H7.89A.39.39,0,0,0,7.5.47V1.3A.39.39,0,0,0,7.93,1.69Z" transform="translate(-0.08 -0.08)"/><path d="M11.27,5.59,9,7.5a1.27,1.27,0,0,0-1.18.39,1.24,1.24,0,1,0,2.1.44l1.63-2.49Z" transform="translate(-0.08 -0.08)"/><rect x="1.85" y="10.51" width="4.33" height="1.24" rx="0.56"/><path d="M8.74,2.55a6.15,6.15,0,0,0-4.4,1.86h2a4.87,4.87,0,0,1,2.37-.62,4.95,4.95,0,0,1,0,9.89,4.87,4.87,0,0,1-2.37-.62h-2A6.18,6.18,0,1,0,8.74,2.55Z" transform="translate(-0.08 -0.08)"/></svg>

    <svg  id="addSer" class="iconOff" width="25px" height="26px" viewBox="0 0 14.96 14.97" style="cursor: pointer; margin-top: 2px;" ><path d="M5.7,12.16H1.83a.79.79,0,0,1-.89-.89V1.83A.79.79,0,0,1,1.82.94h7a.8.8,0,0,1,.89.89V5.47a.47.47,0,1,0,.93,0c0-1.26,0-2.52,0-3.77A1.7,1.7,0,0,0,8.9,0H1.69A1.69,1.69,0,0,0,.35.68,2,2,0,0,0,0,1.49V11.6l0,.07a1.67,1.67,0,0,0,1.45,1.4,6.58,6.58,0,0,0,.89,0H5.68a.47.47,0,0,0,.48-.3A.46.46,0,0,0,5.7,12.16Z" transform="translate(0 0)"/><path d="M14.91,10.25A4.05,4.05,0,1,0,9.77,14.8c.27.07.54.11.81.17h.67l.42-.08A4,4,0,0,0,14.91,10.25ZM10.9,14A3.12,3.12,0,1,1,14,10.92,3.11,3.11,0,0,1,10.9,14Z" transform="translate(0 0)"/><path d="M2.05,5.81a.73.73,0,0,0,.38.11H8.17a.83.83,0,0,0,.22,0,.42.42,0,0,0,.32-.32A.46.46,0,0,0,8.23,5H2.3a.45.45,0,0,0-.41.32A.42.42,0,0,0,2.05,5.81Z" transform="translate(0 0)"/><path d="M5.71,7.48H2.38A.47.47,0,0,0,1.87,8a.48.48,0,0,0,.52.47H5.72a.47.47,0,1,0,0-.94Z" transform="translate(0 0)"/><path d="M2.39,3.43H5.11A.47.47,0,0,0,5.61,3a.48.48,0,0,0-.51-.47H2.38a.47.47,0,1,0,0,.94Z" transform="translate(0 0)"/><path d="M12.85,10.51a.62.62,0,0,0-.3-.06H11.38V9.23a.47.47,0,0,0-.47-.5.47.47,0,0,0-.47.49v1.22H9.22a.47.47,0,1,0,0,.94h1.22V12.6a.48.48,0,0,0,.48.5.48.48,0,0,0,.46-.5V11.38h1.27a.45.45,0,0,0,.44-.36A.46.46,0,0,0,12.85,10.51Z" transform="translate(0 0)"/></svg>

    <svg  id="addSuper" class="iconOff" width="28px" height="25px" viewBox="0 0 14.93 7.73" style="cursor: pointer;"><path d="M0,7.38c.31-.34.59-.7.92-1A10.53,10.53,0,0,1,5.38,3.92a8.09,8.09,0,0,1,4.7.14,10.43,10.43,0,0,1,4.71,3.08.46.46,0,0,1,0,.72,10.34,10.34,0,0,1-6,3.39,8.27,8.27,0,0,1-4.53-.54A10.52,10.52,0,0,1,.21,7.86,1.6,1.6,0,0,1,0,7.61Zm10.45.12a3,3,0,1,0-3,3A3,3,0,0,0,10.48,7.5Zm3.44,0a9.84,9.84,0,0,0-3.29-2.28,3.92,3.92,0,0,1,0,4.6A10.46,10.46,0,0,0,13.92,7.5ZM4.37,5.21A10,10,0,0,0,1.09,7.5,9.86,9.86,0,0,0,4.37,9.79,3.92,3.92,0,0,1,4.37,5.21Z" transform="translate(-0.03 -3.64)"/><path d="M7.5,6A1.49,1.49,0,1,1,6,7.49,1.49,1.49,0,0,1,7.5,6ZM8.11,7.5a.62.62,0,0,0-1.23,0,.62.62,0,1,0,1.23,0Z" transform="translate(-0.03 -3.64)"/></svg>

    <svg  id="addScience" class="iconOff" width="25px" height="26px" viewBox="0 0 13.77 14.84" style="cursor: pointer;" ><path d="M14.37,10.12a3.86,3.86,0,0,0-.67-1.69c-.15-.23-.32-.45-.49-.67L13,7.49l.11-.13a6.39,6.39,0,0,0,1-1.54,2.64,2.64,0,0,0,.26-1.34A1.72,1.72,0,0,0,13.05,3a4.89,4.89,0,0,0-2-.11l-.5.07-.15,0,0-.1c-.05-.13-.09-.25-.14-.37a.12.12,0,0,1,0-.17,1.05,1.05,0,0,0,.07-1.2A1,1,0,0,0,9.17.62.25.25,0,0,1,8.92.55,1.73,1.73,0,0,0,7.37.12a2.09,2.09,0,0,0-1.1.7,5.85,5.85,0,0,0-1.11,2l0,.14H5.05l-.2,0a5.77,5.77,0,0,0-2.2,0,2,2,0,0,0-1.31.86,2,2,0,0,0-.15,1.58A4.93,4.93,0,0,0,2,6.86c.12.16.24.32.37.47l.13.17-.07.1-.28.33-.18.26-.17.24H1.71A1.05,1.05,0,0,0,1,10.33a.2.2,0,0,1,.06.11A1.7,1.7,0,0,0,2.27,12a4.56,4.56,0,0,0,2.19.17l.48-.07.15,0c0,.1.09.21.13.31.11.25.22.52.35.77a3.67,3.67,0,0,0,1.14,1.43,1.8,1.8,0,0,0,1,.35,1.72,1.72,0,0,0,1-.35,3.66,3.66,0,0,0,.55-.5,5.7,5.7,0,0,0,1-1.94c0-.07,0-.08.13-.06a6.39,6.39,0,0,0,1.83.12.16.16,0,0,1,.14.05,1,1,0,0,0,1.27.2,1.06,1.06,0,0,0,.51-1.2.32.32,0,0,1,0-.14A1.84,1.84,0,0,0,14.37,10.12ZM2.74,11.3A1.92,1.92,0,0,1,2.17,11a.64.64,0,0,1-.25-.46,1.07,1.07,0,0,0,.57-1.72L3,8.12l0,0,.21.18c.21.19.41.37.62.54s.23.19.35.28l.26.2a.36.36,0,0,1,.07.09c.08.53.17,1,.26,1.59l0,.3A4.7,4.7,0,0,1,2.74,11.3Zm.83-3.79.87-.78V8.27ZM4.81,4c0,.28-.11.55-.16.82l-.06.43c0,.11,0,.22,0,.33s0,.09,0,.1l-1.18,1L3,6.92a4.45,4.45,0,0,1-1.12-2,.92.92,0,0,1,.58-1.1,3.16,3.16,0,0,1,.86-.18,2.17,2.17,0,0,1,.36,0,6.15,6.15,0,0,1,1.16.13Zm5-.09L10.05,5,8.73,4.27h0l.32-.12L9.61,4ZM7,1.27A1.17,1.17,0,0,1,7.56.91a1,1,0,0,1,.87.28,1,1,0,0,0,.92,1.52c.06,0,.07,0,.09.07s.07.19.11.29l0,.07h0l-.22.07-1.52.55a.24.24,0,0,1-.11,0L6.29,3.25l-.38-.14A4.85,4.85,0,0,1,7,1.27ZM5.66,3.9l1.09.36L5.43,5ZM5.42,10l1.33.77-1.1.37Zm3.19,3.68a1.37,1.37,0,0,1-.69.44,1,1,0,0,1-1-.34A4.2,4.2,0,0,1,6,12.25c0-.1-.08-.2-.11-.3l0-.08.25-.08.72-.24.47-.19.34-.13a.15.15,0,0,1,.11,0l1.54.55.27.1A5.12,5.12,0,0,1,8.61,13.65ZM9.83,11.1l-1.11-.36L10.05,10Zm.4-3.24c0,.32,0,.63-.05,1A.18.18,0,0,1,10.1,9a14.36,14.36,0,0,1-2.29,1.32.2.2,0,0,1-.15,0A15.91,15.91,0,0,1,5.36,9a.15.15,0,0,1-.06-.11,15.22,15.22,0,0,1,0-2.7.18.18,0,0,1,0-.08A14.63,14.63,0,0,1,7.68,4.72H7.8A16.71,16.71,0,0,1,10.11,6a.21.21,0,0,1,.08.16c0,.34,0,.67,0,1v.66Zm2.5-4.16.16,0a1,1,0,0,1,.67,1.19,3.83,3.83,0,0,1-.67,1.42l-.32.42-.12.13-.18-.16-.55-.49-.42-.33L11,5.7a.36.36,0,0,1-.07-.09c-.09-.52-.17-1.05-.26-1.58l0-.32A5,5,0,0,1,12.73,3.7ZM11.9,7.51,11,8.28V6.73Zm.74,3.1a1,1,0,0,0-.5.78,5.53,5.53,0,0,1-1.53-.11l.08-.41c.06-.34.13-.67.19-1v0a.78.78,0,0,0,0-.22c0-.17.07-.27.24-.4s.61-.51.91-.77l.34-.29,0,0,.07.09a3.68,3.68,0,0,1,1.06,2.35A1,1,0,0,0,12.64,10.61Z" transform="translate(-0.62 -0.08)"/><path d="M7.75,6.1a1.4,1.4,0,1,0,0,2.8,1.4,1.4,0,0,0,0-2.8Z" transform="translate(-0.62 -0.08)"/></svg>

    </div>`;
    const ts1 = document.createElement('td');
    const ts1Input = divAtt('input', 'type', 'text');
    ts1Input.setAttribute('class', 'searchInputTable searchInp');
    ts1Input.setAttribute('placeholder', 'Search by job Number');
    ts1Input.setAttribute('id', 'rfcSearch');
    const ts2 = document.createElement('td');
    const ts2Input = divAtt('input', 'type', 'text');
    ts2Input.setAttribute('placeholder', 'Search by candidate');
    ts2Input.setAttribute('class', 'searchInputTable searchInp');
    ts2Input.setAttribute('id', 'canSearch');
    const ts3 = document.createElement('td');
    const ts3Input = divAtt('input', 'type', 'text');
    ts3Input.setAttribute('class', 'searchInputTable searchInp');
    ts3Input.setAttribute('placeholder', 'Search by job title');
    ts3Input.setAttribute('id', 'jobTitleSearch');
    const ts4 = document.createElement('td');
    const ts4Input = divAtt('input', 'type', 'text');
    ts4Input.setAttribute('class', 'searchInputTable searchInp');
    ts4Input.setAttribute('placeholder', 'Search by position');
    ts4Input.setAttribute('id', 'posSearch');
    // const ts5 = divAtt('td');
    // const ts5Input = divAtt('input', 'type', 'text');
    // ts5Input.setAttribute('class', 'searchInputTable');
    // ts5Input.setAttribute('placeholder', 'Search by position level');
    // ts5Input.setAttribute('id', 'posLevelSearch');
    const ts6 = document.createElement('td');
    const ts6Input = divAtt('input', 'type', 'text');
    ts6Input.setAttribute('class', 'searchInputTable searchInp');
    ts6Input.setAttribute('placeholder', 'Search by line manager');
    ts6Input.setAttribute('id', 'lineManSearch');

    const ts8 = document.createElement('td');
    const ts8Input = divAtt('input', 'type', 'text');
    ts8Input.setAttribute('class', 'searchInputTable searchInp');
    ts8Input.setAttribute('placeholder', 'Search by status');
    ts8Input.setAttribute('id', 'statusSearch');

    const ts7 = document.createElement('td');
    ts7.innerHTML = `
    <svg id="penAct" class="iconOff" style="cursor: pointer;"  width="20.34" height="15" viewBox="0 0 20.34 15"><polygon class="cls-1" points="18.42 0 7.43 11.19 1.89 5.91 0 7.84 7.46 15 20.34 1.9 18.42 0"/></svg>
   `;
    // <div class="iconGrid"> </div>

    const ts9 = document.createElement('td');
    const clearBtn = divAtt('button', 'id', 'clearButton');
    clearBtn.setAttribute('class', 'clearBtn');
    clearBtn.innerHTML = '<svg  width="13.58" height="13.58" viewBox="0 0 13.58 13.58"><defs><style>.a{fill:#231f20;}</style></defs><polygon class="a" points="12.53 13.53 13.58 12.47 7.84 6.78 13.53 1.05 12.47 0 6.79 5.74 1.05 0.06 0 1.1 5.74 6.79 0.05 12.53 1.1 13.58 6.8 7.84 12.53 13.53"/></svg> Clear Search';

    ts1.appendChild(ts1Input);
    ts2.appendChild(ts2Input);
    ts3.appendChild(ts3Input);
    ts4.appendChild(ts4Input);
    // ts5.appendChild(ts5Input);
    ts6.appendChild(ts6Input);
    ts8.appendChild(ts8Input);
    ts9.appendChild(clearBtn);
    searchRow.appendChild(ts0);
    searchRow.appendChild(ts1);
    searchRow.appendChild(ts2);
    searchRow.appendChild(ts3);
    searchRow.appendChild(ts4);
    // searchRow.appendChild(ts5);
    searchRow.appendChild(ts6);
    searchRow.appendChild(ts8);
    searchRow.appendChild(ts7);
    searchRow.appendChild(ts9);

    return searchRow;
  }

  static async getDiscApplicants(displaypage, displayListCount) {
    const obj = {};
    obj.rfcSearch = id('rfcSearch').value;
    obj.canSearch = id('canSearch').value;
    obj.jobTitleSearch = id('jobTitleSearch').value;
    obj.posSearch = id('posSearch').value;
    obj.posLevelSearch = ''; //id('posLevelSearch').value;
    obj.lineManSearch = id('lineManSearch').value;
    obj.HclientID = id('clientDD').value;
    obj.statusSearch = id('statusSearch').value;
    obj.genSearch = id('genSearch').value;
    obj.expSearch = id('exp').classList.contains('iconOn') ? true : false;
    obj.addSearch = id('addSer').classList.contains('iconOn') ? true : false;
    obj.supervisionSearch = id('addSuper').classList.contains('iconOn') ? true : false;
    obj.scientistSearch = id('addScience').classList.contains('iconOn') ? true : false;
    obj.pendingActSearch = id('penAct').classList.contains('iconOn') ? true : false;
    // obj.publishedSearch = id('pub').classList.contains('iconOn') ? false : true;

    const vars = {};
    vars.applicationState = id('applicationState').value ? id('applicationState').value : 'o'; //id('applicationState').value ? id('applicationState').value :
    vars.displaypage = displaypage || 1;
    vars.displayListCount = displayListCount || 50;
    vars.searchObj = JSON.stringify(obj) || JSON.stringify({});
    hide('pagDiv');

    let returnData;
    await PREP(['getDiscoveryApplications'], vars, 'Searching... Please wait')
      .then((res) => {
        returnData = res.data.getDiscoveryApplications[0].ReturnList;
        let callback = (p1, p2) => {
          DiscoveryApplications.getDiscApplicants(p1, p2);
        };
        pagination(res.data.getDiscoveryApplications[0].pagination[0], callback);
        DiscoveryApplications.populateDiscAppTable(returnData);
      })
      .catch(console.error());
  }

  static async populateDiscAppTable(data) {
    if (data.length) {
      await DiscoveryApplications.buildDiscAppBody(data);
      DiscoveryApplications.searchDiscTable();
      hide('noApps');
      id('listApplicationsTable').style = 'visibility: visible;';
    } else {
      id('appListBody').innerHTML = '';
      id('listApplicationsTable').style = 'visibility: hidden;';
      unhide('noApps');
      // hide('searchSpace')
    }
  }

  static async buildDiscAppBody(data) {
    const tbody = id('appListBody') ? id('appListBody') : divAtt('tbody', 'id', 'appListBody');
    tbody.innerHTML = '';

    if (data.length) {
      for (let row of data) {
        const tr = divAtt('tr', 'class', '');
        const td0 = divAtt('td', 'class', '');
        const iconDiv = divAtt('div', 'style', 'display: flex;');
        const expressImg = divAtt('span', 'class', 'tableIcon');
        expressImg.innerHTML = timerIcon;
        const addSerImg = divAtt('span', 'class', 'tableIcon');
        addSerImg.innerHTML = additionalServicesIcon;
        const superImg = divAtt('span', 'class', 'tableIcon');
        superImg.innerHTML = supervisionIcon;
        const scientistImg = divAtt('span', 'class', 'tableIcon');
        scientistImg.innerHTML = scientistIcon;

        if (row.expressServiceYN) {
          iconDiv.appendChild(expressImg);
        }
        if (row.additionalServicesYN) {
          iconDiv.appendChild(addSerImg);
        }
        if (row.containsSupervisedAssessmentYN) {
          iconDiv.appendChild(superImg);
        }
        if (row.acanscCombo) {
          iconDiv.appendChild(scientistImg);
        }
        td0.appendChild(iconDiv);

        const td1 = divAtt('td', 'class', '');
        td1.innerHTML = row.RFCNumber;
        const td2 = divAtt('td', 'class', '');
        td2.innerHTML = row.candidateFname + ' ' + row.candidatesname;
        const td3 = divAtt('td', 'class', '');
        td3.innerHTML = row.clientjobTitle;
        const td4 = divAtt('td', 'class', '');
        td4.innerHTML = row.clientpositionID;
        // const td5 = divAtt('td', 'class', '');
        // td5.innerHTML = row.positionLevel;
        const td6 = divAtt('td', 'class', '');
        td6.innerHTML = row.lineManagerfname + ' ' + row.linemanagerSname;
        const td8 = divAtt('td', 'class', '');
        td8.innerHTML = row.status;
        const td7 = divAtt('td', 'class', '');
        const pendActivity = row.activityInProgressYN ? divAtt('img', 'src', `${tickIcon}`) : divAtt('img', 'src', `${greyCross}`);
        td7.appendChild(pendActivity);
        const td9 = divAtt('td', 'class', '');
        const btn = divAtt('button', 'onclick', 'PREP("viewApplication", "HAPPLICATIONID=' + row.HapplicationID + '")');
        btn.classList.add('btn');
        btn.innerHTML = 'view';
        td9.appendChild(btn);

        tr.appendChild(td0);
        tr.appendChild(td1);
        tr.appendChild(td2);
        tr.appendChild(td3);
        tr.appendChild(td4);
        // tr.appendChild(td5);
        tr.appendChild(td6);
        tr.appendChild(td8);
        tr.appendChild(td7);
        tr.appendChild(td9);
        tbody.appendChild(tr);
      }
      unhide('searchSpace');
    }
    id('listApplicationsTable').appendChild(tbody);
    // return tbody
  }

  static searchDiscTable() {
    const searchInp = document.querySelectorAll('.searchInp');
    searchInp.forEach((sInp) => {
      let timeout;
      sInp.addEventListener('keyup', () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          DiscoveryApplications.getDiscApplicants(1, 50);
        }, 1500);
      });
    });
  }
}

export class ViewDiscoveryApplication {
  constructor(vars) {
    this.name = 'View Application Detail';
    this.pageTier = 15;
    this.reference = 'viewApplication';
    this.pageID = null;
    this.data = null;
    this.applicationID = vars.HAPPLICATIONID;
    this.HclientID = 4;
  }

  initPage(data) {
    // Set page pecific variables
    this.appDetail = data.getApplicationDetail;
    this.HclientID = data.getApplicationDetail[0].HclientID;
    this.HapplicationID = data.getApplicationDetail[0].HapplicationID;
    this.addServices = data.getAdditionalServices;
    this.feedbackRequestor = data.getFeedbackRequestor;
    this.reportAllocToApp = cObj(data.getReportsAllocatedToApplication);
    this.addServicesAlloc = cObj(data.getAdditionalServicesAllocated);
    // this.appHistory = data.getApplicationHistory;
    this.appHistory2 = data.getApplicationHistory2;

    if (data.listAllocatedAssessmentOne.length) {
      if (data.listAllocatedAssessmentOne[0].assListArray) {
        this.appAss = data.listAllocatedAssessmentOne[0].assListArray;
      } else {
        this.appAss = data.listAllocatedAssessmentOne;
      }
    } else {
      this.appAss = data.listAllocatedAssessmentOne;
    }

    this.loadPage();
  }

  async loadPage() {
    this.viewDiscDetailPage();
  }

  viewDiscDetailPage() {
    this.viewDetail();
    this.listAssessments();
    additionalService.buildAssSerCheckboxes1(this.addServices, this.feedbackRequestor, this.HclientID);
    if (this.addServicesAlloc.length) {
      additionalService.allocatedServices(this.addServicesAlloc, 1);
    } else {
      additionalService.allocatedServices(this.addServicesAlloc);
    }

    this.buildReportList(this.reportAllocToApp);
    this.listHistory();
  }

  viewDetail() {
    const data = this.appDetail[0];

    const expressService = id('expressService');
    const checkBoxColour = id('checkBoxColour');
    expressService.checked = data.expressServiceYN;
    if (expressService.checked) {
      expressService.setAttribute('disabled', '');
      checkBoxColour.style.backgroundColor = 'var(--mediumGrey)';
    }

    id('lastUpdatedBy').innerHTML = !data.lastUpdaterText ? `N/A` : data.lastUpdaterText;
    id('lastUpdatedDate').innerHTML = !data.lastupdated ? '' : ` on ${dateFromDateTime(data.lastupdated)}`;
    id('status1').innerHTML = data.status;
    id('c_name').innerHTML = `${data.candidateFname} ${data.candidatesname}`;
    id('c_mobile').innerHTML = data.candidateMobilenumber;
    id('c_eMail').innerHTML = data.candidateEmail;

    if (data.candidateIDnumber && data.candidateIDnumber !== 'N/A') {
      id('c_idPassNum').innerHTML = data.candidateIDnumber;
      id('c_idPassNumName').innerHTML = 'ID Number';
    } else {
      id('c_idPassNum').innerHTML = data.candidatePassportNumber;
      id('c_idPassNumName').innerHTML = 'Passport Number';
    }

    id('c_comments').innerHTML = data.clientcomments;
    id('purpose').innerHTML = data.purpose;
    id('businessDivision').innerHTML = data.division;
    id('positionLevel').innerHTML = data.positionLevel;
    id('costCentre').innerHTML = data.costCenter;
    id('lineManager').innerHTML = `${data.lineManagerfname} ${data.linemanagerSname}`;
    id('lineManagerEmail').innerHTML = data.lineManagerEmail;
    id('jobTitle').innerHTML = data.clientjobTitle;
    id('jobfamily').innerHTML = data.jobFamilyName;
    id('RFCnumber').innerHTML = data.RFCNumber;
    id('recruiterEmail').innerHTML = data.recruiterEmail;
    id('preferedLoc').innerHTML = data.countryname;
    id('preferedDate').innerHTML = dateFromDateTime(data.clientrequiredAssessmentDate);
    id('status').innerHTML = data.status;
    const fname = data.recruiterfname !== null ? data.recruiterfname : '';
    const sname = data.recruitersname !== null ? data.recruitersname : '';
    id('recruiter').innerHTML = fname + ' ' + sname;

    id('Q1YN').src = data.question1 === 1 ? `${tickIcon}` : `${greyCross}`;
    id('Q2YN').src = data.question2 === 1 ? `${tickIcon}` : `${greyCross}`;
    id('QcomboYN').src = data.questionCombo === 1 ? `${tickIcon}` : `${greyCross}`;
    id('actStatus').innerHTML = data.latestActivity;

    // Cater for client pacific fields
    applications.hideClientPacificFields(this.HclientID);
  }

  // listAssessments() {

  //     const data = this.appAss;

  //     id('assessmentList').innerHTML = '';
  //     for (let el of data) {
  //         const li = divAtt('li', 'class', '');
  //         li.innerHTML = (!el.bookingdate) ? el.shortname : el.shortname + ' - ' + dateFromDateTime(el.bookingdate);
  //         id('assessmentList').appendChild(li);
  //     }
  // }

  async listAssessments() {
    const langObj = {};
    const vars = {};
    vars.HTMLPageName = 'reportHistList';
    vars.languageID = getCookie('mbohvbhfje');

    await PREP(['getHTMLLexicon'], vars).then(async (res) => {
      const lang = res.data.getHTMLLexicon;
      for (let row of lang) {
        langObj[row.marker] = row.display;
      }
    });

    const data = this.appAss;
    const ass = id('assTable');
    ass.innerHTML = '';

    if (data.length) {
      hide('noass');

      const thead = await viewApplication.buildAssHead();
      ass.appendChild(thead);

      for (const el of data) {
        const tr = divAtt('tr');
        const td1 = divAtt('td');
        td1.innerHTML = el.shortname;
        const td2 = divAtt('td');
        td2.innerHTML = el.assStatus ? el.assStatus : '';
        const td3 = divAtt('td');
        const bookingDate = el.bookingdate ? dateFromDateTime(el.bookingdate) : el.bookingdate;
        td3.innerHTML = el.lastUpdated ? dateFromDateTime(el.lastUpdated) : bookingDate;
        tr.appendChild(td1);
        tr.appendChild(td2);
        tr.appendChild(td3);
        ass.appendChild(tr);
      }
    } else {
      unhide('noass');
    }
  }

  async listHistory() {
    const data = this.appHistory2;
    const history = id('hidtoryList');
    history.innerHTML = '';

    if (data.length) {
      hide('noHistory');
      viewApplication.buildHistoryTable(data);
    } else {
      unhide('noHistory');
    }
  }

  async buildReportList(reports) {
    const table = id('applicationReports') ? id('applicationReports') : id('userReports');
    table.innerHTML = '';

    if (reports.length) {
      hide('noReports');
      const thead = await viewApplication.listReportHead();
      table.appendChild(thead);

      reports.forEach((rprt) => {
        PREP(['downloadReport'], {
          reportRegisterID: rprt.REPORTREGISTERID,
        })
          .then(async (res) => {
            rprt.url = res.data.downloadReport;
            await this.listReports(rprt, table);
          })
          .catch(console.error());
      });
    } else {
      unhide('noReports');
    }
  }

  async listReports(data, table) {
    console.log('encrypt', data);
    const tr = divAtt('tr', 'class', '');
    const td1 = divAtt('td', 'class', 'reportdate');
    td1.innerHTML = dateFromDateTime(new Date(data.DATEON));
    const td2 = divAtt('td', 'class', 'reportUpdater');
    td2.innerHTML = `${data.FNAME} ${data.SNAME}`;
    const td3 = divAtt('td', 'class', 'reporttype');
    td3.innerHTML = data.REPORTTYPE;
    const td7 = divAtt('td', 'class', 'reporttype');
    td7.innerHTML = data.ORIGINALFILE;

    const td4 = divAtt('td', 'class', 'center');
    if (data.ENCRYPTYN) {
      const encryptIcon = divAtt('div', 'class', 'iconTable');
      encryptIcon.innerHTML = keyEncrypt;
      td4.appendChild(encryptIcon);
    }

    const td5 = divAtt('td', 'class', 'reporreporturlttype');
    const btn = divAtt('button', 'class', 'btn');
    btn.innerHTML = 'View';

    td5.appendChild(btn);

    const td6 = divAtt('td', 'class', 'downloadHistory');
    const histBtn = divAtt('button', 'class', 'btn');
    histBtn.innerHTML = 'Download History';
    // const histBtn = buildBtn(
    //   "dlHist",
    //   `report.reportHistory('${data.REPORTREGISTERID}', '${data.ORIGINALFILE}')`,
    //   "Download History"
    // );
    td6.appendChild(histBtn);

    tr.appendChild(td1);
    tr.appendChild(td2);
    tr.appendChild(td3);
    tr.appendChild(td7);
    tr.appendChild(td4);
    tr.appendChild(td5);
    tr.appendChild(td6);

    table.appendChild(tr);
    if (data.ENCRYPTYN) {
      eListen(
        btn,
        () => {
          report.encryptedReport(data.REPORTREGISTERID, data.ORIGINALFILE);
        },
        'click'
      );
      // btn.setAttribute(
      //   "onclick",
      //   `report.encryptedReport('${data.REPORTREGISTERID}', '${data.ORIGINALFILE}')`
      // );
    } else {
      eListen(
        btn,
        () => {
          report.download(data.REPORTREGISTERID);
        },
        'click'
      );
      // btn.setAttribute(
      //   "onclick",
      //   `report.download('${data.REPORTREGISTERID}')`
      // );
    }
    eListen(
      histBtn,
      () => {
        report.reportHistory(data.REPORTREGISTERID, data.ORIGINALFILE);
      },
      'click'
    );
  }

  static async requestAddServicesDisc() {
    const vars = await SAt_addServices.addSerVars(pgstr.viewApplication.HapplicationID);

    console.log(vars);

    if (vars) {
      PREP(['uploadnewrecords'], vars)
        .then((res) => {
          note(res.data.uploadnewrecords);
          vars.HAPPLICATIONID = pgstr.viewApplication.HapplicationID;
          PREP('viewApplication', vars);
        })
        .catch(console.error());
    }
  }
}

export class RecordDiscoveryApplication {
  constructor(vars) {
    this.name = 'Record Discovery Application';
    this.pageTier = 10;
    this.reference = 'addApplications';
    this.pageID = null;
    this.data = null;
    this.HclientID = vars.HclientID;
    this.grouping = vars.grouping;
    this.getDDCountry = null;
    this.getDDPositionLevel = null;
    this.getDiscoveryLineManagers = null;
    this.getDDCostCenters = null;
    this.getDDdivisions = null;
    this.getDDjobfamily = null;
    this.getDiscoveryRecruiters = null;
  }
  initPage(data) {
    // Set page pecific variables
    this.getDDCountry = cObj(data.getDDCountry);
    this.getDDPositionLevel = cObj(data.getDDPositionLevel);
    this.getDiscoveryLineManagers = cObj(data.getDiscoveryLineManagers);
    this.getDDCostCenters = cObj(data.getDDCostCenters);
    this.getDDdivisions = cObj(data.getDDdivisions);
    this.getDDjobfamily = cObj(data.getDDjobfamily);
    this.getDiscoveryRecruiters = cObj(data.getDiscoveryRecruiters);

    this.loadPage();
  }

  async loadPage() {
    this.populateDiscRecordPage();
  }

  populateDiscRecordPage() {
    // getDDCountry
    buildDropDownMain(this.getDDCountry, 'preferredLocation', 'DDCOUNTRYID', 'DESCRIPTION');

    // getDDPositionLevel
    createSelectOptions2(this.getDDPositionLevel, 'DDPOSITIONLEVELID', ['SHORTDESCRIPTION'], 'DDpositionLevelID');
    id('DDpositionLevelID').addEventListener('click', () => {
      const select = id('DDpositionLevelID');
      id('c_f_positionlevel').value = select.options[select.selectedIndex].text;
    });

    id('DDjobFamilyID').addEventListener('change', () => {
      if (id('DDjobFamilyID').value === '6') {
        unhide('APOquestions');
      } else {
        hide('APOquestions');
      }
    });

    // getDiscoveryLineManagers
    createSelectOptions2(this.getDiscoveryLineManagers, 'HUSERID', ['COMBONAME'], 'hiringManagerID');
    id('hiringManagerID').addEventListener('click', () => {
      const select = id('hiringManagerID');
      id('c_f_hiringManager').value = select.options[select.selectedIndex].text;
    });

    // getDDCostCenters
    createSelectOptions2(this.getDDCostCenters, 'DDCOSTCENTERID', ['SHORTDESCRIPTION'], 'DDcostCenterID');
    id('DDcostCenterID').addEventListener('click', () => {
      var select = id('DDcostCenterID');
      id('newCostCenterName').value = select.options[select.selectedIndex].text;
    });

    // getDDdivisions
    createSelectOptions2(this.getDDdivisions, 'DDDIVISIONID', ['SHORTDESCRIPTION'], 'DDdivisionID');
    id('DDdivisionID').addEventListener('click', () => {
      const select = id('DDdivisionID');
      id('newDivisionName').value = select.options[select.selectedIndex].text;
    });

    // getDDjobfamily
    createSelectOptions2(this.getDDjobfamily, 'DDJOBFAMILYID', ['FULLDECSRIPTION'], 'DDjobFamilyID');
    id('DDjobFamilyID').addEventListener('click', () => {
      const select = id('DDjobFamilyID');
      id('newjobFamilyName').value = select.options[select.selectedIndex].text;
    });

    // getDiscoveryRecruiters
    createSelectOptions2(this.getDiscoveryRecruiters, 'HUSERID', ['COMBONAME'], 'recruiterID');
    id('recruiterID').addEventListener('click', () => {
      const select = id('recruiterID');
      id('c_f_recruiter').value = select.options[select.selectedIndex].text;
    });

    ccRegexMulti(0, pgstr.addApplications.HclientID);
  }

  static selectCountry() {
    if (id('countrySelect').checked === false) {
      id('candidateIDnr').classList.remove('notEmpty');
      id('candidateIDnr').value = '';
      id('candidatePassportnr').classList.add('notEmpty');
      unhide('candidatePassportnrInput');
      hide('candidateIDnrInput');
    } else {
      id('candidateIDnr').classList.add('notEmpty');
      id('candidatePassportnr').classList.remove('notEmpty');
      id('candidatePassportnr').value = '';
      hide('candidatePassportnrInput');
      unhide('candidateIDnrInput');
    }
  }

  static addNew(selectID, inputID, btnID, newDiv) {
    const input = id(inputID);
    const select = id(selectID);

    select.value = '';
    input.value = '';
    input.setAttribute('placeHolder', `New ${id(inputID).name}`);
    input.classList.add('newEnt');

    const btn = id(btnID);
    btn.innerHTML = `<img style="width: 17px; position: relative;
        top: -3px;" alt="add new">`;
    btn.src = minusIcon;

    if (newDiv) {
      unhide(newDiv);
      hide(selectID);
      btn.setAttribute('onclick', `RecordDiscoveryApplication.showOptions("${selectID}", "${inputID}", "${btnID}", "${newDiv}")`);
      select.classList.remove('notEmpty');

      // new entries
      id(`${selectID}fname`).classList.add('notEmpty');
      id(`${selectID}sname`).classList.add('notEmpty');
      id(`${selectID}emailaddress`).classList.add('notEmpty');
      id(`${selectID}emailaddress`).classList.add('eAddress');
      id(`${selectID}mobileNo`).classList.add('notEmpty');
      id(`${selectID}mobileNo`).classList.add('mobNum');
    } else {
      select.classList.remove('notEmpty');
      input.classList.add('notEmpty');
      input.setAttribute('onchange', 'notEmptyVal(this.id)');
      hide(selectID);
      btn.setAttribute('onclick', `RecordDiscoveryApplication.showOptions("${selectID}", "${inputID}", "${btnID}")`);
    }
  }

  static showOptions(selectID, inputID, btnID, newDiv) {
    const input = id(inputID);
    const select = id(selectID);

    input.value = '';
    input.setAttribute('placeHolder', `Search ${id(inputID).name}`);
    input.classList.remove('newEnt');

    const btn = id(btnID);
    btn.innerHTML = `<img style="height: 17px; margin-top: 3px" src="${plusIcon}" alt="add new">`;

    if (newDiv) {
      hide(newDiv);
      unhide(selectID);
      btn.setAttribute('onclick', `RecordDiscoveryApplication.addNew("${selectID}", "${inputID}", "${btnID}", "${newDiv}")`);

      select.classList.add('notEmpty');

      // new entries remove val
      id(`${selectID}fname`).classList.remove('notEmpty');
      id(`${selectID}sname`).classList.remove('notEmpty');
      id(`${selectID}emailaddress`).classList.remove('notEmpty');
      id(`${selectID}emailaddress`).classList.remove('eAddress');
      id(`${selectID}mobileNo`).classList.remove('notEmpty');
      id(`${selectID}mobileNo`).classList.remove('mobNum');
    } else {
      select.classList.add('notEmpty');
      input.classList.remove('notEmpty');
      input.removeAttribute('onchange', 'notEmptyVal(this.id)');
      unhide(selectID);
      btn.setAttribute('onclick', `RecordDiscoveryApplication.addNew("${selectID}", "${inputID}", "${btnID}")`);
    }
  }

  static async recordDiscApplication() {
    if (!validatePage()) {
      return;
    }

    if (!id('rfcNr_FB').classList.contains('hide')) {
      id('rfcNr').classList.add('incorrect');
      inpFeedbackBanner('RFC number is already assigned. Please verify its accuracy or provide a new one.');
      return;
    }

    const obj = {};
    obj.expressService = id('expressService').checked ? 1 : 0;
    obj.candidatefname = id('candidatefname').value.trim();
    obj.candidatesname = id('candidatesname').value.trim();
    if (id('countrySelect').checked) {
      obj.foreignNational = 0;
      obj.candidateIDnr = id('candidateIDnr').value.trim();
    } else {
      obj.foreignNational = 1;
      obj.passportNumber = id('candidatePassportnr').value.trim();
    }
    obj.candidateemailAddress = id('candidateemailAddress').value.trim();
    const phoneNumber = await sanatizeNum(id('candidatemobileNo').value, id('countryCodesCan').value);
    obj.candidatemobileNo = phoneNumber;
    obj.positionNumber = id('positionNumber').value.trim();
    obj.rfcNr = id('rfcNr').value.trim();
    obj.clientcomments = id('clientcomments').value.trim();
    obj.clientcomments = obj.clientcomments ? obj.clientcomments : 0;
    obj.jobTitle = id('jobTitle').value.trim();
    obj.preferredDate = id('preferredDate').value.trim();
    obj.DDCountryID = id('preferredLocation').value;
    obj.purpose = id('purpose').value.trim();

    obj.DDpositionLevelID = id('DDpositionLevelID').value;
    obj.acansc1 = id('DDjobFamilyID').value == 6 ? toggleSliderYN(id('APOq1').checked) : 0;
    obj.acansc2 = id('DDjobFamilyID').value == 6 ? toggleSliderYN(id('APOq2').checked) : 0;
    obj.DDjobFamilyID = id('DDjobFamilyID').value.trim();

    obj.DDcostCenterID = id('DDcostCenterID').value.trim();
    if (obj.DDcostCenterID === '') {
      obj.DDcostCenterID = 0;
      obj.newCostCenterName = id('newCostCenterName').value;
    }

    obj.DDdivisionID = id('DDdivisionID').value.trim();
    if (obj.DDdivisionID === '') {
      obj.DDdivisionID = 0;
      obj.newDivisionName = id('newDivisionName').value;
    }

    // ============hiring manager
    obj.hiringManagerID = id('hiringManagerID').value.trim();
    if (obj.hiringManagerID === '') {
      obj.hiringManagerID = 0;
      obj.hiringManagerfname = id('hiringManagerIDfname').value.trim();
      obj.hiringManagersname = id('hiringManagerIDsname').value.trim();
      const mobNumHM = await sanatizeNum(id('hiringManagerIDmobileNo').value, id('HMcountryCodes').value);
      obj.hiringmanagermobileNo = mobNumHM;
      obj.hiringManageremailaddress = id('hiringManagerIDemailaddress').value.trim();
    }

    if (obj.hiringManageremailaddress === obj.candidateemailAddress) {
      infoBox("Hiring manager's email address can not be the same as the applicants email address.");
      return;
    }

    // ============ Recruiter
    obj.recruiterID = id('recruiterID').value.trim();
    if (obj.recruiterID === '') {
      obj.recruiterID = 0;
      obj.recruiterfname = id('recruiterIDfname').value.trim();
      obj.recruitersname = id('recruiterIDsname').value.trim();
      const mobNumR = await sanatizeNum(id('recruiterIDmobileNo').value, id('countryCodesR').value);
      obj.recruitermobileNo = mobNumR;
      obj.recruiteremailaddress = id('recruiterIDemailaddress').value.trim();
    }

    if (obj.recruiteremailaddress === obj.candidateemailAddress) {
      infoBox('Recruiter email address can not be the same as the applicants email address.');
      return;
    }

    const vars = {};
    vars.payLoad = JSON.stringify(obj);
    vars.entityType = 'recordDiscoveryApplication';
    vars.entityUUID = uuidv4();
    PREP(['uploadNewRecords'], vars)
      .then((res) => {
        note(res.statusText);
        window.scrollTo(0, 0);
        changeTabN('addApplications');
      })
      .catch(console.error());
  }

  static searchRFC() {
    const rfcInpt = id('rfcNr');
    const vars = {};
    vars.HclientID = 4;
    vars.RFCNumber = rfcInpt.value;

    if (!rfcInpt.value) {
      id('rfcNr_FB').innerHTML = 'Please fill in required field.';
      return;
    }
    PREP(['checkRFCNumberExists'], vars, 'Searching for RFC...').then((res) => {
      const result = res.data.checkRFCNumberExists[0].RFCExistsYN;

      if (result === 1) {
        rfcInpt.classList.add('incorrect');
        id('rfcNr_FB').innerHTML = 'This RFC number is already assigned. Please verify its accuracy or provide a new one.';
        unhide('rfcNr_FB');
      } else {
        rfcInpt.classList.remove('incorrect');
        id('rfcNr_FB').innerHTML = 'Please fill in required field.';
        hide('rfcNr_FB');
      }
    });
  }
}

// ======== GENERIC FUNCTIONS =========

export class applications {
  static async searchFilters() {
    const searchFilters = id('searchFilters');
    const trSearch = id('trSearch');

    if (trSearch.classList.contains('hide')) {
      searchFilters.classList.add('searchFiltersActive');
      hide('searchBar');
      id('genSearch').value = '';
      unhide('trSearch');
    } else {
      searchFilters.classList.remove('searchFiltersActive');
      hide('trSearch');
      unhide('searchBar');

      const searchInps = document.querySelectorAll('.searchInp');
      searchInps.forEach((inp) => {
        inp.value = '';
      });
    }
    applications.appIndicator();
    applications.clearSearch();
  }
  static async searchFiltersExpress() {
    const express = id('exp');

    if (express.classList.contains('iconOn')) {
      express.classList.remove('iconOn');
    } else {
      express.classList.add('iconOn');
    }

    applications.appIndicator();
  }
  static async searchFiltersAddSer() {
    const addServices = id('addSer');

    if (addServices.classList.contains('iconOn')) {
      addServices.classList.remove('iconOn');
    } else {
      addServices.classList.add('iconOn');
    }
    applications.appIndicator();
  }
  static async searchFiltersSuper() {
    const addSupervsion = id('addSuper');

    if (addSupervsion.classList.contains('iconOn')) {
      addSupervsion.classList.remove('iconOn');
    } else {
      addSupervsion.classList.add('iconOn');
    }
    applications.appIndicator();
  }
  static async searchFiltersScience() {
    const addScience = id('addScience');

    if (addScience.classList.contains('iconOn')) {
      addScience.classList.remove('iconOn');
    } else {
      addScience.classList.add('iconOn');
    }
    applications.appIndicator();
  }
  static async searchFiltersPublished() {
    const published = id('pub');

    if (published.classList.contains('iconOn')) {
      published.classList.remove('iconOn');
    } else {
      published.classList.add('iconOn');
    }
    applications.appIndicator();
  }
  static async searchFiltersPenAct() {
    const penActYes = id('penAct');

    if (penActYes.classList.contains('iconOn')) {
      penActYes.classList.remove('iconOn');
    } else {
      penActYes.classList.add('iconOn');
    }

    applications.appIndicator();
  }
  static async searchFiltersSmartR() {
    const smartYes = id('smartR');

    if (smartYes.classList.contains('iconOn')) {
      smartYes.classList.remove('iconOn');
    } else {
      smartYes.classList.add('iconOn');
    }

    applications.appIndicator();
  }
  static async searchFiltersSuccess() {
    const success = id('success');
    const unsuccessful = id('unsuccessful');

    if (success.classList.contains('iconOn')) {
      success.classList.remove('iconOn');
    } else {
      success.classList.add('iconOn');
      unsuccessful.classList.remove('iconOn');
    }

    applications.appIndicator();
  }
  static async searchFiltersUnsuccess() {
    const unsuccessful = id('unsuccessful');
    const success = id('success');

    if (unsuccessful.classList.contains('iconOn')) {
      unsuccessful.classList.remove('iconOn');
    } else {
      unsuccessful.classList.add('iconOn');
      success.classList.remove('iconOn');
    }

    applications.appIndicator();
  }
  static async searchFiltersDupStatus() {
    const dupStatus = id('dupStatus');

    if (dupStatus.classList.contains('iconOn')) {
      dupStatus.classList.remove('iconOn');
    } else {
      dupStatus.classList.add('iconOn');
    }

    applications.appIndicator();
  }

  static async searchFilterOnOff(elID) {
    const icon = id(elID);

    if (icon.classList.contains('iconOn')) {
      icon.classList.remove('iconOn');
    } else {
      icon.classList.add('iconOn');
    }

    applications.appIndicator();
  }

  static async clearSearch() {
    const searchInps = document.querySelectorAll('.searchInp');
    searchInps.forEach((inp) => {
      inp.value = '';
    });

    if (id('exp')) {
      id('exp').classList.remove('iconOn');
    }

    if (id('addSer')) {
      id('addSer').classList.remove('iconOn');
    }

    if (id('addSuper')) {
      id('addSuper').classList.remove('iconOn');
    }

    //Discovery extra search fields
    if (id('addScience')) {
      id('addScience').classList.remove('iconOn');
    }
    // Generic not published search
    if (id('pub')) {
      id('pub').classList.remove('iconOn');
    }

    if (id('penAct')) {
      id('penAct').classList.remove('iconOn');
    }

    if (id('smartR')) {
      id('smartR').classList.remove('iconOn');
    }

    if (id('dupStatus')) {
      id('dupStatus').classList.remove('iconOn');
    }

    if (id('unsuccessful')) {
      id('unsuccessful').classList.remove('iconOn');
    }

    if (id('success')) {
      id('success').classList.remove('iconOn');
    }

    if (id('dateSearch')) {
      id('dateSearch').value = '';
    }

    if (id('MFE')) {
      id('MFE').classList.remove('iconOn');
    }
    if (id('CFE')) {
      id('CFE').classList.remove('iconOn');
    }
    if (id('CDR')) {
      id('CDR').classList.remove('iconOn');
    }
    if (id('MCG')) {
      id('MCG').classList.remove('iconOn');
    }

    applications.appIndicator();
  }
  static paginate(pagination, callback, direction) {
    const pagDiv = id('pagDiv');
    pagDiv.innerHTML = '';
    const varble = direction ? direction : '';
    if (pagination.totalPages == 1) {
      hide('pagDiv');
    } else if (pagination.totalPages <= 10) {
      for (let i = 1; i <= pagination.totalPages; i++) {
        const button = divAtt('button', 'class', 'pagNum');
        //button.setAttribute("onclick", `${callback}(${i}, '${varble}')`);
        button.innerHTML = i;
        if (i == pagination.currentPage) {
          button.classList.add('pagNumActive');
        }
        pagDiv.appendChild(button);
        eListen(
          button,
          () => {
            eval(`${callback}(${i}, '${varble}')`);
          },
          'click'
        );
      }
      unhide('pagDiv');
    } else if (pagination.totalPages > 10) {
      paginateA(pagination, callback, varble);
    }
  }
  static async changeAppState(block, appState) {
    // block active
    const blocks = document.querySelectorAll('.blockItem');
    blocks.forEach((block) => {
      block.classList.remove('blockActive');
    });
    id(block).classList.add('blockActive');
    id('applicationState').value = appState;

    applications.appIndicator();
  }
  static async appIndicator() {
    console.log(id('appIndicator').value);
    if (id('appIndicator').value === 'gap') {
      await AdminApplications.getApplicants(1, 50);
    } else if (id('appIndicator').value === 'disc') {
      await DiscoveryApplications.getDiscApplicants(1, 50);
    } else if (id('appIndicator').value === 'gapDetails') {
      await ManageApplications.getGAPApplicants(1, 50);
    } else if (id('appIndicator').value === 'anglo') {
      await AngloApplications.getAngloApplicants(1, 50);
    }
  }

  static hideClientPacificFields(HclientID) {
    // Cater for client pacific fields
    const vars = {};
    vars.HclientID = HclientID;
    PREP(['getClientDetails'], vars)
      .then((res) => {
        const clientDets = res.data.getClientDetails[0];
        Object.entries(optionalFieldsObj).forEach((field) => {
          if (clientDets[`${field[0]}`] === 0) {
            //|| clientDets[`${field[0]}`] === ''

            if (id(`${field[1].displayDiv}`)) {
              console.log('hide:', `${field[1].detailDiv}`);
              hide(`${field[1].displayDiv}`);

              if (id(`${field[1].displayDiv}`) === 'GAPDisplayLineManager' || id(`${field[1].displayDiv}`) === 'GAPDisplayRecruiter') {
                if (id('lineEmailDisplay')) {
                  hide('lineEmailDisplay');
                  hide('lineManagerEmail');
                }

                if (id('recruiterEmailDisplay')) {
                  hide('recruiterEmailDisplay');
                  hide('recruiterEmail');
                }
              }
            }

            if (id(`${field[1].detailDiv}`)) {
              hide(`${field[1].detailDiv}`);
            }
          }
        });
      })
      .catch(console.error());
  }

  static reactivateApp(appID) {
    const vars = {};
    vars.HapplicationID = appID;

    PREP(['uncancellApplication'], vars)
      .then((res) => {
        note(res.data.uncancellApplication);
        PREP('adminApplications');
      })
      .catch(console.error());
  }
}

export const viewApplication = {
  async toggleHistory(numID) {
    const langObj = {};
    const vars = {};
    vars.HTMLPageName = 'reportHistList';
    vars.languageID = getCookie('mbohvbhfje');

    await PREP(['getHTMLLexicon'], vars).then(async (res) => {
      const lang = res.data.getHTMLLexicon;
      for (let row of lang) {
        langObj[row.marker] = row.display;
      }
    });

    id(`historyShow1_${numID}`).classList.toggle('hide');
    id(`historyShow2_${numID}`).classList.toggle('hide');

    const showMore = langObj.rhl_Mkr7 ? langObj.rhl_Mkr7 : 'Show more';
    const btn = id(`historyView_${numID}`);
    if (btn.innerHTML === showMore) {
      btn.innerHTML = langObj.rhl_Mkr6 ? langObj.rhl_Mkr6 : 'Show less';
    } else {
      btn.innerHTML = showMore;
    }
  },
  async buildHistoryHead() {
    const langObj = {};

    const vars = {};
    vars.HTMLPageName = 'reportHistList';
    vars.languageID = getCookie('mbohvbhfje');

    await PREP(['getHTMLLexicon'], vars).then(async (res) => {
      const lang = res.data.getHTMLLexicon;
      for (let row of lang) {
        langObj[row.marker] = row.display;
      }
    });

    const thead = divAtt('thead');
    const th1 = document.createElement('th');
    const th2 = document.createElement('th');
    const th3 = document.createElement('th');
    const th4 = document.createElement('th');
    th1.innerHTML = langObj.rhl_Mkr1 ? langObj.rhl_Mkr1 : 'Date';
    th2.innerHTML = langObj.rhl_Mkr2 ? langObj.rhl_Mkr2 : 'History updater';
    th3.innerHTML = langObj.rhl_Mkr3 ? langObj.rhl_Mkr3 : 'History Type';
    th4.innerHTML = '';
    thead.appendChild(th1);
    thead.appendChild(th2);
    thead.appendChild(th3);
    thead.appendChild(th4);

    return thead;
  },
  async buildHistoryTable(data) {
    const langObj = {};
    const vars = {};
    vars.HTMLPageName = 'reportHistList';
    vars.languageID = getCookie('mbohvbhfje');

    await PREP(['getHTMLLexicon'], vars).then(async (res) => {
      const lang = res.data.getHTMLLexicon;
      for (let row of lang) {
        langObj[row.marker] = row.display;
      }
    });

    const history = id('hidtoryList');
    const timezone = await getLocalTimeUCT();
    const tz = timezone ? `(${timezone})` : '';
    const thead = divAtt('thead');
    const th1 = document.createElement('th');
    const th2 = document.createElement('th');
    const th3 = document.createElement('th');
    const th4 = document.createElement('th');
    const th5 = document.createElement('th');
    th1.innerHTML = langObj.rhl_Mkr1 ? `${langObj.rhl_Mkr1} ${tz}` : `Date ${tz}`;
    th2.innerHTML = langObj.rhl_Mkr2 ? langObj.rhl_Mkr2 : 'History updater';
    th3.innerHTML = langObj.rhl_Mkr3 ? langObj.rhl_Mkr3 : 'History Type';
    th4.innerHTML = langObj.rhl_Mkr12 ? langObj.rhl_Mkr12 : 'Update';
    th5.innerHTML = '';
    thead.appendChild(th1);
    thead.appendChild(th2);
    thead.appendChild(th3);
    thead.appendChild(th4);
    thead.appendChild(th5);
    history.appendChild(thead);

    for (const el of data) {
      const dbDate = `${el.Dateon} GMT+0200`;
      const convertDate = new Date(dbDate);

      const tr = divAtt('tr');
      const td1 = divAtt('td');
      td1.innerHTML = formatDateTime(convertDate);
      const td2 = divAtt('td');
      td2.innerHTML = el.comboname;
      const td3 = divAtt('td');
      td3.innerHTML = el.historyType;
      const td4 = divAtt('td');
      td4.innerHTML = el.description;
      const td5 = divAtt('td');
      const btn = divAtt('button', 'class', 'btn');
      btn.innerHTML = langObj.rhl_Mkr13 ? langObj.rhl_Mkr13 : 'View comms';
      if (el.commslogID) {
        // btn.setAttribute(
        //   "onclick",
        //   `viewApplication.viewMsg(${el.commslogID})`
        // );
        td5.appendChild(btn);
      }

      tr.appendChild(td1);
      tr.appendChild(td2);
      tr.appendChild(td3);
      tr.appendChild(td4);
      tr.appendChild(td5);

      history.appendChild(tr);
      if (el.commslogID) {
        eListen(
          btn,
          () => {
            viewApplication.viewMsg(el.commslogID);
          },
          'click'
        );
      }
    }
  },
  async listReportHead() {
    const langObj = {};
    const vars = {};
    vars.HTMLPageName = 'reportHistList';
    vars.languageID = getCookie('mbohvbhfje');

    await PREP(['getHTMLLexicon'], vars).then(async (res) => {
      const lang = res.data.getHTMLLexicon;
      for (let row of lang) {
        langObj[row.marker] = row.display;
      }
    });

    const thead = document.createElement('thead');
    const th1 = document.createElement('th');
    const th2 = document.createElement('th');
    const th3 = document.createElement('th');
    const th7 = document.createElement('th');
    const th4 = document.createElement('th');
    const th5 = document.createElement('th');
    const th6 = document.createElement('th');
    th1.innerHTML = langObj.rhl_Mkr1 ? langObj.rhl_Mkr1 : 'Date';
    th2.innerHTML = langObj.rhl_Mkr4 ? langObj.rhl_Mkr4 : 'Report updater';
    th3.innerHTML = langObj.rhl_Mkr5 ? langObj.rhl_Mkr5 : 'Report Type';
    th7.innerHTML = langObj.rhl_Mkr8 ? langObj.rhl_Mkr8 : 'File Name';
    th4.innerHTML = ''; //Encrypted
    th5.innerHTML = '';
    th6.innerHTML = '';
    thead.appendChild(th1);
    thead.appendChild(th2);
    thead.appendChild(th3);
    thead.appendChild(th7);
    thead.appendChild(th4);
    thead.appendChild(th5);
    thead.appendChild(th6);

    return thead;
  },
  async buildAssHead() {
    const langObj = {};

    const vars = {};
    vars.HTMLPageName = 'reportHistList';
    vars.languageID = getCookie('mbohvbhfje');

    await PREP(['getHTMLLexicon'], vars).then(async (res) => {
      const lang = res.data.getHTMLLexicon;
      for (let row of lang) {
        langObj[row.marker] = row.display;
      }
    });

    const thead = divAtt('thead');
    const th1 = document.createElement('th');
    const th2 = document.createElement('th');
    const th3 = document.createElement('th');
    th1.innerHTML = langObj.rhl_Mkr9 ? langObj.rhl_Mkr9 : 'Assessment';
    th2.innerHTML = langObj.rhl_Mkr10 ? langObj.rhl_Mkr10 : 'Status';
    th3.innerHTML = langObj.rhl_Mkr11 ? langObj.rhl_Mkr11 : 'Last Status update';
    thead.appendChild(th1);
    thead.appendChild(th2);
    thead.appendChild(th3);

    return thead;
  },
  async viewMsg(msgId) {
    const vars = {};
    vars.commslogID = msgId;
    vars.HTMLPageName = 'EUt_messageBox';
    vars.languageID = getCookie('mbohvbhfje');
    PREP(['getMessageDetail', 'getHTMLLexicon'], vars)
      .then(async (res) => {
        const langObj = {};
        const data = res.data.getHTMLLexicon;
        for (let row of data) {
          langObj[row.marker] = row.display;
        }

        const msgDetail = divAtt('div', 'class', 'grid-1col');
        const detail = res.data.getMessageDetail[0];

        const date = divAtt('p', 'id', 'msgDDate');
        date.innerHTML = dateFromDateTime(`${detail.spooled}`);
        const subject = divAtt('h5', 'id', 'msgDSubject');
        subject.style = 'text-align: left;';
        subject.innerHTML = detail.emailSubject;
        const sender = divAtt('p', 'id', 'msgDWho');
        if (detail.direction) {
          sender.innerHTML = `From: <span>${detail.senderName}</span>`;
        } else {
          sender.innerHTML = `To: <span>${detail.senderName}</span>`;
        }

        const hr = divAtt('hr', 'style', 'margin-top: 30px;');
        const msg = divAtt('p', 'id', 'text');
        msg.innerHTML = detail.emailBody;

        msgDetail.appendChild(date);
        msgDetail.appendChild(subject);
        msgDetail.appendChild(sender);
        msgDetail.appendChild(hr);
        msgDetail.appendChild(msg);

        await custardBox(msgDetail, '');
      })
      .catch(console.error());
  },
};

export const report = {
  download: (reportRegisterID) => {
    PREP(['downloadReport'], {
      reportRegisterID: reportRegisterID,
    })
      .then((res) => {
        window.open(res.data.downloadReport, '_blank');
      })
      .catch(console.error());
  },
  removeReason: async (reportRegisterID) => {
    const removedClassification = [
      {
        rmvClass: 'Testing',
      },
      {
        rmvClass: 'Incorrect file uploaded',
      },
      {
        rmvClass: 'Other/Unknown',
      },
    ];

    const div = divAtt('div', 'class', 'grid-1col');
    div.setAttribute('id', 'cancelDiv');
    const select = await buildSelectInp('removeReason', 1, 'Reason');
    select.setAttribute('style', 'margin-top: 3rem;');
    const comments = await buildTextarea('removeComments', 0, 'Comments');
    // const btn = buildBtnFormCenter(
    //   "confirmCancel",
    //   `report.remove('${reportRegisterID}')`,
    //   "Remove"
    // );
    const btn = divAtt('button', 'class', 'btn');
    btn.innerHTML = `Remove`;
    div.appendChild(select);
    div.appendChild(comments);
    div.appendChild(btn);
    // custardBox(div, `Reason For Removing Report`);
    eCustardBox(div, `Reason For Removing Report`, [
      btn,
      () => {
        report.remove(`${reportRegisterID}`);
      },
      'click',
    ]);
    buildDropDownMain(removedClassification, 'removeReason', 'rmvClass', 'rmvClass');
  },
  remove: (reportRegisterID) => {
    if (id('removeReason').value === '-') {
      validatePage();
      infoBox('Please select a reason from the dropdown.');
      return;
    }

    const vars = {};
    vars.reportRegisterID = reportRegisterID;
    vars.removedClassification = id('removeReason').value;
    vars.removedComments = id('removeComments').value;

    PREP(['removeUploadReport'], vars)
      .then((res) => {
        hide('custardBox');
        note(res.data.removeUploadReport);
        changeTabN('EUt_reports');
      })
      .catch(console.error());
  },
  encryptedReport(reportRegisterID, fileName) {
    const vars = {};
    vars.HTMLPageName = 'downloadEncryptedReport';
    vars.languageID = getCookie('mbohvbhfje');

    PREP(['getHTMLLexicon'], vars).then(async (res) => {
      const langObj = {};

      const lang = res.data.getHTMLLexicon;
      for (let row of lang) {
        langObj[row.marker] = row.display;
      }

      // pass pop up
      const div1 = divAtt('div', 'class', 'center');
      const div = divAtt('div');
      const name = divAtt('h6');
      name.innerHTML = `${fileName}`;
      const instructions = divAtt('p');
      instructions.innerHTML = langObj.der_Mkr2 ? langObj.der_Mkr2 : `Please provide your login password to download report. <br>You will use this same password to open the pdf.`;

      const forgotPass = divAtt('p', 'class', 'instructionP');
      forgotPass.style = 'margin-top: 1rem;';
      forgotPass.innerHTML = langObj.der_Mkr10 ? langObj.der_Mkr10 : `If you do not know your password, please navigate to "User Profile" section or click on the "Update Password" button to update your password. Once updated, please provide the new password below to open the report.`;

      const forgotPassLink = divAtt('span', 'class', 'linkOpenTab');
      forgotPass.setAttribute('onclick', `PREP('userProfile'), navSel(), hide('custardBox')`);
      forgotPassLink.innerHTML = langObj.der_Mkr9 ? ` ${langObj.der_Mkr9} ${linkOpenTabSVG}` : ` Update Password ${linkOpenTabSVG}`;
      forgotPass.appendChild(forgotPassLink);

      const passDiv = divAtt('div', 'class', 'grid-1col-input center');
      const pass = divAtt('div', 'class', 'group marginBottom marginTop');
      pass.style = 'width: unset';
      pass.setAttribute('id', 'passCust');
      const input = divAtt('input', 'type', 'password');
      input.setAttribute('id', 'l_password');
      input.setAttribute('oninput', 'capsLock(this.id)');
      input.setAttribute('onclick', 'this.select()');
      input.setAttribute('onblur', `hide('capsLock')`);
      input.setAttribute('onkeyup', `notEmptyVal(this.id)`);

      const bar = divAtt('span', 'class', 'bar');
      const label = divAtt('label', 'for', 'l_password');
      label.innerHTML = langObj.der_Mkr3 ? langObj.der_Mkr3 : 'Login Password';
      pass.innerHTML = passwordEye;
      const capsDiv = divAtt('div', 'id', 'capsLock');
      capsDiv.setAttribute('class', 'hide');
      const capCopy = divAtt('h6');
      capCopy.innerHTML = 'Caps lock is on';
      capsDiv.appendChild(capCopy);

      pass.appendChild(input);
      pass.appendChild(input);
      pass.appendChild(bar);
      pass.appendChild(label);
      pass.appendChild(capsDiv);
      passDiv.appendChild(pass);

      const cancelBtn = divAtt('button', 'class', 'btnCancel');
      cancelBtn.innerHTML = langObj.der_Mkr4 ? langObj.der_Mkr4 : 'Cancel';
      cancelBtn.setAttribute('onclick', `hide('custardBox')`);
      const dwnld = langObj.der_Mkr5 ? langObj.der_Mkr5 : 'Download';
      const btn = divAtt('button', 'id', 'dlEncryptReport');
      btn.innerHTML = dwnld;
      // const btn = buildBtn(
      //   "dlEncryptReport",
      //   `report.downloadEncryptedReport(${reportRegisterID})`,
      //   dwnld
      // );
      const FB = buildFeedbackBanner('passEncrypt');

      div.appendChild(name);
      div.appendChild(instructions);
      div.appendChild(forgotPass);
      div.appendChild(passDiv);
      div.appendChild(FB);
      div.appendChild(cancelBtn);
      div.appendChild(btn);
      div1.appendChild(div);

      const head = langObj.der_Mkr1 ? langObj.der_Mkr1 : `Download Encrypted Report`;
      //custardBox(div1, head);
      eCustardBox(div1, head, [
        btn,
        () => {
          report.downloadEncryptedReport(reportRegisterID);
        },
        'click',
      ]);
      id('l_password').type = 'password';
    });
  },
  downloadEncryptedReport: (reportRegisterID) => {
    const vars = {};

    vars.reportRegisterID = reportRegisterID;
    vars.currentPassword = id('l_password').value;

    PREP(['downloadEncryptedReport'], vars)
      .then((res) => {
        console.log(res.data.downloadEncryptedReport);

        const data = res.data.downloadEncryptedReport[0];
        if (data.FailMessage) {
          inpFeedbackBanner(`${data.FailMessage}`, 'passEncrypt');
          id('l_password').classList.add('incorrect');
        } else {
          window.open(data.ReportLink, '_blank');
          // report.download(data.ReportLink)
          hide('custardBox');
        }
      })
      .catch(console.error());
  },
  reportHistory(reportRegisterID, fileName) {
    const vars = {};
    vars.reportregisterID = reportRegisterID;
    vars.HTMLPageName = 'downloadEncryptedReport';
    vars.languageID = getCookie('mbohvbhfje');

    PREP(['getReportDownloadHistory', 'getHTMLLexicon'], vars)
      .then((res) => {
        const langObj = {};

        const lang = res.data.getHTMLLexicon;
        for (let row of lang) {
          langObj[row.marker] = row.display;
        }

        const data = res.data.getReportDownloadHistory;
        console.log(data);

        const div = divAtt('div');
        const name = divAtt('h6');
        name.innerHTML = fileName;

        const table = divAtt('table');
        table.style = `margin: 0;`;
        const thead = divAtt('thead');
        const th1 = divAtt('th');
        th1.innerHTML = langObj.der_Mkr8 ? langObj.der_Mkr8 : 'Date';
        const th2 = divAtt('th');
        th2.innerHTML = langObj.der_Mkr7 ? langObj.der_Mkr7 : 'Downloaded by';
        const th3 = divAtt('th');

        thead.appendChild(th1);
        thead.appendChild(th2);
        thead.appendChild(th3);
        table.appendChild(thead);
        const tbody = divAtt('tbody');

        for (const row of data) {
          const tr = divAtt('tr');
          const td1 = divAtt('td');
          td1.innerHTML = formatDate(row.dateon);
          const td2 = divAtt('td');
          td2.innerHTML = `${row.fname} ${row.sname}`;
          const td3 = divAtt('td');
          if (row.encryptedYN) {
            const encryptIcon = divAtt('div', 'class', 'iconTable');
            encryptIcon.innerHTML = keyEncrypt;
            td3.appendChild(encryptIcon);
          }

          tr.appendChild(td1);
          tr.appendChild(td2);
          tr.appendChild(td3);
          tbody.appendChild(tr);
        }

        table.appendChild(tbody);

        div.appendChild(name);
        div.appendChild(table);

        const head = langObj.der_Mkr6 ? langObj.der_Mkr6 : `Report Download History`;
        custardBox(div, head);
      })
      .catch(console.error());
  },
};

//  ======================= ADDITIONAL SERVICES ========================

export const additionalService = {
  complete: (reportID) => {
    if (id(reportID).checked) {
      const div = divAtt('div', 'id', 'completeAS');
      div.style = `margin-top: 3rem;`;
      const dateCompleted = buildDateInp('dateCompleted', 1, 'Date Completed');
      const timeDiv = divAtt('div', 'class', 'flex');
      const hours = buildInpText('durationHour', 1, 'Hours');
      const mins = buildInpText('durationMinute', 1, 'Minutes');
      const comments = buildTextarea('FeedbackCompletedComments', 1, 'Comments');
      timeDiv.appendChild(hours);
      timeDiv.appendChild(mins);

      const cancelBtn = divAtt('button', 'class', 'btnCancel');
      cancelBtn.innerHTML = 'Cancel';
      // cancelBtn.setAttribute(
      //   "onclick",
      //   `additionalService.cancelComplete('${reportID}')`
      // );
      const btn = divAtt('button', 'class', 'btn');
      btn.innerHTML = `Submit`;
      // btn.setAttribute(
      //   "onclick",
      //   `additionalService.completeFeedback('${reportID}')`
      // );
      const feedback = buildFeedbackBanner('completeAS');

      div.appendChild(dateCompleted);
      div.appendChild(timeDiv);
      div.appendChild(comments);
      div.appendChild(feedback);
      div.appendChild(cancelBtn);
      div.appendChild(btn);

      //custardBox(div, "Feedback Completed");
      eCustardBox(div, `Feedback Completed`, [
        [
          cancelBtn,
          () => {
            additionalService.cancelComplete(reportID);
          },
          'click',
        ],
        [
          btn,
          () => {
            additionalService.completeFeedback(reportID);
          },
          'click',
        ],
      ]);
      id('durationHour').setAttribute('type', 'number');
      id('durationMinute').setAttribute('type', 'number');
    }
  },
  cancelComplete: (reportID) => {
    id(`${reportID}`).checked = false;
    hide('custardBox');
  },
  completeFeedback: (feedbackID) => {
    if (!validateDiv('completeAS')) {
      return;
    }

    const lastItem = Object.keys(pgstr).pop();
    console.log('pgstr', pgstr);

    const vars = {};
    vars.dateCompleted = id('dateCompleted').value;
    vars.durationHours = id('durationHour').value;
    vars.durationMinutes = id('durationMinute').value;
    vars.additionalservicesID = feedbackID;
    vars.FeedbackCompletedComments = id('FeedbackCompletedComments').value;

    if (!vars.dateCompleted) {
      infoBox('Date is a required field.');
      return;
    }
    if (!vars.durationHours && !vars.durationMinutes) {
      infoBox('Duration is a required field.');
      return;
    }
    if (!vars.FeedbackCompletedComments) {
      infoBox('Comments is a required field.');
      return;
    }

    PREP(['recordAdditionalServicesFeedback'], vars)
      .then(() => {
        hide('custardBox');
        note('Feedback status Has been updated');

        const vars2 = {};
        const appID = id('HapplicationID').value;
        vars2.happlicationID = appID;
        vars2.HclientID = pgstr[`${lastItem}`].HclientID;
        const page = pgstr[`${lastItem}`].reference;
        PREP(`${page}`, vars2);
      })
      .catch(console.error());
  },
  closeCandidateReport: () => {
    id('feedbackCompletedForm').style.display = 'none';
    id('dateCompleted').value = '';
    id('durationHour').value = '';
    id('durationMinute').value = '';
    id('FeedbackCompletedComments').value = '';
  },
  requestAdditionalServices: () => {
    const checkboxes = document.querySelectorAll('.addSerInp');
    const checkArr = [];

    checkboxes.forEach((box) => {
      if (box.checked) {
        checkArr.push(box.id);
      }
    });
    if (!checkArr.length) {
      infoBox('Please select a service.');
      return;
    }

    const vars = {};
    vars.applicationID = id('HapplicationID').value;
    vars.additionalservices = checkArr;

    const canFBbox = document.getElementsByName('Candidate feedback');
    const canBox = canFBbox[0];

    const manFBbox = document.getElementsByName('Management feedback');
    const manbox = manFBbox[0];

    if (manbox) {
      // Managememt || candidate Feedback Ticked
      if (manbox.checked === true) {
        if (id('requester').value === '-' || !id('requester').value) {
          return infoBox('Please select a Requester.');
        }
        vars.requestor = id('requester').value;
        if (id('requester').value === 'New') {
          if (!id('fName').value || !id('sName').value || !id('email').value) {
            return infoBox('Please fill in new requester details.');
          }
          if (!valE(id('email').value)) {
            return infoBox('Please fill in a valid email address.');
          }
          const obj = {};

          (obj.fName = id('fName').value), (obj.sName = id('sName').value), (obj.email = id('email').value), (vars.payload = JSON.stringify(obj));
        }

        if (id('fbDuration').value === '-') {
          return infoBox('Please select a duration of feedback.');
        }
        vars.feedbackDuration = id('fbDuration').value;
      }
    } else if (canBox) {
      if (canBox.checked === true) {
        if (id('fbDuration').value === '-') {
          return infoBox('Please select a duration of feedback.');
        }
        vars.feedbackDuration = id('fbDuration').value;
        vars.requestor = '';
      }
    } else {
      vars.feedbackDuration = '';
      vars.requestor = '';
    }
    PREP(['requestAdditionalServices'], vars)
      .then((res) => {
        note(res.data.requestAdditionalServices);
        vars.HAPPLICATIONID = vars.applicationID;
        PREP('viewApplication', vars);
      })
      .catch(console.error());
  },
  checkRequest: () => {
    const div = divAtt('div', 'class', '');
    const p = divAtt('p', 'class', 'marginTop marginBottom');
    p.innerHTML = `Are you sure you would like to request this as an Express Service?`;
    const cancelBtn = divAtt('button', 'class', 'btnCancel');
    cancelBtn.innerHTML = 'Cancel';
    //cancelBtn.setAttribute("onclick", `additionalService.proceed(0)`);
    const btn = divAtt('button', 'class', 'btn');
    btn.innerHTML = 'Proceed';
    // btn.setAttribute("onclick", `additionalService.proceed(1)`);

    div.appendChild(p);
    div.appendChild(cancelBtn);
    div.appendChild(btn);

    //custardBox(div, "Note:");
    eCustardBox(div, `Note:`, [
      [
        cancelBtn,
        () => {
          additionalService.proceed(0);
        },
        'click',
      ],
      [
        btn,
        () => {
          additionalService.proceed(1);
        },
        'click',
      ],
    ]);
  },
  proceed: (num) => {
    const expressService = id('expressService');

    if (num === 1) {
      hide('custardBox');
      expressService.setAttribute('disabled', '');
      if (id('HapplicationID')) {
        const vars = {};
        vars.HapplicationID = id('HapplicationID').value;
        PREP(['requestExpressService1'], vars)
          .then(() => {
            note('Requested as Express Service');
          })
          .catch(console.error());
      }
    } else {
      hide('custardBox');
      expressService.checked = false;
    }
  },
  get: (data, getFeedbackRequestor) => {
    const dom = id('additionalServices');
    dom.innerHTML = '';

    if (data.length) {
      for (let el of data) {
        const header = document.createElement('h5');
        header.innerHTML = el.serviceType;
        const container = divAtt('div', 'class', 'marginBottom');
        container.appendChild(header);

        for (let el2 of el.services) {
          const checkDiv = divAtt('label', 'for', el2.serviceID);
          checkDiv.classList.add('checkContainer');
          const input = divAtt('input', 'type', 'checkbox');
          input.setAttribute('id', el2.serviceID);
          input.setAttribute('class', 'addSerInp');
          input.setAttribute('name', el2.serviceName);
          const span = divAtt('span', 'class', 'tick');
          const labelName = divAtt('p');
          labelName.innerHTML = el2.serviceName;
          checkDiv.appendChild(input);
          checkDiv.appendChild(span);
          checkDiv.appendChild(labelName);
          container.appendChild(checkDiv);
          dom.appendChild(container);
          if (el2.serviceName === 'Management feedback') {
            // input.setAttribute(
            //   'onchange',
            //   `additionalService.addInfoFeedback()`
            // );
            eListen(
              input,
              () => {
                additionalService.addInfoFeedback();
              },
              'change'
            );
          }
          if (el2.serviceName === 'Candidate feedback') {
            // input.setAttribute(
            //   'onchange',
            //   `additionalService.addInfoFeedback()`
            // )
            eListen(
              input,
              () => {
                additionalService.addInfoFeedback();
              },
              'change'
            );
          }
        }
      }
    } else {
      hide('requestAdditionalServicesBtn');
    }

    if (getFeedbackRequestor.length) {
      getFeedbackRequestor.forEach((arr) => {
        const opt = divAtt('option', 'value', arr.HuserID);
        opt.innerHTML = arr.comboName;
        id('requester').appendChild(opt);
      });
    } else {
      optOne = divAtt('option', 'value', '-');
      optOne.innerHTML = 'No options available --';
      id('requester').appendChild(optOne);
    }
  },
  allocatedServices: async (data, service, adminCancel) => {
    const langObj = {};
    const vars = {};
    vars.HTMLPageName = 'additionalService';
    vars.languageID = getCookie('mbohvbhfje');

    await PREP(['getHTMLLexicon'], vars).then(async (res) => {
      const lang = res.data.getHTMLLexicon;
      for (let row of lang) {
        langObj[row.marker] = row.display;
      }
    });

    if (data.length) {
      const dom = document.getElementById('additionalServicesAdded');
      dom.innerHTML = '';
      const header = document.createElement('thead');
      const th1 = document.createElement('th');
      th1.innerHTML = langObj.ads_Mkr30 ? langObj.ads_Mkr30 : 'Requested date';
      const th2 = document.createElement('th');
      th2.innerHTML = langObj.ads_Mkr31 ? langObj.ads_Mkr31 : 'Requested by';
      const th3 = document.createElement('th');
      th3.innerHTML = langObj.ads_Mkr32 ? langObj.ads_Mkr32 : 'Service';
      const th4 = document.createElement('th');
      th4.innerHTML = langObj.ads_Mkr6 ? langObj.ads_Mkr6 : 'Status';
      const th5 = document.createElement('th');
      th5.innerHTML = langObj.ads_Mkr33 ? langObj.ads_Mkr33 : 'Completed date';
      const th6 = document.createElement('th');
      th6.innerHTML = langObj.ads_Mkr34 ? langObj.ads_Mkr34 : 'Duration';
      const th10 = document.createElement('th');
      th10.innerHTML = 'Language';
      const th11 = document.createElement('th');
      th11.innerHTML = 'Time zone';
      const th7 = document.createElement('th');
      th7.innerHTML = langObj.ads_Mkr42 ? langObj.ads_Mkr42 : 'Comments';
      const th8 = document.createElement('th');
      th8.innerHTML = langObj.ads_Mkr35 ? langObj.ads_Mkr35 : 'Contact Requestor';
      const th12 = document.createElement('th');
      th12.innerHTML = langObj.ads_Mkr58 ? langObj.ads_Mkr58 : 'Select preferred booking date';

      header.appendChild(th1);
      header.appendChild(th2);
      header.appendChild(th3);
      header.appendChild(th4);
      header.appendChild(th5);
      header.appendChild(th6);
      header.appendChild(th10);
      header.appendChild(th11);
      header.appendChild(th7);
      header.appendChild(th8);
      header.appendChild(th12);

      if (adminCancel) {
        const th9 = document.createElement('th');
        th9.innerHTML = 'Cancel Request';
        header.appendChild(th9);
      }

      dom.appendChild(header);

      for (let el of data) {
        const row = divAtt('tr', 'class', '');
        const date = divAtt('td', 'class', 'date');
        date.innerHTML = el.DATEREQUESTED;
        const requestedBy = divAtt('td', 'class', 'requestedBy');
        requestedBy.innerHTML = `${el.REQUESTEDBYFNAME} ${el.REQUESTEDBYSNAME}`;
        const reportName = divAtt('td', 'class', 'reportName');
        reportName.innerHTML = el.SERVICENAME;
        const completion = divAtt('td', 'class', 'completion');
        let evts = [];

        if (!service) {
          completion.innerHTML = el.STATUS;
        } else if (el.UPDATESCLOSED !== true) {
          const inputH = divAtt('input', 'id', 'reportID');
          inputH.setAttribute('type', 'hidden');
          inputH.value = el.ALLOCHUSERADDITIONALSERVICEID;

          const input = divAtt('input', 'id', el.ALLOCHUSERADDITIONALSERVICEID);
          input.setAttribute('type', 'checkbox');
          evts.push([
            input,
            () => {
              additionalService.complete(`${el.ALLOCHUSERADDITIONALSERVICEID}`);
            },
          ]); //@mike

          const label = divAtt('label', 'for', `${el.ALLOCHUSERADDITIONALSERVICEID}`);
          completion.appendChild(inputH);
          completion.appendChild(input);
          completion.appendChild(label);
        } else {
          completion.innerHTML = el.STATUS;
        }
        row.appendChild(date);
        row.appendChild(requestedBy);
        row.appendChild(reportName);
        row.appendChild(completion);

        if (el.UPDATESCLOSED) {
          const spanCompDate = divAtt('td', 'class', 'reportCompleted');
          spanCompDate.innerHTML = el.DATECOMPLETED;
          const spanDuration = divAtt('td', 'class', 'duration');
          spanDuration.innerHTML = `${el.DURATIONHOURS} ${langObj.ads_Mkr40}, ${el.DURATIONMINUTES} ${langObj.ads_Mkr41}`;
          const lang = divAtt('td', 'class', 'lang');
          lang.innerHTML = el.LANGUAGEDESC;
          const timeZone = divAtt('td', 'class', 'timeZone');
          timeZone.innerHTML = el.TIMEZONE;
          const spanComments = divAtt('td', 'class', 'completComments');

          if (el.COMPLETIONCOMMENTS !== '') {
            const btn = divAtt('div', 'class', 'btn');
            evts.push([
              btn,
              () => {
                additionalService.showComments(el.COMPLETIONCOMMENTS);
              },
            ]);
            // btn.setAttribute(
            //   "onclick",
            //   `additionalService.showComments('${el.COMPLETIONCOMMENTS}')`
            // );
            btn.innerHTML = langObj.ads_Mkr39 ? langObj.ads_Mkr39 : 'View';
            spanComments.appendChild(btn);
          }

          row.appendChild(spanCompDate);
          row.appendChild(spanDuration);
          row.appendChild(lang);
          row.appendChild(timeZone);
          row.appendChild(spanComments);
        } else {
          const spanCompDate = divAtt('td', 'class', 'reportCompleted');
          spanCompDate.innerHTML = '';
          const spanDuration = divAtt('td', 'class', 'duration');
          spanDuration.innerHTML = '';
          const lang = divAtt('td', 'class', 'lang');
          lang.innerHTML = el.LANGUAGEDESC;
          const timeZone = divAtt('td', 'class', 'timeZone');
          timeZone.innerHTML = el.TIMEZONE;

          const spanComments = divAtt('td', 'class', 'completComments');
          spanComments.innerHTML = '';
          row.appendChild(spanCompDate);
          row.appendChild(spanDuration);
          row.appendChild(lang);
          row.appendChild(timeZone);
          row.appendChild(spanComments);
        }

        const ContactRequestor = divAtt('td');
        const ContactRequestorBtn = divAtt('div', 'class', 'btn');
        // ContactRequestorBtn.setAttribute(
        //   "onclick",
        //   `additionalService.contactRequster('${el.ALLOCHUSERADDITIONALSERVICEID}')`
        // );
        ContactRequestorBtn.innerHTML = langObj.ads_Mkr36 ? langObj.ads_Mkr36 : 'Contact';
        ContactRequestor.appendChild(ContactRequestorBtn);
        row.appendChild(ContactRequestor);

        const bookingColumn = divAtt('td');
        const bookingBtn = divAtt('button', 'class', 'btn');
        bookingBtn.innerHTML = langObj.ads_Mkr59 ? langObj.ads_Mkr59 : 'Book Date';
        bookingColumn.appendChild(bookingBtn);
        if (!el.LINKACTIVEYN) {
          bookingBtn.disabled = true;
        }
        row.appendChild(bookingColumn);

        console.log(el.BOOKINGLINK);
        eListen(
          bookingBtn,
          () => {
            window.open(`${el.BOOKINGLINK}`, '_blank');
          },
          'click'
        );

        const cancelColumn = divAtt('td');
        const cancelBtn = divAtt('div', 'class', 'btn');
        if (adminCancel) {
          // cancelBtn.setAttribute('onclick', `additionalService.buildCancelPopup('${el.ALLOCHUSERADDITIONALSERVICEID}')`);
          cancelBtn.innerHTML = 'Cancel';
          if (el.STATUS != 'Completed') {
            cancelColumn.appendChild(cancelBtn);
          }
          row.appendChild(cancelColumn);
        }

        dom.appendChild(row);
        eListen(
          ContactRequestorBtn,
          () => {
            additionalService.contactRequster(el.ALLOCHUSERADDITIONALSERVICEID);
          },
          'click'
        );
        if (adminCancel) {
          eListen(
            cancelBtn,
            () => {
              additionalService.buildCancelPopup(el.ALLOCHUSERADDITIONALSERVICEID);
            },
            'click'
          );
        }

        for (let i = 0; i < evts.length; i++) {
          eListen(evts[i][0], evts[i][1], 'click');
        }
      }
    }
  },
  showComments: (comment) => {
    const div = divAtt('div', 'class', '');
    const p = divAtt('p', 'class', 'marginTop marginBottom');
    p.innerHTML = comment;
    const btn = divAtt('button', 'class', 'btn');
    btn.innerHTML = 'Done';
    //btn.setAttribute("onclick", `hide('custardBox')`);

    div.appendChild(p);
    div.appendChild(btn);

    //custardBox(div, "Comments");
    eCustardBox(div, `Comments`, [
      btn,
      () => {
        hide('custardBox');
      },
      'click',
    ]);
  },
  contactRequster: (ALLOCHUSERADDITIONALSERVICEID) => {
    const vars = {};
    vars.HTMLPageName = 'additionalService';
    vars.languageID = getCookie('mbohvbhfje');

    PREP(['getHTMLLexicon'], vars).then(async (res) => {
      const langObj = {};

      const lang = res.data.getHTMLLexicon;
      for (let row of lang) {
        langObj[row.marker] = row.display;
      }

      const div = divAtt('div', 'id', 'emailCommentsDiv');
      const comments = langObj.ads_Mkr42 ? langObj.ads_Mkr42 : 'Comments';
      const textDiv = buildTextarea('textToRequester', 1, comments); //comments
      const closeBtn = divAtt('button', 'class', 'btnCancel');
      closeBtn.innerHTML = langObj.ads_Mkr11 ? langObj.ads_Mkr11 : 'Close';
      //closeBtn.setAttribute("onclick", `hide('custardBox')`);
      const btn = divAtt('button', 'class', 'btn upp_Mkr17');
      btn.innerHTML = langObj.ads_Mkr38 ? langObj.ads_Mkr38 : 'Send Feedback';
      // btn.setAttribute(
      //   "onclick",
      //   `additionalService.sendFeedback('${ALLOCHUSERADDITIONALSERVICEID}')`
      // );

      div.appendChild(textDiv);
      div.appendChild(closeBtn);
      div.appendChild(btn);

      const heads = langObj.ads_Mkr43 ? langObj.ads_Mkr43 : 'Email Requestor';
      // custardBox(div, heads);
      eCustardBox(div, heads, [
        [
          btn,
          () => {
            additionalService.sendFeedback(ALLOCHUSERADDITIONALSERVICEID);
          },
          'click',
        ],
        [
          closeBtn,
          () => {
            hide('custardBox');
          },
          'click',
        ],
      ]);
    });
  },
  sendFeedback: (ALLOCHUSERADDITIONALSERVICEID) => {
    if (!validateDiv('emailCommentsDiv')) {
      return;
    }

    const vars = {};
    vars.comments = lineBreaks(id('textToRequester').value);
    vars.allocHuserAdditionalServiceID = ALLOCHUSERADDITIONALSERVICEID;

    PREP(['emailAddServicesRequestor'], vars).then((res) => {
      note(res.data.emailAddServicesRequestor);
      hide('custardBox');
    });
  },
  addInfoFeedback: () => {
    const canFBbox = document.getElementsByName('Candidate feedback');
    const canBox = canFBbox[0];

    const manFBbox = document.getElementsByName('Management feedback');
    const manbox = manFBbox[0];

    if (manbox) {
      if (manbox.checked === true) {
        unhide('requesterDiv');
        unhide('fbDurationDiv');

        unhide('addSerDiv');
      } else {
        hide('requesterDiv');
        hide('fbDurationDiv');
        hide('addSerDiv');
      }

      if (canBox.checked === false && manbox.checked === false) {
        hide('addSerDiv');
      }
    }

    if (canBox) {
      if (canBox.checked === true) {
        unhide('fbDurationDiv');
        unhide('addSerDiv');
      } else {
        hide('fbDurationDiv');
      }
    }
  },
  newRequester: (elID) => {
    if (id(`${elID}requester`).value === 'New') {
      unhide(`${elID}newRequester`);
    } else {
      hide(`${elID}newRequester`);
    }

    var e = id(`${elID}requester`);
    var text = e.options[e.selectedIndex].text;
    id(`${elID}requestorInput`).value = text;
  },
  buildCancelPopup: (ALLOCHUSERADDITIONALSERVICEID) => {
    const div = divAtt('div', 'class', 'grid-1col');
    div.setAttribute('id', 'cancelDiv');
    const select = buildSelectInp('cancelReason', 1, 'Reason');
    select.setAttribute('style', 'margin-top: 3rem;');
    const comments = buildTextarea('cancelComments', 0, 'Comments');
    const btn = buildBtnFormCenter('confirmCancel', `additionalService.cancelRequest('${ALLOCHUSERADDITIONALSERVICEID}')`, 'Confirm Cancel');
    div.appendChild(select);
    div.appendChild(comments);
    div.appendChild(btn);
    //custardBox(div, `Reason for Additional Service`)
    eCustardBox(div, `Reason for cancelling Additional Service`, [
      'confirmCancel',
      () => {
        additionalService.cancelRequest(ALLOCHUSERADDITIONALSERVICEID);
      },
      'click',
    ]);

    PREP(['getDDaddServCancelReason'])
      .then((res) => {
        buildDropDownMain(res.data.getDDaddServCancelReason, 'cancelReason', 'DDaddServCancelReasonID', 'shortName');
      })
      .catch(console.error());
  },
  cancelRequest: (ALLOCHUSERADDITIONALSERVICEID) => {
    if (id('cancelReason').value === '-') {
      //validatePage();
      infoBox('Please select a reason from the dropdown.');
      return;
    }
    const vars = {};
    vars.allocHuserAdditionalServiceID = ALLOCHUSERADDITIONALSERVICEID;
    vars.DDaddServCancelReasonID = parseInt(id('cancelReason').value);
    vars.cancelComments = id('cancelComments').value;
    PREP(['cancelAddServReq'], vars)
      .then((res) => {
        hide('custardBox');
        note(res.data.cancelAddServReq);
        changeTabN('SAt_addServices');
      })
      .catch(console.error());
  },
  // NEW ADDSER
  buildAssSerCheckboxes1: async (data, getFeedbackRequestor, HclientID) => {
    const vars = {};
    vars.HTMLPageName = 'additionalService';
    vars.languageID = getCookie('mbohvbhfje');

    PREP(['getHTMLLexicon'], vars)
      .then(async (res) => {
        const langObj = {};

        const lang = res.data.getHTMLLexicon;
        for (let row of lang) {
          langObj[row.marker] = row.display;
        }
        window.langObj = langObj;
        const dom = id('additionalServices');
        dom.innerHTML = '';

        if (data.length) {
          let timeZoneLangData;
          let timeZoneData;
          let langData;
          if (HclientID == 42) {
            timeZoneLangData = await additionalService.getTimeZoneLangData(HclientID);
            console.log('timeZoneLangData', timeZoneLangData);
            timeZoneData = timeZoneLangData.timeZones;
            langData = timeZoneLangData.languages;
          }

          for (let el of data) {
            const header = document.createElement('h5');
            header.innerHTML = el.serviceType;
            const container = divAtt('div', 'class', 'marginBottom');
            container.appendChild(header);

            for (let el2 of el.services) {
              const checkDiv = divAtt('label', 'for', el2.serviceID);
              checkDiv.classList.add('checkContainer');
              const input = divAtt('input', 'type', 'checkbox');
              input.setAttribute('id', el2.serviceID);
              input.setAttribute('class', 'addSerInp');
              input.setAttribute('name', el2.serviceNameEng);
              const span = divAtt('span', 'class', 'tick');
              const labelName = divAtt('p');
              labelName.innerHTML = el2.serviceName;
              checkDiv.appendChild(input);
              checkDiv.appendChild(span);
              checkDiv.appendChild(labelName);
              container.appendChild(checkDiv);
              dom.appendChild(container);
              unhide('additionalServices');

              if (el2.serviceNameEng === 'Management feedback') {
                const manFeedback = await additionalService.buildManFeedback(HclientID, langObj);
                container.appendChild(manFeedback);

                if (HclientID == 42) {
                  buildDropDownMain(timeZoneData, 'manTimeZone', 'DDTIMEZONEID', 'DESCRIPTION');
                  buildDropDownMain(langData, 'manLang', 'HlanguageID', 'shortname');
                  eListen(
                    'manTimeZone',
                    () => {
                      notEmptyVal('manTimeZone');
                      additionalService.timeZoneDescription('man');
                    },
                    'change'
                  );
                }
                eListen(
                  'manrequestorInput',
                  () => {
                    filterOptionsHandler('manrequestorInput', 'manrequester');
                  },
                  'keyup'
                );
                eListen(
                  'manrequester',
                  () => {
                    additionalService.newRequester('man');
                    notEmptyVal('manrequester');
                  },
                  'change'
                );
                eListen(
                  'manduration',
                  () => {
                    notEmptyVal('manduration');
                  },
                  'change'
                );
                additionalService.populateRequestor(getFeedbackRequestor, 'manrequester');
              } else if (el2.serviceNameEng === 'Candidate feedback') {
                const canFeedback = await additionalService.buildCanFeedback(HclientID, langObj);
                container.appendChild(canFeedback);
                if (HclientID == 42) {
                  buildDropDownMain(timeZoneData, 'canTimeZone', 'DDTIMEZONEID', 'DESCRIPTION');
                  buildDropDownMain(langData, 'canLang', 'HlanguageID', 'shortname');
                  eListen(
                    'canTimeZone',
                    () => {
                      notEmptyVal('canTimeZone');
                      additionalService.timeZoneDescription('can');
                    },
                    'change'
                  );
                }
                eListen(
                  'canduration',
                  () => {
                    notEmptyVal('canduration');
                  },
                  'change'
                );
                // additionalService.populateRequestor(getFeedbackRequestor, 'canrequester');
              } else if (el2.serviceNameEng === 'Manager Comparative Group feedback') {
                const mancompGroupFeedback = await additionalService.mancompGroupFeedback(HclientID, langObj);
                container.appendChild(mancompGroupFeedback);

                //eListens
                if (HclientID == 42) {
                  buildDropDownMain(timeZoneData, 'mancompTimeZone', 'DDTIMEZONEID', 'DESCRIPTION');
                  buildDropDownMain(langData, 'mancompLang', 'HlanguageID', 'shortname');
                  eListen(
                    'mancompTimeZone',
                    () => {
                      notEmptyVal('mancompTimeZone');
                      additionalService.timeZoneDescription('mancomp');
                    },
                    'change'
                  );
                }
                eListen(
                  'mancomprequestorInput',
                  () => {
                    filterOptionsHandler('mancomprequestorInput', 'mancomprequester');
                  },
                  'keyup'
                );
                eListen(
                  'mancomprequester',
                  () => {
                    additionalService.newRequester('mancomp');
                    notEmptyVal('mancomprequester');
                  },
                  'change'
                );
                eListen(
                  'addCan',
                  () => {
                    additionalService.addCandidate();
                  },
                  'click'
                );

                additionalService.populateRequestor(getFeedbackRequestor, 'mancomprequester');
              }
              // else
              // if (el2.serviceName === 'Candidate Development Report') {
              //     const canDevFeedback = await additionalService.buildCanDevFeedback(HclientID)
              //     container.appendChild(canDevFeedback);
              //     additionalService.populateRequestor(getFeedbackRequestor, 'CDrequester');
              // };
              eListen(
                input,
                () => {
                  additionalService.addSerInfo();
                },
                'change'
              );
            }
          }
        } else {
          hide('requestAdditionalServicesBtn');
        }
      })
      .catch(console.log());
  },
  //Annglo recordPage specific
  buildAssSerCheckboxes2: async (data, getFeedbackRequestor, HclientID) => {
    const vars = {};
    vars.HTMLPageName = 'additionalService';
    vars.languageID = getCookie('mbohvbhfje');

    PREP(['getHTMLLexicon'], vars)
      .then(async (res) => {
        const langObj = {};

        const lang = res.data.getHTMLLexicon;
        for (let row of lang) {
          langObj[row.marker] = row.display;
        }
        window.langObj = langObj;

        const dom = id('additionalServices');
        dom.innerHTML = '';

        if (data.length) {
          let timeZoneLangData;
          let timeZoneData;
          let langData;
          if (HclientID == 42) {
            timeZoneLangData = await additionalService.getTimeZoneLangData(HclientID);
            timeZoneData = timeZoneLangData.timeZones;
            langData = timeZoneLangData.languages;
          }

          const feedBackAS = divAtt('div', 'id', 'feedBackAS');
          feedBackAS.setAttribute('class', 'hide');
          const feedbackH5 = divAtt('h5');
          feedbackH5.innerHTML = langObj.ads_Mkr13 ? langObj.ads_Mkr13 : 'Feedback';
          feedBackAS.appendChild(feedbackH5);
          dom.appendChild(feedBackAS);

          const reportsAS = divAtt('div', 'id', 'reportsAS');
          reportsAS.setAttribute('class', 'hide');
          const reportH5 = divAtt('h5');
          reportH5.innerHTML = langObj.ads_Mkr21 ? langObj.ads_Mkr21 : 'Reports';
          reportsAS.appendChild(reportH5);
          dom.appendChild(reportsAS);

          for (let el of data) {
            // No Manager Comparative Group Feedback before the job exists
            if (el.serviceID == 11) {
              continue;
            }
            const checkDiv = divAtt('label', 'for', el.serviceID);
            checkDiv.classList.add('checkContainer');
            const input = divAtt('input', 'type', 'checkbox');
            input.setAttribute('id', el.serviceID);
            input.setAttribute('class', 'addSerInp');
            input.setAttribute('name', el.serviceNameEng);
            // input.setAttribute("onchange", `additionalService.addSerInfo()`);
            const span = divAtt('span', 'class', 'tick');
            const labelName = divAtt('p');
            labelName.innerHTML = el.serviceName;
            checkDiv.appendChild(input);
            checkDiv.appendChild(span);
            checkDiv.appendChild(labelName);

            if (el.serviceTypeEng === 'feedback' || el.serviceTypeEng === 'Feedback') {
              feedBackAS.appendChild(checkDiv);
              if (el.serviceNameEng === 'Management feedback') {
                const manFeedback = await additionalService.buildManFeedback(HclientID, langObj);
                feedBackAS.appendChild(manFeedback);

                buildDropDownMain(timeZoneData, 'manTimeZone', 'DDTIMEZONEID', 'DESCRIPTION');
                buildDropDownMain(langData, 'manLang', 'HlanguageID', 'shortname');
                eListen(
                  'manTimeZone',
                  () => {
                    notEmptyVal('manTimeZone');
                    additionalService.timeZoneDescription('man');
                  },
                  'change'
                );

                eListen(
                  'manrequestorInput',
                  () => {
                    filterOptionsHandler('manrequestorInput', 'manrequester');
                  },
                  'keyup'
                );
                eListen(
                  'manrequester',
                  () => {
                    additionalService.newRequester('man');
                    notEmptyVal('manrequester');
                  },
                  'change'
                );
                eListen(
                  'manduration',
                  () => {
                    notEmptyVal('manduration');
                  },
                  'change'
                );
                additionalService.populateRequestor(getFeedbackRequestor, 'manrequester');
              }
              if (el.serviceNameEng === 'Candidate feedback') {
                const canFeedback = await additionalService.buildCanFeedback(HclientID, langObj);
                feedBackAS.appendChild(canFeedback);

                buildDropDownMain(timeZoneData, 'canTimeZone', 'DDTIMEZONEID', 'DESCRIPTION');
                buildDropDownMain(langData, 'canLang', 'HlanguageID', 'shortname');
                eListen(
                  'canTimeZone',
                  () => {
                    notEmptyVal('canTimeZone');
                    additionalService.timeZoneDescription('can');
                  },
                  'change'
                );

                //mike steph
                //  eListen('canrequestorInput',() => {filterOptionsHandler('canrequestorInput', 'canrequester')},"keyup");
                // eListen('canrequester',() => {additionalService.newRequester("can"); notEmptyVal('canrequester')},"change");
                // eListen("canduration",() => {notEmptyVal("canduration")},"change");
              }

              unhide('feedBackAS');
            } else if (el.serviceTypeEng === 'Reports') {
              reportsAS.appendChild(checkDiv);

              if (el.serviceNameEng === 'Management feedback') {
                const manFeedback = await additionalService.buildManFeedback(HclientID, langObj);
                reportsAS.appendChild(manFeedback);

                if (HclientID == 42) {
                  buildDropDownMain(timeZoneData, 'manTimeZone', 'DDTIMEZONEID', 'DESCRIPTION');
                  buildDropDownMain(langData, 'manLang', 'HlanguageID', 'shortname');
                  eListen(
                    'manTimeZone',
                    () => {
                      notEmptyVal('manTimeZone');
                      additionalService.timeZoneDescription('man');
                    },
                    'change'
                  );
                }

                eListen(
                  'manrequestorInput',
                  () => {
                    filterOptionsHandler('manrequestorInput', 'manrequester');
                  },
                  'keyup'
                );
                eListen(
                  'manrequester',
                  () => {
                    additionalService.newRequester('man');
                    notEmptyVal('manrequester');
                  },
                  'change'
                );
                eListen(
                  'manduration',
                  () => {
                    notEmptyVal('manduration');
                  },
                  'change'
                );
                additionalService.populateRequestor(getFeedbackRequestor, 'manrequester');
              } else if (el.serviceNameEng === 'Candidate feedback') {
                const canFeedback = await additionalService.buildCanFeedback(HclientID, langObj);
                reportsAS.appendChild(canFeedback);

                if (HclientID == 42) {
                  buildDropDownMain(timeZoneData, 'canTimeZone', 'DDTIMEZONEID', 'DESCRIPTION');
                  buildDropDownMain(langData, 'canLang', 'HlanguageID', 'shortname');
                  eListen(
                    'canTimeZone',
                    () => {
                      notEmptyVal('canTimeZone');
                      additionalService.timeZoneDescription('can');
                    },
                    'change'
                  );
                }

                eListen(
                  'canrequestorInput',
                  () => {
                    filterOptionsHandler('canrequestorInput', 'canrequester');
                  },
                  'keyup'
                );
                eListen(
                  'canrequester',
                  () => {
                    additionalService.newRequester('can');
                    notEmptyVal('canrequester');
                  },
                  'change'
                );
                eListen(
                  'canduration',
                  () => {
                    notEmptyVal('canduration');
                  },
                  'change'
                );
                // additionalService.populateRequestor(getFeedbackRequestor, 'canrequester');
              }
              unhide('reportsAS');
            }
            eListen(
              input,
              () => {
                additionalService.addSerInfo();
              },
              'change'
            );
            unhide('additionalServices');
          }
        } else {
          hide('additionalServices');
        }
      })
      .catch(console.error());
  },
  async getTimeZoneLangData(HclientID) {
    return new Promise((resolve, reject) => {
      const data = {};
      const vars = {};
      vars.HclientID = HclientID;

      PREP(['getTimezones', 'getLanguagesPerClient'], vars)
        .then((res) => {
          data.timeZones = cObj(res.data.getTimezones);
          window.timeZones = cObj(res.data.getTimezones);
          data.languages = res.data.getLanguagesPerClient;

          resolve(data);
        })
        .catch((error) => {
          console.error(error);
          reject(error);
        });
    });
  },
  async buildManFeedback(HclientID, langObj) {
    const div = divAtt('div', 'id', 'manFeedback');
    div.setAttribute('class', 'grid-2col-input sectionGap hide'); //hide
    div.style = 'justify-content: start; gap:3rem;';

    const requesterDiv = divAtt('div', 'id', 'manrequesterDiv');
    const selectDiv = divAtt('div', 'id', 'selectDiv');
    const requestorLabel = divAtt('label', 'for', 'manrequester');

    const requestorInput = divAtt('input', 'type', 'text');
    requestorInput.setAttribute('id', 'manrequestorInput');
    if (HclientID == 42) {
      requestorLabel.innerHTML = langObj.ads_Mkr18 ? langObj.ads_Mkr18 : 'Line Manager / Hiring Manager';
      requestorInput.setAttribute('placeholder', `${langObj.ads_Mkr19}`); //'Search for Line Manager / Hiring Manager');
    } else {
      requestorLabel.innerHTML = 'Requestor';
      requestorInput.setAttribute('placeholder', 'Search for Requestor');
    }

    // requestorInput.setAttribute(
    //   "onkeyup",
    //   "filterOptionsHandler('manrequestorInput', 'manrequester')"
    // );
    const requestorSelect = divAtt('select', 'id', 'manrequester');
    requestorSelect.setAttribute('multiple', 'true');
    // requestorSelect.setAttribute(
    //   "onchange",
    //   'additionalService.newRequester("man"), notEmptyVal(this.id)'
    // );
    requestorSelect.style = 'margin-top: 0;';
    selectDiv.appendChild(requestorLabel);
    selectDiv.appendChild(requestorInput);
    selectDiv.appendChild(requestorSelect);

    const newRequestorDiv = divAtt('div', 'id', 'mannewRequester');
    newRequestorDiv.setAttribute('class', 'hide');
    newRequestorDiv.style = 'margin-top: 3rem;';
    const name = buildInpText('manfName', 0, `${langObj.ads_Mkr26}`);
    const surname = buildInpText('mansName', 0, `${langObj.ads_Mkr27}`);
    const email = buildInpEmail('manemail', 0, langObj.ads_Mkr28);
    newRequestorDiv.appendChild(name);
    newRequestorDiv.appendChild(surname);
    newRequestorDiv.appendChild(email);

    requesterDiv.appendChild(selectDiv);
    requesterDiv.appendChild(newRequestorDiv);
    div.appendChild(requesterDiv);

    const durationDiv = divAtt('div', 'id', 'mandurationDiv');
    const durationLabel = divAtt('label', 'for', 'manduration');
    durationLabel.innerHTML = langObj.ads_Mkr20 ? langObj.ads_Mkr20 : 'Duration of Management feedback';
    const durationSelect = divAtt('select', 'id', 'manduration');
    const opt0 = divAtt('option', 'value', '-');
    const infoText = window.infoText;
    opt0.innerHTML = infoText.inf_Mkr10 ? infoText.inf_Mkr10 : 'Please choose an option ---';
    const opt1 = divAtt('option', 'value', '30');
    opt1.innerHTML = langObj.ads_Mkr16 ? langObj.ads_Mkr16 : '30 Minutes';
    const opt2 = divAtt('option', 'value', '45');
    opt2.innerHTML = langObj.ads_Mkr17 ? langObj.ads_Mkr17 : '45 Minutes';
    const opt3 = divAtt('option', 'value', '60');
    opt3.innerHTML = langObj.ads_Mkr29 ? langObj.ads_Mkr29 : '1 Hour';
    durationSelect.appendChild(opt0);
    durationSelect.appendChild(opt1);
    if (HclientID !== 42) {
      durationSelect.appendChild(opt2);
      durationSelect.appendChild(opt3);
    }
    durationDiv.appendChild(durationLabel);
    durationDiv.appendChild(durationSelect);
    div.appendChild(durationDiv);

    // Anglo Extra Dropdowns ========
    if (HclientID == 42) {
      // TimeZone
      const timeZoneDiv = divAtt('div', 'id', 'manTimezoneDiv');
      const timeLabel = langObj.ads_Mkr44 ? langObj.ads_Mkr44 : 'Time zone';
      const timeZoneSelect = await buildSelectInp('manTimeZone', 1, `${timeLabel}`);
      const timeZoneDes = divAtt('p', 'id', 'manTimeZoneDesc');
      timeZoneDes.classList.add('marginBottom');
      timeZoneDiv.appendChild(timeZoneSelect);
      timeZoneDiv.appendChild(timeZoneDes);
      div.appendChild(timeZoneDiv);
      // Langauge
      const langDiv = divAtt('div', 'id', 'manLangDiv');
      const langLabel = langObj.ads_Mkr45 ? langObj.ads_Mkr45 : 'Language';
      const langSelect = await buildSelectInp('manLang', 1, `${langLabel}`);
      langDiv.appendChild(langSelect);
      div.appendChild(langDiv);
    }

    return div;
  },
  async buildCanFeedback(HclientID, langObj) {
    const div = divAtt('div', 'id', 'canFeedback');
    div.setAttribute('class', 'grid-2col-input sectionGap hide'); //hide
    div.style = 'justify-content: start; gap:3rem;';

    const requesterDiv = divAtt('div', 'id', 'canrequesterDiv');
    const selectDiv = divAtt('div', 'id', 'selectDiv');
    const requestorLabel = divAtt('label', 'for', 'canrequester');

    const requestorInput = divAtt('input', 'type', 'text');
    requestorInput.setAttribute('id', `canrequestorInput${HclientID}`);

    if (HclientID == 42) {
      requestorLabel.innerHTML = langObj.ads_Mkr24 ? langObj.ads_Mkr24 : 'Line Manager / Hiring Manage (optional)';
      requestorInput.setAttribute('placeholder', `${langObj.ads_Mkr19}`); //'Search for Line Manager / Hiring Manager');
    } else {
      requestorLabel.innerHTML = 'Requestor (optional)';
      requestorInput.setAttribute('placeholder', 'Search for Requestor');
    }

    const requestorSelect = divAtt('select', 'id', 'canrequester');
    requestorSelect.setAttribute('multiple', 'true');
    requestorSelect.style = 'margin-top: 0;';
    selectDiv.appendChild(requestorLabel);
    selectDiv.appendChild(requestorInput);
    selectDiv.appendChild(requestorSelect);

    const newRequestorDiv = divAtt('div', 'id', 'cannewRequester');
    newRequestorDiv.setAttribute('class', 'hide');
    newRequestorDiv.style = 'margin-top: 3rem;';
    const name = buildInpText('canfName', 0, `${langObj.ads_Mkr26}`);
    const surname = buildInpText('cansName', 0, `${langObj.ads_Mkr27}`);
    const email = buildInpEmail('canemail', 0, `${langObj.ads_Mkr28}`);
    newRequestorDiv.appendChild(name);
    newRequestorDiv.appendChild(surname);
    newRequestorDiv.appendChild(email);

    requesterDiv.appendChild(selectDiv);
    requesterDiv.appendChild(newRequestorDiv);
    // div.appendChild(requesterDiv)

    const durationDiv = divAtt('div', 'id', 'candurationDiv');
    const durationLabel = divAtt('label', 'for', 'canduration');
    durationLabel.innerHTML = langObj.ads_Mkr15 ? langObj.ads_Mkr15 : 'Duration of Candidate Feedback';
    const durationSelect = divAtt('select', 'id', 'canduration');
    const opt0 = divAtt('option', 'value', '-');
    const infoText = window.infoText;
    opt0.innerHTML = infoText.inf_Mkr10 ? infoText.inf_Mkr10 : 'Please choose an option ---';
    const opt1 = divAtt('option', 'value', '30');
    opt1.innerHTML = langObj.ads_Mkr16 ? langObj.ads_Mkr16 : '30 Minutes';
    const opt2 = divAtt('option', 'value', '45');
    opt2.innerHTML = langObj.ads_Mkr17 ? langObj.ads_Mkr17 : '45 Minutes';
    const opt3 = divAtt('option', 'value', '60');
    opt3.innerHTML = langObj.ads_Mkr29 ? langObj.ads_Mkr29 : '1 Hour';
    durationSelect.appendChild(opt0);
    if (HclientID != 42) {
      durationSelect.appendChild(opt1);
      durationSelect.appendChild(opt2);
    }
    durationSelect.appendChild(opt3);
    durationDiv.appendChild(durationLabel);
    durationDiv.appendChild(durationSelect);
    div.appendChild(durationDiv);

    // Anglo Extra Dropdowns ========
    if (HclientID == 42) {
      // TimeZone
      const timeZoneDiv = divAtt('div', 'id', 'canTimeZoneDiv');
      const timeLabel = langObj.ads_Mkr44 ? langObj.ads_Mkr44 : 'Time zone';
      const timeZoneSelect = await buildSelectInp('canTimeZone', 1, `${timeLabel}`);
      const timeZoneDes = divAtt('p', 'id', 'canTimeZoneDesc');
      timeZoneDes.classList.add('marginBottom');
      timeZoneDiv.appendChild(timeZoneSelect);
      timeZoneDiv.appendChild(timeZoneDes);
      div.appendChild(timeZoneDiv);
      // Langauge
      const langDiv = divAtt('div', 'id', 'canLangDiv');
      const langLabel = langObj.ads_Mkr45 ? langObj.ads_Mkr45 : 'Language';
      const langSelect = await buildSelectInp('canLang', 1, `${langLabel}`);
      langDiv.appendChild(langSelect);
      div.appendChild(langDiv);
    }

    return div;
  },
  async mancompGroupFeedback(HclientID, langObj) {
    const div = divAtt('div', 'id', 'mancompFeedback');
    div.setAttribute('class', 'grid-2col-input sectionGap hide'); //hide
    div.style = 'justify-content: start; gap:3rem;';

    const requesterDiv = divAtt('div', 'id', 'mancomprequesterDiv');
    const selectDiv = divAtt('div', 'id', 'selectDiv');
    const requestorLabel = divAtt('label', 'for', 'mancomprequester');

    const requestorInput = divAtt('input', 'type', 'text');
    requestorInput.setAttribute('id', 'mancomprequestorInput');
    if (HclientID == 42) {
      requestorLabel.innerHTML = langObj.ads_Mkr18 ? langObj.ads_Mkr18 : 'Line Manager / Hiring Manager';
      requestorInput.setAttribute('placeholder', `${langObj.ads_Mkr19}`); //'Search for Line Manager / Hiring Manager');
    } else {
      requestorLabel.innerHTML = 'Requestor';
      requestorInput.setAttribute('placeholder', 'Search for Requestor');
    }

    const requestorSelect = divAtt('select', 'id', 'mancomprequester');
    requestorSelect.setAttribute('multiple', 'true');
    requestorSelect.style = 'margin-top: 0;';
    selectDiv.appendChild(requestorLabel);
    selectDiv.appendChild(requestorInput);
    selectDiv.appendChild(requestorSelect);

    const newRequestorDiv = divAtt('div', 'id', 'mancompnewRequester');
    newRequestorDiv.setAttribute('class', 'hide');
    newRequestorDiv.style = 'margin-top: 3rem;';
    const name = buildInpText('mancompfName', 0, `${langObj.ads_Mkr26}`);
    const surname = buildInpText('mancompsName', 0, `${langObj.ads_Mkr27}`);
    const email = buildInpEmail('mancompemail', 0, langObj.ads_Mkr28);
    newRequestorDiv.appendChild(name);
    newRequestorDiv.appendChild(surname);
    newRequestorDiv.appendChild(email);

    requesterDiv.appendChild(selectDiv);
    requesterDiv.appendChild(newRequestorDiv);
    div.appendChild(requesterDiv);

    // Anglo Extra Dropdowns ========
    if (HclientID == 42) {
      // TimeZone
      const timeZoneDiv = divAtt('div', 'id', 'mancompTimezoneDiv');
      const timeLabel = langObj.ads_Mkr44 ? langObj.ads_Mkr44 : 'Time zone';
      const timeZoneSelect = await buildSelectInp('mancompTimeZone', 1, `${timeLabel}`);
      const timeZoneDes = divAtt('p', 'id', 'mancompTimeZoneDesc');
      timeZoneDes.classList.add('marginBottom');
      timeZoneDiv.appendChild(timeZoneSelect);
      timeZoneDiv.appendChild(timeZoneDes);
      div.appendChild(timeZoneDiv);
      // Langauge
      const langDiv = divAtt('div', 'id', 'mancompLangDiv');
      const langLabel = langObj.ads_Mkr45 ? langObj.ads_Mkr45 : 'Language';
      const langSelect = await buildSelectInp('mancompLang', 1, `${langLabel}`);
      langDiv.appendChild(langSelect);
      div.appendChild(langDiv);
    }

    const candidateDiv = divAtt('div', 'id', 'mancompCandidateDiv');
    candidateDiv.classList.add('gridSpan');

    const instructP = divAtt('p', 'class', 'marginBottom');
    instructP.innerHTML = langObj.ads_Mkr47 ? langObj.ads_Mkr47 : 'Please input an AADB number and click add to search for an existing candidate.</br> Between 2 and 4 Candidates can be added.';
    candidateDiv.appendChild(instructP);

    const AADBnumInpt = divAtt('div');
    AADBnumInpt.innerHTML = `<div class="AADBnumInptDiv" style="display: flex;">
        <div class="group" style="width: fit-content;">
        <input type="text" name="AADBnumInpt" id="AADBnumInpt" placeholder="${langObj.ads_Mkr50 ? langObj.ads_Mkr50 : 'AADB Number'}">
          <span class="bar"></span>
          <p id="AADBnumInpt_FB" class="inpFB hide"></p>
        </div>
        <div >
          <button id="addCan" class="subBtn" style="width: fit-content;margin-left: 1rem">
            <img src="plus_icon.svg" alt="add new" />
          </button>
        </div>
      </div>`;
    candidateDiv.appendChild(AADBnumInpt);

    const canTable = divAtt('table', 'class', 'gridSpan sectionGap marginTop hide');
    canTable.id = 'canTable';

    const thead1 = divAtt('thead', 'style', 'border-bottom: none !important; height: unset');
    const htr1 = divAtt('tr');
    const th = divAtt('th', 'colspan', '5');
    th.innerHTML = langObj.ads_Mkr46 ? langObj.ads_Mkr46 : 'Selected Candidates:';
    htr1.appendChild(th);
    thead1.appendChild(htr1);
    canTable.appendChild(thead1);

    const thead2 = divAtt('thead', 'class', 'listHead');
    const htr2 = divAtt('tr');
    const th1 = divAtt('th');
    th1.innerHTML = langObj.ads_Mkr48 ? langObj.ads_Mkr48 : 'Name';
    htr2.appendChild(th1);

    const th2 = divAtt('th');
    th2.innerHTML = langObj.ads_Mkr49 ? langObj.ads_Mkr49 : 'Email';
    htr2.appendChild(th2);

    const th3 = divAtt('th');
    th3.innerHTML = langObj.ads_Mkr50 ? langObj.ads_Mkr50 : 'AADB Number';
    htr2.appendChild(th3);

    const th4 = divAtt('th');
    th4.innerHTML = langObj.ads_Mkr51 ? langObj.ads_Mkr51 : 'Job Title';
    htr2.appendChild(th4);

    const th5 = divAtt('th');
    th5.innerHTML = langObj.ads_Mkr52 ? `${langObj.ads_Mkr52} <b><span id="mancompduration"></span></b>` : `Duration Feedback: <b><span id="mancompduration"></span></b>`;
    htr2.appendChild(th5);

    thead2.appendChild(htr2);
    canTable.appendChild(thead2);

    const canTableBody = divAtt('tbody', 'id', 'canTableBody');
    canTable.appendChild(canTableBody);
    candidateDiv.appendChild(canTable);
    div.appendChild(candidateDiv);

    return div;
  },
  // async buildCanDevFeedback(HclientID) {

  //     const div = divAtt('div', 'id', 'canDevFeedback');
  //     div.setAttribute('class', 'grid-2col-input sectionGap hide'); //hide

  //     const requesterDiv = divAtt('div', 'id', 'CDrequesterDiv');
  //     const selectDiv = divAtt('div', 'id', 'selectDiv');
  //     const requestorLabel = divAtt('label', 'for', 'CDrequester');

  //     const requestorInput = divAtt('input', 'type', 'text');
  //     requestorInput.setAttribute('id', 'CDrequestorInput');
  //     if (HclientID == 42) {
  //         requestorLabel.innerHTML = 'Line Manager / Hiring Manager (optional)';
  //         requestorInput.setAttribute('placeholder', 'Search for Line Manager / Hiring Manager');
  //     } else {
  //         requestorLabel.innerHTML = 'Requestor (optional)';
  //         requestorInput.setAttribute('placeholder', 'Search for Requestor');
  //     }

  //     requestorInput.setAttribute('onkeyup', "filterOptionsHandler('CDrequestorInput', 'CDrequester')");
  //     const requestorSelect = divAtt('select', 'id', 'CDrequester');
  //     requestorSelect.setAttribute('multiple', 'true');
  //     requestorSelect.setAttribute('onchange', 'additionalService.newRequester("CD"), notEmptyVal(this.id)');
  //     requestorSelect.style = 'margin-top: 0;';
  //     selectDiv.appendChild(requestorLabel);
  //     selectDiv.appendChild(requestorInput);
  //     selectDiv.appendChild(requestorSelect);

  //     const newRequestorDiv = divAtt('div', 'id', 'CDnewRequester');
  //     newRequestorDiv.setAttribute('class', 'hide');
  //     newRequestorDiv.style = 'margin-top: 3rem;';
  //     const name = buildInpText('CDfName', 0, 'Line Manager / Hiring Manager first name');
  //     const surname = buildInpText('CDsName', 0, 'Line Manager / Hiring Manager surname');
  //     const email = buildInpEmail('CDemail', 0)
  //     newRequestorDiv.appendChild(name);
  //     newRequestorDiv.appendChild(surname);
  //     newRequestorDiv.appendChild(email);

  //     requesterDiv.appendChild(selectDiv);
  //     requesterDiv.appendChild(newRequestorDiv);
  //     div.appendChild(requesterDiv)

  //     return div

  // },
  async populateRequestor(getFeedbackRequestor, selectID) {
    if (selectID) {
      if (getFeedbackRequestor.length >= 100) {
        // deal with more than 100
        for (var i = 0; i < getFeedbackRequestor.length; i++) {
          const val = getFeedbackRequestor[i];
          const opt = divAtt('option', 'value', val.HuserID);
          opt.innerHTML = val.comboName;
          id(selectID).appendChild(opt);
        }
      } else if (!getFeedbackRequestor.length) {
        optOne = divAtt('option', 'value', '-');
        optOne.innerHTML = 'No options available --';
        id(selectID).appendChild(optOne);
      } else {
        getFeedbackRequestor.forEach((arr) => {
          const opt = divAtt('option', 'value', arr.HuserID);
          opt.innerHTML = arr.comboName;
          id(selectID).appendChild(opt);
        });
      }
    }
  },
  addSerInfo() {
    const canFBbox = document.getElementsByName('Candidate feedback');
    const canBox = canFBbox[0];

    const manFBbox = document.getElementsByName('Management feedback');
    const manbox = manFBbox[0];

    const mancompFBbox = document.getElementsByName('Manager Comparative Group feedback');
    const mancompbox = mancompFBbox[0];

    // const canDevFBbox = document.getElementsByName('Candidate Development Report');
    // const CDbox = canDevFBbox[0];

    if (canBox && canBox.checked === true) {
      unhide('canFeedback');
    } else if (canBox && canBox.checked === false) {
      hide('canFeedback');
    }

    if (manbox && manbox.checked === true) {
      unhide('manFeedback');
    } else if (manbox && manbox.checked === false) {
      hide('manFeedback');
    }

    if (mancompbox && mancompbox.checked === true) {
      unhide('mancompFeedback');
    } else if (mancompbox && mancompbox.checked === false) {
      hide('mancompFeedback');
    }

    // if (CDbox && CDbox.checked === true) {
    //     unhide('canDevFeedback');
    // } else if (CDbox && CDbox.checked === false) {
    //     hide('canDevFeedback');
    // }
  },
  timeZoneDescription(feedbackID) {
    if (id(`${feedbackID}TimeZone`).value === '-' || !id(`${feedbackID}TimeZone`).value) {
      hide(`${feedbackID}TimeZoneDesc`);
    } else {
      id(`${feedbackID}TimeZoneDesc`).innerHTML = '';

      const data = window.timeZones;
      for (let row of data) {
        if (id(`${feedbackID}TimeZone`).value == row.DDTIMEZONEID) {
          id(`${feedbackID}TimeZoneDesc`).innerHTML = `<b>${row.DESCRIPTION}:</b> ${row.LONGDESCRIPTION}`;
        }
      }
      unhide(`${feedbackID}TimeZoneDesc`);
    }
  },
  addCandidate() {
    const langObj = window.langObj;
    //val
    const AADBnumInpt = id('AADBnumInpt').value;
    const table = id('canTableBody');
    const canLength = table.children.length;
    if (!AADBnumInpt) {
      const aaMsg = langObj.ads_Mkr53 ? langObj.ads_Mkr53 : 'Please type a AADB number.';
      return infoBox(aaMsg);
    } else if (canLength == 4) {
      const cannMsg = langObj.ads_Mkr54 ? langObj.ads_Mkr54 : "4 Candidates have already been selected. Please remove one if you'd like to add another.";
      return infoBox(cannMsg);
    }

    const elements = document.getElementsByClassName('rfcNumCheck');
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      if (element.innerHTML === AADBnumInpt) {
        const alreadyMsg = langObj.ads_Mkr55 ? langObj.ads_Mkr55 : 'You have already added this candidate.';
        return infoBox(alreadyMsg);
      }
    }

    const vars = {};
    vars.RFCNumber = AADBnumInpt;
    vars.HapplicationID = id('HapplicationID').value;

    if (AADBnumInpt.includes(vars.HapplicationID)) {
      const cannotMsg = langObj.ads_Mkr56 ? langObj.ads_Mkr56 : 'You cannot select the current candidate.';
      return infoBox(cannotMsg);
    }

    PREP(['getAppDetsByRFCNum'], vars).then((res) => {
      console.log('res', res);

      if (typeof res.data.getAppDetsByRFCNum === 'string') {
        return errBox(res.data.getAppDetsByRFCNum);
      }

      const data = res.data.getAppDetsByRFCNum[0];
      const tr = divAtt('tr', 'id', `${data.HapplicationID}`);

      const td1 = divAtt('td');
      td1.innerHTML = `${data.fname} ${data.sname}`;
      tr.appendChild(td1);

      const td2 = divAtt('td');
      td2.innerHTML = data.emailaddress;
      tr.appendChild(td2);

      const td3 = divAtt('td', 'class', 'rfcNumCheck');
      td3.innerHTML = AADBnumInpt;
      tr.appendChild(td3);

      const td4 = divAtt('td');
      td4.innerHTML = data.jobTitleLang;
      tr.appendChild(td4);

      const th5 = divAtt('td');
      let remove = divAtt('img', 'class', 'iconSize');
      remove.src = trashCanIcon;
      th5.appendChild(remove);
      tr.appendChild(th5);
      id('canTableBody').appendChild(tr);
      unhide('canTable');

      //eventlistener
      eListen(
        remove,
        () => {
          additionalService.removeCandidate(data.HapplicationID);
        },
        'click'
      );

      //reset input
      id('AADBnumInpt').value = '';
      additionalService.changeDuration();
    });
  },
  removeCandidate(elId) {
    id(elId).remove();
    //Change Duration
    additionalService.changeDuration();

    const table = id('canTableBody');
    let canLength = table.children.length;
    if (canLength < 1) {
      hide('canTable');
    }
  },
  changeDuration() {
    const langObj = window.langObj;
    const table = id('canTableBody');
    let canLength = table.children.length;
    //Change Duration
    if (canLength == 2) {
      id('mancompduration').innerHTML = langObj.ads_Mkr16 ? langObj.ads_Mkr16 : '30 Minutes';
    } else if (canLength == 3) {
      id('mancompduration').innerHTML = langObj.ads_Mkr17 ? langObj.ads_Mkr17 : '45 Minutes';
    } else if (canLength == 4) {
      id('mancompduration').innerHTML = langObj.ads_Mkr57 ? langObj.ads_Mkr57 : '60 Minutes';
    } else {
      id('mancompduration').innerHTML = '';
    }
  },
};

// ======================= MANAGE JOBS =============================

export class ManageJobs {
  constructor() {
    this.name = 'Manage Jobs';
    this.pageTier = 10;
    this.reference = 'manageJobs';
    this.pageID = null;
    this.data = null;
    this.HclientID = null;
  }

  initPage() {
    // Set page pecific variables

    this.loadPage();
  }

  loadPage() {
    this.jobsListPage();
  }

  async jobsListPage() {
    if (id('clientDD').value) {
      hide('selectClient');
      id('manageJobsTable').innerHTML = '';

      const table = id('manageJobsTable');
      const thead = await this.buildJobsHead();
      table.appendChild(thead);
      const searchRow = await this.buildSearchRow();
      table.appendChild(searchRow);
      eListen(
        'activeSearch',
        () => {
          manageJobs.getJobs(1, 50);
        },
        'click'
      );
      eListen(
        'clearButon',
        () => {
          ManageJobs.clearSearch();
        },
        'click'
      );

      const jobs = await ManageJobs.getJobs();

      if (jobs.length) {
        await ManageJobs.buildJobsBody(jobs);
        ManageJobs.searchTable();
        hide('noJobs');
      } else {
        id('manageJobsTable').innerHTML = '';
        unhide('noJobs');
        hide('searchSpace');
      }
    } else {
      id('manageJobsTable').innerHTML = '';
      hide('searchSpace');
      unhide('selectClient');
      hide('noJobs');
    }
  }

  async buildJobsHead() {
    const thead = document.createElement('thead');
    const th0 = document.createElement('th');
    const th1 = document.createElement('th');
    const th2 = document.createElement('th');
    const th3 = document.createElement('th');
    const th4 = document.createElement('th');
    const th5 = document.createElement('th');
    const th6 = document.createElement('th');
    const th7 = document.createElement('th');
    th0.innerHTML = '';
    th1.innerHTML = 'Job Number';
    th2.innerHTML = 'Job Title';
    th3.innerHTML = 'Added By';
    th4.innerHTML = 'Line manager';
    th5.innerHTML = 'Job level';
    th6.innerHTML = 'Job grade';
    th7.innerHTML = 'Action';

    thead.appendChild(th0);
    thead.appendChild(th1);
    thead.appendChild(th2);
    thead.appendChild(th3);
    thead.appendChild(th4);
    thead.appendChild(th5);
    thead.appendChild(th6);
    thead.appendChild(th7);

    return thead;
  }

  async buildSearchRow() {
    //@mike - you are here
    const searchRow = divAtt('tr', 'id', 'trSearch');
    searchRow.setAttribute('class', 'hide');
    const ts0 = divAtt('td');
    ts0.innerHTML = ` <div>
          <label class="switch" class="alignCenter">
            <input type="checkbox" id="activeSearch" checked>
            <span class="slider round"></span>
          </label>
          <label class="tgglLabel" for="">Active</label>
        </div>`;
    const ts1 = divAtt('td');
    const ts1Input = divAtt('input', 'type', 'text');
    ts1Input.setAttribute('class', 'searchInputTable searchInp');
    ts1Input.setAttribute('placeholder', 'Search by Job Number');
    ts1Input.setAttribute('id', 'jobNumSearch');
    const ts2 = divAtt('td');
    const ts2Input = divAtt('input', 'type', 'text');
    ts2Input.setAttribute('placeholder', 'Search by Job Title');
    ts2Input.setAttribute('class', 'searchInputTable searchInp');
    ts2Input.setAttribute('id', 'jobTitleSearch');
    const ts3 = divAtt('td');
    const ts3Input = divAtt('input', 'type', 'text');
    ts3Input.setAttribute('class', 'searchInputTable searchInp');
    ts3Input.setAttribute('placeholder', 'Search by Added By');
    ts3Input.setAttribute('id', 'addedBySearch');
    const ts4 = divAtt('td');
    const ts4Input = divAtt('input', 'type', 'text');
    ts4Input.setAttribute('class', 'searchInputTable searchInp');
    ts4Input.setAttribute('placeholder', 'Search by Line Manager');
    ts4Input.setAttribute('id', 'lineManSearch');
    const ts5 = divAtt('td');
    const ts5Input = divAtt('input', 'type', 'text');
    ts5Input.setAttribute('class', 'searchInputTable searchInp');
    ts5Input.setAttribute('placeholder', 'Search by Job level');
    ts5Input.setAttribute('id', 'jobLevelSearch');
    const ts6 = divAtt('td');
    const ts6Input = divAtt('input', 'type', 'text');
    ts6Input.setAttribute('class', 'searchInputTable searchInp');
    ts6Input.setAttribute('placeholder', 'Search by Job Grade');
    ts6Input.setAttribute('id', 'jobGradeSearch');
    const ts7 = divAtt('td');
    const clearBtn = divAtt('button', 'class', 'clearBtn');
    clearBtn.setAttribute('class', 'clearBtn');
    clearBtn.setAttribute('id', 'clearButon');
    clearBtn.innerHTML = '<svg  width="13.58" height="13.58" viewBox="0 0 13.58 13.58"><defs><style>.a{fill:#231f20;}</style></defs><polygon class="a" points="12.53 13.53 13.58 12.47 7.84 6.78 13.53 1.05 12.47 0 6.79 5.74 1.05 0.06 0 1.1 5.74 6.79 0.05 12.53 1.1 13.58 6.8 7.84 12.53 13.53"/></svg> Clear Search';

    ts1.appendChild(ts1Input);
    ts2.appendChild(ts2Input);
    ts3.appendChild(ts3Input);
    ts4.appendChild(ts4Input);
    ts5.appendChild(ts5Input);
    ts6.appendChild(ts6Input);
    ts7.appendChild(clearBtn);
    searchRow.appendChild(ts0);
    searchRow.appendChild(ts1);
    searchRow.appendChild(ts2);
    searchRow.appendChild(ts3);
    searchRow.appendChild(ts4);
    searchRow.appendChild(ts5);
    searchRow.appendChild(ts6);
    searchRow.appendChild(ts7);

    return searchRow;
  }

  static async getJobs(displaypage, displayListCount) {
    const obj = {};
    obj.genSearch = id('genSearch').value;
    obj.jobNumSearch = id('jobNumSearch').value;
    obj.jobTitleSearch = id('jobTitleSearch').value;
    obj.addedBySearch = id('addedBySearch').value;
    obj.lineManSearch = id('lineManSearch').value;
    obj.jobLevelSearch = id('jobLevelSearch').value;
    obj.jobGradeSearch = id('jobGradeSearch').value;
    obj.activeSearch = id('activeSearch').checked ? true : false;

    const vars = {};
    vars.HclientID = id('clientDD').value;
    vars.displaypage = displaypage || 1;
    vars.displayListCount = displayListCount || 50;
    vars.searchObj = JSON.stringify(obj) || JSON.stringify({});
    hide('pagDiv');

    let returnData;
    await PREP(['getJobsForUser'], vars)
      .then((res) => {
        let callback = (p1, p2) => {
          ManageJobs.getJobs(p1, p2);
        };
        pagination(res.data.getJobsForUser[0].pagination[0], callback);
        returnData = res.data.getJobsForUser[0].ReturnList;
      })
      .catch(console.error());

    return returnData;
  }

  static async buildJobsBody(data) {
    const hclientID = id('clientDD').value;
    const tbody = id('jobListBody') ? id('jobListBody') : divAtt('tbody', 'id', 'jobListBody');
    tbody.innerHTML = '';

    if (data.length) {
      for (let row of data) {
        const tr = document.createElement('tr');
        const td0 = document.createElement('td');
        const td1 = document.createElement('td');
        const td2 = document.createElement('td');
        const td3 = document.createElement('td');
        const td4 = document.createElement('td');
        const td5 = document.createElement('td');
        const td6 = document.createElement('td');
        const td7 = document.createElement('td');
        const manageBtn = divAtt('button', 'class', 'btn');

        manageBtn.setAttribute('onclick', `PREP('editJobs', 'HjobID=${row.HjobID}&hclientID=${hclientID}')`);
        manageBtn.innerHTML = 'Manage';
        td0.innerHTML = '';
        td1.innerHTML = row.jobnumber;
        td2.innerHTML = row.jobTitle;
        td3.innerHTML = `${row.adderFname} ${row.adderSname}`;
        td4.innerHTML = `${row.lineManagerFname} ${row.lineManagerSname}`;
        td5.innerHTML = row.jobLevel;
        td6.innerHTML = row.jobGrade;
        td7.appendChild(manageBtn);
        tr.appendChild(td0);
        tr.appendChild(td1);
        tr.appendChild(td2);
        tr.appendChild(td3);
        tr.appendChild(td4);
        tr.appendChild(td5);
        tr.appendChild(td6);
        tr.appendChild(td7);
        tbody.appendChild(tr);
      }
      unhide('searchSpace');
    }
    id('manageJobsTable').appendChild(tbody);
    // return tbody
  }

  static searchTable() {
    const searchInp = document.querySelectorAll('.searchInp');
    searchInp.forEach((sInp) => {
      let timeout;
      sInp.addEventListener('keyup', () => {
        clearTimeout(timeout);
        timeout = setTimeout(async () => {
          const jobs = await ManageJobs.getJobs(1, 50);
          await ManageJobs.buildJobsBody(jobs);
        }, 1500);
      });
    });
  }

  static async showSearchFilters() {
    const searchFilters = id('searchFilters');
    const trSearch = id('trSearch');

    if (trSearch.classList.contains('hide')) {
      searchFilters.classList.add('searchFiltersActive');
      hide('searchBar');
      id('genSearch').value = '';
      unhide('trSearch');
    } else {
      searchFilters.classList.remove('searchFiltersActive');
      hide('trSearch');
      unhide('searchBar');
      id('jobNumSearch').value = '';
      id('jobTitleSearch').value = '';
      id('addedBySearch').value = '';
      id('lineManSearch').value = '';
      id('jobLevelSearch').value = '';
      id('jobGradeSearch').value = '';
    }
    const jobs = await ManageJobs.getJobs(1, 50);
    await ManageJobs.buildJobsBody(jobs);
  }

  static async clearSearch() {
    id('jobNumSearch').value = '';
    id('jobTitleSearch').value = '';
    id('addedBySearch').value = '';
    id('lineManSearch').value = '';
    id('jobLevelSearch').value = '';
    id('jobGradeSearch').value = '';
    const jobs = await ManageJobs.getJobs(1, 50);
    await ManageJobs.buildJobsBody(jobs);
  }

  static inpVal_V(eli) {
    if (!id(`${eli}_V`).value) {
      id(eli).classList.add('incorrect');
    } else {
      id(eli).classList.remove('incorrect');
    }
  }
}

export class RecordJob {
  constructor() {
    this.name = 'Record Job';
    this.pageTier = 10;
    this.reference = 'recordJob';
    this.pageID = null;
    this.data = null;
    this.hclientID = null;
  }

  initPage() {
    // Set page pecific variables
    // this.GAPJobProfessional = data.GAPJobProfessional
    // this.GAPJobTitle = data.GAPJobTitle
    // this.GAPJobObjectives = data.GAPJobObjectives
    // this.GAPJobPurpose = data.GAPJobPurpose
    // this.GAPJobLineManager = data.GAPJobLineManager
    // this.GAPJobDivision = data.GAPJobDivision
    // this.GAPJobFunctionArea = data.GAPJobFunctionArea
    // this.GAPJobFamilyLevel = data.GAPJobFamilyLevel
    // this.GAPJobGrade = data.GAPJobGrade
    // this.GAPPositionLevel = data.GAPPositionLevel
    // this.GAPCostCenter = data.GAPCostCenter
    // thiis.GAPJobRecruiter = data.GAPJobRecruiter

    this.loadPage();
  }

  loadPage() {
    this.HclientID = id('clientDD').value;
    this.recordJobPage();
  }

  async recordJobPage() {
    if (id('clientDD').value) {
      const recipe = await getRecipe();
      recipe.methods = ['GAPJobProfessional', 'GAPJobTitle', 'GAPJobObjectives', 'GAPJobPurpose', 'GAPJobLineManager', 'GAPJobDivision', 'GAPJobFunctionArea', 'GAPJobFamilyLevel', 'GAPJobGrade', 'GAPPositionLevel', 'GAPCostCenter', 'GAPJobRecruiter', 'getClientDetails'];
      // recipe.div = 'jobSpecPage';
      // recipe.page = 'recordJob';
      PREP(recipe, {
        HclientID: id('clientDD').value,
      })
        .then((res) => {
          ccRegexMulti(0, id('clientDD').value);

          buildDropDownMain(res.data.GAPJobProfessional, 'professional', 'allocProfessionalHclientID', 'shortname');

          buildDList(res.data.GAPJobTitle, 'job_T_L', 'shortname');
          RecordJob.dataListMatch(res.data.GAPJobTitle, 'job_T', 'DDjobtitleID', 'shortname');

          buildDList(res.data.GAPPositionLevel, 'job_L_L', 'shortname');
          RecordJob.dataListMatch(res.data.GAPPositionLevel, 'job_L', 'DDpositionLevelID', 'shortname');

          buildDList(res.data.GAPJobGrade, 'job_G_L', 'shortname');
          RecordJob.dataListMatch(res.data.GAPJobGrade, 'job_G', 'DDjobGradeID', 'shortname');

          buildDList(res.data.GAPJobFamilyLevel, 'job_F_L', 'shortname');
          RecordJob.dataListMatch(res.data.GAPJobFamilyLevel, 'job_F', 'DDjobfamilyID', 'shortname');

          buildDList(res.data.GAPJobFunctionArea, 'funct_A_L', 'shortname');
          RecordJob.dataListMatch(res.data.GAPJobFunctionArea, 'funct_A', 'DDjobFunctionAreaID', 'shortname');

          buildDList(res.data.GAPJobDivision, 'depart_L', 'shortname');
          RecordJob.dataListMatch(res.data.GAPJobDivision, 'depart', 'DDDivisionID', 'shortname');

          buildDList(res.data.GAPJobLineManager, 'line_M_L', 'shortname');
          RecordJob.dataListMatch(res.data.GAPJobLineManager, 'line_M', 'HuserID', 'shortname');

          buildDList(res.data.GAPJobRecruiter, 'recruiter_L', 'shortname');
          RecordJob.dataListMatch(res.data.GAPJobRecruiter, 'recruiter', 'HuserID', 'shortname');

          buildDList(res.data.GAPJobPurpose, 'job_P_L', 'shortname');
          RecordJob.dataListMatch(res.data.GAPJobPurpose, 'job_P', 'DDjobpurposeID', 'shortname');

          buildDList(res.data.GAPJobObjectives, 'job_O_L', 'shortname');
          RecordJob.dataListMatch(res.data.GAPJobObjectives, 'job_O', 'DDjobObjectivesID', 'shortname');

          buildDList(res.data.GAPCostCenter, 'costC_L', 'shortdescription');
          RecordJob.dataListMatch(res.data.GAPCostCenter, 'costC', 'DDcostCenterID', 'shortdescription');

          hide('selectClient');
          unhide('recordJobForm');

          // Cater for client pacific fields
          const clientDets = res.data.getClientDetails[0];

          Object.entries(optionalFieldsObj).forEach((field) => {
            if (clientDets[`${field[0]}`] === 0) {
              if (id(`${field[1].displayDiv}`)) {
                console.log('hide:', `${field[1].displayDiv}`, `${field[1].input}`);
                hide(`${field[1].displayDiv}`);
                id(`${field[1].input}`).classList.remove('val');

                if (id(`${field[1].input_V}`)) {
                  id(`${field[1].input_V}`).classList.remove('notEmpty');
                }
              }
            }
          });
        })
        .catch(console.error());
    } else {
      unhide('selectClient');
      hide('recordJobForm');
    }
  }

  static inpVal(eli) {
    if (!id(eli).value || id(eli).value == '-') {
      id(eli).classList.add('incorrect');
    } else {
      id(eli).classList.remove('incorrect');
    }
  }

  static inpVal_V(eli) {
    if (!id(`${eli}_V`).value) {
      id(eli).classList.add('incorrect');
    } else {
      id(eli).classList.remove('incorrect');
    }
  }

  static fileSelected(inputID, nameDisplayID) {
    const iMaxFilesize = 250000; // 1MB
    const oFile = id(inputID).files[0];
    const acceptList = ['application/pdf', '.doc', '.docx', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];

    if (!acceptList.includes(oFile.type)) {
      if (id('jobSpecFile')) {
        id('jobSpecFile').value = '';
      } else if (id('displayFileName')) {
        id('displayFileName').value = '';
      }
      infoBox('Invalid: Please select a *.pdf file format.');
      hide('fileDisplay');
      unhide('uploadBtn');
    } else {
      id(nameDisplayID).innerHTML = oFile.name;
      hide('uploadBtn');
      unhide('fileDisplay');
      if (oFile.size <= iMaxFilesize) {
        const oReader = new FileReader();
        oReader.readAsDataURL(oFile);
      }
    }
  }

  static rmvFile(inputID) {
    id(inputID).value = '';
    hide('fileDisplay');
    unhide('uploadBtn');
  }

  static addJobObjective() {
    const objList = id('objectiveList');

    if (!id('job_O').value) {
      infoBox('Please select an objective.');
    } else if (id('job_O_V').value === 'NEW') {
      if (!id('job_O_C').value) {
        infoBox('Please fill in new job objective entry.');
      } else {
        const divuuid = uuidvMain();

        let div1 = divAtt('div', 'class', 'row');
        div1.style = `align-items: center;`;
        div1.setAttribute('id', `obj_${divuuid}`);
        const div2 = divAtt('div', 'class', 'jobObj newJobObj');
        div2.innerHTML = id('job_O_C').value;
        let remove = divAtt('img', 'class', 'iconSize');
        // let remove = divAtt(
        //   "img",
        //   "onclick",
        //   `manageJobs.removeJobObjective('obj_${divuuid}')`
        // );
        remove.src = trashCanIcon;
        remove.style = `margin-right: 10px; cursor: pointer;`;

        div1.appendChild(remove);
        div1.appendChild(div2);
        objList.appendChild(div1);
        eListen(
          remove,
          () => {
            manageJobs.removeJobObjective(`obj_${divuuid}`);
          },
          'click'
        );
        id('job_O').value = '';
        id('job_O_C').value = '';
        hide('job_O_DIV');
      }
    } else {
      if (id(`obj_${id('job_O_V').value}`)) {
        return infoBox('Objective has already been selected.');
      }
      const div1 = divAtt('div', 'class', 'row ');
      div1.style = `align-items: center;`;
      const div2 = divAtt('div', 'class', '');
      div2.innerHTML = id('job_O').value;
      let remove = divAtt('img', 'class', 'iconSize');
      remove.src = trashCanIcon;
      remove.style = `margin-right: 10px; cursor: pointer;`;

      div1.setAttribute('id', `obj_${id('job_O_V').value}`);
      const hiddenInp = divAtt('input', 'type', 'hidden');
      hiddenInp.setAttribute('value', `${id('job_O_V').value}`);
      hiddenInp.classList.add('jobObj');
      remove.setAttribute('', '');
      div1.appendChild(hiddenInp);

      div1.appendChild(remove);
      div1.appendChild(div2);
      objList.appendChild(div1);
      eListen(
        remove,
        () => {
          manageJobs.removeJobObjective(`obj_${id('job_O_V').value}`);
        },
        'click'
      );
      unhide('objSection');
      id('job_O').value = '';
      id('job_O_C').value = '';
    }
  }

  static removeJobObjective(elID) {
    id(elID).remove();
  }

  static addNewDataList(btnID) {
    const split = btnID.split('_');
    const inpID = `${split[0]}_${split[1]}`;
    const text = 'Are you sure you would like to add the following entry to the data base?';
    const div = document.createElement('div');
    const label = divAtt('label', 'for', 'valueDisp');
    const span = divAtt('span', 'id', 'valueDisp');
    const okBtn = divAtt('button', 'class', 'btn');
    const cancelBtn = divAtt('button', 'class', 'btn');
    label.innerHTML = 'New Entry: ';
    span.innerHTML = id(inpID).value;
    okBtn.innerHTML = 'Ok';
    cancelBtn.innerHTML = 'Cancel';
    div.appendChild(label);
    div.appendChild(span);
    div.appendChild(okBtn);
    div.appendChild(cancelBtn);
    custardBox(div, text);
  }

  static dataListMatch(data, inpID, val, text) {
    const valID = `${inpID}_V`;
    const cusID = `${inpID}_DIV`;
    const rgx = /ID$/;
    if (id(valID).value) {
      let rowID;
      for (let row of data) {
        if (!rowID) {
          for (let key in row) {
            if (rgx.test(key)) {
              rowID = key;
              break;
            }
          }
        }
        if (rowID && id(valID).value == row[rowID]) {
          if (row.shortname === undefined) {
            id(inpID).value = row.shortdescription;
          } else {
            id(inpID).value = row.shortname;
          }

          break;
        }
      }
    }
    eListen(
      inpID,
      () => {
        let isMatch = false;
        for (let job of data) {
          if (job[text] == id(inpID).value) {
            id(valID).value = job[val];
            isMatch = true;
          }
        }
        if (id(valID).value == 'NEW') {
          unhide(cusID);
        } else {
          hide(cusID);
        }
        if (!isMatch) {
          id(valID).value = '';
        }
      },
      'input'
    );
  }

  static async recordJob() {
    btnModalOn('recordJobBtn');
    let pass = validatePage();

    const inputs = document.querySelectorAll('.val');
    const inpArr2 = Array.from(inputs);

    for (let input of inpArr2) {
      if (!id(`${input.id}_V`).value) {
        input.classList.add('incorrect');
      } else {
        input.classList.remove('incorrect');
      }
    }
    if (!pass) return btnModalOff('recordJobBtn');

    //line manager
    // const phoneNumber = await sanatizeNum(id('f_cellNr').value, id('countryCodes').value);

    if (id('line_M').value === '*Add new*') {
      if (id('fName').value === '' || id('sName').value === '' || id('email').value === '') {
        infoBox('Please fill in all details for new line manager.');
        btnModalOff('recordJobBtn');
        return;
      }
      if (!valE(id('email').value)) {
        infoBox('A valid email address is required.');
        btnModalOff('recordJobBtn');
        return;
      }
    }

    //recruiter
    // const R_phoneNumber = await sanatizeNum(id('R_f_cellNr').value, id('R_countryCodes').value);

    if (id('recruiter').value === '*Add new*') {
      if (id('R_fName').value === '' || id('R_sName').value === '' || id('R_email').value === '') {
        infoBox('Please fill in all details for new line manager.');
        btnModalOff('recordJobBtn');
        return;
      }
      if (!valE(id('R_email').value)) {
        infoBox('A valid email address is required.');
        btnModalOff('recordJobBtn');
        return;
      }
    }

    const idArr = ['job_T', 'job_L', 'job_G', 'job_F', 'funct_A', 'depart', 'line_M', 'job_P', 'costC', 'recruiter']; //'job_O',

    const vars = {};
    const obj = {};
    for (let item of idArr) {
      const itemVal = `${item}_V`;
      if (id(itemVal).value == 'NEW' && item == 'line_M') {
        obj[item] = {
          value: id(itemVal).value,
          fName: id('fName').value,
          sName: id('sName').value,
          email: id('email').value,
          mobNum: '', //phoneNumber,
        };
      } else if (id(itemVal).value == 'NEW' && item == 'recruiter') {
        obj[item] = {
          value: id(itemVal).value,
          fName: id('R_fName').value,
          sName: id('R_sName').value,
          email: id('R_email').value,
          mobNum: '', //R_phoneNumber,
        };
      } else if (id(itemVal).value == 'NEW') {
        if (!id(`${item}_C`).value) {
          infoBox('Please fill in new entry');
          btnModalOff('recordJobBtn');
          return;
        } else {
          obj[item] = {
            value: id(itemVal).value,
            newEntry: id(`${item}_C`).value,
          };
        }
      } else {
        obj[item] = {
          value: id(itemVal).value,
        };
      }
    }

    if (!id('GAPDisplayJobObjectives').classList.contains('hide')) {
      const jobObjectives = document.querySelectorAll('.jobObj');
      if (jobObjectives.length) {
        const valueList = [];
        const newList = [];
        jobObjectives.forEach((jobObj) => {
          if (jobObj.classList.contains('newJobObj')) {
            newList.push(jobObj.innerHTML);
          } else {
            valueList.push(jobObj.value);
          }
        });
        obj['job_O'] = {
          newList: newList,
          valueList: valueList,
        };
      } else {
        infoBox('Please add a Job Objective. <br> Click the "+" button to add the objective to the list.');
        id('job_O').classList.add('incorrect');
        btnModalOff('recordJobBtn');
        return;
      }
    } else {
      obj['job_O'] = {
        value: '',
      };
    }

    obj['HireResource'] = {
      value: id('HireResource').value,
    };

    obj['agency'] = {
      value: id('agency').value,
    };

    // if (id('jobSpecFile').files[0]) {
    //     vars.uploadFile = id('jobSpecFile').files[0];
    //     vars.fileName = id('jobSpecFile').files[0].name;
    // }

    obj.numReports = {
      value: '0', //id('numReports').value;
    };
    obj.professional = id('professional').value;
    obj.jobNum = {
      value: id('jobNum').value,
    };
    obj.HclientID = id('clientDD').value;

    vars.entityType = 'recordJobSpecification';
    vars.entityUUID = uuidvMain();
    vars.payload = JSON.stringify(obj);

    PREP(['uploadNewRecords'], vars)
      .then((res) => {
        note(res.data.uploadNewRecords);
        btnModalOff('recordJobBtn');
        PREP('recordJob');
      })
      .catch(console.error());
    btnModalOff('recordJobBtn');
  }
}

export class EditJobs {
  constructor() {
    this.name = 'Edit Jobs';
    this.pageTier = 10;
    this.reference = 'editJobs';
    this.pageID = null;
    this.data = null;
    this.HclientID = null;
  }

  initPage() {
    // Set page pecific variables
    this.loadPage();
  }

  loadPage() {}
}

export class MJtJobSpecs {
  constructor(vars) {
    this.name = 'Edit Job Specifications';
    this.pageTier = 15;
    this.reference = 'MJt_jobSpecs';
    this.pageID = null;
    this.data = null;
    this.HclientID = vars.hclientID;
    this.HjobID = vars.HjobID;
  }

  initPage(data) {
    // Set page pecific variables
    this.getJobsSpecDets = data.getJobsSpecDets;
    this.GAPJobTitle = data.GAPJobTitle;
    this.GAPJobObjectives = data.GAPJobObjectives;
    this.GAPJobPurpose = data.GAPJobPurpose;
    this.GAPJobLineManager = data.GAPJobLineManager;
    this.GAPJobDivision = data.GAPJobDivision;
    this.GAPJobFunctionArea = data.GAPJobFunctionArea;
    this.GAPJobFamilyLevel = data.GAPJobFamilyLevel;
    this.GAPJobGrade = data.GAPJobGrade;
    this.GAPPositionLevel = data.GAPPositionLevel;
    this.GAPJobProfessional = data.GAPJobProfessional;
    this.GAPCostCenter = data.GAPCostCenter;
    this.GAPJobRecruiter = data.GAPJobRecruiter;
    this.clientDets = data.getClientDetails[0];

    this.loadPage();
  }

  loadPage() {
    this.jobsSpecPage();
  }

  jobsSpecPage() {
    // ccRegex(0, id('hclientID').value)
    ccRegexMulti(0, id('hclientID').value);

    buildDropDownMain(this.GAPJobProfessional, 'professional', 'allocProfessionalHclientID', 'shortname');

    MJtJobSpecs.profList();
    MJtJobSpecs.docList();

    id('job_T_V').value = this.getJobsSpecDets[0].DDjobTitleID;
    buildDList(this.GAPJobTitle, 'job_T_L', 'shortname');
    RecordJob.dataListMatch(this.GAPJobTitle, 'job_T', 'DDjobtitleID', 'shortname');

    id('job_L_V').value = this.getJobsSpecDets[0].DDjoblevelID;
    buildDList(this.GAPPositionLevel, 'job_L_L', 'shortname');
    RecordJob.dataListMatch(this.GAPPositionLevel, 'job_L', 'DDpositionLevelID', 'shortname');

    id('job_G_V').value = this.getJobsSpecDets[0].DDjobGradeID;
    buildDList(this.GAPJobGrade, 'job_G_L', 'shortname');
    RecordJob.dataListMatch(this.GAPJobGrade, 'job_G', 'DDjobGradeID', 'shortname');

    id('job_F_V').value = this.getJobsSpecDets[0].DDjobFamilyID;
    buildDList(this.GAPJobFamilyLevel, 'job_F_L', 'shortname');
    RecordJob.dataListMatch(this.GAPJobFamilyLevel, 'job_F', 'DDjobfamilyID', 'shortname');

    id('funct_A_V').value = this.getJobsSpecDets[0].DDjobfunctionAreaID;
    buildDList(this.GAPJobFunctionArea, 'funct_A_L', 'shortname');
    RecordJob.dataListMatch(this.GAPJobFunctionArea, 'funct_A', 'DDjobFunctionAreaID', 'shortname');

    id('depart_V').value = this.getJobsSpecDets[0].DDdivisionID;
    buildDList(this.GAPJobDivision, 'depart_L', 'shortname');
    RecordJob.dataListMatch(this.GAPJobDivision, 'depart', 'DDDivisionID', 'shortname');

    id('job_P_V').value = this.getJobsSpecDets[0].DDjobpurposeID;
    buildDList(this.GAPJobPurpose, 'job_P_L', 'shortname');
    RecordJob.dataListMatch(this.GAPJobPurpose, 'job_P', 'DDjobpurposeID', 'shortname');

    // id('job_O_V').value = this.getJobsSpecDets[0].DDjobObjectivesID;
    buildDList(this.GAPJobObjectives, 'job_O_L', 'shortname');
    RecordJob.dataListMatch(this.GAPJobObjectives, 'job_O', 'DDjobObjectivesID', 'shortname');

    const objList = id('objectiveList');
    objList.innerHTML = '';
    for (let objective of this.getJobsSpecDets[0].objectives) {
      const div1 = divAtt('div', 'class', 'row ');
      div1.style = `align-items: center;`;
      const div2 = divAtt('div', 'class', '');
      div2.innerHTML = objective.shortName;
      let remove = divAtt('img', 'class', 'iconSize');
      remove.src = trashCanIcon;
      remove.style = `margin-right: 10px; cursor: pointer;`;
      div1.setAttribute('id', `obj_${objective.jobObjectivesID}`);
      const hiddenInp = divAtt('input', 'type', 'hidden');
      hiddenInp.setAttribute('value', `${objective.jobObjectivesID}`);
      hiddenInp.classList.add('jobObj');
      // remove.setAttribute(
      //   "onclick",
      //   `manageJobs.removeJobObjective('obj_${objective.jobObjectivesID}')`
      // );
      div1.appendChild(hiddenInp);

      div1.appendChild(remove);
      div1.appendChild(div2);
      objList.appendChild(div1);
      eListen(
        remove,
        () => {
          manageJobs.removeJobObjective(`obj_${objective.jobObjectivesID}`);
        },
        'click'
      );
    }

    id('line_M_V').value = this.getJobsSpecDets[0].linemanagerID;
    buildDList(this.GAPJobLineManager, 'line_M_L', 'shortname');
    RecordJob.dataListMatch(this.GAPJobLineManager, 'line_M', 'HuserID', 'shortname');

    id('recruiter_V').value = this.getJobsSpecDets[0].recruiterID;
    buildDList(this.GAPJobRecruiter, 'recruiter_L', 'shortname');
    RecordJob.dataListMatch(this.GAPJobRecruiter, 'recruiter', 'HuserID', 'shortname');

    id('costC_V').value = this.getJobsSpecDets[0].DDcostcenterID;
    buildDList(this.GAPCostCenter, 'costC_L', 'shortdescription');
    RecordJob.dataListMatch(this.GAPCostCenter, 'costC', 'DDcostCenterID', 'shortdescription');

    id('jobNum').value = this.getJobsSpecDets[0].jobnumber;
    if (this.getJobsSpecDets[0].hireResource) {
      id('HireResource').value = this.getJobsSpecDets[0].hireResource;
    }

    if (this.getJobsSpecDets[0].agency) {
      id('agency').value = this.getJobsSpecDets[0].agency;
    }
    // id('numReports').value = this.getJobsSpecDets[0].directReportCnt;

    id('HjobID').value = this.getJobsSpecDets[0].HjobID;

    // Client pacific
    const clientDets = this.clientDets;
    Object.entries(optionalFieldsObj).forEach((field) => {
      if (clientDets[`${field[0]}`] === 0) {
        if (id(`${field[1].displayDiv}`)) {
          console.log('hide:', `${field[1].displayDiv}`, `${field[1].input}`);
          hide(`${field[1].displayDiv}`);
          id(`${field[1].input}`).classList.remove('val');

          if (id(`${field[1].input_V}`)) {
            id(`${field[1].input_V}`).classList.remove('notEmpty');
          }
        }
      }
    });
  }

  static profList() {
    const profBody = id('profBody');
    profBody.innerHTML = '';

    const vars = {};
    vars.HclientID = id('hclientID').value;
    vars.HjobID = id('HjobID').value;
    PREP(['getJobsSpecDets'], vars)
      .then((res) => {
        if (res.data.getJobsSpecDets[0].professionals.length) {
          const data = res.data.getJobsSpecDets[0].professionals;
          for (const el of data) {
            const profRow = divAtt('tr', 'class', 'prof');
            profRow.setAttribute('id', `profID_${el.HuserID}`);
            const dateAdded = divAtt('td', 'class', '');
            dateAdded.innerHTML = `${el.dateAdded}`;
            const addedBy = divAtt('td', 'class', '');
            addedBy.innerHTML = `${el.addedbyFname} ${el.addedbySname}`;
            const profName = divAtt('td', 'class', '');
            profName.innerHTML = `${el.fname} ${el.sname}`;
            const remove = divAtt('td', 'class', 'iconSize');
            const removeImg = divAtt('img');
            removeImg.src = trashCanIcon;
            removeImg.setAttribute('onclick', `MJtJobSpecs.removeProf(${el.allocProfessionalHjobID})`);
            remove.appendChild(removeImg);

            profRow.appendChild(dateAdded);
            profRow.appendChild(addedBy);
            profRow.appendChild(profName);
            profRow.appendChild(remove);
            profBody.appendChild(profRow);
            eListen(
              remove,
              () => {
                manageJobs.removeJobObjective(MJtJobSpecs.removeProf(`${el.allocProfessionalHjobID}`));
              },
              'click'
            );
            unhide('profTable');
            hide('noneProf');
          }
        } else {
          profBody.innerHTML = '';
          hide('profTable');
          unhide('noneProf');
          infoBox('Please allocate a professional.');
        }
      })
      .catch(console.error());
  }

  static docList() {
    const vars = {};
    vars.HclientID = id('hclientID').value;
    vars.HjobID = id('HjobID').value;
    PREP(['getJobsSpecDets'], vars)
      .then((res) => {
        if (res.data.getJobsSpecDets[0].documents.length) {
          const data = res.data.getJobsSpecDets[0].documents;
          const docBody = id('docBody');
          docBody.innerHTML = '';

          for (let el of data) {
            const profRow = divAtt('tr', 'class', 'doc');
            profRow.setAttribute('id', `docID_${el.HjobDocumentsID}`);
            const dateAdded = divAtt('td', 'class', '');
            dateAdded.innerHTML = `${el.dateAdded}`;
            const addedBy = divAtt('td', 'class', '');
            addedBy.innerHTML = `${el.addedbyFname} ${el.addedbySname}`;
            const fileName = divAtt('td', 'class', '');
            fileName.innerHTML = `${el.originalFileName}`;

            const download = divAtt('td', 'class', '');
            const downloadImg = divAtt('a', 'class', 'flex');
            downloadImg.innerHTML = `<svg  width="13.8" height="13.8" viewBox="0 0 13.8 13.8">
                <path
                    d="M7,11.34a.72.72,0,0,0,1,0l2.7-2.69a.74.74,0,0,0,0-1,.72.72,0,0,0-1,0L8.21,9.11V1.31a.71.71,0,0,0-1.42,0v7.8L5.31,7.64a.72.72,0,0,0-1,0,.74.74,0,0,0,0,1Z"
                    transform="translate(-0.6 -0.6)" />
                <path
                    d="M13.69,6.79A.72.72,0,0,0,13,7.5V13H2V7.5a.71.71,0,0,0-.71-.71h0A.71.71,0,0,0,.6,7.5v5.71A1.19,1.19,0,0,0,1.79,14.4H13.21a1.19,1.19,0,0,0,1.19-1.19V7.5A.71.71,0,0,0,13.69,6.79Z"
                    transform="translate(-0.6 -0.6)" /></svg>`;
            // downloadImg.setAttribute('href', `${el.documentLink}`)
            // downloadImg.setAttribute('target', `blank`);
            downloadImg.setAttribute('id', 'downloadImg1');
            // downloadImg.setAttribute(
            //   "onclick",
            //   `MJtJobSpecs.downloadJobDoc('${el.HjobDocumentsID}')`
            // );
            download.appendChild(downloadImg);

            profRow.appendChild(dateAdded);
            profRow.appendChild(addedBy);
            profRow.appendChild(fileName);
            profRow.appendChild(download);
            docBody.appendChild(profRow);
            eListen(
              'downloadImg1',
              () => {
                MJtJobSpecs.downloadJobDoc(el.HjobDocumentsID);
              },
              'click'
            );
          }
          unhide('docTable');
        } else {
          hide('docTable');
        }
      })
      .catch(console.error());
  }

  static async updateJob() {
    btnModalOn('updateJobBtn');
    let pass = validatePage();

    const inputs = document.querySelectorAll('.val');
    console.log('inputs', inputs);

    for (let input of inputs) {
      if (!id(`${input.id}`).value) {
        input.classList.add('incorrect');
      } else {
        input.classList.remove('incorrect');
      }
    }
    if (!pass) return btnModalOff('updateJobBtn');

    for (let inp of inputs) {
      if (!id(`${inp.id}_V`).value || id(`${inp.id}_V`).value === '-') {
        infoBox('Please select an option for each field.');
        btnModalOff('updateJobBtn');
        return;
      }
    }

    for (let inp of inputs) {
      if (!id(inp.id).value.trim()) {
        infoBox('Please fill in all required fields.');
        btnModalOff('updateJobBtn');
        return;
      }
    }

    if (id('profBody').innerHTML === '') {
      infoBox('Please select a professional and click add to allocate to this job.');
      btnModalOff('updateJobBtn');
      return;
    }

    //line manager
    // const phoneNumber = await sanatizeNum(id('f_cellNr').value, id('countryCodes').value);
    if (id('line_M').value === '*Add new*') {
      if (id('fName').value === '' || id('sName').value === '' || id('email').value === '') {
        infoBox('Please fill in all details for new line manager.');
        btnModalOff('updateJobBtn');
        return;
      }
      if (!valE(id('email').value)) {
        infoBox('A valid email address is required.');
        btnModalOff('updateJobBtn');
        return;
      }
    }

    //recruiter
    // const R_phoneNumber = await sanatizeNum(id('R_f_cellNr').value, id('R_countryCodes').value);

    if (id('recruiter').value === '*Add new*') {
      if (id('R_fName').value === '' || id('R_sName').value === '' || id('R_email').value === '') {
        infoBox('Please fill in all details for new line manager.');
        btnModalOff('updateJobBtn');
        return;
      }
      if (!valE(id('R_email').value)) {
        infoBox('A valid email address is required.');
        btnModalOff('updateJobBtn');
        return;
      }
    }

    const idArr = ['job_T', 'job_L', 'job_G', 'job_F', 'funct_A', 'depart', 'line_M', 'job_P', 'costC', 'recruiter']; //job_O

    const vars = {};
    const obj = {};
    for (let item of idArr) {
      const itemVal = `${item}_V`;
      if (id(itemVal).value == 'NEW' && item == 'line_M') {
        obj[item] = {
          value: id(itemVal).value,
          fName: id('fName').value,
          sName: id('sName').value,
          email: id('email').value,
          mobNum: '', //phoneNumber,
        };
      } else if (id(itemVal).value == 'NEW' && item == 'recruiter') {
        obj[item] = {
          value: id(itemVal).value,
          fName: id('R_fName').value,
          sName: id('R_sName').value,
          email: id('R_email').value,
          mobNum: '', //R_phoneNumber,
        };
      } else if (id(itemVal).value == 'NEW') {
        if (!id(`${item}_C`).value) {
          infoBox('Please fill in new entry');
          btnModalOff('updateJobBtn');
          return;
        } else {
          obj[item] = {
            value: id(itemVal).value,
            newEntry: id(`${item}_C`).value,
          };
        }
      } else {
        obj[item] = {
          value: id(itemVal).value,
        };
      }
    }

    if (!id('GAPDisplayJobObjectives').classList.contains('hide')) {
      const jobObjectives = document.querySelectorAll('.jobObj');
      if (jobObjectives.length) {
        const valueList = [];
        const newList = [];
        jobObjectives.forEach((jobObj) => {
          if (jobObj.classList.contains('newJobObj')) {
            newList.push(jobObj.innerHTML);
          } else {
            valueList.push(jobObj.value);
          }
        });
        obj['job_O'] = {
          newList: newList,
          valueList: valueList,
        };
      } else {
        infoBox('Please add a Job Objective. <br> Click the "+" button to add the objective to the list.');
        id('job_O').classList.add('incorrect');
        btnModalOff('updateJobBtn');
        return;
      }
    } else {
      obj['job_O'] = {
        value: '',
      };
    }

    obj['HireResource'] = {
      value: id('HireResource').value,
    };

    obj['agency'] = {
      value: id('agency').value,
    };

    obj.numReports = {
      value: '0', //id('numReports').value
    };
    obj.jobNum = {
      value: id('jobNum').value,
    };
    obj.HclientID = pgstr.MJt_jobSpecs.HclientID;
    obj.HjobID = pgstr.MJt_jobSpecs.HjobID;
    obj.activeYN = toggleSliderYN(id('jobActive').checked);
    vars.entityType = 'updateJobSpecification';
    vars.entityUUID = uuidvMain();
    vars.payload = JSON.stringify(obj);
    PREP(['uploadNewRecords'], vars)
      .then((res) => {
        note(res.data.uploadNewRecords);
        btnModalOff('updateJobBtn');
        changeTabN('MJt_jobSpecs');
      })
      .catch(console.error());
    btnModalOff('updateJobBtn');
  }

  static cloneJob() {
    btnModalOn('cloneBtn');

    const vars = {};
    vars.HjobID = pgstr.MJt_jobSpecs.HjobID;
    PREP(['cloneHjob'], vars)
      .then((res) => {
        vars.hclientID = pgstr.MJt_jobSpecs.HclientID;
        vars.HjobID = res.data.cloneHjob;

        PREP(['getJobsSpecDets', 'GAPJobTitle', 'GAPJobObjectives', 'GAPJobPurpose', 'GAPJobLineManager', 'GAPJobDivision', 'GAPJobFunctionArea', 'GAPJobFamilyLevel', 'GAPJobGrade', 'GAPPositionLevel', 'GAPJobProfessional', 'GAPCostCenter', 'GAPJobRecruiter'], vars)
          .then((res2) => {
            infoBox(`<b>Job successfully cloned.</b><br> To confirm please see job number now ends with "- CLONED". <br>Please edit and click update.`);
            btnModalOff('cloneBtn');
            this.jobsSpecPage(res2);
          })
          .catch(console.error());
        btnModalOff('cloneBtn');
      })
      .catch(console.error());
    btnModalOff('cloneBtn');
  }

  static addProf() {
    const professional = id('professional');

    if (professional.value === '-') {
      infoBox('Please select a professional from the dropdown.');
    } else {
      const vars = {};
      vars.allocProfessionalHclientID = id('professional').value;
      vars.HclientID = pgstr.MJt_jobSpecs.HclientID;
      vars.HjobID = pgstr.MJt_jobSpecs.HjobID;

      PREP(['allocateProfessionalToJob'], vars)
        .then((res) => {
          note(res.data.allocateProfessionalToJob);
          MJtJobSpecs.profList();
        })
        .catch(console.error());
    }
  }

  static removeProf(allocProfessionalHjobID) {
    const vars = {};
    vars.allocProfessionalHjobID = allocProfessionalHjobID;

    PREP(['removeProfessionalFromJob'], vars)
      .then((res) => {
        note(res.data.removeProfessionalFromJob);
        MJtJobSpecs.profList();
      })
      .catch(console.error());
  }

  static fileSelected(inputID, nameDisplayID) {
    const iMaxFilesize = 250000; // 1MB
    const oFile = id(inputID).files[0];

    if (oFile.type !== 'application/pdf') {
      if (id('f_articles_upload')) {
        id('f_articles_upload').value = '';
      } else if (id('docList')) {
        id('docList').value = '';
      }
      infoBox('Invalid: Please select a *.pdf file format.');
    } else {
      id(nameDisplayID).innerHTML = oFile.name;
      if (oFile.size <= iMaxFilesize) {
        const oReader = new FileReader();
        oReader.readAsDataURL(oFile);
      }
    }
  }

  static addDoc(inputID) {
    const iMaxFilesize = 250000; // 1MB
    const oFile = id(inputID).files[0];
    const acceptList = ['application/pdf', '.doc', '.docx', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];

    if (!acceptList.includes(oFile.type)) {
      infoBox('Invalid: File format must be word or pdf only.');
    } else {
      if (oFile.size <= iMaxFilesize) {
        const oReader = new FileReader();
        oReader.readAsDataURL(oFile);
      }

      const vars = {};
      vars.uploadFile = id('jobSpecFile').files[0];
      vars.HjobID = pgstr.MJt_jobSpecs.HjobID;
      vars.fileName = id('jobSpecFile').files[0].name;

      PREP(['additionalJobDocument'], vars)
        .then((res) => {
          note(res.data.additionalJobDocument);
          MJtJobSpecs.docList();
        })
        .catch(console.error());
    }
  }

  static downloadJobDoc(docID) {
    PREP(['downloadJobDoc'], {
      HjobDocumentsID: docID,
    })
      .then((res) => {
        window.open(res.data.downloadJobDoc);
      })
      .catch(console.error());
  }
}

export class MJtApplications {
  constructor(vars) {
    this.name = 'Job Applications';
    this.pageTier = 15;
    this.reference = 'MJt_applications';
    this.pageID = null;
    this.data = null;
    this.HclientID = vars.hclientID;
    this.HjobID = vars.HjobID;
  }

  initPage(data) {
    // Set page pecific variables
    this.getApplicationsPerJob = data.getApplicationsPerJob;

    this.loadPage();
  }

  loadPage() {
    this.appPage();
  }

  appPage() {
    // build dropdown mobile
    ccRegex(0, this.HclientID);

    const list = this.getApplicationsPerJob[1].applicationsArray;
    if (list.length) {
      const table = id('existingCandidates');
      table.innerHTML = '';
      const tbody = divAtt('tbody', 'id', 'appListBody');
      const thead = document.createElement('thead');
      const th0 = document.createElement('th');
      const th1 = document.createElement('th');
      const th2 = document.createElement('th');
      const th3 = document.createElement('th');
      th0.innerHTML = 'Name';
      th1.innerHTML = 'Email';
      th2.innerHTML = 'Mobile Number';
      th3.innerHTML = 'Result';
      thead.appendChild(th0);
      thead.appendChild(th1);
      thead.appendChild(th2);
      thead.appendChild(th3);

      for (let app of list) {
        const tr = divAtt('tr', 'id', `HapplicationID_${app.HapplicationID}`);
        const name = document.createElement('td');
        name.innerHTML = `${app.candFname} ${app.candSname}`;
        const email = document.createElement('td');
        email.innerHTML = `${app.emailaddress}`;
        const num = document.createElement('td');
        num.innerHTML = `${app.mobilenumber}`;
        const result = document.createElement('td');
        result.innerHTML = `${app.applicationstatus}`;

        tr.appendChild(name);
        tr.appendChild(email);
        tr.appendChild(num);
        tr.appendChild(result);
        tbody.appendChild(tr);
      }

      table.appendChild(thead);
      table.appendChild(tbody);
      unhide('existingDiv');
    } else {
      hide('existingDiv');
    }
    unhide('addAppSection');
  }

  static bulkToggle() {
    if (id('bulkUploadToggle').checked) {
      unhide('bulkUpload');
      hide('signleUpload');
    } else {
      hide('bulkUpload');
      unhide('signleUpload');
    }
  }

  static displayFile(file) {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    if (file) {
      if (file.type == fileType) {
        id('displayFileName').innerHTML = file.name;
        unhide('displayFile');
      } else {
        infoBox("Invalid file: Please choose a file ending in '.xls'. ");
        id('upload').files[0] = null;
        hide('displayFile');
      }
    } else {
      infoBox('Please choose a file to upload.');
      id('upload').files[0] = null;
      hide('displayFile');
    }
  }

  static uploadApps() {
    const file = id('upload').files[0];
    if (file) {
      const vars = {};
      const obj = {};
      obj.HjobID = pgstr.MJt_applications.HjobID;
      vars.uploadFile = file;
      vars.entityType = 'bulkUploadApplicants';
      vars.entityUUID = uuidvMain();
      vars.payload = JSON.stringify({
        obj,
      });
      PREP(['uploadNewRecords'], vars)
        .then((res) => {
          note(res.data.uploadNewRecords);
          changeTabN('MJt_applications');
        })
        .catch(console.error());
    } else {
      infoBox('Please choose a file to upload.');
      id('upload').files[0] = null;
      hide('displayFile');
    }
  }

  static async addApplicant() {
    if (!validatePage()) {
      return;
    }

    const phoneNumber = await sanatizeNum(id('f_cellNr').value, id('countryCodes').value);

    const vars = {};
    vars.HjobID = pgstr.MJt_applications.HjobID;
    vars.fname = id('fName').value;
    vars.sname = id('sName').value;
    vars.email = id('email').value;
    vars.mobile = phoneNumber;
    vars.dob = ''; //id('DOB').value;
    vars.idNum = ''; //id('IDnum').value;
    vars.passNum = ''; // id('passNum').value;

    var radios = document.getElementsByName('internExternal');
    let internalExternal = null;
    for (var i = 0, length = radios.length; i < length; i++) {
      if (radios[i].checked) {
        internalExternal = radios[i].value;
        break;
      }
    }
    vars.internalExternal = internalExternal;

    PREP(['addGAPApplication'], vars).then((res) => {
      note(res.data.addGAPApplication);
      changeTabN('MJt_applications');
    });
  }

  static IDtoggle() {
    if (id('IDtoggle').checked === false) {
      id('IDnum').value = '';
      id('IDnum').classList.remove('notEmpty');
      id('passNum').classList.add('notEmpty');
      unhide('passNumDiv');
      hide('IDnumDiv');
    } else {
      id('passNum').value = '';
      id('IDnum').classList.add('notEmpty');
      id('passNum').classList.remove('notEmpty');
      hide('passNumDiv');
      unhide('IDnumDiv');
    }
  }
}

export class MJtCom {
  constructor(vars) {
    this.name = 'Job';
    this.pageTier = 15;
    this.reference = 'MJt_comAss';
    this.pageID = null;
    this.data = null;
    this.HclientID = vars.hclientID;
    this.HjobID = vars.HjobID;
  }

  initPage(data) {
    // Set page pecific variables
    this.getDDCategoryGroupPerClient = data.getDDCategoryGroupPerClient;
    this.getCompetencyByJob = data.getCompetencyByJob;
    this.getAssessmentsPerJob = data.getAssessmentsPerJob;
    this.getAssessmentsPerJobCompetencies = data.getAssessmentsPerJobCompetencies;
    this.getReportsPerJob = data.getReportsPerJob;
    this.getReportsForJob = data.getReportsForJob;
    this.getReportsForJob_SC = data.getReportsForJob_SC;
    this.getReportsForJob_ST = data.getReportsForJob_ST;

    this.loadPage();
  }

  loadPage() {
    this.comPage();
  }

  comPage() {
    const getDDCategoryGroup = this.getDDCategoryGroupPerClient;
    const getCompetencyByJob = this.getCompetencyByJob;
    const getAssessmentsPerJob = this.getAssessmentsPerJob;
    const getAssessmentsPerJobCompetencies = this.getAssessmentsPerJobCompetencies;
    const getReportsForJob = this.getReportsForJob;
    const getReportsPerJob = this.getReportsPerJob;

    // Build Dropdowns
    buildDropDownMain(getDDCategoryGroup, 'catGroup', 'categoryGroup', 'categoryGroup');

    // Section 1: Competencies -----------------------------------------
    if (getCompetencyByJob.length) {
      for (let row of getCompetencyByJob) {
        const comList = id('comList');
        let div1 = divAtt('div', 'class', 'row');
        div1.style = `align-items: center; flex-direction: row !important; margin-bottom: 0.6rem;`;
        div1.classList.add('com');
        div1.setAttribute('id', `category_${row.allocCompetencyJobID}`);
        const div2 = divAtt('div', 'class', '');
        div2.innerHTML = row.shortdescription;
        let remove = divAtt('img', 'class', 'iconSize');
        remove.src = trashCanIcon;
        remove.style = `margin-right: 10px; cursor: pointer;`;

        div1.appendChild(remove);
        div1.appendChild(div2);
        comList.appendChild(div1);
        eListen(
          remove,
          () => {
            MJtCom.removeCompetency(row.allocCompetencyJobID);
          },
          'click'
        );
      }
    }
  }

  static linkCompetency() {
    const catGroupDD = id('catGroup');
    if (catGroupDD.value && catGroupDD.value === '-') {
      hide('catDomainSection');
    } else {
      const vars = {};
      vars.CategoryGroup = catGroupDD.value;
      PREP(['getDDCategory'], vars).then((res) => {
        buildDropDownMain(cObj(res.data.getDDCategory), 'catDomain', 'DDCATEGORYID', 'DISPLAYNAME');
        unhide('catDomainSection');
      });
    }
  }

  static addCompetency() {
    const catDomainID = id('catDomain').value;

    if (catDomainID && catDomainID === '-') {
      errBox('Please select an option for category domain.');
    } else {
      const vars = {};
      vars.ddcategoryID = catDomainID;
      vars.HjobID = pgstr.MJt_comAss.HjobID;
      PREP(['allocCompetencyJob'], vars)
        .then(() => {
          changeTabN('MJt_comAss');
        })
        .catch(console.error());
    }
  }

  static removeCompetency(comId) {
    const vars = {};
    vars.allocCompetencyJobID = comId;
    PREP(['removeCompetencyJob'], vars)
      .then((res) => {
        note(res.data.removeCompetencyJob);
        changeTabN('MJt_comAss');
      })
      .catch(console.error());
  }
}

export class MJtAss {
  constructor(vars) {
    this.name = 'Job';
    this.pageTier = 15;
    this.reference = 'MJt_ass';
    this.pageID = null;
    this.data = null;
    this.HclientID = vars.hclientID;
    this.HjobID = vars.HjobID;
  }

  initPage(data) {
    // Set page pecific variables
    this.getDDCategoryGroupPerClient = data.getDDCategoryGroupPerClient;
    this.getCompetencyByJob = data.getCompetencyByJob;
    this.getAssessmentsPerJob = data.getAssessmentsPerJob;
    this.getAssessmentsPerJobCompetencies = data.getAssessmentsPerJobCompetencies;
    this.getReportsPerJob = data.getReportsPerJob;
    this.getBatteriesPerJob = data.getBatteriesPerJob;
    this.getReportsForJob = data.getReportsForJob;
    this.getBatteriesForJob = data.getBatteriesForJob;
    this.getReportsForJob_SC = data.getReportsForJob_SC;
    this.getReportsForJob_ST = data.getReportsForJob_ST;

    this.loadPage();
  }

  loadPage() {
    this.assPage();
  }

  assPage() {
    const getDDCategoryGroup = this.getDDCategoryGroupPerClient;
    const getCompetencyByJob = this.getCompetencyByJob;
    const getBatteriesPerJob = this.getBatteriesPerJob;
    const getBatteriesForJob = this.getBatteriesForJob;
    const getAssessmentsPerJob = this.getAssessmentsPerJob;
    const getAssessmentsPerJobCompetencies = this.getAssessmentsPerJobCompetencies;

    // Build Dropdowns
    // buildDropDownMain(getAssessmentsPerJobCompetencies, 'assName', 'externalSupplierAssessmentID', 'shortname');

    buildDropDownMain(getBatteriesForJob, 'assBatName', 'GAPBAtteryID', 'shortDescription');

    // Section 1: Competencies -----------------------------------------
    if (getCompetencyByJob.length) {
      unhide('assSection');
      hide('noComps');
    } else {
      hide('assSection');
      unhide('noComps');
    }

    // Section 2: Assessments -----------------------------------------
    // id('assBatName').addEventListener('change', () => {
    //     if (id('assBatName').value === '-') {
    //         hide('superV')
    //     } else {
    //         unhide('superV')
    //     }
    // }); //assName

    // id('supervision').addEventListener('change', () => {
    //     if (id('supervision').checked) {
    //         unhide('supervisionOptions')
    //     } else {
    //         hide('supervisionOptions')
    //     }
    // });

    if (getBatteriesPerJob.length) {
      //getAssessmentsPerJob
      for (let row of getBatteriesPerJob) {
        //getAssessmentsPerJob
        const assList = id('assList');
        let div1 = divAtt('div', 'class', 'row');
        div1.style = `align-items: center; flex-direction: row !important; margin-bottom: 0.6rem;`;
        div1.classList.add('com');
        div1.setAttribute('id', `assessment_${row.allocGAPBatteryHjobID}`);
        const div2 = divAtt('div', 'class', '');
        div2.innerHTML = row.shortDescription;
        let remove = divAtt('img', 'class', 'iconSize'); // removeAssessment
        remove.src = trashCanIcon;
        remove.style = `margin-right: 10px; cursor: pointer;`;
        div1.appendChild(remove);
        div1.appendChild(div2);
        assList.appendChild(div1);
        eListen(
          remove,
          () => {
            MJtAss.removeBattery(row.allocGAPBatteryHjobID);
          },
          'click'
        );
      }
    }
  }

  static addAssessment() {
    if (id('assName').value && id('assName').value !== '-') {
      const vars = {};
      vars.externalSupplierAssessmentID = id('assName').value;
      vars.HjobID = pgstr.MJt_ass.HjobID;
      vars.supervisionRequiredYN = toggleSliderYN(id('supervision').checked);
      vars.supervisionType = '';

      if (id('supervision').checked) {
        if (!id('virtual').checked && !id('inPerson').checked) {
          infoBox('Please select type of supervision required.');
          return;
        } else {
          if (id('virtual').checked) {
            vars.supervisionType = 'virtual';
          } else {
            vars.supervisionType = 'inPerson';
          }
        }
      }

      PREP(['allocAssessmentJob'], vars)
        .then(() => {
          changeTabN('MJt_ass');
        })
        .catch(console.error());
    } else {
      infoBox('Please select an Assessment.');
    }
  }

  static removeAssessment(assId) {
    const vars = {};
    vars.externalSupplierAssessmentID = assId;
    vars.HjobID = pgstr.MJt_ass.HjobID;
    PREP(['removeAssessmentJob'], vars)
      .then((res) => {
        note(res.data.removeAssessmentJob);
        changeTabN('MJt_ass');
      })
      .catch(console.error());
  }

  static addBattery() {
    if (id('assBatName').value && id('assBatName').value !== '-') {
      const vars = {};
      vars.GAPBatteryID = id('assBatName').value;
      vars.HjobID = pgstr.MJt_ass.HjobID;

      PREP(['linkGAPBatteryToJob'], vars)
        .then(() => {
          changeTabN('MJt_ass');
        })
        .catch(console.error());
    } else {
      infoBox('Please select an Assessment Battery.');
    }
  }

  static removeBattery(assId) {
    const vars = {};
    vars.allocGAPBatteryHjobID = assId;
    vars.HjobID = pgstr.MJt_ass.HjobID;
    PREP(['removeBatteriesPerJob'], vars)
      .then((res) => {
        note(res.data.removeBatteriesPerJob);
        changeTabN('MJt_ass');
      })
      .catch(console.error());
  }
}

export class MJtReports {
  constructor(vars) {
    this.name = 'Job Reports';
    this.pageTier = 15;
    this.reference = 'MJt_reports';
    this.pageID = null;
    this.data = null;
    this.HclientID = vars.hclientID;
    this.HjobID = vars.HjobID;
  }

  initPage(data) {
    // Set page pecific variables
    this.getDDCategoryGroupPerClient = data.getDDCategoryGroupPerClient;
    this.getCompetencyByJob = data.getCompetencyByJob;
    this.getAssessmentsPerJob = data.getAssessmentsPerJob;
    this.getAssessmentsPerJobCompetencies = data.getAssessmentsPerJobCompetencies;
    this.getReportsPerJob = data.getReportsPerJob;
    this.getReportsForJob = data.getReportsForJob;
    this.getReportsForJob_SC = data.getReportsForJob_SC;
    this.getReportsForJob_ST = data.getReportsForJob_ST;

    this.loadPage();
  }

  loadPage() {
    this.reportsPage();
  }

  reportsPage() {
    const getDDCategoryGroup = this.getDDCategoryGroupPerClient;
    const getCompetencyByJob = this.getCompetencyByJob;
    const getAssessmentsPerJob = this.getAssessmentsPerJob;
    const getAssessmentsPerJobCompetencies = this.getAssessmentsPerJobCompetencies;
    const getReportsForJob = this.getReportsForJob;
    const getReportsPerJob = this.getReportsPerJob;

    // Build Dropdowns
    buildDropDownMain(getReportsForJob, 'genReport', 'HIRID', 'shortname');

    // Section 3: Reports/ Missing competencies -----------------------------------------
    if (this.getReportsForJob_SC === 203) {
      id('reqText').innerHTML = this.getReportsForJob_ST;

      if (this.getReportsForJob.length) {
        for (let row of this.getReportsForJob) {
          const missingList = id('missingList');
          let div1 = divAtt('div', 'class', 'row');
          div1.style = `align-items: center; flex-direction: row !important; margin-bottom: 0.6rem;`;
          div1.classList.add('com');
          const div2 = divAtt('div', 'class', '');
          div2.innerHTML = row.missingCompetency;
          div1.appendChild(div2);
          missingList.appendChild(div1);
        }
      }
      unhide('reqSection');
      hide('allocateSection');
    } else if (getCompetencyByJob.length) {
      if (getReportsPerJob[0].reports.length) {
        const reportList = id('reportList1');
        reportList.innerHTML = ``;

        for (let row of getReportsPerJob[0].reports) {
          let div1 = divAtt('div', 'class', 'row');
          div1.style = `align-items: center;`;
          div1.classList.add('com');
          div1.setAttribute('id', `assessment_${row.HIRID}`);
          const div2 = divAtt('div', 'class', '');
          div2.innerHTML = row.shortname;
          let remove = divAtt('img', 'class', 'iconSize');
          remove.src = trashCanIcon;
          remove.style = `margin-right: 10px; cursor: pointer;`;
          div1.appendChild(remove);
          div1.appendChild(div2);
          reportList.appendChild(div1);
          eListen(
            remove,
            () => {
              this.removeIRJob(row.HIRID);
            },
            'click'
          );
        }
        unhide('reportList');
      }
    } else {
      unhide('noComps');
      hide('allocateSection');
    }

    // Update/Publish status of button
    if (getReportsPerJob[0].publishedYN === 1) {
      id('compAssBtn').innerHTML = `Update`;
    } else {
      id('compAssBtn').innerHTML = `Publish`;
    }
  }

  static removeIRJob(HIRID) {
    const vars = {};
    vars.HjobID = pgstr.MJt_reports.HjobID;
    vars.hirID = HIRID;

    PREP(['removeIRJob'], vars)
      .then((res) => {
        note(res.data.removeIRJob);
        changeTabN('MJt_reports');
      })
      .catch(console.error());
  }

  static allocReport() {
    if (id('genReport').value === '-') {
      return infoBox('Please select a report from the dropdown.');
    }
    const vars = {};
    vars.HIRID = id('genReport').value;
    vars.HjobID = pgstr.MJt_reports.HjobID;
    PREP(['allocIRJob'], vars)
      .then((res) => {
        note(res.data.allocIRJob);
        changeTabN('MJt_reports');
      })
      .catch(console.error());
  }

  static allocateComAss() {
    if (id('reportList1').innerHTML === ``) {
      infoBox('Report is a required field.');
    } else {
      const vars = {};
      vars.HjobID = pgstr.MJt_reports.HjobID;

      PREP(['publishGAPJob'], vars)
        .then((res) => {
          note(res.data.publishGAPJob);
          changeTabN('MJt_reports');
        })
        .catch(console.error());
    }
  }
}

// On/Off job fields > update client settings
export const optionalFieldsObj = {
  GAPDisplayCostCenter: {
    displayDiv: 'GAPDisplayCostCenter',
    input: 'costC',
    input_V: 'costC_V',
    detailDiv: 'costCentre',
  },
  GAPDisplayDivision: {
    displayDiv: 'GAPDisplayDivision',
    input: 'depart',
    input_V: 'depart_V',
    detailDiv: 'businessDivision',
  },
  GAPDisplayJobFamily: {
    displayDiv: 'GAPDisplayJobFamily',
    input: 'job_F',
    input_V: 'job_F_V',
    detailDiv: 'jobfamily',
  },
  GAPDisplayJobFunctionalArea: {
    displayDiv: 'GAPDisplayJobFunctionalArea',
    input: 'funct_A',
    input_V: 'funct_A_V',
    detailDiv: 'funcArea',
  },
  GAPDisplayJobGrade: {
    displayDiv: 'GAPDisplayJobGrade',
    input: 'job_G',
    input_V: 'job_G_V',
    detailDiv: 'jobGrade',
  },
  GAPDisplayJobLevel: {
    displayDiv: 'GAPDisplayJobLevel',
    input: 'job_L',
    input_V: 'job_L_V',
    detailDiv: 'positionLevel',
  },
  GAPDisplayJobPurpose: {
    displayDiv: 'GAPDisplayJobPurpose',
    input: 'job_P',
    input_V: 'job_P_V',
    detailDiv: 'purpose',
  },
  GAPDisplayJobTitle: {
    displayDiv: 'GAPDisplayJobTitle',
    input: 'job_T',
    input_V: 'job_T_V',
    detailDiv: 'jobTitle',
  },
  GAPDisplayLineManager: {
    displayDiv: 'GAPDisplayLineManager',
    input: 'line_M',
    input_V: 'line_M_V',
    detailDiv: 'lineManager',
    email: 'lineEmailDisplay',
    emailDetail: 'lineManagerEmail',
  },
  GAPDisplayRecruiter: {
    displayDiv: 'GAPDisplayRecruiter',
    input: 'recruiter',
    input_V: 'recruiter_V',
    detailDiv: 'recruiter',
    email: 'recruiterEmailDisplay',
    emailDetail: 'recruiterEmail',
  },
  GAPDisplayJobObjectives: {
    displayDiv: 'GAPDisplayJobObjectives',
    input: 'job_O',
    input_V: 'job_O_V',
    detailDiv: 'jobObjectives',
  },
  GAPDisplayHireResource: {
    displayDiv: 'GAPDisplayHireResource',
    input: 'HireResource',
    detailDiv: 'hireResource',
  },
  GAPDisplayAgency: {
    displayDiv: 'GAPDisplayAgency',
    input: 'agency',
    detailDiv: 'agency',
  },
};

//  ========================= REPORTS =============================

export class AddReport {
  constructor() {
    this.name = 'Add Report';
    this.pageTier = 10;
    this.reference = 'addReport';
    this.pageID = null;
    this.HclientID = null;
  }

  initPage() {
    // Set page pecific variables
    this.loadPage();
  }

  loadPage() {
    this.addReportPage();
  }

  addReportPage() {
    if (id('clientDD').value) {
      const vars = {};
      vars.messageEventType = 'Upload report';
      vars.HclientID = id('clientDD').value;

      PREP(['getMessageEvents', 'getAssessmentsPerClient'], vars)
        .then((res) => {
          buildDropDownMain(cObj(res.data.getMessageEvents), 'messageEvent_select', 'MESSAGEEVENTID', 'SHORTNAME');
          buildDropDownMain(cObj(res.data.getAssessmentsPerClient), 'completeAss_select', 'HASSESSMENTID', 'SHORTNAME');

          hide('noDataMsg');
          unhide('editReportContent');
        })
        .catch(console.error());
    } else {
      unhide('noDataMsg');
      hide('editReportContent');
    }
  }

  static addReport() {
    if (!validatePage()) {
      return;
    }

    const vars = {};
    vars.HclientID = id('clientDD').value;
    vars.shortName = id('reportShortname').value;
    vars.description = id('reportDesc').value;
    vars.messageeventID = id('messageEvent_select').value;
    vars.HassessmentID = id('completeAss_select').value == '-' ? '' : id('completeAss_select').value;
    vars.linkToApplicationYN = toggleSliderYN(id('linkToApplication_switch').checked);
    vars.linkToCandidateYN = toggleSliderYN(id('linkToCandidate_switch').checked);
    vars.linkAdditionalServicesYN = toggleSliderYN(id('addService_switch').checked);
    vars.candidateViewYN = toggleSliderYN(id('candidateViewYN_switch').checked);
    vars.clientViewYN = toggleSliderYN(id('clientViewYN_switch').checked);

    PREP(['addReportDets'], vars)
      .then((res) => {
        note(res.data.addReportDets);
        PREP('addReport');
      })
      .catch(console.error());
  }
}

export class ManageReports {
  constructor() {
    this.name = 'Manage Reports';
    this.pageTier = 10;
    this.reference = 'manageReports';
    this.pageID = null;
    this.HclientID = null;
  }

  initPage() {
    // Set page pecific variables
    this.loadPage();
  }

  loadPage() {
    this.listReportsPage();
  }

  listReportsPage() {
    const table = id('reportListBody');
    table.innerHTML = '';

    if (id('clientDD').value == '') {
      hide('ReportList');
      hide('noDataMessage');
    } else {
      PREP(['getReportType'], {
        HclientID: id('clientDD').value,
      }).then((res) => {
        const reports = cObj(res.data.getReportType);
        if (!reports.length) {
          hide('ReportList');
          unhide('noDataMessage');
        } else {
          hide('noDataMessage');
          for (let el of reports) {
            // Report ID
            const tr = document.createElement('tr');
            const elID = divAtt('td', 'class', '');
            elID.innerHTML = el.HREPORTTYPEID;
            //Report Shortname
            const shortname = divAtt('td', 'class', '');
            shortname.innerHTML = el.SHORTNAME;
            // Link Application
            const linkroapplicationYN = divAtt('td', 'class', '');
            const tc1 = el.LINKTOAPPLICATIONYN ? divAtt('img', 'src', `${tickIcon}`) : divAtt('img', 'src', `${greyCross}`);
            linkroapplicationYN.appendChild(tc1);
            //Link to candidate
            const linktocandidateYN = divAtt('td', 'class', '');
            const tc2 = el.LINKTOAPPLICATIONYN ? divAtt('img', 'src', `${tickIcon}`) : divAtt('img', 'src', `${greyCross}`);
            linktocandidateYN.appendChild(tc2);
            // Link Additional services
            const additionalservocesYN = divAtt('td', 'class', '');
            const tc3 = el.ADDITIONALSERVICESYN ? divAtt('img', 'src', `${tickIcon}`) : divAtt('img', 'src', `${greyCross}`);
            additionalservocesYN.appendChild(tc3);
            //Candidate can view
            const candidateCanViewYN = divAtt('td', 'class', '');
            const tc4 = el.CANDIDATECANVIEWYN ? divAtt('img', 'src', `${tickIcon}`) : divAtt('img', 'src', `${greyCross}`);
            candidateCanViewYN.appendChild(tc4);
            // Client can View
            const clientCanViewYN = divAtt('td', 'class', '');
            const tc5 = el.CLIENTCANVIEWYN ? divAtt('img', 'src', `${tickIcon}`) : divAtt('img', 'src', `${greyCross}`);
            clientCanViewYN.appendChild(tc5);
            //View Button
            const button = divAtt('td', 'class', 'button');
            const btn = divAtt('div', 'class', 'btn');
            btn.innerHTML = 'Edit';
            btn.setAttribute('onclick', `PREP('editReports', 'HreportTypeID=${el.HREPORTTYPEID}&HclientID=${id('clientDD').value}')`);
            button.appendChild(btn);

            tr.appendChild(elID);
            tr.appendChild(shortname);
            tr.appendChild(linkroapplicationYN);
            tr.appendChild(linktocandidateYN);
            tr.appendChild(additionalservocesYN);
            tr.appendChild(candidateCanViewYN);
            tr.appendChild(clientCanViewYN);
            tr.appendChild(button);
            table.appendChild(tr);
          }
          unhide('ReportList');
        }
      });
    }
  }
}

export class EditReport {
  constructor(vars) {
    this.name = 'Edit Reports';
    this.pageTier = 10;
    this.reference = 'editReport';
    this.pageID = null;
    this.data = null;
    this.HclientID = vars.HclientID;
    this.messageEventType = vars.messageEventType;
    this.HreportTypeID = vars.HreportTypeID;
  }

  initPage() {
    // Set page pecific variables
    this.loadPage();
  }

  loadPage() {}
}

export class MRtReportHeaders {
  constructor(vars) {
    this.name = 'Edit Report';
    this.pageTier = 15;
    this.reference = 'MRtReportHeaders';
    this.pageID = null;
    this.HclientID = vars.HclientID;
    this.messageEventType = vars.messageEventType;
    this.HreportTypeID = vars.HreportTypeID;
  }

  initPage(data) {
    // Set page pecific data
    this.getMessageEvents = cObj(data.getMessageEvents);
    this.getReportDetails = cObj(data.getReportDetails);
    this.getAssessmentsPerClient = cObj(data.getAssessmentsPerClient);
    this.loadPage();
  }

  loadPage() {
    this.editReportsPage();
  }

  editReportsPage() {
    const data = this.getReportDetails[0];
    const getMessageEvents = this.getMessageEvents;
    const getAssessmentsPerClient = this.getAssessmentsPerClient;

    buildDropDownMain(getMessageEvents, 'messageEvent_select', 'MESSAGEEVENTID', 'SHORTNAME');
    buildDropDownMain(getAssessmentsPerClient, 'completeAss_select', 'HASSESSMENTID', 'SHORTNAME');

    this.HreportTypeID = data.HREPORTTYPEID;
    id('reportShortname').value = data.SHORTNAME;
    id('reportDesc').value = data.DESCRIPTION;
    id('messageEvent_select').value = data.MESSAGEEVENTID ? data.MESSAGEEVENTID : '-';
    id('completeAss_select').value = data.HASSESSMENTID ? data.HASSESSMENTID : '-';
    id('linkToApplication_switch').checked = data.LINKTOAPPLICATIONYN;
    id('linkToCandidate_switch').checked = data.LINKTOCANDIDATEYN;
    id('active_switch').checked = data.ACTIVEYN;
    id('addService_switch').checked = data.ADDITIONALSERVICESYN;
    id('candidateViewYN_switch').checked = toggleSliderYN(data.CANDIDATECANVIEWYN);
    id('clientViewYN_switch').checked = toggleSliderYN(data.CLIENTCANVIEWYN);

    //set edit rules button
    const editRulesBtn = id('editRules');
    editRulesBtn.setAttribute('onclick', `PREP('rar_edit', 'HclientID=${this.HclientID}&HreportTypeID=${this.HreportTypeID}')`);
  }

  static updateReport() {
    const vars = {};
    vars.hreportTypeID = pgstr.MRtReportHeaders.HreportTypeID;
    vars.shortName = id('reportShortname').value;
    vars.description = id('reportDesc').value;
    vars.messageeventID = id('messageEvent_select').value == '-' ? 0 : id('messageEvent_select').value;
    vars.HassessmentID = id('completeAss_select').value == '-' ? 0 : id('completeAss_select').value;
    vars.linkToApplicationYN = toggleSliderYN(id('linkToApplication_switch').checked);
    vars.linkToCandidateYN = toggleSliderYN(id('linkToCandidate_switch').checked);
    vars.linkAdditionalServicesYN = toggleSliderYN(id('addService_switch').checked);
    vars.activeYN = toggleSliderYN(id('active_switch').checked);
    vars.candidateCanViewYN = toggleSliderYN(id('candidateViewYN_switch').checked);
    vars.clientCanViewYN = toggleSliderYN(id('clientViewYN_switch').checked);

    PREP(['updateReportDets'], vars)
      .then((res) => {
        note(res.data.updateReportDets);
      })
      .catch(console.error());
  }
}

export class MRtMsgEvents {
  constructor(vars) {
    this.name = 'Message Events';
    this.pageTier = 15;
    this.reference = 'MRtMsgEvents';
    this.pageID = null;
    this.HclientID = vars.HclientID;
    this.messageEventType = vars.messageEventType;
    this.HreportTypeID = vars.HreportTypeID;
  }

  initPage(data) {
    // Set page pecific data
    this.getReportDetails = cObj(data.getReportDetails);
    this.getMessageEvents = cObj(data.getMessageEvents);
    this.getMessageEventsByReportType = data.getMessageEventsByReportType;
    this.loadPage();
  }

  loadPage() {
    this.msgEventsPage();
  }

  msgEventsPage() {
    const getMessageEvents = this.getMessageEvents;
    buildDropDownMain(getMessageEvents, 'messageEvent_select', 'MESSAGEEVENTID', 'SHORTNAME');

    const data = this.getReportDetails[0];
    const listData = this.getMessageEventsByReportType;

    id('reportName').innerHTML = data.SHORTNAME;
    id('messageEvent_select').value = data.MESSAGEEVENTID ? data.MESSAGEEVENTID : '-';

    //Build Listy list
    const list = id('msgListy');
    list.innerHTML = '';

    if (listData.length) {
      for (const row of listData) {
        const tr = divAtt('tr');
        const td1 = divAtt('td');
        td1.innerHTML = row.shortName;
        const td2 = divAtt('td');
        td2.innerHTML = row.dynamicrecipientListDescription;
        const td3 = divAtt('td');
        const remove = divAtt('span', 'class', 'trash');
        remove.innerHTML = dustbinSVG;
        td3.appendChild(remove);

        tr.appendChild(td1);
        tr.appendChild(td2);
        tr.appendChild(td3);
        list.appendChild(tr);
        eListen(
          remove,
          () => {
            MRtMsgEvents.removeMsgEventToReportTye(row.allocHreportTypeDDroleID);
          },
          'click'
        );
      }
      unhide('listyTable');
    } else {
      hide('listyTable');
    }
  }

  static addMsgEventToReportTye() {
    const vars = {};
    vars.HreportTypeID = id('hreportTypeID').value;
    vars.messageEventID = id('messageEvent_select').value;
    vars.dynamicRecipient = id('dynamicRecipient').value;
    vars.dynamicRecipientText = id('dynamicRecipient').options[id('dynamicRecipient').selectedIndex].text;
    if (vars.messageEventID === '-') {
      return infoBox('Message Event required');
    }
    if (vars.dynamicRecipient == '') {
      return infoBox('Recipient required');
    }
    PREP(['allocMessageEventReportType'], vars)
      .then((res) => {
        note(res.data.allocMessageEventReportType);
        // Refresh the listy list
        changeTabN('MRt_msgEvents');
      })
      .catch(console.error());
  }

  static removeMsgEventToReportTye(elID) {
    const vars = {};
    //vars.allocHreportMessageEventID = elID;
    vars.allocHreportTypeDDroleID = elID;
    PREP(['removeReportMessageEvent'], vars)
      .then((res) => {
        note(res.data.removeReportMessageEvent);
        // Refresh the listy list
        changeTabN('MRt_msgEvents');
      })
      .catch(console.error());
  }
}

export class MRtUserRoles {
  constructor(vars) {
    this.name = 'User Roles';
    this.pageTier = 15;
    this.reference = 'MRtUserRoles';
    this.pageID = null;
    this.HclientID = vars.HclientID;
  }

  initPage(data) {
    // Set page pecific data
    this.getDDroles = cObj(data.getDDroles);
    this.getRoleAllocReport = data.getRoleAllocReport;
    this.loadPage();
  }

  loadPage() {
    this.userRolePage();
  }

  userRolePage() {
    const rolesList = this.getDDroles;
    buildDropDownMain(rolesList, 'userRoleDD', 'DDROLEID', 'DESCRIPTION');

    const listData = this.getRoleAllocReport;
    console.log('getRoleAllocReport', listData);
    // id('reportName').innerHTML = data.SHORTNAME;

    // Build Listy list
    const list = id('msgListy');
    list.innerHTML = '';

    if (listData.length) {
      for (const row of listData) {
        const tr = divAtt('tr');
        const td1 = divAtt('td');
        td1.innerHTML = row.roleName;

        const td3 = divAtt('td');
        const remove = divAtt('span', 'class', 'trash');
        remove.innerHTML = dustbinSVG;
        td3.appendChild(remove);

        tr.appendChild(td1);
        // tr.appendChild(td2);
        tr.appendChild(td3);
        list.appendChild(tr);
        eListen(
          remove,
          () => {
            MRtUserRoles.removeUserRoleToReport(row.allocDDroleHreportTypeID);
          },
          'click'
        );
      }
      unhide('listyTable');
    } else {
      hide('listyTable');
    }
  }

  static addUserRoleToReport() {
    if (id('userRoleDD').value === '-') {
      return infoBox('Pleasse select a User Role.');
    }
    const vars = {};
    vars.DDroleID = id('userRoleDD').value;
    vars.HreporttypeID = id('hreportTypeID').value;

    PREP(['addRoleAllocReport'], vars)
      .then((res) => {
        note(res.data.addRoleAllocReport);
        // Refresh the listy list
        changeTabN('MRt_userRoles');
      })
      .catch(console.error());
  }

  static removeUserRoleToReport(elID) {
    const vars = {};
    vars.allocDDroleHreportTypeID = elID;
    PREP(['rmvRoleAllocReport'], vars)
      .then((res) => {
        note(res.data.rmvRoleAllocReport);
        // Refresh the listy list
        changeTabN('MRt_userRoles');
      })
      .catch(console.error());
  }
}

export class ResourceRegister {
  constructor(vars) {
    this.name = 'Resource Register';
    this.pageTier = 15;
    this.reference = 'resourceRegister';
    this.pageID = null;
    // this.HclientID = vars.HclientID;
  }

  initPage(data) {
    // Set page pecific data
    this.loadPage();
  }

  loadPage() {
    this.resourceRegisterPage();
  }

  async resourceRegisterPage() {
    if (id('clientDD').value) {
      await this.popDD();
      this.buildResourceHead();
      hide('selectClientHeading');
    } else {
      hide('regContent');
      id('resTable').innerHTML = '';
      unhide('selectClientHeading');
    }
  }

  popDD() {
    const vars = {};
    vars.HclientID = id('clientDD').value;
    PREP(['getServiceRequestedDD', 'getServiceStatusDD'], vars)
      .then((res) => {
        buildDropDownMain(res.data.getServiceRequestedDD, 'serviceRDD', 'serviceRequested', 'serviceRequested');
        buildDropDownMain(res.data.getServiceStatusDD, 'serviceStatusDD', 'serviceStatus', 'serviceStatus');
      })
      .catch(console.error());
  }

  buildResourceHead() {
    const table = id('resTable');
    table.innerHTML = '';
    const tBody = divAtt('tBody', 'id', 'resourceListBody');

    const thead = divAtt('thead');
    const th0 = divAtt('th');
    const th1 = divAtt('th');
    const th2 = divAtt('th');
    const th3 = divAtt('th');
    const th4 = divAtt('th');
    const th5 = divAtt('th');
    const th6 = divAtt('th');
    const th7 = divAtt('th');
    const th8 = divAtt('th');
    const th9 = divAtt('th');
    th0.innerHTML = 'Ref Number';
    th1.innerHTML = 'Candidate Name';
    th2.innerHTML = 'Service';
    th3.innerHTML = 'Service Status';
    th4.innerHTML = 'Reschedule Required';
    th5.innerHTML = 'Last Update';
    th6.innerHTML = 'Requested Date';
    th7.innerHTML = 'Booking Date';
    th8.innerHTML = 'Allocated Consultant';
    thead.appendChild(th0);
    thead.appendChild(th1);
    thead.appendChild(th2);
    thead.appendChild(th3);
    thead.appendChild(th4);
    thead.appendChild(th5);
    thead.appendChild(th6);
    thead.appendChild(th7);
    thead.appendChild(th8);
    thead.appendChild(th9);
    table.appendChild(thead);
    table.appendChild(tBody);

    ResourceRegister.getResourceReg();
  }

  static async getResourceReg(displaypage, displayListCount) {
    const vars = {};
    vars.HclientID = id('clientDD').value;
    vars.displaypage = displaypage || 1;
    vars.displayListCount = displayListCount || 50;

    vars.serviceRequested = id('serviceRDD') && id('serviceRDD').value !== '-' ? id('serviceRDD').value : '';
    vars.serviceStatus = id('serviceStatusDD') && id('serviceStatusDD').value !== '-' ? id('serviceStatusDD').value : '';
    hide('pagDiv');

    if (id('clientDD').value) {
      PREP(['getResourceRegisterList'], vars)
        .then((res) => {
          ResourceRegister.buildRegList(res.data.getResourceRegisterList);

          //Pagination ===
          // ResourceRegister.buildRegList(
          //   res.data.getReportUploadRegisterSPI[0].ReturnList
          // );
          // paginate(
          //   res.data.getReportUploadRegisterSPI[0].pagination[0],
          //   "ResourceRegister.getResourceReg"
          // );
        })
        .catch(console.error());
    } else {
      hide('regContent');
      infoBox('Please select a client.');
    }
  }

  static async buildRegList(data) {
    id('resourceListBody').innerHTML = '';

    for (let row of data) {
      const tr = divAtt('tr', 'class', '');
      const tdRFCnum = divAtt('td');
      tdRFCnum.innerHTML = row.RFCNumber;
      tr.appendChild(tdRFCnum);

      const tdName = divAtt('td');
      tdName.innerHTML = row.comboName;
      tr.appendChild(tdName);

      const tdStatus = divAtt('td', 'class', 'emailAddress');
      tdStatus.innerHTML = row.serviceRequested;
      tr.appendChild(tdStatus);

      const tdLastUpdt = divAtt('td', 'class', 'mobileNr');
      tdLastUpdt.innerHTML = row.serviceStatus;
      tr.appendChild(tdLastUpdt);

      const tdReschedule = divAtt('td', 'id', `rescheduleDiv_${row.resourceRegisterID}`);
      tdReschedule.style = 'display: flex; justify-content: center;';
      let checkBox;
      if (row.rescheduleYN) {
        checkBox = divAtt('img', 'src', `${tickIcon}`);
      } else {
        checkBox = await buildTickBox(`reschedule_${row.resourceRegisterID}`, 0);
      }
      tdReschedule.appendChild(checkBox);
      tr.appendChild(tdReschedule);

      const tdUpdateDate = divAtt('td', 'class', 'updatedDate');
      tdUpdateDate.innerHTML = dateFromDateTime(row.lastUpdate);
      tr.appendChild(tdUpdateDate);

      const tdrequestDate = divAtt('td', 'class', 'requestedDate');
      tdrequestDate.innerHTML = dateFromDateTime(row.dateRequested);
      tr.appendChild(tdrequestDate);

      const tdBookingDate = divAtt('td', 'class', 'bookingDate');
      tdBookingDate.innerHTML = row.candidatebookingdate ? dateFromDateTime(row.candidatebookingdate) : '';
      tr.appendChild(tdBookingDate);

      const tdallocFB = divAtt('td', 'class', 'allocFB');
      tdallocFB.innerHTML = row.fbProvider ? row.fbProvider : 'N/A';
      tr.appendChild(tdallocFB);

      const tdlink = divAtt('td');
      tdlink.style = 'display: flex; gap: 0.5rem; max-width: unset;';
      const btn = divAtt('button', 'class', 'btn');
      btn.setAttribute('id', 'updateBoxBtn');
      // btn.setAttribute(
      //   "onclick",
      //   `ResourceRegister.buildUpdateBox(${row.resourceRegisterID})`
      // );
      btn.innerHTML = 'Update';
      tdlink.appendChild(btn);
      // ------------------
      const btn2 = divAtt('button', 'class', 'btn');
      btn2.setAttribute('id', 'resourceHistBtn');
      // btn2.setAttribute(
      //   "onclick",
      //   `ResourceRegister.viewResourceHist(${row.resourceRegisterID})`
      // );
      btn2.innerHTML = 'View';
      tdlink.appendChild(btn2);
      tr.appendChild(tdlink);
      // ------------------
      const btn3 = divAtt('button', 'class', 'btn');
      btn3.setAttribute('id', 'allocFBprovBtn');
      btn3.innerHTML = row.fbProvider ? 'Re-allocate' : 'Allocate';
      tdlink.appendChild(btn3);
      tr.appendChild(tdlink);

      id('resourceListBody').appendChild(tr);

      eListen(
        checkBox,
        () => {
          ResourceRegister.rescheduleWarning(row.resourceRegisterID);
        },
        'change'
      );

      eListen(
        btn,
        () => {
          ResourceRegister.buildUpdateBox(row.resourceRegisterID);
        },
        'click'
      );
      eListen(
        btn2,
        () => {
          ResourceRegister.viewResourceHist(row.resourceRegisterID);
        },
        'click'
      );

      eListen(
        btn3,
        () => {
          ResourceRegister.allocateFBproviderSelect(row.resourceRegisterID);
        },
        'click'
      );

      unhide('regContent');
    }

    unhide('resTable');
  }

  static DDchange() {
    id('clientDD').value && ResourceRegister.getResourceReg();
  }

  static viewResourceHist(reportID, fileName) {
    const vars = {};
    vars.resourceRegisterID = reportID;

    PREP(['getServiceStatusHistory'], vars)
      .then((res) => {
        const resourceHist = res.data.getServiceStatusHistory;
        console.log('resourceHist', resourceHist);

        const div = divAtt('div', 'class', '');

        const table = divAtt('table');
        table.style.margin = '2rem 0';

        const closeBtn = divAtt('button', 'class', 'btn');
        closeBtn.innerHTML = 'Close';
        closeBtn.setAttribute('onclick', `hide('custardBox')`);

        const thead = divAtt('thead');
        const th0 = divAtt('th');
        const th1 = divAtt('th');
        const th2 = divAtt('th');
        const th3 = divAtt('th');
        th0.innerHTML = 'Updated on';
        th1.innerHTML = 'RFC Number';
        th2.innerHTML = 'Updated by';
        th3.innerHTML = 'Service status';
        thead.appendChild(th0);
        thead.appendChild(th1);
        thead.appendChild(th2);
        thead.appendChild(th3);

        const tBody = divAtt('tBody');
        for (let row of resourceHist) {
          const tr = divAtt('tr', 'class', '');
          const date = divAtt('td');
          date.innerHTML = dateFromDateTime(row.updatedOn);
          const status = divAtt('td');
          status.innerHTML = row.RFCNumber;
          const updated = divAtt('td');
          updated.innerHTML = row.comboName;
          const comments = divAtt('td');
          comments.innerHTML = row.serviceStatus; //row.statusDetail;
          tr.appendChild(date);
          tr.appendChild(status);
          tr.appendChild(updated);
          tr.appendChild(comments);
          tBody.appendChild(tr);
        }

        table.appendChild(thead);
        table.appendChild(tBody);

        if (resourceHist.length) {
          div.appendChild(table);
        } else {
          const p = divAtt('p');
          p.innerHTML = 'No history to show.';
          p.style = 'margin-bottom: 1rem;';
          div.appendChild(p);
        }

        div.appendChild(closeBtn);

        custardBox(div, `Resource History`);
      })
      .catch(console.error());
  }

  static buildUpdateBox(resourceRegisterID) {
    const div = divAtt('div', 'id', 'resourceDateDiv');
    // div.classList.add('grid-2col-input');
    div.style = `margin-top: 3rem;`;

    const div1 = divAtt('div');
    div1.style = 'display: flex; justify-content: center;';
    const dateBooking = buildDateInp('bookingDate', 1, 'Booking Date');
    dateBooking.style = 'width: unset;';
    div1.appendChild(dateBooking);

    const div2 = divAtt('div');
    div2.style = 'display: flex; justify-content: center;';
    const selectReason = buildSelectInp('bookingReason', 1, 'Booking Reason');
    selectReason.style = 'width: unset; margin-top: 0.5rem;';
    div2.appendChild(selectReason);

    const cancelBtn = divAtt('button', 'class', 'btnCancel');
    cancelBtn.innerHTML = 'Cancel';
    cancelBtn.setAttribute('onclick', `hide('custardBox')`);
    const btn = divAtt('button', 'class', 'btn');
    btn.innerHTML = `Submit`;
    // btn.setAttribute(
    //   "onclick",
    //   `ResourceRegister.updateResourceReg('${resourceRegisterID}')`
    // );
    const feedback = buildFeedbackBanner('resourceDateDiv');
    div.appendChild(div1);
    div.appendChild(div2);
    div.appendChild(feedback);
    div.appendChild(cancelBtn);
    div.appendChild(btn);

    //custardBox(div, "Update Resource Register");
    eCustardBox(div, 'Update Resource Register', [
      btn,
      () => {
        ResourceRegister.updateResourceReg(resourceRegisterID);
      },
      'click',
    ]);

    const reasons = [{ reason: 'New Booking' }, { reason: 'Reschedule requested' }, { reason: 'Reschedule – No notice' }];
    buildDropDownMain(reasons, 'bookingReason', 'reason', 'reason');
  }

  static updateResourceReg(resourceRegisterID) {
    if (!validateDiv('resourceDateDiv')) {
      return;
    }

    const vars = {};
    vars.bookingDate = id('bookingDate').value;
    vars.bookingReason = id('bookingReason').value;
    vars.resourceRegisterID = resourceRegisterID;

    PREP(['updServiceBookingDate'], vars)
      .then((res) => {
        note(res.data.updServiceBookingDate);
        hide('custardBox');
        ResourceRegister.getResourceReg();
      })
      .catch(console.error());
  }

  static async allocateFBproviderSelect(resourceRegisterID) {
    const vars = {};
    vars.HclientID = id('clientDD').value;

    PREP(['getFeedbackProvider'], vars).then(async (res) => {
      // build pop up with DD and
      const div = divAtt('div', 'class', 'grid-1col-input');
      div.id = 'allocFBproviderDiv';
      div.style = `justify-items: center;`;

      const select = await buildSelectInp('fbProviderDD', 1, 'Reason');
      select.setAttribute('style', 'margin-top: 3rem; width: auto');
      div.appendChild(select);

      const btnDiv = divAtt('div', 'class', 'gridSpan btnCenterGrid width100');
      const btn = divAtt('button', 'class', 'btn');
      btn.innerHTML = `Allocate`;
      const cancelBtn = divAtt('button', 'class', 'btnCancel');
      cancelBtn.innerHTML = 'Cancel';
      cancelBtn.setAttribute('onclick', `hide('custardBox')`);

      btnDiv.appendChild(cancelBtn);
      btnDiv.appendChild(btn);
      div.appendChild(btnDiv);

      eCustardBox(div, 'Allocated Feedback Provider', [
        btn,
        () => {
          ResourceRegister.allocateFBprovider(resourceRegisterID);
        },
        'click',
      ]);

      const fbProvs = res.data.getFeedbackProvider;
      buildDropDownMain(fbProvs, 'fbProviderDD', 'HuserID', 'shortname');
    });
  }

  static async allocateFBprovider(resourceRegisterID) {
    if (id('fbProviderDD').value === '-') {
      id('fbProviderDD').classList.add('incorrect');
      return;
    }

    const vars = {};
    vars.targetUserID = id('fbProviderDD').value;
    vars.resourceRegisterID = resourceRegisterID;

    PREP(['addFeedbackProviderToFeedback'], vars)
      .then((res) => {
        note(res.data.addFeedbackProviderToFeedback);
        hide('custardBox');
        ResourceRegister.getResourceReg();
      })
      .catch(console.error());
  }

  static rescheduleWarning(resourceRegisterID) {
    const checkboxID = `reschedule_${resourceRegisterID}`;

    if (id(checkboxID).checked === false) {
      return;
    } else {
      const msg = 'You are about to mark this service as Reschedule Required. Click <b>Proceed</b> to continue.';
      warningBox(msg, `ResourceRegister.rescheduleConfirmed(${resourceRegisterID})`, 1);
      id(checkboxID).checked = false;

      eListen(
        'infoBoxBtn',
        () => {
          ResourceRegister.rescheduleConfirmed(`${resourceRegisterID}`);
        },
        'click'
      );
    }
  }

  static async rescheduleConfirmed(resourceRegisterID) {
    const vars = {};
    vars.resourceRegisterID = resourceRegisterID;
    vars.HclientID = id('clientDD').value;

    PREP(['rescheduleResourceReg'], vars)
      .then((res) => {
        note(res.data.rescheduleResourceReg);
        ResourceRegister.getResourceReg();

        // note('reschedule dunn');
        // const rescheduleDiv = id(`rescheduleDiv_${resourceRegisterID}`);
        // rescheduleDiv.innerHTML = '';
        // const tick = await divAtt('img', 'src', `${tickIcon}`);
        // rescheduleDiv.appendChild(tick);
      })
      .catch(console.error());
  }
}

export const viewReportRules = {
  viewReportRulesPage() {
    if (id('clientDD').value) {
      viewReportRules.buildRulesHead();

      const vars = {};
      vars.HclientID = id('clientDD').value;

      PREP(['GAPPositionLevel', 'getDDpurposeByClient', 'getDDReportUploadMethod', 'getProjectNameByClient'], vars)
        .then(async (res) => {
          const positionLevel = res.data.GAPPositionLevel;
          const purposeLevel = res.data.getDDpurposeByClient;
          const uploadMeth = res.data.getDDReportUploadMethod;
          const projectName = res.data.getProjectNameByClient;

          //   buildDropDownMain(
          //     purposeLevel,
          //     "purposeDD",
          //     "DDpurposeID",
          //     "description"
          //   );
          buildDropDownMain(positionLevel, 'globalBandDD', 'DDpositionLevelID', 'shortname');

          buildDropDownMain(uploadMeth, 'uploadMethodDD', 'DDReportUploadMethodID', 'methodName');

          buildDropDownMain(projectName, 'projectNameDD', 'projectName', 'projectName');

          viewReportRules.getReportUploadRuleMatrix();

          unhide('rulesContent');
          hide('selectClientHeading');
        })
        .catch(console.error());
    } else {
      hide('rulesContent');
      unhide('selectClientHeading');
    }
  },

  getReportUploadRuleMatrix() {
    const vars = {};
    vars.HclientID = id('clientDD').value;
    vars.DDpositionLevelID = id('globalBandDD').value !== '-' ? id('globalBandDD').value : 0;
    vars.DDReportUploadMethodID = id('uploadMethodDD').value !== '-' ? id('uploadMethodDD').value : 0;
    vars.projectName = id('projectNameDD').value !== '-' ? id('projectNameDD').value : '';

    PREP(['getReportUploadRuleMatrix'], vars)
      .then((res) => {
        viewReportRules.buildReportRuleTable(res.data.getReportUploadRuleMatrix);
      })
      .catch(console.error());
  },

  buildRulesHead() {
    const table = id('rulesTable');
    table.innerHTML = '';
    const tBody = divAtt('tBody', 'id', 'reportListBody');

    const thead = divAtt('thead');
    const th0 = divAtt('th');
    const th1 = divAtt('th');
    const th2 = divAtt('th');
    const th3 = divAtt('th');
    const th4 = divAtt('th');
    th0.innerHTML = 'Global Band';
    th1.innerHTML = 'Battery Name';
    th2.innerHTML = 'Report Type';
    th3.innerHTML = 'Upload Method';
    th4.innerHTML = 'Project Name';
    thead.appendChild(th0);
    thead.appendChild(th1);
    thead.appendChild(th2);
    thead.appendChild(th3);
    thead.appendChild(th4);
    table.appendChild(thead);
    table.appendChild(tBody);
  },

  async buildReportRuleTable(data) {
    id('reportListBody').innerHTML = '';
    for (let row of data) {
      const tr = divAtt('tr');
      const globalBand = divAtt('td');
      globalBand.innerHTML = row.positionLevelDesc;
      tr.appendChild(globalBand);

      const batteryName = divAtt('td');
      batteryName.innerHTML = row.batteryName;
      tr.appendChild(batteryName);

      const reportType = divAtt('td');
      reportType.innerHTML = row.reportKey;
      tr.appendChild(reportType);

      const methodName = divAtt('td');
      methodName.innerHTML = row.methodName;
      tr.appendChild(methodName);

      const projectName = divAtt('td');
      projectName.innerHTML = row.projectName;
      tr.appendChild(projectName);

      id('reportListBody').appendChild(tr);
      unhide('rulesContent');
    }

    unhide('rulesTable');
  },

  DDchange() {
    id('clientDD').value && viewReportRules.getReportUploadRuleMatrix();
  },
};

export const editReportRules = {
  editReportRulesPage(data, vars) {
    id('HreportTypeID').value = vars.HreportTypeID;

    console.log('vars', vars);
    const positionLevel = data.GAPPositionLevel;
    const purposeLevel = data.getDDpurposeByClient;
    const uploadMeth = data.getDDReportUploadMethod;

    buildDropDownMain(purposeLevel, 'purposeDD', 'DDpurposeID', 'description');
    buildDropDownMain(positionLevel, 'globalBandDD', 'DDpositionLevelID', 'shortname');

    buildDropDownMain(uploadMeth, 'uploadMethodDD', 'DDReportUploadMethodID', 'methodName');
  },
  DDchange() {
    const globalBandDD = id('globalBandDD').value;
    const purposeDD = id('purposeDD').value;

    if (purposeDD && purposeDD !== '-' && globalBandDD && globalBandDD !== '-') {
      const vars = {};
      vars.DDpositionLevelID = globalBandDD;
      vars.DDpurposeID = purposeDD;
      vars.HclientID = id('clientDD').value;
      vars.HreportTypeID = id('HreportTypeID').value;

      PREP(['getBatteryNameList'], vars)
        .then((res) => {
          const data = res.data.getBatteryNameList;
          buildDropDownMain(data, 'batteryNameDD', 'allocUploadMethodHreportTypeID', 'batteryName');
          unhide('batDiv');
        })
        .catch(console.error());
    } else {
      hide('batDiv');
      hide('uploadDiv');
    }
  },
  DDchange2() {
    const batteryNameDD = id('batteryNameDD').value;
    const globalBandDD = id('globalBandDD').value;
    const purposeDD = id('purposeDD').value;

    if (batteryNameDD && batteryNameDD !== '-') {
      const vars = {};
      vars.DDpositionLevelID = globalBandDD;
      vars.DDpurposeID = purposeDD;
      vars.HclientID = id('clientDD').value;
      vars.HreportTypeID = id('HreportTypeID').value;

      PREP(['getBatteryNameList'], vars)
        .then((res) => {
          const data = res.data.getBatteryNameList;

          data.forEach((opt) => {
            if (opt.allocUploadMethodHreportTypeID == batteryNameDD) {
              id('currentSelection').innerHTML = opt.methodName;
            }
          });

          unhide('uploadDiv');
        })
        .catch(console.error());

      // id('currentSelectioin').innerHTML = '';
    } else {
      hide('uploadDiv');
    }
  },
  updateRules() {
    if (!validatePage()) {
      return;
    }

    const vars = {};
    vars.HclientID = id('clientDD').value;
    vars.allocUploadMethodHreportTypeID = id('batteryNameDD').value;
    vars.DDReportUploadMethodID = id('uploadMethodDD').value;

    PREP(['updReportUploadMethod'], vars)
      .then((res) => {
        note(res.data.updReportUploadMethod);
      })
      .catch(console.error());
  },
};

export const adminReporting = {
  currState: {},
  infoType: 'appStatusInfo',
  langObj: {},

  buildAppStatus: async (langData) => {
    if (id('clientDD').value) {
      // set translations
      for (let row of langData) {
        adminReporting.langObj[row.marker] = row.display;
      }

      hide('selectClient');
      id('appStatusTable').innerHTML = '';
      const vars = {};
      vars.monthsPrevious = 1;
      vars.HclientID = id('clientDD').value;
      vars.displaypage = 1;
      vars.displayListCount = 25;
      PREP(['getDDApplicatonStatus', 'getDDRestrictedlegalEntity', 'getDDMonths', 'repList_arep_appstatus', 'repGraph_arep_appstatus'], vars)
        .then((res) => {
          const statusData = res.data.getDDApplicatonStatus;
          const monthData = res.data.getDDMonths;
          const legalData = cObj(res.data.getDDRestrictedlegalEntity);
          adminReporting.buildCP(statusData, monthData, legalData);
          adminReporting.buildData(res);
          unhide('buildAppStatus');
          unhide('blockTabs');
          adminReporting.currState = vars;

          //set tab onclicks
          eListen(
            'appStatusInfo',
            () => {
              adminReporting.tabChange('appStatusInfo');
            },
            'click'
          );

          eListen(
            'addServInfo',
            () => {
              adminReporting.tabChange('addServInfo');
            },
            'click'
          );
        })
        .catch(console.error());
    } else {
      id('appStatusTable').innerHTML = '';
      unhide('selectClient');
      hide('buildAppStatus');
      hide('blockTabs');
    }
  },
  buildData: (res, filterYN) => {
    const rawAppData = res.data.repGraph_arep_appstatus[0].ReturnList;
    const rawTableData = res.data.repList_arep_appstatus;
    const chartData = {};
    chartData.labels = [];
    chartData.rows = [];
    chartData.status = {};

    if (rawAppData[0]) {
      for (let row of rawAppData) {
        chartData.labels.push(row.status);
        chartData.rows.push(row.ccnt);
        chartData.status[row.status] = row.DDapplicationStatusID;
      }
    }

    adminReporting.buildGraph(chartData, filterYN || '');
    adminReporting.buildAppList(rawTableData);
    unhide('dataGraphDiv');
  },
  buildCP: async (statusData, monthData, legalData) => {
    const buildAppStatus = id('buildAppStatus');
    buildAppStatus.innerHTML = '';
    const h0 = divAtt('h3');
    const h1 = divAtt('h4', 'class', 'secondColor');
    const h2 = divAtt('h4', 'class', 'secondColor');
    const h3 = divAtt('h4', 'class', 'secondColor');
    const div1 = divAtt('div');
    const gridDiv1 = divAtt('div', 'class', 'controlPanelGrid');
    const div2 = divAtt('div', 'class', 'sectionGap');
    const gridDiv2 = divAtt('div', 'class', 'controlPanelGrid');
    gridDiv2.setAttribute('id', 'dateControl');
    const div3 = divAtt('div', 'class', 'sectionGap');
    const gridDiv3 = divAtt('div', 'class', '');
    gridDiv3.setAttribute('id', 'legalControl');
    h0.innerHTML = adminReporting.langObj.ras_Mkr2 || 'Control Panel';
    h1.innerHTML = adminReporting.langObj.ras_Mkr3 || 'Status';
    h2.innerHTML = adminReporting.langObj.ras_Mkr4 || 'Date';
    h3.innerHTML = adminReporting.langObj.ras_Mkr7 || 'Legal Entity';
    div1.appendChild(h1);
    div2.appendChild(h2);
    div3.appendChild(h3);

    const monthSlider = divAtt('div', 'class', 'rating');
    const descriptionMonths = document.createElement('p');
    descriptionMonths.innerHTML = adminReporting.langObj.ras_Mkr6 || 'Number of months';

    const steps = divAtt('div', 'class', 'ratingSteps1');
    let elems = [];
    for (let i = 1; i <= 12; i++) {
      const line = divAtt('div', 'class', `ratingLine ratingLine_${i}`);
      line.setAttribute('id', `line_${i}`);
      const sliderItem = divAtt('label', 'class', `ratingItem rating_${i}`);
      sliderItem.setAttribute('id', `dot_${i}`);
      sliderItem.innerHTML = i;
      sliderItem.setAttribute('for', `${i}`);
      steps.appendChild(sliderItem);
      elems.push([sliderItem, i]);
      // sliderItem.setAttribute(
      //   "onclick",
      //   `adminReporting.updateDateControl(${i})`
      // );
      if (i != 12) {
        steps.appendChild(line);
      }
    }
    monthSlider.appendChild(descriptionMonths);
    monthSlider.appendChild(steps);
    div2.appendChild(monthSlider);
    let statusIds = [];
    let countID = 0;
    for (let row of statusData) {
      let elID = 'adminReportingStatus' + countID;
      statusIds.push(elID);
      const tgl = await buildTgl(`cntrlStatus`, row.DDapplicationStatusID, false, 'adminReporting.updateChart()', row.shortdescription, elID);
      gridDiv1.appendChild(tgl);
      countID++;
    }
    //------------------------------
    let dateIds = [];
    countID = 0;
    for (let row of monthData) {
      let elID = 'adminReportingDate' + countID;
      dateIds.push(elID);
      const tgl = await buildTgl(`cntrlDate`, row.MonthValue, false, 'adminReporting.updateChart()', row.monthDisplay, elID);
      gridDiv2.appendChild(tgl);
      countID++;
    }
    //------------------------------
    // LEGAL ENTITY SECTION
    // let legalIds = [];
    // let EcountID = 0;
    // for (let row of legalData) {
    //   let elID = 'adminReportingEntity' + EcountID;
    //   legalIds.push(elID);
    //   const tgl = await buildTgl(`cntrlEntity`, row.DDLEGALENTITYID, false, 'adminReporting.updateChart()', row.DISPLAYNAME, elID);
    //   gridDiv3.appendChild(tgl);
    //   EcountID++;
    // };

    const legalEntDDHTML = `<div class="inptAddBtnDiv">
        <div class="group" style="width: auto;">
          <select id="legalEntDD" name="legalEntDD"></select>
          <span class="bar"></span>
          <p id="legalEntDD_FB" class="inpFB hide"></p>
        </div>
        <div >
          <button id="addLE" class="subBtn">
            <img src="plus_icon.svg" alt="add new" />
          </button>
        </div>
      </div>
      
      <div id="legFilters" class="legFilters"></div>`;
    gridDiv3.innerHTML = legalEntDDHTML;

    //------------------------------
    div1.appendChild(gridDiv1);
    div2.appendChild(gridDiv2);
    div3.appendChild(gridDiv3);
    buildAppStatus.appendChild(h0);
    buildAppStatus.appendChild(div1);
    buildAppStatus.appendChild(div2);
    buildAppStatus.appendChild(div3);

    //Legal Ents actions --
    // const legalEnts = await assStatusReport.getUserGroups();
    buildDropDownMain(legalData, 'legalEntDD', 'DDLEGALENTITYID', 'DISPLAYNAME');
    eListen(
      'addLE',
      () => {
        adminReporting.legalEntFilter();
      },
      'click'
    );

    for (let i = 0; i < elems.length; i++) {
      eListen(
        elems[i][0],
        () => {
          adminReporting.updateDateControl(elems[i][1]);
        },
        'click'
      );
    }
    for (let i = 0; i < statusIds.length; i++) {
      eListen(
        statusIds[i],
        () => {
          adminReporting.updateChart();
        },
        'change'
      );
    }
    for (let i = 0; i < dateIds.length; i++) {
      eListen(
        dateIds[i],
        () => {
          adminReporting.updateChart();
        },
        'change'
      );
    }
    // for (let i = 0; i < legalIds.length; i++) {
    //   eListen(
    //     legalIds[i],
    //     () => {
    //       adminReporting.updateChart();
    //     },
    //     'change'
    //   );
    // }
    adminReporting.colorSlider(1);
  },
  legalEntFilter: async (elID) => {
    if (elID) {
      const tagEl = id(elID);
      id('legFilters').removeChild(tagEl);
    } else {
      //built tag here
      const legDD = id('legalEntDD');
      const selectedOption = legDD.options[legDD.selectedIndex];
      const selectedText = selectedOption.textContent;
      const tagEl = legDD.value;
      let repeat = false;

      if (!tagEl || tagEl === '-') {
        const erMsg = adminReporting.langObj.ras_Mkr28 || 'Please select a Legal Entity';
        return errBox(erMsg);
      }

      const childElements = id('legFilters').querySelectorAll('*');
      if (childElements.length) {
        childElements.forEach((element) => {
          if (element.id === tagEl) {
            repeat = true;
            const errMsg = adminReporting.langObj.ras_Mkr29 || 'Legal Entity already added';
            errBox(errMsg);
          }
        });
      }

      if (repeat) {
        return;
      }

      // @steph x styling
      const tag = divAtt('div', 'class', 'filterTag');
      tag.id = tagEl;
      tag.innerHTML = `${selectedText} ${crossSVG}`;
      id('legFilters').appendChild(tag);

      //add elisten to tag
      eListen(
        tag,
        () => {
          adminReporting.legalEntFilter(`${tagEl}`);
        },
        'click'
      );
    }
    adminReporting.updateChart();
  },
  updateDateControl: (monthNum) => {
    const gridDiv2 = id('dateControl');
    const vars = {};
    vars.monthsPrevious = monthNum; // id('monthSelect').value;
    vars.HclientID = id('clientDD').value;

    PREP(['getDDMonths'], vars)
      .then(async (res) => {
        gridDiv2.innerHTML = '';
        const monthData = res.data.getDDMonths;
        let elems1 = [];
        let countID = 0;
        for (let row of monthData) {
          let elID = 'cntrlDate' + countID;
          elems1.push(elID);
          const tgl = await buildTgl(`cntrlDate`, row.MonthValue, false, 'adminReporting.updateChart()', row.monthDisplay, elID);
          gridDiv2.appendChild(tgl);
          countID++;
        }
        for (let i = 0; i < elems1.length; i++) {
          eListen(
            elems1[i],
            () => {
              adminReporting.updateChart();
            },
            'change'
          );
        }
        adminReporting.updateChart(monthNum);
        adminReporting.colorSlider(monthNum);
      })
      .catch(console.error());
  },
  updateChart: (monthNum, infoBlock) => {
    const cntrlStatus = document.querySelectorAll('.cntrlStatus');
    const cntrlDate = document.querySelectorAll('.cntrlDate');
    const monthsPrev = document.querySelectorAll('.ratingItem');
    // const legalEnts = document.querySelectorAll('.cntrlEntity');
    const legalEnts = document.querySelectorAll('.filterTag');

    const statusList = [];
    const monthList = [];
    const legalList = [];

    if (!monthNum) {
      monthsPrev.forEach((toggle) => {
        if (toggle.classList.contains('ratingActive')) {
          monthNum = toggle.id.split('_')[1];
        }
      });
    }

    cntrlStatus.forEach((toggle) => {
      if (toggle.checked) {
        statusList.push(toggle.value);
      }
    });

    cntrlDate.forEach((toggle) => {
      if (toggle.checked) {
        monthList.push(toggle.value);
      }
    });

    // legalEnts.forEach((toggle) => {
    //   if (toggle.checked) {
    //     legalList.push(toggle.value);
    //   }
    // });

    legalEnts.forEach((tag) => {
      legalList.push(`${tag.id}`);
    });

    adminReporting.buildAppStatusData(statusList, monthList, monthNum, legalList);
  },
  buildAppStatusData: (statusList, monthList, monthNum, legalList) => {
    const vars = {};
    vars.HclientID = id('clientDD').value;
    monthList.length && (vars.monthList = monthList.join(','));
    statusList.length && (vars.statusList = statusList.join(','));
    legalList.length && (vars.legalList = legalList.join(','));
    vars.displaypage = 1;
    vars.displayListCount = 25;
    vars.monthsPrevious = monthNum; //id('monthSelect').value;

    let filteredYN = false;
    statusList.length && (filteredYN = true);
    legalList.length && (filteredYN = true);

    //here i thinnk
    let methods;
    const statusMethods = ['repList_arep_appstatus', 'repGraph_arep_appstatus'];
    const addServMethods = ['repList_arep_addservices', 'repGraph_arep_addservices'];
    if (adminReporting.infoType === 'appStatusInfo') {
      methods = statusMethods;
    } else if (adminReporting.infoType === 'addServInfo') {
      methods = addServMethods;
    }

    PREP(methods, vars)
      .then((res) => {
        if (adminReporting.infoType === 'appStatusInfo') {
          adminReporting.buildData(res, filteredYN);
        } else if (adminReporting.infoType === 'addServInfo') {
          adminReporting.buildDataAS(res, filteredYN);
        }
        // adminReporting.buildData(res, filteredYN);
        adminReporting.currState = vars;
        unhide('dataGraphDiv');
      })
      .catch(console.error());
  },
  navTablePag: (pageNr) => {
    const cntrlStatus = document.querySelectorAll('.cntrlStatus');
    const cntrlDate = document.querySelectorAll('.cntrlDate');
    const monthsPrev = document.querySelectorAll('.ratingItem');
    const statusList = [];
    const monthList = [];
    let monthNum = 0;

    monthsPrev.forEach((toggle) => {
      if (toggle.classList.contains('ratingActive')) {
        monthNum = toggle.id.split('_')[1];
      }
    });

    cntrlStatus.forEach((toggle) => {
      if (toggle.checked) {
        statusList.push(toggle.value);
      }
    });

    cntrlDate.forEach((toggle) => {
      if (toggle.checked) {
        monthList.push(toggle.value);
      }
    });

    const vars = {};
    vars.HclientID = id('clientDD').value;
    monthList.length && (vars.monthList = monthList.join(','));
    statusList.length && (vars.statusList = statusList.join(','));
    vars.displaypage = parseInt(pageNr) || 1;
    vars.displayListCount = 25;
    vars.monthsPrevious = monthNum;
    PREP(['repList_arep_appstatus'], vars)
      .then((res) => {
        const rawTableData = res.data.repList_arep_appstatus;
        adminReporting.buildAppList(rawTableData);
        adminReporting.currState = vars;
      })
      .catch(console.error());
  },
  buildGraph: (dataMap, filterY) => {
    const pageDiv = id('appChart');
    const intervals = filterY ? 20 : 200;
    pageDiv.innerHTML = '';

    if (dataMap.rows.length) {
      const canvas = divAtt('canvas', 'id', 'chartCanvas');
      pageDiv.appendChild(canvas);
      const ctx = document.getElementById('chartCanvas').getContext('2d');

      const style = getComputedStyle(document.body);
      const primCol = style.getPropertyValue('--primaryColor');
      const secCol = style.getPropertyValue('--secondaryColor');
      const thirdCol = style.getPropertyValue('--thirdColor');
      const fourthCol = style.getPropertyValue('--fourthColour');
      const myChart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: dataMap.labels,
          datasets: [
            {
              barPercentage: 0.5,
              barThickness: 80,
              maxBarThickness: 100,
              minBarLength: 20,
              label: 'Count',
              data: dataMap.rows,
              backgroundColor: [primCol, secCol, thirdCol, fourthCol],
              borderColor: [primCol, secCol, thirdCol, fourthCol],
              borderWidth: 1,
            },
          ],
        },
        options: {
          onClick: (e) => {
            const canvasPosition = Chart.helpers.getRelativePosition(e, myChart);
            const dataX = myChart.scales.x.getValueForPixel(canvasPosition.x);
            const label = myChart.data.labels[dataX];
            const statusID = dataMap.status[label];
            const cntrlTgl = document.querySelectorAll('.cntrlStatus');
            cntrlTgl.forEach((tgl) => {
              if (tgl.value == statusID) {
                tgl.checked = true;
              } else {
                tgl.checked = false;
              }
            });
            adminReporting.updateChart();
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                stepSize: intervals,
              },
            },
          },
          plugins: {
            legend: {
              display: false,
            },
          },
        },
      });
    } else {
      pageDiv.innerHTML = adminReporting.langObj.ras_Mkr10 || 'No Data To Display';
    }
  },
  buildAppList: (data) => {
    const userList = data[0].ReturnList;
    const pagin = data[0].pagination;
    const table = id('appStatusTable');
    let callback = (p1, p2) => {
      adminReporting.navTablePag(p1, p2);
    };
    table.innerHTML = '';
    if (userList.length) {
      const thead1 = document.createElement('thead');
      const th1 = document.createElement('th');
      const th2 = document.createElement('th');
      const th3 = document.createElement('th');
      const th4 = document.createElement('th');
      const th5 = document.createElement('th');
      const th6 = document.createElement('th');
      const th7 = document.createElement('th');
      const th8 = document.createElement('th');
      th1.innerHTML = adminReporting.langObj.ras_Mkr16 || 'RFCNumber';
      th2.innerHTML = adminReporting.langObj.ras_Mkr17 || 'Job ID';
      th3.innerHTML = adminReporting.langObj.ras_Mkr18 || 'Applicant';
      th4.innerHTML = adminReporting.langObj.ras_Mkr19 || 'Job Title';
      th5.innerHTML = adminReporting.langObj.ras_Mkr20 || 'Band';
      th6.innerHTML = adminReporting.langObj.ras_Mkr21 || 'Line Manager';
      th7.innerHTML = adminReporting.langObj.ras_Mkr22 || 'Status';
      th8.innerHTML = '';
      thead1.appendChild(th1);
      thead1.appendChild(th2);
      thead1.appendChild(th3);
      thead1.appendChild(th4);
      thead1.appendChild(th5);
      thead1.appendChild(th6);
      thead1.appendChild(th7);
      thead1.appendChild(th8);
      table.appendChild(thead1);

      if (userList[0] && userList[0].HapplicationID !== '') {
        for (let row of userList) {
          const tr = document.createElement('tr');
          const status = document.createElement('td');
          status.innerHTML = row.status;

          const applicant = document.createElement('td');
          applicant.innerHTML = `${row.candidateFname} ${row.candidatesname}`;

          const rfcNumber = document.createElement('td');
          rfcNumber.innerHTML = row.RFCNumber;

          const jobTitle = document.createElement('td');
          jobTitle.innerHTML = row.clientjobTitle;

          const lineManager = document.createElement('td');
          lineManager.innerHTML = `${row.lineManagerfname} ${row.linemanagerSname}`;

          const jobID = document.createElement('td');
          jobID.innerHTML = row.HjobID ? row.HjobID : '';

          const band = document.createElement('td');
          band.innerHTML = row.band;

          const viewbtn = divAtt('a', 'href', '#');
          const view = document.createElement('td');
          viewbtn.setAttribute('class', 'btn viewMail');
          viewbtn.setAttribute('onclick', `PREP("viewAppDetails", "HAPPLICATIONID=${row.HapplicationID}")`);
          viewbtn.id = `appID_${row.HapplicationID}`;
          viewbtn.innerHTML = adminReporting.langObj.ras_Mkr23 || 'View';
          view.appendChild(viewbtn);

          tr.appendChild(rfcNumber);
          tr.appendChild(jobID);
          tr.appendChild(applicant);
          tr.appendChild(jobTitle);
          tr.appendChild(band);
          tr.appendChild(lineManager);
          tr.appendChild(status);
          tr.appendChild(view);
          table.appendChild(tr);
        }
      } else {
        const tr = document.createElement('tr');
        const noData = document.createElement('td');
        noData.setAttribute('colspan', '8');
        noData.innerHTML = adminReporting.langObj.ras_Mkr10 || 'No data to display';
        tr.appendChild(noData);
        table.appendChild(tr);
      }
    }
    pagination(pagin[0], callback);
  },
  exportData: () => {
    // console.log('custard Box:  Please note that this export will include all data displayed in the above graph. Do you wish to proceed?');

    const div = divAtt('div', 'class', '');
    const p = divAtt('p', 'class', 'marginTop marginBottom');
    p.innerHTML = adminReporting.langObj.ras_Mkr25 || 'Please note that this export will include all data displayed in the above graph. <br> Do you wish to proceed?';
    const cancelBtn = divAtt('button', 'class', 'btnCancel');
    cancelBtn.innerHTML = adminReporting.langObj.ras_Mkr26 || 'Cancel';
    cancelBtn.setAttribute('onclick', `hide('custardBox')`);
    const btn = divAtt('button', 'class', 'btn');
    btn.innerHTML = adminReporting.langObj.ras_Mkr27 || 'Proceed';
    //btn.setAttribute("onclick", `adminReporting.confirmExportData()`);

    div.appendChild(p);
    div.appendChild(cancelBtn);
    div.appendChild(btn);

    // custardBox(div, "Export Data");
    const heading = adminReporting.langObj.ras_Mkr24 || 'Export Data';
    eCustardBox(div, heading, [
      btn,
      () => {
        adminReporting.confirmExportData();
      },
      'click',
    ]);
  },
  confirmExportData: () => {
    const vars = adminReporting.currState;
    PREP([mFile('repList_arep_appstatus_ssheet', `application_status`)], vars)
      .then((res) => {
        res.data.repList_arep_appstatus_ssheet && note('File Downloaded.');
      })
      .catch(console.error());

    hide('custardBox');
  },
  colorSlider(monthNum) {
    // DOT
    const ratingNums = document.querySelectorAll(`.ratingItem`);
    ratingNums.forEach((ratingNum) => {
      const rating = ratingNum.id.split('_');
      if (parseInt(rating[1]) <= parseInt(monthNum)) {
        ratingNum.classList.add('ratingActive');
      } else {
        ratingNum.classList.remove('ratingActive');
      }
    });

    // LINE
    const ratingLines = document.querySelectorAll(`.ratingLine`);
    ratingLines.forEach((ratingLine) => {
      const line = ratingLine.id.split('_');
      if (parseInt(line[1]) < parseInt(monthNum)) {
        ratingLine.classList.add('ratingActive');
      } else {
        ratingLine.classList.remove('ratingActive');
      }
    });
  },
  tabChange: (block) => {
    // block active
    const blocks = document.querySelectorAll('.blockItem');
    blocks.forEach((block) => {
      block.classList.remove('blockActive');
    });
    id(block).classList.add('blockActive');

    adminReporting.infoType = block;
    adminReporting.updateChart();
  },
  buildDataAS: (res, filterYN) => {
    const rawAppData = res.data.repGraph_arep_addservices[0].ReturnList;
    const rawTableData = res.data.repList_arep_addservices;
    const chartData = {};
    chartData.labels = [];
    chartData.rows = [];
    chartData.status = {};

    if (rawAppData[0]) {
      for (let row of rawAppData) {
        const labelName = `${row.status} - ${row.additionalService}`;
        chartData.labels.push(labelName);
        chartData.rows.push(row.ccnt);
        chartData.status[row.status] = row.additionalServicesID;
      }
    }

    adminReporting.buildGraph(chartData, filterYN || '');
    adminReporting.buildAppList(rawTableData);
    unhide('dataGraphDiv');
  },
};

export const assStatusReport = {
  currState: {},
  page: () => {
    if (id('clientDD').value) {
      hide('selectClient');
      id('assStatusTable').innerHTML = '';
      const vars = {};
      vars.monthsPrevious = 6;
      vars.HclientID = id('clientDD').value;
      vars.displaypage = 1;
      vars.displayListCount = 25;
      PREP(['getAssessmentsDD', 'getDDMonths', 'repGraph_arep_assStatus', 'repList_arep_assStatus', 'repGraph_control_assStatus'], vars)
        .then((res) => {
          const getAssessmentsDD = cObj(res.data.getAssessmentsDD);
          const assStatus = res.data.repGraph_control_assStatus;
          const monthData = res.data.getDDMonths;
          assStatusReport.buildCP(getAssessmentsDD, monthData, assStatus);
          assStatusReport.buildData(res);
          assStatusReport.currState = vars;

          unhide('buildAssStatus');
        })
        .catch(console.error());
    } else {
      id('assStatusTable').innerHTML = '';
      unhide('selectClient');
      hide('buildAssStatus');
    }
  },
  buildCP: async (getAssessmentsDD, monthData, assStatus) => {
    const buildAppStatus = id('buildAssStatus');
    buildAppStatus.innerHTML = '';
    const h0 = divAtt('h3');
    const h1 = divAtt('h4', 'class', 'secondColor');
    const h2 = divAtt('h4', 'class', 'secondColor');
    const h3 = divAtt('h4', 'class', 'secondColor');
    const h4 = divAtt('h4', 'class', 'secondColor');
    const div1 = divAtt('div');
    const gridDiv1 = divAtt('div', 'class', 'controlPanelGrid');
    const div2 = divAtt('div', 'class', 'sectionGap');
    const gridDiv2 = divAtt('div', 'class', 'controlPanelGrid');
    gridDiv2.setAttribute('id', 'dateControl');
    const div3 = divAtt('div', 'class', 'sectionGap');
    const gridDiv3 = divAtt('div', 'class', 'controlPanelGrid');
    const div4 = divAtt('div', 'class', 'sectionGap');
    const gridDiv4 = divAtt('div');
    // gridDiv3.setAttribute('id', 'statusSelect')
    h0.innerHTML = 'Control Panel';
    h1.innerHTML = 'Assessment';
    h2.innerHTML = 'Date';
    h3.innerHTML = 'Status';
    h4.innerHTML = 'User Groups';
    div1.appendChild(h1);
    div2.appendChild(h2);
    div3.appendChild(h3);
    div4.appendChild(h4);

    const monthSlider = divAtt('div', 'class', 'rating');
    const descriptionMonths = document.createElement('p');
    descriptionMonths.innerHTML = 'Number of months';
    let elems = [];
    const steps = divAtt('div', 'class', 'ratingSteps1');
    for (let i = 1; i <= 12; i++) {
      const line = divAtt('div', 'class', `ratingLine ratingLine_${i}`);
      line.setAttribute('id', `line_${i}`);

      const sliderItem = divAtt('label', 'class', `ratingItem rating_${i}`);
      sliderItem.setAttribute('id', `dot_${i}`);
      sliderItem.innerHTML = i;
      sliderItem.setAttribute('for', `${i}`);
      elems.push([sliderItem, i]);
      // sliderItem.setAttribute(
      //   "onclick",
      //   `assStatusReport.updateDateControl(${i})`
      // );

      steps.appendChild(sliderItem);
      if (i != 12) {
        steps.appendChild(line);
      }
    }
    monthSlider.appendChild(descriptionMonths);
    monthSlider.appendChild(steps);
    div2.appendChild(monthSlider);
    let elems1 = [];
    let countID = 0;
    for (let row of assStatus) {
      let elID = 'statusList' + countID;
      elems1.push(elID);
      const tgl = await buildTgl('statusList', row.DDassessmentStatusID, true, 'assStatusReport.updateChart()', row.status, elID);
      gridDiv3.appendChild(tgl);
      countID++;
    }
    let elems2 = [];
    countID = 0;
    for (let row of getAssessmentsDD) {
      let elID = 'cntrlStatus' + countID;
      elems2.push(elID);
      const tgl = await buildTgl(`cntrlStatus`, row.HASSESSMENTID, false, 'assStatusReport.updateChart()', row.SHORTNAME, elID);
      gridDiv1.appendChild(tgl);
      countID++;
    }
    let elems3 = [];
    countID = 0;
    for (let row of monthData) {
      let elID = 'cntrlDate' + countID;
      elems3.push(elID);
      const tgl = await buildTgl(`cntrlDate`, row.MonthValue, false, 'assStatusReport.updateChart()', row.monthDisplay, elID);
      gridDiv2.appendChild(tgl);
      countID++;
    }

    // @steph
    const userGroupDDHTML = `<div class="inptAddBtnDiv">
        <div class="group" style="width: auto;">
          <select id="userGroupDD" name="userGroupDD"></select>
          <span class="bar"></span>
          <p id="userGroupDD_FB" class="inpFB hide"></p>
        </div>
        <div >
          <button id="addUG" class="subBtn">
            <img src="plus_icon.svg" alt="add new" />
          </button>
        </div>
      </div>
      
      <div id="ugFilters" class="ugFilters"></div>`;
    gridDiv4.innerHTML = userGroupDDHTML;

    div1.appendChild(gridDiv1);
    div2.appendChild(gridDiv2);
    div3.appendChild(gridDiv3);
    div4.appendChild(gridDiv4);
    buildAppStatus.appendChild(h0);
    buildAppStatus.appendChild(div1);
    buildAppStatus.appendChild(div2);
    buildAppStatus.appendChild(div3);
    buildAppStatus.appendChild(div4);
    adminReporting.colorSlider(6);

    //UserrGroups actions --
    const userGroups = await assStatusReport.getUserGroups();
    buildDropDownMain(userGroups, 'userGroupDD', 'HUSERGROUPID', 'SHORTNAME');
    eListen(
      'addUG',
      () => {
        assStatusReport.userGroupFilter();
      },
      'click'
    );

    // buildAppStatus.buildStatusBar(graphData)
    for (let i = 0; i < elems.length; i++) {
      eListen(
        elems[i][0],
        () => {
          assStatusReport.updateDateControl(elems[i][1]);
        },
        'click'
      );
    }
    for (let i = 0; i < elems1.length; i++) {
      eListen(
        elems1[i],
        () => {
          assStatusReport.updateChart();
        },
        'change'
      );
    }
    for (let i = 0; i < elems2.length; i++) {
      eListen(
        elems2[i],
        () => {
          assStatusReport.updateChart();
        },
        'change'
      );
    }
    for (let i = 0; i < elems3.length; i++) {
      eListen(
        elems3[i],
        () => {
          assStatusReport.updateChart();
        },
        'change'
      );
    }
  },
  buildData: (res) => {
    const rawAssData = res.data.repGraph_arep_assStatus[0].ReturnList;
    const rawTableData = res.data.repList_arep_assStatus;
    const chartData = {};
    chartData.labels = [];
    chartData.rows = [];
    chartData.status = {};

    for (let row of rawAssData) {
      chartData.labels.push(row.status);
      console.log('labels', row.status); //label
      chartData.rows.push(row.ccnt);
      console.log('rows', row.ccnt); //value
      chartData.status[row.status] = row.DDassessmentStatusID;
      console.log('status', row.DDassessmentStatusID); //label
    }

    assStatusReport.buildGraph(chartData);
    assStatusReport.buildAssList(rawTableData);
    unhide('dataGraphDiv');
  },
  buildAssList: (data) => {
    const userList = data[0].ReturnList;
    const pagin = data[0].pagination;
    const table = id('assStatusTable');
    let callback = (p1, p2) => {
      assStatusReport.navTablePag(p1, p2);
    };
    table.innerHTML = '';
    if (userList.length) {
      const thead1 = document.createElement('thead');
      const th1 = document.createElement('th');
      const th2 = document.createElement('th');
      const th3 = document.createElement('th');
      const th4 = document.createElement('th');
      const th5 = document.createElement('th');
      const th6 = document.createElement('th');
      const th7 = document.createElement('th');
      // const th6 = document.createElement('th');
      th1.innerHTML = 'Status';
      th2.innerHTML = 'Ratee';
      th3.innerHTML = 'Rater';
      th4.innerHTML = 'Relationship';
      th5.innerHTML = 'RFCNumber';
      th6.innerHTML = 'Assessment';
      th7.innerHTML = 'Purpose';
      // th6.innerHTML = 'Action';
      thead1.appendChild(th1);
      thead1.appendChild(th2);
      thead1.appendChild(th3);
      thead1.appendChild(th4);
      thead1.appendChild(th5);
      thead1.appendChild(th6);
      thead1.appendChild(th7);
      table.appendChild(thead1);

      for (let row of userList) {
        const tr = document.createElement('tr');
        const status = document.createElement('td');
        const ratee = document.createElement('td');
        const rater = document.createElement('td');
        const relationship = document.createElement('td');
        const rfcNumber = document.createElement('td');
        const assName = document.createElement('td');
        const purpose = document.createElement('td');
        const view = document.createElement('td');
        const viewbtn = divAtt('a', 'href', '#');
        status.innerHTML = row.status;
        ratee.innerHTML = `${row.rateeFname} ${row.rateesname}`;
        rater.innerHTML = `${row.raterFname} ${row.ratersname}`;
        relationship.innerHTML = row.raterRelationship;
        rfcNumber.innerHTML = row.RFCNumber;
        assName.innerHTML = row.assessmentName;
        purpose.innerHTML = row.purpose;
        viewbtn.setAttribute('class', 'btn viewMail');
        viewbtn.setAttribute('onclick', `PREP("viewAppDetails", "HAPPLICATIONID=${row.allocHuserHassessmentID}")`);
        viewbtn.id = `appID_${row.allocHuserHassessmentID}`;
        viewbtn.innerHTML = 'View';
        view.appendChild(viewbtn);
        tr.appendChild(status);
        tr.appendChild(ratee);
        tr.appendChild(rater);
        tr.appendChild(relationship);
        tr.appendChild(rfcNumber);
        tr.appendChild(assName);
        tr.appendChild(purpose);
        // tr.appendChild(view);
        table.appendChild(tr);
      }
    }
    pagination(pagin[0], callback);
  },
  getUserGroups: async () => {
    return new Promise((resolve, reject) => {
      PREP(['getUserGroups'], {
        hclientID: id('clientDD').value,
      })
        .then((res) => {
          resolve(cObj(res.data.getUserGroups));
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  userGroupFilter: async (elID) => {
    console.log('userGroupFilter', elID);
    if (elID) {
      const tagEl = id(elID);
      id('ugFilters').removeChild(tagEl);
    } else {
      //built tag here
      const ugDD = id('userGroupDD');
      const selectedOption = ugDD.options[ugDD.selectedIndex];
      const selectedText = selectedOption.textContent;
      const tagEl = ugDD.value;
      let repeat = false;

      if (!tagEl || tagEl === '-') {
        return errBox('Please select a User Group');
      }

      const childElements = id('ugFilters').querySelectorAll('*');
      if (childElements.length) {
        childElements.forEach((element) => {
          if (element.id === tagEl) {
            repeat = true;
            errBox('User Group already added');
          }
        });
      }

      if (repeat) {
        return;
      }

      // @steph x styling
      const tag = divAtt('div', 'class', 'filterTag');
      tag.id = tagEl;
      tag.innerHTML = `${selectedText} ${crossSVG}`;
      id('ugFilters').appendChild(tag);

      //add elisten to tag
      eListen(
        tag,
        () => {
          assStatusReport.userGroupFilter(`${tagEl}`);
        },
        'click'
      );
    }
    assStatusReport.updateChart();
  },
  updateDateControl: (monthNum) => {
    const gridDiv2 = id('dateControl');
    const vars = {};
    vars.monthsPrevious = monthNum;
    vars.HclientID = id('clientDD').value;

    PREP(['getDDMonths'], vars)
      .then(async (res) => {
        gridDiv2.innerHTML = '';
        const monthData = res.data.getDDMonths;
        let elems1 = [];
        let countID = 0;
        for (let row of monthData) {
          let elID = 'cntrlDate' + countID;
          elems1.push(elID);
          const tgl = await buildTgl(`cntrlDate`, row.MonthValue, false, 'assStatusReport.updateChart()', row.monthDisplay, elID);
          gridDiv2.appendChild(tgl);
          countID++;
        }
        for (let i = 0; i < elems1.length; i++) {
          eListen(
            elems1[i],
            () => {
              assStatusReport.updateChart();
            },
            'change'
          );
        }
        assStatusReport.updateChart(monthNum);
        adminReporting.colorSlider(monthNum);
      })
      .catch(console.error());
  },
  updateChart: async (monthNum, returnFilters) => {
    const cntrlStatus = document.querySelectorAll('.cntrlStatus');
    const cntrlDate = document.querySelectorAll('.cntrlDate');
    const monthsPrev = document.querySelectorAll('.ratingItem');
    const assStatus = document.querySelectorAll('.statusList');
    const userGroup = document.querySelectorAll('.filterTag');

    const Assessmentlist = [];
    const monthList = [];
    const statusList = [];
    const userGroupList = [];

    if (!monthNum) {
      monthsPrev.forEach((toggle) => {
        if (toggle.classList.contains('ratingActive')) {
          monthNum = toggle.id.split('_')[1];
        }
      });
    }

    assStatus.forEach((toggle) => {
      if (toggle.checked) {
        statusList.push(toggle.value);
      }
    });

    cntrlStatus.forEach((toggle) => {
      if (toggle.checked) {
        Assessmentlist.push(toggle.value);
      }
    });

    cntrlDate.forEach((toggle) => {
      if (toggle.checked) {
        monthList.push(toggle.value);
      }
    });

    userGroup.forEach((tag) => {
      userGroupList.push(`${tag.id}`);
    });

    if (returnFilters) {
      let filterData = {};
      filterData.monthNum = monthNum; //mandatory
      monthList.length && (filterData.monthList = monthList);
      Assessmentlist.length && (filterData.Assessmentlist = Assessmentlist);
      statusList.length && (filterData.statusList = statusList);
      userGroupList.length && (filterData.userGroupList = userGroupList);
      return filterData;
    } else {
      assStatusReport.buildAppgetAssessmentsDD(Assessmentlist, monthList, monthNum, statusList, userGroupList);
    }
  },
  buildAppgetAssessmentsDD: (Assessmentlist, monthList, monthNum, statusList, userGroupList) => {
    const vars = {};
    vars.HclientID = id('clientDD').value;
    monthList.length && (vars.monthList = monthList.join(','));
    Assessmentlist.length && (vars.Assessmentlist = Assessmentlist.join(','));
    statusList.length && (vars.statusList = statusList.join(','));
    vars.displaypage = 1;
    vars.displayListCount = 25;
    vars.monthsPrevious = monthNum;
    userGroupList.length && (vars.userGroupList = userGroupList.join(','));

    PREP(['repList_arep_assStatus', 'repGraph_arep_assStatus'], vars)
      .then((res) => {
        assStatusReport.buildData(res);
        unhide('dataGraphDiv');
        assStatusReport.currState = vars;
      })
      .catch(console.error());
  },
  navTablePag: (pageNr) => {
    const cntrlStatus = document.querySelectorAll('.cntrlStatus');
    const cntrlDate = document.querySelectorAll('.cntrlDate');
    const monthsPrev = document.querySelectorAll('.ratingItem');
    const Assessmentlist = [];
    const monthList = [];
    let monthNum = 0;

    monthsPrev.forEach((toggle) => {
      if (toggle.classList.contains('ratingActive')) {
        monthNum = toggle.id.split('_')[1];
      }
    });

    cntrlStatus.forEach((toggle) => {
      if (toggle.checked) {
        Assessmentlist.push(toggle.value);
      }
    });

    cntrlDate.forEach((toggle) => {
      if (toggle.checked) {
        monthList.push(toggle.value);
      }
    });

    const vars = {};
    vars.HclientID = id('clientDD').value;
    monthList.length && (vars.monthList = monthList.join(','));
    Assessmentlist.length && (vars.Assessmentlist = Assessmentlist.join(','));
    vars.displaypage = parseInt(pageNr) || 1;
    vars.displayListCount = 25;
    vars.monthsPrevious = monthNum;
    PREP(['repList_arep_assStatus'], vars)
      .then((res) => {
        const rawTableData = res.data.repList_arep_assStatus;
        assStatusReport.buildAssList(rawTableData);
        assStatusReport.currState = vars;
      })
      .catch(console.error());
  },
  buildGraph: (dataMap) => {
    const pageDiv = id('appChart');
    pageDiv.innerHTML = '';

    if (dataMap.rows.length) {
      const canvas = divAtt('canvas', 'id', 'chartCanvas');
      pageDiv.appendChild(canvas);
      const ctx = document.getElementById('chartCanvas').getContext('2d');

      const style = getComputedStyle(document.body);
      const primCol = style.getPropertyValue('--primaryColor');
      const secCol = style.getPropertyValue('--secondaryColor');
      const thirdCol = style.getPropertyValue('--thirdColor');
      const fourthCol = style.getPropertyValue('--fourthColour');
      const myChart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: dataMap.labels,
          datasets: [
            {
              barPercentage: 0.5,
              barThickness: 80,
              maxBarThickness: 100,
              minBarLength: 20,
              label: 'Count',
              data: dataMap.rows,
              backgroundColor: [primCol, secCol, thirdCol, fourthCol],
              borderColor: [primCol, secCol, thirdCol, fourthCol],
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          onClick: (e) => {
            const canvasPosition = Chart.helpers.getRelativePosition(e, myChart);
            const dataX = myChart.scales.x.getValueForPixel(canvasPosition.x);
            const label = myChart.data.labels[dataX];
            const statusID = dataMap.status[label];
            const cntrlTgl = document.querySelectorAll('.statusList');
            cntrlTgl.forEach((tgl) => {
              if (tgl.value == statusID) {
                tgl.checked = true;
              } else {
                tgl.checked = false;
              }
            });
            assStatusReport.updateChart();
          },
          scales: {
            y: {
              beginAtZero: true,
            },
          },
          plugins: {
            legend: {
              display: false,
            },
          },
        },
      });
    } else {
      pageDiv.innerHTML = 'No Data To Display';
    }
  },
  exportData: () => {
    // console.log('custard Box:  Please note that this export will include all data displayed in the above graph. Do you wish to proceed?');

    const div = divAtt('div', 'class', '');
    const p = divAtt('p', 'class', 'marginTop marginBottom');
    p.innerHTML = 'Please note that this export will include all data displayed in the above graph. <br> Do you wish to proceed?';
    const cancelBtn = divAtt('button', 'class', 'btnCancel');
    cancelBtn.innerHTML = 'Cancel';
    cancelBtn.setAttribute('onclick', `hide('custardBox')`);
    const btn = divAtt('button', 'class', 'btn');
    btn.innerHTML = 'Proceed';
    // btn.setAttribute("onclick", `assStatusReport.confirmExportData()`);
    div.appendChild(p);
    div.appendChild(cancelBtn);
    div.appendChild(btn);

    // custardBox(div, "Export Data");
    eCustardBox(div, 'Export Data', [
      btn,
      () => {
        assStatusReport.confirmExportData();
      },
      'click',
    ]);
  },
  confirmExportData: () => {
    const vars = assStatusReport.currState;
    PREP([mFile('repList_arep_assStatus_ssheet', `assessment_status`)], vars)
      .then((res) => {
        res.data.repList_arep_assStatus_ssheet && note('File Downloaded.');
      })
      .catch(console.error());

    hide('custardBox');
  },
  emailData: async () => {
    //gather filers --
    const filterData = await assStatusReport.updateChart(null, 1);

    // check filters val --
    console.log({ filterData: filterData, filterDataLength: Object.keys(filterData).length });
    // if no data display
    if (Object.keys(filterData).length < 1) {
      return errBox('Please use filters from the Control Panel to create a dataset before sending email');
    } else if (id('appChart').innerHTML === 'No Data To Display') {
      return errBox('No data with these filters');
    }

    const vars = {};
    vars.HclientID = id('clientDD').value;
    vars.messageEventID = 15;

    PREP(['getTemplateByEvent'], vars)
      .then(async (res) => {
        const div = divAtt('div', 'class', '');
        const select = await buildSelectInp('msgTemp', 1, 'Message Template');
        select.setAttribute('style', 'margin-top: 3rem;');
        const subject = await buildInpText('subject', 1, 'Subject');
        const cancelBtn = divAtt('button', 'class', 'btnCancel');
        cancelBtn.innerHTML = 'Cancel';
        cancelBtn.setAttribute('onclick', `hide('custardBox')`);
        const btn = divAtt('button', 'class', 'btn');
        btn.innerHTML = 'Send';
        div.appendChild(select);
        div.appendChild(subject);
        div.appendChild(cancelBtn);
        div.appendChild(btn);
        await eCustardBox(div, 'Send Email', [
          btn,
          () => {
            assStatusReport.sendEmailData(filterData);
          },
          'click',
        ]);

        buildDropDownMain(res.data.getTemplateByEvent, 'msgTemp', 'messageTemplateID', 'shortdescription');
      })
      .catch(console.error());
  },
  sendEmailData: (filterData) => {
    if (!id('subject').value || id('msgTemp').value === '-') {
      //user feedback here
      errBox('Please make sure you have a subject and picked a template.');
      return;
    }

    const vars = {};
    vars.HclientID = id('clientDD').value;
    vars.emailSubject = id('subject').value;
    vars.messagetemplateID = id('msgTemp').value;
    filterData.monthList && (vars.monthList = filterData.monthList);
    filterData.monthNum && (vars.monthsPrevious = filterData.monthNum);
    filterData.Assessmentlist && (vars.Assessmentlist = filterData.Assessmentlist);
    filterData.statusList && (vars.statusList = filterData.statusList);
    filterData.userGroupList && (vars.userGroupList = filterData.userGroupList);

    console.log('vars', vars);
    PREP(['emailUserGroup'], vars)
      .then((res) => {
        console.log('res:', res.data);
        note('Email sent successfully');
        hide('custardBox');
      })
      .catch(console.error());
  },
};

export const bookSLA = {
  page: () => {
    if (id('clientDD').value) {
      hide('selectClient');
      id('assBookTable').innerHTML = '';
      const vars = {};
      vars.monthsPrevious = 6;
      vars.HclientID = id('clientDD').value;
      vars.displaypage = 1;
      vars.displayListCount = 25;
      PREP(['getAssessmentsDD', 'getDDMonths', 'repGraph_arep_SLABook', 'repList_arep_SLABook', 'repGraph_control_SLABook'], vars)
        .then((res) => {
          const statusData = cObj(res.data.getAssessmentsDD);
          const monthData = res.data.getDDMonths;
          const statusSLA = res.data.repGraph_control_SLABook;
          bookSLA.buildCP(statusData, monthData, statusSLA);
          bookSLA.buildData(res);
          unhide('buildAssBook');
        })
        .catch(console.error());
    } else {
      id('assBookTable').innerHTML = '';
      unhide('selectClient');
      hide('buildAssBook');
    }
  },
  buildCP: async (statusData, monthData, statusSLA) => {
    const buildAppStatus = id('buildAssBook');
    buildAppStatus.innerHTML = '';
    const h0 = divAtt('h3');
    const h1 = divAtt('h4', 'class', 'secondColor');
    const h2 = divAtt('h4', 'class', 'secondColor');
    const h3 = divAtt('h4', 'class', 'secondColor');
    const div1 = divAtt('div');
    const gridDiv1 = divAtt('div', 'class', 'controlPanelGrid');
    const div2 = divAtt('div', 'class', 'sectionGap');
    const gridDiv2 = divAtt('div', 'class', 'controlPanelGrid');
    const div3 = divAtt('div', 'class', 'sectionGap');
    const gridDiv3 = divAtt('div', 'class', 'controlPanelGrid');
    gridDiv2.setAttribute('id', 'dateControl');
    h0.innerHTML = 'Control Panel';
    h1.innerHTML = 'Assessment';
    h2.innerHTML = 'Date';
    h3.innerHTML = 'SLA Status';
    div1.appendChild(h1);
    div2.appendChild(h2);
    div3.appendChild(h3);

    const monthSlider = divAtt('div', 'class', 'rating');
    const descriptionMonths = document.createElement('p');
    descriptionMonths.innerHTML = 'Number of months';
    const steps = divAtt('div', 'class', 'ratingSteps1');
    for (let i = 1; i <= 12; i++) {
      const line = divAtt('div', 'class', `ratingLine ratingLine_${i}`);
      line.setAttribute('id', `line_${i}`);

      const sliderItem = divAtt('label', 'class', `ratingItem rating_${i}`);
      sliderItem.setAttribute('id', `dot_${i}`);
      sliderItem.innerHTML = i;
      sliderItem.setAttribute('for', `${i}`);
      steps.appendChild(sliderItem);
      //sliderItem.setAttribute("onclick", `bookSLA.updateDateControl(${i})`);
      eListen(
        sliderItem,
        () => {
          bookSLA.updateDateControl(i);
        },
        'click'
      );

      if (i != 12) {
        steps.appendChild(line);
      }
    }
    monthSlider.appendChild(descriptionMonths);
    monthSlider.appendChild(steps);
    div2.appendChild(monthSlider);
    let elems1 = [];
    let countID = 0;
    for (let row of statusData) {
      let elID = 'cntrlStatus' + countID;
      elems1.push(elID);
      const tgl = await buildTgl(`cntrlStatus`, row.HASSESSMENTID, false, 'bookSLA.updateChart()', row.SHORTNAME, elID);
      gridDiv1.appendChild(tgl);
      countID++;
    }
    let elems2 = [];
    countID = 0;
    for (let row of monthData) {
      let elID = 'cntrlDate' + countID;
      elems2.push(elID);
      const tgl = await buildTgl(`cntrlDate`, row.MonthValue, false, 'bookSLA.updateChart()', row.monthDisplay, elID);
      gridDiv2.appendChild(tgl);
      countID++;
    }
    let elems3 = [];
    countID = 0;
    for (let row of statusSLA) {
      let elID = 'statusSLA' + countID;
      elems3.push(elID);
      const tgl = await buildTgl(`statusSLA`, row.SLABook, true, 'bookSLA.updateChart()', row.SLABook, elID);
      gridDiv3.appendChild(tgl);
      countID++;
    }

    div1.appendChild(gridDiv1);
    div2.appendChild(gridDiv2);
    div3.appendChild(gridDiv3);
    buildAppStatus.appendChild(h0);
    buildAppStatus.appendChild(div1);
    buildAppStatus.appendChild(div2);
    buildAppStatus.appendChild(div3);
    // bookSLA.updateDateControl(6);
    adminReporting.colorSlider(6);
    for (let i = 0; i < elems1.length; i++) {
      eListen(
        elems1[i],
        () => {
          bookSLA.updateChart();
        },
        'change'
      );
    }
    for (let i = 0; i < elems2.length; i++) {
      eListen(
        elems2[i],
        () => {
          bookSLA.updateChart();
        },
        'change'
      );
    }
    for (let i = 0; i < elems3.length; i++) {
      eListen(
        elems3[i],
        () => {
          bookSLA.updateChart();
        },
        'change'
      );
    }
  },
  buildData: (res) => {
    const rawAssData = res.data.repGraph_arep_SLABook[0].ReturnList;
    const rawTableData = res.data.repList_arep_SLABook;
    const chartData = {};
    chartData.labels = [];
    chartData.rows = [];
    chartData.status = {};

    for (let row of rawAssData) {
      chartData.labels.push(row.SLABook);
      chartData.rows.push(row.ccnt);
      chartData.status[row.SLABook] = row.SLABook;
    }

    bookSLA.buildGraph(chartData);
    bookSLA.buildAssList(rawTableData);
    unhide('dataGraphDiv');
  },
  buildAssList: (data) => {
    const userList = data[0].ReturnList;
    const pagin = data[0].pagination;
    const table = id('assBookTable');
    let callback = (p1, p2) => {
      bookSLA.navTablePag(p1, p2);
    };
    table.innerHTML = '';
    if (userList.length) {
      const thead1 = document.createElement('thead');
      const th1 = document.createElement('th');
      const th2 = document.createElement('th');
      const th3 = document.createElement('th');
      const th4 = document.createElement('th');
      const th5 = document.createElement('th');
      const th55 = document.createElement('th');
      const th6 = document.createElement('th');
      th1.innerHTML = 'Status';
      th2.innerHTML = 'Applicant';
      th3.innerHTML = 'RFCNumber';
      th4.innerHTML = 'Assessment';
      th5.innerHTML = 'SLA Book';
      th55.innerHTML = 'Purpose';
      th6.innerHTML = 'Action';
      thead1.appendChild(th1);
      thead1.appendChild(th2);
      thead1.appendChild(th3);
      thead1.appendChild(th4);
      thead1.appendChild(th5);
      thead1.appendChild(th55);
      thead1.appendChild(th6);
      table.appendChild(thead1);

      for (let row of userList) {
        const tr = document.createElement('tr');
        const status = document.createElement('td');
        const applicant = document.createElement('td');
        const rfcNumber = document.createElement('td');
        const assName = document.createElement('td');
        const slaBook = document.createElement('td');
        const purpose = document.createElement('td');
        const view = document.createElement('td');
        const viewbtn = divAtt('a', 'href', '#');
        status.innerHTML = row.status;
        applicant.innerHTML = `${row.candidateFname} ${row.candidatesname}`;
        rfcNumber.innerHTML = row.RFCNumber;
        assName.innerHTML = row.assessmentName;
        slaBook.innerHTML = row.SLABook;
        purpose.innerHTML = row.purpose;
        viewbtn.setAttribute('class', 'btn viewMail');
        viewbtn.setAttribute('onclick', `PREP("viewAppDetails", "HAPPLICATIONID=${row.HapplicationID}")`);
        viewbtn.id = `appID_${row.allocHuserHassessmentID}`;
        viewbtn.innerHTML = 'View';
        view.appendChild(viewbtn);
        tr.appendChild(status);
        tr.appendChild(applicant);
        tr.appendChild(rfcNumber);
        tr.appendChild(assName);
        tr.appendChild(slaBook);
        tr.appendChild(purpose);
        tr.appendChild(view);
        table.appendChild(tr);
      }
    }
    pagination(pagin[0], callback);
  },
  updateDateControl: (monthNum) => {
    const gridDiv2 = id('dateControl');
    const vars = {};
    vars.monthsPrevious = monthNum;
    vars.HclientID = id('clientDD').value;

    PREP(['getDDMonths'], vars)
      .then(async (res) => {
        gridDiv2.innerHTML = '';
        const monthData = res.data.getDDMonths;
        let elems1 = [];
        let countID = 0;
        for (let row of monthData) {
          let elID = 'cntrlDate' + countID;
          elems1.push(elID);
          const tgl = await buildTgl(`cntrlDate`, row.MonthValue, false, 'bookSLA.updateChart()', row.monthDisplay, elID);
          gridDiv2.appendChild(tgl);
          countID++;
        }
        for (let i = 0; i < elems1.length; i++) {
          eListen(
            elems1[i],
            () => {
              bookSLA.updateChart();
            },
            'change'
          );
        }
        bookSLA.updateChart(monthNum);
        adminReporting.colorSlider(monthNum);
      })
      .catch(console.error());
  },
  updateChart: (monthNum) => {
    const cntrlStatus = document.querySelectorAll('.cntrlStatus');
    const cntrlDate = document.querySelectorAll('.cntrlDate');
    const monthsPrev = document.querySelectorAll('.ratingItem');
    const statusSLA = document.querySelectorAll('.statusSLA');

    const Assessmentlist = [];
    const monthList = [];
    const listSLA = [];

    if (!monthNum) {
      monthsPrev.forEach((toggle) => {
        if (toggle.classList.contains('ratingActive')) {
          monthNum = toggle.id.split('_')[1];
        }
      });
    }

    statusSLA.forEach((toggle) => {
      if (toggle.checked) {
        listSLA.push(toggle.value);
      }
    });

    cntrlStatus.forEach((toggle) => {
      if (toggle.checked) {
        Assessmentlist.push(toggle.value);
      }
    });

    cntrlDate.forEach((toggle) => {
      if (toggle.checked) {
        monthList.push(toggle.value);
      }
    });

    bookSLA.buildAppStatusData(Assessmentlist, monthList, monthNum, listSLA);
  },
  buildAppStatusData: (Assessmentlist, monthList, monthNum, statusSLA) => {
    const vars = {};
    vars.HclientID = id('clientDD').value;
    monthList.length && (vars.monthList = monthList.join(','));
    Assessmentlist.length && (vars.Assessmentlist = Assessmentlist.join(','));
    statusSLA.length === 1 && (vars.slabook = statusSLA.join(','));
    vars.displaypage = 1;
    vars.displayListCount = 25;
    vars.monthsPrevious = monthNum;

    PREP(['repList_arep_SLABook', 'repGraph_arep_SLABook'], vars)
      .then((res) => {
        bookSLA.buildData(res);
        unhide('dataGraphDiv');
      })
      .catch(console.error());
  },
  navTablePag: (pageNr) => {
    const cntrlStatus = document.querySelectorAll('.cntrlStatus');
    const cntrlDate = document.querySelectorAll('.cntrlDate');
    const monthsPrev = document.querySelectorAll('.ratingItem');
    const Assessmentlist = [];
    const monthList = [];
    let monthNum = 0;

    monthsPrev.forEach((toggle) => {
      if (toggle.classList.contains('ratingActive')) {
        monthNum = toggle.id.split('_')[1];
      }
    });

    cntrlStatus.forEach((toggle) => {
      if (toggle.checked) {
        Assessmentlist.push(toggle.value);
      }
    });

    cntrlDate.forEach((toggle) => {
      if (toggle.checked) {
        monthList.push(toggle.value);
      }
    });

    const vars = {};
    vars.HclientID = id('clientDD').value;
    monthList.length && (vars.monthList = monthList.join(','));
    Assessmentlist.length && (vars.Assessmentlist = Assessmentlist.join(','));
    vars.displaypage = parseInt(pageNr) || 1;
    vars.displayListCount = 25;
    vars.monthsPrevious = monthNum;
    PREP(['repList_arep_SLABook'], vars)
      .then((res) => {
        const rawTableData = res.data.repList_arep_SLABook;
        bookSLA.buildAssList(rawTableData);
      })
      .catch(console.error());
  },
  buildGraph: (dataMap) => {
    const pageDiv = id('appChart');
    pageDiv.innerHTML = '';

    if (dataMap.rows.length) {
      const canvas = divAtt('canvas', 'id', 'chartCanvas');
      canvas.style = 'max-width: 900px; max-height: 795px;';
      pageDiv.appendChild(canvas);
      const ctx = document.getElementById('chartCanvas').getContext('2d');

      const style = getComputedStyle(document.body);
      const primCol = style.getPropertyValue('--primaryColor');
      const secCol = style.getPropertyValue('--secondaryColor');
      const thirdCol = style.getPropertyValue('--thirdColor');
      const fourthCol = style.getPropertyValue('--fourthColour');
      const myChart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: dataMap.labels,
          datasets: [
            {
              barPercentage: 0.5,
              barThickness: 80,
              maxBarThickness: 100,
              minBarLength: 20,
              label: 'Count',
              data: dataMap.rows,
              backgroundColor: [primCol, secCol, thirdCol, fourthCol],
              borderColor: [primCol, secCol, thirdCol, fourthCol],
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          aspectRatio: 1,
          scales: {
            y: {
              display: false,
            },
            x: {
              display: false,
            },
          },
          plugins: {
            legend: {
              onClick: (e, legendItem) => {
                const cntrlTgl = document.querySelectorAll('.statusSLA');
                cntrlTgl.forEach((tgl) => {
                  if (tgl.value == legendItem.text) {
                    tgl.checked = true;
                  } else {
                    tgl.checked = false;
                  }
                });
                bookSLA.updateChart();
              },
              display: true,
              position: 'right',
              labels: {
                padding: 20,
              },
            },
          },
        },
      });
    } else {
      pageDiv.innerHTML = 'No Data To Display';
    }
  },
};

export const reportSLA = {
  page: () => {
    if (id('clientDD').value) {
      hide('selectClient');
      id('assReportTable').innerHTML = '';
      const vars = {};
      vars.monthsPrevious = 6;
      vars.HclientID = id('clientDD').value;
      vars.displaypage = 1;
      vars.displayListCount = 25;
      PREP(['getAssessmentsDD', 'getDDMonths', 'repGraph_arep_SLAReport', 'repList_arep_SLAReport', 'repGraph_control_SLAReport'], vars)
        .then((res) => {
          const statusData = cObj(res.data.getAssessmentsDD);
          const monthData = res.data.getDDMonths;
          const reportStatus = res.data.repGraph_control_SLAReport;
          reportSLA.buildCP(statusData, monthData, reportStatus);
          reportSLA.buildData(res);
          unhide('buildAssReport');
        })
        .catch(console.error());
    } else {
      id('assReportTable').innerHTML = '';
      unhide('selectClient');
      hide('buildAssReport');
    }
  },
  buildCP: async (statusData, monthData, reportStatus) => {
    const buildAppStatus = id('buildAssReport');
    buildAppStatus.innerHTML = '';
    const h0 = divAtt('h3');
    // const h1 = divAtt('h4', 'class', 'secondColor');
    const h2 = divAtt('h4', 'class', 'secondColor');
    const h3 = divAtt('h4', 'class', 'secondColor');
    // const div1 = divAtt('div');
    const gridDiv1 = divAtt('div', 'class', 'controlPanelGrid');
    const div2 = divAtt('div', 'class', 'sectionGap');
    const gridDiv2 = divAtt('div', 'class', 'controlPanelGrid');
    const div3 = divAtt('div', 'class', 'sectionGap');
    const gridDiv3 = divAtt('div', 'class', 'controlPanelGrid');
    gridDiv2.setAttribute('id', 'dateControl');
    h0.innerHTML = 'Control Panel';
    // h1.innerHTML = 'Assessment';
    h2.innerHTML = 'Date';
    h3.innerHTML = 'SLA Status';
    // div1.appendChild(h1);
    div2.appendChild(h2);
    div3.appendChild(h3);

    const monthSlider = divAtt('div', 'class', 'rating');
    const descriptionMonths = document.createElement('p');
    descriptionMonths.innerHTML = 'Number of months';

    const steps = divAtt('div', 'class', 'ratingSteps1');
    let elems = [];
    for (let i = 1; i <= 12; i++) {
      const line = divAtt('div', 'class', `ratingLine ratingLine_${i}`);
      line.setAttribute('id', `line_${i}`);

      const sliderItem = divAtt('label', 'class', `ratingItem rating_${i}`);
      sliderItem.setAttribute('id', `dot_${i}`);
      sliderItem.innerHTML = i;
      sliderItem.setAttribute('for', `${i}`);
      steps.appendChild(sliderItem);
      elems.push([sliderItem, i]);
      //sliderItem.setAttribute("onclick", `reportSLA.updateDateControl(${i})`);

      if (i != 12) {
        steps.appendChild(line);
      }
    }
    monthSlider.appendChild(descriptionMonths);
    monthSlider.appendChild(steps);
    div2.appendChild(monthSlider);

    // for (let row of statusData) {
    //     const tgl = await buildTgl(`cntrlStatus`, row.HASSESSMENTID, false, 'reportSLA.updateChart()', row.SHORTNAME);
    //     gridDiv1.appendChild(tgl);
    // }
    let elems1 = [];
    let countID = 0;
    for (let row of monthData) {
      let elID = 'cntrlDate' + countID;
      elems1.push(elID);
      const tgl = await buildTgl(`cntrlDate`, row.MonthValue, false, 'reportSLA.updateChart()', row.monthDisplay, elID);
      gridDiv2.appendChild(tgl);
      countID++;
    }
    let elems2 = [];
    countID = 0;
    for (let row of reportStatus) {
      if (row.SLAreport !== 'Exceeded SLA') {
        let elID = 'statusSLA' + countID;
        elems2.push(elID);
        const tgl = await buildTgl(`statusSLA`, row.SLAreport, true, 'reportSLA.updateChart()', row.SLAreport, elID);
        gridDiv3.appendChild(tgl);
        countID++;
      }
    }

    // div1.appendChild(gridDiv1);
    div2.appendChild(gridDiv2);
    div3.appendChild(gridDiv3);
    buildAppStatus.appendChild(h0);
    // buildAppStatus.appendChild(div1);
    buildAppStatus.appendChild(div2);
    buildAppStatus.appendChild(div3);
    // reportSLA.updateDateControl(6);
    adminReporting.colorSlider(6);
    for (let i = 0; i < elems.length; i++) {
      eListen(
        elems[i][0],
        () => {
          reportSLA.updateDateControl(elems[i][1]);
        },
        'click'
      );
    }
    for (let i = 0; i < elems1.length; i++) {
      eListen(
        elems1[i],
        () => {
          reportSLA.updateChart();
        },
        'change'
      );
    }
    for (let i = 0; i < elems2.length; i++) {
      eListen(
        elems2[i],
        () => {
          reportSLA.updateChart();
        },
        'change'
      );
    }
    //report Delivery SLA
  },
  buildData: (res) => {
    const rawAssData = res.data.repGraph_arep_SLAReport[0].ReturnList;
    const rawTableData = res.data.repList_arep_SLAReport;
    const chartData = {};
    chartData.labels = [];
    chartData.rows = [];
    chartData.status = {};

    for (let row of rawAssData) {
      chartData.labels.push(row.SLAreport);
      chartData.rows.push(row.ccnt);
      chartData.status[row.SLAreport] = row.SLAreport;
    }

    reportSLA.buildGraph(chartData);
    reportSLA.buildAssList(rawTableData);
    unhide('dataGraphDiv');
  },
  buildAssList: (data) => {
    const userList = data[0].ReturnList;
    const pagin = data[0].pagination;
    const table = id('assReportTable');
    let callback = (p1, p2) => {
      reportSLA.navTablePag(p1, p2);
    };
    table.innerHTML = '';
    if (userList.length) {
      const thead1 = document.createElement('thead');
      const th0 = document.createElement('th');
      const th1 = document.createElement('th');
      const th2 = document.createElement('th');
      const th3 = document.createElement('th');
      const th4 = document.createElement('th');
      const th5 = document.createElement('th');
      const th6 = document.createElement('th');
      th0.innerHTML = 'SLA Report';
      th1.innerHTML = 'Status';
      th2.innerHTML = 'Applicant';
      th3.innerHTML = 'RFCNumber';
      th4.innerHTML = 'Job Title';
      th5.innerHTML = 'Line Manager';
      th6.innerHTML = 'Action';
      thead1.appendChild(th0);
      thead1.appendChild(th1);
      thead1.appendChild(th2);
      thead1.appendChild(th3);
      thead1.appendChild(th4);
      thead1.appendChild(th5);
      thead1.appendChild(th6);
      table.appendChild(thead1);

      for (let row of userList) {
        const tr = document.createElement('tr');
        const slaReport = document.createElement('td');
        const status = document.createElement('td');
        const applicant = document.createElement('td');
        const rfcNumber = document.createElement('td');
        const jobTitle = document.createElement('td');
        const lineManager = document.createElement('td');
        const view = document.createElement('td');
        const viewbtn = divAtt('a', 'href', '#');
        slaReport.innerHTML = row.SLAReport;
        status.innerHTML = row.status;
        applicant.innerHTML = `${row.candidateFname} ${row.candidatesname}`;
        rfcNumber.innerHTML = row.RFCNumber;
        jobTitle.innerHTML = row.clientjobTitle;
        lineManager.innerHTML = `${row.lineManagerfname} ${row.linemanagerSname}`;
        viewbtn.setAttribute('class', 'btn viewMail');
        viewbtn.setAttribute('onclick', `PREP("viewAppDetails", "HAPPLICATIONID=${row.HapplicationID}")`);
        viewbtn.id = `appID_${row.HapplicationID}`;
        viewbtn.innerHTML = 'View';
        view.appendChild(viewbtn);
        tr.appendChild(slaReport);
        tr.appendChild(status);
        tr.appendChild(applicant);
        tr.appendChild(rfcNumber);
        tr.appendChild(jobTitle);
        tr.appendChild(lineManager);
        tr.appendChild(view);
        table.appendChild(tr);
      }
    }
    pagination(pagin[0], callback);
  },
  updateDateControl: (monthNum) => {
    const gridDiv2 = id('dateControl');
    const vars = {};
    vars.monthsPrevious = monthNum;
    vars.HclientID = id('clientDD').value;

    PREP(['getDDMonths'], vars)
      .then(async (res) => {
        gridDiv2.innerHTML = '';
        const monthData = res.data.getDDMonths;
        let elems1 = [];
        let countID = 0;
        for (let row of monthData) {
          let elID = 'cntrlDate' + countID;
          elems1.push(elID);
          const tgl = await buildTgl(`cntrlDate`, row.MonthValue, false, 'reportSLA.updateChart()', row.monthDisplay, elID);
          gridDiv2.appendChild(tgl);
          countID++;
        }
        for (let i = 0; i < elems1.length; i++) {
          eListen(
            elems1[i],
            () => {
              reportSLA.updateChart();
            },
            'change'
          );
        }
        reportSLA.updateChart(monthNum);
        adminReporting.colorSlider(monthNum);
      })
      .catch(console.error());
  },
  updateChart: (monthNum) => {
    const cntrlStatus = document.querySelectorAll('.cntrlStatus');
    const cntrlDate = document.querySelectorAll('.cntrlDate');
    const monthsPrev = document.querySelectorAll('.ratingItem');
    const statusSLA = document.querySelectorAll('.statusSLA');

    const Assessmentlist = [];
    const monthList = [];
    const listSLA = [];

    if (!monthNum) {
      monthsPrev.forEach((toggle) => {
        if (toggle.classList.contains('ratingActive')) {
          monthNum = toggle.id.split('_')[1];
        }
      });
    }

    cntrlStatus.forEach((toggle) => {
      if (toggle.checked) {
        Assessmentlist.push(toggle.value);
      }
    });

    cntrlDate.forEach((toggle) => {
      if (toggle.checked) {
        monthList.push(toggle.value);
      }
    });

    statusSLA.forEach((toggle) => {
      if (toggle.checked) {
        listSLA.push(toggle.value);
      }
    });

    reportSLA.buildAppStatusData(Assessmentlist, monthList, monthNum, listSLA);
  },
  buildAppStatusData: (Assessmentlist, monthList, monthNum, listSLA) => {
    const vars = {};
    vars.HclientID = id('clientDD').value;
    monthList.length && (vars.monthList = monthList.join(','));
    Assessmentlist.length && (vars.Assessmentlist = Assessmentlist.join(','));
    listSLA.length === 1 && (vars.SLAreport = listSLA.join(','));
    vars.displaypage = 1;
    vars.displayListCount = 25;
    vars.monthsPrevious = monthNum;

    PREP(['repList_arep_SLAReport', 'repGraph_arep_SLAReport'], vars)
      .then((res) => {
        reportSLA.buildData(res);
        unhide('dataGraphDiv');
      })
      .catch(console.error());
  },
  navTablePag: (pageNr) => {
    const cntrlStatus = document.querySelectorAll('.cntrlStatus');
    const cntrlDate = document.querySelectorAll('.cntrlDate');
    const monthsPrev = document.querySelectorAll('.ratingItem');
    const Assessmentlist = [];
    const monthList = [];
    let monthNum = 0;

    monthsPrev.forEach((toggle) => {
      if (toggle.classList.contains('ratingActive')) {
        monthNum = toggle.id.split('_')[1];
      }
    });

    cntrlStatus.forEach((toggle) => {
      if (toggle.checked) {
        Assessmentlist.push(toggle.value);
      }
    });

    cntrlDate.forEach((toggle) => {
      if (toggle.checked) {
        monthList.push(toggle.value);
      }
    });

    const vars = {};
    vars.HclientID = id('clientDD').value;
    monthList.length && (vars.monthList = monthList.join(','));
    Assessmentlist.length && (vars.Assessmentlist = Assessmentlist.join(','));
    vars.displaypage = parseInt(pageNr) || 1;
    vars.displayListCount = 25;
    vars.monthsPrevious = monthNum;
    PREP(['repList_arep_SLAReport'], vars)
      .then((res) => {
        const rawTableData = res.data.repList_arep_SLAReport;
        reportSLA.buildAssList(rawTableData);
      })
      .catch(console.error());
  },
  buildGraph: (dataMap) => {
    const pageDiv = id('appChart');
    pageDiv.innerHTML = '';

    if (dataMap.rows.length) {
      const canvas = divAtt('canvas', 'id', 'chartCanvas');
      canvas.style = 'max-width: 900px; max-height: 795px;';
      pageDiv.appendChild(canvas);
      const ctx = document.getElementById('chartCanvas').getContext('2d');

      const style = getComputedStyle(document.body);
      const primCol = style.getPropertyValue('--primaryColor');
      const secCol = style.getPropertyValue('--secondaryColor');
      const thirdCol = style.getPropertyValue('--thirdColor');
      const fourthCol = style.getPropertyValue('--fourthColour');
      const myChart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: dataMap.labels,
          datasets: [
            {
              barPercentage: 0.5,
              barThickness: 80,
              maxBarThickness: 100,
              minBarLength: 20,
              label: 'Count',
              data: dataMap.rows,
              backgroundColor: [primCol, secCol, thirdCol, fourthCol],
              borderColor: [primCol, secCol, thirdCol, fourthCol],
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          scales: {
            y: {
              display: false,
            },
            x: {
              display: false,
            },
          },
          plugins: {
            legend: {
              onClick: (e, legendItem) => {
                const cntrlTgl = document.querySelectorAll('.statusSLA');
                cntrlTgl.forEach((tgl) => {
                  if (tgl.value == legendItem.text) {
                    tgl.checked = true;
                  } else {
                    tgl.checked = false;
                  }
                });
                reportSLA.updateChart();
              },
              display: true,
              position: 'right',
              labels: {
                padding: 20,
              },
            },
          },
        },
      });
    } else {
      pageDiv.innerHTML = 'No Data To Display';
    }
  },
};

export const jobLevels = {
  page: () => {
    if (id('clientDD').value) {
      hide('selectClient');
      id('jobLevelTable').innerHTML = '';
      const vars = {};
      vars.monthsPrevious = 6;
      vars.HclientID = id('clientDD').value;
      vars.displaypage = 1;
      vars.displayListCount = 25;
      PREP(['getDDPositionLevel', 'getDDMonths', 'repGraph_arep_appJoblevel', 'repList_arep_appJoblevel'], vars)
        .then((res) => {
          const statusData = cObj(res.data.getDDPositionLevel);
          const monthData = res.data.getDDMonths;
          jobLevels.buildCP(statusData, monthData);
          jobLevels.buildData(res);
          unhide('buildJobReport');
        })
        .catch(console.error());
    } else {
      id('jobLevelTable').innerHTML = '';
      unhide('selectClient');
      hide('buildJobReport');
    }
  },
  buildCP: async (statusData, monthData) => {
    const buildJobReport = id('buildJobReport');
    buildJobReport.innerHTML = '';
    const h0 = divAtt('h3');
    const h1 = divAtt('h4', 'class', 'secondColor');
    const h2 = divAtt('h4', 'class', 'secondColor');
    const div1 = divAtt('div');
    const gridDiv1 = divAtt('div', 'class', 'controlPanelGrid');
    const div2 = divAtt('div', 'class', 'sectionGap');
    const gridDiv2 = divAtt('div', 'class', 'controlPanelGrid');
    gridDiv2.setAttribute('id', 'dateControl');
    h0.innerHTML = 'Control Panel';
    h1.innerHTML = 'Position Level';
    h2.innerHTML = 'Date';
    div1.appendChild(h1);
    div2.appendChild(h2);

    const monthSlider = divAtt('div', 'class', 'rating');
    const descriptionMonths = document.createElement('p');
    descriptionMonths.innerHTML = 'Number of months';

    const steps = divAtt('div', 'class', 'ratingSteps1');
    let sliderElems = [];
    for (let i = 1; i <= 12; i++) {
      const line = divAtt('div', 'class', `ratingLine ratingLine_${i}`);
      line.setAttribute('id', `line_${i}`);

      const sliderItem = divAtt('label', 'class', `ratingItem rating_${i}`);
      sliderItem.setAttribute('id', `dot_${i}`);
      sliderItem.innerHTML = i;
      sliderItem.setAttribute('for', `${i}`);
      // sliderItem.setAttribute("onclick", `jobLevels.updateDateControl(${i})`);
      sliderElems.push([sliderItem, i]);
      steps.appendChild(sliderItem);
      if (i != 12) {
        steps.appendChild(line);
      }
    }
    monthSlider.appendChild(descriptionMonths);
    monthSlider.appendChild(steps);
    div2.appendChild(monthSlider);
    console.log('HEREEE');
    let elems1 = [];
    let countID = 0;
    for (let row of statusData) {
      let elID = 'cntrlStatus' + countID;
      elems1.push(elID);
      const tgl = await buildTgl(`cntrlStatus`, row.DDPOSITIONLEVELID, false, 'jobLevels.updateChart()', row.SHORTDESCRIPTION, elID);
      gridDiv1.appendChild(tgl);
      countID++;
    }
    let elems2 = [];
    countID = 0;
    for (let row of monthData) {
      let elID = 'cntrlDate' + countID;
      elems2.push(elID);
      const tgl = await buildTgl(`cntrlDate`, row.MonthValue, false, 'jobLevels.updateChart()', row.monthDisplay, elID);
      gridDiv2.appendChild(tgl);
      countID++;
    }
    div1.appendChild(gridDiv1);
    div2.appendChild(gridDiv2);
    buildJobReport.appendChild(h0);
    buildJobReport.appendChild(div1);
    buildJobReport.appendChild(div2);
    adminReporting.colorSlider(6);
    for (let i = 0; i < sliderElems.length; i++) {
      eListen(
        sliderElems[i][0],
        () => {
          jobLevels.updateDateControl(sliderElems[i][1]);
        },
        'click'
      );
    }
    for (let i = 0; i < elems1.length; i++) {
      eListen(
        elems1[i],
        () => {
          jobLevels.updateChart();
        },
        'change'
      );
    }
    for (let i = 0; i < elems2.length; i++) {
      eListen(
        elems2[i],
        () => {
          jobLevels.updateChart();
        },
        'change'
      );
    }
  },
  buildData: (res) => {
    const rawAssData = res.data.repGraph_arep_appJoblevel[0].ReturnList;
    const rawTableData = res.data.repList_arep_appJoblevel;
    const chartData = {};
    chartData.labels = [];
    chartData.rows = [];
    chartData.status = {};

    for (let row of rawAssData) {
      chartData.labels.push(row.positionlevel);
      chartData.rows.push(row.ccnt);
      chartData.status[row.positionlevel] = row.DDpositionlevelID;
    }

    jobLevels.buildGraph(chartData);
    jobLevels.buildAssList(rawTableData);
    unhide('dataGraphDiv');
  },
  buildAssList: (data) => {
    const userList = data[0].ReturnList;
    const pagin = data[0].pagination;
    const table = id('jobLevelTable');
    let callback = (p1, p2) => {
      jobLevels.navTablePag(p1, p2);
    };
    table.innerHTML = '';
    if (userList.length) {
      const thead1 = document.createElement('thead');
      const th0 = document.createElement('th');
      const th1 = document.createElement('th');
      const th2 = document.createElement('th');
      const th3 = document.createElement('th');
      const th4 = document.createElement('th');
      const th5 = document.createElement('th');
      const th6 = document.createElement('th');
      th0.innerHTML = 'Job Level';
      th1.innerHTML = 'Status';
      th2.innerHTML = 'Applicant';
      th3.innerHTML = 'RFCNumber';
      th4.innerHTML = 'Job Title';
      th5.innerHTML = 'Line Manager';
      th6.innerHTML = 'Action';
      thead1.appendChild(th0);
      thead1.appendChild(th1);
      thead1.appendChild(th2);
      thead1.appendChild(th3);
      thead1.appendChild(th4);
      thead1.appendChild(th5);
      thead1.appendChild(th6);
      table.appendChild(thead1);

      for (let row of userList) {
        const tr = document.createElement('tr');
        const jobLevel = document.createElement('td');
        const status = document.createElement('td');
        const applicant = document.createElement('td');
        const rfcNumber = document.createElement('td');
        const jobTitle = document.createElement('td');
        const lineManager = document.createElement('td');
        const view = document.createElement('td');
        const viewbtn = divAtt('a', 'href', '#');
        jobLevel.innerHTML = row.joblevel;
        status.innerHTML = row.status;
        applicant.innerHTML = `${row.candidateFname} ${row.candidatesname}`;
        rfcNumber.innerHTML = row.RFCNumber;
        jobTitle.innerHTML = row.clientjobTitle;
        lineManager.innerHTML = `${row.lineManagerfname} ${row.linemanagerSname}`;
        viewbtn.setAttribute('class', 'btn viewMail');
        viewbtn.setAttribute('onclick', `PREP("viewAppDetails", "HAPPLICATIONID=${row.HapplicationID}")`);
        viewbtn.id = `appID_${row.HapplicationID}`;
        viewbtn.innerHTML = 'View';
        view.appendChild(viewbtn);
        tr.appendChild(jobLevel);
        tr.appendChild(status);
        tr.appendChild(applicant);
        tr.appendChild(rfcNumber);
        tr.appendChild(jobTitle);
        tr.appendChild(lineManager);
        tr.appendChild(view);
        table.appendChild(tr);
      }
    }
    pagination(pagin[0], callback);
  },
  updateDateControl: (monthNum) => {
    const gridDiv2 = id('dateControl');
    const vars = {};
    vars.monthsPrevious = monthNum;
    vars.HclientID = id('clientDD').value;

    PREP(['getDDMonths'], vars)
      .then(async (res) => {
        gridDiv2.innerHTML = '';
        const monthData = res.data.getDDMonths;
        let elems1 = [];
        let countID = 0;
        for (let row of monthData) {
          let elID = 'cntrlDate' + countID;
          elems1.push(elID);
          const tgl = await buildTgl(`cntrlDate`, row.MonthValue, false, 'jobLevels.updateChart()', row.monthDisplay, elID);
          gridDiv2.appendChild(tgl);
          countID++;
        }

        for (let i = 0; i < elems1.length; i++) {
          eListen(
            elems1[i],
            () => {
              jobLevels.updateChart();
            },
            'change'
          );
        }
        jobLevels.updateChart(monthNum);
        adminReporting.colorSlider(monthNum);
      })
      .catch(console.error());
  },
  updateChart: (monthNum) => {
    const cntrlStatus = document.querySelectorAll('.cntrlStatus');
    const cntrlDate = document.querySelectorAll('.cntrlDate');
    const monthsPrev = document.querySelectorAll('.ratingItem');

    const positionLevelList = [];
    const monthList = [];

    if (!monthNum) {
      monthsPrev.forEach((toggle) => {
        if (toggle.classList.contains('ratingActive')) {
          monthNum = toggle.id.split('_')[1];
        }
      });
    }

    cntrlStatus.forEach((toggle) => {
      if (toggle.checked) {
        positionLevelList.push(toggle.value);
      }
    });

    cntrlDate.forEach((toggle) => {
      if (toggle.checked) {
        monthList.push(toggle.value);
      }
    });

    jobLevels.buildJobReportData(positionLevelList, monthList, monthNum);
  },
  buildJobReportData: (positionLevelList, monthList, monthNum) => {
    const vars = {};
    vars.HclientID = id('clientDD').value;
    monthList.length && (vars.monthList = monthList.join(','));
    positionLevelList.length && (vars.positionLevelList = positionLevelList.join(','));
    vars.displaypage = 1;
    vars.displayListCount = 25;
    vars.monthsPrevious = monthNum;

    PREP(['repList_arep_appJoblevel', 'repGraph_arep_appJoblevel'], vars)
      .then((res) => {
        jobLevels.buildData(res);
        unhide('dataGraphDiv');
      })
      .catch(console.error());
  },
  navTablePag: (pageNr) => {
    const cntrlStatus = document.querySelectorAll('.cntrlStatus');
    const cntrlDate = document.querySelectorAll('.cntrlDate');
    const monthsPrev = document.querySelectorAll('.ratingItem');
    const positionLevelList = [];
    const monthList = [];
    let monthNum = 0;

    monthsPrev.forEach((toggle) => {
      if (toggle.classList.contains('ratingActive')) {
        monthNum = toggle.id.split('_')[1];
      }
    });

    cntrlStatus.forEach((toggle) => {
      if (toggle.checked) {
        positionLevelList.push(toggle.value);
      }
    });

    cntrlDate.forEach((toggle) => {
      if (toggle.checked) {
        monthList.push(toggle.value);
      }
    });

    const vars = {};
    vars.HclientID = id('clientDD').value;
    monthList.length && (vars.monthList = monthList.join(','));
    positionLevelList.length && (vars.positionLevelList = positionLevelList.join(','));
    vars.displaypage = parseInt(pageNr) || 1;
    vars.displayListCount = 25;
    vars.monthsPrevious = monthNum;
    PREP(['repList_arep_appJoblevel'], vars)
      .then((res) => {
        const rawTableData = res.data.repList_arep_appJoblevel;
        jobLevels.buildAssList(rawTableData);
      })
      .catch(console.error());
  },
  buildGraph: (dataMap) => {
    const pageDiv = id('appChart');
    pageDiv.innerHTML = '';

    if (dataMap.rows.length) {
      const canvas = divAtt('canvas', 'id', 'chartCanvas');
      pageDiv.appendChild(canvas);
      const ctx = document.getElementById('chartCanvas').getContext('2d');

      const style = getComputedStyle(document.body);
      const primCol = style.getPropertyValue('--primaryColor');
      const secCol = style.getPropertyValue('--secondaryColor');
      const thirdCol = style.getPropertyValue('--thirdColor');
      const fourthCol = style.getPropertyValue('--fourthColour');
      const myChart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: dataMap.labels,
          datasets: [
            {
              barPercentage: 0.5,
              barThickness: 80,
              maxBarThickness: 100,
              minBarLength: 20,
              label: 'Count',
              data: dataMap.rows,
              backgroundColor: [primCol, secCol, thirdCol, fourthCol],
              borderColor: [primCol, secCol, thirdCol, fourthCol],
              borderWidth: 1,
            },
          ],
        },
        options: {
          onClick: (e) => {
            const canvasPosition = Chart.helpers.getRelativePosition(e, myChart);
            const dataX = myChart.scales.x.getValueForPixel(canvasPosition.x);
            const label = myChart.data.labels[dataX];
            const statusID = dataMap.status[label];
            const cntrlTgl = document.querySelectorAll('.cntrlStatus');
            cntrlTgl.forEach((tgl) => {
              if (tgl.value == statusID) {
                tgl.checked = true;
              } else {
                tgl.checked = false;
              }
            });
            jobLevels.updateChart();
          },
          scales: {
            y: {
              beginAtZero: true,
            },
          },
          plugins: {
            legend: {
              display: false,
            },
          },
        },
      });
    } else {
      pageDiv.innerHTML = 'No Data To Display';
    }
  },
};

// COPY THIS ONE FOR CC FAM
export const servicePBUnit = {
  page: () => {
    if (id('clientDD').value) {
      hide('selectClient');
      id('buildServiceTable').innerHTML = '';
      const vars = {};
      vars.monthsPrevious = 6;
      vars.HclientID = id('clientDD').value;
      vars.displaypage = 1;
      vars.displayListCount = 25;
      PREP(['getDDdivisions', 'getDDMonths', 'repGraph_arep_appBusunit', 'repList_arep_appBusunit'], vars)
        .then((res) => {
          const statusData = cObj(res.data.getDDdivisions);
          const monthData = res.data.getDDMonths;
          servicePBUnit.buildCP(statusData, monthData);
          servicePBUnit.buildData(res);
          unhide('buildService');
        })
        .catch(console.error());
    } else {
      id('buildServiceTable').innerHTML = '';
      unhide('selectClient');
      hide('buildService');
    }
  },
  buildCP: async (statusData, monthData) => {
    const buildService = id('buildService');
    buildService.innerHTML = '';
    const h0 = divAtt('h3');
    const h1 = divAtt('h4', 'class', 'secondColor');
    const h2 = divAtt('h4', 'class', 'secondColor');
    const div1 = divAtt('div');
    const gridDiv1 = divAtt('div', 'class', 'controlPanelGrid');
    const div2 = divAtt('div', 'class', 'sectionGap');
    const gridDiv2 = divAtt('div', 'class', 'controlPanelGrid');
    gridDiv2.setAttribute('id', 'dateControl');
    h0.innerHTML = 'Control Panel';
    h1.innerHTML = 'Divisions';
    h2.innerHTML = 'Date';
    div1.appendChild(h1);
    div2.appendChild(h2);

    const monthSlider = divAtt('div', 'class', 'rating');
    const descriptionMonths = document.createElement('p');
    descriptionMonths.innerHTML = 'Number of months';

    const steps = divAtt('div', 'class', 'ratingSteps1');
    let sliderElems = [];
    for (let i = 1; i <= 12; i++) {
      const line = divAtt('div', 'class', `ratingLine ratingLine_${i}`);
      line.setAttribute('id', `line_${i}`);

      const sliderItem = divAtt('label', 'class', `ratingItem rating_${i}`);
      sliderItem.setAttribute('id', `dot_${i}`);
      sliderItem.innerHTML = i;
      sliderItem.setAttribute('for', `${i}`);
      sliderElems.push([sliderItem, i]);
      // sliderItem.setAttribute(
      //   "onclick",
      //   `servicePBUnit.updateDateControl(${i})`
      // );

      steps.appendChild(sliderItem);
      if (i != 12) {
        steps.appendChild(line);
      }
    }
    monthSlider.appendChild(descriptionMonths);
    monthSlider.appendChild(steps);
    div2.appendChild(monthSlider);

    let elems1 = [];
    let countID = 0;
    for (let row of statusData) {
      let elID = 'cntrlStatus' + countID;
      elems1.push(elID);
      const tgl = await buildTgl(`cntrlStatus`, row.DDDIVISIONID, false, 'servicePBUnit.updateChart()', row.SHORTDESCRIPTION, elID);
      gridDiv1.appendChild(tgl);
      countID++;
    }

    let elems2 = [];
    countID = 0;
    for (let row of monthData) {
      let elID = 'cntrlDate' + countID;
      elems2.push(elID);
      const tgl = await buildTgl(`cntrlDate`, row.MonthValue, false, 'servicePBUnit.updateChart()', row.monthDisplay, elID);
      gridDiv2.appendChild(tgl);
      countID++;
    }
    div1.appendChild(gridDiv1);
    div2.appendChild(gridDiv2);
    buildService.appendChild(h0);
    buildService.appendChild(div1);
    buildService.appendChild(div2);
    // servicePBUnit.updateDateControl(6);
    adminReporting.colorSlider(6);
    for (let i = 0; i < sliderElems.length; i++) {
      eListen(
        sliderElems[i][0],
        () => {
          servicePBUnit.updateDateControl(sliderElems[i][1]);
        },
        'click'
      );
    }
    for (let i = 0; i < elems1.length; i++) {
      eListen(
        elems1[i],
        () => {
          servicePBUnit.updateChart();
        },
        'change'
      );
    }
    for (let i = 0; i < elems2.length; i++) {
      eListen(
        elems2[i],
        () => {
          servicePBUnit.updateChart();
        },
        'change'
      );
    }
  },
  buildData: (res) => {
    const rawAssData = res.data.repGraph_arep_appBusunit[0].ReturnList;
    const rawTableData = res.data.repList_arep_appBusunit;
    const chartData = {};
    chartData.labels = [];
    chartData.rows = [];
    chartData.status = {};

    for (let row of rawAssData) {
      chartData.labels.push(row.division);
      chartData.rows.push(row.ccnt);
      chartData.status[row.division] = row.DDdivisionID;
    }

    servicePBUnit.buildGraph(chartData);
    servicePBUnit.buildAssList(rawTableData);
    unhide('dataGraphDiv');
  },
  buildAssList: (data) => {
    const userList = data[0].ReturnList;
    const pagin = data[0].pagination;
    const table = id('buildServiceTable');
    let callback = (p1, p2) => {
      servicePBUnit.navTablePag(p1, p2);
    };
    table.innerHTML = '';
    if (userList.length) {
      const thead1 = document.createElement('thead');
      const th0 = document.createElement('th');
      const th1 = document.createElement('th');
      const th2 = document.createElement('th');
      const th3 = document.createElement('th');
      const th4 = document.createElement('th');
      const th5 = document.createElement('th');
      const th6 = document.createElement('th');
      th0.innerHTML = 'Business Unit';
      th1.innerHTML = 'Status';
      th2.innerHTML = 'Applicant';
      th3.innerHTML = 'RFCNumber';
      th4.innerHTML = 'Job Title';
      th5.innerHTML = 'Line Manager';
      th6.innerHTML = 'Action';
      thead1.appendChild(th0);
      thead1.appendChild(th1);
      thead1.appendChild(th2);
      thead1.appendChild(th3);
      thead1.appendChild(th4);
      thead1.appendChild(th5);
      thead1.appendChild(th6);
      table.appendChild(thead1);

      for (let row of userList) {
        const tr = document.createElement('tr');
        const busUnit = document.createElement('td');
        const status = document.createElement('td');
        const applicant = document.createElement('td');
        const rfcNumber = document.createElement('td');
        const jobTitle = document.createElement('td');
        const lineManager = document.createElement('td');
        const view = document.createElement('td');
        const viewbtn = divAtt('a', 'href', '#');
        busUnit.innerHTML = row.busunit;
        status.innerHTML = row.status;
        applicant.innerHTML = `${row.candidateFname} ${row.candidatesname}`;
        rfcNumber.innerHTML = row.RFCNumber;
        jobTitle.innerHTML = row.clientjobTitle;
        lineManager.innerHTML = `${row.lineManagerfname} ${row.linemanagerSname}`;
        viewbtn.setAttribute('class', 'btn viewMail');
        viewbtn.setAttribute('onclick', `PREP("viewAppDetails", "HAPPLICATIONID=${row.HapplicationID}")`);
        viewbtn.id = `appID_${row.HapplicationID}`;
        viewbtn.innerHTML = 'View';
        view.appendChild(viewbtn);
        tr.appendChild(busUnit);
        tr.appendChild(status);
        tr.appendChild(applicant);
        tr.appendChild(rfcNumber);
        tr.appendChild(jobTitle);
        tr.appendChild(lineManager);
        tr.appendChild(view);
        table.appendChild(tr);
      }
    }
    pagination(pagin[0], callback);
  },
  updateDateControl: (monthNum) => {
    const gridDiv2 = id('dateControl');
    const vars = {};
    vars.monthsPrevious = monthNum;
    vars.HclientID = id('clientDD').value;

    PREP(['getDDMonths'], vars)
      .then(async (res) => {
        gridDiv2.innerHTML = '';
        const monthData = res.data.getDDMonths;
        let elems1 = [];
        let countID = 0;
        for (let row of monthData) {
          let elID = 'cntrlDate' + countID;
          elems1.push(elID);
          const tgl = await buildTgl(`cntrlDate`, row.MonthValue, false, 'servicePBUnit.updateChart()', row.monthDisplay, elID);
          gridDiv2.appendChild(tgl);
          countID++;
        }
        for (let i = 0; i < elems1.length; i++) {
          eListen(
            elems1[i],
            () => {
              servicePBUnit.updateChart();
            },
            'change'
          );
        }
        servicePBUnit.updateChart(monthNum);
        adminReporting.colorSlider(monthNum);
      })
      .catch(console.error());
  },
  updateChart: (monthNum) => {
    const cntrlStatus = document.querySelectorAll('.cntrlStatus');
    const cntrlDate = document.querySelectorAll('.cntrlDate');
    const monthsPrev = document.querySelectorAll('.ratingItem');

    const divisionList = [];
    const monthList = [];

    if (!monthNum) {
      monthsPrev.forEach((toggle) => {
        if (toggle.classList.contains('ratingActive')) {
          monthNum = toggle.id.split('_')[1];
        }
      });
    }

    cntrlStatus.forEach((toggle) => {
      if (toggle.checked) {
        divisionList.push(toggle.value);
      }
    });

    cntrlDate.forEach((toggle) => {
      if (toggle.checked) {
        monthList.push(toggle.value);
      }
    });

    servicePBUnit.buildServiceData(divisionList, monthList, monthNum);
  },
  buildServiceData: (divisionList, monthList, monthNum) => {
    const vars = {};
    vars.HclientID = id('clientDD').value;
    monthList.length && (vars.monthList = monthList.join(','));
    divisionList.length && (vars.divisionList = divisionList.join(','));
    vars.displaypage = 1;
    vars.displayListCount = 25;
    vars.monthsPrevious = monthNum;

    PREP(['repList_arep_appBusunit', 'repGraph_arep_appBusunit'], vars)
      .then((res) => {
        servicePBUnit.buildData(res);
        unhide('dataGraphDiv');
      })
      .catch(console.error());
  },
  navTablePag: (pageNr) => {
    const cntrlStatus = document.querySelectorAll('.cntrlStatus');
    const cntrlDate = document.querySelectorAll('.cntrlDate');
    const monthsPrev = document.querySelectorAll('.ratingItem');
    const divisionList = [];
    const monthList = [];
    let monthNum = 0;

    monthsPrev.forEach((toggle) => {
      if (toggle.classList.contains('ratingActive')) {
        monthNum = toggle.id.split('_')[1];
      }
    });

    cntrlStatus.forEach((toggle) => {
      if (toggle.checked) {
        divisionList.push(toggle.value);
      }
    });

    cntrlDate.forEach((toggle) => {
      if (toggle.checked) {
        monthList.push(toggle.value);
      }
    });

    const vars = {};
    vars.HclientID = id('clientDD').value;
    monthList.length && (vars.monthList = monthList.join(','));
    divisionList.length && (vars.divisionList = divisionList.join(','));
    vars.displaypage = parseInt(pageNr) || 1;
    vars.displayListCount = 25;
    vars.monthsPrevious = monthNum;
    PREP(['repList_arep_appBusunit'], vars)
      .then((res) => {
        const rawTableData = res.data.repList_arep_appBusunit;
        servicePBUnit.buildAssList(rawTableData);
      })
      .catch(console.error());
  },
  buildGraph: (dataMap) => {
    const pageDiv = id('appChart');
    pageDiv.innerHTML = '';

    if (dataMap.rows.length) {
      const canvas = divAtt('canvas', 'id', 'chartCanvas');
      pageDiv.appendChild(canvas);
      const ctx = document.getElementById('chartCanvas').getContext('2d');

      const style = getComputedStyle(document.body);
      const primCol = style.getPropertyValue('--primaryColor');
      const secCol = style.getPropertyValue('--secondaryColor');
      const thirdCol = style.getPropertyValue('--thirdColor');
      const fourthCol = style.getPropertyValue('--fourthColour');
      const myChart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: dataMap.labels,
          datasets: [
            {
              barPercentage: 0.5,
              barThickness: 80,
              maxBarThickness: 100,
              minBarLength: 20,
              label: 'Count',
              data: dataMap.rows,
              backgroundColor: [primCol, secCol, thirdCol, fourthCol],
              borderColor: [primCol, secCol, thirdCol, fourthCol],
              borderWidth: 1,
            },
          ],
        },
        options: {
          onClick: (e) => {
            const canvasPosition = Chart.helpers.getRelativePosition(e, myChart);
            const dataX = myChart.scales.x.getValueForPixel(canvasPosition.x);
            const label = myChart.data.labels[dataX];
            const statusID = dataMap.status[label];
            const cntrlTgl = document.querySelectorAll('.cntrlStatus');
            cntrlTgl.forEach((tgl) => {
              if (tgl.value == statusID) {
                tgl.checked = true;
              } else {
                tgl.checked = false;
              }
            });
            servicePBUnit.updateChart();
          },
          scales: {
            y: {
              beginAtZero: true,
            },
          },
          plugins: {
            legend: {
              display: false,
            },
          },
        },
      });
    } else {
      pageDiv.innerHTML = 'No Data To Display';
    }
  },
};

export const jobPublication = {
  page: () => {
    if (id('clientDD').value) {
      hide('selectClient');
      id('jobPublicationTable').innerHTML = '';
      const vars = {};
      vars.monthsPrevious = 6;
      vars.HclientID = id('clientDD').value;
      vars.displaypage = 1;
      vars.displayListCount = 25;
      PREP(['getAssessmentsDD', 'getDDMonths', 'repGraph_arep_appPublish', 'repList_arep_appPublish'], vars)
        .then((res) => {
          const statusData = cObj(res.data.getAssessmentsDD);
          const monthData = res.data.getDDMonths;
          jobPublication.buildCP(statusData, monthData);
          jobPublication.buildData(res);
          unhide('buildJobPublication');
        })
        .catch(console.error());
    } else {
      id('jobPublicationTable').innerHTML = '';
      unhide('selectClient');
      hide('buildJobPublication');
    }
  },
  buildCP: async (statusData, monthData) => {
    const buildJobPublication = id('buildJobPublication');
    buildJobPublication.innerHTML = '';
    const h0 = divAtt('h3');
    // const h1 = divAtt('h4', 'class', 'secondColor');
    const h2 = divAtt('h4', 'class', 'secondColor');
    const h3 = divAtt('h4', 'class', 'secondColor');
    // const div1 = divAtt('div');
    // const gridDiv1 = divAtt('div', 'class', 'controlPanelGrid');
    const div2 = divAtt('div', 'class', 'sectionGap');
    const gridDiv2 = divAtt('div', 'class', 'controlPanelGrid');
    const div3 = divAtt('div', 'class', 'sectionGap');
    const gridDiv3 = divAtt('div', 'class', 'controlPanelGrid');
    gridDiv2.setAttribute('id', 'dateControl');
    h0.innerHTML = 'Control Panel';
    // h1.innerHTML = 'Assessment';
    h2.innerHTML = 'Date';
    h3.innerHTML = 'Status';
    // div1.appendChild(h1);
    div2.appendChild(h2);
    div3.appendChild(h3);

    const monthSlider = divAtt('div', 'class', 'rating');
    const descriptionMonths = document.createElement('p');
    descriptionMonths.innerHTML = 'Number of months';

    const steps = divAtt('div', 'class', 'ratingSteps1');
    let sliderElems = [];
    for (let i = 1; i <= 12; i++) {
      const line = divAtt('div', 'class', `ratingLine ratingLine_${i}`);
      line.setAttribute('id', `line_${i}`);

      const sliderItem = divAtt('label', 'class', `ratingItem rating_${i}`);
      sliderItem.setAttribute('id', `dot_${i}`);
      sliderItem.innerHTML = i;
      sliderItem.setAttribute('for', `${i}`);
      sliderElems.push([sliderItem, i]);
      // sliderItem.setAttribute(
      //   "onclick",
      //   `jobPublication.updateDateControl(${i})`
      // );

      steps.appendChild(sliderItem);
      if (i != 12) {
        steps.appendChild(line);
      }
    }
    monthSlider.appendChild(descriptionMonths);
    monthSlider.appendChild(steps);
    div2.appendChild(monthSlider);

    // for (let row of statusData) {
    //     const tgl = await buildTgl(`cntrlStatus`, row.HASSESSMENTID, false, 'jobPublication.updateChart()', row.SHORTNAME);
    //     gridDiv1.appendChild(tgl);
    // }

    let elems1 = [];
    let countID = 0;
    for (let row of monthData) {
      let elID = 'cntrlDate' + countID;
      elems1.push(elID);
      const tgl = await buildTgl(`cntrlDate`, row.MonthValue, false, 'jobPublication.updateChart()', row.monthDisplay, elID);
      gridDiv2.appendChild(tgl);
      countID++;
    }

    let elID = 'publishYN' + countID;
    elems1.push(elID);
    countID++;
    const tglA = await buildTgl(`publishYN`, 0, true, 'jobPublication.updateChart()', 'Not Published', elID);
    elID = 'publishYN' + countID;
    elems1.push(elID);
    countID++;
    const tglB = await buildTgl(`publishYN`, 1, true, 'jobPublication.updateChart()', 'Published', elID);
    gridDiv3.appendChild(tglA);
    gridDiv3.appendChild(tglB);

    // div1.appendChild(gridDiv1);
    div2.appendChild(gridDiv2);
    div3.appendChild(gridDiv3);
    buildJobPublication.appendChild(h0);
    // buildJobPublication.appendChild(div1);
    buildJobPublication.appendChild(div2);
    buildJobPublication.appendChild(div3);
    // jobPublication.updateDateControl(6);
    adminReporting.colorSlider(6);
    for (let i = 0; i < sliderElems.length; i++) {
      eListen(
        sliderElems[i][0],
        () => {
          jobPublication.updateDateControl(sliderElems[i][1]);
        },
        'click'
      );
    }
    for (let i = 0; i < elems1.length; i++) {
      eListen(
        elems1[i],
        () => {
          jobPublication.updateChart();
        },
        'change'
      );
    }
  },
  buildData: (res) => {
    const rawAssData = res.data.repGraph_arep_appPublish[0].ReturnList;
    const rawTableData = res.data.repList_arep_appPublish;
    const chartData = {};
    chartData.labels = [];
    chartData.rows = [];
    chartData.status = {};

    for (let row of rawAssData) {
      chartData.labels.push(row.published);
      chartData.rows.push(row.ccnt);
      chartData.status[row.published] = row.publishedYN;
    }

    jobPublication.buildGraph(chartData);
    jobPublication.buildAssList(rawTableData);
    unhide('dataGraphDiv');
  },
  buildAssList: (data) => {
    const userList = data[0].ReturnList;
    const pagin = data[0].pagination;
    const table = id('jobPublicationTable');
    let callback = (p1, p2) => {
      jobPublication.navTablePag(p1, p2);
    };
    table.innerHTML = '';
    if (userList.length) {
      const thead1 = document.createElement('thead');
      const th0 = document.createElement('th');
      const th05 = document.createElement('th');
      const th1 = document.createElement('th');
      const th15 = document.createElement('th');
      const th2 = document.createElement('th');
      const th3 = document.createElement('th');
      const th4 = document.createElement('th');
      const th5 = document.createElement('th');
      const th6 = document.createElement('th');
      th0.innerHTML = 'Business Unit';
      th05.innerHTML = 'PublishedYN';
      th1.innerHTML = 'Status';
      th15.innerHTML = 'Job Level';
      th2.innerHTML = 'Applicant';
      th3.innerHTML = 'RFCNumber';
      th4.innerHTML = 'Job Title';
      th5.innerHTML = 'Line Manager';
      th6.innerHTML = 'Action';
      thead1.appendChild(th0);
      thead1.appendChild(th05);
      thead1.appendChild(th1);
      thead1.appendChild(th15);
      thead1.appendChild(th2);
      thead1.appendChild(th3);
      thead1.appendChild(th4);
      thead1.appendChild(th5);
      thead1.appendChild(th6);
      table.appendChild(thead1);

      for (let row of userList) {
        const tr = document.createElement('tr');
        const busUnit = document.createElement('td');
        const publishedYN = document.createElement('td');
        const status = document.createElement('td');
        const jobLevel = document.createElement('td');
        const applicant = document.createElement('td');
        const rfcNumber = document.createElement('td');
        const jobTitle = document.createElement('td');
        const lineManager = document.createElement('td');
        const view = document.createElement('td');
        const viewbtn = divAtt('a', 'href', '#');
        busUnit.innerHTML = row.busunit;
        publishedYN.innerHTML = row.publishedYN;
        status.innerHTML = row.status;
        jobLevel.innerHTML = row.joblevel;
        applicant.innerHTML = `${row.candidateFname} ${row.candidatesname}`;
        rfcNumber.innerHTML = row.RFCNumber;
        jobTitle.innerHTML = row.clientjobTitle;
        lineManager.innerHTML = `${row.lineManagerfname} ${row.linemanagerSname}`;
        viewbtn.setAttribute('class', 'btn viewMail');
        viewbtn.setAttribute('onclick', `PREP("viewAppDetails", "HAPPLICATIONID=${row.HapplicationID}")`);
        viewbtn.id = `appID_${row.HapplicationID}`;
        viewbtn.innerHTML = 'View';
        view.appendChild(viewbtn);
        tr.appendChild(busUnit);
        tr.appendChild(publishedYN);
        tr.appendChild(status);
        tr.appendChild(jobLevel);
        tr.appendChild(applicant);
        tr.appendChild(rfcNumber);
        tr.appendChild(jobTitle);
        tr.appendChild(lineManager);
        tr.appendChild(view);
        table.appendChild(tr);
      }
    }
    pagination(pagin[0], callback);
  },
  updateDateControl: (monthNum) => {
    const gridDiv2 = id('dateControl');
    const vars = {};
    vars.monthsPrevious = monthNum;
    vars.HclientID = id('clientDD').value;

    PREP(['getDDMonths'], vars)
      .then(async (res) => {
        gridDiv2.innerHTML = '';
        const monthData = res.data.getDDMonths;
        let elems1 = [];
        let countID = 0;
        for (let row of monthData) {
          let elID = 'cntrlDate' + countID;
          elems1.push(elID);
          const tgl = await buildTgl(`cntrlDate`, row.MonthValue, false, 'jobPublication.updateChart()', row.monthDisplay, elID);
          gridDiv2.appendChild(tgl);
          countID++;
        }
        for (let i = 0; i < elems1.length; i++) {
          eListen(
            elems1[i],
            () => {
              jobPublication.updateChart();
            },
            'change'
          );
        }
        jobPublication.updateChart(monthNum);
        adminReporting.colorSlider(monthNum);
      })
      .catch(console.error());
  },
  updateChart: (monthNum) => {
    const cntrlStatus = document.querySelectorAll('.publishYN');
    const cntrlDate = document.querySelectorAll('.cntrlDate');
    const monthsPrev = document.querySelectorAll('.ratingItem');

    const publishYN = [];
    const monthList = [];

    if (!monthNum) {
      monthsPrev.forEach((toggle) => {
        if (toggle.classList.contains('ratingActive')) {
          monthNum = toggle.id.split('_')[1];
        }
      });
    }

    cntrlStatus.forEach((toggle) => {
      if (toggle.checked) {
        publishYN.push(toggle.value);
      }
    });

    cntrlDate.forEach((toggle) => {
      if (toggle.checked) {
        monthList.push(toggle.value);
      }
    });

    jobPublication.buildJobPublicationData(publishYN, monthList, monthNum);
  },
  buildJobPublicationData: (publishYN, monthList, monthNum) => {
    const vars = {};
    vars.HclientID = id('clientDD').value;
    monthList.length && (vars.monthList = monthList.join(','));
    publishYN.length === 1 && (vars.publishYN = publishYN.join(','));
    vars.displaypage = 1;
    vars.displayListCount = 25;
    vars.monthsPrevious = monthNum;

    PREP(['repList_arep_appPublish', 'repGraph_arep_appPublish'], vars)
      .then((res) => {
        jobPublication.buildData(res);
        unhide('dataGraphDiv');
      })
      .catch(console.error());
  },
  navTablePag: (pageNr) => {
    const cntrlStatus = document.querySelectorAll('.cntrlStatus');
    const cntrlDate = document.querySelectorAll('.cntrlDate');
    const monthsPrev = document.querySelectorAll('.ratingItem');
    const publishYN = [];
    const monthList = [];
    let monthNum = 0;

    monthsPrev.forEach((toggle) => {
      if (toggle.classList.contains('ratingActive')) {
        monthNum = toggle.id.split('_')[1];
      }
    });

    cntrlStatus.forEach((toggle) => {
      if (toggle.checked) {
        publishYN.push(toggle.value);
      }
    });

    cntrlDate.forEach((toggle) => {
      if (toggle.checked) {
        monthList.push(toggle.value);
      }
    });

    const vars = {};
    vars.HclientID = id('clientDD').value;
    monthList.length && (vars.monthList = monthList.join(','));
    publishYN.length && (vars.publishYN = publishYN.join(','));
    vars.displaypage = parseInt(pageNr) || 1;
    vars.displayListCount = 25;
    vars.monthsPrevious = monthNum;
    PREP(['repList_arep_appPublish'], vars)
      .then((res) => {
        const rawTableData = res.data.repList_arep_appPublish;
        jobPublication.buildAssList(rawTableData);
      })
      .catch(console.error());
  },
  buildGraph: (dataMap) => {
    const pageDiv = id('appChart');
    pageDiv.innerHTML = '';

    if (dataMap.rows.length) {
      const canvas = divAtt('canvas', 'id', 'chartCanvas');
      pageDiv.appendChild(canvas);
      const ctx = document.getElementById('chartCanvas').getContext('2d');

      const style = getComputedStyle(document.body);
      const primCol = style.getPropertyValue('--primaryColor');
      const secCol = style.getPropertyValue('--secondaryColor');
      const thirdCol = style.getPropertyValue('--thirdColor');
      const fourthCol = style.getPropertyValue('--fourthColour');
      const myChart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: dataMap.labels,
          datasets: [
            {
              barPercentage: 0.5,
              barThickness: 80,
              maxBarThickness: 100,
              minBarLength: 20,
              label: 'Count',
              data: dataMap.rows,
              backgroundColor: [primCol, secCol, thirdCol, fourthCol],
              borderColor: [primCol, secCol, thirdCol, fourthCol],
              borderWidth: 1,
            },
          ],
        },
        options: {
          onClick: (e) => {
            const canvasPosition = Chart.helpers.getRelativePosition(e, myChart);
            const dataX = myChart.scales.x.getValueForPixel(canvasPosition.x);
            const publishValue = dataX == -0 ? 0 : dataX;
            const publishTgl = document.querySelectorAll('.publishYN');
            publishTgl.forEach((tgl) => {
              if (tgl.value == publishValue) {
                tgl.checked = true;
              } else {
                tgl.checked = false;
              }
            });
            jobPublication.updateChart();
          },
          scales: {
            y: {
              beginAtZero: true,
            },
          },
          plugins: {
            legend: {
              display: false,
            },
          },
        },
      });
    } else {
      pageDiv.innerHTML = 'No Data To Display';
    }
  },
};

export const jobFamily = {
  page: () => {
    if (id('clientDD').value) {
      hide('selectClient');
      id('jobFamilyTable').innerHTML = '';
      const vars = {};
      vars.monthsPrevious = 6;
      vars.HclientID = id('clientDD').value;
      vars.displaypage = 1;
      vars.displayListCount = 25;
      PREP(['getDDJobfamily', 'getDDMonths', 'repGraph_arep_appJobFamily', 'repList_arep_appJobFamily'], vars)
        .then((res) => {
          const statusData = cObj(res.data.getDDJobfamily);
          const monthData = res.data.getDDMonths;
          jobFamily.buildCP(statusData, monthData);
          jobFamily.buildData(res);
          unhide('buildJobFamily');
        })
        .catch(console.error());
    } else {
      id('jobFamilyTable').innerHTML = '';
      unhide('selectClient');
      hide('buildJobFamily');
    }
  },
  buildCP: async (statusData, monthData) => {
    const buildJobFam = id('buildJobFamily');
    buildJobFam.innerHTML = '';
    const h0 = divAtt('h3');
    const h1 = divAtt('h4', 'class', 'secondColor');
    const h2 = divAtt('h4', 'class', 'secondColor');
    const div1 = divAtt('div');
    const gridDiv1 = divAtt('div', 'class', 'controlPanelGrid');
    const div2 = divAtt('div', 'class', 'sectionGap');
    const gridDiv2 = divAtt('div', 'class', 'controlPanelGrid');
    gridDiv2.setAttribute('id', 'dateControl');
    h0.innerHTML = 'Control Panel';
    h1.innerHTML = 'Job Families';
    h2.innerHTML = 'Date';
    div1.appendChild(h1);
    div2.appendChild(h2);

    const monthSlider = divAtt('div', 'class', 'rating');
    const descriptionMonths = document.createElement('p');
    descriptionMonths.innerHTML = 'Number of months';

    const steps = divAtt('div', 'class', 'ratingSteps1');
    let sliderElems = [];
    for (let i = 1; i <= 12; i++) {
      const line = divAtt('div', 'class', `ratingLine ratingLine_${i}`);
      line.setAttribute('id', `line_${i}`);

      const sliderItem = divAtt('label', 'class', `ratingItem rating_${i}`);
      sliderItem.setAttribute('id', `dot_${i}`);
      sliderItem.innerHTML = i;
      sliderItem.setAttribute('for', `${i}`);
      //sliderItem.setAttribute("onclick", `jobFamily.updateDateControl(${i})`);
      sliderElems.push([sliderItem, i]);

      steps.appendChild(sliderItem);
      if (i != 12) {
        steps.appendChild(line);
      }
    }
    monthSlider.appendChild(descriptionMonths);
    monthSlider.appendChild(steps);
    div2.appendChild(monthSlider);

    let elems1 = [];
    let countID = 0;
    for (let row of statusData) {
      let elID = 'cntrlStatus' + countID;
      elems1.push(elID);
      const tgl = await buildTgl(`cntrlStatus`, row.DDJOBFAMILYID, false, 'jobFamily.updateChart()', row.FULLDECSRIPTION, elID);
      gridDiv1.appendChild(tgl);
      countID++;
    }

    let elems2 = [];
    countID = 0;
    for (let row of monthData) {
      let elID = 'cntrlDate' + countID;
      elems2.push(elID);
      const tgl = await buildTgl(`cntrlDate`, row.MonthValue, false, 'jobFamily.updateChart()', row.monthDisplay, elID);
      gridDiv2.appendChild(tgl);
      countID++;
    }
    div1.appendChild(gridDiv1);
    div2.appendChild(gridDiv2);
    buildJobFam.appendChild(h0);
    buildJobFam.appendChild(div1);
    buildJobFam.appendChild(div2);
    // jobFamily.updateDateControl(6);
    adminReporting.colorSlider(6);
    for (let i = 0; i < sliderElems.length; i++) {
      eListen(
        sliderElems[i][0],
        () => {
          jobFamily.updateDateControl(sliderElems[i][1]);
        },
        'click'
      );
    }
    for (let i = 0; i < elems1.length; i++) {
      eListen(
        elems1[i],
        () => {
          jobFamily.updateChart();
        },
        'change'
      );
    }
    for (let i = 0; i < elems2.length; i++) {
      eListen(
        elems2[i],
        () => {
          jobFamily.updateChart();
        },
        'change'
      );
    }
  },
  buildData: (res) => {
    const rawAssData = res.data.repGraph_arep_appJobFamily[0].ReturnList;
    const rawTableData = res.data.repList_arep_appJobFamily;
    const chartData = {};
    chartData.labels = [];
    chartData.rows = [];
    chartData.status = {};

    for (let row of rawAssData) {
      chartData.labels.push(row.jobFamily);
      chartData.rows.push(row.ccnt);
      chartData.status[row.jobFamily] = row.DDjobfamilyID;
    }

    jobFamily.buildGraph(chartData);
    jobFamily.buildAssList(rawTableData);
    unhide('dataGraphDiv');
  },
  buildAssList: (data) => {
    const userList = data[0].ReturnList;
    const pagin = data[0].pagination;
    const table = id('jobFamilyTable');
    let callback = (p1, p2) => {
      jobFamily.navTablePag(p1, p2);
    };
    table.innerHTML = '';
    if (userList.length) {
      const thead1 = document.createElement('thead');
      const th0 = document.createElement('th');
      const th1 = document.createElement('th');
      const th2 = document.createElement('th');
      const th3 = document.createElement('th');
      const th4 = document.createElement('th');
      const th5 = document.createElement('th');
      const th6 = document.createElement('th');
      th0.innerHTML = 'Business Unit';
      th1.innerHTML = 'Status';
      th2.innerHTML = 'Applicant';
      th3.innerHTML = 'RFCNumber';
      th4.innerHTML = 'Job Title';
      th5.innerHTML = 'Line Manager';
      th6.innerHTML = 'Action';
      thead1.appendChild(th0);
      thead1.appendChild(th1);
      thead1.appendChild(th2);
      thead1.appendChild(th3);
      thead1.appendChild(th4);
      thead1.appendChild(th5);
      thead1.appendChild(th6);
      table.appendChild(thead1);

      for (let row of userList) {
        const tr = document.createElement('tr');
        const busUnit = document.createElement('td');
        const status = document.createElement('td');
        const applicant = document.createElement('td');
        const rfcNumber = document.createElement('td');
        const jobTitle = document.createElement('td');
        const lineManager = document.createElement('td');
        const view = document.createElement('td');
        const viewbtn = divAtt('a', 'href', '#');
        busUnit.innerHTML = row.busunit;
        status.innerHTML = row.status;
        applicant.innerHTML = `${row.candidateFname} ${row.candidatesname}`;
        rfcNumber.innerHTML = row.RFCNumber;
        jobTitle.innerHTML = row.clientjobTitle;
        lineManager.innerHTML = `${row.lineManagerfname} ${row.linemanagerSname}`;
        viewbtn.setAttribute('class', 'btn viewMail');
        viewbtn.setAttribute('onclick', `PREP("viewAppDetails", "HAPPLICATIONID=${row.HapplicationID}")`);
        viewbtn.id = `appID_${row.HapplicationID}`;
        viewbtn.innerHTML = 'View';
        view.appendChild(viewbtn);
        tr.appendChild(busUnit);
        tr.appendChild(status);
        tr.appendChild(applicant);
        tr.appendChild(rfcNumber);
        tr.appendChild(jobTitle);
        tr.appendChild(lineManager);
        tr.appendChild(view);
        table.appendChild(tr);
      }
    }
    pagination(pagin[0], callback);
  },
  updateDateControl: (monthNum) => {
    const gridDiv2 = id('dateControl');
    const vars = {};
    vars.monthsPrevious = monthNum;
    vars.HclientID = id('clientDD').value;

    PREP(['getDDMonths'], vars)
      .then(async (res) => {
        gridDiv2.innerHTML = '';
        const monthData = res.data.getDDMonths;
        let elems1 = [];
        let countID = 0;
        for (let row of monthData) {
          let elID = 'cntrlDate' + countID;
          elems1.push(elID);
          const tgl = await buildTgl(`cntrlDate`, row.MonthValue, false, 'jobFamily.updateChart()', row.monthDisplay, elID);
          gridDiv2.appendChild(tgl);
          countID++;
        }
        for (let i = 0; i < elems1.length; i++) {
          eListen(
            elems1[i],
            () => {
              jobFamily.updateChart();
            },
            'change'
          );
        }
        jobFamily.updateChart(monthNum);
        adminReporting.colorSlider(monthNum);
      })
      .catch(console.error());
  },
  updateChart: (monthNum) => {
    const cntrlStatus = document.querySelectorAll('.cntrlStatus');
    const cntrlDate = document.querySelectorAll('.cntrlDate');
    const monthsPrev = document.querySelectorAll('.ratingItem');

    const jobFamilyList = [];
    const monthList = [];

    if (!monthNum) {
      monthsPrev.forEach((toggle) => {
        if (toggle.classList.contains('ratingActive')) {
          monthNum = toggle.id.split('_')[1];
        }
      });
    }

    cntrlStatus.forEach((toggle) => {
      if (toggle.checked) {
        jobFamilyList.push(toggle.value);
      }
    });

    cntrlDate.forEach((toggle) => {
      if (toggle.checked) {
        monthList.push(toggle.value);
      }
    });

    jobFamily.buildJobFamData(jobFamilyList, monthList, monthNum);
  },
  buildJobFamData: (jobFamilyList, monthList, monthNum) => {
    const vars = {};
    vars.HclientID = id('clientDD').value;
    monthList.length && (vars.monthList = monthList.join(','));
    jobFamilyList.length && (vars.jobFamilyList = jobFamilyList.join(','));
    vars.displaypage = 1;
    vars.displayListCount = 25;
    vars.monthsPrevious = monthNum;

    PREP(['repList_arep_appJobFamily', 'repGraph_arep_appJobFamily'], vars)
      .then((res) => {
        jobFamily.buildData(res);
        unhide('dataGraphDiv');
      })
      .catch(console.error());
  },
  navTablePag: (pageNr) => {
    const cntrlStatus = document.querySelectorAll('.cntrlStatus');
    const cntrlDate = document.querySelectorAll('.cntrlDate');
    const monthsPrev = document.querySelectorAll('.ratingItem');
    const jobFamilyList = [];
    const monthList = [];
    let monthNum = 0;

    monthsPrev.forEach((toggle) => {
      if (toggle.classList.contains('ratingActive')) {
        monthNum = toggle.id.split('_')[1];
      }
    });

    cntrlStatus.forEach((toggle) => {
      if (toggle.checked) {
        jobFamilyList.push(toggle.value);
      }
    });

    cntrlDate.forEach((toggle) => {
      if (toggle.checked) {
        monthList.push(toggle.value);
      }
    });

    const vars = {};
    vars.HclientID = id('clientDD').value;
    monthList.length && (vars.monthList = monthList.join(','));
    jobFamilyList.length && (vars.jobFamilyList = jobFamilyList.join(','));
    vars.displaypage = parseInt(pageNr) || 1;
    vars.displayListCount = 25;
    vars.monthsPrevious = monthNum;
    PREP(['repList_arep_appJobFamily'], vars)
      .then((res) => {
        const rawTableData = res.data.repList_arep_appJobFamily;
        jobFamily.buildAssList(rawTableData);
      })
      .catch(console.error());
  },
  buildGraph: (dataMap) => {
    const pageDiv = id('appChart');
    pageDiv.innerHTML = '';

    if (dataMap.rows.length) {
      const canvas = divAtt('canvas', 'id', 'chartCanvas');
      pageDiv.appendChild(canvas);
      const ctx = document.getElementById('chartCanvas').getContext('2d');

      const style = getComputedStyle(document.body);
      const primCol = style.getPropertyValue('--primaryColor');
      const secCol = style.getPropertyValue('--secondaryColor');
      const thirdCol = style.getPropertyValue('--thirdColor');
      const fourthCol = style.getPropertyValue('--fourthColour');
      const myChart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: dataMap.labels,
          datasets: [
            {
              barPercentage: 0.5,
              barThickness: 80,
              maxBarThickness: 100,
              minBarLength: 20,
              label: 'Count',
              data: dataMap.rows,
              backgroundColor: [primCol, secCol, thirdCol, fourthCol],
              borderColor: [primCol, secCol, thirdCol, fourthCol],
              borderWidth: 1,
            },
          ],
        },
        options: {
          onClick: (e) => {
            const canvasPosition = Chart.helpers.getRelativePosition(e, myChart);
            const dataX = myChart.scales.x.getValueForPixel(canvasPosition.x);
            const label = myChart.data.labels[dataX];
            const statusID = dataMap.status[label];
            const cntrlTgl = document.querySelectorAll('.cntrlStatus');
            cntrlTgl.forEach((tgl) => {
              if (tgl.value == statusID) {
                tgl.checked = true;
              } else {
                tgl.checked = false;
              }
            });
            jobFamily.updateChart();
          },
          scales: {
            y: {
              beginAtZero: true,
            },
          },
          plugins: {
            legend: {
              display: false,
            },
          },
        },
      });
    } else {
      pageDiv.innerHTML = 'No Data To Display';
    }
  },
};

export const costCenter = {
  page: () => {
    if (id('clientDD').value) {
      hide('selectClient');
      id('costCenterTable').innerHTML = '';
      const vars = {};
      vars.monthsPrevious = 6;
      vars.HclientID = id('clientDD').value;
      vars.displaypage = 1;
      vars.displayListCount = 25;
      PREP(['getDDCostCenters', 'getDDMonths', 'repGraph_arep_appCostCentre', 'repList_arep_appCostCentre'], vars)
        .then((res) => {
          const statusData = cObj(res.data.getDDCostCenters);
          const monthData = res.data.getDDMonths;
          costCenter.buildCP(statusData, monthData);
          costCenter.buildData(res);
          unhide('buildCostCenter');
        })
        .catch(console.error());
    } else {
      id('costCenterTable').innerHTML = '';
      unhide('selectClient');
      hide('buildCostCenter');
    }
  },
  buildCP: async (statusData, monthData) => {
    const buildCostCenter = id('buildCostCenter');
    buildCostCenter.innerHTML = '';
    const h0 = divAtt('h3');
    const h1 = divAtt('h4', 'class', 'secondColor');
    const h2 = divAtt('h4', 'class', 'secondColor');
    const div1 = divAtt('div');
    const gridDiv1 = divAtt('div', 'class', 'controlPanelGrid');
    const div2 = divAtt('div', 'class', 'sectionGap');
    const gridDiv2 = divAtt('div', 'class', 'controlPanelGrid');
    gridDiv2.setAttribute('id', 'dateControl');
    h0.innerHTML = 'Control Panel';
    h1.innerHTML = 'Cost Centers';
    h2.innerHTML = 'Date';
    div1.appendChild(h1);
    div2.appendChild(h2);

    const monthSlider = divAtt('div', 'class', 'rating');
    const descriptionMonths = document.createElement('p');
    descriptionMonths.innerHTML = 'Number of months';

    const steps = divAtt('div', 'class', 'ratingSteps1');
    let sliderElems = [];
    for (let i = 1; i <= 12; i++) {
      const line = divAtt('div', 'class', `ratingLine ratingLine_${i}`);
      line.setAttribute('id', `line_${i}`);

      const sliderItem = divAtt('label', 'class', `ratingItem rating_${i}`);
      sliderItem.setAttribute('id', `dot_${i}`);
      sliderItem.innerHTML = i;
      sliderItem.setAttribute('for', `${i}`);
      //sliderItem.setAttribute("onclick", `costCenter.updateDateControl(${i})`);
      sliderElems.push([sliderItem, i]);

      steps.appendChild(sliderItem);
      if (i != 12) {
        steps.appendChild(line);
      }
    }
    monthSlider.appendChild(descriptionMonths);
    monthSlider.appendChild(steps);
    div2.appendChild(monthSlider);

    let elems1 = [];
    let countID = 0;
    for (let row of statusData) {
      let elID = 'cntrlStatus' + countID;
      elems1.push(elID);
      const tgl = await buildTgl(`cntrlStatus`, row.DDCOSTCENTERID, false, 'costCenter.updateChart()', row.SHORTDESCRIPTION, elID);
      gridDiv1.appendChild(tgl);
      countID++;
    }

    let elems2 = [];
    countID = 0;
    for (let row of monthData) {
      let elID = 'cntrlDate' + countID;
      elems2.push(elID);
      const tgl = await buildTgl(`cntrlDate`, row.MonthValue, false, 'costCenter.updateChart()', row.monthDisplay, elID);
      gridDiv2.appendChild(tgl);
      countID++;
    }
    div1.appendChild(gridDiv1);
    div2.appendChild(gridDiv2);
    buildCostCenter.appendChild(h0);
    buildCostCenter.appendChild(div1);
    buildCostCenter.appendChild(div2);
    // costCenter.updateDateControl(6);
    adminReporting.colorSlider(6);
    for (let i = 0; i < sliderElems.length; i++) {
      eListen(
        sliderElems[i][0],
        () => {
          costCenter.updateDateControl(sliderElems[i][1]);
        },
        'click'
      );
    }
    for (let i = 0; i < elems1.length; i++) {
      eListen(
        elems1[i],
        () => {
          costCenter.updateChart();
        },
        'change'
      );
    }
    for (let i = 0; i < elems2.length; i++) {
      eListen(
        elems2[i],
        () => {
          costCenter.updateChart();
        },
        'change'
      );
    }
  },
  buildData: (res) => {
    const rawAssData = res.data.repGraph_arep_appCostCentre[0].ReturnList;
    const rawTableData = res.data.repList_arep_appCostCentre;
    const chartData = {};
    chartData.labels = [];
    chartData.rows = [];
    chartData.status = {};

    for (let row of rawAssData) {
      chartData.labels.push(row.costCentre);
      chartData.rows.push(row.ccnt);
      chartData.status[row.costCentre] = row.DDcostCenterID;
    }

    costCenter.buildGraph(chartData);
    costCenter.buildAssList(rawTableData);
    unhide('dataGraphDiv');
  },
  buildAssList: (data) => {
    const userList = data[0].ReturnList;
    const pagin = data[0].pagination;
    const table = id('costCenterTable');
    let callback = (p1, p2) => {
      costCenter.navTablePag(p1, p2);
    };
    table.innerHTML = '';
    if (userList.length) {
      const thead1 = document.createElement('thead');
      const th0 = document.createElement('th');
      const th1 = document.createElement('th');
      const th2 = document.createElement('th');
      const th3 = document.createElement('th');
      const th4 = document.createElement('th');
      const th5 = document.createElement('th');
      const th6 = document.createElement('th');
      th0.innerHTML = 'Business Unit';
      th1.innerHTML = 'Status';
      th2.innerHTML = 'Applicant';
      th3.innerHTML = 'RFCNumber';
      th4.innerHTML = 'Job Title';
      th5.innerHTML = 'Line Manager';
      th6.innerHTML = 'Action';
      thead1.appendChild(th0);
      thead1.appendChild(th1);
      thead1.appendChild(th2);
      thead1.appendChild(th3);
      thead1.appendChild(th4);
      thead1.appendChild(th5);
      thead1.appendChild(th6);
      table.appendChild(thead1);

      for (let row of userList) {
        const tr = document.createElement('tr');
        const busUnit = document.createElement('td');
        const status = document.createElement('td');
        const applicant = document.createElement('td');
        const rfcNumber = document.createElement('td');
        const jobTitle = document.createElement('td');
        const lineManager = document.createElement('td');
        const view = document.createElement('td');
        const viewbtn = divAtt('a', 'href', '#');
        busUnit.innerHTML = row.busunit;
        status.innerHTML = row.status;
        applicant.innerHTML = `${row.candidateFname} ${row.candidatesname}`;
        rfcNumber.innerHTML = row.RFCNumber;
        jobTitle.innerHTML = row.clientjobTitle;
        lineManager.innerHTML = `${row.lineManagerfname} ${row.linemanagerSname}`;
        viewbtn.setAttribute('class', 'btn viewMail');
        viewbtn.setAttribute('onclick', `PREP("viewAppDetails", "HAPPLICATIONID=${row.HapplicationID}")`);
        viewbtn.id = `appID_${row.HapplicationID}`;
        viewbtn.innerHTML = 'View';
        view.appendChild(viewbtn);
        tr.appendChild(busUnit);
        tr.appendChild(status);
        tr.appendChild(applicant);
        tr.appendChild(rfcNumber);
        tr.appendChild(jobTitle);
        tr.appendChild(lineManager);
        tr.appendChild(view);
        table.appendChild(tr);
      }
    }
    pagination(pagin[0], callback);
  },
  updateDateControl: (monthNum) => {
    const gridDiv2 = id('dateControl');
    const vars = {};
    vars.monthsPrevious = monthNum;
    vars.HclientID = id('clientDD').value;

    PREP(['getDDMonths'], vars)
      .then(async (res) => {
        gridDiv2.innerHTML = '';
        const monthData = res.data.getDDMonths;
        let elems1 = [];
        let countID = 0;
        for (let row of monthData) {
          let elID = 'cntrlDate' + countID;
          elems1.push(elID);
          const tgl = await buildTgl(`cntrlDate`, row.MonthValue, false, 'costCenter.updateChart()', row.monthDisplay, elID);
          gridDiv2.appendChild(tgl);
          countID++;
        }
        for (let i = 0; i < elems1.length; i++) {
          eListen(
            elems1[i],
            () => {
              costCenter.updateChart();
            },
            'change'
          );
        }
        costCenter.updateChart(monthNum);
        adminReporting.colorSlider(monthNum);
      })
      .catch(console.error());
  },
  updateChart: (monthNum) => {
    const cntrlStatus = document.querySelectorAll('.cntrlStatus');
    const cntrlDate = document.querySelectorAll('.cntrlDate');
    const monthsPrev = document.querySelectorAll('.ratingItem');

    const centreList = [];
    const monthList = [];

    if (!monthNum) {
      monthsPrev.forEach((toggle) => {
        if (toggle.classList.contains('ratingActive')) {
          monthNum = toggle.id.split('_')[1];
        }
      });
    }

    cntrlStatus.forEach((toggle) => {
      if (toggle.checked) {
        centreList.push(toggle.value);
      }
    });

    cntrlDate.forEach((toggle) => {
      if (toggle.checked) {
        monthList.push(toggle.value);
      }
    });

    costCenter.buildCostCenterData(centreList, monthList, monthNum);
  },
  buildCostCenterData: (centreList, monthList, monthNum) => {
    const vars = {};
    vars.HclientID = id('clientDD').value;
    monthList.length && (vars.monthList = monthList.join(','));
    centreList.length && (vars.centreList = centreList.join(','));
    vars.displaypage = 1;
    vars.displayListCount = 25;
    vars.monthsPrevious = monthNum;

    PREP(['repList_arep_appCostCentre', 'repGraph_arep_appCostCentre'], vars)
      .then((res) => {
        costCenter.buildData(res);
        unhide('dataGraphDiv');
      })
      .catch(console.error());
  },
  navTablePag: (pageNr) => {
    const cntrlStatus = document.querySelectorAll('.cntrlStatus');
    const cntrlDate = document.querySelectorAll('.cntrlDate');
    const monthsPrev = document.querySelectorAll('.ratingItem');
    const centreList = [];
    const monthList = [];
    let monthNum = 0;

    monthsPrev.forEach((toggle) => {
      if (toggle.classList.contains('ratingActive')) {
        monthNum = toggle.id.split('_')[1];
      }
    });

    cntrlStatus.forEach((toggle) => {
      if (toggle.checked) {
        centreList.push(toggle.value);
      }
    });

    cntrlDate.forEach((toggle) => {
      if (toggle.checked) {
        monthList.push(toggle.value);
      }
    });

    const vars = {};
    vars.HclientID = id('clientDD').value;
    monthList.length && (vars.monthList = monthList.join(','));
    centreList.length && (vars.centreList = centreList.join(','));
    vars.displaypage = parseInt(pageNr) || 1;
    vars.displayListCount = 25;
    vars.monthsPrevious = monthNum;
    PREP(['repList_arep_appCostCentre'], vars)
      .then((res) => {
        const rawTableData = res.data.repList_arep_appCostCentre;
        costCenter.buildAssList(rawTableData);
      })
      .catch(console.error());
  },
  buildGraph: (dataMap) => {
    const pageDiv = id('appChart');
    pageDiv.innerHTML = '';

    if (dataMap.rows.length) {
      const canvas = divAtt('canvas', 'id', 'chartCanvas');
      pageDiv.appendChild(canvas);
      const ctx = document.getElementById('chartCanvas').getContext('2d');

      const style = getComputedStyle(document.body);
      const primCol = style.getPropertyValue('--primaryColor');
      const secCol = style.getPropertyValue('--secondaryColor');
      const thirdCol = style.getPropertyValue('--thirdColor');
      const fourthCol = style.getPropertyValue('--fourthColour');
      const myChart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: dataMap.labels,
          datasets: [
            {
              barPercentage: 0.5,
              barThickness: 80,
              maxBarThickness: 100,
              minBarLength: 20,
              label: 'Count',
              data: dataMap.rows,
              backgroundColor: [primCol, secCol, thirdCol, fourthCol],
              borderColor: [primCol, secCol, thirdCol, fourthCol],
              borderWidth: 1,
            },
          ],
        },
        options: {
          onClick: (e) => {
            const canvasPosition = Chart.helpers.getRelativePosition(e, myChart);
            const dataX = myChart.scales.x.getValueForPixel(canvasPosition.x);
            const label = myChart.data.labels[dataX];
            const statusID = dataMap.status[label];
            const cntrlTgl = document.querySelectorAll('.cntrlStatus');
            cntrlTgl.forEach((tgl) => {
              if (tgl.value == statusID) {
                tgl.checked = true;
              } else {
                tgl.checked = false;
              }
            });
            costCenter.updateChart();
          },
          scales: {
            y: {
              beginAtZero: true,
            },
          },
          plugins: {
            legend: {
              display: false,
            },
          },
        },
      });
    } else {
      pageDiv.innerHTML = 'No Data To Display';
    }
  },
};

export const assBookSLA = {
  page: () => {
    if (id('clientDD').value) {
      hide('selectClient');
      id('assBookTable').innerHTML = '';
      const vars = {};
      vars.monthsPrevious = 6;
      vars.HclientID = id('clientDD').value;
      vars.displaypage = 1;
      vars.displayListCount = 25;
      PREP(['getAssessmentsDD', 'getDDMonths', 'repGraph_arep_SLABookReview', 'repList_arep_SLABookReview', 'repGraph_control_SLABookReview'], vars)
        .then((res) => {
          const statusData = cObj(res.data.getAssessmentsDD);
          const monthData = res.data.getDDMonths;
          const statusSLA = res.data.repGraph_control_SLABookReview;
          assBookSLA.buildCP(statusData, monthData, statusSLA);
          assBookSLA.buildData(res);
          unhide('buildAssBook');
        })
        .catch(console.error());
    } else {
      id('assBookTable').innerHTML = '';
      unhide('selectClient');
      hide('buildAssBook');
    }
  },
  buildCP: async (statusData, monthData, statusSLA) => {
    const buildAppStatus = id('buildAssBook');
    buildAppStatus.innerHTML = '';
    const h0 = divAtt('h3');
    const h1 = divAtt('h4', 'class', 'secondColor');
    const h2 = divAtt('h4', 'class', 'secondColor');
    const h3 = divAtt('h4', 'class', 'secondColor');
    const div1 = divAtt('div');
    const gridDiv1 = divAtt('div', 'class', 'controlPanelGrid');
    const div2 = divAtt('div', 'class', 'sectionGap');
    const gridDiv2 = divAtt('div', 'class', 'controlPanelGrid');
    const div3 = divAtt('div', 'class', 'sectionGap');
    const gridDiv3 = divAtt('div', 'class', 'controlPanelGrid');
    gridDiv2.setAttribute('id', 'dateControl');
    h0.innerHTML = 'Control Panel';
    h1.innerHTML = 'Assessment';
    h2.innerHTML = 'Date';
    h3.innerHTML = 'SLA Status';
    div1.appendChild(h1);
    div2.appendChild(h2);
    div3.appendChild(h3);

    const monthSlider = divAtt('div', 'class', 'rating');
    const descriptionMonths = document.createElement('p');
    descriptionMonths.innerHTML = 'Number of months';

    const steps = divAtt('div', 'class', 'ratingSteps1');
    let sliderElems = [];
    for (let i = 1; i <= 12; i++) {
      const line = divAtt('div', 'class', `ratingLine ratingLine_${i}`);
      line.setAttribute('id', `line_${i}`);

      const sliderItem = divAtt('label', 'class', `ratingItem rating_${i}`);
      sliderItem.setAttribute('id', `dot_${i}`);
      sliderItem.innerHTML = i;
      sliderItem.setAttribute('for', `${i}`);
      //sliderItem.setAttribute("onclick", `assBookSLA.updateDateControl(${i})`);
      sliderElems.push([sliderItem, i]);

      steps.appendChild(sliderItem);
      if (i != 12) {
        steps.appendChild(line);
      }
    }
    monthSlider.appendChild(descriptionMonths);
    monthSlider.appendChild(steps);
    div2.appendChild(monthSlider);

    let elems1 = [];
    let countID = 0;
    for (let row of statusData) {
      let elID = 'cntrlStatus' + countID;
      elems1.push(elID);
      const tgl = await buildTgl(`cntrlStatus`, row.HASSESSMENTID, false, 'assBookSLA.updateChart()', row.SHORTNAME, elID);
      gridDiv1.appendChild(tgl);
      countID++;
    }

    let elems2 = [];
    countID = 0;
    for (let row of monthData) {
      let elID = 'cntrlDate' + countID;
      elems2.push(elID);
      const tgl = await buildTgl(`cntrlDate`, row.MonthValue, false, 'assBookSLA.updateChart()', row.monthDisplay, elID);
      gridDiv2.appendChild(tgl);
      countID++;
    }

    let elems3 = [];
    countID = 0;
    for (let row of statusSLA) {
      let elID = 'statusSLA' + countID;
      elems3.push(elID);
      const tgl = await buildTgl(`statusSLA`, row.SLABook, true, 'assBookSLA.updateChart()', row.SLABook, elID);
      gridDiv3.appendChild(tgl);
      countID++;
    }

    div1.appendChild(gridDiv1);
    div2.appendChild(gridDiv2);
    div3.appendChild(gridDiv3);
    buildAppStatus.appendChild(h0);
    buildAppStatus.appendChild(div1);
    buildAppStatus.appendChild(div2);
    buildAppStatus.appendChild(div3);
    // assBookSLA.updateDateControl(6);
    adminReporting.colorSlider(6);
    for (let i = 0; i < sliderElems.length; i++) {
      eListen(
        sliderElems[i][0],
        () => {
          assBookSLA.updateDateControl(sliderElems[i][1]);
        },
        'click'
      );
    }
    for (let i = 0; i < elems1.length; i++) {
      eListen(
        elems1[i],
        () => {
          assBookSLA.updateChart();
        },
        'change'
      );
    }
    for (let i = 0; i < elems2.length; i++) {
      eListen(
        elems2[i],
        () => {
          assBookSLA.updateChart();
        },
        'change'
      );
    }
    for (let i = 0; i < elems3.length; i++) {
      eListen(
        elems3[i],
        () => {
          assBookSLA.updateChart();
        },
        'change'
      );
    }
  },
  buildData: (res) => {
    const rawAssData = res.data.repGraph_arep_SLABookReview[0].ReturnList;
    const rawTableData = res.data.repList_arep_SLABookReview;
    const chartData = {};
    chartData.labels = [];
    chartData.rows = [];
    chartData.status = {};

    for (let row of rawAssData) {
      chartData.labels.push(row.SLABook);
      chartData.rows.push(row.ccnt);
      chartData.status[row.SLABook] = row.SLABook;
    }

    assBookSLA.buildGraph(chartData);
    assBookSLA.buildAssList(rawTableData);
    unhide('dataGraphDiv');
  },
  buildAssList: (data) => {
    const userList = data[0].ReturnList;
    const pagin = data[0].pagination;
    const table = id('assBookTable');
    let callback = (p1, p2) => {
      assBookSLA.navTablePag(p1, p2);
    };
    table.innerHTML = '';
    if (userList.length) {
      const thead1 = document.createElement('thead');
      const th1 = document.createElement('th');
      const th2 = document.createElement('th');
      const th3 = document.createElement('th');
      const th4 = document.createElement('th');
      const th5 = document.createElement('th');
      const th55 = document.createElement('th');
      const th6 = document.createElement('th');
      th1.innerHTML = 'Status';
      th2.innerHTML = 'Applicant';
      th3.innerHTML = 'RFCNumber';
      th4.innerHTML = 'Assessment';
      th5.innerHTML = 'SLA Book';
      th55.innerHTML = 'Purpose';
      th6.innerHTML = 'Action';
      thead1.appendChild(th1);
      thead1.appendChild(th2);
      thead1.appendChild(th3);
      thead1.appendChild(th4);
      thead1.appendChild(th5);
      thead1.appendChild(th55);
      thead1.appendChild(th6);
      table.appendChild(thead1);

      for (let row of userList) {
        const tr = document.createElement('tr');
        const status = document.createElement('td');
        const applicant = document.createElement('td');
        const rfcNumber = document.createElement('td');
        const assName = document.createElement('td');
        const slaBook = document.createElement('td');
        const purpose = document.createElement('td');
        const view = document.createElement('td');
        const viewbtn = divAtt('a', 'href', '#');
        status.innerHTML = row.status;
        applicant.innerHTML = `${row.candidateFname} ${row.candidatesname}`;
        rfcNumber.innerHTML = row.RFCNumber;
        assName.innerHTML = row.assessmentName;
        slaBook.innerHTML = row.SLABook;
        purpose.innerHTML = row.purpose;
        viewbtn.setAttribute('class', 'btn viewMail');
        viewbtn.setAttribute('onclick', `PREP("viewAppDetails", "HAPPLICATIONID=${row.HapplicationID}")`);
        viewbtn.id = `appID_${row.allocHuserHassessmentID}`;
        viewbtn.innerHTML = 'View';
        view.appendChild(viewbtn);
        tr.appendChild(status);
        tr.appendChild(applicant);
        tr.appendChild(rfcNumber);
        tr.appendChild(assName);
        tr.appendChild(slaBook);
        tr.appendChild(purpose);
        tr.appendChild(view);
        table.appendChild(tr);
      }
    }
    pagination(pagin[0], callback);
  },
  updateDateControl: (monthNum) => {
    const gridDiv2 = id('dateControl');
    const vars = {};
    vars.monthsPrevious = monthNum;
    vars.HclientID = id('clientDD').value;

    PREP(['getDDMonths'], vars)
      .then(async (res) => {
        gridDiv2.innerHTML = '';
        const monthData = res.data.getDDMonths;
        let elems1 = [];
        let countID = 0;
        for (let row of monthData) {
          let elID = 'cntrlDate' + countID;
          elems1.push(elID);
          const tgl = await buildTgl(`cntrlDate`, row.MonthValue, false, 'assBookSLA.updateChart()', row.monthDisplay, elID);
          gridDiv2.appendChild(tgl);
          countID++;
        }
        for (let i = 0; i < elems1.length; i++) {
          eListen(
            elems1[i],
            () => {
              assBookSLA.updateChart();
            },
            'change'
          );
        }
        assBookSLA.updateChart(monthNum);
        adminReporting.colorSlider(monthNum);
      })
      .catch(console.error());
  },
  updateChart: (monthNum) => {
    const cntrlStatus = document.querySelectorAll('.cntrlStatus');
    const cntrlDate = document.querySelectorAll('.cntrlDate');
    const monthsPrev = document.querySelectorAll('.ratingItem');
    const statusSLA = document.querySelectorAll('.statusSLA');

    const Assessmentlist = [];
    const monthList = [];
    const listSLA = [];

    if (!monthNum) {
      monthsPrev.forEach((toggle) => {
        if (toggle.classList.contains('ratingActive')) {
          monthNum = toggle.id.split('_')[1];
        }
      });
    }

    statusSLA.forEach((toggle) => {
      if (toggle.checked) {
        listSLA.push(toggle.value);
      }
    });

    cntrlStatus.forEach((toggle) => {
      if (toggle.checked) {
        Assessmentlist.push(toggle.value);
      }
    });

    cntrlDate.forEach((toggle) => {
      if (toggle.checked) {
        monthList.push(toggle.value);
      }
    });

    assBookSLA.buildAppStatusData(Assessmentlist, monthList, monthNum, listSLA);
  },
  buildAppStatusData: (Assessmentlist, monthList, monthNum, statusSLA) => {
    const vars = {};
    vars.HclientID = id('clientDD').value;
    monthList.length && (vars.monthList = monthList.join(','));
    Assessmentlist.length && (vars.Assessmentlist = Assessmentlist.join(','));
    statusSLA.length === 1 && (vars.slabook = statusSLA.join(','));
    vars.displaypage = 1;
    vars.displayListCount = 25;
    vars.monthsPrevious = monthNum;

    PREP(['repList_arep_SLABookReview', 'repGraph_arep_SLABookReview'], vars)
      .then((res) => {
        assBookSLA.buildData(res);
        unhide('dataGraphDiv');
      })
      .catch(console.error());
  },
  navTablePag: (pageNr) => {
    const cntrlStatus = document.querySelectorAll('.cntrlStatus');
    const cntrlDate = document.querySelectorAll('.cntrlDate');
    const monthsPrev = document.querySelectorAll('.ratingItem');
    const Assessmentlist = [];
    const monthList = [];
    let monthNum = 0;

    monthsPrev.forEach((toggle) => {
      if (toggle.classList.contains('ratingActive')) {
        monthNum = toggle.id.split('_')[1];
      }
    });

    cntrlStatus.forEach((toggle) => {
      if (toggle.checked) {
        Assessmentlist.push(toggle.value);
      }
    });

    cntrlDate.forEach((toggle) => {
      if (toggle.checked) {
        monthList.push(toggle.value);
      }
    });

    const vars = {};
    vars.HclientID = id('clientDD').value;
    monthList.length && (vars.monthList = monthList.join(','));
    Assessmentlist.length && (vars.Assessmentlist = Assessmentlist.join(','));
    vars.displaypage = parseInt(pageNr) || 1;
    vars.displayListCount = 25;
    vars.monthsPrevious = monthNum;
    PREP(['repList_arep_SLABookReview'], vars)
      .then((res) => {
        const rawTableData = res.data.repList_arep_SLABookReview;
        assBookSLA.buildAssList(rawTableData);
      })
      .catch(console.error());
  },
  buildGraph: (dataMap) => {
    const pageDiv = id('appChart');
    pageDiv.innerHTML = '';

    if (dataMap.rows.length) {
      const canvas = divAtt('canvas', 'id', 'chartCanvas');
      canvas.style = 'max-width: 900px; max-height: 795px;';
      pageDiv.appendChild(canvas);
      const ctx = document.getElementById('chartCanvas').getContext('2d');

      const style = getComputedStyle(document.body);
      const primCol = style.getPropertyValue('--primaryColor');
      const secCol = style.getPropertyValue('--secondaryColor');
      const thirdCol = style.getPropertyValue('--thirdColor');
      const fourthCol = style.getPropertyValue('--fourthColour');
      const myChart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: dataMap.labels,
          datasets: [
            {
              barPercentage: 0.5,
              barThickness: 80,
              maxBarThickness: 100,
              minBarLength: 20,
              label: 'Count',
              data: dataMap.rows,
              backgroundColor: [primCol, secCol, thirdCol, fourthCol],
              borderColor: [primCol, secCol, thirdCol, fourthCol],
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          aspectRatio: 1,
          scales: {
            y: {
              display: false,
            },
            x: {
              display: false,
            },
          },
          plugins: {
            legend: {
              onClick: (e, legendItem) => {
                const cntrlTgl = document.querySelectorAll('.statusSLA');
                cntrlTgl.forEach((tgl) => {
                  if (tgl.value == legendItem.text) {
                    tgl.checked = true;
                  } else {
                    tgl.checked = false;
                  }
                });
                assBookSLA.updateChart();
              },
              display: true,
              position: 'right',
              labels: {
                padding: 20,
              },
            },
          },
        },
      });
    } else {
      pageDiv.innerHTML = 'No Data To Display';
    }
  },
};

export const assPurpose = {
  currState: {},
  buildAppStatus: () => {
    if (id('clientDD').value) {
      hide('selectClient');
      id('assPurposeTable').innerHTML = '';
      const vars = {};
      vars.monthsPrevious = 6;
      vars.HclientID = id('clientDD').value;
      vars.displaypage = 1;
      vars.displayListCount = 25;
      PREP(['getDDAppPurpose', 'getDDMonths', 'repList_arep_apppurpose', 'repGraph_arep_apppurpose'], vars)
        .then((res) => {
          const statusData = res.data.getDDAppPurpose;
          const monthData = res.data.getDDMonths;
          assPurpose.buildCP(statusData, monthData);
          assPurpose.buildData(res);
          unhide('buildAppStatus');
          assPurpose.currState = vars;
          console.log('assPurpose.currState', assPurpose.currState);
        })
        .catch(console.error());
    } else {
      id('assPurposeTable').innerHTML = '';
      unhide('selectClient');
      hide('buildAppStatus');
    }
  },
  buildData: (res) => {
    const rawAppData = res.data.repGraph_arep_apppurpose[0].ReturnList;
    const rawTableData = res.data.repList_arep_apppurpose;
    const chartData = {};
    chartData.labels = [];
    chartData.rows = [];
    chartData.status = {};

    for (let row of rawAppData) {
      chartData.labels.push(row.purpose);
      chartData.rows.push(row.ccnt);
      chartData.status[row.purpose] = row.purpose;
    }

    assPurpose.buildGraph(chartData);
    assPurpose.buildAppList(rawTableData);
    unhide('dataGraphDiv');
  },
  buildCP: async (statusData, monthData) => {
    const buildAppStatus = id('buildAppStatus');
    buildAppStatus.innerHTML = '';
    const h0 = divAtt('h1');
    const h1 = divAtt('h2');
    const h2 = divAtt('h2');
    const div1 = divAtt('div');
    const gridDiv1 = divAtt('div', 'class', 'controlPanelGrid');
    const div2 = divAtt('div', 'class', 'sectionGap');
    const gridDiv2 = divAtt('div', 'class', 'controlPanelGrid');
    gridDiv2.setAttribute('id', 'dateControl');
    h0.innerHTML = 'Control Panel';
    h1.innerHTML = 'Status';
    h2.innerHTML = 'Date';
    div1.appendChild(h1);
    div2.appendChild(h2);

    const monthSlider = divAtt('div', 'class', 'rating');
    const descriptionMonths = document.createElement('p');
    descriptionMonths.innerHTML = 'Number of months';

    const steps = divAtt('div', 'class', 'ratingSteps1');
    let sliderElems = [];
    for (let i = 1; i <= 12; i++) {
      const line = divAtt('div', 'class', `ratingLine ratingLine_${i}`);
      line.setAttribute('id', `line_${i}`);

      const sliderItem = divAtt('label', 'class', `ratingItem rating_${i}`);
      sliderItem.setAttribute('id', `dot_${i}`);
      sliderItem.innerHTML = i;
      sliderItem.setAttribute('for', `${i}`);
      // sliderItem.setAttribute("onclick", `assPurpose.updateDateControl(${i})`);
      sliderElems.push([sliderItem, i]);

      steps.appendChild(sliderItem);
      if (i != 12) {
        steps.appendChild(line);
      }
    }
    monthSlider.appendChild(descriptionMonths);
    monthSlider.appendChild(steps);
    div2.appendChild(monthSlider);

    let elems1 = [];
    let countID = 0;
    for (let row of statusData) {
      let elID = 'cntrlStatus' + countID;
      elems1.push(elID);
      const tgl = await buildTgl(`cntrlStatus`, row.purpose, false, 'assPurpose.updateChart()', row.purpose, elID);
      gridDiv1.appendChild(tgl);
      countID++;
    }

    for (let row of monthData) {
      let elID = 'cntrlDate' + countID;
      elems1.push(elID);
      const tgl = await buildTgl(`cntrlDate`, row.MonthValue, false, 'assPurpose.updateChart()', row.monthDisplay, elID);
      gridDiv2.appendChild(tgl);
      countID++;
    }
    div1.appendChild(gridDiv1);
    div2.appendChild(gridDiv2);
    buildAppStatus.appendChild(h0);
    buildAppStatus.appendChild(div1);
    buildAppStatus.appendChild(div2);
    // assPurpose.updateDateControl(6);
    assPurpose.colorSlider(6);
    for (let i = 0; i < sliderElems.length; i++) {
      eListen(
        sliderElems[i][0],
        () => {
          assPurpose.updateDateControl(sliderElems[i][1]);
        },
        'click'
      );
    }
    for (let i = 0; i < elems1.length; i++) {
      eListen(
        elems1[i],
        () => {
          assPurpose.updateChart();
        },
        'change'
      );
    }
  },
  updateDateControl: (monthNum) => {
    const gridDiv2 = id('dateControl');
    const vars = {};
    vars.monthsPrevious = monthNum; // id('monthSelect').value;
    vars.HclientID = id('clientDD').value;

    PREP(['getDDMonths'], vars)
      .then(async (res) => {
        gridDiv2.innerHTML = '';
        const monthData = res.data.getDDMonths;
        let elems1 = [];
        let countID = 0;
        for (let row of monthData) {
          let elID = 'cntrlDate' + countID;
          elems1.push(elID);
          const tgl = await buildTgl(`cntrlDate`, row.MonthValue, false, 'assPurpose.updateChart()', row.monthDisplay, elID);
          gridDiv2.appendChild(tgl);
          countID++;
        }
        for (let i = 0; i < elems1.length; i++) {
          eListen(
            elems1[i],
            () => {
              assPurpose.updateChart();
            },
            'change'
          );
        }
        assPurpose.updateChart(monthNum);
        assPurpose.colorSlider(monthNum);
      })
      .catch(console.error());
  },
  updateChart: (monthNum) => {
    const cntrlStatus = document.querySelectorAll('.cntrlStatus');
    const cntrlDate = document.querySelectorAll('.cntrlDate');
    const monthsPrev = document.querySelectorAll('.ratingItem');

    const purposeList = [];
    const monthList = [];

    if (!monthNum) {
      monthsPrev.forEach((toggle) => {
        if (toggle.classList.contains('ratingActive')) {
          monthNum = toggle.id.split('_')[1];
        }
      });
    }

    cntrlStatus.forEach((toggle) => {
      if (toggle.checked) {
        purposeList.push(toggle.value);
      }
    });

    cntrlDate.forEach((toggle) => {
      if (toggle.checked) {
        monthList.push(toggle.value);
      }
    });

    assPurpose.buildAppStatusData(purposeList, monthList, monthNum);
  },
  buildAppStatusData: (purposeList, monthList, monthNum) => {
    const vars = {};
    vars.HclientID = id('clientDD').value;
    monthList.length && (vars.monthList = monthList.join(','));
    purposeList.length && (vars.purposeList = purposeList.join(','));
    vars.displaypage = 1;
    vars.displayListCount = 25;
    vars.monthsPrevious = monthNum; //id('monthSelect').value;

    PREP(['repList_arep_apppurpose', 'repGraph_arep_apppurpose'], vars)
      .then((res) => {
        assPurpose.buildData(res);
        unhide('dataGraphDiv');
        assPurpose.currState = vars;
      })
      .catch(console.error());
  },
  navTablePag: (pageNr) => {
    const cntrlStatus = document.querySelectorAll('.cntrlStatus');
    const cntrlDate = document.querySelectorAll('.cntrlDate');
    const monthsPrev = document.querySelectorAll('.ratingItem');
    const purposeList = [];
    const monthList = [];
    let monthNum = 0;

    monthsPrev.forEach((toggle) => {
      if (toggle.classList.contains('ratingActive')) {
        monthNum = toggle.id.split('_')[1];
      }
    });

    cntrlStatus.forEach((toggle) => {
      if (toggle.checked) {
        purposeList.push(toggle.value);
      }
    });

    cntrlDate.forEach((toggle) => {
      if (toggle.checked) {
        monthList.push(toggle.value);
      }
    });

    const vars = {};
    vars.HclientID = id('clientDD').value;
    monthList.length && (vars.monthList = monthList.join(','));
    purposeList.length && (vars.purposeList = purposeList.join(','));
    vars.displaypage = parseInt(pageNr) || 1;
    vars.displayListCount = 25;
    vars.monthsPrevious = monthNum;
    PREP(['repList_arep_apppurpose'], vars)
      .then((res) => {
        const rawTableData = res.data.repList_arep_apppurpose;
        assPurpose.buildAppList(rawTableData);
        assPurpose.currState = vars;
      })
      .catch(console.error());
  },
  buildGraph: (dataMap) => {
    console.log('dataMap', dataMap);

    const pageDiv = id('appChart');
    pageDiv.innerHTML = '';

    if (dataMap.rows.length) {
      const canvas = divAtt('canvas', 'id', 'chartCanvas');
      pageDiv.appendChild(canvas);
      const ctx = document.getElementById('chartCanvas').getContext('2d');

      const style = getComputedStyle(document.body);
      const primCol = style.getPropertyValue('--primaryColor');
      const secCol = style.getPropertyValue('--secondaryColor');
      const thirdCol = style.getPropertyValue('--thirdColor');
      const fourthCol = style.getPropertyValue('--fourthColour');
      const myChart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: dataMap.labels,
          datasets: [
            {
              barPercentage: 0.5,
              barThickness: 80,
              maxBarThickness: 100,
              minBarLength: 20,
              label: 'Count',
              data: dataMap.rows,
              backgroundColor: [primCol, secCol, thirdCol, fourthCol],
              borderColor: [primCol, secCol, thirdCol, fourthCol],
              borderWidth: 1,
            },
          ],
        },
        options: {
          onClick: (e) => {
            const canvasPosition = Chart.helpers.getRelativePosition(e, myChart);
            const dataX = myChart.scales.x.getValueForPixel(canvasPosition.x);
            const label = myChart.data.labels[dataX];
            const statusID = dataMap.status[label];
            const cntrlTgl = document.querySelectorAll('.cntrlStatus');
            cntrlTgl.forEach((tgl) => {
              if (tgl.value == statusID) {
                tgl.checked = true;
              } else {
                tgl.checked = false;
              }
            });
            assPurpose.updateChart();
          },
          scales: {
            y: {
              beginAtZero: true,
            },
          },
          plugins: {
            legend: {
              display: false,
            },
          },
        },
      });
    } else {
      pageDiv.innerHTML = 'No Data To Display';
    }
  },
  buildAppList: (data) => {
    const userList = data[0].ReturnList;
    const pagin = data[0].pagination;
    const table = id('assPurposeTable');
    let callback = (p1, p2) => {
      assPurpose.navTablePag(p1, p2);
    };
    table.innerHTML = '';
    if (userList.length) {
      const thead1 = document.createElement('thead');
      const th1 = document.createElement('th');
      const th11 = document.createElement('th');
      const th2 = document.createElement('th');
      const th3 = document.createElement('th');
      const th4 = document.createElement('th');
      const th5 = document.createElement('th');
      const th6 = document.createElement('th');
      th1.innerHTML = 'Status';
      th11.innerHTML = 'Purpose';
      th2.innerHTML = 'Applicant';
      th3.innerHTML = 'RFCNumber';
      th4.innerHTML = 'Job Title';
      th5.innerHTML = 'Line Manager';
      th6.innerHTML = 'Action';
      thead1.appendChild(th1);
      thead1.appendChild(th11);
      thead1.appendChild(th2);
      thead1.appendChild(th3);
      thead1.appendChild(th4);
      thead1.appendChild(th5);
      thead1.appendChild(th6);
      table.appendChild(thead1);

      for (let row of userList) {
        const tr = document.createElement('tr');
        const status = document.createElement('td');
        const purpose = document.createElement('td');
        const applicant = document.createElement('td');
        const rfcNumber = document.createElement('td');
        const jobTitle = document.createElement('td');
        const lineManager = document.createElement('td');
        const view = document.createElement('td');
        const viewbtn = divAtt('a', 'href', '#');
        status.innerHTML = row.status;
        purpose.innerHTML = row.purpose;
        applicant.innerHTML = `${row.candidateFname} ${row.candidatesname}`;
        rfcNumber.innerHTML = row.RFCNumber;
        jobTitle.innerHTML = row.clientjobTitle;
        lineManager.innerHTML = `${row.lineManagerfname} ${row.linemanagerSname}`;
        viewbtn.setAttribute('class', 'btn viewMail');
        viewbtn.setAttribute('onclick', `PREP("viewAppDetails", "HAPPLICATIONID=${row.HapplicationID}")`);
        viewbtn.id = `appID_${row.HapplicationID}`;
        viewbtn.innerHTML = 'View';
        view.appendChild(viewbtn);
        tr.appendChild(status);
        tr.appendChild(purpose);
        tr.appendChild(applicant);
        tr.appendChild(rfcNumber);
        tr.appendChild(jobTitle);
        tr.appendChild(lineManager);
        tr.appendChild(view);
        table.appendChild(tr);
      }
    }
    pagination(pagin[0], callback);
  },
  exportData: () => {
    const div = divAtt('div', 'class', '');
    const p = divAtt('p', 'class', 'marginTop marginBottom');
    p.innerHTML = 'Please note that this export will include all data displayed in the above graph. <br> Do you wish to proceed?';
    const cancelBtn = divAtt('button', 'class', 'btnCancel');
    cancelBtn.innerHTML = 'Cancel';
    cancelBtn.setAttribute('onclick', `hide('custardBox')`);
    const btn = divAtt('button', 'class', 'btn');
    btn.innerHTML = 'Proceed';
    btn.setAttribute('onclick', `assPurpose.confirmExportData()`);

    div.appendChild(p);
    div.appendChild(cancelBtn);
    div.appendChild(btn);

    custardBox(div, 'Export Data');
  },
  confirmExportData: () => {
    const vars = assPurpose.currState;
    console.log(vars);
    PREP([mFile('repList_arep_apppurpose_ssheet', 'application_purpose')], vars)
      .then((res) => {
        res.data.repList_arep_apppurpose_ssheet && note('File Downloaded.');
      })
      .catch(console.error());

    hide('custardBox');
  },
  colorSlider(monthNum) {
    // DOT
    const ratingNums = document.querySelectorAll(`.ratingItem`);
    ratingNums.forEach((ratingNum) => {
      const rating = ratingNum.id.split('_');
      if (parseInt(rating[1]) <= parseInt(monthNum)) {
        ratingNum.classList.add('ratingActive');
      } else {
        ratingNum.classList.remove('ratingActive');
      }
    });

    // LINE
    const ratingLines = document.querySelectorAll(`.ratingLine`);
    ratingLines.forEach((ratingLine) => {
      const line = ratingLine.id.split('_');
      if (parseInt(line[1]) < parseInt(monthNum)) {
        ratingLine.classList.add('ratingActive');
      } else {
        ratingLine.classList.remove('ratingActive');
      }
    });
  },
};

export const reportRegister = {
  async reportRegPage() {
    if (id('clientDD').value) {
      await this.popDD();
      this.buildRegisterHead();

      // unhide('regContent');
      hide('selectClientHeading');

      reportRegister.searchTable();
    } else {
      hide('regContent');
      id('regTable').innerHTML = '';
      hide('searchSpace');
      unhide('selectClientHeading');
    }
  },

  popDD() {
    const vars = {};
    vars.HclientID = id('clientDD').value;
    PREP(['getReportTypeListSPI', 'getReportStatusListSPI', 'getProjectNameByClient'], vars)
      .then((res) => {
        buildDropDownMain(res.data.getReportStatusListSPI, 'reportStatusDD', 'statusText', 'statusText');
        buildDropDownMain(res.data.getReportTypeListSPI, 'reportTypeDD', 'HreportTypeID', 'shortName');
        buildDropDownMain(res.data.getProjectNameByClient, 'projectNameDD', 'projectName', 'projectName');
      })
      .catch(console.error());
  },

  buildRegisterHead() {
    const table = id('regTable');
    table.innerHTML = '';
    const tBody = divAtt('tBody', 'id', 'reportListBody');

    const thead = divAtt('thead');
    const th0 = divAtt('th');
    const th1 = divAtt('th');
    const th2 = divAtt('th');
    const th3 = divAtt('th');
    const th4 = divAtt('th');
    const th5 = divAtt('th');
    const th6 = divAtt('th');
    th0.innerHTML = 'RFC Number';
    th1.innerHTML = 'Applicant';
    th2.innerHTML = 'Report Status';
    th3.innerHTML = 'Last Updated';
    th4.innerHTML = 'Report Type';
    th5.innerHTML = 'File name';
    th6.innerHTML = 'Import History';
    thead.appendChild(th0);
    thead.appendChild(th1);
    thead.appendChild(th2);
    thead.appendChild(th3);
    thead.appendChild(th4);
    thead.appendChild(th5);
    thead.appendChild(th6);
    table.appendChild(thead);
    table.appendChild(tBody);

    reportRegister.getReportReg();
  },

  getReportReg(displaypage, displayListCount) {
    const vars = {};
    vars.HclientID = id('clientDD').value;
    vars.displaypage = displaypage || 1;
    vars.displayListCount = displayListCount || 50;
    vars.reportRegisterStatus = id('reportStatusDD').value !== '-' ? id('reportStatusDD').value : '';
    let reportTypeDD = 0;
    if (id('reportTypeDD').value && id('reportTypeDD').value !== '-') {
      reportTypeDD = id('reportTypeDD').value;
    }
    vars.HreportTypeID = reportTypeDD;
    vars.genSearch = id('genSearch').value;

    hide('pagDiv');
    if (id('clientDD').value) {
      PREP(['getReportUploadRegisterSPI'], vars)
        .then((res) => {
          //   reportRegister.buildRegList(res.data.getReportUploadRegisterSPI);

          //Pagination ===
          reportRegister.buildRegList(res.data.getReportUploadRegisterSPI[0].ReturnList);
          let callback = (p1, p2) => {
            reportRegister.getReportReg(p1, p2);
          };
          pagination(res.data.getReportUploadRegisterSPI[0].pagination[0], callback);
        })
        .catch(console.error());
    } else {
      hide('regContent');
      infoBox('Please select a client.');
    }
  },

  async buildRegList(data) {
    id('reportListBody').innerHTML = '';
    for (let row of data) {
      const tr = divAtt('tr', 'class', '');
      const tdRFCnum = divAtt('td');
      tdRFCnum.innerHTML = row.RFCNumber;
      tr.appendChild(tdRFCnum);

      const tdName = divAtt('td');
      tdName.innerHTML = row.candidateFullName;
      tr.appendChild(tdName);

      const tdStatus = divAtt('td', 'class', 'emailAddress');
      tdStatus.innerHTML = row.statusText;
      tr.appendChild(tdStatus);

      const tdLastUpdt = divAtt('td', 'class', 'mobileNr');
      tdLastUpdt.innerHTML = row.lastUpdated;
      tr.appendChild(tdLastUpdt);

      const tdReportType = divAtt('td', 'class', 'role');
      tdReportType.innerHTML = row.reportKEY;
      tr.appendChild(tdReportType);

      const tdFileName = divAtt('td', 'class', 'role');
      tdFileName.innerHTML = row.fileName;
      tr.appendChild(tdFileName);

      const tdlink = divAtt('td', 'class', '');
      const btn = divAtt('button', 'class', 'btn');
      // btn.setAttribute(
      //   "onclick",
      //   `reportRegister.viewReportHist(${row.unityReportUploadRegisterID}, '${row.fileName}')`
      // );
      btn.innerHTML = 'View';
      tdlink.appendChild(btn);
      tr.appendChild(tdlink);

      eListen(
        btn,
        () => {
          reportRegister.viewReportHist(row.unityReportUploadRegisterID, row.fileName);
        },
        'click'
      );
      id('reportListBody').appendChild(tr);
      unhide('regContent');
    }

    unhide('regTable');
    unhide('searchSpace');
  },

  DDchange() {
    id('clientDD').value && reportRegister.getReportReg();
  },

  viewReportHist(reportID, fileName) {
    const vars = {};
    vars.unityReportUploadRegisterID = reportID;

    PREP(['getReportUploadStatusHistorySPI'], vars)
      .then((res) => {
        const reportHist = res.data.getReportUploadStatusHistorySPI;
        console.log('reportHist', reportHist);

        const div = divAtt('div', 'class', '');

        const table = divAtt('table');
        table.style.margin = '2rem 0';

        const closeBtn = divAtt('button', 'class', 'btn');
        closeBtn.innerHTML = 'Close';
        closeBtn.setAttribute('onclick', `hide('custardBox')`);

        const thead = divAtt('thead');
        const th0 = divAtt('th');
        const th1 = divAtt('th');
        const th2 = divAtt('th');
        const th3 = divAtt('th');
        th0.innerHTML = 'Date';
        th1.innerHTML = 'Report Status';
        th2.innerHTML = 'Updated by';
        th3.innerHTML = 'Comments';
        thead.appendChild(th0);
        thead.appendChild(th1);
        thead.appendChild(th2);
        thead.appendChild(th3);

        const tBody = divAtt('tBody');
        for (let row of reportHist) {
          const tr = divAtt('tr', 'class', '');
          const date = divAtt('td');
          date.innerHTML = dateFromDateTime(row.dateon);
          const status = divAtt('td');
          status.innerHTML = row.statusText;
          const updated = divAtt('td');
          updated.innerHTML = row.UpdatedBy;
          const comments = divAtt('td');
          comments.innerHTML = row.comments; //row.statusDetail;
          tr.appendChild(date);
          tr.appendChild(status);
          tr.appendChild(updated);
          tr.appendChild(comments);
          tBody.appendChild(tr);
        }

        table.appendChild(thead);
        table.appendChild(tBody);

        if (reportHist.length) {
          div.appendChild(table);
        } else {
          const p = divAtt('p');
          p.innerHTML = 'No history to show.';
          div.appendChild(p);
        }

        div.appendChild(closeBtn);

        custardBox(div, `Report Import History: ${fileName}`);
      })
      .catch(console.error());
  },

  searchTable() {
    const searchInp = id('genSearch');
    let timeout;
    searchInp.addEventListener('keyup', () => {
      clearTimeout(timeout);
      timeout = setTimeout(async () => {
        reportRegister.getReportReg(1, 50);
      }, 1500);
    });
  },
};

export const reportReview = {
  reportReviewPage() {
    if (id('clientDD').value) {
      this.popDD();
      this.buildReviewHead();

      // unhide('regContent');
      hide('selectClientHeading');
      reportReview.searchTable();
    } else {
      hide('regContent');
      id('regTable').innerHTML = '';
      hide('searchSpace');
      unhide('selectClientHeading');
    }
  },

  popDD() {
    const vars = {};
    vars.HclientID = id('clientDD').value;
    PREP(['getReportTypeListSPI', 'getProjectNameByClient'], vars)
      .then((res) => {
        buildDropDownMain(res.data.getReportTypeListSPI, 'reportTypeDD', 'HreportTypeID', 'shortName');
        // buildDropDownMain(
        //   cObj(res.data.getReportType),
        //   "reportTypeDD",
        //   "HREPORTTYPEID",
        //   "SHORTNAME"
        // );
        buildDropDownMain(res.data.getProjectNameByClient, 'projectNameDD', 'projectName', 'projectName');
      })
      .catch(console.error());
  },

  buildReviewHead() {
    const table = id('regTable');
    table.innerHTML = '';
    const tBody = divAtt('tBody', 'id', 'reportListBody');

    const thead = divAtt('thead');
    const th0 = divAtt('th');
    const th1 = divAtt('th');
    const th2 = divAtt('th');
    const th3 = divAtt('th');
    const th4 = divAtt('th');
    const th5 = divAtt('th');
    const th6 = divAtt('th');
    const th7 = divAtt('th');
    const th8 = divAtt('th');
    th0.innerHTML = 'RFC Number';
    th1.innerHTML = 'Applicant';
    th2.innerHTML = 'Report Status';
    th3.innerHTML = 'Last Updated';
    th4.innerHTML = 'Report Type';
    th5.innerHTML = 'File name';
    th6.innerHTML = 'Download report';
    th7.innerHTML = 'Reject report';
    th8.innerHTML = 'Process report';
    thead.appendChild(th0);
    thead.appendChild(th1);
    thead.appendChild(th2);
    thead.appendChild(th3);
    thead.appendChild(th4);
    thead.appendChild(th5);
    thead.appendChild(th6);
    thead.appendChild(th7);
    thead.appendChild(th8);
    table.appendChild(thead);
    table.appendChild(tBody);

    reportReview.getReportRev();
  },

  getReportRev(displaypage, displayListCount) {
    const vars = {};
    vars.HclientID = id('clientDD').value;
    vars.displaypage = displaypage || 1;
    vars.displayListCount = displayListCount || 50;
    vars.reportRegisterStatus = 'Ready For Review';
    vars.reportRegisterStatus2 = 'Archived';
    let reportTypeDD = 0;
    if (id('reportTypeDD').value && id('reportTypeDD').value !== '-') {
      reportTypeDD = id('reportTypeDD').value;
    }
    vars.HreportTypeID = reportTypeDD;
    vars.genSearch = id('genSearch').value;

    hide('pagDiv');
    if (id('clientDD').value) {
      PREP(['getReportUploadRegisterSPI'], vars)
        .then((res) => {
          //   reportReview.buildRevList(res.data.getReportUploadRegisterSPI);

          //Pagination ===
          reportReview.buildRevList(res.data.getReportUploadRegisterSPI[0].ReturnList);
          let callback = (p1, p2) => {
            reportReview.getReportRev(p1, p2);
          };
          pagination(res.data.getReportUploadRegisterSPI[0].pagination[0], callback);
        })
        .catch(console.error());
    } else {
      hide('regContent');
      infoBox('Please select a client.');
    }
  },

  async buildRevList(data) {
    id('reportListBody').innerHTML = '';
    for (let row of data) {
      const tr = divAtt('tr', 'class', '');
      const tdRFCnum = divAtt('td');
      tdRFCnum.innerHTML = row.RFCNumber;
      tr.appendChild(tdRFCnum);

      const tdName = divAtt('td');
      tdName.innerHTML = row.candidateFullName;
      tr.appendChild(tdName);

      const tdStatus = divAtt('td', 'class', 'emailAddress');
      tdStatus.innerHTML = row.statusText;
      tr.appendChild(tdStatus);

      const tdLastUpdt = divAtt('td', 'class', 'mobileNr');
      tdLastUpdt.innerHTML = row.lastUpdated;
      tr.appendChild(tdLastUpdt);

      const tdReportType = divAtt('td', 'class', 'role');
      tdReportType.innerHTML = row.reportKEY;
      tr.appendChild(tdReportType);

      const tdFileName = divAtt('td', 'class', 'role');
      tdFileName.innerHTML = row.fileName;
      tr.appendChild(tdFileName);

      const tdlink = divAtt('td', 'class', '');
      tdlink.style = 'max-width: unset; width: unset;';
      const btn = divAtt('button', 'class', 'btn');
      // btn.setAttribute(
      //   "onclick",
      //   `reportReview.downloadReport(${row.unityReportUploadRegisterID}, '${row.fileName}')`
      // );

      const tdlink2 = divAtt('td', 'class', '');
      btn.innerHTML = 'Download';
      const btn2 = divAtt('button', 'class', 'btn');
      // btn2.setAttribute(
      //   "onclick",
      //   `reportReview.rejectReport(${row.unityReportUploadRegisterID}, '${row.fileName}')`
      // );

      btn2.innerHTML = 'Reject';
      const tdlink3 = divAtt('td', 'class', '');
      const btn3 = divAtt('button', 'class', 'btn');
      // btn3.setAttribute(
      //   "onclick",
      //   `reportReview.processReport(${row.unityReportUploadRegisterID}, '${row.fileName}')`
      // );
      btn3.innerHTML = 'Process';

      //   if (row.statusDetail === "Pending Admin Review") {
      tdlink.appendChild(btn);
      tr.appendChild(tdlink);
      //   }

      tdlink2.appendChild(btn2);
      tdlink3.appendChild(btn3);

      tr.appendChild(tdlink2);
      tr.appendChild(tdlink3);

      eListen(
        btn,
        () => {
          reportReview.downloadReport(row.unityReportUploadRegisterID, row.fileName);
        },
        'click'
      );
      eListen(
        btn2,
        () => {
          reportReview.rejectReport(row.unityReportUploadRegisterID, row.fileName);
        },
        'click'
      );
      eListen(
        btn3,
        () => {
          reportReview.processReport(row.unityReportUploadRegisterID, row.fileName);
        },
        'click'
      );

      id('reportListBody').appendChild(tr);
      unhide('regContent');
    }

    unhide('regTable');
    unhide('searchSpace');
  },

  DDchange() {
    id('clientDD').value && reportReview.getReportRev();
  },

  downloadReport(reportID) {
    PREP(['downloadReportSPI'], {
      unityReportUploadRegisterID: reportID,
    })
      .then((res) => {
        window.open(res.data.downloadReportSPI, '_blank');
      })
      .catch(console.error());
  },

  async rejectReport(reportID, fileName) {
    const div = divAtt('div', 'class', 'grid-1col');
    div.setAttribute('id', 'cancelDiv');

    const p = divAtt('p', 'class', 'marginBottom');
    p.innerHTML = 'You are about to  reject the selected report for upload. Please specify a reason for rejecting the report.';
    const comments = await buildTextarea('cancellComments', 1, 'Comments');
    const btnDiv = divAtt('div', 'class', 'gridSpan btnCenterGrid width100');
    const btn = divAtt('button', 'class', 'btn');
    btn.innerHTML = 'Submit';
    // btn.setAttribute(
    //   "onclick",
    //   `reportReview.submitRejectReport('${reportID}')`
    // );
    const btn2 = divAtt('button', 'class', 'btnCancel');
    btn2.innerHTML = 'Cancel';
    //btn2.setAttribute("onclick", `hide('custardBox')`);
    btnDiv.appendChild(btn2);
    btnDiv.appendChild(btn);
    //  const btn = buildBtnFormCenter('confirmCancel', `SanitizeAppGAPHeaders.cancelApplication('${pgstr.SAs_headersDISC.HapplicationID}')`, 'Confirm Cancel')
    div.appendChild(p);
    div.appendChild(comments);
    div.appendChild(btnDiv);
    //custardBox(div, `Reject report: ${fileName}`);
    eCustardBox(div, `Reject report: ${fileName}`, [
      [
        btn,
        () => {
          reportReview.submitRejectReport(reportID);
        },
        'click',
      ],
      [
        btn2,
        () => {
          hide('custardBox');
        },
        'click',
      ],
    ]);
  },

  processReport(reportID, fileName) {
    const div = divAtt('div', 'class', '');
    const p = divAtt('p', 'class', 'marginBottom');
    p.innerHTML = 'You are about to  proceed with processing of the selected report for upload?';

    const btnDiv = divAtt('div', 'class', 'gridSpan btnCenterGrid');
    const btn = divAtt('button', 'class', 'btn');
    btn.innerHTML = 'Submit';
    // btn.setAttribute(
    //   "onclick",
    //   `reportReview.submitProcessReport('${reportID}')`
    // );
    const btn2 = divAtt('button', 'class', 'btnCancel');
    btn2.innerHTML = 'Cancel';
    //  btn2.setAttribute("onclick", `hide('custardBox')`);
    btnDiv.appendChild(btn2);
    btnDiv.appendChild(btn);

    div.appendChild(p);
    div.appendChild(btnDiv);
    // custardBox(div, `Process report: ${fileName}`);
    eCustardBox(div, `Process report: ${fileName}`, [
      [
        btn,
        () => {
          reportReview.submitProcessReport(reportID);
        },
        'click',
      ],
      [
        btn2,
        () => {
          hide('custardBox');
        },
        'click',
      ],
    ]);
  },

  submitProcessReport(reportID) {
    const vars = {};
    vars.unityReportUploadRegisterID = reportID;
    vars.comments = '';

    PREP(['processReportUpload'], vars)
      .then((res) => {
        note(res.data.processReportUpload);
        hide('custardBox');

        const activePag = document.getElementsByClassName('pagNumActive');
        const displayPage = activePag[0] ? parseInt(activePag[0].innerHTML) : 1;
        reportReview.getReportRev(displayPage);
      })
      .catch(console.error());
  },
  submitRejectReport(reportID) {
    if (!validateDiv('cancelDiv')) {
      return;
    }

    const vars = {};
    vars.unityReportUploadRegisterID = reportID;
    vars.comments = id('cancellComments').value;
    PREP(['rejectReportUpload'], vars)
      .then((res) => {
        note(res.data.rejectReportUpload);
        hide('custardBox');
        const activePag = document.getElementsByClassName('pagNumActive');
        const displayPage = activePag[0] ? parseInt(activePag[0].innerHTML) : 1;
        reportReview.getReportRev(displayPage);
        // PREP('adminApplications');
      })
      .catch(console.error());
  },

  searchTable() {
    const searchInp = id('genSearch');
    let timeout;
    searchInp.addEventListener('keyup', () => {
      clearTimeout(timeout);
      timeout = setTimeout(async () => {
        reportReview.getReportRev(1, 50);
      }, 1500);
    });
  },
};

export const reportFailure = {
  reportFailPage() {
    if (id('clientDD').value) {
      reportFailure.popDD();
      reportFailure.buildFailHead();
      hide('selectClientHeading');
      reportFailure.searchTable();
    } else {
      hide('regContent');
      id('failTable').innerHTML = '';
      hide('searchSpace');
      unhide('selectClientHeading');
    }
  },

  popDD() {
    const vars = {};
    vars.HclientID = id('clientDD').value;
    PREP(['getReportType'], vars)
      .then((res) => {
        buildDropDownMain(cObj(res.data.getReportType), 'reportTypeDD', 'HREPORTTYPEID', 'SHORTNAME');
      })
      .catch(console.error());
  },

  buildFailHead() {
    const table = id('failTable');
    table.innerHTML = '';
    const tBody = divAtt('tBody', 'id', 'reportListBody');

    const thead = divAtt('thead');
    const th0 = divAtt('th');
    const th1 = divAtt('th');
    const th2 = divAtt('th');
    const th3 = divAtt('th');
    const th4 = divAtt('th');
    const th5 = divAtt('th');
    th0.innerHTML = 'RFC Number';
    th1.innerHTML = 'Applicant';
    th2.innerHTML = 'Report Status';
    th3.innerHTML = 'Last Updated';
    th4.innerHTML = 'Report Type';
    th5.innerHTML = 'File name';
    thead.appendChild(th0);
    thead.appendChild(th1);
    thead.appendChild(th2);
    thead.appendChild(th3);
    thead.appendChild(th4);
    thead.appendChild(th5);
    table.appendChild(thead);
    table.appendChild(tBody);
    reportFailure.getReportFail();
  },

  getReportFail(displaypage, displayListCount) {
    const vars = {};
    vars.HclientID = id('clientDD').value;
    vars.displaypage = displaypage || 1;
    vars.displayListCount = displayListCount || 50;
    vars.reportRegisterStatus = 'Failed to Import';
    let reportTypeDD = 0;
    if (id('reportTypeDD').value && id('reportTypeDD').value !== '-') {
      reportTypeDD = id('reportTypeDD').value;
    }
    vars.HreportTypeID = reportTypeDD;
    vars.genSearch = id('genSearch').value;

    hide('pagDiv');
    if (id('clientDD').value) {
      PREP(['getReportUploadRegisterSPI'], vars)
        .then((res) => {
          reportFailure.buildFailList(res.data.getReportUploadRegisterSPI[0].ReturnList);
          let callback = (p1, p2) => {
            reportFailure.getReportFail(p1, p2);
          };
          pagination(res.data.getReportUploadRegisterSPI[0].pagination[0], callback);
        })
        .catch(console.error());
    } else {
      hide('regContent');
      infoBox('Please select a client.');
    }
  },

  async buildFailList(data) {
    id('reportListBody').innerHTML = '';
    for (let row of data) {
      const tr = divAtt('tr', 'class', '');
      const tdRFCnum = divAtt('td');
      tdRFCnum.innerHTML = row.RFCNumber;
      tr.appendChild(tdRFCnum);

      const tdName = divAtt('td');
      tdName.innerHTML = row.candidateFullName;
      tr.appendChild(tdName);

      const tdStatus = divAtt('td', 'class', 'emailAddress');
      tdStatus.innerHTML = row.statusText;
      tr.appendChild(tdStatus);

      const tdLastUpdt = divAtt('td', 'class', 'mobileNr');
      tdLastUpdt.innerHTML = row.lastUpdated;
      tr.appendChild(tdLastUpdt);

      const tdReportType = divAtt('td', 'class', 'role');
      tdReportType.innerHTML = row.reportKEY;
      tr.appendChild(tdReportType);

      const tdFileName = divAtt('td', 'class', 'role');
      tdFileName.innerHTML = row.fileName;
      tr.appendChild(tdFileName);
      id('reportListBody').appendChild(tr);
    }
    unhide('regContent');
    unhide('failTable');
    unhide('searchSpace');
  },

  DDchange() {
    id('clientDD').value && reportFailure.getReportFail();
  },

  searchTable() {
    const searchInp = id('genSearch');
    let timeout;
    searchInp.addEventListener('keyup', () => {
      clearTimeout(timeout);
      timeout = setTimeout(async () => {
        reportFailure.getReportFail(1, 50);
      }, 1500);
    });
  },
};

export const AADBBilling = {
  getBillingDownload() {
    if (!validatePage()) {
      return;
    }

    const fromDate = id('fromDate').value;
    const toDate = id('toDate').value;

    if (fromDate > toDate) {
      infoBox('From date cannot be after the to date.');
      return;
    }

    const vars = {};
    vars.fromDate = fromDate;
    vars.toDate = toDate;
    PREP([mFile('AADBBilling', 'AADB Billing')], vars)
      .then((res) => {
        res.data.AADBBilling && infoBox('File Generated. Please check your downloads');
      })
      .catch(console.error());
  },
};
export const adminReports = {
  //michael
  getReportsDownload() {
    if (!validatePage()) {
      return;
    }

    const fromDate = id('fromDate').value;
    const toDate = id('toDate').value;

    if (fromDate > toDate) {
      const errMsg = adminReports.langObj.aar_Mkr7 || 'From date cannot be after the to date.';
      infoBox(errMsg);
      return;
    }

    const vars = {};
    vars.fromDate = fromDate;
    vars.toDate = toDate;
    const fileName = adminReports.langObj.aar_Mkr5 || 'Admin Report Export';
    PREP([mFile('adminReportDownload', fileName)], vars)
      .then((res) => {
        const msg = adminReports.langObj.aar_Mkr4 || 'File Generated. Please check your downloads';
        res.data.adminReportDownload && infoBox(msg);
      })
      .catch(console.error());
  },
};

export const MOt_Reports = {
  page: () => {
    if (id('clientDD').value) {
      hide('selectClient');
      // id('MOt_reportsTable').innerHTML = '';
      const methods = ['getReportImportFailures_MD', 'getReportUploadDelay_MD', 'getReportImportFailToMatch_MD', 'getAddServDelay_MD'];
      const vars = {};
      vars.startDate = id('sDate').value;
      vars.endDate = id('eDate').value;
      vars.HclientID = id('clientDD').value;
      vars.displaypage = 1;
      vars.displayListCount = 25;

      PREP(methods, vars)
        .then((res) => {
          MOt_Reports.buildData(res.data);
          unhide('buildAssStatus');
        })
        .catch(console.error());
    } else {
      id('MOt_reportsTable').innerHTML = '';
      unhide('selectClient');
      hide('buildAssStatus');
    }
  },
  buildData: (data) => {
    const chartData = {
      labels: [
        'Failed import from Unity',
        'Completed application waiting for a report (24 hour)',
        'Report failed to match',
        'Additional service report delay 24 (hours)',
        //@steph add label
      ],
      rows: [
        data.getReportImportFailures_MD[0].pagination[0].totalRecords,
        data.getReportUploadDelay_MD[0].pagination[0].totalRecords,
        data.getReportImportFailToMatch_MD[0].pagination[0].totalRecords,
        data.getAddServDelay_MD[0].pagination[0].totalRecords, //status[0].returnList =>[{},{}]
        //add data value
      ],
      status: {
        'Failed import from Unity': 'getReportImportFailures_MD',
        'Completed application waiting for a report (24 hour)': 'getReportUploadDelay_MD',
        'Report failed to match': 'getReportImportFailToMatch_MD',
        'Additional service report delay 24 (hours)': 'getAddServDelay_MD',
        //copy label : method
      },
    };

    MOt_Reports.buildGraph(chartData);
    //assStatusReport.buildAssList(rawTableData);
    unhide('dataGraphDiv');
  },
  buildRepList: (data) => {
    //console.log('DATA',data);
    const userList = data.ReturnList;
    const pagin = data.pagination;
    const table = id('MOt_reportsTable');
    let callback = (p1, p2) => {
      MOt_Reports.navTablePag(p1, p2);
    };
    table.innerHTML = '';
    if (userList.length) {
      const thead1 = document.createElement('thead');
      const th1 = document.createElement('th');
      const th2 = document.createElement('th');
      const th3 = document.createElement('th');
      const th4 = document.createElement('th');
      const th5 = document.createElement('th');
      const th6 = document.createElement('th');
      const th7 = document.createElement('th');
      const th8 = document.createElement('th');
      th1.innerHTML = 'RFC Number';
      th2.innerHTML = 'Candidate';
      th3.innerHTML = 'Report Status'; //swop
      th4.innerHTML = 'Issue Type';
      th5.innerHTML = 'Issue First Occurrence';
      th6.innerHTML = 'Occurrence Duration'; //swop
      th7.innerHTML = 'Issue Detail'; //custard box -
      th8.innerHTML = 'Application History';
      thead1.appendChild(th1);
      thead1.appendChild(th2);
      thead1.appendChild(th3);
      thead1.appendChild(th4);
      thead1.appendChild(th5);
      thead1.appendChild(th6);
      thead1.appendChild(th7);
      thead1.appendChild(th8);
      table.appendChild(thead1);

      for (let row of userList) {
        const tr = document.createElement('tr');
        const td1 = document.createElement('td');
        const td2 = document.createElement('td');
        const td3 = document.createElement('td');
        const td4 = document.createElement('td');
        const td5 = document.createElement('td');
        const td6 = document.createElement('td');
        const td7 = document.createElement('td');
        const td8 = document.createElement('td');
        const td7btn = divAtt('button', 'class', 'btn');
        td7btn.id = 'viewIssueDetail'; //ecustardbox ->statusDetail //mikk
        const td8btn = divAtt('button', 'class', 'btn');
        td8btn.id = 'viewAppHistory';
        td1.innerHTML = row.RFCNumber;
        td2.innerHTML = row.candidateFullName;
        td3.innerHTML = row.issueType;
        td4.innerHTML = row.issueType;
        td5.innerHTML = row.dateOfOcc;
        td6.innerHTML = row.occDuration;

        td7btn.innerHTML = 'View Issue Detail';
        td8btn.innerHTML = 'View Application History';
        td7.appendChild(td7btn);
        td8.appendChild(td8btn);
        tr.appendChild(td1);
        tr.appendChild(td2);
        tr.appendChild(td3);
        tr.appendChild(td4);
        tr.appendChild(td5);
        tr.appendChild(td6);
        tr.appendChild(td7);
        tr.appendChild(td8);
        table.appendChild(tr);

        const div = divAtt('div', 'class', '');
        const p = divAtt('p', 'class', 'marginBottom');
        p.innerHTML = row.statusDetail;

        const btn2 = divAtt('button', 'class', 'btn');
        btn2.innerHTML = 'Close';
        div.appendChild(p);
        div.appendChild(btn2);
        eListen(
          td7btn,
          () => {
            eCustardBox(div, `Issue Detail`, [
              btn2,
              () => {
                hide('custardBox');
              },
              'click',
            ]);
          },
          'click'
        );

        eListen(
          td8btn,
          () => {
            MOt_Reports.goToAppHist(row.HapplicationID);
          },
          'click'
        );
      }
    }
    unhide('tabelDiv');
    pagination(pagin[0], callback);
  },
  navTablePag: (pageNr, listCount) => {
    //get sDate,, eDate
    //console.log('method',MOt_Reports.currState);
    const method = MOt_Reports.currState.method;
    const vars = {};
    vars.HclientID = id('clientDD').value;
    vars.displaypage = parseInt(pageNr) || 1;
    vars.displayListCount = listCount || 25;
    vars.startDate = id('sDate').value;
    vars.endDate = id('eDate').value;
    PREP([method], vars)
      .then((res) => {
        const rawTableData = res.data[method][0];
        MOt_Reports.buildRepList(rawTableData);
        // MOt_Reports.currState = vars;
      })
      .catch(console.error());
  },
  buildGraph: (dataMap) => {
    const pageDiv = id('appChart');
    pageDiv.innerHTML = '';

    if (dataMap.rows.length) {
      const canvas = divAtt('canvas', 'id', 'chartCanvas');
      pageDiv.appendChild(canvas);
      const ctx = document.getElementById('chartCanvas').getContext('2d');

      const style = getComputedStyle(document.body);
      const primCol = style.getPropertyValue('--primaryColor');
      const secCol = style.getPropertyValue('--secondaryColor');
      const thirdCol = style.getPropertyValue('--thirdColor');
      const fourthCol = style.getPropertyValue('--fourthColour');
      const myChart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: dataMap.labels,
          datasets: [
            {
              barPercentage: 0.5,
              barThickness: 80,
              maxBarThickness: 100,
              minBarLength: 20,
              label: 'Count',
              data: dataMap.rows,
              backgroundColor: [primCol, secCol, thirdCol, fourthCol],
              borderColor: [primCol, secCol, thirdCol, fourthCol],
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          onClick: (e) => {
            const canvasPosition = getRelativePosition(e, myChart);
            const dataX = myChart.scales.x.getValueForPixel(canvasPosition.x);
            const label = myChart.data.labels[dataX];
            const statusID = dataMap.status[label];
            const cntrlTgl = document.querySelectorAll('.statusList');
            cntrlTgl.forEach((tgl) => {
              if (tgl.value == statusID) {
                tgl.checked = true;
              } else {
                tgl.checked = false;
              }
            });
            MOt_Reports.updateReportsTable(statusID);
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                precision: 0, // Display only integerz
              },
            },
          },
          plugins: {
            legend: {
              display: false,
            },
          },
        },
      });
    } else {
      pageDiv.innerHTML = 'No Data To Display';
    }
  },
  updateReportsTable: (method) => {
    const vars = {};
    vars.HclientID = id('clientDD').value;
    // monthList.length && (vars.monthList = monthList.join(","));
    // Assessmentlist.length && (vars.Assessmentlist = Assessmentlist.join(","));
    vars.displaypage = 1;
    vars.displayListCount = 25;
    vars.method = method;
    vars.startDate = id('sDate').value;
    vars.endDate = id('eDate').value;
    //steph dates maybe - not sure how

    PREP([method], vars)
      .then((res) => {
        ////status[0].returnList =>[{},{}]
        const rawTableData = res.data[method][0];
        MOt_Reports.buildRepList(rawTableData);
        MOt_Reports.currState = vars;
      })
      .catch(console.error());
  },
  //todo
  exportData: () => {
    // console.log('custard Box:  Please note that this export will include all data displayed in the above graph. Do you wish to proceed?');

    const div = divAtt('div', 'class', '');
    const p = divAtt('p', 'class', 'marginTop marginBottom');
    p.innerHTML = 'Please note that this export will include all data displayed in the above graph. <br> Do you wish to proceed?';
    const cancelBtn = divAtt('button', 'class', 'btnCancel');
    cancelBtn.innerHTML = 'Cancel';
    cancelBtn.setAttribute('onclick', `hide('custardBox')`);
    const btn = divAtt('button', 'class', 'btn');
    btn.innerHTML = 'Proceed';
    // btn.setAttribute("onclick", `assStatusReport.confirmExportData()`);
    div.appendChild(p);
    div.appendChild(cancelBtn);
    div.appendChild(btn);

    custardBox(div, 'Export Data');
    eCustardBox(div, 'Export Data', [
      btn,
      () => {
        assStatusReport.confirmExportData();
      },
      'click',
    ]);
  },
  confirmExportData: () => {
    const vars = assStatusReport.currState;
    PREP([mFile('repList_arep_assStatus_ssheet', `assessment_status`)], vars)
      .then((res) => {
        res.data.repList_arep_assStatus_ssheet && note('File Downloaded.');
      })
      .catch(console.error());

    hide('custardBox');
  },
  goToAppHist: async (appID) => {
    const vars = {};
    vars.HAPPLICATIONID = appID;
    vars.dTab = 'SAt_history';
    navSel('apps');
    await PREP('sanitizeApplications', vars);
  },
};
